import _asyncToGenerator from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _Kt$AST$allowedTags, _Kt$AST$allowedAttrib, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { r as Fi } from "./variables-37cba309-153935bd.js";
import { Ge as pi, hi as Hi, bo as Be, di as Re, M as Tt, fi as zi, w as _e } from "./abstract-base-8edf0a84-e11d45a3.js";
import { e as we } from "./state-b4c9cc73-ee633f6c.js";
import { i as Se } from "./query-24926cff-3eb94bfb.js";
import { e as Xi } from "./map-7910a3a7-389c4b7b.js";
import { n as Yi } from "./breakpoints-1ea07f11-d0da757c.js";
import { p as At, E as Wi, a as Ui, R as Ki, S as qi, y as Zi, v as Vi } from "./chart-base.helpers-722f3948-fa82acec.js";
import { L as $i } from "./chart-tooltip-e4995844-42c7681e.js";
import { u as Qi } from "./utils-2e24a437-383bbd0f.js";
var Ji = pi(_templateObject || (_templateObject = _taggedTemplateLiteral(["/**\n * @license Highcharts\n *\n * (c) 2009-2016 Torstein Honsi\n *\n * License: www.highcharts.com/license\n */.highcharts-container{position:relative;overflow:hidden;width:100%;height:100%;text-align:left;line-height:normal;z-index:0;-webkit-tap-highlight-color:rgba(0,0,0,0);font-family:Lucida Grande,Lucida Sans Unicode,Arial,Helvetica,sans-serif;font-size:12px;-webkit-user-select:none;user-select:none;touch-action:manipulation;outline:none}.highcharts-root{display:block}.highcharts-root text{stroke-width:0}.highcharts-strong{font-weight:700}.highcharts-emphasized{font-style:italic}.highcharts-anchor{cursor:pointer}.highcharts-background{fill:#fff}.highcharts-plot-border,.highcharts-plot-background,.highcharts-label-box{fill:none}.highcharts-button-box{fill:inherit}.highcharts-tracker-line{stroke-linejoin:round;stroke:#c0c0c000;stroke-width:22;fill:none}.highcharts-tracker-area{fill:#c0c0c000;stroke-width:0}.highcharts-title{fill:#333;font-size:1.5em}.highcharts-subtitle{fill:#666;font-size:1em}.highcharts-axis-line{fill:none;stroke:#ccd6eb}.highcharts-yaxis .highcharts-axis-line{stroke-width:0}.highcharts-axis-title{fill:#666}.highcharts-axis-labels{fill:#666;cursor:default;font-size:.9em}.highcharts-grid-line{fill:none;stroke:#e6e6e6}.highcharts-xaxis-grid .highcharts-grid-line{stroke-width:0px}.highcharts-tick{stroke:#ccd6eb}.highcharts-yaxis .highcharts-tick{stroke-width:0}.highcharts-minor-grid-line{stroke:#f2f2f2}.highcharts-crosshair-thin{stroke-width:1px;stroke:#ccc}.highcharts-crosshair-category{stroke:#ccd6eb;stroke-opacity:.25}.highcharts-credits{cursor:pointer;fill:#999;font-size:.7em;transition:fill .25s,font-size .25s}.highcharts-credits:hover{fill:#000;font-size:1em}.highcharts-tooltip{cursor:default;pointer-events:none;white-space:nowrap;transition:stroke .15s}.highcharts-tooltip text{fill:#333}.highcharts-tooltip .highcharts-header{font-size:.85em}.highcharts-tooltip-box{stroke-width:1px;fill:#f7f7f7;fill-opacity:.85}.highcharts-tooltip-box .highcharts-label-box{fill:#f7f7f7;fill-opacity:.85}div.highcharts-tooltip{filter:none}.highcharts-selection-marker{fill:#335cad;fill-opacity:.25}.highcharts-graph{fill:none;stroke-width:2px;stroke-linecap:round;stroke-linejoin:round}.highcharts-empty-series{stroke-width:1px;fill:none;stroke:#ccc}.highcharts-state-hover .highcharts-graph{stroke-width:3}.highcharts-point-inactive,.highcharts-series-inactive{opacity:.2;transition:opacity 50ms}.highcharts-state-hover path{transition:stroke-width 50ms}.highcharts-state-normal path{transition:stroke-width .25s}g.highcharts-series,.highcharts-point,.highcharts-markers,.highcharts-data-labels{transition:opacity .25s}.highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),.highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover),.highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),.highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover){opacity:.2}.highcharts-color-0{fill:#7cb5ec;stroke:#7cb5ec}.highcharts-color-1{fill:#434348;stroke:#434348}.highcharts-color-2{fill:#90ed7d;stroke:#90ed7d}.highcharts-color-3{fill:#f7a35c;stroke:#f7a35c}.highcharts-color-4{fill:#8085e9;stroke:#8085e9}.highcharts-color-5{fill:#f15c80;stroke:#f15c80}.highcharts-color-6{fill:#e4d354;stroke:#e4d354}.highcharts-color-7{fill:#2b908f;stroke:#2b908f}.highcharts-color-8{fill:#f45b5b;stroke:#f45b5b}.highcharts-color-9{fill:#91e8e1;stroke:#91e8e1}.highcharts-area{fill-opacity:.75;stroke-width:0}.highcharts-markers{stroke-width:1px;stroke:#fff}.highcharts-a11y-markers-hidden .highcharts-point:not(.highcharts-point-hover):not(.highcharts-a11y-marker-visible),.highcharts-a11y-marker-hidden{opacity:0}.highcharts-point{stroke-width:1px}.highcharts-dense-data .highcharts-point{stroke-width:0}.highcharts-data-label{font-size:.9em;font-weight:700}.highcharts-data-label-box{fill:none;stroke-width:0}.highcharts-data-label text,text.highcharts-data-label{fill:#333}.highcharts-data-label-connector{fill:none}.highcharts-data-label-hidden{pointer-events:none}.highcharts-halo{fill-opacity:.25;stroke-width:0}.highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,.highcharts-markers .highcharts-point-select{fill:#ccc;stroke:#000}.highcharts-column-series rect.highcharts-point{stroke:#fff}.highcharts-column-series .highcharts-point{transition:fill-opacity .25s}.highcharts-column-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pie-series .highcharts-point{stroke-linejoin:round;stroke:#fff}.highcharts-pie-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point{stroke-linejoin:round;stroke:#fff}.highcharts-funnel-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-funnel-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-pyramid-series .highcharts-point{stroke-linejoin:round;stroke:#fff}.highcharts-pyramid-series .highcharts-point-hover{fill-opacity:.75;transition:fill-opacity 50ms}.highcharts-pyramid-series .highcharts-point-select{fill:inherit;stroke:inherit}.highcharts-solidgauge-series .highcharts-point{stroke-width:0}.highcharts-treemap-series .highcharts-point{stroke-width:1px;stroke:#e6e6e6;transition:stroke .25s,fill .25s,fill-opacity .25s}.highcharts-treemap-series .highcharts-point-hover{stroke:#999;transition:stroke 25ms,fill 25ms,fill-opacity 25ms}.highcharts-treemap-series .highcharts-above-level{display:none}.highcharts-treemap-series .highcharts-internal-node{fill:none}.highcharts-treemap-series .highcharts-internal-node-interactive{fill-opacity:.15;cursor:pointer}.highcharts-treemap-series .highcharts-internal-node-interactive:hover{fill-opacity:.75}.highcharts-vector-series .highcharts-point,.highcharts-windbarb-series .highcharts-point{fill:none;stroke-width:2px}.highcharts-lollipop-stem{stroke:#000}.highcharts-focus-border{fill:none;stroke-width:2px}.highcharts-legend-item-hidden .highcharts-focus-border{fill:none!important}.highcharts-legend-box{fill:none;stroke-width:0}.highcharts-legend-item>text{fill:#333;font-weight:700;font-size:1em;cursor:pointer;stroke-width:0}.highcharts-legend-item:hover text{fill:#000}.highcharts-legend-item-hidden *{fill:#ccc!important;stroke:#ccc!important;transition:fill .25s}.highcharts-legend-nav-active{fill:#039;cursor:pointer}.highcharts-legend-nav-inactive{fill:#ccc}circle.highcharts-legend-nav-active,circle.highcharts-legend-nav-inactive{fill:#c0c0c000}.highcharts-legend-title-box{fill:none;stroke-width:0}.highcharts-bubble-legend-symbol{stroke-width:2;fill-opacity:.5}.highcharts-bubble-legend-connectors{stroke-width:1}.highcharts-bubble-legend-labels{fill:#333}.highcharts-loading{position:absolute;background-color:#fff;opacity:.5;text-align:center;z-index:10;transition:opacity .25s}.highcharts-loading-hidden{height:0!important;opacity:0;overflow:hidden;transition:opacity .25s,height .25s step-end}.highcharts-loading-inner{font-weight:700;position:relative;top:45%}.highcharts-plot-band,.highcharts-pane{fill:#000;fill-opacity:.05}.highcharts-plot-line{fill:none;stroke:#999;stroke-width:1px}.highcharts-boxplot-box{fill:#fff}.highcharts-boxplot-median{stroke-width:2px}.highcharts-bubble-series .highcharts-point{fill-opacity:.5}.highcharts-errorbar-series .highcharts-point{stroke:#000}.highcharts-gauge-series .highcharts-data-label-box{stroke:#ccc;stroke-width:1px}.highcharts-gauge-series .highcharts-dial{fill:#000;stroke-width:0}.highcharts-polygon-series .highcharts-graph{fill:inherit;stroke-width:0}.highcharts-waterfall-series .highcharts-graph{stroke:#333;stroke-dasharray:1,3}.highcharts-sankey-series .highcharts-point{stroke-width:0}.highcharts-sankey-series .highcharts-link{transition:fill .25s,fill-opacity .25s;fill-opacity:.5}.highcharts-sankey-series .highcharts-point-hover.highcharts-link{transition:fill 50ms,fill-opacity 50ms;fill-opacity:1}.highcharts-venn-series .highcharts-point{fill-opacity:.75;stroke:#ccc;transition:stroke .25s,fill-opacity .25s}.highcharts-venn-series .highcharts-point-hover{fill-opacity:1;stroke:#ccc}.highcharts-navigator-mask-outside{fill-opacity:0}.highcharts-navigator-mask-inside{fill:#6685c2;fill-opacity:.25;cursor:ew-resize}.highcharts-navigator-outline{stroke:#ccc;fill:none}.highcharts-navigator-handle{stroke:#ccc;fill:#f2f2f2;cursor:ew-resize}.highcharts-navigator-series{fill:#335cad;stroke:#335cad}.highcharts-navigator-series .highcharts-graph{stroke-width:1px}.highcharts-navigator-series .highcharts-area{fill-opacity:.05}.highcharts-navigator-xaxis .highcharts-axis-line{stroke-width:0}.highcharts-navigator-xaxis .highcharts-grid-line{stroke-width:1px;stroke:#e6e6e6}.highcharts-navigator-xaxis.highcharts-axis-labels{fill:#999}.highcharts-navigator-yaxis .highcharts-grid-line{stroke-width:0}.highcharts-scrollbar-thumb{fill:#ccc;stroke:#ccc;stroke-width:1px}.highcharts-scrollbar-button{fill:#e6e6e6;stroke:#ccc;stroke-width:1px}.highcharts-scrollbar-arrow{fill:#666}.highcharts-scrollbar-rifles{stroke:#666;stroke-width:1px}.highcharts-scrollbar-track{fill:#f2f2f2;stroke:#f2f2f2;stroke-width:1px}.highcharts-button{fill:#f7f7f7;stroke:#ccc;cursor:default;stroke-width:1px;transition:fill .25s}.highcharts-button text{fill:#333}.highcharts-button-hover{transition:fill 0ms;fill:#e6e6e6;stroke:#ccc}.highcharts-button-hover text{fill:#333}.highcharts-button-pressed{font-weight:700;fill:#e6ebf5;stroke:#ccc}.highcharts-button-pressed text{fill:#333;font-weight:700}.highcharts-button-disabled text{fill:#333}.highcharts-range-selector-buttons .highcharts-button{stroke-width:0px}.highcharts-range-label rect{fill:none}.highcharts-range-label text{fill:#666}.highcharts-range-input rect{fill:none}.highcharts-range-input text{fill:#333}.highcharts-range-input{stroke-width:1px;stroke:#ccc}input.highcharts-range-selector{position:absolute;border:0;width:1px;height:1px;padding:0;text-align:center;left:-9em}.highcharts-crosshair-label text{fill:#fff;font-size:1.1em}.highcharts-crosshair-label .highcharts-label-box{fill:inherit}.highcharts-candlestick-series .highcharts-point{stroke:#000;stroke-width:1px}.highcharts-candlestick-series .highcharts-point-up{fill:#fff}.highcharts-hollowcandlestick-series .highcharts-point-down{fill:#f21313;stroke:#f21313}.highcharts-hollowcandlestick-series .highcharts-point-down-bearish-up{fill:#06b535;stroke:#06b535}.highcharts-hollowcandlestick-series .highcharts-point-up{fill:transparent;stroke:#06b535}.highcharts-ohlc-series .highcharts-point-hover{stroke-width:3px}.highcharts-flags-series .highcharts-point .highcharts-label-box{stroke:#999;fill:#fff;transition:fill .25s}.highcharts-flags-series .highcharts-point-hover .highcharts-label-box{stroke:#000;fill:#ccd6eb}.highcharts-flags-series .highcharts-point text{fill:#000;font-size:.9em;font-weight:700}.highcharts-map-series .highcharts-point{transition:fill .5s,fill-opacity .5s,stroke-width .25s;stroke:#ccc;stroke-width:inherit}.highcharts-map-series .highcharts-point-hover{transition:fill 0ms,fill-opacity 0ms;fill-opacity:.5}.highcharts-mapline-series .highcharts-point{fill:none}.highcharts-heatmap-series .highcharts-point{stroke-width:0}.highcharts-map-navigation{font-size:1.3em;font-weight:700;text-align:center}.highcharts-mapview-inset-border{stroke:#ccc;stroke-width:1px;fill:none}.highcharts-coloraxis{stroke-width:0}.highcharts-coloraxis-marker{fill:#999}.highcharts-null-point{fill:#f7f7f7}.highcharts-3d-frame{fill:transparent}.highcharts-contextbutton{fill:#fff;stroke:none;stroke-linecap:round}.highcharts-contextbutton:hover{fill:#e6e6e6;stroke:#e6e6e6}.highcharts-button-symbol{stroke:#666;stroke-width:3px}.highcharts-menu{border:1px solid #999999;background:#ffffff;padding:5px 0;box-shadow:3px 3px 10px #888}.highcharts-menu-item{padding:.5em 1em;background:none;color:#333;cursor:pointer;transition:background .25s,color .25s}.highcharts-menu-item:hover{background:#335cad;color:#fff}.highcharts-breadcrumbs-button{fill:none;stroke-width:0;cursor:pointer}.highcharts-breadcrumbs-separator{fill:#666}.highcharts-drilldown-point{cursor:pointer}.highcharts-drilldown-data-label text,text.highcharts-drilldown-data-label,.highcharts-drilldown-axis-label{cursor:pointer;fill:#039;font-weight:700;text-decoration:underline}.highcharts-no-data text{font-weight:700;font-size:12px;fill:#666}.highcharts-axis-resizer{cursor:ns-resize;stroke:#000;stroke-width:2px}.highcharts-bullet-target{stroke-width:0}.highcharts-lineargauge-target,.highcharts-lineargauge-target-line{stroke-width:1px;stroke:#333}.highcharts-annotation-label-box{stroke-width:1px;stroke:#000;fill:#000;fill-opacity:.75}.highcharts-annotation-label text{fill:#e6e6e6}.highcharts-a11y-proxy-button{border-width:0;background-color:transparent;cursor:pointer;outline:none;opacity:.001;z-index:999;overflow:hidden;padding:0;margin:0;display:block;position:absolute}.highcharts-a11y-proxy-group li{list-style:none}.highcharts-visually-hidden{position:absolute;width:1px;height:1px;overflow:hidden;white-space:nowrap;clip:rect(1px,1px,1px,1px);margin-top:-3px;opacity:.01}.highcharts-a11y-invisible{visibility:hidden}.highcharts-a11y-proxy-container,.highcharts-a11y-proxy-container-before,.highcharts-a11y-proxy-container-after{position:absolute;white-space:nowrap}g.highcharts-series,.highcharts-markers,.highcharts-point{outline:none}.highcharts-treegrid-node-collapsed,.highcharts-treegrid-node-expanded{cursor:pointer}.highcharts-point-connecting-path{fill:none}.highcharts-grid-axis .highcharts-tick,.highcharts-grid-axis .highcharts-axis-line{stroke-width:1px}\n"])));
var to = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xt(K) {
  return K && K.__esModule && Object.prototype.hasOwnProperty.call(K, "default") ? K.default : K;
}
var di = {
  exports: {}
};
(function (K) {
  (function (O) {
    K.exports ? (O.default = O, K.exports = O) : O(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function (O) {
    function V(S, D, E, B) {
      S.hasOwnProperty(D) || (S[D] = B.apply(null, E), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
        detail: {
          path: D,
          module: S[D]
        }
      })));
    }
    O = O ? O._modules : {}, V(O, "Extensions/Pane.js", [O["Core/Chart/Chart.js"], O["Series/CenteredUtilities.js"], O["Core/Globals.js"], O["Core/Pointer.js"], O["Core/Utilities.js"]], function (S, D, E, B, H) {
      function X(h, s, l, u, v) {
        var M = !0,
          I = l[0],
          L = l[1],
          C = Math.sqrt(Math.pow(h - I, 2) + Math.pow(s - L, 2));
        return w(u) && w(v) && (h = Math.atan2(z(s - L, 8), z(h - I, 8)), v !== u && (M = u > v ? h >= u && h <= Math.PI || h <= v && h >= -Math.PI : h >= u && h <= z(v, 8))), C <= Math.ceil(l[2] / 2) && M;
      }
      var W = H.addEvent,
        z = H.correctFloat,
        w = H.defined,
        A = H.extend,
        k = H.merge,
        g = H.pick,
        p = H.splat;
      return S.prototype.collectionsWithUpdate.push("pane"), H = function () {
        function h(s, l) {
          this.options = this.chart = this.center = this.background = void 0, this.coll = "pane", this.defaultOptions = {
            center: ["50%", "50%"],
            size: "85%",
            innerSize: "0%",
            startAngle: 0
          }, this.defaultBackgroundOptions = {
            shape: "circle",
            borderWidth: 1,
            borderColor: "#cccccc",
            backgroundColor: {
              linearGradient: {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: 1
              },
              stops: [[0, "#ffffff"], [1, "#e6e6e6"]]
            },
            from: -Number.MAX_VALUE,
            innerRadius: 0,
            to: Number.MAX_VALUE,
            outerRadius: "105%"
          }, this.init(s, l);
        }
        return h.prototype.init = function (s, l) {
          this.chart = l, this.background = [], l.pane.push(this), this.setOptions(s);
        }, h.prototype.setOptions = function (s) {
          this.options = k(this.defaultOptions, this.chart.angular ? {
            background: {}
          } : void 0, s);
        }, h.prototype.render = function () {
          var s = this.options,
            l = this.options.background,
            u = this.chart.renderer;
          if (this.group || (this.group = u.g("pane-group").attr({
            zIndex: s.zIndex || 0
          }).add()), this.updateCenter(), l) for (l = p(l), s = Math.max(l.length, this.background.length || 0), u = 0; u < s; u++) l[u] && this.axis ? this.renderBackground(k(this.defaultBackgroundOptions, l[u]), u) : this.background[u] && (this.background[u] = this.background[u].destroy(), this.background.splice(u, 1));
        }, h.prototype.renderBackground = function (s, l) {
          var u = "animate",
            v = {
              class: "highcharts-pane " + (s.className || "")
            };
          this.chart.styledMode || A(v, {
            fill: s.backgroundColor,
            stroke: s.borderColor,
            "stroke-width": s.borderWidth
          }), this.background[l] || (this.background[l] = this.chart.renderer.path().add(this.group), u = "attr"), this.background[l][u]({
            d: this.axis.getPlotBandPath(s.from, s.to, s)
          }).attr(v);
        }, h.prototype.updateCenter = function (s) {
          this.center = (s || this.axis || {}).center = D.getCenter.call(this);
        }, h.prototype.update = function (s, l) {
          k(!0, this.options, s), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function (u) {
            u.pane === this && (u.pane = null, u.update({}, l));
          }, this);
        }, h;
      }(), S.prototype.getHoverPane = function (h) {
        var s = this,
          l;
        return h && s.pane.forEach(function (u) {
          X(h.chartX - s.plotLeft, h.chartY - s.plotTop, u.center) && (l = u);
        }), l;
      }, W(S, "afterIsInsidePlot", function (h) {
        if (this.polar) {
          if (h.options.inverted) {
            var s = [h.y, h.x];
            h.x = s[0], h.y = s[1];
          }
          h.isInsidePlot = this.pane.some(function (l) {
            return X(h.x, h.y, l.center, l.axis && l.axis.normalizedStartAngleRad, l.axis && l.axis.normalizedEndAngleRad);
          });
        }
      }), W(B, "beforeGetHoverData", function (h) {
        var s = this.chart;
        s.polar ? (s.hoverPane = s.getHoverPane(h), h.filter = function (l) {
          return l.visible && !(!h.shared && l.directTouch) && g(l.options.enableMouseTracking, !0) && (!s.hoverPane || l.xAxis.pane === s.hoverPane);
        }) : s.hoverPane = void 0;
      }), W(B, "afterGetHoverData", function (h) {
        var s = this.chart;
        h.hoverPoint && h.hoverPoint.plotX && h.hoverPoint.plotY && s.hoverPane && !X(h.hoverPoint.plotX, h.hoverPoint.plotY, s.hoverPane.center) && (h.hoverPoint = void 0);
      }), E.Pane = H, E.Pane;
    }), V(O, "Series/AreaRange/AreaRangePoint.js", [O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D) {
      var E = this && this.__extends || function () {
        var _W = function W(z, w) {
          return _W = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (A, k) {
            A.__proto__ = k;
          } || function (A, k) {
            for (var g in k) k.hasOwnProperty(g) && (A[g] = k[g]);
          }, _W(z, w);
        };
        return function (z, w) {
          function A() {
            this.constructor = z;
          }
          _W(z, w), z.prototype = w === null ? Object.create(w) : (A.prototype = w.prototype, new A());
        };
      }();
      S = S.seriesTypes.area.prototype;
      var B = S.pointClass.prototype,
        H = D.defined,
        X = D.isNumber;
      return function (W) {
        function z() {
          var w = W !== null && W.apply(this, arguments) || this;
          return w.high = void 0, w.low = void 0, w.options = void 0, w.plotX = void 0, w.series = void 0, w;
        }
        return E(z, W), z.prototype.setState = function () {
          var w = this.state,
            A = this.series,
            k = A.chart.polar;
          H(this.plotHigh) || (this.plotHigh = A.yAxis.toPixels(this.high, !0)), H(this.plotLow) || (this.plotLow = this.plotY = A.yAxis.toPixels(this.low, !0)), A.stateMarkerGraphic && (A.lowerStateMarkerGraphic = A.stateMarkerGraphic, A.stateMarkerGraphic = A.upperStateMarkerGraphic), this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, k && X(this.plotHighX) && (this.plotX = this.plotHighX), B.setState.apply(this, arguments), this.state = w, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], k && X(this.plotLowX) && (this.plotX = this.plotLowX), A.stateMarkerGraphic && (A.upperStateMarkerGraphic = A.stateMarkerGraphic, A.stateMarkerGraphic = A.lowerStateMarkerGraphic, A.lowerStateMarkerGraphic = void 0), B.setState.apply(this, arguments);
        }, z.prototype.haloPath = function () {
          var w = this.series.chart.polar,
            A = [];
          return this.plotY = this.plotLow, w && X(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (A = B.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, w && X(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (A = A.concat(B.haloPath.apply(this, arguments))), A;
        }, z.prototype.isValid = function () {
          return X(this.low) && X(this.high);
        }, z;
      }(S.pointClass);
    }), V(O, "Series/AreaRange/AreaRangeSeries.js", [O["Series/AreaRange/AreaRangePoint.js"], O["Core/Globals.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      var H = this && this.__extends || function () {
        var _u = function u(v, M) {
          return _u = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (I, L) {
            I.__proto__ = L;
          } || function (I, L) {
            for (var C in L) L.hasOwnProperty(C) && (I[C] = L[C]);
          }, _u(v, M);
        };
        return function (v, M) {
          function I() {
            this.constructor = v;
          }
          _u(v, M), v.prototype = M === null ? Object.create(M) : (I.prototype = M.prototype, new I());
        };
      }();
      D = D.noop;
      var X = E.seriesTypes,
        W = X.area,
        z = X.area.prototype,
        w = X.column.prototype;
      X = B.addEvent;
      var A = B.defined,
        k = B.extend,
        g = B.isArray,
        p = B.isNumber,
        h = B.pick,
        s = B.merge,
        l = {
          lineWidth: 1,
          threshold: null,
          tooltip: {
            pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'
          },
          trackByArea: !0,
          dataLabels: {
            align: void 0,
            verticalAlign: void 0,
            xLow: 0,
            xHigh: 0,
            yLow: 0,
            yHigh: 0
          }
        };
      return B = function (u) {
        function v() {
          var M = u !== null && u.apply(this, arguments) || this;
          return M.data = void 0, M.options = void 0, M.points = void 0, M.lowerStateMarkerGraphic = void 0, M.xAxis = void 0, M;
        }
        return H(v, u), v.prototype.toYData = function (M) {
          return [M.low, M.high];
        }, v.prototype.highToXY = function (M) {
          var I = this.chart,
            L = this.xAxis.postTranslate(M.rectPlotX || 0, this.yAxis.len - (M.plotHigh || 0));
          M.plotHighX = L.x - I.plotLeft, M.plotHigh = L.y - I.plotTop, M.plotLowX = M.plotX;
        }, v.prototype.getGraphPath = function (M) {
          var I = [],
            L = [],
            C = z.getGraphPath,
            m = this.options,
            d = this.chart.polar,
            o = d && m.connectEnds !== !1,
            n = m.connectNulls,
            r,
            i = m.step;
          for (M = M || this.points, r = M.length; r--;) {
            var t = M[r],
              e = d ? {
                plotX: t.rectPlotX,
                plotY: t.yBottom,
                doCurve: !1
              } : {
                plotX: t.plotX,
                plotY: t.plotY,
                doCurve: !1
              };
            t.isNull || o || n || M[r + 1] && !M[r + 1].isNull || L.push(e);
            var a = {
              polarPlotY: t.polarPlotY,
              rectPlotX: t.rectPlotX,
              yBottom: t.yBottom,
              plotX: h(t.plotHighX, t.plotX),
              plotY: t.plotHigh,
              isNull: t.isNull
            };
            L.push(a), I.push(a), t.isNull || o || n || M[r - 1] && !M[r - 1].isNull || L.push(e);
          }
          return M = C.call(this, M), i && (i === !0 && (i = "left"), m.step = {
            left: "right",
            center: "center",
            right: "left"
          }[i]), I = C.call(this, I), L = C.call(this, L), m.step = i, m = [].concat(M, I), !this.chart.polar && L[0] && L[0][0] === "M" && (L[0] = ["L", L[0][1], L[0][2]]), this.graphPath = m, this.areaPath = M.concat(L), m.isArea = !0, m.xMap = M.xMap, this.areaPath.xMap = M.xMap, m;
        }, v.prototype.drawDataLabels = function () {
          var M = this.points,
            I = M.length,
            L = [],
            C = this.options.dataLabels,
            m = this.chart.inverted,
            d,
            o;
          if (C) {
            if (g(C)) var n = C[0] || {
                enabled: !1
              },
              r = C[1] || {
                enabled: !1
              };else n = k({}, C), n.x = C.xHigh, n.y = C.yHigh, r = k({}, C), r.x = C.xLow, r.y = C.yLow;
            if (n.enabled || this._hasPointLabels) {
              for (d = I; d--;) if (o = M[d]) {
                var i = o.plotHigh;
                i = i === void 0 ? 0 : i;
                var t = o.plotLow;
                t = t === void 0 ? 0 : t, t = n.inside ? i < t : i > t, o.y = o.high, o._plotY = o.plotY, o.plotY = i, L[d] = o.dataLabel, o.dataLabel = o.dataLabelUpper, o.below = t, m ? n.align || (n.align = t ? "right" : "left") : n.verticalAlign || (n.verticalAlign = t ? "top" : "bottom");
              }
              for (this.options.dataLabels = n, z.drawDataLabels && z.drawDataLabels.apply(this, arguments), d = I; d--;) (o = M[d]) && (o.dataLabelUpper = o.dataLabel, o.dataLabel = L[d], delete o.dataLabels, o.y = o.low, o.plotY = o._plotY);
            }
            if (r.enabled || this._hasPointLabels) {
              for (d = I; d--;) (o = M[d]) && (L = o.plotHigh, i = L === void 0 ? 0 : L, L = o.plotLow, t = L === void 0 ? 0 : L, t = r.inside ? i < t : i > t, o.below = !t, m ? r.align || (r.align = t ? "left" : "right") : r.verticalAlign || (r.verticalAlign = t ? "bottom" : "top"));
              this.options.dataLabels = r, z.drawDataLabels && z.drawDataLabels.apply(this, arguments);
            }
            if (n.enabled) for (d = I; d--;) (o = M[d]) && (o.dataLabels = [o.dataLabelUpper, o.dataLabel].filter(function (e) {
              return !!e;
            }));
            this.options.dataLabels = C;
          }
        }, v.prototype.alignDataLabel = function () {
          w.alignDataLabel.apply(this, arguments);
        }, v.prototype.drawPoints = function () {
          var M = this.points.length,
            I;
          for (z.drawPoints.apply(this, arguments), I = 0; I < M;) {
            var L = this.points[I];
            L.graphics = L.graphics || [], L.origProps = {
              plotY: L.plotY,
              plotX: L.plotX,
              isInside: L.isInside,
              negative: L.negative,
              zone: L.zone,
              y: L.y
            }, (L.graphic || L.graphics[0]) && (L.graphics[0] = L.graphic), L.graphic = L.graphics[1], L.plotY = L.plotHigh, A(L.plotHighX) && (L.plotX = L.plotHighX), L.y = h(L.high, L.origProps.y), L.negative = L.y < (this.options.threshold || 0), this.zones.length && (L.zone = L.getZone()), this.chart.polar || (L.isInside = L.isTopInside = typeof L.plotY < "u" && 0 <= L.plotY && L.plotY <= this.yAxis.len && 0 <= L.plotX && L.plotX <= this.xAxis.len), I++;
          }
          for (z.drawPoints.apply(this, arguments), I = 0; I < M;) L = this.points[I], L.graphics = L.graphics || [], (L.graphic || L.graphics[1]) && (L.graphics[1] = L.graphic), L.graphic = L.graphics[0], L.origProps && (k(L, L.origProps), delete L.origProps), I++;
        }, v.defaultOptions = s(W.defaultOptions, l), v;
      }(W), X(B, "afterTranslate", function () {
        var u = this;
        this.pointArrayMap.join(",") === "low,high" && this.points.forEach(function (v) {
          var M = v.high,
            I = v.plotY;
          v.isNull ? v.plotY = void 0 : (v.plotLow = I, v.plotHigh = p(M) ? u.yAxis.translate(u.dataModify ? u.dataModify.modifyValue(M) : M, !1, !0, void 0, !0) : void 0, u.dataModify && (v.yBottom = v.plotHigh));
        });
      }, {
        order: 0
      }), X(B, "afterTranslate", function () {
        var u = this;
        this.points.forEach(function (v) {
          if (u.chart.polar) u.highToXY(v), v.plotLow = v.plotY, v.tooltipPos = [((v.plotHighX || 0) + (v.plotLowX || 0)) / 2, ((v.plotHigh || 0) + (v.plotLow || 0)) / 2];else {
            var M = v.pos(!1, v.plotLow),
              I = v.pos(!1, v.plotHigh);
            M && I && (M[0] = (M[0] + I[0]) / 2, M[1] = (M[1] + I[1]) / 2), v.tooltipPos = M;
          }
        });
      }, {
        order: 3
      }), k(B.prototype, {
        deferTranslatePolar: !0,
        pointArrayMap: ["low", "high"],
        pointClass: S,
        pointValKey: "low",
        setStackedPoints: D
      }), E.registerSeriesType("arearange", B), B;
    }), V(O, "Series/AreaSplineRange/AreaSplineRangeSeries.js", [O["Series/AreaRange/AreaRangeSeries.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E) {
      var B = this && this.__extends || function () {
          var _z = function z(w, A) {
            return _z = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (k, g) {
              k.__proto__ = g;
            } || function (k, g) {
              for (var p in g) g.hasOwnProperty(p) && (k[p] = g[p]);
            }, _z(w, A);
          };
          return function (w, A) {
            function k() {
              this.constructor = w;
            }
            _z(w, A), w.prototype = A === null ? Object.create(A) : (k.prototype = A.prototype, new k());
          };
        }(),
        H = D.seriesTypes.spline.prototype,
        X = E.merge;
      E = E.extend;
      var W = function (z) {
        function w() {
          var A = z !== null && z.apply(this, arguments) || this;
          return A.options = void 0, A.data = void 0, A.points = void 0, A;
        }
        return B(w, z), w.defaultOptions = X(S.defaultOptions), w;
      }(S);
      return E(W.prototype, {
        getPointSpline: H.getPointSpline
      }), D.registerSeriesType("areasplinerange", W), W;
    }), V(O, "Series/BoxPlot/BoxPlotSeries.js", [O["Series/Column/ColumnSeries.js"], O["Core/Globals.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      var H = this && this.__extends || function () {
        var _w = function w(A, k) {
          return _w = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (g, p) {
            g.__proto__ = p;
          } || function (g, p) {
            for (var h in p) p.hasOwnProperty(h) && (g[h] = p[h]);
          }, _w(A, k);
        };
        return function (A, k) {
          function g() {
            this.constructor = A;
          }
          _w(A, k), A.prototype = k === null ? Object.create(k) : (g.prototype = k.prototype, new g());
        };
      }();
      D = D.noop;
      var X = B.extend,
        W = B.merge,
        z = B.pick;
      return B = function (w) {
        function A() {
          var k = w !== null && w.apply(this, arguments) || this;
          return k.data = void 0, k.options = void 0, k.points = void 0, k;
        }
        return H(A, w), A.prototype.pointAttribs = function () {
          return {};
        }, A.prototype.translate = function () {
          var k = this.yAxis,
            g = this.pointArrayMap;
          w.prototype.translate.apply(this), this.points.forEach(function (p) {
            g.forEach(function (h) {
              p[h] !== null && (p[h + "Plot"] = k.translate(p[h], 0, 1, 0, 1));
            }), p.plotHigh = p.highPlot;
          });
        }, A.prototype.drawPoints = function () {
          var k = this,
            g = k.options,
            p = k.chart,
            h = p.renderer,
            s,
            l,
            u,
            v,
            M,
            I,
            L = 0,
            C,
            m,
            d,
            o,
            n = k.doQuartiles !== !1,
            r,
            i = k.options.whiskerLength;
          k.points.forEach(function (t) {
            var e = t.graphic,
              a = e ? "animate" : "attr",
              c = t.shapeArgs,
              y = {},
              b = {},
              j = {},
              P = {},
              f = t.color || k.color;
            typeof t.plotY < "u" && (C = Math.round(c.width), m = Math.floor(c.x), d = m + C, o = Math.round(C / 2), s = Math.floor(n ? t.q1Plot : t.lowPlot), l = Math.floor(n ? t.q3Plot : t.lowPlot), u = Math.floor(t.highPlot), v = Math.floor(t.lowPlot), e || (t.graphic = e = h.g("point").add(k.group), t.stem = h.path().addClass("highcharts-boxplot-stem").add(e), i && (t.whiskers = h.path().addClass("highcharts-boxplot-whisker").add(e)), n && (t.box = h.path(void 0).addClass("highcharts-boxplot-box").add(e)), t.medianShape = h.path(void 0).addClass("highcharts-boxplot-median").add(e)), p.styledMode || (b.stroke = t.stemColor || g.stemColor || f, b["stroke-width"] = z(t.stemWidth, g.stemWidth, g.lineWidth), b.dashstyle = t.stemDashStyle || g.stemDashStyle || g.dashStyle, t.stem.attr(b), i && (j.stroke = t.whiskerColor || g.whiskerColor || f, j["stroke-width"] = z(t.whiskerWidth, g.whiskerWidth, g.lineWidth), j.dashstyle = t.whiskerDashStyle || g.whiskerDashStyle || g.dashStyle, t.whiskers.attr(j)), n && (y.fill = t.fillColor || g.fillColor || f, y.stroke = g.lineColor || f, y["stroke-width"] = g.lineWidth || 0, y.dashstyle = t.boxDashStyle || g.boxDashStyle || g.dashStyle, t.box.attr(y)), P.stroke = t.medianColor || g.medianColor || f, P["stroke-width"] = z(t.medianWidth, g.medianWidth, g.lineWidth), P.dashstyle = t.medianDashStyle || g.medianDashStyle || g.dashStyle, t.medianShape.attr(P)), I = t.stem.strokeWidth() % 2 / 2, L = m + o + I, e = [["M", L, l], ["L", L, u], ["M", L, s], ["L", L, v]], t.stem[a]({
              d: e
            }), n && (I = t.box.strokeWidth() % 2 / 2, s = Math.floor(s) + I, l = Math.floor(l) + I, m += I, d += I, e = [["M", m, l], ["L", m, s], ["L", d, s], ["L", d, l], ["L", m, l], ["Z"]], t.box[a]({
              d: e
            })), i && (I = t.whiskers.strokeWidth() % 2 / 2, u += I, v += I, r = /%$/.test(i) ? o * parseFloat(i) / 100 : i / 2, e = [["M", L - r, u], ["L", L + r, u], ["M", L - r, v], ["L", L + r, v]], t.whiskers[a]({
              d: e
            })), M = Math.round(t.medianPlot), I = t.medianShape.strokeWidth() % 2 / 2, M += I, e = [["M", m, M], ["L", d, M]], t.medianShape[a]({
              d: e
            }));
          });
        }, A.prototype.toYData = function (k) {
          return [k.low, k.q1, k.median, k.q3, k.high];
        }, A.defaultOptions = W(S.defaultOptions, {
          threshold: null,
          tooltip: {
            pointFormat: '<span style="color:{point.color}">●</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>'
          },
          whiskerLength: "50%",
          fillColor: "#ffffff",
          lineWidth: 1,
          medianWidth: 2,
          whiskerWidth: 2
        }), A;
      }(S), X(B.prototype, {
        pointArrayMap: ["low", "q1", "median", "q3", "high"],
        pointValKey: "high",
        drawDataLabels: D,
        setStackedPoints: D
      }), E.registerSeriesType("boxplot", B), B;
    }), V(O, "Series/Bubble/BubbleLegendDefaults.js", [], function () {
      return {
        borderColor: void 0,
        borderWidth: 2,
        className: void 0,
        color: void 0,
        connectorClassName: void 0,
        connectorColor: void 0,
        connectorDistance: 60,
        connectorWidth: 1,
        enabled: !1,
        labels: {
          className: void 0,
          allowOverlap: !1,
          format: "",
          formatter: void 0,
          align: "right",
          style: {
            fontSize: "10px",
            color: "#000000"
          },
          x: 0,
          y: 0
        },
        maxSize: 60,
        minSize: 10,
        legendIndex: 0,
        ranges: {
          value: void 0,
          borderColor: void 0,
          color: void 0,
          connectorColor: void 0
        },
        sizeBy: "area",
        sizeByAbsoluteValue: !1,
        zIndex: 1,
        zThreshold: 0
      };
    }), V(O, "Series/Bubble/BubbleLegendItem.js", [O["Core/Color/Color.js"], O["Core/FormatUtilities.js"], O["Core/Globals.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      var H = S.parse,
        X = E.noop,
        W = B.arrayMax,
        z = B.arrayMin,
        w = B.isNumber,
        A = B.merge,
        k = B.pick,
        g = B.stableSort;
      return S = function () {
        function p(h, s) {
          this.options = this.symbols = this.visible = this.selected = this.ranges = this.movementX = this.maxLabel = this.legend = this.fontMetrics = this.chart = void 0, this.setState = X, this.init(h, s);
        }
        return p.prototype.init = function (h, s) {
          this.options = h, this.visible = !0, this.chart = s.chart, this.legend = s;
        }, p.prototype.addToLegend = function (h) {
          h.splice(this.options.legendIndex, 0, this);
        }, p.prototype.drawLegendSymbol = function (h) {
          var s = this.chart,
            l = k(h.options.itemDistance, 20),
            u = this.legendItem || {},
            v = this.options,
            M = v.ranges,
            I = v.connectorDistance;
          this.fontMetrics = s.renderer.fontMetrics(v.labels.style.fontSize), M && M.length && w(M[0].value) ? (g(M, function (L, C) {
            return C.value - L.value;
          }), this.ranges = M, this.setOptions(), this.render(), h = this.getMaxLabelSize(), M = this.ranges[0].radius, s = 2 * M, I = I - M + h.width, I = 0 < I ? I : 0, this.maxLabel = h, this.movementX = v.labels.align === "left" ? I : 0, u.labelWidth = s + I + l, u.labelHeight = s + this.fontMetrics.h / 2) : h.options.bubbleLegend.autoRanges = !0;
        }, p.prototype.setOptions = function () {
          var h = this.ranges,
            s = this.options,
            l = this.chart.series[s.seriesIndex],
            u = this.legend.baseline,
            v = {
              zIndex: s.zIndex,
              "stroke-width": s.borderWidth
            },
            M = {
              zIndex: s.zIndex,
              "stroke-width": s.connectorWidth
            },
            I = {
              align: this.legend.options.rtl || s.labels.align === "left" ? "right" : "left",
              zIndex: s.zIndex
            },
            L = l.options.marker.fillOpacity,
            C = this.chart.styledMode;
          h.forEach(function (m, d) {
            C || (v.stroke = k(m.borderColor, s.borderColor, l.color), v.fill = k(m.color, s.color, L !== 1 ? H(l.color).setOpacity(L).get("rgba") : l.color), M.stroke = k(m.connectorColor, s.connectorColor, l.color)), h[d].radius = this.getRangeRadius(m.value), h[d] = A(h[d], {
              center: h[0].radius - h[d].radius + u
            }), C || A(!0, h[d], {
              bubbleAttribs: A(v),
              connectorAttribs: A(M),
              labelAttribs: I
            });
          }, this);
        }, p.prototype.getRangeRadius = function (h) {
          var s = this.options;
          return this.chart.series[this.options.seriesIndex].getRadius.call(this, s.ranges[s.ranges.length - 1].value, s.ranges[0].value, s.minSize, s.maxSize, h);
        }, p.prototype.render = function () {
          var h = this.legendItem || {},
            s = this.chart.renderer,
            l = this.options.zThreshold;
          this.symbols || (this.symbols = {
            connectors: [],
            bubbleItems: [],
            labels: []
          }), h.symbol = s.g("bubble-legend"), h.label = s.g("bubble-legend-item"), h.symbol.translateX = 0, s = h.symbol.translateY = 0;
          for (var u = this.ranges; s < u.length; s++) {
            var v = u[s];
            v.value >= l && this.renderRange(v);
          }
          h.symbol.add(h.label), h.label.add(h.group), this.hideOverlappingLabels();
        }, p.prototype.renderRange = function (h) {
          var s = this.options,
            l = s.labels,
            u = this.chart,
            v = u.series[s.seriesIndex],
            M = u.renderer,
            I = this.symbols;
          u = I.labels;
          var L = h.center,
            C = Math.abs(h.radius),
            m = s.connectorDistance || 0,
            d = l.align,
            o = s.connectorWidth,
            n = this.ranges[0].radius || 0,
            r = L - C - s.borderWidth / 2 + o / 2,
            i = this.fontMetrics;
          i = i.f / 2 - (i.h - i.f) / 2;
          var t = M.styledMode;
          m = this.legend.options.rtl || d === "left" ? -m : m, d === "center" && (m = 0, s.connectorDistance = 0, h.labelAttribs.align = "center"), d = r + s.labels.y;
          var e = n + m + s.labels.x;
          I.bubbleItems.push(M.circle(n, L + ((r % 1 ? 1 : 0.5) - (o % 2 ? 0 : 0.5)), C).attr(t ? {} : h.bubbleAttribs).addClass((t ? "highcharts-color-" + v.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (s.className || "")).add(this.legendItem.symbol)), I.connectors.push(M.path(M.crispLine([["M", n, r], ["L", n + m, r]], s.connectorWidth)).attr(t ? {} : h.connectorAttribs).addClass((t ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (s.connectorClassName || "")).add(this.legendItem.symbol)), h = M.text(this.formatLabel(h), e, d + i).attr(t ? {} : h.labelAttribs).css(t ? {} : l.style).addClass("highcharts-bubble-legend-labels " + (s.labels.className || "")).add(this.legendItem.symbol), u.push(h), h.placed = !0, h.alignAttr = {
            x: e,
            y: d + i
          };
        }, p.prototype.getMaxLabelSize = function () {
          var h, s;
          return this.symbols.labels.forEach(function (l) {
            s = l.getBBox(!0), h = h ? s.width > h.width ? s : h : s;
          }), h || {};
        }, p.prototype.formatLabel = function (h) {
          var s = this.options,
            l = s.labels.formatter;
          s = s.labels.format;
          var u = this.chart.numberFormatter;
          return s ? D.format(s, h) : l ? l.call(h) : u(h.value, 1);
        }, p.prototype.hideOverlappingLabels = function () {
          var h = this.chart,
            s = this.symbols;
          !this.options.labels.allowOverlap && s && (h.hideOverlappingLabels(s.labels), s.labels.forEach(function (l, u) {
            l.newOpacity ? l.newOpacity !== l.oldOpacity && s.connectors[u].show() : s.connectors[u].hide();
          }));
        }, p.prototype.getRanges = function () {
          var h = this.legend.bubbleLegend,
            s = h.options.ranges,
            l,
            u = Number.MAX_VALUE,
            v = -Number.MAX_VALUE;
          h.chart.series.forEach(function (I) {
            I.isBubble && !I.ignoreSeries && (l = I.zData.filter(w), l.length && (u = k(I.options.zMin, Math.min(u, Math.max(z(l), I.options.displayNegative === !1 ? I.options.zThreshold : -Number.MAX_VALUE))), v = k(I.options.zMax, Math.max(v, W(l)))));
          });
          var M = u === v ? [{
            value: v
          }] : [{
            value: u
          }, {
            value: (u + v) / 2
          }, {
            value: v,
            autoRanges: !0
          }];
          return s.length && s[0].radius && M.reverse(), M.forEach(function (I, L) {
            s && s[L] && (M[L] = A(s[L], I));
          }), M;
        }, p.prototype.predictBubbleSizes = function () {
          var h = this.chart,
            s = this.fontMetrics,
            l = h.legend.options,
            u = l.floating,
            v = (l = l.layout === "horizontal") ? h.legend.lastLineHeight : 0,
            M = h.plotSizeX,
            I = h.plotSizeY,
            L = h.series[this.options.seriesIndex],
            C = L.getPxExtremes();
          h = Math.ceil(C.minPxSize), C = Math.ceil(C.maxPxSize);
          var m = Math.min(I, M);
          return L = L.options.maxSize, u || !/%$/.test(L) ? s = C : (L = parseFloat(L), s = (m + v - s.h / 2) * L / 100 / (L / 100 + 1), (l && I - s >= M || !l && M - s >= I) && (s = C)), [h, Math.ceil(s)];
        }, p.prototype.updateRanges = function (h, s) {
          var l = this.legend.options.bubbleLegend;
          l.minSize = h, l.maxSize = s, l.ranges = this.getRanges();
        }, p.prototype.correctSizes = function () {
          var h = this.legend,
            s = this.chart.series[this.options.seriesIndex].getPxExtremes();
          1 < Math.abs(Math.ceil(s.maxPxSize) - this.options.maxSize) && (this.updateRanges(this.options.minSize, s.maxPxSize), h.render());
        }, p;
      }(), S;
    }), V(O, "Series/Bubble/BubbleLegendComposition.js", [O["Series/Bubble/BubbleLegendDefaults.js"], O["Series/Bubble/BubbleLegendItem.js"], O["Core/Defaults.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      function H(l, u, v) {
        var M = this.legend,
          I = 0 <= X(this),
          L;
        if (M && M.options.enabled && M.bubbleLegend && M.options.bubbleLegend.autoRanges && I) {
          var C = M.bubbleLegend.options;
          I = M.bubbleLegend.predictBubbleSizes(), M.bubbleLegend.updateRanges(I[0], I[1]), C.placed || (M.group.placed = !1, M.allItems.forEach(function (m) {
            L = m.legendItem || {}, L.group && (L.group.translateY = null);
          })), M.render(), this.getMargins(), this.axes.forEach(function (m) {
            m.visible && m.render(), C.placed || (m.setScale(), m.updateNames(), p(m.ticks, function (d) {
              d.isNew = !0, d.isNewLabel = !0;
            }));
          }), C.placed = !0, this.getMargins(), l.call(this, u, v), M.bubbleLegend.correctSizes(), A(M, W(M));
        } else l.call(this, u, v), M && M.options.enabled && M.bubbleLegend && (M.render(), A(M, W(M)));
      }
      function X(l) {
        l = l.series;
        for (var u = 0; u < l.length;) {
          if (l[u] && l[u].isBubble && l[u].visible && l[u].zData.length) return u;
          u++;
        }
        return -1;
      }
      function W(l) {
        l = l.allItems;
        var u = [],
          v = l.length,
          M,
          I = 0;
        for (M = 0; M < v; M++) {
          var L = l[M].legendItem || {},
            C = (l[M + 1] || {}).legendItem || {};
          if (L.labelHeight && (l[M].itemHeight = L.labelHeight), l[M] === l[v - 1] || L.y !== C.y) {
            for (u.push({
              height: 0
            }), L = u[u.length - 1], I; I <= M; I++) l[I].itemHeight > L.height && (L.height = l[I].itemHeight);
            L.step = M;
          }
        }
        return u;
      }
      function z(l) {
        var u = this.bubbleLegend,
          v = this.options,
          M = v.bubbleLegend,
          I = X(this.chart);
        u && u.ranges && u.ranges.length && (M.ranges.length && (M.autoRanges = !!M.ranges[0].autoRanges), this.destroyItem(u)), 0 <= I && v.enabled && M.enabled && (M.seriesIndex = I, this.bubbleLegend = new D(M, this), this.bubbleLegend.addToLegend(l.allItems));
      }
      function w() {
        var l = this.chart,
          u = this.visible,
          v = this.chart.legend;
        v && v.bubbleLegend && (this.visible = !u, this.ignoreSeries = u, l = 0 <= X(l), v.bubbleLegend.visible !== l && (v.update({
          bubbleLegend: {
            enabled: l
          }
        }), v.bubbleLegend.visible = l), this.visible = u);
      }
      function A(l, u) {
        var v = l.options.rtl,
          M,
          I,
          L,
          C,
          m = 0;
        l.allItems.forEach(function (d, o) {
          C = d.legendItem || {}, C.group && (M = C.group.translateX || 0, I = C.y || 0, ((L = d.movementX) || v && d.ranges) && (L = v ? M - d.options.maxSize / 2 : M + L, C.group.attr({
            translateX: L
          })), o > u[m].step && m++, C.group.attr({
            translateY: Math.round(I + u[m].height / 2)
          }), C.y = I + u[m].height / 2);
        });
      }
      var k = E.setOptions,
        g = B.addEvent,
        p = B.objectEach,
        h = B.wrap,
        s = [];
      return {
        compose: function compose(l, u, v) {
          s.indexOf(l) === -1 && (s.push(l), k({
            legend: {
              bubbleLegend: S
            }
          }), h(l.prototype, "drawChartBox", H)), s.indexOf(u) === -1 && (s.push(u), g(u, "afterGetAllItems", z)), s.indexOf(v) === -1 && (s.push(v), g(v, "legendItemClick", w));
        }
      };
    }), V(O, "Series/Bubble/BubblePoint.js", [O["Core/Series/Point.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E) {
      var B = this && this.__extends || function () {
        var _H = function H(X, W) {
          return _H = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (z, w) {
            z.__proto__ = w;
          } || function (z, w) {
            for (var A in w) w.hasOwnProperty(A) && (z[A] = w[A]);
          }, _H(X, W);
        };
        return function (X, W) {
          function z() {
            this.constructor = X;
          }
          _H(X, W), X.prototype = W === null ? Object.create(W) : (z.prototype = W.prototype, new z());
        };
      }();
      return E = E.extend, D = function (H) {
        function X() {
          var W = H !== null && H.apply(this, arguments) || this;
          return W.options = void 0, W.series = void 0, W;
        }
        return B(X, H), X.prototype.haloPath = function (W) {
          return S.prototype.haloPath.call(this, W === 0 ? 0 : (this.marker && this.marker.radius || 0) + W);
        }, X;
      }(D.seriesTypes.scatter.prototype.pointClass), E(D.prototype, {
        ttBelow: !1
      }), D;
    }), V(O, "Series/Bubble/BubbleSeries.js", [O["Series/Bubble/BubbleLegendComposition.js"], O["Series/Bubble/BubblePoint.js"], O["Core/Color/Color.js"], O["Core/Globals.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B, H, X) {
      function W() {
        var L = this,
          C = this.len,
          m = this.chart,
          d = this.isXAxis,
          o = d ? "xData" : "yData",
          n = this.min,
          r = this.max - n,
          i = 0,
          t = C,
          e = C / r,
          a;
        this.series.forEach(function (c) {
          if (c.bubblePadding && (c.visible || !m.options.chart.ignoreHiddenSeries)) {
            a = L.allowZoomOutside = !0;
            var y = c[o];
            if (d && ((c.onPoint || c).getRadii(0, 0, c), c.onPoint && (c.radii = c.onPoint.radii)), 0 < r) {
              for (var b = y.length; b--;) if (u(y[b]) && L.dataMin <= y[b] && y[b] <= L.max) {
                var j = c.radii && c.radii[b] || 0;
                i = Math.min((y[b] - n) * e - j, i), t = Math.max((y[b] - n) * e + j, t);
              }
            }
          }
        }), a && 0 < r && !this.logarithmic && (t -= C, e *= (C + Math.max(0, i) - Math.min(t, C)) / C, [["min", "userMin", i], ["max", "userMax", t]].forEach(function (c) {
          typeof M(L.options[c[0]], L[c[1]]) > "u" && (L[c[0]] += c[2] / e);
        }));
      }
      var z = this && this.__extends || function () {
          var _L = function L(C, m) {
            return _L = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (d, o) {
              d.__proto__ = o;
            } || function (d, o) {
              for (var n in o) o.hasOwnProperty(n) && (d[n] = o[n]);
            }, _L(C, m);
          };
          return function (C, m) {
            function d() {
              this.constructor = C;
            }
            _L(C, m), C.prototype = m === null ? Object.create(m) : (d.prototype = m.prototype, new d());
          };
        }(),
        w = E.parse;
      E = B.noop;
      var A = H.series,
        k = H.seriesTypes;
      B = k.column.prototype;
      var g = k.scatter;
      k = X.addEvent;
      var p = X.arrayMax,
        h = X.arrayMin,
        s = X.clamp,
        l = X.extend,
        u = X.isNumber,
        v = X.merge,
        M = X.pick,
        I = [];
      return X = function (L) {
        function C() {
          var m = L !== null && L.apply(this, arguments) || this;
          return m.data = void 0, m.maxPxSize = void 0, m.minPxSize = void 0, m.options = void 0, m.points = void 0, m.radii = void 0, m.yData = void 0, m.zData = void 0, m;
        }
        return z(C, L), C.compose = function (m, d, o, n) {
          S.compose(d, o, n), I.indexOf(m) === -1 && (I.push(m), m.prototype.beforePadding = W);
        }, C.prototype.animate = function (m) {
          !m && this.points.length < this.options.animationLimit && this.points.forEach(function (d) {
            var o = d.graphic;
            o && o.width && (this.hasRendered || o.attr({
              x: d.plotX,
              y: d.plotY,
              width: 1,
              height: 1
            }), o.animate(this.markerAttribs(d), this.options.animation));
          }, this);
        }, C.prototype.getRadii = function () {
          var m = this,
            d = this.zData,
            o = this.yData,
            n = [],
            r = this.chart.bubbleZExtremes,
            i = this.getPxExtremes(),
            t = i.minPxSize,
            e = i.maxPxSize;
          if (!r) {
            var a = Number.MAX_VALUE,
              c = -Number.MAX_VALUE,
              y;
            this.chart.series.forEach(function (P) {
              P.bubblePadding && (P.visible || !m.chart.options.chart.ignoreHiddenSeries) && (P = (P.onPoint || P).getZExtremes()) && (a = Math.min(a || P.zMin, P.zMin), c = Math.max(c || P.zMax, P.zMax), y = !0);
            }), y ? (r = {
              zMin: a,
              zMax: c
            }, this.chart.bubbleZExtremes = r) : r = {
              zMin: 0,
              zMax: 0
            };
          }
          var b = 0;
          for (i = d.length; b < i; b++) {
            var j = d[b];
            n.push(this.getRadius(r.zMin, r.zMax, t, e, j, o && o[b]));
          }
          this.radii = n;
        }, C.prototype.getRadius = function (m, d, o, n, r, i) {
          var t = this.options,
            e = t.sizeBy !== "width",
            a = t.zThreshold,
            c = d - m,
            y = 0.5;
          if (i === null || r === null) return null;
          if (u(r)) {
            if (t.sizeByAbsoluteValue && (r = Math.abs(r - a), c = Math.max(d - a, Math.abs(m - a)), m = 0), r < m) return o / 2 - 1;
            0 < c && (y = (r - m) / c);
          }
          return e && 0 <= y && (y = Math.sqrt(y)), Math.ceil(o + y * (n - o)) / 2;
        }, C.prototype.hasData = function () {
          return !!this.processedXData.length;
        }, C.prototype.pointAttribs = function (m, d) {
          var o = this.options.marker.fillOpacity;
          return m = A.prototype.pointAttribs.call(this, m, d), o !== 1 && (m.fill = w(m.fill).setOpacity(o).get("rgba")), m;
        }, C.prototype.translate = function () {
          L.prototype.translate.call(this), this.getRadii(), this.translateBubble();
        }, C.prototype.translateBubble = function () {
          for (var m = this.data, d = this.radii, o = this.getPxExtremes().minPxSize, n = m.length; n--;) {
            var r = m[n],
              i = d ? d[n] : 0;
            u(i) && i >= o / 2 ? (r.marker = l(r.marker, {
              radius: i,
              width: 2 * i,
              height: 2 * i
            }), r.dlBox = {
              x: r.plotX - i,
              y: r.plotY - i,
              width: 2 * i,
              height: 2 * i
            }) : (r.shapeArgs = r.plotY = r.dlBox = void 0, r.isInside = !1);
          }
        }, C.prototype.getPxExtremes = function () {
          var m = Math.min(this.chart.plotWidth, this.chart.plotHeight),
            d = function d(n) {
              if (typeof n == "string") {
                var r = /%$/.test(n);
                n = parseInt(n, 10);
              }
              return r ? m * n / 100 : n;
            },
            o = d(M(this.options.minSize, 8));
          return d = Math.max(d(M(this.options.maxSize, "20%")), o), {
            minPxSize: o,
            maxPxSize: d
          };
        }, C.prototype.getZExtremes = function () {
          var m = this.options,
            d = (this.zData || []).filter(u);
          if (d.length) {
            var o = M(m.zMin, s(h(d), m.displayNegative === !1 ? m.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE));
            if (m = M(m.zMax, p(d)), u(o) && u(m)) return {
              zMin: o,
              zMax: m
            };
          }
        }, C.defaultOptions = v(g.defaultOptions, {
          dataLabels: {
            formatter: function formatter() {
              var m = this.series.chart.numberFormatter,
                d = this.point.z;
              return u(d) ? m(d, -1) : "";
            },
            inside: !0,
            verticalAlign: "middle"
          },
          animationLimit: 250,
          marker: {
            lineColor: null,
            lineWidth: 1,
            fillOpacity: 0.5,
            radius: null,
            states: {
              hover: {
                radiusPlus: 0
              }
            },
            symbol: "circle"
          },
          minSize: 8,
          maxSize: "20%",
          softThreshold: !1,
          states: {
            hover: {
              halo: {
                size: 5
              }
            }
          },
          tooltip: {
            pointFormat: "({point.x}, {point.y}), Size: {point.z}"
          },
          turboThreshold: 0,
          zThreshold: 0,
          zoneAxis: "z"
        }), C;
      }(g), l(X.prototype, {
        alignDataLabel: B.alignDataLabel,
        applyZones: E,
        bubblePadding: !0,
        buildKDTree: E,
        directTouch: !0,
        isBubble: !0,
        pointArrayMap: ["y", "z"],
        pointClass: D,
        parallelArrays: ["x", "y", "z"],
        trackerGroups: ["group", "dataLabelsGroup"],
        specialGroup: "group",
        zoneAxis: "z"
      }), k(X, "updatedData", function (L) {
        delete L.target.chart.bubbleZExtremes;
      }), k(X, "remove", function (L) {
        delete L.target.chart.bubbleZExtremes;
      }), H.registerSeriesType("bubble", X), X;
    }), V(O, "Series/ColumnRange/ColumnRangePoint.js", [O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D) {
      var E = this && this.__extends || function () {
          var _W2 = function W(z, w) {
            return _W2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (A, k) {
              A.__proto__ = k;
            } || function (A, k) {
              for (var g in k) k.hasOwnProperty(g) && (A[g] = k[g]);
            }, _W2(z, w);
          };
          return function (z, w) {
            function A() {
              this.constructor = z;
            }
            _W2(z, w), z.prototype = w === null ? Object.create(w) : (A.prototype = w.prototype, new A());
          };
        }(),
        B = S.seriesTypes;
      S = B.column.prototype.pointClass.prototype;
      var H = D.extend,
        X = D.isNumber;
      return D = function (W) {
        function z() {
          var w = W !== null && W.apply(this, arguments) || this;
          return w.options = void 0, w.series = void 0, w;
        }
        return E(z, W), z.prototype.isValid = function () {
          return X(this.low);
        }, z;
      }(B.arearange.prototype.pointClass), H(D.prototype, {
        setState: S.setState
      }), D;
    }), V(O, "Series/ColumnRange/ColumnRangeSeries.js", [O["Series/ColumnRange/ColumnRangePoint.js"], O["Core/Globals.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      var H = this && this.__extends || function () {
        var _s2 = function s(l, u) {
          return _s2 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (v, M) {
            v.__proto__ = M;
          } || function (v, M) {
            for (var I in M) M.hasOwnProperty(I) && (v[I] = M[I]);
          }, _s2(l, u);
        };
        return function (l, u) {
          function v() {
            this.constructor = l;
          }
          _s2(l, u), l.prototype = u === null ? Object.create(u) : (v.prototype = u.prototype, new v());
        };
      }();
      D = D.noop;
      var X = E.seriesTypes,
        W = X.arearange,
        z = X.column,
        w = X.column.prototype,
        A = B.clamp;
      X = B.extend;
      var k = B.isNumber,
        g = B.merge,
        p = B.pick,
        h = {
          pointRange: null,
          marker: null,
          states: {
            hover: {
              halo: !1
            }
          }
        };
      return B = function (s) {
        function l() {
          return s !== null && s.apply(this, arguments) || this;
        }
        return H(l, s), l.prototype.setOptions = function () {
          return g(!0, arguments[0], {
            stacking: void 0
          }), W.prototype.setOptions.apply(this, arguments);
        }, l.prototype.translate = function () {
          var u = this,
            v = this.yAxis,
            M = this.xAxis,
            I = M.startAngleRad,
            L = this.chart,
            C = this.xAxis.isRadial,
            m = Math.max(L.chartWidth, L.chartHeight) + 999,
            d,
            o,
            n,
            r;
          w.translate.apply(this), this.points.forEach(function (i) {
            var t = i.shapeArgs || {},
              e = u.options.minPointLength,
              a = i.plotY,
              c = v.translate(i.high, 0, 1, 0, 1);
            k(c) && k(a) && (i.plotHigh = A(c, -m, m), i.plotLow = A(a, -m, m), r = i.plotHigh, d = p(i.rectPlotY, i.plotY) - i.plotHigh, Math.abs(d) < e ? (o = e - d, d += o, r -= o / 2) : 0 > d && (d *= -1, r -= d), C && u.polar ? (n = i.barX + I, i.shapeType = "arc", i.shapeArgs = u.polar.arc(r + d, r, n, n + i.pointWidth)) : (t.height = d, t.y = r, e = t.x, e = e === void 0 ? 0 : e, t = t.width, t = t === void 0 ? 0 : t, i.tooltipPos = L.inverted ? [v.len + v.pos - L.plotLeft - r - d / 2, M.len + M.pos - L.plotTop - e - t / 2, d] : [M.left - L.plotLeft + e + t / 2, v.pos - L.plotTop + r + d / 2, d]));
          });
        }, l.prototype.pointAttribs = function () {
          return w.pointAttribs.apply(this, arguments);
        }, l.prototype.translate3dPoints = function () {
          return w.translate3dPoints.apply(this, arguments);
        }, l.prototype.translate3dShapes = function () {
          return w.translate3dShapes.apply(this, arguments);
        }, l.defaultOptions = g(z.defaultOptions, W.defaultOptions, h), l;
      }(W), X(B.prototype, {
        directTouch: !0,
        pointClass: S,
        trackerGroups: ["group", "dataLabelsGroup"],
        adjustForMissingColumns: w.adjustForMissingColumns,
        animate: w.animate,
        crispCol: w.crispCol,
        drawGraph: D,
        drawPoints: w.drawPoints,
        getSymbol: D,
        drawTracker: w.drawTracker,
        getColumnMetrics: w.getColumnMetrics
      }), E.registerSeriesType("columnrange", B), B;
    }), V(O, "Series/ColumnPyramid/ColumnPyramidSeries.js", [O["Series/Column/ColumnSeries.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E) {
      var B = this && this.__extends || function () {
          var _w2 = function w(A, k) {
            return _w2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (g, p) {
              g.__proto__ = p;
            } || function (g, p) {
              for (var h in p) p.hasOwnProperty(h) && (g[h] = p[h]);
            }, _w2(A, k);
          };
          return function (A, k) {
            function g() {
              this.constructor = A;
            }
            _w2(A, k), A.prototype = k === null ? Object.create(k) : (g.prototype = k.prototype, new g());
          };
        }(),
        H = S.prototype,
        X = E.clamp,
        W = E.merge,
        z = E.pick;
      return E = function (w) {
        function A() {
          var k = w !== null && w.apply(this, arguments) || this;
          return k.data = void 0, k.options = void 0, k.points = void 0, k;
        }
        return B(A, w), A.prototype.translate = function () {
          var k = this,
            g = k.chart,
            p = k.options,
            h = k.dense = 2 > k.closestPointRange * k.xAxis.transA;
          h = k.borderWidth = z(p.borderWidth, h ? 0 : 1);
          var s = k.yAxis,
            l = p.threshold,
            u = k.translatedThreshold = s.getThreshold(l),
            v = z(p.minPointLength, 5),
            M = k.getColumnMetrics(),
            I = M.width,
            L = k.barW = Math.max(I, 1 + 2 * h),
            C = k.pointXOffset = M.offset;
          g.inverted && (u -= 0.5), p.pointPadding && (L = Math.ceil(L)), H.translate.apply(k), k.points.forEach(function (m) {
            var d = z(m.yBottom, u),
              o = 999 + Math.abs(d),
              n = X(m.plotY, -o, s.len + o);
            o = m.plotX + C;
            var r = L / 2,
              i = Math.min(n, d);
            d = Math.max(n, d) - i;
            var t;
            m.barX = o, m.pointWidth = I, m.tooltipPos = g.inverted ? [s.len + s.pos - g.plotLeft - n, k.xAxis.len - o - r, d] : [o + r, n + s.pos - g.plotTop, d], n = l + (m.total || m.y), p.stacking === "percent" && (n = l + (0 > m.y) ? -100 : 100), n = s.toPixels(n, !0);
            var e = (t = g.plotHeight - n - (g.plotHeight - u)) ? r * (i - n) / t : 0,
              a = t ? r * (i + d - n) / t : 0;
            t = o - e + r, e = o + e + r;
            var c = o + a + r;
            a = o - a + r;
            var y = i - v,
              b = i + d;
            0 > m.y && (y = i, b = i + d + v), g.inverted && (c = s.width - i, t = n - (s.width - u), e = r * (n - c) / t, a = r * (n - (c - d)) / t, t = o + r + e, e = t - 2 * e, c = o - a + r, a = o + a + r, y = i, b = i + d - v, 0 > m.y && (b = i + d + v)), m.shapeType = "path", m.shapeArgs = {
              x: t,
              y: y,
              width: e - t,
              height: d,
              d: [["M", t, y], ["L", e, y], ["L", c, b], ["L", a, b], ["Z"]]
            };
          });
        }, A.defaultOptions = W(S.defaultOptions, {}), A;
      }(S), D.registerSeriesType("columnpyramid", E), E;
    }), V(O, "Series/ErrorBar/ErrorBarSeriesDefaults.js", [], function () {
      return {
        color: "#000000",
        grouping: !1,
        linkedTo: ":previous",
        tooltip: {
          pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'
        },
        whiskerWidth: null
      };
    }), V(O, "Series/ErrorBar/ErrorBarSeries.js", [O["Series/BoxPlot/BoxPlotSeries.js"], O["Series/Column/ColumnSeries.js"], O["Series/ErrorBar/ErrorBarSeriesDefaults.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B, H) {
      var X = this && this.__extends || function () {
          var _k = function k(g, p) {
            return _k = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        W = B.seriesTypes.arearange,
        z = H.addEvent,
        w = H.merge;
      H = H.extend;
      var A = function (k) {
        function g() {
          var p = k !== null && k.apply(this, arguments) || this;
          return p.data = void 0, p.options = void 0, p.points = void 0, p;
        }
        return X(g, k), g.prototype.getColumnMetrics = function () {
          return this.linkedParent && this.linkedParent.columnMetrics || D.prototype.getColumnMetrics.call(this);
        }, g.prototype.drawDataLabels = function () {
          var p = this.pointValKey;
          W && (W.prototype.drawDataLabels.call(this), this.data.forEach(function (h) {
            h.y = h[p];
          }));
        }, g.prototype.toYData = function (p) {
          return [p.low, p.high];
        }, g.defaultOptions = w(S.defaultOptions, E), g;
      }(S);
      return z(A, "afterTranslate", function () {
        this.points.forEach(function (k) {
          k.plotLow = k.plotY;
        });
      }, {
        order: 0
      }), H(A.prototype, {
        pointArrayMap: ["low", "high"],
        pointValKey: "high",
        doQuartiles: !1
      }), B.registerSeriesType("errorbar", A), A;
    }), V(O, "Series/Gauge/GaugePoint.js", [O["Core/Series/SeriesRegistry.js"]], function (S) {
      var D = this && this.__extends || function () {
        var _E = function E(B, H) {
          return _E = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (X, W) {
            X.__proto__ = W;
          } || function (X, W) {
            for (var z in W) W.hasOwnProperty(z) && (X[z] = W[z]);
          }, _E(B, H);
        };
        return function (B, H) {
          function X() {
            this.constructor = B;
          }
          _E(B, H), B.prototype = H === null ? Object.create(H) : (X.prototype = H.prototype, new X());
        };
      }();
      return function (E) {
        function B() {
          var H = E !== null && E.apply(this, arguments) || this;
          return H.options = void 0, H.series = void 0, H.shapeArgs = void 0, H;
        }
        return D(B, E), B.prototype.setState = function (H) {
          this.state = H;
        }, B;
      }(S.series.prototype.pointClass);
    }), V(O, "Series/Gauge/GaugeSeries.js", [O["Series/Gauge/GaugePoint.js"], O["Core/Globals.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      var H = this && this.__extends || function () {
        var _h = function h(s, l) {
          return _h = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (u, v) {
            u.__proto__ = v;
          } || function (u, v) {
            for (var M in v) v.hasOwnProperty(M) && (u[M] = v[M]);
          }, _h(s, l);
        };
        return function (s, l) {
          function u() {
            this.constructor = s;
          }
          _h(s, l), s.prototype = l === null ? Object.create(l) : (u.prototype = l.prototype, new u());
        };
      }();
      D = D.noop;
      var X = E.series,
        W = E.seriesTypes.column,
        z = B.clamp,
        w = B.isNumber,
        A = B.extend,
        k = B.merge,
        g = B.pick,
        p = B.pInt;
      return B = function (h) {
        function s() {
          var l = h !== null && h.apply(this, arguments) || this;
          return l.data = void 0, l.points = void 0, l.options = void 0, l.yAxis = void 0, l;
        }
        return H(s, h), s.prototype.translate = function () {
          var l = this.yAxis,
            u = this.options,
            v = l.center;
          this.generatePoints(), this.points.forEach(function (M) {
            var I = k(u.dial, M.dial),
              L = p(I.radius) * v[2] / 200,
              C = p(I.baseLength) * L / 100,
              m = p(I.rearLength) * L / 100,
              d = I.baseWidth,
              o = I.topWidth,
              n = u.overshoot,
              r = l.startAngleRad + l.translate(M.y, void 0, void 0, void 0, !0);
            (w(n) || u.wrap === !1) && (n = w(n) ? n / 180 * Math.PI : 0, r = z(r, l.startAngleRad - n, l.endAngleRad + n)), r = 180 * r / Math.PI, M.shapeType = "path", M.shapeArgs = {
              d: I.path || [["M", -m, -d / 2], ["L", C, -d / 2], ["L", L, -o / 2], ["L", L, o / 2], ["L", C, d / 2], ["L", -m, d / 2], ["Z"]],
              translateX: v[0],
              translateY: v[1],
              rotation: r
            }, M.plotX = v[0], M.plotY = v[1];
          });
        }, s.prototype.drawPoints = function () {
          var l = this,
            u = l.chart,
            v = l.yAxis.center,
            M = l.pivot,
            I = l.options,
            L = I.pivot,
            C = u.renderer;
          l.points.forEach(function (m) {
            var d = m.graphic,
              o = m.shapeArgs,
              n = o.d,
              r = k(I.dial, m.dial);
            d ? (d.animate(o), o.d = n) : m.graphic = C[m.shapeType](o).attr({
              rotation: o.rotation,
              zIndex: 1
            }).addClass("highcharts-dial").add(l.group), u.styledMode || m.graphic[d ? "animate" : "attr"]({
              stroke: r.borderColor,
              "stroke-width": r.borderWidth,
              fill: r.backgroundColor
            });
          }), M ? M.animate({
            translateX: v[0],
            translateY: v[1]
          }) : L && (l.pivot = C.circle(0, 0, L.radius).attr({
            zIndex: 2
          }).addClass("highcharts-pivot").translate(v[0], v[1]).add(l.group), u.styledMode || l.pivot.attr({
            fill: L.backgroundColor,
            stroke: L.borderColor,
            "stroke-width": L.borderWidth
          }));
        }, s.prototype.animate = function (l) {
          var u = this;
          l || u.points.forEach(function (v) {
            var M = v.graphic;
            M && (M.attr({
              rotation: 180 * u.yAxis.startAngleRad / Math.PI
            }), M.animate({
              rotation: v.shapeArgs.rotation
            }, u.options.animation));
          });
        }, s.prototype.render = function () {
          this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), X.prototype.render.call(this), this.group.clip(this.chart.clipRect);
        }, s.prototype.setData = function (l, u) {
          X.prototype.setData.call(this, l, !1), this.processData(), this.generatePoints(), g(u, !0) && this.chart.redraw();
        }, s.prototype.hasData = function () {
          return !!this.points.length;
        }, s.defaultOptions = k(X.defaultOptions, {
          dataLabels: {
            borderColor: "#cccccc",
            borderRadius: 3,
            borderWidth: 1,
            crop: !1,
            defer: !1,
            enabled: !0,
            verticalAlign: "top",
            y: 15,
            zIndex: 2
          },
          dial: {
            backgroundColor: "#000000",
            baseLength: "70%",
            baseWidth: 3,
            borderColor: "#cccccc",
            borderWidth: 0,
            radius: "80%",
            rearLength: "10%",
            topWidth: 1
          },
          pivot: {
            radius: 5,
            borderWidth: 0,
            borderColor: "#cccccc",
            backgroundColor: "#000000"
          },
          tooltip: {
            headerFormat: ""
          },
          showInLegend: !1
        }), s;
      }(X), A(B.prototype, {
        angular: !0,
        directTouch: !0,
        drawGraph: D,
        drawTracker: W.prototype.drawTracker,
        fixedBox: !0,
        forceDL: !0,
        noSharedTooltip: !0,
        pointClass: S,
        trackerGroups: ["group", "dataLabelsGroup"]
      }), E.registerSeriesType("gauge", B), B;
    }), V(O, "Series/DragNodesComposition.js", [O["Core/Utilities.js"]], function (S) {
      function D() {
        var H = this,
          X,
          W,
          z;
        H.container && (X = E(H.container, "mousedown", function (w) {
          var A = H.hoverPoint;
          A && A.series && A.series.hasDraggableNodes && A.series.options.draggable && (A.series.onMouseDown(A, w), W = E(H.container, "mousemove", function (k) {
            return A && A.series && A.series.onMouseMove(A, k);
          }), z = E(H.container.ownerDocument, "mouseup", function (k) {
            return W(), z(), A && A.series && A.series.onMouseUp(A, k);
          }));
        })), E(H, "destroy", function () {
          X();
        });
      }
      var E = S.addEvent,
        B = [];
      return {
        compose: function compose(H) {
          B.indexOf(H) === -1 && (B.push(H), E(H, "load", D));
        },
        onMouseDown: function onMouseDown(H, X) {
          X = this.chart.pointer.normalize(X), H.fixedPosition = {
            chartX: X.chartX,
            chartY: X.chartY,
            plotX: H.plotX,
            plotY: H.plotY
          }, H.inDragMode = !0;
        },
        onMouseMove: function onMouseMove(H, X) {
          if (H.fixedPosition && H.inDragMode) {
            var W = this.chart,
              z = W.pointer.normalize(X);
            X = H.fixedPosition.chartX - z.chartX, z = H.fixedPosition.chartY - z.chartY;
            var w = W.graphLayoutsLookup,
              A = void 0,
              k = void 0;
            (5 < Math.abs(X) || 5 < Math.abs(z)) && (A = H.fixedPosition.plotX - X, k = H.fixedPosition.plotY - z, W.isInsidePlot(A, k) && (H.plotX = A, H.plotY = k, H.hasDragged = !0, this.redrawHalo(H), w.forEach(function (g) {
              g.restartSimulation();
            })));
          }
        },
        onMouseUp: function onMouseUp(H, X) {
          H.fixedPosition && (H.hasDragged && (this.layout.enableSimulation ? this.layout.start() : this.chart.redraw()), H.inDragMode = H.hasDragged = !1, this.options.fixedDraggable || delete H.fixedPosition);
        },
        redrawHalo: function redrawHalo(H) {
          H && this.halo && this.halo.attr({
            d: H.haloPath(this.options.states.hover.halo.size)
          });
        }
      };
    }), V(O, "Series/GraphLayoutComposition.js", [O["Core/Animation/AnimationUtilities.js"], O["Core/Utilities.js"]], function (S, D) {
      function E() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach(function (A) {
          A.updateSimulation();
        }), this.redraw());
      }
      function B() {
        this.graphLayoutsLookup && (this.graphLayoutsLookup.forEach(function (A) {
          A.updateSimulation(!1);
        }), this.redraw());
      }
      function H() {
        this.graphLayoutsLookup && this.graphLayoutsLookup.forEach(function (A) {
          A.stop();
        });
      }
      function X() {
        var A = !1,
          k = function k(p) {
            p.maxIterations-- && isFinite(p.temperature) && !p.isStable() && !p.enableSimulation && (p.beforeStep && p.beforeStep(), p.step(), g = !1, A = !0);
          };
        if (this.graphLayoutsLookup) {
          for (W(!1, this), this.graphLayoutsLookup.forEach(function (p) {
            return p.start();
          }); !g;) {
            var g = !0;
            this.graphLayoutsLookup.forEach(k);
          }
          A && this.series.forEach(function (p) {
            p && p.layout && p.render();
          });
        }
      }
      var W = S.setAnimation,
        z = D.addEvent,
        w = [];
      return {
        compose: function compose(A) {
          w.indexOf(A) && (w.push(A), z(A, "afterPrint", E), z(A, "beforePrint", B), z(A, "predraw", H), z(A, "render", X));
        },
        integrations: {},
        layouts: {}
      };
    }), V(O, "Series/PackedBubble/PackedBubblePoint.js", [O["Core/Chart/Chart.js"], O["Core/Series/Point.js"], O["Core/Series/SeriesRegistry.js"]], function (S, D, E) {
      var B = this && this.__extends || function () {
        var _H2 = function H(X, W) {
          return _H2 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (z, w) {
            z.__proto__ = w;
          } || function (z, w) {
            for (var A in w) w.hasOwnProperty(A) && (z[A] = w[A]);
          }, _H2(X, W);
        };
        return function (X, W) {
          function z() {
            this.constructor = X;
          }
          _H2(X, W), X.prototype = W === null ? Object.create(W) : (z.prototype = W.prototype, new z());
        };
      }();
      return function (H) {
        function X() {
          var W = H !== null && H.apply(this, arguments) || this;
          return W.degree = NaN, W.mass = NaN, W.radius = NaN, W.options = void 0, W.series = void 0, W.value = null, W;
        }
        return B(X, H), X.prototype.destroy = function () {
          return this.series.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), D.prototype.destroy.apply(this, arguments);
        }, X.prototype.firePointEvent = function () {
          var W = this.series.options;
          if (this.isParentNode && W.parentNode) {
            var z = W.allowPointSelect;
            W.allowPointSelect = W.parentNode.allowPointSelect, D.prototype.firePointEvent.apply(this, arguments), W.allowPointSelect = z;
          } else D.prototype.firePointEvent.apply(this, arguments);
        }, X.prototype.select = function () {
          var W = this.series.chart;
          this.isParentNode ? (W.getSelectedPoints = W.getSelectedParentNodes, D.prototype.select.apply(this, arguments), W.getSelectedPoints = S.prototype.getSelectedPoints) : D.prototype.select.apply(this, arguments);
        }, X;
      }(E.seriesTypes.bubble.prototype.pointClass);
    }), V(O, "Series/PackedBubble/PackedBubbleSeriesDefaults.js", [O["Core/Utilities.js"]], function (S) {
      var D = S.isNumber;
      return {
        minSize: "10%",
        maxSize: "50%",
        sizeBy: "area",
        zoneAxis: "y",
        crisp: !1,
        tooltip: {
          pointFormat: "Value: {point.value}"
        },
        draggable: !0,
        useSimulation: !0,
        parentNode: {
          allowPointSelect: !1
        },
        dataLabels: {
          formatter: function formatter() {
            var E = this.series.chart.numberFormatter,
              B = this.point.value;
            return D(B) ? E(B, -1) : "";
          },
          parentNodeFormatter: function parentNodeFormatter() {
            return this.name;
          },
          parentNodeTextPath: {
            enabled: !0
          },
          padding: 0,
          style: {
            transition: "opacity 2000ms"
          }
        },
        layoutAlgorithm: {
          initialPositions: "circle",
          initialPositionRadius: 20,
          bubblePadding: 5,
          parentNodeLimit: !1,
          seriesInteraction: !0,
          dragBetweenSeries: !1,
          parentNodeOptions: {
            maxIterations: 400,
            gravitationalConstant: 0.03,
            maxSpeed: 50,
            initialPositionRadius: 100,
            seriesInteraction: !0,
            marker: {
              fillColor: null,
              fillOpacity: 1,
              lineWidth: null,
              lineColor: null,
              symbol: "circle"
            }
          },
          enableSimulation: !0,
          type: "packedbubble",
          integration: "packedbubble",
          maxIterations: 1e3,
          splitSeries: !1,
          maxSpeed: 5,
          gravitationalConstant: 0.01,
          friction: -0.981
        }
      };
    }), V(O, "Series/Networkgraph/VerletIntegration.js", [], function () {
      return {
        attractive: function attractive(S, D, E) {
          var B = S.getMass(),
            H = -E.x * D * this.diffTemperature;
          D = -E.y * D * this.diffTemperature, S.fromNode.fixedPosition || (S.fromNode.plotX -= H * B.fromNode / S.fromNode.degree, S.fromNode.plotY -= D * B.fromNode / S.fromNode.degree), S.toNode.fixedPosition || (S.toNode.plotX += H * B.toNode / S.toNode.degree, S.toNode.plotY += D * B.toNode / S.toNode.degree);
        },
        attractiveForceFunction: function attractiveForceFunction(S, D) {
          return (D - S) / S;
        },
        barycenter: function barycenter() {
          var S = this.options.gravitationalConstant,
            D = this.barycenter.xFactor,
            E = this.barycenter.yFactor;
          D = (D - (this.box.left + this.box.width) / 2) * S, E = (E - (this.box.top + this.box.height) / 2) * S, this.nodes.forEach(function (B) {
            B.fixedPosition || (B.plotX -= D / B.mass / B.degree, B.plotY -= E / B.mass / B.degree);
          });
        },
        getK: function getK(S) {
          return Math.pow(S.box.width * S.box.height / S.nodes.length, 0.5);
        },
        integrate: function integrate(S, D) {
          var E = -S.options.friction,
            B = S.options.maxSpeed,
            H = (D.plotX + D.dispX - D.prevX) * E;
          E *= D.plotY + D.dispY - D.prevY;
          var X = Math.abs,
            W = X(H) / (H || 1);
          X = X(E) / (E || 1), H = W * Math.min(B, Math.abs(H)), E = X * Math.min(B, Math.abs(E)), D.prevX = D.plotX + D.dispX, D.prevY = D.plotY + D.dispY, D.plotX += H, D.plotY += E, D.temperature = S.vectorLength({
            x: H,
            y: E
          });
        },
        repulsive: function repulsive(S, D, E) {
          D = D * this.diffTemperature / S.mass / S.degree, S.fixedPosition || (S.plotX += E.x * D, S.plotY += E.y * D);
        },
        repulsiveForceFunction: function repulsiveForceFunction(S, D) {
          return (D - S) / S * (D > S ? 1 : 0);
        }
      };
    }), V(O, "Series/PackedBubble/PackedBubbleIntegration.js", [O["Core/Globals.js"], O["Series/Networkgraph/VerletIntegration.js"]], function (S, D) {
      return {
        barycenter: function barycenter() {
          for (var E = this.options.gravitationalConstant, B = this.box, H = this.nodes, X, W, z = 0; z < H.length; z++) {
            var w = H[z];
            this.options.splitSeries && !w.isParentNode ? (X = w.series.parentNode.plotX, W = w.series.parentNode.plotY) : (X = B.width / 2, W = B.height / 2), w.fixedPosition || (w.plotX -= (w.plotX - X) * E / (w.mass * Math.sqrt(H.length)), w.plotY -= (w.plotY - W) * E / (w.mass * Math.sqrt(H.length)));
          }
        },
        getK: S.noop,
        integrate: D.integrate,
        repulsive: function repulsive(E, B, H, X) {
          var W = B * this.diffTemperature / E.mass / E.degree;
          B = H.x * W, H = H.y * W, E.fixedPosition || (E.plotX += B, E.plotY += H), X.fixedPosition || (X.plotX -= B, X.plotY -= H);
        },
        repulsiveForceFunction: function repulsiveForceFunction(E, B, H, X) {
          return Math.min(E, (H.marker.radius + X.marker.radius) / 2);
        }
      };
    }), V(O, "Series/Networkgraph/EulerIntegration.js", [], function () {
      return {
        attractive: function attractive(S, D, E, B) {
          var H = S.getMass(),
            X = E.x / B * D;
          D *= E.y / B, S.fromNode.fixedPosition || (S.fromNode.dispX -= X * H.fromNode / S.fromNode.degree, S.fromNode.dispY -= D * H.fromNode / S.fromNode.degree), S.toNode.fixedPosition || (S.toNode.dispX += X * H.toNode / S.toNode.degree, S.toNode.dispY += D * H.toNode / S.toNode.degree);
        },
        attractiveForceFunction: function attractiveForceFunction(S, D) {
          return S * S / D;
        },
        barycenter: function barycenter() {
          var S = this.options.gravitationalConstant,
            D = this.barycenter.xFactor,
            E = this.barycenter.yFactor;
          this.nodes.forEach(function (B) {
            if (!B.fixedPosition) {
              var H = B.getDegree();
              H *= 1 + H / 2, B.dispX += (D - B.plotX) * S * H / B.degree, B.dispY += (E - B.plotY) * S * H / B.degree;
            }
          });
        },
        getK: function getK(S) {
          return Math.pow(S.box.width * S.box.height / S.nodes.length, 0.3);
        },
        integrate: function integrate(S, D) {
          D.dispX += D.dispX * S.options.friction, D.dispY += D.dispY * S.options.friction;
          var E = D.temperature = S.vectorLength({
            x: D.dispX,
            y: D.dispY
          });
          E !== 0 && (D.plotX += D.dispX / E * Math.min(Math.abs(D.dispX), S.temperature), D.plotY += D.dispY / E * Math.min(Math.abs(D.dispY), S.temperature));
        },
        repulsive: function repulsive(S, D, E, B) {
          S.dispX += E.x / B * D / S.degree, S.dispY += E.y / B * D / S.degree;
        },
        repulsiveForceFunction: function repulsiveForceFunction(S, D) {
          return D * D / S;
        }
      };
    }), V(O, "Series/Networkgraph/QuadTreeNode.js", [], function () {
      return function () {
        function S(D) {
          this.isInternal = this.isEmpty = this.body = !1, this.nodes = [], this.box = D, this.boxSize = Math.min(D.width, D.height);
        }
        return S.prototype.divideBox = function () {
          var D = this.box.width / 2,
            E = this.box.height / 2;
          this.nodes[0] = new S({
            left: this.box.left,
            top: this.box.top,
            width: D,
            height: E
          }), this.nodes[1] = new S({
            left: this.box.left + D,
            top: this.box.top,
            width: D,
            height: E
          }), this.nodes[2] = new S({
            left: this.box.left + D,
            top: this.box.top + E,
            width: D,
            height: E
          }), this.nodes[3] = new S({
            left: this.box.left,
            top: this.box.top + E,
            width: D,
            height: E
          });
        }, S.prototype.getBoxPosition = function (D) {
          var E = D.plotY < this.box.top + this.box.height / 2;
          return D.plotX < this.box.left + this.box.width / 2 ? E ? 0 : 3 : E ? 1 : 2;
        }, S.prototype.insert = function (D, E) {
          this.isInternal ? this.nodes[this.getBoxPosition(D)].insert(D, E - 1) : (this.isEmpty = !1, this.body ? E ? (this.isInternal = !0, this.divideBox(), this.body !== !0 && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, E - 1), this.body = !0), this.nodes[this.getBoxPosition(D)].insert(D, E - 1)) : (E = new S({
            top: D.plotX || NaN,
            left: D.plotY || NaN,
            width: 0.1,
            height: 0.1
          }), E.body = D, E.isInternal = !1, this.nodes.push(E)) : (this.isInternal = !1, this.body = D));
        }, S.prototype.updateMassAndCenter = function () {
          var D = 0,
            E = 0,
            B = 0;
          if (this.isInternal) {
            for (var H = 0, X = this.nodes; H < X.length; H++) {
              var W = X[H];
              W.isEmpty || (D += W.mass, E += W.plotX * W.mass, B += W.plotY * W.mass);
            }
            E /= D, B /= D;
          } else this.body && (D = this.body.mass, E = this.body.plotX, B = this.body.plotY);
          this.mass = D, this.plotX = E, this.plotY = B;
        }, S;
      }();
    }), V(O, "Series/Networkgraph/QuadTree.js", [O["Series/Networkgraph/QuadTreeNode.js"]], function (S) {
      return function () {
        function D(E, B, H, X) {
          this.box = {
            left: E,
            top: B,
            width: H,
            height: X
          }, this.maxDepth = 25, this.root = new S(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
        }
        return D.prototype.calculateMassAndCenter = function () {
          this.visitNodeRecursive(null, null, function (E) {
            E.updateMassAndCenter();
          });
        }, D.prototype.insertNodes = function (E) {
          for (var B = 0; B < E.length; B++) this.root.insert(E[B], this.maxDepth);
        }, D.prototype.visitNodeRecursive = function (E, B, H) {
          var X;
          if (E || (E = this.root), E === this.root && B && (X = B(E)), X !== !1) {
            for (var W = 0, z = E.nodes; W < z.length; W++) {
              var w = z[W];
              if (w.isInternal) {
                if (B && (X = B(w)), X === !1) continue;
                this.visitNodeRecursive(w, B, H);
              } else w.body && B && B(w.body);
              H && H(w);
            }
            E === this.root && H && H(E);
          }
        }, D;
      }();
    }), V(O, "Series/Networkgraph/ReingoldFruchtermanLayout.js", [O["Series/Networkgraph/EulerIntegration.js"], O["Core/Globals.js"], O["Series/GraphLayoutComposition.js"], O["Series/Networkgraph/QuadTree.js"], O["Core/Utilities.js"], O["Series/Networkgraph/VerletIntegration.js"]], function (S, D, E, B, H, X) {
      var W = D.win,
        z = H.clamp,
        w = H.defined,
        A = H.isFunction,
        k = H.pick;
      return function () {
        function g() {
          this.attractiveForce = void 0, this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.integration = void 0, this.links = [], this.nodes = [], this.repulsiveForce = this.quadTree = this.options = void 0, this.series = [], this.simulation = !1;
        }
        return g.compose = function (p) {
          E.compose(p), E.integrations.euler = S, E.integrations.verlet = X, E.layouts["reingold-fruchterman"] = g;
        }, g.prototype.init = function (p) {
          this.options = p, this.nodes = [], this.links = [], this.series = [], this.box = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          }, this.setInitialRendering(!0), this.integration = E.integrations[p.integration], this.enableSimulation = p.enableSimulation, this.attractiveForce = k(p.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = k(p.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = p.approximation;
        }, g.prototype.updateSimulation = function (p) {
          this.enableSimulation = k(p, this.options.enableSimulation);
        }, g.prototype.start = function () {
          var p = this.series,
            h = this.options;
          this.currentStep = 0, this.forces = p[0] && p[0].forces || [], this.chart = p[0] && p[0].chart, this.initialRendering && (this.initPositions(), p.forEach(function (s) {
            s.finishedAnimating = !0, s.render();
          })), this.setK(), this.resetSimulation(h), this.enableSimulation && this.step();
        }, g.prototype.step = function () {
          var p = this,
            h = this.series;
          this.currentStep++, this.approximation === "barnes-hut" && (this.createQuadTree(), this.quadTree.calculateMassAndCenter());
          for (var s = 0, l = this.forces || []; s < l.length; s++) this[l[s] + "Forces"](this.temperature);
          if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
            for (s = 0; s < h.length; s++) l = h[s], l.chart && l.render();
            this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && W.cancelAnimationFrame(this.simulation), this.simulation = W.requestAnimationFrame(function () {
              return p.step();
            })) : this.simulation = !1;
          }
        }, g.prototype.stop = function () {
          this.simulation && W.cancelAnimationFrame(this.simulation);
        }, g.prototype.setArea = function (p, h, s, l) {
          this.box = {
            left: p,
            top: h,
            width: s,
            height: l
          };
        }, g.prototype.setK = function () {
          this.k = this.options.linkLength || this.integration.getK(this);
        }, g.prototype.addElementsToCollection = function (p, h) {
          for (var s = 0; s < p.length; s++) {
            var l = p[s];
            h.indexOf(l) === -1 && h.push(l);
          }
        }, g.prototype.removeElementFromCollection = function (p, h) {
          p = h.indexOf(p), p !== -1 && h.splice(p, 1);
        }, g.prototype.clear = function () {
          this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
        }, g.prototype.resetSimulation = function () {
          this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
        }, g.prototype.restartSimulation = function () {
          this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
        }, g.prototype.setMaxIterations = function (p) {
          this.maxIterations = k(p, this.options.maxIterations);
        }, g.prototype.setTemperature = function () {
          this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
        }, g.prototype.setDiffTemperature = function () {
          this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
        }, g.prototype.setInitialRendering = function (p) {
          this.initialRendering = p;
        }, g.prototype.createQuadTree = function () {
          this.quadTree = new B(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
        }, g.prototype.initPositions = function () {
          var p = this.options.initialPositions;
          if (A(p)) {
            p.call(this), p = 0;
            for (var h = this.nodes; p < h.length; p++) {
              var s = h[p];
              w(s.prevX) || (s.prevX = s.plotX), w(s.prevY) || (s.prevY = s.plotY), s.dispX = 0, s.dispY = 0;
            }
          } else p === "circle" ? this.setCircularPositions() : this.setRandomPositions();
        }, g.prototype.setCircularPositions = function () {
          for (var p = this.box, h = this.nodes, s = 2 * Math.PI / (h.length + 1), l = h.filter(function (m) {
              return m.linksTo.length === 0;
            }), u = {}, v = this.options.initialPositionRadius, M = function M(m) {
              var d = 0;
              for (m = m.linksFrom || []; d < m.length; d++) {
                var o = m[d];
                u[o.toNode.id] || (u[o.toNode.id] = !0, I.push(o.toNode), M(o.toNode));
              }
            }, I = [], L = 0; L < l.length; L++) {
            var C = l[L];
            I.push(C), M(C);
          }
          if (I.length) for (l = 0; l < h.length; l++) L = h[l], I.indexOf(L) === -1 && I.push(L);else I = h;
          for (l = 0, L = I.length; l < L; ++l) h = I[l], h.plotX = h.prevX = k(h.plotX, p.width / 2 + v * Math.cos(l * s)), h.plotY = h.prevY = k(h.plotY, p.height / 2 + v * Math.sin(l * s)), h.dispX = 0, h.dispY = 0;
        }, g.prototype.setRandomPositions = function () {
          for (var p = this.box, h = this.nodes, s = h.length + 1, l = function l(I) {
              return I = I * I / Math.PI, I -= Math.floor(I);
            }, u, v = 0, M = h.length; v < M; ++v) u = h[v], u.plotX = u.prevX = k(u.plotX, p.width * l(v)), u.plotY = u.prevY = k(u.plotY, p.height * l(s + v)), u.dispX = 0, u.dispY = 0;
        }, g.prototype.force = function (p) {
          for (var h = [], s = 1; s < arguments.length; s++) h[s - 1] = arguments[s];
          this.integration[p].apply(this, h);
        }, g.prototype.barycenterForces = function () {
          this.getBarycenter(), this.force("barycenter");
        }, g.prototype.getBarycenter = function () {
          for (var p = 0, h = 0, s = 0, l = 0, u = this.nodes; l < u.length; l++) {
            var v = u[l];
            h += v.plotX * v.mass, s += v.plotY * v.mass, p += v.mass;
          }
          return this.barycenter = {
            x: h,
            y: s,
            xFactor: h / p,
            yFactor: s / p
          };
        }, g.prototype.barnesHutApproximation = function (p, h) {
          var s = this.getDistXY(p, h),
            l = this.vectorLength(s);
          if (p !== h && l !== 0) if (h.isInternal) {
            if (h.boxSize / l < this.options.theta && l !== 0) {
              var u = this.repulsiveForce(l, this.k);
              this.force("repulsive", p, u * h.mass, s, l);
              var v = !1;
            } else v = !0;
          } else u = this.repulsiveForce(l, this.k), this.force("repulsive", p, u * h.mass, s, l);
          return v;
        }, g.prototype.repulsiveForces = function () {
          var p = this;
          if (this.approximation === "barnes-hut") for (var h = function h(d) {
              s.quadTree.visitNodeRecursive(null, function (o) {
                return p.barnesHutApproximation(d, o);
              });
            }, s = this, l = 0, u = this.nodes; l < u.length; l++) {
            var v = u[l];
            h(v);
          } else {
            u = l = h = void 0;
            for (var M = 0, I = this.nodes; M < I.length; M++) {
              v = I[M];
              for (var L = 0, C = this.nodes; L < C.length; L++) {
                var m = C[L];
                v === m || v.fixedPosition || (u = this.getDistXY(v, m), l = this.vectorLength(u), l !== 0 && (h = this.repulsiveForce(l, this.k), this.force("repulsive", v, h * m.mass, u, l)));
              }
            }
          }
        }, g.prototype.attractiveForces = function () {
          for (var p, h, s, l = 0, u = this.links; l < u.length; l++) {
            var v = u[l];
            v.fromNode && v.toNode && (p = this.getDistXY(v.fromNode, v.toNode), h = this.vectorLength(p), h !== 0 && (s = this.attractiveForce(h, this.k), this.force("attractive", v, s, p, h)));
          }
        }, g.prototype.applyLimits = function () {
          for (var p = 0, h = this.nodes; p < h.length; p++) {
            var s = h[p];
            if (s.fixedPosition) break;
            this.integration.integrate(this, s), this.applyLimitBox(s, this.box), s.dispX = 0, s.dispY = 0;
          }
        }, g.prototype.applyLimitBox = function (p, h) {
          var s = p.radius;
          p.plotX = z(p.plotX, h.left + s, h.width - s), p.plotY = z(p.plotY, h.top + s, h.height - s);
        }, g.prototype.coolDown = function (p, h, s) {
          return p - h * s;
        }, g.prototype.isStable = function () {
          return 1e-5 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || 0 >= this.temperature;
        }, g.prototype.getSystemTemperature = function () {
          for (var p = 0, h = 0, s = this.nodes; h < s.length; h++) p += s[h].temperature;
          return p;
        }, g.prototype.vectorLength = function (p) {
          return Math.sqrt(p.x * p.x + p.y * p.y);
        }, g.prototype.getDistR = function (p, h) {
          return p = this.getDistXY(p, h), this.vectorLength(p);
        }, g.prototype.getDistXY = function (p, h) {
          var s = p.plotX - h.plotX;
          return p = p.plotY - h.plotY, {
            x: s,
            y: p,
            absX: Math.abs(s),
            absY: Math.abs(p)
          };
        }, g;
      }();
    }), V(O, "Series/PackedBubble/PackedBubbleLayout.js", [O["Series/GraphLayoutComposition.js"], O["Series/PackedBubble/PackedBubbleIntegration.js"], O["Series/Networkgraph/ReingoldFruchtermanLayout.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      function H() {
        var k = [];
        return this.series.forEach(function (g) {
          g.parentNode && g.parentNode.selected && k.push(g.parentNode);
        }), k;
      }
      function X() {
        this.allDataPoints && delete this.allDataPoints;
      }
      var W = this && this.__extends || function () {
          var _k2 = function k(g, p) {
            return _k2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k2(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k2(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        z = B.addEvent,
        w = B.pick,
        A = [];
      return B = function (k) {
        function g() {
          var p = k !== null && k.apply(this, arguments) || this;
          return p.index = NaN, p.nodes = [], p.options = void 0, p.series = [], p;
        }
        return W(g, k), g.compose = function (p) {
          E.compose(p), S.integrations.packedbubble = D, S.layouts.packedbubble = g, A.indexOf(p) === -1 && (A.push(p), z(p, "beforeRedraw", X), p.prototype.getSelectedParentNodes = H);
        }, g.prototype.beforeStep = function () {
          this.options.marker && this.series.forEach(function (p) {
            p && p.calculateParentRadius();
          });
        }, g.prototype.isStable = function () {
          var p = Math.abs(this.prevSystemTemperature - this.systemTemperature);
          return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && 1e-5 > p || 0 >= this.temperature;
        }, g.prototype.setCircularPositions = function () {
          for (var p = this.box, h = this.nodes, s = 2 * Math.PI / (h.length + 1), l = this.options.initialPositionRadius, u, v, M = 0, I = 0; I < h.length; I++) {
            var L = h[I];
            this.options.splitSeries && !L.isParentNode ? (u = L.series.parentNode.plotX, v = L.series.parentNode.plotY) : (u = p.width / 2, v = p.height / 2), L.plotX = L.prevX = w(L.plotX, u + l * Math.cos(L.index || M * s)), L.plotY = L.prevY = w(L.plotY, v + l * Math.sin(L.index || M * s)), L.dispX = 0, L.dispY = 0, M++;
          }
        }, g.prototype.repulsiveForces = function () {
          var p = this,
            h = p.options.bubblePadding,
            s,
            l,
            u;
          p.nodes.forEach(function (v) {
            v.degree = v.mass, v.neighbours = 0, p.nodes.forEach(function (M) {
              s = 0, v === M || v.fixedPosition || !p.options.seriesInteraction && v.series !== M.series || (u = p.getDistXY(v, M), l = p.vectorLength(u) - (v.marker.radius + M.marker.radius + h), 0 > l && (v.degree += 0.01, v.neighbours++, s = p.repulsiveForce(-l / Math.sqrt(v.neighbours), p.k, v, M)), p.force("repulsive", v, s * M.mass, u, M, l));
            });
          });
        }, g.prototype.applyLimitBox = function (p, h) {
          if (this.options.splitSeries && !p.isParentNode && this.options.parentNodeLimit) {
            var s = this.getDistXY(p, p.series.parentNode),
              l = p.series.parentNodeRadius - p.marker.radius - this.vectorLength(s);
            0 > l && l > -2 * p.marker.radius && (p.plotX -= 0.01 * s.x, p.plotY -= 0.01 * s.y);
          }
          k.prototype.applyLimitBox.call(this, p, h);
        }, g;
      }(E), S.layouts.packedbubble = B;
    }), V(O, "Series/PackedBubble/PackedBubbleSeries.js", [O["Core/Color/Color.js"], O["Series/DragNodesComposition.js"], O["Series/GraphLayoutComposition.js"], O["Core/Globals.js"], O["Series/PackedBubble/PackedBubblePoint.js"], O["Series/PackedBubble/PackedBubbleSeriesDefaults.js"], O["Series/PackedBubble/PackedBubbleLayout.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B, H, X, W, z, w) {
      var A = this && this.__extends || function () {
          var _m = function m(d, o) {
            return _m = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (n, r) {
              n.__proto__ = r;
            } || function (n, r) {
              for (var i in r) r.hasOwnProperty(i) && (n[i] = r[i]);
            }, _m(d, o);
          };
          return function (d, o) {
            function n() {
              this.constructor = d;
            }
            _m(d, o), d.prototype = o === null ? Object.create(o) : (n.prototype = o.prototype, new n());
          };
        }(),
        k = S.parse;
      S = B.noop;
      var g = z.series.prototype,
        p = z.seriesTypes.bubble,
        h = w.addEvent,
        s = w.clamp,
        l = w.defined,
        u = w.extend,
        v = w.fireEvent,
        M = w.isArray,
        I = w.isNumber,
        L = w.merge,
        C = w.pick;
      return w = function (m) {
        function d() {
          var o = m !== null && m.apply(this, arguments) || this;
          return o.chart = void 0, o.data = void 0, o.layout = void 0, o.options = void 0, o.parentNodeMass = 0, o.points = void 0, o.xData = void 0, o;
        }
        return A(d, m), d.compose = function (o, n, r, i) {
          p.compose(o, n, r, i), D.compose(n), W.compose(n);
        }, d.prototype.accumulateAllPoints = function () {
          for (var o = this.chart, n = [], r, i = 0, t = o.series; i < t.length; i++) {
            var e = t[i];
            if (e.is("packedbubble") && e.visible || !o.options.chart.ignoreHiddenSeries) {
              r = e.yData || [];
              for (var a = 0; a < r.length; a++) n.push([null, null, r[a], e.index, a, {
                id: a,
                marker: {
                  radius: 0
                }
              }]);
            }
          }
          return n;
        }, d.prototype.addLayout = function () {
          var o = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {},
            n = o.type || "packedbubble",
            r = this.chart.options.chart,
            i = this.chart.graphLayoutsStorage,
            t = this.chart.graphLayoutsLookup;
          i || (this.chart.graphLayoutsStorage = i = {}, this.chart.graphLayoutsLookup = t = []);
          var e = i[n];
          e || (o.enableSimulation = l(r.forExport) ? !r.forExport : o.enableSimulation, i[n] = e = new E.layouts[n](), e.init(o), t.splice(e.index, 0, e)), this.layout = e, this.points.forEach(function (a) {
            a.mass = 2, a.degree = 1, a.collisionNmb = 1;
          }), e.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), e.addElementsToCollection([this], e.series), e.addElementsToCollection(this.points, e.nodes);
        }, d.prototype.addSeriesLayout = function () {
          var o = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {},
            n = o.type || "packedbubble",
            r = this.chart.graphLayoutsStorage,
            i = this.chart.graphLayoutsLookup;
          o = L(o, o.parentNodeOptions, {
            enableSimulation: this.layout.options.enableSimulation
          });
          var t = r[n + "-series"];
          t || (r[n + "-series"] = t = new E.layouts[n](), t.init(o), i.splice(t.index, 0, t)), this.parentNodeLayout = t, this.createParentNodes();
        }, d.prototype.calculateParentRadius = function () {
          var o = this.seriesBox();
          this.parentNodeRadius = s(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, o ? Math.max(Math.sqrt(Math.pow(o.width, 2) + Math.pow(o.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
        }, d.prototype.calculateZExtremes = function () {
          var o = this.options.zMin,
            n = this.options.zMax,
            r = 1 / 0,
            i = -1 / 0;
          return o && n ? [o, n] : (this.chart.series.forEach(function (t) {
            t.yData.forEach(function (e) {
              l(e) && (e > i && (i = e), e < r && (r = e));
            });
          }), o = C(o, r), n = C(n, i), [o, n]);
        }, d.prototype.checkOverlap = function (o, n) {
          var r = o[0] - n[0],
            i = o[1] - n[1];
          return -1e-3 > Math.sqrt(r * r + i * i) - Math.abs(o[2] + n[2]);
        }, d.prototype.createParentNodes = function () {
          var o = this,
            n = this.pointClass,
            r = this.chart,
            i = this.parentNodeLayout,
            t = this.layout.options,
            e,
            a = this.parentNode,
            c = {
              radius: this.parentNodeRadius,
              lineColor: this.color,
              fillColor: k(this.color).brighten(0.4).get()
            };
          t.parentNodeOptions && (c = L(t.parentNodeOptions.marker || {}, c)), this.parentNodeMass = 0, this.points.forEach(function (y) {
            o.parentNodeMass += Math.PI * Math.pow(y.marker.radius, 2);
          }), this.calculateParentRadius(), i.nodes.forEach(function (y) {
            y.seriesIndex === o.index && (e = !0);
          }), i.setArea(0, 0, r.plotWidth, r.plotHeight), e || (a || (a = new n().init(this, {
            mass: this.parentNodeRadius / 2,
            marker: c,
            dataLabels: {
              inside: !1
            },
            states: {
              normal: {
                marker: c
              },
              hover: {
                marker: c
              }
            },
            dataLabelOnNull: !0,
            degree: this.parentNodeRadius,
            isParentNode: !0,
            seriesIndex: this.index
          })), this.parentNode && (a.plotX = this.parentNode.plotX, a.plotY = this.parentNode.plotY), this.parentNode = a, i.addElementsToCollection([this], i.series), i.addElementsToCollection([a], i.nodes));
        }, d.prototype.deferLayout = function () {
          var o = this.options.layoutAlgorithm;
          this.visible && (this.addLayout(), o.splitSeries && this.addSeriesLayout());
        }, d.prototype.destroy = function () {
          var o = this;
          this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach(function (n) {
            n.removeElementFromCollection(o, n.series);
          }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), g.destroy.apply(this, arguments);
        }, d.prototype.drawDataLabels = function () {
          g.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", g.drawDataLabels.call(this, [this.parentNode]));
        }, d.prototype.drawGraph = function () {
          if (this.layout && this.layout.options.splitSeries) {
            var o = this.chart,
              n = this.layout.options.parentNodeOptions.marker;
            n = {
              fill: n.fillColor || k(this.color).brighten(0.4).get(),
              opacity: n.fillOpacity,
              stroke: n.lineColor || this.color,
              "stroke-width": C(n.lineWidth, this.options.lineWidth)
            }, this.parentNodesGroup || (this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", 0.1, o.seriesGroup), this.group.attr({
              zIndex: 2
            })), this.calculateParentRadius();
            var r = L({
              x: this.parentNode.plotX - this.parentNodeRadius,
              y: this.parentNode.plotY - this.parentNodeRadius,
              width: 2 * this.parentNodeRadius,
              height: 2 * this.parentNodeRadius
            }, n);
            this.parentNode.graphic || (this.graph = this.parentNode.graphic = o.renderer.symbol(n.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(r);
          }
        }, d.prototype.drawTracker = function () {
          var o = this.parentNode;
          if (m.prototype.drawTracker.call(this), o) {
            var n = M(o.dataLabels) ? o.dataLabels : o.dataLabel ? [o.dataLabel] : [];
            o.graphic && (o.graphic.element.point = o), n.forEach(function (r) {
              r.div ? r.div.point = o : r.element.point = o;
            });
          }
        }, d.prototype.getPointRadius = function () {
          var o = this,
            n = this.chart,
            r = this.options,
            i = r.useSimulation,
            t = Math.min(n.plotWidth, n.plotHeight),
            e = {},
            a = [],
            c = n.allDataPoints || [],
            y = c.length,
            b,
            j,
            P,
            f;
          ["minSize", "maxSize"].forEach(function (N) {
            var R = parseInt(r[N], 10),
              F = /%$/.test(r[N]);
            e[N] = F ? t * R / 100 : R * Math.sqrt(y);
          }), n.minRadius = b = e.minSize / Math.sqrt(y), n.maxRadius = j = e.maxSize / Math.sqrt(y);
          var x = i ? this.calculateZExtremes() : [b, j];
          c.forEach(function (N, R) {
            P = i ? s(N[2], x[0], x[1]) : N[2], f = o.getRadius(x[0], x[1], b, j, P), f === 0 && (f = null), c[R][2] = f, a.push(f);
          }), this.radii = a;
        }, d.prototype.init = function () {
          return g.init.apply(this, arguments), this.eventsToUnbind.push(h(this, "updatedData", function () {
            var o = this;
            this.chart.series.forEach(function (n) {
              n.type === o.type && (n.isDirty = !0);
            }, this);
          })), this;
        }, d.prototype.onMouseUp = function (o) {
          var n = o;
          if (n.fixedPosition && !n.removed) {
            var r = this.layout,
              i = this.parentNodeLayout,
              t,
              e;
            i && r.options.dragBetweenSeries && i.nodes.forEach(function (a) {
              n && n.marker && a !== n.series.parentNode && (t = r.getDistXY(n, a), e = r.vectorLength(t) - a.marker.radius - n.marker.radius, 0 > e && (a.series.addPoint(L(n.options, {
                plotX: n.plotX,
                plotY: n.plotY
              }), !1), r.removeElementFromCollection(n, r.nodes), n.remove()));
            }), D.onMouseUp.apply(this, arguments);
          }
        }, d.prototype.placeBubbles = function (o) {
          var n = this.checkOverlap,
            r = this.positionBubble,
            i = [],
            t = 1,
            e = 0,
            a = 0,
            c = [],
            y;
          if (o = o.sort(function (b, j) {
            return j[2] - b[2];
          }), o.length) {
            if (i.push([[0, 0, o[0][2], o[0][3], o[0][4]]]), 1 < o.length) for (i.push([[0, 0 - o[1][2] - o[0][2], o[1][2], o[1][3], o[1][4]]]), y = 2; y < o.length; y++) o[y][2] = o[y][2] || 1, c = r(i[t][e], i[t - 1][a], o[y]), n(c, i[t][0]) ? (i.push([]), a = 0, i[t + 1].push(r(i[t][e], i[t][0], o[y])), t++, e = 0) : 1 < t && i[t - 1][a + 1] && n(c, i[t - 1][a + 1]) ? (a++, i[t].push(r(i[t][e], i[t - 1][a], o[y])), e++) : (e++, i[t].push(c));
            this.chart.stages = i, this.chart.rawPositions = [].concat.apply([], i), this.resizeRadius(), c = this.chart.rawPositions;
          }
          return c;
        }, d.prototype.pointAttribs = function (o, n) {
          var r = this.options,
            i = r.marker;
          return o && o.isParentNode && r.layoutAlgorithm && r.layoutAlgorithm.parentNodeOptions && (i = r.layoutAlgorithm.parentNodeOptions.marker), r = i.fillOpacity, o = g.pointAttribs.call(this, o, n), r !== 1 && (o["fill-opacity"] = r), o;
        }, d.prototype.positionBubble = function (o, n, r) {
          var i = Math.sqrt,
            t = Math.asin,
            e = Math.acos,
            a = Math.pow,
            c = Math.abs;
          return i = i(a(o[0] - n[0], 2) + a(o[1] - n[1], 2)), e = e((a(i, 2) + a(r[2] + n[2], 2) - a(r[2] + o[2], 2)) / (2 * (r[2] + n[2]) * i)), t = t(c(o[0] - n[0]) / i), o = (0 > o[1] - n[1] ? 0 : Math.PI) + e + t * (0 > (o[0] - n[0]) * (o[1] - n[1]) ? 1 : -1), [n[0] + (n[2] + r[2]) * Math.sin(o), n[1] - (n[2] + r[2]) * Math.cos(o), r[2], r[3], r[4]];
        }, d.prototype.render = function () {
          var o = [];
          g.render.apply(this, arguments), this.options.dataLabels.allowOverlap || (this.data.forEach(function (n) {
            M(n.dataLabels) && n.dataLabels.forEach(function (r) {
              o.push(r);
            });
          }), this.options.useSimulation && this.chart.hideOverlappingLabels(o));
        }, d.prototype.resizeRadius = function () {
          for (var o = this.chart, n = o.rawPositions, r = Math.min, i = Math.max, t = o.plotLeft, e = o.plotTop, a = o.plotHeight, c = o.plotWidth, y, b, j = y = Number.POSITIVE_INFINITY, P = b = Number.NEGATIVE_INFINITY, f = 0; f < n.length; f++) {
            var x = n[f],
              N = x[2];
            j = r(j, x[0] - N), P = i(P, x[0] + N), y = r(y, x[1] - N), b = i(b, x[1] + N);
          }
          if (x = [P - j, b - y], r = r.apply([], [(c - t) / x[0], (a - e) / x[1]]), 1e-10 < Math.abs(r - 1)) {
            for (o = 0; o < n.length; o++) x = n[o], x[2] *= r;
            this.placeBubbles(n);
          } else o.diffY = a / 2 + e - y - (b - y) / 2, o.diffX = c / 2 + t - j - (P - j) / 2;
        }, d.prototype.seriesBox = function () {
          var o = this.chart,
            n = Math.max,
            r = Math.min,
            i = [o.plotLeft, o.plotLeft + o.plotWidth, o.plotTop, o.plotTop + o.plotHeight],
            t;
          return this.data.forEach(function (e) {
            l(e.plotX) && l(e.plotY) && e.marker.radius && (t = e.marker.radius, i[0] = r(i[0], e.plotX - t), i[1] = n(i[1], e.plotX + t), i[2] = r(i[2], e.plotY - t), i[3] = n(i[3], e.plotY + t));
          }), I(i.width / i.height) ? i : null;
        }, d.prototype.setVisible = function () {
          var o = this;
          g.setVisible.apply(o, arguments), o.parentNodeLayout && o.graph ? o.visible ? (o.graph.show(), o.parentNode.dataLabel && o.parentNode.dataLabel.show()) : (o.graph.hide(), o.parentNodeLayout.removeElementFromCollection(o.parentNode, o.parentNodeLayout.nodes), o.parentNode.dataLabel && o.parentNode.dataLabel.hide()) : o.layout && (o.visible ? o.layout.addElementsToCollection(o.points, o.layout.nodes) : o.points.forEach(function (n) {
            o.layout.removeElementFromCollection(n, o.layout.nodes);
          }));
        }, d.prototype.translate = function () {
          var o = this.chart,
            n = this.data,
            r = this.index,
            i = this.options.useSimulation;
          if (this.processedXData = this.xData, this.generatePoints(), l(o.allDataPoints) || (o.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), i) var t = o.allDataPoints;else t = this.placeBubbles(o.allDataPoints), this.options.draggable = !1;
          for (var e = 0, a = t; e < a.length; e++) {
            var c = a[e];
            if (c[3] === r) {
              t = n[c[4]];
              var y = C(c[2], void 0);
              i || (t.plotX = c[0] - o.plotLeft + o.diffX, t.plotY = c[1] - o.plotTop + o.diffY), I(y) && (t.marker = u(t.marker, {
                radius: y,
                width: 2 * y,
                height: 2 * y
              }), t.radius = y);
            }
          }
          i && this.deferLayout(), v(this, "afterTranslate");
        }, d.defaultOptions = L(p.defaultOptions, X), d;
      }(p), u(w.prototype, {
        pointClass: H,
        axisTypes: [],
        directTouch: !0,
        forces: ["barycenter", "repulsive"],
        hasDraggableNodes: !0,
        isCartesian: !1,
        noSharedTooltip: !0,
        pointArrayMap: ["value"],
        pointValKey: "value",
        requireSorting: !1,
        trackerGroups: ["group", "dataLabelsGroup", "parentNodesGroup"],
        alignDataLabel: g.alignDataLabel,
        indexateNodes: S,
        onMouseDown: D.onMouseDown,
        onMouseMove: D.onMouseMove,
        redrawHalo: D.redrawHalo,
        searchPoint: S
      }), z.registerSeriesType("packedbubble", w), w;
    }), V(O, "Series/Polygon/PolygonSeries.js", [O["Core/Globals.js"], O["Core/Legend/LegendSymbol.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      var H = this && this.__extends || function () {
        var _g = function g(p, h) {
          return _g = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (s, l) {
            s.__proto__ = l;
          } || function (s, l) {
            for (var u in l) l.hasOwnProperty(u) && (s[u] = l[u]);
          }, _g(p, h);
        };
        return function (p, h) {
          function s() {
            this.constructor = p;
          }
          _g(p, h), p.prototype = h === null ? Object.create(h) : (s.prototype = h.prototype, new s());
        };
      }();
      S = S.noop;
      var X = E.series,
        W = E.seriesTypes,
        z = W.area,
        w = W.line,
        A = W.scatter;
      W = B.extend;
      var k = B.merge;
      return B = function (g) {
        function p() {
          var h = g !== null && g.apply(this, arguments) || this;
          return h.data = void 0, h.options = void 0, h.points = void 0, h;
        }
        return H(p, g), p.prototype.getGraphPath = function () {
          for (var h = w.prototype.getGraphPath.call(this), s = h.length + 1; s--;) (s === h.length || h[s][0] === "M") && 0 < s && h.splice(s, 0, ["Z"]);
          return this.areaPath = h;
        }, p.prototype.drawGraph = function () {
          this.options.fillColor = this.color, z.prototype.drawGraph.call(this);
        }, p.defaultOptions = k(A.defaultOptions, {
          marker: {
            enabled: !1,
            states: {
              hover: {
                enabled: !1
              }
            }
          },
          stickyTracking: !1,
          tooltip: {
            followPointer: !0,
            pointFormat: ""
          },
          trackByArea: !0
        }), p;
      }(A), W(B.prototype, {
        type: "polygon",
        drawLegendSymbol: D.drawRectangle,
        drawTracker: X.prototype.drawTracker,
        setStackedPoints: S
      }), E.registerSeriesType("polygon", B), B;
    }), V(O, "Core/Axis/WaterfallAxis.js", [O["Core/Axis/Stacking/StackItem.js"], O["Core/Utilities.js"]], function (S, D) {
      var E = D.addEvent,
        B = D.objectEach,
        H;
      return function (X) {
        function W() {
          var g = this.waterfall.stacks;
          g && (g.changed = !1, delete g.alreadyChanged);
        }
        function z() {
          var g = this.options.stackLabels;
          g && g.enabled && this.waterfall.stacks && this.waterfall.renderStackTotals();
        }
        function w() {
          for (var g = this.axes, p = this.series, h = p.length; h--;) p[h].options.stacking && (g.forEach(function (s) {
            s.isXAxis || (s.waterfall.stacks.changed = !0);
          }), h = 0);
        }
        function A() {
          this.waterfall || (this.waterfall = new k(this));
        }
        var k = function () {
          function g(p) {
            this.axis = p, this.stacks = {
              changed: !1
            };
          }
          return g.prototype.renderStackTotals = function () {
            var p = this.axis,
              h = p.waterfall.stacks,
              s = p.stacking && p.stacking.stackTotalGroup,
              l = new S(p, p.options.stackLabels || {}, !1, 0, void 0);
            this.dummyStackItem = l, s && B(h, function (u) {
              B(u, function (v, M) {
                l.total = v.stackTotal, l.x = +M, v.label && (l.label = v.label), S.prototype.render.call(l, s), v.label = l.label, delete l.label;
              });
            }), l.total = null;
          }, g;
        }();
        X.Composition = k, X.compose = function (g, p) {
          E(g, "init", A), E(g, "afterBuildStacks", W), E(g, "afterRender", z), E(p, "beforeRedraw", w);
        };
      }(H || (H = {})), H;
    }), V(O, "Series/Waterfall/WaterfallPoint.js", [O["Series/Column/ColumnSeries.js"], O["Core/Series/Point.js"], O["Core/Utilities.js"]], function (S, D, E) {
      var B = this && this.__extends || function () {
          var _X = function X(W, z) {
            return _X = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (w, A) {
              w.__proto__ = A;
            } || function (w, A) {
              for (var k in A) A.hasOwnProperty(k) && (w[k] = A[k]);
            }, _X(W, z);
          };
          return function (W, z) {
            function w() {
              this.constructor = W;
            }
            _X(W, z), W.prototype = z === null ? Object.create(z) : (w.prototype = z.prototype, new w());
          };
        }(),
        H = E.isNumber;
      return function (X) {
        function W() {
          var z = X !== null && X.apply(this, arguments) || this;
          return z.options = void 0, z.series = void 0, z;
        }
        return B(W, X), W.prototype.getClassName = function () {
          var z = D.prototype.getClassName.call(this);
          return this.isSum ? z += " highcharts-sum" : this.isIntermediateSum && (z += " highcharts-intermediate-sum"), z;
        }, W.prototype.isValid = function () {
          return H(this.y) || this.isSum || !!this.isIntermediateSum;
        }, W;
      }(S.prototype.pointClass);
    }), V(O, "Series/Waterfall/WaterfallSeries.js", [O["Core/Axis/Axis.js"], O["Core/Chart/Chart.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"], O["Core/Axis/WaterfallAxis.js"], O["Series/Waterfall/WaterfallPoint.js"]], function (S, D, E, B, H, X) {
      var W = this && this.__extends || function () {
          var _v = function v(M, I) {
            return _v = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (L, C) {
              L.__proto__ = C;
            } || function (L, C) {
              for (var m in C) C.hasOwnProperty(m) && (L[m] = C[m]);
            }, _v(M, I);
          };
          return function (M, I) {
            function L() {
              this.constructor = M;
            }
            _v(M, I), M.prototype = I === null ? Object.create(I) : (L.prototype = I.prototype, new L());
          };
        }(),
        z = E.seriesTypes,
        w = z.column,
        A = z.line,
        k = B.arrayMax,
        g = B.arrayMin,
        p = B.correctFloat;
      z = B.extend;
      var h = B.isNumber,
        s = B.merge,
        l = B.objectEach,
        u = B.pick;
      return B = function (v) {
        function M() {
          var I = v !== null && v.apply(this, arguments) || this;
          return I.chart = void 0, I.data = void 0, I.options = void 0, I.points = void 0, I.stackedYNeg = void 0, I.stackedYPos = void 0, I.stackKey = void 0, I.xData = void 0, I.yAxis = void 0, I.yData = void 0, I;
        }
        return W(M, v), M.prototype.generatePoints = function () {
          w.prototype.generatePoints.apply(this);
          for (var I = 0, L = this.points.length; I < L; I++) {
            var C = this.points[I],
              m = this.processedYData[I];
            h(m) && (C.isIntermediateSum || C.isSum) && (C.y = p(m));
          }
        }, M.prototype.translate = function () {
          var I = this.options,
            L = this.yAxis,
            C = u(I.minPointLength, 5),
            m = C / 2,
            d = I.threshold || 0;
          I = I.stacking;
          var o = L.waterfall.stacks[this.stackKey],
            n = d,
            r = d;
          w.prototype.translate.apply(this);
          for (var i = this.points, t = 0; t < i.length; t++) {
            var e = i[t],
              a = this.processedYData[t],
              c = e.shapeArgs;
            if (c && h(a)) {
              var y = [0, a],
                b = e.y;
              if (I) {
                if (o) {
                  if (y = o[t], I === "overlap") {
                    var j = y.stackState[y.stateIndex--];
                    j = 0 <= b ? j : j - b, Object.hasOwnProperty.call(y, "absolutePos") && delete y.absolutePos, Object.hasOwnProperty.call(y, "absoluteNeg") && delete y.absoluteNeg;
                  } else 0 <= b ? (j = y.threshold + y.posTotal, y.posTotal -= b) : (j = y.threshold + y.negTotal, y.negTotal -= b, j -= b), !y.posTotal && h(y.absolutePos) && Object.hasOwnProperty.call(y, "absolutePos") && (y.posTotal = y.absolutePos, delete y.absolutePos), !y.negTotal && h(y.absoluteNeg) && Object.hasOwnProperty.call(y, "absoluteNeg") && (y.negTotal = y.absoluteNeg, delete y.absoluteNeg);
                  e.isSum || (y.connectorThreshold = y.threshold + y.stackTotal), L.reversed ? (a = 0 <= b ? j - b : j + b, b = j) : (a = j, b = j - b), e.below = a <= d, c.y = L.translate(a, !1, !0, !1, !0), c.height = Math.abs(c.y - L.translate(b, !1, !0, !1, !0)), (b = L.waterfall.dummyStackItem) && (b.x = t, b.label = o[t].label, b.setOffset(this.pointXOffset || 0, this.barW || 0, this.stackedYNeg[t], this.stackedYPos[t], void 0, this.xAxis));
                }
              } else j = Math.max(r, r + b) + y[0], c.y = L.translate(j, !1, !0, !1, !0), e.isSum ? (c.y = L.translate(y[1], !1, !0, !1, !0), c.height = Math.min(L.translate(y[0], !1, !0, !1, !0), L.len) - c.y, e.below = y[1] <= d) : e.isIntermediateSum ? (0 <= b ? (a = y[1] + n, b = n) : (a = n, b = y[1] + n), L.reversed && (a ^= b, b ^= a, a ^= b), c.y = L.translate(a, !1, !0, !1, !0), c.height = Math.abs(c.y - Math.min(L.translate(b, !1, !0, !1, !0), L.len)), n += y[1], e.below = a <= d) : (c.height = 0 < a ? L.translate(r, !1, !0, !1, !0) - c.y : L.translate(r, !1, !0, !1, !0) - L.translate(r - a, !1, !0, !1, !0), r += a, e.below = r < d), 0 > c.height && (c.y += c.height, c.height *= -1);
              e.plotY = c.y = Math.round(c.y || 0) - this.borderWidth % 2 / 2, c.height = Math.max(Math.round(c.height || 0), 1e-3), e.yBottom = c.y + c.height, c.height <= C && !e.isNull ? (c.height = C, c.y -= m, e.plotY = c.y, e.minPointLengthOffset = 0 > e.y ? -m : m) : (e.isNull && (c.width = 0), e.minPointLengthOffset = 0), b = e.plotY + (e.negative ? c.height : 0), e.below && (e.plotY += c.height), e.tooltipPos && (this.chart.inverted ? e.tooltipPos[0] = L.len - b : e.tooltipPos[1] = b), e.isInside = this.isPointInside(e);
            }
          }
        }, M.prototype.processData = function (I) {
          var L = this.options,
            C = this.yData,
            m = L.data,
            d = C.length,
            o = L.threshold || 0,
            n,
            r,
            i,
            t,
            e;
          for (e = r = n = i = t = 0; e < d; e++) {
            var a = C[e],
              c = m && m[e] ? m[e] : {};
            a === "sum" || c.isSum ? C[e] = p(r) : a === "intermediateSum" || c.isIntermediateSum ? (C[e] = p(n), n = 0) : (r += a, n += a), i = Math.min(r, i), t = Math.max(r, t);
          }
          v.prototype.processData.call(this, I), L.stacking || (this.dataMin = i + o, this.dataMax = t);
        }, M.prototype.toYData = function (I) {
          return I.isSum ? "sum" : I.isIntermediateSum ? "intermediateSum" : I.y;
        }, M.prototype.updateParallelArrays = function (I, L) {
          v.prototype.updateParallelArrays.call(this, I, L), (this.yData[0] === "sum" || this.yData[0] === "intermediateSum") && (this.yData[0] = null);
        }, M.prototype.pointAttribs = function (I, L) {
          var C = this.options.upColor;
          return C && !I.options.color && (I.color = 0 < I.y ? C : void 0), I = w.prototype.pointAttribs.call(this, I, L), delete I.dashstyle, I;
        }, M.prototype.getGraphPath = function () {
          return [["M", 0, 0]];
        }, M.prototype.getCrispPath = function () {
          var I = this.data,
            L = this.yAxis,
            C = I.length,
            m = Math.round(this.graph.strokeWidth()) % 2 / 2,
            d = Math.round(this.borderWidth) % 2 / 2,
            o = this.xAxis.reversed,
            n = this.yAxis.reversed,
            r = this.options.stacking,
            i = [],
            t;
          for (t = 1; t < C; t++) {
            var e = I[t].shapeArgs,
              a = I[t - 1],
              c = I[t - 1].shapeArgs,
              y = L.waterfall.stacks[this.stackKey],
              b = 0 < a.y ? -c.height : 0;
            y && c && e && (y = y[t - 1], r ? (y = y.connectorThreshold, b = Math.round(L.translate(y, !1, !0, !1, !0) + (n ? b : 0)) - m) : b = c.y + a.minPointLengthOffset + d - m, i.push(["M", (c.x || 0) + (o ? 0 : c.width || 0), b], ["L", (e.x || 0) + (o && e.width || 0), b])), c && i.length && (!r && 0 > a.y && !n || 0 < a.y && n) && ((a = i[i.length - 2]) && typeof a[2] == "number" && (a[2] += c.height || 0), (a = i[i.length - 1]) && typeof a[2] == "number" && (a[2] += c.height || 0));
          }
          return i;
        }, M.prototype.drawGraph = function () {
          A.prototype.drawGraph.call(this), this.graph && this.graph.attr({
            d: this.getCrispPath()
          });
        }, M.prototype.setStackedPoints = function () {
          function I(F, T, G, _) {
            if (P) {
              if (R) for (G; G < R; G++) P.stackState[G] += _;else P.stackState[0] = F, R = P.stackState.length;
              P.stackState.push(P.stackState[R - 1] + T);
            }
          }
          var L = this.options,
            C = this.yAxis.waterfall.stacks,
            m = L.threshold || 0,
            d = m,
            o = d,
            n = this.stackKey,
            r = this.xData,
            i = r.length,
            t,
            e,
            a;
          this.yAxis.stacking.usePercentage = !1;
          var c = t = e = d;
          if (this.visible || !this.chart.options.chart.ignoreHiddenSeries) {
            var y = C.changed;
            if ((a = C.alreadyChanged) && 0 > a.indexOf(n) && (y = !0), C[n] || (C[n] = {}), a = C[n]) for (var b = 0; b < i; b++) {
              var j = r[b];
              (!a[j] || y) && (a[j] = {
                negTotal: 0,
                posTotal: 0,
                stackTotal: 0,
                threshold: 0,
                stateIndex: 0,
                stackState: [],
                label: y && a[j] ? a[j].label : void 0
              });
              var P = a[j],
                f = this.yData[b];
              0 <= f ? P.posTotal += f : P.negTotal += f;
              var x = L.data[b];
              j = P.absolutePos = P.posTotal;
              var N = P.absoluteNeg = P.negTotal;
              P.stackTotal = j + N;
              var R = P.stackState.length;
              x && x.isIntermediateSum ? (I(e, t, 0, e), e = t, t = m, d ^= o, o ^= d, d ^= o) : x && x.isSum ? (I(m, c, R, 0), d = m) : (I(d, f, 0, c), x && (c += f, t += f)), P.stateIndex++, P.threshold = d, d += P.stackTotal;
            }
            C.changed = !1, C.alreadyChanged || (C.alreadyChanged = []), C.alreadyChanged.push(n);
          }
        }, M.prototype.getExtremes = function () {
          var I = this.options.stacking;
          if (I) {
            var L = this.yAxis;
            L = L.waterfall.stacks;
            var C = this.stackedYNeg = [],
              m = this.stackedYPos = [];
            return I === "overlap" ? l(L[this.stackKey], function (d) {
              C.push(g(d.stackState)), m.push(k(d.stackState));
            }) : l(L[this.stackKey], function (d) {
              C.push(d.negTotal + d.threshold), m.push(d.posTotal + d.threshold);
            }), {
              dataMin: g(C),
              dataMax: k(m)
            };
          }
          return {
            dataMin: this.dataMin,
            dataMax: this.dataMax
          };
        }, M.defaultOptions = s(w.defaultOptions, {
          dataLabels: {
            inside: !0
          },
          lineWidth: 1,
          lineColor: "#333333",
          dashStyle: "Dot",
          borderColor: "#333333",
          states: {
            hover: {
              lineWidthPlus: 0
            }
          }
        }), M;
      }(w), z(B.prototype, {
        getZonesGraphs: A.prototype.getZonesGraphs,
        pointValKey: "y",
        showLine: !0,
        pointClass: X
      }), E.registerSeriesType("waterfall", B), H.compose(S, D), B;
    }), V(O, "Core/Axis/RadialAxis.js", [O["Core/Axis/AxisDefaults.js"], O["Core/Defaults.js"], O["Core/Globals.js"], O["Core/Utilities.js"]], function (S, D, E, B) {
      var H = D.defaultOptions,
        X = E.noop,
        W = B.addEvent,
        z = B.correctFloat,
        w = B.defined,
        A = B.extend,
        k = B.fireEvent,
        g = B.merge,
        p = B.pick,
        h = B.relativeLength,
        s = B.wrap,
        l;
      return function (u) {
        function v() {
          this.autoConnect = this.isCircular && typeof p(this.userMax, this.options.max) > "u" && z(this.endAngleRad - this.startAngleRad) === z(2 * Math.PI), !this.isCircular && this.chart.inverted && this.max++, this.autoConnect && (this.max += this.categories && 1 || this.pointRange || this.closestPointRange || 0);
        }
        function M() {
          var Y = this;
          return function () {
            if (Y.isRadial && Y.tickPositions && Y.options.labels && Y.options.labels.allowOverlap !== !0) return Y.tickPositions.map(function (U) {
              return Y.ticks[U] && Y.ticks[U].label;
            }).filter(function (U) {
              return !!U;
            });
          };
        }
        function I() {
          return X;
        }
        function L(Y, U, Z) {
          var J = this.pane.center,
            et = Y.value;
          if (this.isCircular) {
            if (w(et)) Y.point && (nt = Y.point.shapeArgs || {}, nt.start && (et = this.chart.inverted ? this.translate(Y.point.rectPlotY, !0) : Y.point.x));else {
              var nt = Y.chartX || 0,
                lt = Y.chartY || 0;
              et = this.translate(Math.atan2(lt - Z, nt - U) - this.startAngleRad, !0);
            }
            Y = this.getPosition(et), nt = Y.x, lt = Y.y;
          } else w(et) || (nt = Y.chartX, lt = Y.chartY), w(nt) && w(lt) && (Z = J[1] + this.chart.plotTop, et = this.translate(Math.min(Math.sqrt(Math.pow(nt - U, 2) + Math.pow(lt - Z, 2)), J[2] / 2) - J[3] / 2, !0));
          return [et, nt || 0, lt || 0];
        }
        function C(Y, U, Z) {
          Y = this.pane.center;
          var J = this.chart,
            et = this.left || 0,
            nt = this.top || 0,
            lt = p(U, Y[2] / 2 - this.offset);
          return typeof Z > "u" && (Z = this.horiz ? 0 : this.center && -this.center[3] / 2), Z && (lt += Z), this.isCircular || typeof U < "u" ? (U = this.chart.renderer.symbols.arc(et + Y[0], nt + Y[1], lt, lt, {
            start: this.startAngleRad,
            end: this.endAngleRad,
            open: !0,
            innerR: 0
          }), U.xBounds = [et + Y[0]], U.yBounds = [nt + Y[1] - lt]) : (U = this.postTranslate(this.angleRad, lt), U = [["M", this.center[0] + J.plotLeft, this.center[1] + J.plotTop], ["L", U.x, U.y]]), U;
        }
        function m() {
          this.constructor.prototype.getOffset.call(this), this.chart.axisOffset[this.side] = 0;
        }
        function d(Y, U, Z) {
          var J = this.chart,
            et = function et(ht) {
              if (typeof ht == "string") {
                var pt = parseInt(ht, 10);
                return $.test(ht) && (pt = pt * ct / 100), pt;
              }
              return ht;
            },
            nt = this.center,
            lt = this.startAngleRad,
            ct = nt[2] / 2,
            tt = Math.min(this.offset, 0),
            st = this.left || 0,
            it = this.top || 0,
            $ = /%$/,
            Q = this.isCircular,
            ot = p(et(Z.outerRadius), ct),
            at = et(Z.innerRadius);
          if (et = p(et(Z.thickness), 10), this.options.gridLineInterpolation === "polygon") tt = this.getPlotLinePath({
            value: Y
          }).concat(this.getPlotLinePath({
            value: U,
            reverse: !0
          }));else {
            if (Y = Math.max(Y, this.min), U = Math.min(U, this.max), Y = this.translate(Y), U = this.translate(U), Q || (ot = Y || 0, at = U || 0), Z.shape !== "circle" && Q) Z = lt + (Y || 0), lt += U || 0;else {
              Z = -Math.PI / 2, lt = 1.5 * Math.PI;
              var rt = !0;
            }
            ot -= tt, tt = J.renderer.symbols.arc(st + nt[0], it + nt[1], ot, ot, {
              start: Math.min(Z, lt),
              end: Math.max(Z, lt),
              innerR: p(at, ot - (et - tt)),
              open: rt
            }), Q && (Q = (lt + Z) / 2, st = st + nt[0] + nt[2] / 2 * Math.cos(Q), tt.xBounds = Q > -Math.PI / 2 && Q < Math.PI / 2 ? [st, J.plotWidth] : [0, st], tt.yBounds = [it + nt[1] + nt[2] / 2 * Math.sin(Q)], tt.yBounds[0] += Q > -Math.PI && 0 > Q || Q > Math.PI ? -10 : 10);
          }
          return tt;
        }
        function o(Y) {
          var U = this,
            Z = this.pane.center,
            J = this.chart,
            et = J.inverted,
            nt = Y.reverse,
            lt = this.pane.options.background ? this.pane.options.background[0] || this.pane.options.background : {},
            ct = lt.innerRadius || "0%",
            tt = lt.outerRadius || "100%",
            st = Z[0] + J.plotLeft,
            it = Z[1] + J.plotTop,
            $ = this.height,
            Q = Y.isCrosshair;
          lt = Z[3] / 2;
          var ot = Y.value,
            at,
            rt = this.getPosition(ot),
            ht = rt.x;
          if (rt = rt.y, Q && (rt = this.getCrosshairPosition(Y, st, it), ot = rt[0], ht = rt[1], rt = rt[2]), this.isCircular) ot = Math.sqrt(Math.pow(ht - st, 2) + Math.pow(rt - it, 2)), nt = typeof ct == "string" ? h(ct, 1) : ct / ot, J = typeof tt == "string" ? h(tt, 1) : tt / ot, Z && lt && (lt /= ot, nt < lt && (nt = lt), J < lt && (J = lt)), Z = [["M", st + nt * (ht - st), it - nt * (it - rt)], ["L", ht - (1 - J) * (ht - st), rt + (1 - J) * (it - rt)]];else if ((ot = this.translate(ot)) && (0 > ot || ot > $) && (ot = 0), this.options.gridLineInterpolation === "circle") Z = this.getLinePath(0, ot, lt);else if (Z = [], J[et ? "yAxis" : "xAxis"].forEach(function (pt) {
            pt.pane === U.pane && (at = pt);
          }), at) for (st = at.tickPositions, at.autoConnect && (st = st.concat([st[0]])), nt && (st = st.slice().reverse()), ot && (ot += lt), it = 0; it < st.length; it++) lt = at.getPosition(st[it], ot), Z.push(it ? ["L", lt.x, lt.y] : ["M", lt.x, lt.y]);
          return Z;
        }
        function n(Y, U) {
          return Y = this.translate(Y), this.postTranslate(this.isCircular ? Y : this.angleRad, p(this.isCircular ? U : 0 > Y ? 0 : Y, this.center[2] / 2) - this.offset);
        }
        function r() {
          var Y = this.center,
            U = this.chart,
            Z = this.options.title;
          return {
            x: U.plotLeft + Y[0] + (Z.x || 0),
            y: U.plotTop + Y[1] - {
              high: 0.5,
              middle: 0.25,
              low: 0
            }[Z.align] * Y[2] + (Z.y || 0)
          };
        }
        function i(Y) {
          Y.beforeSetTickPositions = v, Y.createLabelCollector = M, Y.getCrosshairPosition = L, Y.getLinePath = C, Y.getOffset = m, Y.getPlotBandPath = d, Y.getPlotLinePath = o, Y.getPosition = n, Y.getTitlePosition = r, Y.postTranslate = P, Y.setAxisSize = x, Y.setAxisTranslation = N, Y.setOptions = R;
        }
        function t() {
          var Y = this.chart,
            U = this.options,
            Z = this.pane,
            J = Z && Z.options;
          Y.angular && this.isXAxis || !Z || !Y.angular && !Y.polar || (Y = 2 * Math.PI, Z = (p(J.startAngle, 0) - 90) * Math.PI / 180, J = (p(J.endAngle, p(J.startAngle, 0) + 360) - 90) * Math.PI / 180, this.angleRad = (U.angle || 0) * Math.PI / 180, this.startAngleRad = Z, this.endAngleRad = J, this.offset = U.offset || 0, U = (Z % Y + Y) % Y, J = (J % Y + Y) % Y, U > Math.PI && (U -= Y), J > Math.PI && (J -= Y), this.normalizedStartAngleRad = U, this.normalizedEndAngleRad = J);
        }
        function e(Y) {
          this.isRadial && (Y.align = void 0, Y.preventDefault());
        }
        function a() {
          if (this.chart && this.chart.labelCollectors) {
            var Y = this.labelCollector ? this.chart.labelCollectors.indexOf(this.labelCollector) : -1;
            0 <= Y && this.chart.labelCollectors.splice(Y, 1);
          }
        }
        function c(Y) {
          var U = this.chart,
            Z = U.inverted,
            J = U.angular,
            et = U.polar,
            nt = this.isXAxis,
            lt = this.coll,
            ct = J && nt;
          Y = Y.userOptions.pane || 0, Y = this.pane = U.pane && U.pane[Y];
          var tt;
          lt === "colorAxis" ? this.isRadial = !1 : (J ? (ct ? (this.isHidden = !0, this.createLabelCollector = I, this.getOffset = X, this.render = this.redraw = f, this.setTitle = this.setCategories = this.setScale = X) : i(this), (tt = !nt) && (this.defaultPolarOptions = _)) : et && (i(this), this.defaultPolarOptions = (tt = this.horiz) ? G : g(lt === "xAxis" ? S.defaultXAxisOptions : S.defaultYAxisOptions, q), Z && lt === "yAxis" && (this.defaultPolarOptions.stackLabels = S.defaultYAxisOptions.stackLabels, this.defaultPolarOptions.reversedStacks = !0)), J || et ? (this.isRadial = !0, this.labelCollector || (this.labelCollector = this.createLabelCollector()), this.labelCollector && U.labelCollectors.push(this.labelCollector)) : this.isRadial = !1, Y && tt && (Y.axis = this), this.isCircular = tt);
        }
        function y() {
          this.isRadial && this.beforeSetTickPositions();
        }
        function b(Y) {
          var U = this.label;
          if (U) {
            var Z = this.axis,
              J = U.getBBox(),
              et = Z.options.labels,
              nt = (Z.translate(this.pos) + Z.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360,
              lt = Math.round(nt),
              ct = w(et.y) ? 0 : 0.3 * -J.height,
              tt = et.y,
              st = 20,
              it = et.align,
              $ = "end",
              Q = 0 > lt ? lt + 360 : lt,
              ot = Q,
              at = 0,
              rt = 0;
            if (Z.isRadial) {
              var ht = Z.getPosition(this.pos, Z.center[2] / 2 + h(p(et.distance, -25), Z.center[2] / 2, -Z.center[2] / 2));
              et.rotation === "auto" ? U.attr({
                rotation: nt
              }) : w(tt) || (tt = Z.chart.renderer.fontMetrics(U.styles && U.styles.fontSize).b - J.height / 2), w(it) || (Z.isCircular ? (J.width > Z.len * Z.tickInterval / (Z.max - Z.min) && (st = 0), it = nt > st && nt < 180 - st ? "left" : nt > 180 + st && nt < 360 - st ? "right" : "center") : it = "center", U.attr({
                align: it
              })), it === "auto" && Z.tickPositions.length === 2 && Z.isCircular && (90 < Q && 180 > Q ? Q = 180 - Q : 270 < Q && 360 >= Q && (Q = 540 - Q), 180 < ot && 360 >= ot && (ot = 360 - ot), (Z.pane.options.startAngle === lt || Z.pane.options.startAngle === lt + 360 || Z.pane.options.startAngle === lt - 360) && ($ = "start"), it = -90 <= lt && 90 >= lt || -360 <= lt && -270 >= lt || 270 <= lt && 360 >= lt ? $ === "start" ? "right" : "left" : $ === "start" ? "left" : "right", 70 < ot && 110 > ot && (it = "center"), 15 > Q || 180 <= Q && 195 > Q ? at = 0.3 * J.height : 15 <= Q && 35 >= Q ? at = $ === "start" ? 0 : 0.75 * J.height : 195 <= Q && 215 >= Q ? at = $ === "start" ? 0.75 * J.height : 0 : 35 < Q && 90 >= Q ? at = $ === "start" ? 0.25 * -J.height : J.height : 215 < Q && 270 >= Q && (at = $ === "start" ? J.height : 0.25 * -J.height), 15 > ot ? rt = $ === "start" ? 0.15 * -J.height : 0.15 * J.height : 165 < ot && 180 >= ot && (rt = $ === "start" ? 0.15 * J.height : 0.15 * -J.height), U.attr({
                align: it
              }), U.translate(rt, at + ct)), Y.pos.x = ht.x + (et.x || 0), Y.pos.y = ht.y + (tt || 0);
            }
          }
        }
        function j(Y) {
          this.axis.getPosition && A(Y.pos, this.axis.getPosition(this.pos));
        }
        function P(Y, U) {
          var Z = this.chart,
            J = this.center;
          return Y = this.startAngleRad + Y, {
            x: Z.plotLeft + J[0] + Math.cos(Y) * U,
            y: Z.plotTop + J[1] + Math.sin(Y) * U
          };
        }
        function f() {
          this.isDirty = !1;
        }
        function x() {
          if (this.constructor.prototype.setAxisSize.call(this), this.isRadial) {
            this.pane.updateCenter(this);
            var Y = this.center = this.pane.center.slice();
            if (this.isCircular) this.sector = this.endAngleRad - this.startAngleRad;else {
              var U = this.postTranslate(this.angleRad, Y[3] / 2);
              Y[0] = U.x - this.chart.plotLeft, Y[1] = U.y - this.chart.plotTop;
            }
            this.len = this.width = this.height = (Y[2] - Y[3]) * p(this.sector, 1) / 2;
          }
        }
        function N() {
          this.constructor.prototype.setAxisTranslation.call(this), this.center && (this.transA = this.isCircular ? (this.endAngleRad - this.startAngleRad) / (this.max - this.min || 1) : (this.center[2] - this.center[3]) / 2 / (this.max - this.min || 1), this.minPixelPadding = this.isXAxis ? this.transA * this.minPointOffset : 0);
        }
        function R(Y) {
          Y = this.options = g(this.constructor.defaultOptions, this.defaultPolarOptions, H[this.coll], Y), Y.plotBands || (Y.plotBands = []), k(this, "afterSetOptions");
        }
        function F(Y, U, Z, J, et, nt, lt) {
          var ct = this.axis;
          return ct.isRadial ? (Y = ct.getPosition(this.pos, ct.center[2] / 2 + J), U = ["M", U, Z, "L", Y.x, Y.y]) : U = Y.call(this, U, Z, J, et, nt, lt), U;
        }
        var T = [],
          G = {
            gridLineWidth: 1,
            labels: {
              align: void 0,
              distance: 15,
              x: 0,
              y: void 0,
              style: {
                textOverflow: "none"
              }
            },
            maxPadding: 0,
            minPadding: 0,
            showLastLabel: !1,
            tickLength: 0
          },
          _ = {
            labels: {
              align: "center",
              x: 0,
              y: void 0
            },
            minorGridLineWidth: 0,
            minorTickInterval: "auto",
            minorTickLength: 10,
            minorTickPosition: "inside",
            minorTickWidth: 1,
            tickLength: 10,
            tickPosition: "inside",
            tickWidth: 2,
            title: {
              rotation: 0
            },
            zIndex: 2
          },
          q = {
            gridLineInterpolation: "circle",
            gridLineWidth: 1,
            labels: {
              align: "right",
              x: -3,
              y: -2
            },
            showLastLabel: !1,
            title: {
              x: 4,
              text: null,
              rotation: 90
            }
          };
        u.compose = function (Y, U) {
          return T.indexOf(Y) === -1 && (T.push(Y), W(Y, "afterInit", t), W(Y, "autoLabelAlign", e), W(Y, "destroy", a), W(Y, "init", c), W(Y, "initialAxisTranslation", y)), T.indexOf(U) === -1 && (T.push(U), W(U, "afterGetLabelPosition", b), W(U, "afterGetPosition", j), s(U.prototype, "getMarkPath", F)), Y;
        };
      }(l || (l = {})), l;
    }), V(O, "Series/PolarComposition.js", [O["Core/Animation/AnimationUtilities.js"], O["Core/Globals.js"], O["Extensions/Pane.js"], O["Core/Axis/RadialAxis.js"], O["Core/Utilities.js"]], function (S, D, E, B, H) {
      function X(P, f, x, N) {
        var R = N ? 1 : 0,
          F = 0 <= f && f <= P.length - 1 ? f : 0 > f ? P.length - 1 + f : 0;
        f = 0 > F - 1 ? P.length - (1 + R) : F - 1;
        var T = P[f];
        R = P[F + 1 > P.length - 1 ? R : F + 1];
        var G = T.plotY,
          _ = R.plotX,
          q = R.plotY;
        R = P[F].plotX, F = P[F].plotY, T = (1.5 * R + T.plotX) / 2.5, G = (1.5 * F + G) / 2.5, _ = (1.5 * R + _) / 2.5;
        var Y = (1.5 * F + q) / 2.5;
        q = Math.sqrt(Math.pow(T - R, 2) + Math.pow(G - F, 2));
        var U = Math.sqrt(Math.pow(_ - R, 2) + Math.pow(Y - F, 2));
        return T = Math.atan2(G - F, T - R), Y = Math.PI / 2 + (T + Math.atan2(Y - F, _ - R)) / 2, Math.abs(T - Y) > Math.PI / 2 && (Y -= Math.PI), T = R + Math.cos(Y) * q, G = F + Math.sin(Y) * q, _ = R + Math.cos(Math.PI + Y) * U, Y = F + Math.sin(Math.PI + Y) * U, R = {
          rightContX: _,
          rightContY: Y,
          leftContX: T,
          leftContY: G,
          plotX: R,
          plotY: F
        }, x && (R.prevPointCont = X(P, f, !1, N)), R;
      }
      function W() {
        (this.pane || []).forEach(function (P) {
          P.render();
        });
      }
      function z(P) {
        var f = P.args[0].xAxis,
          x = P.args[0].yAxis;
        P = P.args[0].chart, f && x && (x.gridLineInterpolation === "polygon" ? (f.startOnTick = !0, f.endOnTick = !0) : f.gridLineInterpolation === "polygon" && P.inverted && (x.startOnTick = !0, x.endOnTick = !0));
      }
      function w() {
        var P = this;
        this.pane || (this.pane = []), this.options.pane = a(this.options.pane), this.options.pane.forEach(function (f) {
          new E(f, P);
        }, this);
      }
      function A(P) {
        var f = P.args.marker,
          x = this.chart.xAxis[0],
          N = this.chart.yAxis[0],
          R = this.chart.inverted,
          F = R ? N : x;
        if (x = R ? x : N, this.chart.polar) {
          P.preventDefault(), N = (f.attr ? f.attr("start") : f.start) - F.startAngleRad, R = f.attr ? f.attr("r") : f.r;
          var T = (f.attr ? f.attr("end") : f.end) - F.startAngleRad;
          f = f.attr ? f.attr("innerR") : f.innerR, P.result.x = N + F.pos, P.result.width = T - N, P.result.y = x.len + x.pos - f, P.result.height = f - R;
        }
      }
      function k(P) {
        var f = this.chart;
        if (f.polar && f.hoverPane && f.hoverPane.axis) {
          P.preventDefault();
          var x = f.hoverPane.center,
            N = this.mouseDownX || 0,
            R = this.mouseDownY || 0,
            F = P.args.chartY,
            T = P.args.chartX,
            G = 2 * Math.PI,
            _ = f.hoverPane.axis.startAngleRad,
            q = f.hoverPane.axis.endAngleRad,
            Y = f.inverted ? f.xAxis[0] : f.yAxis[0],
            U = {},
            Z = "arc";
          if (U.x = x[0] + f.plotLeft, U.y = x[1] + f.plotTop, this.zoomHor) {
            var J = 0 < _ ? q - _ : Math.abs(_) + Math.abs(q),
              et = Math.atan2(R - f.plotTop - x[1], N - f.plotLeft - x[0]) - _,
              nt = Math.atan2(F - f.plotTop - x[1], T - f.plotLeft - x[0]) - _;
            U.r = x[2] / 2, U.innerR = x[3] / 2, 0 >= et && (et += G), 0 >= nt && (nt += G), nt < et && (nt = [et, et = nt][0]), J < G && _ + nt > q + (G - J) / 2 && (nt = et, et = 0 >= _ ? _ : 0), G = U.start = Math.max(et + _, _), et = U.end = Math.min(nt + _, q), Y.options.gridLineInterpolation === "polygon" && (nt = f.hoverPane.axis, J = G - nt.startAngleRad + nt.pos, et -= G, Z = Y.getPlotLinePath({
              value: Y.max
            }), G = nt.toValue(J), J = nt.toValue(J + et), G < nt.getExtremes().min && (et = nt.getExtremes(), G = et.max - (et.min - G)), J < nt.getExtremes().min && (et = nt.getExtremes(), J = et.max - (et.min - J)), J < G && (J = [G, G = J][0]), Z = s(Z, G, J, nt), Z.push(["L", x[0] + f.plotLeft, f.plotTop + x[1]]), U.d = Z, Z = "path");
          }
          this.zoomVert && (nt = f.inverted ? f.xAxis[0] : f.yAxis[0], N = Math.sqrt(Math.pow(N - f.plotLeft - x[0], 2) + Math.pow(R - f.plotTop - x[1], 2)), F = Math.sqrt(Math.pow(T - f.plotLeft - x[0], 2) + Math.pow(F - f.plotTop - x[1], 2)), F < N && (N = [F, F = N][0]), F > x[2] / 2 && (F = x[2] / 2), N < x[3] / 2 && (N = x[3] / 2), this.zoomHor || (U.start = _, U.end = q), U.r = F, U.innerR = N, nt.options.gridLineInterpolation === "polygon" && (et = nt.toValue(nt.len + nt.pos - N), G = nt.toValue(nt.len + nt.pos - F), Z = nt.getPlotLinePath({
            value: G
          }).concat(nt.getPlotLinePath({
            value: et,
            reverse: !0
          })), U.d = Z, Z = "path")), this.zoomHor && this.zoomVert && Y.options.gridLineInterpolation === "polygon" && (nt = f.hoverPane.axis, G = U.start || 0, et = U.end || 0, J = G - nt.startAngleRad + nt.pos, et -= G, G = nt.toValue(J), J = nt.toValue(J + et), U.d instanceof Array && (x = U.d.slice(0, U.d.length / 2), _ = U.d.slice(U.d.length / 2, U.d.length), _ = d([], _, !0).reverse(), f = f.hoverPane.axis, x = s(x, G, J, f), (_ = s(_, G, J, f)) && (_[0][0] = "L"), _ = d([], _, !0).reverse(), U.d = x.concat(_), Z = "path")), P.attrs = U, P.shapeType = Z;
        }
      }
      function g() {
        var P = this.chart;
        P.polar && (this.polar = new j(this), P.inverted && (this.isRadialSeries = !0, this.is("column") && (this.isRadialBar = !0)));
      }
      function p() {
        if (this.chart.polar && this.xAxis) {
          var P = this.chart;
          (this.kdByAngle = P.tooltip && P.tooltip.shared) ? this.searchPoint = h : this.options.findNearestPointBy = "xy";
          for (var f = this.points, x = f.length; x--;) this.preventPostTranslate || this.polar.toXY(f[x]), P.hasParallelCoordinates || this.yAxis.reversed || (e(f[x].y, Number.MIN_VALUE) < this.yAxis.min || f[x].x < this.xAxis.min || f[x].x > this.xAxis.max ? (f[x].isNull = !0, f[x].plotY = NaN) : f[x].isNull = f[x].isValid && !f[x].isValid());
          this.hasClipCircleSetter || (this.hasClipCircleSetter = !!this.eventsToUnbind.push(n(this, "afterRender", function () {
            if (P.polar) {
              var N = this.yAxis.pane.center;
              if (this.clipCircle) this.clipCircle.animate({
                x: N[0],
                y: N[1],
                r: N[2] / 2,
                innerR: N[3] / 2
              });else {
                var R = P.renderer,
                  F = N[0],
                  T = N[1],
                  G = N[2] / 2,
                  _ = N[3] / 2;
                N = c();
                var q = R.createElement("clipPath").attr({
                  id: N
                }).add(R.defs);
                R = _ ? R.arc(F, T, G, _, 0, 2 * Math.PI).add(q) : R.circle(F, T, G).add(q), R.id = N, R.clipPath = q, this.clipCircle = R;
              }
              this.group.clip(this.clipCircle), this.setClip = D.noop;
            }
          })));
        }
      }
      function h(P) {
        var f = this.chart,
          x = this.xAxis;
        return x = x.pane && x.pane.center, this.searchKDTree({
          clientX: 180 + -180 / Math.PI * Math.atan2(P.chartX - (x && x[0] || 0) - f.plotLeft, P.chartY - (x && x[1] || 0) - f.plotTop)
        });
      }
      function s(P, f, x, N) {
        var R = N.tickInterval;
        N = N.tickPositions;
        var F = i(N, function (G) {
            return G >= x;
          }),
          T = i(d([], N, !0).reverse(), function (G) {
            return G <= f;
          });
        return r(F) || (F = N[N.length - 1]), r(T) || (T = N[0], F += R, P[0][0] = "L", P.unshift(P[P.length - 3])), P = P.slice(N.indexOf(T), N.indexOf(F) + 1), P[0][0] = "M", P;
      }
      function l(P, f) {
        return i(this.pane || [], function (x) {
          return x.options.id === f;
        }) || P.call(this, f);
      }
      function u(P, f, x, N, R, F) {
        var T = this.chart,
          G = e(N.inside, !!this.options.stacking);
        T.polar ? (P = f.rectPlotX / Math.PI * 180, T.inverted ? (this.forceDL = T.isInsidePlot(f.plotX, f.plotY), G && f.shapeArgs ? (R = f.shapeArgs, R = this.yAxis.postTranslate(((R.start || 0) + (R.end || 0)) / 2 - this.xAxis.startAngleRad, f.barX + f.pointWidth / 2), R = {
          x: R.x - T.plotLeft,
          y: R.y - T.plotTop
        }) : f.tooltipPos && (R = {
          x: f.tooltipPos[0],
          y: f.tooltipPos[1]
        }), N.align = e(N.align, "center"), N.verticalAlign = e(N.verticalAlign, "middle")) : (N.align === null && (N.align = 20 < P && 160 > P ? "left" : 200 < P && 340 > P ? "right" : "center"), N.verticalAlign === null && (N.verticalAlign = 45 > P || 315 < P ? "bottom" : 135 < P && 225 > P ? "top" : "middle")), Object.getPrototypeOf(Object.getPrototypeOf(this)).alignDataLabel.call(this, f, x, N, R, F), this.isRadialBar && f.shapeArgs && f.shapeArgs.start === f.shapeArgs.end ? x.hide() : x.show()) : P.call(this, f, x, N, R, F);
      }
      function v(P) {
        var f = this.options,
          x = f.stacking,
          N = this.chart,
          R = this.xAxis,
          F = this.yAxis,
          T = F.reversed,
          G = F.center,
          _ = R.startAngleRad,
          q = R.endAngleRad - _,
          Y = 0,
          U = 0,
          Z = 0;
        if (this.preventPostTranslate = !0, P.call(this), R.isRadial) {
          P = this.points, R = P.length;
          var J = F.translate(F.min),
            et = F.translate(F.max);
          for (f = f.threshold || 0, N.inverted && t(f) && (Y = F.translate(f), r(Y) && (0 > Y ? Y = 0 : Y > q && (Y = q), this.translatedThreshold = Y + _)); R--;) {
            f = P[R];
            var nt = f.barX,
              lt = f.x,
              ct = f.y;
            f.shapeType = "arc", N.inverted ? (f.plotY = F.translate(ct), x && F.stacking ? (ct = F.stacking.stacks[(0 > ct ? "-" : "") + this.stackKey], this.visible && ct && ct[lt] && !f.isNull && (Z = ct[lt].points[this.getStackIndicator(void 0, lt, this.index).key], U = F.translate(Z[0]), Z = F.translate(Z[1]), r(U) && (U = H.clamp(U, 0, q)))) : (U = Y, Z = f.plotY), U > Z && (Z = [U, U = Z][0]), T ? Z > J ? Z = J : U < et ? U = et : (U > J || Z < et) && (U = Z = q) : U < J ? U = J : Z > et ? Z = et : (Z < J || U > et) && (U = Z = 0), F.min > F.max && (U = Z = T ? q : 0), U += _, Z += _, G && (f.barX = nt += G[3] / 2), lt = Math.max(nt, 0), ct = Math.max(nt + f.pointWidth, 0), f.shapeArgs = {
              x: G && G[0],
              y: G && G[1],
              r: ct,
              innerR: lt,
              start: U,
              end: Z
            }, f.opacity = U === Z ? 0 : void 0, f.plotY = (r(this.translatedThreshold) && (U < this.translatedThreshold ? U : Z)) - _) : (U = nt + _, f.shapeArgs = this.polar.arc(f.yBottom, f.plotY, U, U + f.pointWidth)), this.polar.toXY(f), N.inverted ? (nt = F.postTranslate(f.rectPlotY, nt + f.pointWidth / 2), f.tooltipPos = [nt.x - N.plotLeft, nt.y - N.plotTop]) : f.tooltipPos = [f.plotX, f.plotY], G && (f.ttBelow = f.plotY > G[1]);
          }
        }
      }
      function M(P, f) {
        var x = this;
        if (this.chart.polar) {
          f = f || this.points;
          for (var N = 0; N < f.length; N++) if (!f[N].isNull) {
            var R = N;
            break;
          }
          if (this.options.connectEnds !== !1 && typeof R < "u") {
            this.connectEnds = !0, f.splice(f.length, 0, f[R]);
            var F = !0;
          }
          f.forEach(function (T) {
            typeof T.polarPlotY > "u" && x.polar.toXY(T);
          });
        }
        return R = P.apply(this, [].slice.call(arguments, 1)), F && f.pop(), R;
      }
      function I(P, f) {
        var x = this.chart,
          N = {
            xAxis: [],
            yAxis: []
          };
        return x.polar ? x.axes.forEach(function (R) {
          if (R.coll !== "colorAxis") {
            var F = R.isXAxis,
              T = R.center,
              G = f.chartX - T[0] - x.plotLeft;
            T = f.chartY - T[1] - x.plotTop, N[F ? "xAxis" : "yAxis"].push({
              axis: R,
              value: R.translate(F ? Math.PI - Math.atan2(G, T) : Math.sqrt(Math.pow(G, 2) + Math.pow(T, 2)), !0)
            });
          }
        }) : N = P.call(this, f), N;
      }
      function L(P, f) {
        this.chart.polar || P.call(this, f);
      }
      function C(P, f) {
        var x = this,
          N = this.chart,
          R = this.group,
          F = this.markerGroup,
          T = this.xAxis && this.xAxis.center,
          G = N.plotLeft,
          _ = N.plotTop,
          q = this.options.animation,
          Y,
          U,
          Z,
          J;
        if (N.polar) {
          if (x.isRadialBar) f || (x.startAngleRad = e(x.translatedThreshold, x.xAxis.startAngleRad), D.seriesTypes.pie.prototype.animate.call(x, f));else if (N.renderer.isSVG) if (q = o(q), x.is("column")) {
            if (!f) {
              var et = T[3] / 2;
              x.points.forEach(function (nt) {
                Y = nt.graphic, Z = (U = nt.shapeArgs) && U.r, J = U && U.innerR, Y && U && (Y.attr({
                  r: et,
                  innerR: et
                }), Y.animate({
                  r: Z,
                  innerR: J
                }, x.options.animation));
              });
            }
          } else f ? (P = {
            translateX: T[0] + G,
            translateY: T[1] + _,
            scaleX: 1e-3,
            scaleY: 1e-3
          }, R.attr(P), F && F.attr(P)) : (P = {
            translateX: G,
            translateY: _,
            scaleX: 1,
            scaleY: 1
          }, R.animate(P, q), F && F.animate(P, q));
        } else P.call(this, f);
      }
      function m(P, f, x, N) {
        return this.chart.polar ? N ? (P = X(f, N, !0, this.connectEnds), f = P.prevPointCont && P.prevPointCont.rightContX, x = P.prevPointCont && P.prevPointCont.rightContY, P = ["C", t(f) ? f : P.plotX, t(x) ? x : P.plotY, t(P.leftContX) ? P.leftContX : P.plotX, t(P.leftContY) ? P.leftContY : P.plotY, P.plotX, P.plotY]) : P = ["M", x.plotX, x.plotY] : P = P.call(this, f, x, N), P;
      }
      var d = this && this.__spreadArray || function (P, f, x) {
          if (x || arguments.length === 2) for (var N = 0, R = f.length, F; N < R; N++) !F && N in f || (F || (F = Array.prototype.slice.call(f, 0, N)), F[N] = f[N]);
          return P.concat(F || Array.prototype.slice.call(f));
        },
        o = S.animObject,
        n = H.addEvent,
        r = H.defined,
        i = H.find,
        t = H.isNumber,
        e = H.pick,
        a = H.splat,
        c = H.uniqueKey,
        y = H.wrap,
        b = [],
        j = function () {
          function P(f) {
            this.series = f;
          }
          return P.compose = function (f, x, N, R, F, T, G, _, q) {
            B.compose(f, F), b.indexOf(x) === -1 && (b.push(x), n(x, "afterDrawChartBox", W), n(x, "getAxes", w), n(x, "init", z), y(x.prototype, "get", l)), b.indexOf(N) === -1 && (b.push(N), f = N.prototype, y(f, "getCoordinates", I), y(f, "pinch", L), n(N, "getSelectionMarkerAttrs", k), n(N, "getSelectionBox", A)), b.indexOf(R) === -1 && (b.push(R), n(R, "afterInit", g), n(R, "afterTranslate", p, {
              order: 2
            }), y(R.prototype, "animate", C)), G && b.indexOf(G) === -1 && (b.push(G), N = G.prototype, y(N, "alignDataLabel", u), y(N, "animate", C), y(N, "translate", v)), _ && b.indexOf(_) === -1 && (b.push(_), y(_.prototype, "getGraphPath", M)), q && b.indexOf(q) === -1 && (b.push(q), _ = q.prototype, y(_, "getPointSpline", m), T && b.indexOf(T) === -1 && (b.push(T), T.prototype.getPointSpline = _.getPointSpline));
          }, P.prototype.arc = function (f, x, N, R) {
            var F = this.series,
              T = F.xAxis.center,
              G = F.yAxis.len,
              _ = T[3] / 2;
            return x = G - x + _, f = G - e(f, G) + _, F.yAxis.reversed && (0 > x && (x = _), 0 > f && (f = _)), {
              x: T[0],
              y: T[1],
              r: x,
              innerR: f,
              start: N,
              end: R
            };
          }, P.prototype.toXY = function (f) {
            var x = this.series,
              N = x.chart,
              R = x.xAxis,
              F = x.yAxis,
              T = f.plotX,
              G = N.inverted,
              _ = f.y,
              q = f.plotY,
              Y = G ? T : F.len - q;
            G && x && !x.isRadialBar && (f.plotY = q = t(_) ? F.translate(_) : 0), f.rectPlotX = T, f.rectPlotY = q, F.center && (Y += F.center[3] / 2), t(q) && (F = G ? F.postTranslate(q, Y) : R.postTranslate(T, Y), f.plotX = f.polarPlotX = F.x - N.plotLeft, f.plotY = f.polarPlotY = F.y - N.plotTop), x.kdByAngle ? (x = (T / Math.PI * 180 + R.pane.options.startAngle) % 360, 0 > x && (x += 360), f.clientX = x) : f.clientX = f.plotX;
          }, P;
        }();
      return j;
    }), V(O, "masters/highcharts-more.src.js", [O["Core/Globals.js"], O["Core/Series/SeriesRegistry.js"], O["Series/Bubble/BubbleSeries.js"], O["Series/PackedBubble/PackedBubbleSeries.js"], O["Series/PolarComposition.js"]], function (S, D, E, B, H) {
      E.compose(S.Axis, S.Chart, S.Legend, S.Series), B.compose(S.Axis, S.Chart, S.Legend, S.Series), H.compose(S.Axis, S.Chart, S.Pointer, S.Series, S.Tick, D.seriesTypes.areasplinerange, D.seriesTypes.column, D.seriesTypes.line, D.seriesTypes.spline);
    });
  });
})(di);
var eo = di.exports;
var io = /* @__PURE__ */Xt(eo);
var ui = {
  exports: {}
};
(function (K) {
  (function (O, V) {
    K.exports ? (V.default = V, K.exports = O.document ? V(O) : V) : (O.Highcharts && O.Highcharts.error(16, !0), O.Highcharts = V(O));
  })(typeof window < "u" ? window : to, function (O) {
    function V(D, E, B, H) {
      D.hasOwnProperty(E) || (D[E] = H.apply(null, B), typeof CustomEvent == "function" && O.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
        detail: {
          path: E,
          module: D[E]
        }
      })));
    }
    var S = {};
    return V(S, "Core/Globals.js", [], function () {
      var D;
      return function (E) {
        E.SVG_NS = "http://www.w3.org/2000/svg", E.product = "Highcharts", E.version = "10.3.3", E.win = typeof O < "u" ? O : {}, E.doc = E.win.document, E.svg = E.doc && E.doc.createElementNS && !!E.doc.createElementNS(E.SVG_NS, "svg").createSVGRect, E.userAgent = E.win.navigator && E.win.navigator.userAgent || "", E.isChrome = E.userAgent.indexOf("Chrome") !== -1, E.isFirefox = E.userAgent.indexOf("Firefox") !== -1, E.isMS = /(edge|msie|trident)/i.test(E.userAgent) && !E.win.opera, E.isSafari = !E.isChrome && E.userAgent.indexOf("Safari") !== -1, E.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(E.userAgent), E.isWebKit = E.userAgent.indexOf("AppleWebKit") !== -1, E.deg2rad = 2 * Math.PI / 360, E.hasBidiBug = E.isFirefox && 4 > parseInt(E.userAgent.split("Firefox/")[1], 10), E.hasTouch = !!E.win.TouchEvent, E.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], E.noop = function () {}, E.supportsPassiveEvents = function () {
          var B = !1;
          if (!E.isMS) {
            var H = Object.defineProperty({}, "passive", {
              get: function get() {
                B = !0;
              }
            });
            E.win.addEventListener && E.win.removeEventListener && (E.win.addEventListener("testPassive", E.noop, H), E.win.removeEventListener("testPassive", E.noop, H));
          }
          return B;
        }(), E.charts = [], E.dateFormats = {}, E.seriesTypes = {}, E.symbolSizes = {}, E.chartCount = 0;
      }(D || (D = {})), D;
    }), V(S, "Core/Utilities.js", [S["Core/Globals.js"]], function (D) {
      function E(t, e, a, c) {
        var y = e ? "Highcharts error" : "Highcharts warning";
        t === 32 && (t = "" + y + ": Deprecated member");
        var b = k(t),
          j = b ? "" + y + " #" + t + ": www.highcharts.com/errors/" + t + "/" : t.toString();
        if (typeof c < "u") {
          var P = "";
          b && (j += "?"), I(c, function (f, x) {
            P += "\n - ".concat(x, ": ").concat(f), b && (j += encodeURI(x) + "=" + encodeURI(f));
          }), j += P;
        }
        C(D, "displayError", {
          chart: a,
          code: t,
          message: j,
          params: c
        }, function () {
          if (e) throw Error(j);
          o.console && E.messages.indexOf(j) === -1 && console.warn(j);
        }), E.messages.push(j);
      }
      function B(t, e) {
        var a = {};
        return I(t, function (c, y) {
          z(t[y], !0) && !t.nodeType && e[y] ? (c = B(t[y], e[y]), Object.keys(c).length && (a[y] = c)) : (z(t[y]) || t[y] !== e[y] || y in t && !(y in e)) && (a[y] = t[y]);
        }), a;
      }
      function H(t, e) {
        return parseInt(t, e || 10);
      }
      function X(t) {
        return typeof t == "string";
      }
      function W(t) {
        return t = Object.prototype.toString.call(t), t === "[object Array]" || t === "[object Array Iterator]";
      }
      function z(t, e) {
        return !!t && typeof t == "object" && (!e || !W(t));
      }
      function w(t) {
        return z(t) && typeof t.nodeType == "number";
      }
      function A(t) {
        var e = t && t.constructor;
        return !(!z(t, !0) || w(t) || !e || !e.name || e.name === "Object");
      }
      function k(t) {
        return typeof t == "number" && !isNaN(t) && 1 / 0 > t && -1 / 0 < t;
      }
      function g(t) {
        return typeof t < "u" && t !== null;
      }
      function p(t, e, a) {
        var c = X(e) && !g(a),
          y,
          b = function b(j, P) {
            g(j) ? t.setAttribute(P, j) : c ? (y = t.getAttribute(P)) || P !== "class" || (y = t.getAttribute(P + "Name")) : t.removeAttribute(P);
          };
        return X(e) ? b(a, e) : I(e, b), y;
      }
      function h(t, e) {
        var a;
        t || (t = {});
        for (a in e) t[a] = e[a];
        return t;
      }
      function s() {
        for (var t = arguments, e = t.length, a = 0; a < e; a++) {
          var c = t[a];
          if (typeof c < "u" && c !== null) return c;
        }
      }
      function l(t, e) {
        D.isMS && !D.svg && e && g(e.opacity) && (e.filter = "alpha(opacity=".concat(100 * e.opacity, ")")), h(t.style, e);
      }
      function u(t) {
        return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
      }
      function v(t, e) {
        return 1e14 < t ? t : parseFloat(t.toPrecision(e || 14));
      }
      function M(t, e, a) {
        var c = D.getStyle || M;
        if (e === "width") return e = Math.min(t.offsetWidth, t.scrollWidth), a = t.getBoundingClientRect && t.getBoundingClientRect().width, a < e && a >= e - 1 && (e = Math.floor(a)), Math.max(0, e - (c(t, "padding-left", !0) || 0) - (c(t, "padding-right", !0) || 0));
        if (e === "height") return Math.max(0, Math.min(t.offsetHeight, t.scrollHeight) - (c(t, "padding-top", !0) || 0) - (c(t, "padding-bottom", !0) || 0));
        if (o.getComputedStyle || E(27, !0), t = o.getComputedStyle(t, void 0)) {
          var y = t.getPropertyValue(e);
          s(a, e !== "opacity") && (y = H(y));
        }
        return y;
      }
      function I(t, e, a) {
        for (var c in t) Object.hasOwnProperty.call(t, c) && e.call(a || t[c], t[c], c, t);
      }
      function L(t, e, a) {
        function c(P, f) {
          var x = t.removeEventListener || D.removeEventListenerPolyfill;
          x && x.call(t, P, f, !1);
        }
        function y(P) {
          var f;
          if (t.nodeName) {
            if (e) {
              var x = {};
              x[e] = !0;
            } else x = P;
            I(x, function (N, R) {
              if (P[R]) for (f = P[R].length; f--;) c(R, P[R][f].fn);
            });
          }
        }
        var b = typeof t == "function" && t.prototype || t;
        if (Object.hasOwnProperty.call(b, "hcEvents")) {
          var j = b.hcEvents;
          e ? (b = j[e] || [], a ? (j[e] = b.filter(function (P) {
            return a !== P.fn;
          }), c(e, a)) : (y(j), j[e] = [])) : (y(j), delete b.hcEvents);
        }
      }
      function C(t, e, a, c) {
        if (a = a || {}, d.createEvent && (t.dispatchEvent || t.fireEvent && t !== D)) {
          var y = d.createEvent("Events");
          y.initEvent(e, !0, !0), a = h(y, a), t.dispatchEvent ? t.dispatchEvent(a) : t.fireEvent(e, a);
        } else if (t.hcEvents) {
          a.target || h(a, {
            preventDefault: function preventDefault() {
              a.defaultPrevented = !0;
            },
            target: t,
            type: e
          }), y = [];
          for (var b = t, j = !1; b.hcEvents;) Object.hasOwnProperty.call(b, "hcEvents") && b.hcEvents[e] && (y.length && (j = !0), y.unshift.apply(y, b.hcEvents[e])), b = Object.getPrototypeOf(b);
          j && y.sort(function (P, f) {
            return P.order - f.order;
          }), y.forEach(function (P) {
            P.fn.call(t, a) === !1 && a.preventDefault();
          });
        }
        c && !a.defaultPrevented && c.call(t, a);
      }
      var m = D.charts,
        d = D.doc,
        o = D.win;
      (E || (E = {})).messages = [], Math.easeInOutSine = function (t) {
        return -0.5 * (Math.cos(Math.PI * t) - 1);
      };
      var n = Array.prototype.find ? function (t, e) {
        return t.find(e);
      } : function (t, e) {
        var a,
          c = t.length;
        for (a = 0; a < c; a++) if (e(t[a], a)) return t[a];
      };
      I({
        map: "map",
        each: "forEach",
        grep: "filter",
        reduce: "reduce",
        some: "some"
      }, function (t, e) {
        D[e] = function (a) {
          var c;
          return E(32, !1, void 0, (c = {}, c["Highcharts.".concat(e)] = "use Array.".concat(t), c)), Array.prototype[t].apply(a, [].slice.call(arguments, 1));
        };
      });
      var r,
        i = function () {
          var t = Math.random().toString(36).substring(2, 9) + "-",
            e = 0;
          return function () {
            return "highcharts-" + (r ? "" : t) + e++;
          };
        }();
      return o.jQuery && (o.jQuery.fn.highcharts = function () {
        var t = [].slice.call(arguments);
        if (this[0]) return t[0] ? (new D[X(t[0]) ? t.shift() : "Chart"](this[0], t[0], t[1]), this) : m[p(this[0], "data-highcharts-chart")];
      }), n = {
        addEvent: function addEvent(t, e, a, c) {
          c === void 0 && (c = {});
          var y = typeof t == "function" && t.prototype || t;
          Object.hasOwnProperty.call(y, "hcEvents") || (y.hcEvents = {}), y = y.hcEvents, D.Point && t instanceof D.Point && t.series && t.series.chart && (t.series.chart.runTrackerClick = !0);
          var b = t.addEventListener || D.addEventListenerPolyfill;
          return b && b.call(t, e, a, D.supportsPassiveEvents ? {
            passive: c.passive === void 0 ? e.indexOf("touch") !== -1 : c.passive,
            capture: !1
          } : !1), y[e] || (y[e] = []), y[e].push({
            fn: a,
            order: typeof c.order == "number" ? c.order : 1 / 0
          }), y[e].sort(function (j, P) {
            return j.order - P.order;
          }), function () {
            L(t, e, a);
          };
        },
        arrayMax: function arrayMax(t) {
          for (var e = t.length, a = t[0]; e--;) t[e] > a && (a = t[e]);
          return a;
        },
        arrayMin: function arrayMin(t) {
          for (var e = t.length, a = t[0]; e--;) t[e] < a && (a = t[e]);
          return a;
        },
        attr: p,
        clamp: function clamp(t, e, a) {
          return t > e ? t < a ? t : a : e;
        },
        cleanRecursively: B,
        clearTimeout: function (_clearTimeout) {
          function clearTimeout(_x) {
            return _clearTimeout.apply(this, arguments);
          }
          clearTimeout.toString = function () {
            return _clearTimeout.toString();
          };
          return clearTimeout;
        }(function (t) {
          g(t) && clearTimeout(t);
        }),
        correctFloat: v,
        createElement: function createElement(t, e, a, c, y) {
          return t = d.createElement(t), e && h(t, e), y && l(t, {
            padding: "0",
            border: "none",
            margin: "0"
          }), a && l(t, a), c && c.appendChild(t), t;
        },
        css: l,
        defined: g,
        destroyObjectProperties: function destroyObjectProperties(t, e) {
          I(t, function (a, c) {
            a && a !== e && a.destroy && a.destroy(), delete t[c];
          });
        },
        discardElement: function discardElement(t) {
          t && t.parentElement && t.parentElement.removeChild(t);
        },
        erase: function erase(t, e) {
          for (var a = t.length; a--;) if (t[a] === e) {
            t.splice(a, 1);
            break;
          }
        },
        error: E,
        extend: h,
        extendClass: function extendClass(t, e) {
          var a = function a() {};
          return a.prototype = new t(), h(a.prototype, e), a;
        },
        find: n,
        fireEvent: C,
        getMagnitude: u,
        getNestedProperty: function getNestedProperty(t, e) {
          for (t = t.split("."); t.length && g(e);) {
            var a = t.shift();
            if (typeof a > "u" || a === "__proto__" || (e = e[a], !g(e) || typeof e == "function" || typeof e.nodeType == "number" || e === o)) return;
          }
          return e;
        },
        getStyle: M,
        inArray: function inArray(t, e, a) {
          return E(32, !1, void 0, {
            "Highcharts.inArray": "use Array.indexOf"
          }), e.indexOf(t, a);
        },
        isArray: W,
        isClass: A,
        isDOMElement: w,
        isFunction: function isFunction(t) {
          return typeof t == "function";
        },
        isNumber: k,
        isObject: z,
        isString: X,
        keys: function keys(t) {
          return E(32, !1, void 0, {
            "Highcharts.keys": "use Object.keys"
          }), Object.keys(t);
        },
        merge: function merge() {
          var t,
            e = arguments,
            a = {},
            c = function c(b, j) {
              return typeof b != "object" && (b = {}), I(j, function (P, f) {
                f !== "__proto__" && f !== "constructor" && (!z(P, !0) || A(P) || w(P) ? b[f] = j[f] : b[f] = c(b[f] || {}, P));
              }), b;
            };
          e[0] === !0 && (a = e[1], e = Array.prototype.slice.call(e, 2));
          var y = e.length;
          for (t = 0; t < y; t++) a = c(a, e[t]);
          return a;
        },
        normalizeTickInterval: function normalizeTickInterval(t, e, a, c, y) {
          var b = t;
          a = s(a, u(t));
          var j = t / a;
          for (e || (e = y ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], c === !1 && (a === 1 ? e = e.filter(function (P) {
            return P % 1 === 0;
          }) : 0.1 >= a && (e = [1 / a]))), c = 0; c < e.length && (b = e[c], !(y && b * a >= t || !y && j <= (e[c] + (e[c + 1] || e[c])) / 2)); c++);
          return b = v(b * a, -Math.round(Math.log(1e-3) / Math.LN10));
        },
        objectEach: I,
        offset: function offset(t) {
          var e = d.documentElement;
          return t = t.parentElement || t.parentNode ? t.getBoundingClientRect() : {
            top: 0,
            left: 0,
            width: 0,
            height: 0
          }, {
            top: t.top + (o.pageYOffset || e.scrollTop) - (e.clientTop || 0),
            left: t.left + (o.pageXOffset || e.scrollLeft) - (e.clientLeft || 0),
            width: t.width,
            height: t.height
          };
        },
        pad: function pad(t, e, a) {
          return Array((e || 2) + 1 - String(t).replace("-", "").length).join(a || "0") + t;
        },
        pick: s,
        pInt: H,
        relativeLength: function relativeLength(t, e, a) {
          return /%$/.test(t) ? e * parseFloat(t) / 100 + (a || 0) : parseFloat(t);
        },
        removeEvent: L,
        splat: function splat(t) {
          return W(t) ? t : [t];
        },
        stableSort: function stableSort(t, e) {
          var a = t.length,
            c,
            y;
          for (y = 0; y < a; y++) t[y].safeI = y;
          for (t.sort(function (b, j) {
            return c = e(b, j), c === 0 ? b.safeI - j.safeI : c;
          }), y = 0; y < a; y++) delete t[y].safeI;
        },
        syncTimeout: function syncTimeout(t, e, a) {
          return 0 < e ? setTimeout(t, e, a) : (t.call(0, a), -1);
        },
        timeUnits: {
          millisecond: 1,
          second: 1e3,
          minute: 6e4,
          hour: 36e5,
          day: 864e5,
          week: 6048e5,
          month: 24192e5,
          year: 314496e5
        },
        uniqueKey: i,
        useSerialIds: function useSerialIds(t) {
          return r = s(t, r);
        },
        wrap: function wrap(t, e, a) {
          var c = t[e];
          t[e] = function () {
            var y = arguments,
              b = this;
            return a.apply(this, [function () {
              return c.apply(b, arguments.length ? arguments : y);
            }].concat([].slice.call(arguments)));
          };
        }
      }, n;
    }), V(S, "Core/Chart/ChartDefaults.js", [], function () {
      return {
        alignThresholds: !1,
        panning: {
          enabled: !1,
          type: "x"
        },
        styledMode: !1,
        borderRadius: 0,
        colorCount: 10,
        allowMutatingData: !0,
        defaultSeriesType: "line",
        ignoreHiddenSeries: !0,
        spacing: [10, 10, 15, 10],
        resetZoomButton: {
          theme: {
            zIndex: 6
          },
          position: {
            align: "right",
            x: -10,
            y: 10
          }
        },
        zoomBySingleTouch: !1,
        zooming: {
          singleTouch: !1,
          resetButton: {
            theme: {
              zIndex: 6
            },
            position: {
              align: "right",
              x: -10,
              y: 10
            }
          }
        },
        width: null,
        height: null,
        borderColor: "#335cad",
        backgroundColor: "#ffffff",
        plotBorderColor: "#cccccc"
      };
    }), V(S, "Core/Color/Color.js", [S["Core/Globals.js"], S["Core/Utilities.js"]], function (D, E) {
      var B = E.isNumber,
        H = E.merge,
        X = E.pInt;
      return E = function () {
        function W(z) {
          this.rgba = [NaN, NaN, NaN, NaN], this.input = z;
          var w = D.Color;
          if (w && w !== W) return new w(z);
          if (!(this instanceof W)) return new W(z);
          this.init(z);
        }
        return W.parse = function (z) {
          return z ? new W(z) : W.None;
        }, W.prototype.init = function (z) {
          var w;
          if (typeof z == "object" && typeof z.stops < "u") this.stops = z.stops.map(function (p) {
            return new W(p[1]);
          });else if (typeof z == "string") {
            if (this.input = z = W.names[z.toLowerCase()] || z, z.charAt(0) === "#") {
              var A = z.length,
                k = parseInt(z.substr(1), 16);
              A === 7 ? w = [(k & 16711680) >> 16, (k & 65280) >> 8, k & 255, 1] : A === 4 && (w = [(k & 3840) >> 4 | (k & 3840) >> 8, (k & 240) >> 4 | k & 240, (k & 15) << 4 | k & 15, 1]);
            }
            if (!w) for (k = W.parsers.length; k-- && !w;) {
              var g = W.parsers[k];
              (A = g.regex.exec(z)) && (w = g.parse(A));
            }
          }
          w && (this.rgba = w);
        }, W.prototype.get = function (z) {
          var w = this.input,
            A = this.rgba;
          if (typeof w == "object" && typeof this.stops < "u") {
            var k = H(w);
            return k.stops = [].slice.call(k.stops), this.stops.forEach(function (g, p) {
              k.stops[p] = [k.stops[p][0], g.get(z)];
            }), k;
          }
          return A && B(A[0]) ? z === "rgb" || !z && A[3] === 1 ? "rgb(" + A[0] + "," + A[1] + "," + A[2] + ")" : z === "a" ? "".concat(A[3]) : "rgba(" + A.join(",") + ")" : w;
        }, W.prototype.brighten = function (z) {
          var w = this.rgba;
          if (this.stops) this.stops.forEach(function (k) {
            k.brighten(z);
          });else if (B(z) && z !== 0) for (var A = 0; 3 > A; A++) w[A] += X(255 * z), 0 > w[A] && (w[A] = 0), 255 < w[A] && (w[A] = 255);
          return this;
        }, W.prototype.setOpacity = function (z) {
          return this.rgba[3] = z, this;
        }, W.prototype.tweenTo = function (z, w) {
          var A = this.rgba,
            k = z.rgba;
          return !B(A[0]) || !B(k[0]) ? z.input || "none" : (z = k[3] !== 1 || A[3] !== 1, (z ? "rgba(" : "rgb(") + Math.round(k[0] + (A[0] - k[0]) * (1 - w)) + "," + Math.round(k[1] + (A[1] - k[1]) * (1 - w)) + "," + Math.round(k[2] + (A[2] - k[2]) * (1 - w)) + (z ? "," + (k[3] + (A[3] - k[3]) * (1 - w)) : "") + ")");
        }, W.names = {
          white: "#ffffff",
          black: "#000000"
        }, W.parsers = [{
          regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
          parse: function parse(z) {
            return [X(z[1]), X(z[2]), X(z[3]), parseFloat(z[4], 10)];
          }
        }, {
          regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
          parse: function parse(z) {
            return [X(z[1]), X(z[2]), X(z[3]), 1];
          }
        }], W.None = new W(""), W;
      }(), E;
    }), V(S, "Core/Color/Palettes.js", [], function () {
      return {
        colors: "#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" ")
      };
    }), V(S, "Core/Time.js", [S["Core/Globals.js"], S["Core/Utilities.js"]], function (D, E) {
      var B = D.win,
        H = E.defined,
        X = E.error,
        W = E.extend,
        z = E.isObject,
        w = E.merge,
        A = E.objectEach,
        k = E.pad,
        g = E.pick,
        p = E.splat,
        h = E.timeUnits,
        s = D.isSafari && B.Intl && B.Intl.DateTimeFormat.prototype.formatRange,
        l = D.isSafari && B.Intl && !B.Intl.DateTimeFormat.prototype.formatRange;
      return E = function () {
        function u(v) {
          this.options = {}, this.variableTimezone = this.useUTC = !1, this.Date = B.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(v);
        }
        return u.prototype.get = function (v, M) {
          if (this.variableTimezone || this.timezoneOffset) {
            var I = M.getTime(),
              L = I - this.getTimezoneOffset(M);
            return M.setTime(L), v = M["getUTC" + v](), M.setTime(I), v;
          }
          return this.useUTC ? M["getUTC" + v]() : M["get" + v]();
        }, u.prototype.set = function (v, M, I) {
          if (this.variableTimezone || this.timezoneOffset) {
            if (v === "Milliseconds" || v === "Seconds" || v === "Minutes" && this.getTimezoneOffset(M) % 36e5 === 0) return M["setUTC" + v](I);
            var L = this.getTimezoneOffset(M);
            return L = M.getTime() - L, M.setTime(L), M["setUTC" + v](I), v = this.getTimezoneOffset(M), L = M.getTime() + v, M.setTime(L);
          }
          return this.useUTC || s && v === "FullYear" ? M["setUTC" + v](I) : M["set" + v](I);
        }, u.prototype.update = function (v) {
          v === void 0 && (v = {});
          var M = g(v.useUTC, !0);
          this.options = v = w(!0, this.options, v), this.Date = v.Date || B.Date || Date, this.timezoneOffset = (this.useUTC = M) && v.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = M && !(!v.getTimezoneOffset && !v.timezone);
        }, u.prototype.makeTime = function (v, M, I, L, C, m) {
          if (this.useUTC) {
            var d = this.Date.UTC.apply(0, arguments),
              o = this.getTimezoneOffset(d);
            d += o;
            var n = this.getTimezoneOffset(d);
            o !== n ? d += n - o : o - 36e5 !== this.getTimezoneOffset(d - 36e5) || l || (d -= 36e5);
          } else d = new this.Date(v, M, g(I, 1), g(L, 0), g(C, 0), g(m, 0)).getTime();
          return d;
        }, u.prototype.timezoneOffsetFunction = function () {
          var v = this,
            M = this.options,
            I = M.getTimezoneOffset,
            L = M.moment || B.moment;
          if (!this.useUTC) return function (C) {
            return 6e4 * new Date(C.toString()).getTimezoneOffset();
          };
          if (M.timezone) {
            if (L) return function (C) {
              return 6e4 * -L.tz(C, M.timezone).utcOffset();
            };
            X(25);
          }
          return this.useUTC && I ? function (C) {
            return 6e4 * I(C.valueOf());
          } : function () {
            return 6e4 * (v.timezoneOffset || 0);
          };
        }, u.prototype.dateFormat = function (v, M, I) {
          if (!H(M) || isNaN(M)) return D.defaultOptions.lang && D.defaultOptions.lang.invalidDate || "";
          v = g(v, "%Y-%m-%d %H:%M:%S");
          var L = this,
            C = new this.Date(M),
            m = this.get("Hours", C),
            d = this.get("Day", C),
            o = this.get("Date", C),
            n = this.get("Month", C),
            r = this.get("FullYear", C),
            i = D.defaultOptions.lang,
            t = i && i.weekdays,
            e = i && i.shortWeekdays;
          return C = W({
            a: e ? e[d] : t[d].substr(0, 3),
            A: t[d],
            d: k(o),
            e: k(o, 2, " "),
            w: d,
            b: i.shortMonths[n],
            B: i.months[n],
            m: k(n + 1),
            o: n + 1,
            y: r.toString().substr(2, 2),
            Y: r,
            H: k(m),
            k: m,
            I: k(m % 12 || 12),
            l: m % 12 || 12,
            M: k(this.get("Minutes", C)),
            p: 12 > m ? "AM" : "PM",
            P: 12 > m ? "am" : "pm",
            S: k(C.getSeconds()),
            L: k(Math.floor(M % 1e3), 3)
          }, D.dateFormats), A(C, function (a, c) {
            for (; v.indexOf("%" + c) !== -1;) v = v.replace("%" + c, typeof a == "function" ? a.call(L, M) : a);
          }), I ? v.substr(0, 1).toUpperCase() + v.substr(1) : v;
        }, u.prototype.resolveDTLFormat = function (v) {
          return z(v, !0) ? v : (v = p(v), {
            main: v[0],
            from: v[1],
            to: v[2]
          });
        }, u.prototype.getTimeTicks = function (v, M, I, L) {
          var C = this,
            m = [],
            d = {},
            o = new C.Date(M),
            n = v.unitRange,
            r = v.count || 1,
            i;
          if (L = g(L, 1), H(M)) {
            if (C.set("Milliseconds", o, n >= h.second ? 0 : r * Math.floor(C.get("Milliseconds", o) / r)), n >= h.second && C.set("Seconds", o, n >= h.minute ? 0 : r * Math.floor(C.get("Seconds", o) / r)), n >= h.minute && C.set("Minutes", o, n >= h.hour ? 0 : r * Math.floor(C.get("Minutes", o) / r)), n >= h.hour && C.set("Hours", o, n >= h.day ? 0 : r * Math.floor(C.get("Hours", o) / r)), n >= h.day && C.set("Date", o, n >= h.month ? 1 : Math.max(1, r * Math.floor(C.get("Date", o) / r))), n >= h.month) {
              C.set("Month", o, n >= h.year ? 0 : r * Math.floor(C.get("Month", o) / r));
              var t = C.get("FullYear", o);
            }
            n >= h.year && C.set("FullYear", o, t - t % r), n === h.week && (t = C.get("Day", o), C.set("Date", o, C.get("Date", o) - t + L + (t < L ? -7 : 0))), t = C.get("FullYear", o), L = C.get("Month", o);
            var e = C.get("Date", o),
              a = C.get("Hours", o);
            for (M = o.getTime(), !C.variableTimezone && C.useUTC || !H(I) || (i = I - M > 4 * h.month || C.getTimezoneOffset(M) !== C.getTimezoneOffset(I)), M = o.getTime(), o = 1; M < I;) m.push(M), M = n === h.year ? C.makeTime(t + o * r, 0) : n === h.month ? C.makeTime(t, L + o * r) : !i || n !== h.day && n !== h.week ? i && n === h.hour && 1 < r ? C.makeTime(t, L, e, a + o * r) : M + n * r : C.makeTime(t, L, e + o * r * (n === h.day ? 1 : 7)), o++;
            m.push(M), n <= h.hour && 1e4 > m.length && m.forEach(function (c) {
              c % 18e5 === 0 && C.dateFormat("%H%M%S%L", c) === "000000000" && (d[c] = "day");
            });
          }
          return m.info = W(v, {
            higherRanks: d,
            totalRange: n * r
          }), m;
        }, u.prototype.getDateFormat = function (v, M, I, L) {
          var C = this.dateFormat("%m-%d %H:%M:%S.%L", M),
            m = {
              millisecond: 15,
              second: 12,
              minute: 9,
              hour: 6,
              day: 3
            },
            d = "millisecond";
          for (o in h) {
            if (v === h.week && +this.dateFormat("%w", M) === I && C.substr(6) === "00:00:00.000") {
              var o = "week";
              break;
            }
            if (h[o] > v) {
              o = d;
              break;
            }
            if (m[o] && C.substr(m[o]) !== "01-01 00:00:00.000".substr(m[o])) break;
            o !== "week" && (d = o);
          }
          return this.resolveDTLFormat(L[o]).main;
        }, u;
      }(), E;
    }), V(S, "Core/Defaults.js", [S["Core/Chart/ChartDefaults.js"], S["Core/Color/Color.js"], S["Core/Globals.js"], S["Core/Color/Palettes.js"], S["Core/Time.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W) {
      E = E.parse;
      var z = W.merge,
        w = {
          colors: H.colors,
          symbols: ["circle", "diamond", "square", "triangle", "triangle-down"],
          lang: {
            loading: "Loading...",
            months: "January February March April May June July August September October November December".split(" "),
            shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
            weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
            decimalPoint: ".",
            numericSymbols: "kMGTPE".split(""),
            resetZoom: "Reset zoom",
            resetZoomTitle: "Reset zoom level 1:1",
            thousandsSep: " "
          },
          global: {},
          time: {
            Date: void 0,
            getTimezoneOffset: void 0,
            timezone: void 0,
            timezoneOffset: 0,
            useUTC: !0
          },
          chart: D,
          title: {
            text: "Chart title",
            align: "center",
            margin: 15,
            widthAdjust: -44
          },
          subtitle: {
            text: "",
            align: "center",
            widthAdjust: -44
          },
          caption: {
            margin: 15,
            text: "",
            align: "left",
            verticalAlign: "bottom"
          },
          plotOptions: {},
          labels: {
            style: {
              position: "absolute",
              color: "#333333"
            }
          },
          legend: {
            enabled: !0,
            align: "center",
            alignColumns: !0,
            className: "highcharts-no-tooltip",
            layout: "horizontal",
            labelFormatter: function labelFormatter() {
              return this.name;
            },
            borderColor: "#999999",
            borderRadius: 0,
            navigation: {
              activeColor: "#003399",
              inactiveColor: "#cccccc"
            },
            itemStyle: {
              color: "#333333",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: "bold",
              textOverflow: "ellipsis"
            },
            itemHoverStyle: {
              color: "#000000"
            },
            itemHiddenStyle: {
              color: "#cccccc"
            },
            shadow: !1,
            itemCheckboxStyle: {
              position: "absolute",
              width: "13px",
              height: "13px"
            },
            squareSymbol: !0,
            symbolPadding: 5,
            verticalAlign: "bottom",
            x: 0,
            y: 0,
            title: {
              style: {
                fontWeight: "bold"
              }
            }
          },
          loading: {
            labelStyle: {
              fontWeight: "bold",
              position: "relative",
              top: "45%"
            },
            style: {
              position: "absolute",
              backgroundColor: "#ffffff",
              opacity: 0.5,
              textAlign: "center"
            }
          },
          tooltip: {
            enabled: !0,
            animation: B.svg,
            borderRadius: 3,
            dateTimeLabelFormats: {
              millisecond: "%A, %b %e, %H:%M:%S.%L",
              second: "%A, %b %e, %H:%M:%S",
              minute: "%A, %b %e, %H:%M",
              hour: "%A, %b %e, %H:%M",
              day: "%A, %b %e, %Y",
              week: "Week from %A, %b %e, %Y",
              month: "%B %Y",
              year: "%Y"
            },
            footerFormat: "",
            headerShape: "callout",
            hideDelay: 500,
            padding: 8,
            shape: "callout",
            shared: !1,
            snap: B.isTouchDevice ? 25 : 10,
            headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
            pointFormat: '<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>',
            backgroundColor: E("#f7f7f7").setOpacity(0.85).get(),
            borderWidth: 1,
            shadow: !0,
            stickOnContact: !1,
            style: {
              color: "#333333",
              cursor: "default",
              fontSize: "12px",
              whiteSpace: "nowrap"
            },
            useHTML: !1
          },
          credits: {
            enabled: !0,
            href: "https://www.highcharts.com?credits",
            position: {
              align: "right",
              x: -10,
              verticalAlign: "bottom",
              y: -5
            },
            style: {
              cursor: "pointer",
              color: "#999999",
              fontSize: "9px"
            },
            text: "Highcharts.com"
          }
        };
      w.chart.styledMode = !1;
      var A = new X(z(w.global, w.time));
      return D = {
        defaultOptions: w,
        defaultTime: A,
        getOptions: function getOptions() {
          return w;
        },
        setOptions: function setOptions(k) {
          return z(!0, w, k), (k.time || k.global) && (B.time ? B.time.update(z(w.global, w.time, k.global, k.time)) : B.time = A), w;
        }
      }, D;
    }), V(S, "Core/Animation/Fx.js", [S["Core/Color/Color.js"], S["Core/Globals.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = D.parse,
        X = E.win,
        W = B.isNumber,
        z = B.objectEach;
      return function () {
        function w(A, k, g) {
          this.pos = NaN, this.options = k, this.elem = A, this.prop = g;
        }
        return w.prototype.dSetter = function () {
          var A = this.paths,
            k = A && A[0];
          A = A && A[1];
          var g = this.now || 0,
            p = [];
          if (g !== 1 && k && A) {
            if (k.length === A.length && 1 > g) for (var h = 0; h < A.length; h++) {
              for (var s = k[h], l = A[h], u = [], v = 0; v < l.length; v++) {
                var M = s[v],
                  I = l[v];
                W(M) && W(I) && (l[0] !== "A" || v !== 4 && v !== 5) ? u[v] = M + g * (I - M) : u[v] = I;
              }
              p.push(u);
            } else p = A;
          } else p = this.toD || [];
          this.elem.attr("d", p, void 0, !0);
        }, w.prototype.update = function () {
          var A = this.elem,
            k = this.prop,
            g = this.now,
            p = this.options.step;
          this[k + "Setter"] ? this[k + "Setter"]() : A.attr ? A.element && A.attr(k, g, null, !0) : A.style[k] = g + this.unit, p && p.call(A, g, this);
        }, w.prototype.run = function (A, k, g) {
          var p = this,
            h = p.options,
            s = function s(v) {
              return s.stopped ? !1 : p.step(v);
            },
            l = X.requestAnimationFrame || function (v) {
              setTimeout(v, 13);
            },
            u = function u() {
              for (var v = 0; v < w.timers.length; v++) w.timers[v]() || w.timers.splice(v--, 1);
              w.timers.length && l(u);
            };
          A !== k || this.elem["forceAnimate:" + this.prop] ? (this.startTime = + /* @__PURE__ */new Date(), this.start = A, this.end = k, this.unit = g, this.now = this.start, this.pos = 0, s.elem = this.elem, s.prop = this.prop, s() && w.timers.push(s) === 1 && l(u)) : (delete h.curAnim[this.prop], h.complete && Object.keys(h.curAnim).length === 0 && h.complete.call(this.elem));
        }, w.prototype.step = function (A) {
          var k = + /* @__PURE__ */new Date(),
            g = this.options,
            p = this.elem,
            h = g.complete,
            s = g.duration,
            l = g.curAnim;
          if (p.attr && !p.element) A = !1;else if (A || k >= s + this.startTime) {
            this.now = this.end, this.pos = 1, this.update();
            var u = l[this.prop] = !0;
            z(l, function (v) {
              v !== !0 && (u = !1);
            }), u && h && h.call(p), A = !1;
          } else this.pos = g.easing((k - this.startTime) / s), this.now = this.start + (this.end - this.start) * this.pos, this.update(), A = !0;
          return A;
        }, w.prototype.initPath = function (A, k, g) {
          function p(C, m) {
            for (; C.length < L;) {
              var d = C[0],
                o = m[L - C.length];
              o && d[0] === "M" && (C[0] = o[0] === "C" ? ["C", d[1], d[2], d[1], d[2], d[1], d[2]] : ["L", d[1], d[2]]), C.unshift(d), u && (d = C.pop(), C.push(C[C.length - 1], d));
            }
          }
          function h(C, m) {
            for (; C.length < L;) if (m = C[Math.floor(C.length / v) - 1].slice(), m[0] === "C" && (m[1] = m[5], m[2] = m[6]), u) {
              var d = C[Math.floor(C.length / v)].slice();
              C.splice(C.length / 2, 0, m, d);
            } else C.push(m);
          }
          var s = A.startX,
            l = A.endX;
          g = g.slice();
          var u = A.isArea,
            v = u ? 2 : 1;
          if (k = k && k.slice(), !k) return [g, g];
          if (s && l && l.length) {
            for (A = 0; A < s.length; A++) if (s[A] === l[0]) {
              var M = A;
              break;
            } else if (s[0] === l[l.length - s.length + A]) {
              M = A;
              var I = !0;
              break;
            } else if (s[s.length - 1] === l[l.length - s.length + A]) {
              M = s.length - A;
              break;
            }
            typeof M > "u" && (k = []);
          }
          if (k.length && W(M)) {
            var L = g.length + M * v;
            I ? (p(k, g), h(g, k)) : (p(g, k), h(k, g));
          }
          return [k, g];
        }, w.prototype.fillSetter = function () {
          w.prototype.strokeSetter.apply(this, arguments);
        }, w.prototype.strokeSetter = function () {
          this.elem.attr(this.prop, H(this.start).tweenTo(H(this.end), this.pos), void 0, !0);
        }, w.timers = [], w;
      }();
    }), V(S, "Core/Animation/AnimationUtilities.js", [S["Core/Animation/Fx.js"], S["Core/Utilities.js"]], function (D, E) {
      function B(h) {
        return A(h) ? k({
          duration: 500,
          defer: 0
        }, h) : {
          duration: h ? 500 : 0,
          defer: 0
        };
      }
      function H(h, s) {
        for (var l = D.timers.length; l--;) D.timers[l].elem !== h || s && s !== D.timers[l].prop || (D.timers[l].stopped = !0);
      }
      var X = E.defined,
        W = E.getStyle,
        z = E.isArray,
        w = E.isNumber,
        A = E.isObject,
        k = E.merge,
        g = E.objectEach,
        p = E.pick;
      return {
        animate: function animate(h, s, l) {
          var u,
            v = "",
            M,
            I;
          if (!A(l)) {
            var L = arguments;
            l = {
              duration: L[2],
              easing: L[3],
              complete: L[4]
            };
          }
          w(l.duration) || (l.duration = 400), l.easing = typeof l.easing == "function" ? l.easing : Math[l.easing] || Math.easeInOutSine, l.curAnim = k(s), g(s, function (C, m) {
            H(h, m), I = new D(h, l, m), M = void 0, m === "d" && z(s.d) ? (I.paths = I.initPath(h, h.pathArray, s.d), I.toD = s.d, u = 0, M = 1) : h.attr ? u = h.attr(m) : (u = parseFloat(W(h, m)) || 0, m !== "opacity" && (v = "px")), M || (M = C), typeof M == "string" && M.match("px") && (M = M.replace(/px/g, "")), I.run(u, M, v);
          });
        },
        animObject: B,
        getDeferredAnimation: function getDeferredAnimation(h, s, l) {
          var u = B(s),
            v = 0,
            M = 0;
          return (l ? [l] : h.series).forEach(function (I) {
            I = B(I.options.animation), v = s && X(s.defer) ? u.defer : Math.max(v, I.duration + I.defer), M = Math.min(u.duration, I.duration);
          }), h.renderer.forExport && (v = 0), {
            defer: Math.max(0, v - M),
            duration: Math.min(v, M)
          };
        },
        setAnimation: function setAnimation(h, s) {
          s.renderer.globalAnimation = p(h, s.options.chart.animation, !0);
        },
        stop: H
      };
    }), V(S, "Core/Renderer/HTML/AST.js", [S["Core/Globals.js"], S["Core/Utilities.js"]], function (D, E) {
      var B = D.SVG_NS,
        H = E.attr,
        X = E.createElement,
        W = E.css,
        z = E.error,
        w = E.isFunction,
        A = E.isString,
        k = E.objectEach,
        g = E.splat,
        p = (E = D.win.trustedTypes) && w(E.createPolicy) && E.createPolicy("highcharts", {
          createHTML: function createHTML(l) {
            return l;
          }
        }),
        h = p ? p.createHTML("") : "";
      try {
        var s = !!new DOMParser().parseFromString(h, "text/html");
      } catch (_unused) {
        s = !1;
      }
      return w = function () {
        function l(u) {
          this.nodes = typeof u == "string" ? this.parseMarkup(u) : u;
        }
        return l.filterUserAttributes = function (u) {
          return k(u, function (v, M) {
            var I = !0;
            l.allowedAttributes.indexOf(M) === -1 && (I = !1), ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(M) !== -1 && (I = A(v) && l.allowedReferences.some(function (L) {
              return v.indexOf(L) === 0;
            })), I || (z(33, !1, void 0, {
              "Invalid attribute in config": "".concat(M)
            }), delete u[M]), A(v) && u[M] && (u[M] = v.replace(/</g, "&lt;"));
          }), u;
        }, l.parseStyle = function (u) {
          return u.split(";").reduce(function (v, M) {
            M = M.split(":").map(function (L) {
              return L.trim();
            });
            var I = M.shift();
            return I && M.length && (v[I.replace(/-([a-z])/g, function (L) {
              return L[1].toUpperCase();
            })] = M.join(":")), v;
          }, {});
        }, l.setElementHTML = function (u, v) {
          u.innerHTML = l.emptyHTML, v && new l(v).addToDOM(u);
        }, l.prototype.addToDOM = function (u) {
          function v(M, I) {
            var L;
            return g(M).forEach(function (C) {
              var m = C.tagName,
                d = C.textContent ? D.doc.createTextNode(C.textContent) : void 0,
                o = l.bypassHTMLFiltering;
              if (m) if (m === "#text") var n = d;else if (l.allowedTags.indexOf(m) !== -1 || o) {
                m = D.doc.createElementNS(m === "svg" ? B : I.namespaceURI || B, m);
                var r = C.attributes || {};
                k(C, function (i, t) {
                  t !== "tagName" && t !== "attributes" && t !== "children" && t !== "style" && t !== "textContent" && (r[t] = i);
                }), H(m, o ? r : l.filterUserAttributes(r)), C.style && W(m, C.style), d && m.appendChild(d), v(C.children || [], m), n = m;
              } else z(33, !1, void 0, {
                "Invalid tagName in config": m
              });
              n && I.appendChild(n), L = n;
            }), L;
          }
          return v(this.nodes, u);
        }, l.prototype.parseMarkup = function (u) {
          var v = [];
          if (u = u.trim().replace(/ style=(["'])/g, " data-style=$1"), s) u = new DOMParser().parseFromString(p ? p.createHTML(u) : u, "text/html");else {
            var M = X("div");
            M.innerHTML = u, u = {
              body: M
            };
          }
          var I = function I(L, C) {
            var m = L.nodeName.toLowerCase(),
              d = {
                tagName: m
              };
            if (m === "#text" && (d.textContent = L.textContent || ""), m = L.attributes) {
              var o = {};
              [].forEach.call(m, function (r) {
                r.name === "data-style" ? d.style = l.parseStyle(r.value) : o[r.name] = r.value;
              }), d.attributes = o;
            }
            if (L.childNodes.length) {
              var n = [];
              [].forEach.call(L.childNodes, function (r) {
                I(r, n);
              }), n.length && (d.children = n);
            }
            C.push(d);
          };
          return [].forEach.call(u.body.childNodes, function (L) {
            return I(L, v);
          }), v;
        }, l.allowedAttributes = "aria-controls aria-describedby aria-expanded aria-haspopup aria-hidden aria-label aria-labelledby aria-live aria-pressed aria-readonly aria-roledescription aria-selected class clip-path color colspan cx cy d dx dy disabled fill height href id in markerHeight markerWidth offset opacity orient padding paddingLeft paddingRight patternUnits r refX refY role scope slope src startOffset stdDeviation stroke stroke-linecap stroke-width style tableValues result rowspan summary target tabindex text-align text-anchor textAnchor textLength title type valign width x x1 x2 xlink:href y y1 y2 zIndex".split(" "), l.allowedReferences = "https:// http:// mailto: / ../ ./ #".split(" "), l.allowedTags = "a abbr b br button caption circle clipPath code dd defs div dl dt em feComponentTransfer feFuncA feFuncB feFuncG feFuncR feGaussianBlur feOffset feMerge feMergeNode filter h1 h2 h3 h4 h5 h6 hr i img li linearGradient marker ol p path pattern pre rect small span stop strong style sub sup svg table text textPath thead title tbody tspan td th tr u ul #text".split(" "), l.emptyHTML = h, l.bypassHTMLFiltering = !1, l;
      }(), w;
    }), V(S, "Core/FormatUtilities.js", [S["Core/Defaults.js"], S["Core/Utilities.js"]], function (D, E) {
      function B(k, g, p, h) {
        k = +k || 0, g = +g;
        var s = H.lang,
          l = (k.toString().split(".")[1] || "").split("e")[0].length,
          u = k.toString().split("e"),
          v = g;
        if (g === -1) g = Math.min(l, 20);else if (!z(g)) g = 2;else if (g && u[1] && 0 > u[1]) {
          var M = g + +u[1];
          0 <= M ? (u[0] = (+u[0]).toExponential(M).split("e")[0], g = M) : (u[0] = u[0].split(".")[0] || 0, k = 20 > g ? (u[0] * Math.pow(10, u[1])).toFixed(g) : 0, u[1] = 0);
        }
        M = (Math.abs(u[1] ? u[0] : k) + Math.pow(10, -Math.max(g, l) - 1)).toFixed(g), l = String(A(M));
        var I = 3 < l.length ? l.length % 3 : 0;
        return p = w(p, s.decimalPoint), h = w(h, s.thousandsSep), k = (0 > k ? "-" : "") + (I ? l.substr(0, I) + h : ""), k = 0 > +u[1] && !v ? "0" : k + l.substr(I).replace(/(\d{3})(?=\d)/g, "$1" + h), g && (k += p + M.slice(-g)), u[1] && +k != 0 && (k += "e" + u[1]), k;
      }
      var H = D.defaultOptions,
        X = D.defaultTime,
        W = E.getNestedProperty,
        z = E.isNumber,
        w = E.pick,
        A = E.pInt;
      return {
        dateFormat: function dateFormat(k, g, p) {
          return X.dateFormat(k, g, p);
        },
        format: function format(k, g, p) {
          var h = "{",
            s = !1,
            l = /f$/,
            u = /\.([0-9])/,
            v = H.lang,
            M = p && p.time || X;
          p = p && p.numberFormatter || B;
          for (var I = []; k;) {
            var L = k.indexOf(h);
            if (L === -1) break;
            var C = k.slice(0, L);
            if (s) {
              if (C = C.split(":"), h = W(C.shift() || "", g), C.length && typeof h == "number") if (C = C.join(":"), l.test(C)) {
                var m = parseInt((C.match(u) || ["", "-1"])[1], 10);
                h !== null && (h = p(h, m, v.decimalPoint, -1 < C.indexOf(",") ? v.thousandsSep : ""));
              } else h = M.dateFormat(C, h);
              I.push(h);
            } else I.push(C);
            k = k.slice(L + 1), h = (s = !s) ? "}" : "{";
          }
          return I.push(k), I.join("");
        },
        numberFormat: B
      };
    }), V(S, "Core/Renderer/RendererUtilities.js", [S["Core/Utilities.js"]], function (D) {
      var E = D.clamp,
        B = D.pick,
        H = D.stableSort,
        X;
      return function (W) {
        function z(w, A, k) {
          var g = w,
            p = g.reducedLen || A,
            h = function h(I, L) {
              return (L.rank || 0) - (I.rank || 0);
            },
            s = function s(I, L) {
              return I.target - L.target;
            },
            l,
            u = !0,
            v = [],
            M = 0;
          for (l = w.length; l--;) M += w[l].size;
          if (M > p) {
            for (H(w, h), M = l = 0; M <= p;) M += w[l].size, l++;
            v = w.splice(l - 1, w.length);
          }
          for (H(w, s), w = w.map(function (I) {
            return {
              size: I.size,
              targets: [I.target],
              align: B(I.align, 0.5)
            };
          }); u;) {
            for (l = w.length; l--;) p = w[l], h = (Math.min.apply(0, p.targets) + Math.max.apply(0, p.targets)) / 2, p.pos = E(h - p.size * p.align, 0, A - p.size);
            for (l = w.length, u = !1; l--;) 0 < l && w[l - 1].pos + w[l - 1].size > w[l].pos && (w[l - 1].size += w[l].size, w[l - 1].targets = w[l - 1].targets.concat(w[l].targets), w[l - 1].align = 0.5, w[l - 1].pos + w[l - 1].size > A && (w[l - 1].pos = A - w[l - 1].size), w.splice(l, 1), u = !0);
          }
          return g.push.apply(g, v), l = 0, w.some(function (I) {
            var L = 0;
            return (I.targets || []).some(function () {
              return g[l].pos = I.pos + L, typeof k < "u" && Math.abs(g[l].pos - g[l].target) > k ? (g.slice(0, l + 1).forEach(function (C) {
                return delete C.pos;
              }), g.reducedLen = (g.reducedLen || A) - 0.1 * A, g.reducedLen > 0.1 * A && z(g, A, k), !0) : (L += g[l].size, l++, !1);
            });
          }), H(g, s), g;
        }
        W.distribute = z;
      }(X || (X = {})), X;
    }), V(S, "Core/Renderer/SVG/SVGElement.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/Color/Color.js"], S["Core/Globals.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = D.animate,
        W = D.animObject,
        z = D.stop,
        w = B.deg2rad,
        A = B.doc,
        k = B.svg,
        g = B.SVG_NS,
        p = B.win,
        h = H.addEvent,
        s = H.attr,
        l = H.createElement,
        u = H.css,
        v = H.defined,
        M = H.erase,
        I = H.extend,
        L = H.fireEvent,
        C = H.isArray,
        m = H.isFunction,
        d = H.isString,
        o = H.merge,
        n = H.objectEach,
        r = H.pick,
        i = H.pInt,
        t = H.syncTimeout,
        e = H.uniqueKey;
      return D = function () {
        function a() {
          this.element = void 0, this.onEvents = {}, this.opacity = 1, this.renderer = void 0, this.SVG_NS = g, this.symbolCustomAttribs = "x y width height r start end innerR anchorX anchorY rounded".split(" ");
        }
        return a.prototype._defaultGetter = function (c) {
          return c = r(this[c + "Value"], this[c], this.element ? this.element.getAttribute(c) : null, 0), /^[\-0-9\.]+$/.test(c) && (c = parseFloat(c)), c;
        }, a.prototype._defaultSetter = function (c, y, b) {
          b.setAttribute(y, c);
        }, a.prototype.add = function (c) {
          var y = this.renderer,
            b = this.element;
          if (c && (this.parentGroup = c), typeof this.textStr < "u" && this.element.nodeName === "text" && y.buildText(this), this.added = !0, !c || c.handleZ || this.zIndex) var j = this.zIndexSetter();
          return j || (c ? c.element : y.box).appendChild(b), this.onAdd && this.onAdd(), this;
        }, a.prototype.addClass = function (c, y) {
          var b = y ? "" : this.attr("class") || "";
          return c = (c || "").split(/ /g).reduce(function (j, P) {
            return b.indexOf(P) === -1 && j.push(P), j;
          }, b ? [b] : []).join(" "), c !== b && this.attr("class", c), this;
        }, a.prototype.afterSetters = function () {
          this.doTransform && (this.updateTransform(), this.doTransform = !1);
        }, a.prototype.align = function (c, y, b) {
          var j = {},
            P = this.renderer,
            f = P.alignedObjects,
            x,
            N,
            R;
          c ? (this.alignOptions = c, this.alignByTranslate = y, (!b || d(b)) && (this.alignTo = x = b || "renderer", M(f, this), f.push(this), b = void 0)) : (c = this.alignOptions, y = this.alignByTranslate, x = this.alignTo), b = r(b, P[x], x === "scrollablePlotBox" ? P.plotBox : void 0, P), x = c.align;
          var F = c.verticalAlign;
          return P = (b.x || 0) + (c.x || 0), f = (b.y || 0) + (c.y || 0), x === "right" ? N = 1 : x === "center" && (N = 2), N && (P += (b.width - (c.width || 0)) / N), j[y ? "translateX" : "x"] = Math.round(P), F === "bottom" ? R = 1 : F === "middle" && (R = 2), R && (f += (b.height - (c.height || 0)) / R), j[y ? "translateY" : "y"] = Math.round(f), this[this.placed ? "animate" : "attr"](j), this.placed = !0, this.alignAttr = j, this;
        }, a.prototype.alignSetter = function (c) {
          var y = {
            left: "start",
            center: "middle",
            right: "end"
          };
          y[c] && (this.alignValue = c, this.element.setAttribute("text-anchor", y[c]));
        }, a.prototype.animate = function (c, y, b) {
          var j = this,
            P = W(r(y, this.renderer.globalAnimation, !0));
          return y = P.defer, r(A.hidden, A.msHidden, A.webkitHidden, !1) && (P.duration = 0), P.duration !== 0 ? (b && (P.complete = b), t(function () {
            j.element && X(j, c, P);
          }, y)) : (this.attr(c, void 0, b || P.complete), n(c, function (f, x) {
            P.step && P.step.call(this, f, {
              prop: x,
              pos: 1,
              elem: this
            });
          }, this)), this;
        }, a.prototype.applyTextOutline = function (c) {
          var y = this.element;
          c.indexOf("contrast") !== -1 && (c = c.replace(/contrast/g, this.renderer.getContrast(y.style.fill)));
          var b = c.split(" ");
          if (c = b[b.length - 1], (b = b[0]) && b !== "none" && B.svg) {
            this.fakeTS = !0, b = b.replace(/(^[\d\.]+)(.*?)$/g, function (f, x, N) {
              return 2 * Number(x) + N;
            }), this.removeTextOutline();
            var j = A.createElementNS(g, "tspan");
            s(j, {
              class: "highcharts-text-outline",
              fill: c,
              stroke: c,
              "stroke-width": b,
              "stroke-linejoin": "round"
            }), c = y.querySelector("textPath") || y, [].forEach.call(c.childNodes, function (f) {
              var x = f.cloneNode(!0);
              x.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach(function (N) {
                return x.removeAttribute(N);
              }), j.appendChild(x);
            });
            var P = 0;
            [].forEach.call(c.querySelectorAll("text tspan"), function (f) {
              P += Number(f.getAttribute("dy"));
            }), b = A.createElementNS(g, "tspan"), b.textContent = "​", s(b, {
              x: Number(y.getAttribute("x")),
              dy: -P
            }), j.appendChild(b), c.insertBefore(j, c.firstChild);
          }
        }, a.prototype.attr = function (c, y, b, j) {
          var P = this.element,
            f = this.symbolCustomAttribs,
            x,
            N = this,
            R,
            F;
          if (typeof c == "string" && typeof y < "u") {
            var T = c;
            c = {}, c[T] = y;
          }
          return typeof c == "string" ? N = (this[c + "Getter"] || this._defaultGetter).call(this, c, P) : (n(c, function (G, _) {
            R = !1, j || z(this, _), this.symbolName && f.indexOf(_) !== -1 && (x || (this.symbolAttr(c), x = !0), R = !0), !this.rotation || _ !== "x" && _ !== "y" || (this.doTransform = !0), R || (F = this[_ + "Setter"] || this._defaultSetter, F.call(this, G, _, P), !this.styledMode && this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(_) && this.updateShadows(_, G, F));
          }, this), this.afterSetters()), b && b.call(this), N;
        }, a.prototype.clip = function (c) {
          return this.attr("clip-path", c ? "url(" + this.renderer.url + "#" + c.id + ")" : "none");
        }, a.prototype.crisp = function (c, y) {
          y = y || c.strokeWidth || 0;
          var b = Math.round(y) % 2 / 2;
          return c.x = Math.floor(c.x || this.x || 0) + b, c.y = Math.floor(c.y || this.y || 0) + b, c.width = Math.floor((c.width || this.width || 0) - 2 * b), c.height = Math.floor((c.height || this.height || 0) - 2 * b), v(c.strokeWidth) && (c.strokeWidth = y), c;
        }, a.prototype.complexColor = function (c, y, b) {
          var j = this.renderer,
            P,
            f,
            x,
            N,
            R,
            F,
            T,
            G,
            _,
            q,
            Y = [],
            U;
          L(this.renderer, "complexColor", {
            args: arguments
          }, function () {
            if (c.radialGradient ? f = "radialGradient" : c.linearGradient && (f = "linearGradient"), f) {
              if (x = c[f], R = j.gradients, F = c.stops, _ = b.radialReference, C(x) && (c[f] = x = {
                x1: x[0],
                y1: x[1],
                x2: x[2],
                y2: x[3],
                gradientUnits: "userSpaceOnUse"
              }), f === "radialGradient" && _ && !v(x.gradientUnits) && (N = x, x = o(x, j.getRadialAttr(_, N), {
                gradientUnits: "userSpaceOnUse"
              })), n(x, function (J, et) {
                et !== "id" && Y.push(et, J);
              }), n(F, function (J) {
                Y.push(J);
              }), Y = Y.join(","), R[Y]) q = R[Y].attr("id");else {
                x.id = q = e();
                var Z = R[Y] = j.createElement(f).attr(x).add(j.defs);
                Z.radAttr = N, Z.stops = [], F.forEach(function (J) {
                  J[1].indexOf("rgba") === 0 ? (P = E.parse(J[1]), T = P.get("rgb"), G = P.get("a")) : (T = J[1], G = 1), J = j.createElement("stop").attr({
                    offset: J[0],
                    "stop-color": T,
                    "stop-opacity": G
                  }).add(Z), Z.stops.push(J);
                });
              }
              U = "url(" + j.url + "#" + q + ")", b.setAttribute(y, U), b.gradient = Y, c.toString = function () {
                return U;
              };
            }
          });
        }, a.prototype.css = function (c) {
          var y = this.styles,
            b = {},
            j = this.element,
            P = !y;
          if (c.color && (c.fill = c.color), y && n(c, function (N, R) {
            y && y[R] !== N && (b[R] = N, P = !0);
          }), P) {
            if (y && (c = I(y, b)), c.width === null || c.width === "auto") delete this.textWidth;else if (j.nodeName.toLowerCase() === "text" && c.width) var f = this.textWidth = i(c.width);
            this.styles = c, f && !k && this.renderer.forExport && delete c.width;
            var x = o(c);
            j.namespaceURI === this.SVG_NS && ["textOutline", "textOverflow", "width"].forEach(function (N) {
              return x && delete x[N];
            }), u(j, x), this.added && (this.element.nodeName === "text" && this.renderer.buildText(this), c.textOutline && this.applyTextOutline(c.textOutline));
          }
          return this;
        }, a.prototype.dashstyleSetter = function (c) {
          var y = this["stroke-width"];
          if (y === "inherit" && (y = 1), c = c && c.toLowerCase()) {
            var b = c.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");
            for (c = b.length; c--;) b[c] = "" + i(b[c]) * r(y, NaN);
            c = b.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", c);
          }
        }, a.prototype.destroy = function () {
          var c = this,
            y = c.element || {},
            b = c.renderer,
            j = y.ownerSVGElement,
            P = b.isSVG && y.nodeName === "SPAN" && c.parentGroup || void 0;
          if (y.onclick = y.onmouseout = y.onmouseover = y.onmousemove = y.point = null, z(c), c.clipPath && j) {
            var f = c.clipPath;
            [].forEach.call(j.querySelectorAll("[clip-path],[CLIP-PATH]"), function (x) {
              -1 < x.getAttribute("clip-path").indexOf(f.element.id) && x.removeAttribute("clip-path");
            }), c.clipPath = f.destroy();
          }
          if (c.stops) {
            for (j = 0; j < c.stops.length; j++) c.stops[j].destroy();
            c.stops.length = 0, c.stops = void 0;
          }
          for (c.safeRemoveChild(y), b.styledMode || c.destroyShadows(); P && P.div && P.div.childNodes.length === 0;) y = P.parentGroup, c.safeRemoveChild(P.div), delete P.div, P = y;
          c.alignTo && M(b.alignedObjects, c), n(c, function (x, N) {
            c[N] && c[N].parentGroup === c && c[N].destroy && c[N].destroy(), delete c[N];
          });
        }, a.prototype.destroyShadows = function () {
          (this.shadows || []).forEach(function (c) {
            this.safeRemoveChild(c);
          }, this), this.shadows = void 0;
        }, a.prototype.dSetter = function (c, y, b) {
          C(c) && (typeof c[0] == "string" && (c = this.renderer.pathToSegments(c)), this.pathArray = c, c = c.reduce(function (j, P, f) {
            return P && P.join ? (f ? j + " " : "") + P.join(" ") : (P || "").toString();
          }, "")), /(NaN| {2}|^$)/.test(c) && (c = "M 0 0"), this[y] !== c && (b.setAttribute(y, c), this[y] = c);
        }, a.prototype.fadeOut = function (c) {
          var y = this;
          y.animate({
            opacity: 0
          }, {
            duration: r(c, 150),
            complete: function complete() {
              y.hide();
            }
          });
        }, a.prototype.fillSetter = function (c, y, b) {
          typeof c == "string" ? b.setAttribute(y, c) : c && this.complexColor(c, y, b);
        }, a.prototype.getBBox = function (c, y) {
          var b = this.alignValue,
            j = this.element,
            P = this.renderer,
            f = this.styles,
            x = this.textStr,
            N = P.cache,
            R = P.cacheKeys,
            F = j.namespaceURI === this.SVG_NS;
          y = r(y, this.rotation, 0);
          var T = P.styledMode ? j && a.prototype.getStyle.call(j, "font-size") : f && f.fontSize,
            G;
          if (v(x)) {
            var _ = x.toString();
            _.indexOf("<") === -1 && (_ = _.replace(/[0-9]/g, "0")), _ += ["", y, T, this.textWidth, b, f && f.textOverflow, f && f.fontWeight].join();
          }
          if (_ && !c && (G = N[_]), !G) {
            if (F || P.forExport) {
              try {
                var q = this.fakeTS && function (U) {
                  var Z = j.querySelector(".highcharts-text-outline");
                  Z && u(Z, {
                    display: U
                  });
                };
                m(q) && q("none"), G = j.getBBox ? I({}, j.getBBox()) : {
                  width: j.offsetWidth,
                  height: j.offsetHeight,
                  x: 0,
                  y: 0
                }, m(q) && q("");
              } catch (_unused2) {}
              (!G || 0 > G.width) && (G = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
              });
            } else G = this.htmlGetBBox();
            if (P.isSVG && (P = G.width, c = G.height, F && (G.height = c = {
              "11px,17": 14,
              "13px,20": 16
            }["" + (T || "") + ",".concat(Math.round(c))] || c), y)) {
              F = Number(j.getAttribute("y") || 0) - G.y, b = {
                right: 1,
                center: 0.5
              }[b || 0] || 0, f = y * w, T = (y - 90) * w;
              var Y = P * Math.cos(f);
              y = P * Math.sin(f), q = Math.cos(T), f = Math.sin(T), P = G.x + b * (P - Y) + F * q, T = P + Y, q = T - c * q, Y = q - Y, F = G.y + F - b * y + F * f, b = F + y, c = b - c * f, y = c - y, G.x = Math.min(P, T, q, Y), G.y = Math.min(F, b, c, y), G.width = Math.max(P, T, q, Y) - G.x, G.height = Math.max(F, b, c, y) - G.y;
            }
            if (_ && (x === "" || 0 < G.height)) {
              for (; 250 < R.length;) delete N[R.shift()];
              N[_] || R.push(_), N[_] = G;
            }
          }
          return G;
        }, a.prototype.getStyle = function (c) {
          return p.getComputedStyle(this.element || this, "").getPropertyValue(c);
        }, a.prototype.hasClass = function (c) {
          return ("" + this.attr("class")).split(" ").indexOf(c) !== -1;
        }, a.prototype.hide = function () {
          return this.attr({
            visibility: "hidden"
          });
        }, a.prototype.htmlGetBBox = function () {
          return {
            height: 0,
            width: 0,
            x: 0,
            y: 0
          };
        }, a.prototype.init = function (c, y) {
          this.element = y === "span" ? l(y) : A.createElementNS(this.SVG_NS, y), this.renderer = c, L(this, "afterInit");
        }, a.prototype.on = function (c, y) {
          var b = this.onEvents;
          return b[c] && b[c](), b[c] = h(this.element, c, y), this;
        }, a.prototype.opacitySetter = function (c, y, b) {
          this.opacity = c = Number(Number(c).toFixed(3)), b.setAttribute(y, c);
        }, a.prototype.removeClass = function (c) {
          return this.attr("class", ("" + this.attr("class")).replace(d(c) ? new RegExp("(^| )".concat(c, "( |$)")) : c, " ").replace(/ +/g, " ").trim());
        }, a.prototype.removeTextOutline = function () {
          var c = this.element.querySelector("tspan.highcharts-text-outline");
          c && this.safeRemoveChild(c);
        }, a.prototype.safeRemoveChild = function (c) {
          var y = c.parentNode;
          y && y.removeChild(c);
        }, a.prototype.setRadialReference = function (c) {
          var y = this.element.gradient && this.renderer.gradients[this.element.gradient];
          return this.element.radialReference = c, y && y.radAttr && y.animate(this.renderer.getRadialAttr(c, y.radAttr)), this;
        }, a.prototype.setTextPath = function (c, y) {
          var b = this;
          y = o(!0, {
            enabled: !0,
            attributes: {
              dy: -5,
              startOffset: "50%",
              textAnchor: "middle"
            }
          }, y);
          var j = this.renderer.url,
            P = this.text || this,
            f = P.textPath,
            x = y.attributes,
            N = y.enabled;
          return c = c || f && f.path, f && f.undo(), c && N ? (y = h(P, "afterModifyTree", function (R) {
            if (c && N) {
              var F = c.attr("id");
              F || c.attr("id", F = e());
              var T = {
                x: 0,
                y: 0
              };
              v(x.dx) && (T.dx = x.dx, delete x.dx), v(x.dy) && (T.dy = x.dy, delete x.dy), P.attr(T), b.attr({
                transform: ""
              }), b.box && (b.box = b.box.destroy()), T = R.nodes.slice(0), R.nodes.length = 0, R.nodes[0] = {
                tagName: "textPath",
                attributes: I(x, {
                  "text-anchor": x.textAnchor,
                  href: "" + j + "#".concat(F)
                }),
                children: T
              };
            }
          }), P.textPath = {
            path: c,
            undo: y
          }) : (P.attr({
            dx: 0,
            dy: 0
          }), delete P.textPath), this.added && (P.textCache = "", this.renderer.buildText(P)), this;
        }, a.prototype.shadow = function (c, y, b) {
          var j = [],
            P = this.element,
            f = this.oldShadowOptions,
            x = this.parentGroup,
            N = x && x.rotation === 90;
          x = {
            color: "#000000",
            offsetX: N ? -1 : 1,
            offsetY: N ? -1 : 1,
            opacity: 0.15,
            width: 3
          };
          var R = !1,
            F;
          if (c === !0 ? F = x : typeof c == "object" && (F = I(x, c)), F && (F && f && n(F, function (q, Y) {
            q !== f[Y] && (R = !0);
          }), R && this.destroyShadows(), this.oldShadowOptions = F), !F) this.destroyShadows();else if (!this.shadows) {
            x = F.opacity / F.width;
            var T = N ? "translate(".concat(F.offsetY, ", ").concat(F.offsetX, ")") : "translate(".concat(F.offsetX, ", ").concat(F.offsetY, ")");
            for (N = 1; N <= F.width; N++) {
              var G = P.cloneNode(!1),
                _ = 2 * F.width + 1 - 2 * N;
              s(G, {
                stroke: c.color || "#000000",
                "stroke-opacity": x * N,
                "stroke-width": _,
                transform: T,
                fill: "none"
              }), G.setAttribute("class", (G.getAttribute("class") || "") + " highcharts-shadow"), b && (s(G, "height", Math.max(s(G, "height") - _, 0)), G.cutHeight = _), y ? y.element.appendChild(G) : P.parentNode && P.parentNode.insertBefore(G, P), j.push(G);
            }
            this.shadows = j;
          }
          return this;
        }, a.prototype.show = function (c) {
          return c === void 0 && (c = !0), this.attr({
            visibility: c ? "inherit" : "visible"
          });
        }, a.prototype["stroke-widthSetter"] = function (c, y, b) {
          this[y] = c, b.setAttribute(y, c);
        }, a.prototype.strokeWidth = function () {
          if (!this.renderer.styledMode) return this["stroke-width"] || 0;
          var c = this.getStyle("stroke-width"),
            y = 0;
          if (c.indexOf("px") === c.length - 2) y = i(c);else if (c !== "") {
            var b = A.createElementNS(g, "rect");
            s(b, {
              width: c,
              "stroke-width": 0
            }), this.element.parentNode.appendChild(b), y = b.getBBox().width, b.parentNode.removeChild(b);
          }
          return y;
        }, a.prototype.symbolAttr = function (c) {
          var y = this;
          "x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function (b) {
            y[b] = r(c[b], y[b]);
          }), y.attr({
            d: y.renderer.symbols[y.symbolName](y.x, y.y, y.width, y.height, y)
          });
        }, a.prototype.textSetter = function (c) {
          c !== this.textStr && (delete this.textPxLength, this.textStr = c, this.added && this.renderer.buildText(this));
        }, a.prototype.titleSetter = function (c) {
          var y = this.element,
            b = y.getElementsByTagName("title")[0] || A.createElementNS(this.SVG_NS, "title");
          y.insertBefore ? y.insertBefore(b, y.firstChild) : y.appendChild(b), b.textContent = String(r(c, "")).replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        }, a.prototype.toFront = function () {
          var c = this.element;
          return c.parentNode.appendChild(c), this;
        }, a.prototype.translate = function (c, y) {
          return this.attr({
            translateX: c,
            translateY: y
          });
        }, a.prototype.updateShadows = function (c, y, b) {
          var j = this.shadows;
          if (j) for (var P = j.length; P--;) b.call(j[P], c === "height" ? Math.max(y - (j[P].cutHeight || 0), 0) : c === "d" ? this.d : y, c, j[P]);
        }, a.prototype.updateTransform = function () {
          var c = this.element,
            y = this.matrix,
            b = this.rotation;
          b = b === void 0 ? 0 : b;
          var j = this.scaleX,
            P = this.scaleY,
            f = this.translateX,
            x = this.translateY;
          f = ["translate(" + (f === void 0 ? 0 : f) + "," + (x === void 0 ? 0 : x) + ")"], v(y) && f.push("matrix(" + y.join(",") + ")"), b && f.push("rotate(" + b + " " + r(this.rotationOriginX, c.getAttribute("x"), 0) + " " + r(this.rotationOriginY, c.getAttribute("y") || 0) + ")"), (v(j) || v(P)) && f.push("scale(" + r(j, 1) + " " + r(P, 1) + ")"), f.length && !(this.text || this).textPath && c.setAttribute("transform", f.join(" "));
        }, a.prototype.visibilitySetter = function (c, y, b) {
          c === "inherit" ? b.removeAttribute(y) : this[y] !== c && b.setAttribute(y, c), this[y] = c;
        }, a.prototype.xGetter = function (c) {
          return this.element.nodeName === "circle" && (c === "x" ? c = "cx" : c === "y" && (c = "cy")), this._defaultGetter(c);
        }, a.prototype.zIndexSetter = function (c, y) {
          var b = this.renderer,
            j = this.parentGroup,
            P = (j || b).element || b.box,
            f = this.element;
          b = P === b.box;
          var x = !1,
            N = this.added,
            R;
          if (v(c) ? (f.setAttribute("data-z-index", c), c = +c, this[y] === c && (N = !1)) : v(this[y]) && f.removeAttribute("data-z-index"), this[y] = c, N) {
            for ((c = this.zIndex) && j && (j.handleZ = !0), y = P.childNodes, R = y.length - 1; 0 <= R && !x; R--) {
              j = y[R], N = j.getAttribute("data-z-index");
              var F = !v(N);
              j !== f && (0 > c && F && !b && !R ? (P.insertBefore(f, y[R]), x = !0) : (i(N) <= c || F && (!v(c) || 0 <= c)) && (P.insertBefore(f, y[R + 1] || null), x = !0));
            }
            x || (P.insertBefore(f, y[b ? 3 : 0] || null), x = !0);
          }
          return x;
        }, a;
      }(), D.prototype.strokeSetter = D.prototype.fillSetter, D.prototype.yGetter = D.prototype.xGetter, D.prototype.matrixSetter = D.prototype.rotationOriginXSetter = D.prototype.rotationOriginYSetter = D.prototype.rotationSetter = D.prototype.scaleXSetter = D.prototype.scaleYSetter = D.prototype.translateXSetter = D.prototype.translateYSetter = D.prototype.verticalAlignSetter = function (a, c) {
        this[c] = a, this.doTransform = !0;
      }, D;
    }), V(S, "Core/Renderer/RendererRegistry.js", [S["Core/Globals.js"]], function (D) {
      var E;
      return function (B) {
        B.rendererTypes = {};
        var H;
        B.getRendererType = function (X) {
          return X === void 0 && (X = H), B.rendererTypes[X] || B.rendererTypes[H];
        }, B.registerRendererType = function (X, W, z) {
          B.rendererTypes[X] = W, (!H || z) && (H = X, D.Renderer = W);
        };
      }(E || (E = {})), E;
    }), V(S, "Core/Renderer/SVG/SVGLabel.js", [S["Core/Renderer/SVG/SVGElement.js"], S["Core/Utilities.js"]], function (D, E) {
      var B = this && this.__extends || function () {
          var _k3 = function k(g, p) {
            return _k3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k3(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k3(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        H = E.defined,
        X = E.extend,
        W = E.isNumber,
        z = E.merge,
        w = E.pick,
        A = E.removeEvent;
      return function (k) {
        function g(p, h, s, l, u, v, M, I, L, C) {
          var m = k.call(this) || this;
          m.paddingLeftSetter = m.paddingSetter, m.paddingRightSetter = m.paddingSetter, m.init(p, "g"), m.textStr = h, m.x = s, m.y = l, m.anchorX = v, m.anchorY = M, m.baseline = L, m.className = C, m.addClass(C === "button" ? "highcharts-no-tooltip" : "highcharts-label"), C && m.addClass("highcharts-" + C), m.text = p.text(void 0, 0, 0, I).attr({
            zIndex: 1
          });
          var d;
          return typeof u == "string" && ((d = /^url\((.*?)\)$/.test(u)) || m.renderer.symbols[u]) && (m.symbolKey = u), m.bBox = g.emptyBBox, m.padding = 3, m.baselineOffset = 0, m.needsBox = p.styledMode || d, m.deferredAttr = {}, m.alignFactor = 0, m;
        }
        return B(g, k), g.prototype.alignSetter = function (p) {
          p = {
            left: 0,
            center: 0.5,
            right: 1
          }[p], p !== this.alignFactor && (this.alignFactor = p, this.bBox && W(this.xSetting) && this.attr({
            x: this.xSetting
          }));
        }, g.prototype.anchorXSetter = function (p, h) {
          this.anchorX = p, this.boxAttr(h, Math.round(p) - this.getCrispAdjust() - this.xSetting);
        }, g.prototype.anchorYSetter = function (p, h) {
          this.anchorY = p, this.boxAttr(h, p - this.ySetting);
        }, g.prototype.boxAttr = function (p, h) {
          this.box ? this.box.attr(p, h) : this.deferredAttr[p] = h;
        }, g.prototype.css = function (p) {
          if (p) {
            var h = {};
            p = z(p), g.textProps.forEach(function (s) {
              typeof p[s] < "u" && (h[s] = p[s], delete p[s]);
            }), this.text.css(h), "fontSize" in h || "fontWeight" in h ? this.updateTextPadding() : ("width" in h || "textOverflow" in h) && this.updateBoxSize();
          }
          return D.prototype.css.call(this, p);
        }, g.prototype.destroy = function () {
          A(this.element, "mouseenter"), A(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), D.prototype.destroy.call(this);
        }, g.prototype.fillSetter = function (p, h) {
          p && (this.needsBox = !0), this.fill = p, this.boxAttr(h, p);
        }, g.prototype.getBBox = function () {
          this.textStr && this.bBox.width === 0 && this.bBox.height === 0 && this.updateBoxSize();
          var p = this.padding,
            h = w(this.paddingLeft, p);
          return {
            width: this.width,
            height: this.height,
            x: this.bBox.x - h,
            y: this.bBox.y - p
          };
        }, g.prototype.getCrispAdjust = function () {
          return this.renderer.styledMode && this.box ? this.box.strokeWidth() % 2 / 2 : (this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
        }, g.prototype.heightSetter = function (p) {
          this.heightSetting = p;
        }, g.prototype.onAdd = function () {
          this.text.add(this), this.attr({
            text: w(this.textStr, ""),
            x: this.x || 0,
            y: this.y || 0
          }), this.box && H(this.anchorX) && this.attr({
            anchorX: this.anchorX,
            anchorY: this.anchorY
          });
        }, g.prototype.paddingSetter = function (p, h) {
          W(p) ? p !== this[h] && (this[h] = p, this.updateTextPadding()) : this[h] = void 0;
        }, g.prototype.rSetter = function (p, h) {
          this.boxAttr(h, p);
        }, g.prototype.shadow = function (p) {
          return p && !this.renderer.styledMode && (this.updateBoxSize(), this.box && this.box.shadow(p)), this;
        }, g.prototype.strokeSetter = function (p, h) {
          this.stroke = p, this.boxAttr(h, p);
        }, g.prototype["stroke-widthSetter"] = function (p, h) {
          p && (this.needsBox = !0), this["stroke-width"] = p, this.boxAttr(h, p);
        }, g.prototype["text-alignSetter"] = function (p) {
          this.textAlign = p;
        }, g.prototype.textSetter = function (p) {
          typeof p < "u" && this.text.attr({
            text: p
          }), this.updateTextPadding();
        }, g.prototype.updateBoxSize = function () {
          var p = this.text,
            h = p.element.style,
            s = {},
            l = this.padding,
            u = this.bBox = W(this.widthSetting) && W(this.heightSetting) && !this.textAlign || !H(p.textStr) ? g.emptyBBox : p.getBBox();
          this.width = this.getPaddedWidth(), this.height = (this.heightSetting || u.height || 0) + 2 * l, h = this.renderer.fontMetrics(h && h.fontSize, p), this.baselineOffset = l + Math.min((this.text.firstLineMetrics || h).b, u.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - h.h) / 2), this.needsBox && !p.textPath && (this.box || (p = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect(), p.addClass((this.className === "button" ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), p.add(this)), p = this.getCrispAdjust(), s.x = p, s.y = (this.baseline ? -this.baselineOffset : 0) + p, s.width = Math.round(this.width), s.height = Math.round(this.height), this.box.attr(X(s, this.deferredAttr)), this.deferredAttr = {});
        }, g.prototype.updateTextPadding = function () {
          var p = this.text;
          if (!p.textPath) {
            this.updateBoxSize();
            var h = this.baseline ? 0 : this.baselineOffset,
              s = w(this.paddingLeft, this.padding);
            H(this.widthSetting) && this.bBox && (this.textAlign === "center" || this.textAlign === "right") && (s += {
              center: 0.5,
              right: 1
            }[this.textAlign] * (this.widthSetting - this.bBox.width)), (s !== p.x || h !== p.y) && (p.attr("x", s), p.hasBoxWidthChanged && (this.bBox = p.getBBox(!0)), typeof h < "u" && p.attr("y", h)), p.x = s, p.y = h;
          }
        }, g.prototype.widthSetter = function (p) {
          this.widthSetting = W(p) ? p : void 0;
        }, g.prototype.getPaddedWidth = function () {
          var p = this.padding,
            h = w(this.paddingLeft, p);
          return p = w(this.paddingRight, p), (this.widthSetting || this.bBox.width || 0) + h + p;
        }, g.prototype.xSetter = function (p) {
          this.x = p, this.alignFactor && (p -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(p), this.attr("translateX", this.xSetting);
        }, g.prototype.ySetter = function (p) {
          this.ySetting = this.y = Math.round(p), this.attr("translateY", this.ySetting);
        }, g.emptyBBox = {
          width: 0,
          height: 0,
          x: 0,
          y: 0
        }, g.textProps = "color direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow width".split(" "), g;
      }(D);
    }), V(S, "Core/Renderer/SVG/Symbols.js", [S["Core/Utilities.js"]], function (D) {
      function E(w, A, k, g, p) {
        var h = [];
        if (p) {
          var s = p.start || 0,
            l = z(p.r, k);
          k = z(p.r, g || k);
          var u = (p.end || 0) - 1e-3;
          g = p.innerR;
          var v = z(p.open, 1e-3 > Math.abs((p.end || 0) - s - 2 * Math.PI)),
            M = Math.cos(s),
            I = Math.sin(s),
            L = Math.cos(u),
            C = Math.sin(u);
          s = z(p.longArc, 1e-3 > u - s - Math.PI ? 0 : 1), h.push(["M", w + l * M, A + k * I], ["A", l, k, 0, s, z(p.clockwise, 1), w + l * L, A + k * C]), X(g) && h.push(v ? ["M", w + g * L, A + g * C] : ["L", w + g * L, A + g * C], ["A", g, g, 0, s, X(p.clockwise) ? 1 - p.clockwise : 0, w + g * M, A + g * I]), v || h.push(["Z"]);
        }
        return h;
      }
      function B(w, A, k, g, p) {
        return p && p.r ? H(w, A, k, g, p) : [["M", w, A], ["L", w + k, A], ["L", w + k, A + g], ["L", w, A + g], ["Z"]];
      }
      function H(w, A, k, g, p) {
        return p = p && p.r || 0, [["M", w + p, A], ["L", w + k - p, A], ["C", w + k, A, w + k, A, w + k, A + p], ["L", w + k, A + g - p], ["C", w + k, A + g, w + k, A + g, w + k - p, A + g], ["L", w + p, A + g], ["C", w, A + g, w, A + g, w, A + g - p], ["L", w, A + p], ["C", w, A, w, A, w + p, A]];
      }
      var X = D.defined,
        W = D.isNumber,
        z = D.pick;
      return {
        arc: E,
        callout: function callout(w, A, k, g, p) {
          var h = Math.min(p && p.r || 0, k, g),
            s = h + 6,
            l = p && p.anchorX;
          p = p && p.anchorY || 0;
          var u = H(w, A, k, g, {
            r: h
          });
          return W(l) && (w + l >= k ? p > A + s && p < A + g - s ? u.splice(3, 1, ["L", w + k, p - 6], ["L", w + k + 6, p], ["L", w + k, p + 6], ["L", w + k, A + g - h]) : u.splice(3, 1, ["L", w + k, g / 2], ["L", l, p], ["L", w + k, g / 2], ["L", w + k, A + g - h]) : 0 >= w + l ? p > A + s && p < A + g - s ? u.splice(7, 1, ["L", w, p + 6], ["L", w - 6, p], ["L", w, p - 6], ["L", w, A + h]) : u.splice(7, 1, ["L", w, g / 2], ["L", l, p], ["L", w, g / 2], ["L", w, A + h]) : p && p > g && l > w + s && l < w + k - s ? u.splice(5, 1, ["L", l + 6, A + g], ["L", l, A + g + 6], ["L", l - 6, A + g], ["L", w + h, A + g]) : p && 0 > p && l > w + s && l < w + k - s && u.splice(1, 1, ["L", l - 6, A], ["L", l, A - 6], ["L", l + 6, A], ["L", k - h, A])), u;
        },
        circle: function circle(w, A, k, g) {
          return E(w + k / 2, A + g / 2, k / 2, g / 2, {
            start: 0.5 * Math.PI,
            end: 2.5 * Math.PI,
            open: !1
          });
        },
        diamond: function diamond(w, A, k, g) {
          return [["M", w + k / 2, A], ["L", w + k, A + g / 2], ["L", w + k / 2, A + g], ["L", w, A + g / 2], ["Z"]];
        },
        rect: B,
        roundedRect: H,
        square: B,
        triangle: function triangle(w, A, k, g) {
          return [["M", w + k / 2, A], ["L", w + k, A + g], ["L", w, A + g], ["Z"]];
        },
        "triangle-down": function triangleDown(w, A, k, g) {
          return [["M", w, A], ["L", w + k, A], ["L", w + k / 2, A + g], ["Z"]];
        }
      };
    }), V(S, "Core/Renderer/SVG/TextBuilder.js", [S["Core/Renderer/HTML/AST.js"], S["Core/Globals.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = E.doc,
        X = E.SVG_NS,
        W = E.win,
        z = B.attr,
        w = B.extend,
        A = B.fireEvent,
        k = B.isString,
        g = B.objectEach,
        p = B.pick;
      return function () {
        function h(s) {
          var l = s.styles;
          this.renderer = s.renderer, this.svgElement = s, this.width = s.textWidth, this.textLineHeight = l && l.lineHeight, this.textOutline = l && l.textOutline, this.ellipsis = !(!l || l.textOverflow !== "ellipsis"), this.noWrap = !(!l || l.whiteSpace !== "nowrap"), this.fontSize = l && l.fontSize;
        }
        return h.prototype.buildSVG = function () {
          var s = this.svgElement,
            l = s.element,
            u = s.renderer,
            v = p(s.textStr, "").toString(),
            M = v.indexOf("<") !== -1,
            I = l.childNodes;
          u = this.width && !s.added && u.box;
          var L = /<br.*?>/g,
            C = [v, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, this.fontSize, this.width].join();
          if (C !== s.textCache) {
            for (s.textCache = C, delete s.actualWidth, C = I.length; C--;) l.removeChild(I[C]);
            M || this.ellipsis || this.width || s.textPath || v.indexOf(" ") !== -1 && (!this.noWrap || L.test(v)) ? v !== "" && (u && u.appendChild(l), v = new D(v), this.modifyTree(v.nodes), v.addToDOM(l), this.modifyDOM(), this.ellipsis && (l.textContent || "").indexOf("…") !== -1 && s.attr("title", this.unescapeEntities(s.textStr || "", ["&lt;", "&gt;"])), u && u.removeChild(l)) : l.appendChild(H.createTextNode(this.unescapeEntities(v))), k(this.textOutline) && s.applyTextOutline && s.applyTextOutline(this.textOutline);
          }
        }, h.prototype.modifyDOM = function () {
          var s = this,
            l = this.svgElement,
            u = z(l.element, "x");
          l.firstLineMetrics = void 0;
          for (var v; (v = l.element.firstChild) && /^[\s\u200B]*$/.test(v.textContent || " ");) l.element.removeChild(v);
          [].forEach.call(l.element.querySelectorAll("tspan.highcharts-br"), function (C, m) {
            C.nextSibling && C.previousSibling && (m === 0 && C.previousSibling.nodeType === 1 && (l.firstLineMetrics = l.renderer.fontMetrics(void 0, C.previousSibling)), z(C, {
              dy: s.getLineHeight(C.nextSibling),
              x: u
            }));
          });
          var M = this.width || 0;
          if (M) {
            var I = function I(C, m) {
                var d = C.textContent || "",
                  o = d.replace(/([^\^])-/g, "$1- ").split(" "),
                  n = !s.noWrap && (1 < o.length || 1 < l.element.childNodes.length),
                  r = s.getLineHeight(m),
                  i = 0,
                  t = l.actualWidth;
                if (s.ellipsis) d && s.truncate(C, d, void 0, 0, Math.max(0, M - parseInt(s.fontSize || 12, 10)), function (e, a) {
                  return e.substring(0, a) + "…";
                });else if (n) {
                  for (d = [], n = []; m.firstChild && m.firstChild !== C;) n.push(m.firstChild), m.removeChild(m.firstChild);
                  for (; o.length;) o.length && !s.noWrap && 0 < i && (d.push(C.textContent || ""), C.textContent = o.join(" ").replace(/- /g, "-")), s.truncate(C, void 0, o, i === 0 && t || 0, M, function (e, a) {
                    return o.slice(0, a).join(" ").replace(/- /g, "-");
                  }), t = l.actualWidth, i++;
                  n.forEach(function (e) {
                    m.insertBefore(e, C);
                  }), d.forEach(function (e) {
                    m.insertBefore(H.createTextNode(e), C), e = H.createElementNS(X, "tspan"), e.textContent = "​", z(e, {
                      dy: r,
                      x: u
                    }), m.insertBefore(e, C);
                  });
                }
              },
              L = function L(C) {
                [].slice.call(C.childNodes).forEach(function (m) {
                  m.nodeType === W.Node.TEXT_NODE ? I(m, C) : (m.className.baseVal.indexOf("highcharts-br") !== -1 && (l.actualWidth = 0), L(m));
                });
              };
            L(l.element);
          }
        }, h.prototype.getLineHeight = function (s) {
          var l;
          return s = s.nodeType === W.Node.TEXT_NODE ? s.parentElement : s, this.renderer.styledMode || (l = s && /(px|em)$/.test(s.style.fontSize) ? s.style.fontSize : this.fontSize || this.renderer.style.fontSize || 12), this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(l, s || this.svgElement.element).h;
        }, h.prototype.modifyTree = function (s) {
          var l = this,
            u = function u(v, M) {
              var I = v.attributes;
              I = I === void 0 ? {} : I;
              var L = v.children,
                C = v.style;
              C = C === void 0 ? {} : C;
              var m = v.tagName,
                d = l.renderer.styledMode;
              m === "b" || m === "strong" ? d ? I.class = "highcharts-strong" : C.fontWeight = "bold" : (m === "i" || m === "em") && (d ? I.class = "highcharts-emphasized" : C.fontStyle = "italic"), C && C.color && (C.fill = C.color), m === "br" ? (I.class = "highcharts-br", v.textContent = "​", (M = s[M + 1]) && M.textContent && (M.textContent = M.textContent.replace(/^ +/gm, ""))) : m === "a" && L && L.some(function (o) {
                return o.tagName === "#text";
              }) && (v.children = [{
                children: L,
                tagName: "tspan"
              }]), m !== "#text" && m !== "a" && (v.tagName = "tspan"), w(v, {
                attributes: I,
                style: C
              }), L && L.filter(function (o) {
                return o.tagName !== "#text";
              }).forEach(u);
            };
          s.forEach(u), A(this.svgElement, "afterModifyTree", {
            nodes: s
          });
        }, h.prototype.truncate = function (s, l, u, v, M, I) {
          var L = this.svgElement,
            C = L.renderer,
            m = L.rotation,
            d = [],
            o = u ? 1 : 0,
            n = (l || u || "").length,
            r = n,
            i,
            t = function t(a, c) {
              c = c || a;
              var y = s.parentNode;
              if (y && typeof d[c] > "u") if (y.getSubStringLength) try {
                d[c] = v + y.getSubStringLength(0, u ? c + 1 : c);
              } catch (_unused3) {} else C.getSpanWidth && (s.textContent = I(l || u, a), d[c] = v + C.getSpanWidth(L, s));
              return d[c];
            };
          L.rotation = 0;
          var e = t(s.textContent.length);
          if (v + e > M) {
            for (; o <= n;) r = Math.ceil((o + n) / 2), u && (i = I(u, r)), e = t(r, i && i.length - 1), o === n ? o = n + 1 : e > M ? n = r - 1 : o = r;
            n === 0 ? s.textContent = "" : l && n === l.length - 1 || (s.textContent = i || I(l || u, r));
          }
          u && u.splice(0, r), L.actualWidth = e, L.rotation = m;
        }, h.prototype.unescapeEntities = function (s, l) {
          return g(this.renderer.escapes, function (u, v) {
            l && l.indexOf(u) !== -1 || (s = s.toString().replace(new RegExp(u, "g"), v));
          }), s;
        }, h;
      }();
    }), V(S, "Core/Renderer/SVG/SVGRenderer.js", [S["Core/Renderer/HTML/AST.js"], S["Core/Color/Color.js"], S["Core/Globals.js"], S["Core/Renderer/RendererRegistry.js"], S["Core/Renderer/SVG/SVGElement.js"], S["Core/Renderer/SVG/SVGLabel.js"], S["Core/Renderer/SVG/Symbols.js"], S["Core/Renderer/SVG/TextBuilder.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z, w, A) {
      var k = B.charts,
        g = B.deg2rad,
        p = B.doc,
        h = B.isFirefox,
        s = B.isMS,
        l = B.isWebKit,
        u = B.noop,
        v = B.SVG_NS,
        M = B.symbolSizes,
        I = B.win,
        L = A.addEvent,
        C = A.attr,
        m = A.createElement,
        d = A.css,
        o = A.defined,
        n = A.destroyObjectProperties,
        r = A.extend,
        i = A.isArray,
        t = A.isNumber,
        e = A.isObject,
        a = A.isString,
        c = A.merge,
        y = A.pick,
        b = A.pInt,
        j = A.uniqueKey,
        P;
      return B = function () {
        function f(x, N, R, F, T, G, _) {
          this.width = this.url = this.style = this.isSVG = this.imgCount = this.height = this.gradients = this.globalAnimation = this.defs = this.chartIndex = this.cacheKeys = this.cache = this.boxWrapper = this.box = this.alignedObjects = void 0, this.init(x, N, R, F, T, G, _);
        }
        return f.prototype.init = function (x, N, R, F, T, G, _) {
          var q = this.createElement("svg").attr({
              version: "1.1",
              class: "highcharts-root"
            }),
            Y = q.element;
          _ || q.css(this.getStyle(F)), x.appendChild(Y), C(x, "dir", "ltr"), x.innerHTML.indexOf("xmlns") === -1 && C(Y, "xmlns", this.SVG_NS), this.isSVG = !0, this.box = Y, this.boxWrapper = q, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 10.3.3")), this.defs = this.createElement("defs").add(), this.allowHTML = G, this.forExport = T, this.styledMode = _, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.setSize(N, R, !1);
          var U;
          h && x.getBoundingClientRect && (N = function N() {
            d(x, {
              left: 0,
              top: 0
            }), U = x.getBoundingClientRect(), d(x, {
              left: Math.ceil(U.left) - U.left + "px",
              top: Math.ceil(U.top) - U.top + "px"
            });
          }, N(), this.unSubPixelFix = L(I, "resize", N));
        }, f.prototype.definition = function (x) {
          return new D([x]).addToDOM(this.defs.element);
        }, f.prototype.getReferenceURL = function () {
          if ((h || l) && p.getElementsByTagName("base").length) {
            if (!o(P)) {
              var x = j();
              x = new D([{
                tagName: "svg",
                attributes: {
                  width: 8,
                  height: 8
                },
                children: [{
                  tagName: "defs",
                  children: [{
                    tagName: "clipPath",
                    attributes: {
                      id: x
                    },
                    children: [{
                      tagName: "rect",
                      attributes: {
                        width: 4,
                        height: 4
                      }
                    }]
                  }]
                }, {
                  tagName: "rect",
                  attributes: {
                    id: "hitme",
                    width: 8,
                    height: 8,
                    "clip-path": "url(#".concat(x, ")"),
                    fill: "rgba(0,0,0,0.001)"
                  }
                }]
              }]).addToDOM(p.body), d(x, {
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 9e5
              });
              var N = p.elementFromPoint(6, 6);
              P = (N && N.id) === "hitme", p.body.removeChild(x);
            }
            if (P) return I.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20");
          }
          return "";
        }, f.prototype.getStyle = function (x) {
          return this.style = r({
            fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
            fontSize: "12px"
          }, x);
        }, f.prototype.setStyle = function (x) {
          this.boxWrapper.css(this.getStyle(x));
        }, f.prototype.isHidden = function () {
          return !this.boxWrapper.getBBox().width;
        }, f.prototype.destroy = function () {
          var x = this.defs;
          return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), n(this.gradients || {}), this.gradients = null, x && (this.defs = x.destroy()), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null;
        }, f.prototype.createElement = function (x) {
          var N = new this.Element();
          return N.init(this, x), N;
        }, f.prototype.getRadialAttr = function (x, N) {
          return {
            cx: x[0] - x[2] / 2 + (N.cx || 0) * x[2],
            cy: x[1] - x[2] / 2 + (N.cy || 0) * x[2],
            r: (N.r || 0) * x[2]
          };
        }, f.prototype.buildText = function (x) {
          new w(x).buildSVG();
        }, f.prototype.getContrast = function (x) {
          return x = E.parse(x).rgba.map(function (N) {
            return N /= 255, 0.03928 >= N ? N / 12.92 : Math.pow((N + 0.055) / 1.055, 2.4);
          }), x = 0.2126 * x[0] + 0.7152 * x[1] + 0.0722 * x[2], 1.05 / (x + 0.05) > (x + 0.05) / 0.05 ? "#FFFFFF" : "#000000";
        }, f.prototype.button = function (x, N, R, F, T, G, _, q, Y, U) {
          T === void 0 && (T = {});
          var Z = this.label(x, N, R, Y, void 0, void 0, U, void 0, "button"),
            J = this.styledMode;
          x = T.states || {};
          var et = 0;
          T = c(T), delete T.states;
          var nt = c({
            color: "#333333",
            cursor: "pointer",
            fontWeight: "normal"
          }, T.style);
          delete T.style;
          var lt = D.filterUserAttributes(T);
          if (Z.attr(c({
            padding: 8,
            r: 2
          }, lt)), !J) {
            lt = c({
              fill: "#f7f7f7",
              stroke: "#cccccc",
              "stroke-width": 1
            }, lt), G = c(lt, {
              fill: "#e6e6e6"
            }, D.filterUserAttributes(G || x.hover || {}));
            var ct = G.style;
            delete G.style, _ = c(lt, {
              fill: "#e6ebf5",
              style: {
                color: "#000000",
                fontWeight: "bold"
              }
            }, D.filterUserAttributes(_ || x.select || {}));
            var tt = _.style;
            delete _.style, q = c(lt, {
              style: {
                color: "#cccccc"
              }
            }, D.filterUserAttributes(q || x.disabled || {}));
            var st = q.style;
            delete q.style;
          }
          return L(Z.element, s ? "mouseover" : "mouseenter", function () {
            et !== 3 && Z.setState(1);
          }), L(Z.element, s ? "mouseout" : "mouseleave", function () {
            et !== 3 && Z.setState(et);
          }), Z.setState = function (it) {
            it !== 1 && (Z.state = et = it), Z.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][it || 0]), J || (Z.attr([lt, G, _, q][it || 0]), it = [nt, ct, tt, st][it || 0], e(it) && Z.css(it));
          }, J || (Z.attr(lt).css(r({
            cursor: "default"
          }, nt)), U && Z.text.css({
            pointerEvents: "none"
          })), Z.on("touchstart", function (it) {
            return it.stopPropagation();
          }).on("click", function (it) {
            et !== 3 && F.call(Z, it);
          });
        }, f.prototype.crispLine = function (x, N, R) {
          R === void 0 && (R = "round");
          var F = x[0],
            T = x[1];
          return o(F[1]) && F[1] === T[1] && (F[1] = T[1] = Math[R](F[1]) - N % 2 / 2), o(F[2]) && F[2] === T[2] && (F[2] = T[2] = Math[R](F[2]) + N % 2 / 2), x;
        }, f.prototype.path = function (x) {
          var N = this.styledMode ? {} : {
            fill: "none"
          };
          return i(x) ? N.d = x : e(x) && r(N, x), this.createElement("path").attr(N);
        }, f.prototype.circle = function (x, N, R) {
          return x = e(x) ? x : typeof x > "u" ? {} : {
            x: x,
            y: N,
            r: R
          }, N = this.createElement("circle"), N.xSetter = N.ySetter = function (F, T, G) {
            G.setAttribute("c" + T, F);
          }, N.attr(x);
        }, f.prototype.arc = function (x, N, R, F, T, G) {
          return e(x) ? (F = x, N = F.y, R = F.r, x = F.x) : F = {
            innerR: F,
            start: T,
            end: G
          }, x = this.symbol("arc", x, N, R, R, F), x.r = R, x;
        }, f.prototype.rect = function (x, N, R, F, T, G) {
          T = e(x) ? x.r : T;
          var _ = this.createElement("rect");
          return x = e(x) ? x : typeof x > "u" ? {} : {
            x: x,
            y: N,
            width: Math.max(R, 0),
            height: Math.max(F, 0)
          }, this.styledMode || (typeof G < "u" && (x["stroke-width"] = G, x = _.crisp(x)), x.fill = "none"), T && (x.r = T), _.rSetter = function (q, Y, U) {
            _.r = q, C(U, {
              rx: q,
              ry: q
            });
          }, _.rGetter = function () {
            return _.r || 0;
          }, _.attr(x);
        }, f.prototype.setSize = function (x, N, R) {
          this.width = x, this.height = N, this.boxWrapper.animate({
            width: x,
            height: N
          }, {
            step: function step() {
              this.attr({
                viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
              });
            },
            duration: y(R, !0) ? void 0 : 0
          }), this.alignElements();
        }, f.prototype.g = function (x) {
          var N = this.createElement("g");
          return x ? N.attr({
            class: "highcharts-" + x
          }) : N;
        }, f.prototype.image = function (x, N, R, F, T, G) {
          var _ = {
              preserveAspectRatio: "none"
            },
            q = function q(U, Z) {
              U.setAttributeNS ? U.setAttributeNS("http://www.w3.org/1999/xlink", "href", Z) : U.setAttribute("hc-svg-href", Z);
            };
          t(N) && (_.x = N), t(R) && (_.y = R), t(F) && (_.width = F), t(T) && (_.height = T);
          var Y = this.createElement("image").attr(_);
          return N = function N(U) {
            q(Y.element, x), G.call(Y, U);
          }, G ? (q(Y.element, "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="), R = new I.Image(), L(R, "load", N), R.src = x, R.complete && N({})) : q(Y.element, x), Y;
        }, f.prototype.symbol = function (x, N, R, F, T, G) {
          var _ = this,
            q = /^url\((.*?)\)$/,
            Y = q.test(x),
            U = !Y && (this.symbols[x] ? x : "circle"),
            Z = U && this.symbols[U],
            J;
          if (Z) {
            typeof N == "number" && (J = Z.call(this.symbols, Math.round(N || 0), Math.round(R || 0), F || 0, T || 0, G));
            var et = this.path(J);
            _.styledMode || et.attr("fill", "none"), r(et, {
              symbolName: U || void 0,
              x: N,
              y: R,
              width: F,
              height: T
            }), G && r(et, G);
          } else if (Y) {
            var nt = x.match(q)[1],
              lt = et = this.image(nt);
            lt.imgwidth = y(M[nt] && M[nt].width, G && G.width), lt.imgheight = y(M[nt] && M[nt].height, G && G.height);
            var ct = function ct(tt) {
              return tt.attr({
                width: tt.width,
                height: tt.height
              });
            };
            ["width", "height"].forEach(function (tt) {
              lt[tt + "Setter"] = function (st, it) {
                this[it] = st, st = this.alignByTranslate;
                var $ = this.element,
                  Q = this.width,
                  ot = this.height,
                  at = this.imgwidth,
                  rt = this.imgheight,
                  ht = this["img" + it];
                if (o(ht)) {
                  var pt = 1;
                  G && G.backgroundSize === "within" && Q && ot ? (pt = Math.min(Q / at, ot / rt), ht = Math.round(ht * pt), C($, {
                    width: Math.round(at * pt),
                    height: Math.round(rt * pt)
                  })) : $ && $.setAttribute(it, ht), st || this.translate(((Q || 0) - ht * pt) / 2, ((ot || 0) - ht * pt) / 2);
                }
              };
            }), o(N) && lt.attr({
              x: N,
              y: R
            }), lt.isImg = !0, o(lt.imgwidth) && o(lt.imgheight) ? ct(lt) : (lt.attr({
              width: 0,
              height: 0
            }), m("img", {
              onload: function onload() {
                var tt = k[_.chartIndex];
                this.width === 0 && (d(this, {
                  position: "absolute",
                  top: "-999em"
                }), p.body.appendChild(this)), M[nt] = {
                  width: this.width,
                  height: this.height
                }, lt.imgwidth = this.width, lt.imgheight = this.height, lt.element && ct(lt), this.parentNode && this.parentNode.removeChild(this), _.imgCount--, !_.imgCount && tt && !tt.hasLoaded && tt.onload();
              },
              src: nt
            }), this.imgCount++);
          }
          return et;
        }, f.prototype.clipRect = function (x, N, R, F) {
          var T = j() + "-",
            G = this.createElement("clipPath").attr({
              id: T
            }).add(this.defs);
          return x = this.rect(x, N, R, F, 0).add(G), x.id = T, x.clipPath = G, x.count = 0, x;
        }, f.prototype.text = function (x, N, R, F) {
          var T = {};
          return F && (this.allowHTML || !this.forExport) ? this.html(x, N, R) : (T.x = Math.round(N || 0), R && (T.y = Math.round(R)), o(x) && (T.text = x), x = this.createElement("text").attr(T), (!F || this.forExport && !this.allowHTML) && (x.xSetter = function (G, _, q) {
            for (var Y = q.getElementsByTagName("tspan"), U = q.getAttribute(_), Z = 0, J; Z < Y.length; Z++) J = Y[Z], J.getAttribute(_) === U && J.setAttribute(_, G);
            q.setAttribute(_, G);
          }), x);
        }, f.prototype.fontMetrics = function (x, N) {
          return x = !this.styledMode && /px/.test(x) || !I.getComputedStyle ? x || N && N.style && N.style.fontSize || this.style && this.style.fontSize : N && X.prototype.getStyle.call(N, "font-size"), x = /px/.test(x) ? b(x) : 12, N = 24 > x ? x + 3 : Math.round(1.2 * x), {
            h: N,
            b: Math.round(0.8 * N),
            f: x
          };
        }, f.prototype.rotCorr = function (x, N, R) {
          var F = x;
          return N && R && (F = Math.max(F * Math.cos(N * g), 4)), {
            x: -x / 3 * Math.sin(N * g),
            y: F
          };
        }, f.prototype.pathToSegments = function (x) {
          for (var N = [], R = [], F = {
              A: 8,
              C: 7,
              H: 2,
              L: 3,
              M: 3,
              Q: 5,
              S: 5,
              T: 3,
              V: 2
            }, T = 0; T < x.length; T++) a(R[0]) && t(x[T]) && R.length === F[R[0].toUpperCase()] && x.splice(T, 0, R[0].replace("M", "L").replace("m", "l")), typeof x[T] == "string" && (R.length && N.push(R.slice(0)), R.length = 0), R.push(x[T]);
          return N.push(R.slice(0)), N;
        }, f.prototype.label = function (x, N, R, F, T, G, _, q, Y) {
          return new W(this, x, N, R, F, T, G, _, q, Y);
        }, f.prototype.alignElements = function () {
          this.alignedObjects.forEach(function (x) {
            return x.align();
          });
        }, f;
      }(), r(B.prototype, {
        Element: X,
        SVG_NS: v,
        escapes: {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          "'": "&#39;",
          '"': "&quot;"
        },
        symbols: z,
        draw: u
      }), H.registerRendererType("svg", B, !0), B;
    }), V(S, "Core/Renderer/HTML/HTMLElement.js", [S["Core/Globals.js"], S["Core/Renderer/SVG/SVGElement.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = this && this.__extends || function () {
          var _s3 = function s(l, u) {
            return _s3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (v, M) {
              v.__proto__ = M;
            } || function (v, M) {
              for (var I in M) M.hasOwnProperty(I) && (v[I] = M[I]);
            }, _s3(l, u);
          };
          return function (l, u) {
            function v() {
              this.constructor = l;
            }
            _s3(l, u), l.prototype = u === null ? Object.create(u) : (v.prototype = u.prototype, new v());
          };
        }(),
        X = D.isFirefox,
        W = D.isMS,
        z = D.isWebKit,
        w = D.win,
        A = B.css,
        k = B.defined,
        g = B.extend,
        p = B.pick,
        h = B.pInt;
      return function (s) {
        function l() {
          return s !== null && s.apply(this, arguments) || this;
        }
        return H(l, s), l.compose = function (u) {
          if (l.composedClasses.indexOf(u) === -1) {
            l.composedClasses.push(u);
            var v = l.prototype,
              M = u.prototype;
            M.getSpanCorrection = v.getSpanCorrection, M.htmlCss = v.htmlCss, M.htmlGetBBox = v.htmlGetBBox, M.htmlUpdateTransform = v.htmlUpdateTransform, M.setSpanRotation = v.setSpanRotation;
          }
          return u;
        }, l.prototype.getSpanCorrection = function (u, v, M) {
          this.xCorr = -u * M, this.yCorr = -v;
        }, l.prototype.htmlCss = function (u) {
          var v = this.element.tagName === "SPAN" && u && "width" in u,
            M = p(v && u.width, void 0);
          if (v) {
            delete u.width, this.textWidth = M;
            var I = !0;
          }
          return u && u.textOverflow === "ellipsis" && (u.whiteSpace = "nowrap", u.overflow = "hidden"), this.styles = g(this.styles, u), A(this.element, u), I && this.htmlUpdateTransform(), this;
        }, l.prototype.htmlGetBBox = function () {
          var u = this.element;
          return {
            x: u.offsetLeft,
            y: u.offsetTop,
            width: u.offsetWidth,
            height: u.offsetHeight
          };
        }, l.prototype.htmlUpdateTransform = function () {
          if (this.added) {
            var u = this.renderer,
              v = this.element,
              M = this.translateX || 0,
              I = this.translateY || 0,
              L = this.x || 0,
              C = this.y || 0,
              m = this.textAlign || "left",
              d = {
                left: 0,
                center: 0.5,
                right: 1
              }[m],
              o = this.styles;
            if (o = o && o.whiteSpace, A(v, {
              marginLeft: M,
              marginTop: I
            }), !u.styledMode && this.shadows && this.shadows.forEach(function (a) {
              A(a, {
                marginLeft: M + 1,
                marginTop: I + 1
              });
            }), this.inverted && [].forEach.call(v.childNodes, function (a) {
              u.invertChild(a, v);
            }), v.tagName === "SPAN") {
              var n = this.rotation,
                r = this.textWidth && h(this.textWidth),
                i = [n, m, v.innerHTML, this.textWidth, this.textAlign].join(),
                t = void 0;
              if (t = !1, r !== this.oldTextWidth) {
                if (this.textPxLength) var e = this.textPxLength;else A(v, {
                  width: "",
                  whiteSpace: o || "nowrap"
                }), e = v.offsetWidth;
                (r > this.oldTextWidth || e > r) && (/[ \-]/.test(v.textContent || v.innerText) || v.style.textOverflow === "ellipsis") && (A(v, {
                  width: e > r || n ? r + "px" : "auto",
                  display: "block",
                  whiteSpace: o || "normal"
                }), this.oldTextWidth = r, t = !0);
              }
              this.hasBoxWidthChanged = t, i !== this.cTT && (t = u.fontMetrics(v.style.fontSize, v).b, !k(n) || n === (this.oldRotation || 0) && m === this.oldAlign || this.setSpanRotation(n, d, t), this.getSpanCorrection(!k(n) && this.textPxLength || v.offsetWidth, t, d, n, m)), A(v, {
                left: L + (this.xCorr || 0) + "px",
                top: C + (this.yCorr || 0) + "px"
              }), this.cTT = i, this.oldRotation = n, this.oldAlign = m;
            }
          } else this.alignOnAdd = !0;
        }, l.prototype.setSpanRotation = function (u, v, M) {
          var I = {},
            L = W && !/Edge/.test(w.navigator.userAgent) ? "-ms-transform" : z ? "-webkit-transform" : X ? "MozTransform" : w.opera ? "-o-transform" : void 0;
          L && (I[L] = I.transform = "rotate(" + u + "deg)", I[L + (X ? "Origin" : "-origin")] = I.transformOrigin = 100 * v + "% " + M + "px", A(this.element, I));
        }, l.composedClasses = [], l;
      }(E);
    }), V(S, "Core/Renderer/HTML/HTMLRenderer.js", [S["Core/Renderer/HTML/AST.js"], S["Core/Renderer/SVG/SVGElement.js"], S["Core/Renderer/SVG/SVGRenderer.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = this && this.__extends || function () {
          var _k4 = function k(g, p) {
            return _k4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k4(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k4(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        W = H.attr,
        z = H.createElement,
        w = H.extend,
        A = H.pick;
      return function (k) {
        function g() {
          return k !== null && k.apply(this, arguments) || this;
        }
        return X(g, k), g.compose = function (p) {
          return g.composedClasses.indexOf(p) === -1 && (g.composedClasses.push(p), p.prototype.html = g.prototype.html), p;
        }, g.prototype.html = function (p, h, s) {
          var l = this.createElement("span"),
            u = l.element,
            v = l.renderer,
            M = v.isSVG,
            I = function I(L, C) {
              ["opacity", "visibility"].forEach(function (m) {
                L[m + "Setter"] = function (d, o, n) {
                  var r = L.div ? L.div.style : C;
                  E.prototype[m + "Setter"].call(this, d, o, n), r && (r[o] = d);
                };
              }), L.addedSetters = !0;
            };
          return l.textSetter = function (L) {
            L !== this.textStr && (delete this.bBox, delete this.oldTextWidth, D.setElementHTML(this.element, A(L, "")), this.textStr = L, l.doTransform = !0);
          }, M && I(l, l.element.style), l.xSetter = l.ySetter = l.alignSetter = l.rotationSetter = function (L, C) {
            C === "align" ? l.alignValue = l.textAlign = L : l[C] = L, l.doTransform = !0;
          }, l.afterSetters = function () {
            this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
          }, l.attr({
            text: p,
            x: Math.round(h),
            y: Math.round(s)
          }).css({
            position: "absolute"
          }), v.styledMode || l.css({
            fontFamily: this.style.fontFamily,
            fontSize: this.style.fontSize
          }), u.style.whiteSpace = "nowrap", l.css = l.htmlCss, M && (l.add = function (L) {
            var C = v.box.parentNode,
              m = [];
            if (this.parentGroup = L) {
              var d = L.div;
              if (!d) {
                for (; L;) m.push(L), L = L.parentGroup;
                m.reverse().forEach(function (o) {
                  function n(e, a) {
                    o[a] = e, a === "translateX" ? t.left = e + "px" : t.top = e + "px", o.doTransform = !0;
                  }
                  var r = W(o.element, "class"),
                    i = o.styles || {};
                  d = o.div = o.div || z("div", r ? {
                    className: r
                  } : void 0, {
                    position: "absolute",
                    left: (o.translateX || 0) + "px",
                    top: (o.translateY || 0) + "px",
                    display: o.display,
                    opacity: o.opacity,
                    cursor: i.cursor,
                    pointerEvents: i.pointerEvents,
                    visibility: o.visibility
                  }, d || C);
                  var t = d.style;
                  w(o, {
                    classSetter: function (e) {
                      return function (a) {
                        this.element.setAttribute("class", a), e.className = a;
                      };
                    }(d),
                    on: function on() {
                      return m[0].div && l.on.apply({
                        element: m[0].div,
                        onEvents: o.onEvents
                      }, arguments), o;
                    },
                    translateXSetter: n,
                    translateYSetter: n
                  }), o.addedSetters || I(o);
                });
              }
            } else d = C;
            return d.appendChild(u), l.added = !0, l.alignOnAdd && l.htmlUpdateTransform(), l;
          }), l;
        }, g.composedClasses = [], g;
      }(B);
    }), V(S, "Core/Axis/AxisDefaults.js", [], function () {
      var D;
      return function (E) {
        E.defaultXAxisOptions = {
          alignTicks: !0,
          allowDecimals: void 0,
          panningEnabled: !0,
          zIndex: 2,
          zoomEnabled: !0,
          dateTimeLabelFormats: {
            millisecond: {
              main: "%H:%M:%S.%L",
              range: !1
            },
            second: {
              main: "%H:%M:%S",
              range: !1
            },
            minute: {
              main: "%H:%M",
              range: !1
            },
            hour: {
              main: "%H:%M",
              range: !1
            },
            day: {
              main: "%e. %b"
            },
            week: {
              main: "%e. %b"
            },
            month: {
              main: "%b '%y"
            },
            year: {
              main: "%Y"
            }
          },
          endOnTick: !1,
          gridLineDashStyle: "Solid",
          gridZIndex: 1,
          labels: {
            autoRotation: void 0,
            autoRotationLimit: 80,
            distance: void 0,
            enabled: !0,
            indentation: 10,
            overflow: "justify",
            padding: 5,
            reserveSpace: void 0,
            rotation: void 0,
            staggerLines: 0,
            step: 0,
            useHTML: !1,
            x: 0,
            zIndex: 7,
            style: {
              color: "#666666",
              cursor: "default",
              fontSize: "11px"
            }
          },
          maxPadding: 0.01,
          minorGridLineDashStyle: "Solid",
          minorTickLength: 2,
          minorTickPosition: "outside",
          minPadding: 0.01,
          offset: void 0,
          opposite: !1,
          reversed: void 0,
          reversedStacks: !1,
          showEmpty: !0,
          showFirstLabel: !0,
          showLastLabel: !0,
          startOfWeek: 1,
          startOnTick: !1,
          tickLength: 10,
          tickPixelInterval: 100,
          tickmarkPlacement: "between",
          tickPosition: "outside",
          title: {
            align: "middle",
            rotation: 0,
            useHTML: !1,
            x: 0,
            y: 0,
            style: {
              color: "#666666"
            }
          },
          type: "linear",
          uniqueNames: !0,
          visible: !0,
          minorGridLineColor: "#f2f2f2",
          minorGridLineWidth: 1,
          minorTickColor: "#999999",
          lineColor: "#ccd6eb",
          lineWidth: 1,
          gridLineColor: "#e6e6e6",
          gridLineWidth: void 0,
          tickColor: "#ccd6eb"
        }, E.defaultYAxisOptions = {
          reversedStacks: !0,
          endOnTick: !0,
          maxPadding: 0.05,
          minPadding: 0.05,
          tickPixelInterval: 72,
          showLastLabel: !0,
          labels: {
            x: -8
          },
          startOnTick: !0,
          title: {
            rotation: 270,
            text: "Values"
          },
          stackLabels: {
            animation: {},
            allowOverlap: !1,
            enabled: !1,
            crop: !0,
            overflow: "justify",
            formatter: function formatter() {
              var B = this.axis.chart.numberFormatter;
              return B(this.total || 0, -1);
            },
            style: {
              color: "#000000",
              fontSize: "11px",
              fontWeight: "bold",
              textOutline: "1px contrast"
            }
          },
          gridLineWidth: 1,
          lineWidth: 0
        }, E.defaultLeftAxisOptions = {
          labels: {
            x: -15
          },
          title: {
            rotation: 270
          }
        }, E.defaultRightAxisOptions = {
          labels: {
            x: 15
          },
          title: {
            rotation: 90
          }
        }, E.defaultBottomAxisOptions = {
          labels: {
            autoRotation: [-45],
            x: 0
          },
          margin: 15,
          title: {
            rotation: 0
          }
        }, E.defaultTopAxisOptions = {
          labels: {
            autoRotation: [-45],
            x: 0
          },
          margin: 15,
          title: {
            rotation: 0
          }
        };
      }(D || (D = {})), D;
    }), V(S, "Core/Foundation.js", [S["Core/Utilities.js"]], function (D) {
      var E = D.addEvent,
        B = D.isFunction,
        H = D.objectEach,
        X = D.removeEvent,
        W;
      return function (z) {
        z.registerEventOptions = function (w, A) {
          w.eventOptions = w.eventOptions || {}, H(A.events, function (k, g) {
            w.eventOptions[g] !== k && (w.eventOptions[g] && (X(w, g, w.eventOptions[g]), delete w.eventOptions[g]), B(k) && (w.eventOptions[g] = k, E(w, g, k)));
          });
        };
      }(W || (W = {})), W;
    }), V(S, "Core/Axis/Tick.js", [S["Core/FormatUtilities.js"], S["Core/Globals.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = E.deg2rad,
        X = B.clamp,
        W = B.correctFloat,
        z = B.defined,
        w = B.destroyObjectProperties,
        A = B.extend,
        k = B.fireEvent,
        g = B.isNumber,
        p = B.merge,
        h = B.objectEach,
        s = B.pick;
      return E = function () {
        function l(u, v, M, I, L) {
          this.isNewLabel = this.isNew = !0, this.axis = u, this.pos = v, this.type = M || "", this.parameters = L || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, k(this, "init"), M || I || this.addLabel();
        }
        return l.prototype.addLabel = function () {
          var u = this,
            v = u.axis,
            M = v.options,
            I = v.chart,
            L = v.categories,
            C = v.logarithmic,
            m = v.names,
            d = u.pos,
            o = s(u.options && u.options.labels, M.labels),
            n = v.tickPositions,
            r = d === n[0],
            i = d === n[n.length - 1],
            t = (!o.step || o.step === 1) && v.tickInterval === 1;
          n = n.info;
          var e = u.label,
            a;
          if (L = this.parameters.category || (L ? s(L[d], m[d], d) : d), C && g(L) && (L = W(C.lin2log(L))), v.dateTime) if (n) var c = I.time.resolveDTLFormat(M.dateTimeLabelFormats[!M.grid && n.higherRanks[d] || n.unitName]),
            y = c.main;else g(L) && (y = v.dateTime.getXDateFormat(L, M.dateTimeLabelFormats || {}));
          u.isFirst = r, u.isLast = i;
          var b = {
            axis: v,
            chart: I,
            dateTimeLabelFormat: y,
            isFirst: r,
            isLast: i,
            pos: d,
            tick: u,
            tickPositionInfo: n,
            value: L
          };
          k(this, "labelFormat", b);
          var j = function j(f) {
            return o.formatter ? o.formatter.call(f, f) : o.format ? (f.text = v.defaultLabelFormatter.call(f, f), D.format(o.format, f, I)) : v.defaultLabelFormatter.call(f, f);
          };
          M = j.call(b, b);
          var P = c && c.list;
          u.shortenLabel = P ? function () {
            for (a = 0; a < P.length; a++) if (A(b, {
              dateTimeLabelFormat: P[a]
            }), e.attr({
              text: j.call(b, b)
            }), e.getBBox().width < v.getSlotWidth(u) - 2 * o.padding) return;
            e.attr({
              text: ""
            });
          } : void 0, t && v._addedPlotLB && u.moveLabel(M, o), z(e) || u.movedLabel ? e && e.textStr !== M && !t && (!e.textWidth || o.style.width || e.styles.width || e.css({
            width: null
          }), e.attr({
            text: M
          }), e.textPxLength = e.getBBox().width) : (u.label = e = u.createLabel({
            x: 0,
            y: 0
          }, M, o), u.rotation = 0);
        }, l.prototype.createLabel = function (u, v, M) {
          var I = this.axis,
            L = I.chart;
          return (u = z(v) && M.enabled ? L.renderer.text(v, u.x, u.y, M.useHTML).add(I.labelGroup) : null) && (L.styledMode || u.css(p(M.style)), u.textPxLength = u.getBBox().width), u;
        }, l.prototype.destroy = function () {
          w(this, this.axis);
        }, l.prototype.getPosition = function (u, v, M, I) {
          var L = this.axis,
            C = L.chart,
            m = I && C.oldChartHeight || C.chartHeight;
          return u = {
            x: u ? W(L.translate(v + M, void 0, void 0, I) + L.transB) : L.left + L.offset + (L.opposite ? (I && C.oldChartWidth || C.chartWidth) - L.right - L.left : 0),
            y: u ? m - L.bottom + L.offset - (L.opposite ? L.height : 0) : W(m - L.translate(v + M, void 0, void 0, I) - L.transB)
          }, u.y = X(u.y, -1e5, 1e5), k(this, "afterGetPosition", {
            pos: u
          }), u;
        }, l.prototype.getLabelPosition = function (u, v, M, I, L, C, m, d) {
          var o = this.axis,
            n = o.transA,
            r = o.isLinked && o.linkedParent ? o.linkedParent.reversed : o.reversed,
            i = o.staggerLines,
            t = o.tickRotCorr || {
              x: 0,
              y: 0
            },
            e = I || o.reserveSpaceDefault ? 0 : -o.labelOffset * (o.labelAlign === "center" ? 0.5 : 1),
            a = {};
          return M = o.side === 0 ? M.rotation ? -8 : -M.getBBox().height : o.side === 2 ? t.y + 8 : Math.cos(M.rotation * H) * (t.y - M.getBBox(!1, 0).height / 2), z(L.y) && (M = o.side === 0 && o.horiz ? L.y + M : L.y), u = u + L.x + e + t.x - (C && I ? C * n * (r ? -1 : 1) : 0), v = v + M - (C && !I ? C * n * (r ? 1 : -1) : 0), i && (I = m / (d || 1) % i, o.opposite && (I = i - I - 1), v += o.labelOffset / i * I), a.x = u, a.y = Math.round(v), k(this, "afterGetLabelPosition", {
            pos: a,
            tickmarkOffset: C,
            index: m
          }), a;
        }, l.prototype.getLabelSize = function () {
          return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
        }, l.prototype.getMarkPath = function (u, v, M, I, L, C) {
          return C.crispLine([["M", u, v], ["L", u + (L ? 0 : -M), v + (L ? M : 0)]], I);
        }, l.prototype.handleOverflow = function (u) {
          var v = this.axis,
            M = v.options.labels,
            I = u.x,
            L = v.chart.chartWidth,
            C = v.chart.spacing,
            m = s(v.labelLeft, Math.min(v.pos, C[3]));
          C = s(v.labelRight, Math.max(v.isRadial ? 0 : v.pos + v.len, L - C[1]));
          var d = this.label,
            o = this.rotation,
            n = {
              left: 0,
              center: 0.5,
              right: 1
            }[v.labelAlign || d.attr("align")],
            r = d.getBBox().width,
            i = v.getSlotWidth(this),
            t = {},
            e = i,
            a = 1,
            c;
          o || M.overflow !== "justify" ? 0 > o && I - n * r < m ? c = Math.round(I / Math.cos(o * H) - m) : 0 < o && I + n * r > C && (c = Math.round((L - I) / Math.cos(o * H))) : (L = I + (1 - n) * r, I - n * r < m ? e = u.x + e * (1 - n) - m : L > C && (e = C - u.x + e * n, a = -1), e = Math.min(i, e), e < i && v.labelAlign === "center" && (u.x += a * (i - e - n * (i - Math.min(r, e)))), (r > e || v.autoRotation && (d.styles || {}).width) && (c = e)), c && (this.shortenLabel ? this.shortenLabel() : (t.width = Math.floor(c) + "px", (M.style || {}).textOverflow || (t.textOverflow = "ellipsis"), d.css(t)));
        }, l.prototype.moveLabel = function (u, v) {
          var M = this,
            I = M.label,
            L = M.axis,
            C = L.reversed,
            m = !1;
          if (I && I.textStr === u ? (M.movedLabel = I, m = !0, delete M.label) : h(L.ticks, function (o) {
            m || o.isNew || o === M || !o.label || o.label.textStr !== u || (M.movedLabel = o.label, m = !0, o.labelPos = M.movedLabel.xy, delete o.label);
          }), !m && (M.labelPos || I)) {
            var d = M.labelPos || I.xy;
            I = L.horiz ? C ? 0 : L.width + L.left : d.x, L = L.horiz ? d.y : C ? L.width + L.left : 0, M.movedLabel = M.createLabel({
              x: I,
              y: L
            }, u, v), M.movedLabel && M.movedLabel.attr({
              opacity: 0
            });
          }
        }, l.prototype.render = function (u, v, M) {
          var I = this.axis,
            L = I.horiz,
            C = this.pos,
            m = s(this.tickmarkOffset, I.tickmarkOffset);
          C = this.getPosition(L, C, m, v), m = C.x;
          var d = C.y;
          I = L && m === I.pos + I.len || !L && d === I.pos ? -1 : 1, L = s(M, this.label && this.label.newOpacity, 1), M = s(M, 1), this.isActive = !0, this.renderGridLine(v, M, I), this.renderMark(C, M, I), this.renderLabel(C, v, L, u), this.isNew = !1, k(this, "afterRender");
        }, l.prototype.renderGridLine = function (u, v, M) {
          var I = this.axis,
            L = I.options,
            C = {},
            m = this.pos,
            d = this.type,
            o = s(this.tickmarkOffset, I.tickmarkOffset),
            n = I.chart.renderer,
            r = this.gridLine,
            i = L.gridLineWidth,
            t = L.gridLineColor,
            e = L.gridLineDashStyle;
          this.type === "minor" && (i = L.minorGridLineWidth, t = L.minorGridLineColor, e = L.minorGridLineDashStyle), r || (I.chart.styledMode || (C.stroke = t, C["stroke-width"] = i || 0, C.dashstyle = e), d || (C.zIndex = 1), u && (v = 0), this.gridLine = r = n.path().attr(C).addClass("highcharts-" + (d ? d + "-" : "") + "grid-line").add(I.gridGroup)), r && (M = I.getPlotLinePath({
            value: m + o,
            lineWidth: r.strokeWidth() * M,
            force: "pass",
            old: u,
            acrossPanes: !1
          })) && r[u || this.isNew ? "attr" : "animate"]({
            d: M,
            opacity: v
          });
        }, l.prototype.renderMark = function (u, v, M) {
          var I = this.axis,
            L = I.options,
            C = I.chart.renderer,
            m = this.type,
            d = I.tickSize(m ? m + "Tick" : "tick"),
            o = u.x;
          u = u.y;
          var n = s(L[m !== "minor" ? "tickWidth" : "minorTickWidth"], !m && I.isXAxis ? 1 : 0);
          L = L[m !== "minor" ? "tickColor" : "minorTickColor"];
          var r = this.mark,
            i = !r;
          d && (I.opposite && (d[0] = -d[0]), r || (this.mark = r = C.path().addClass("highcharts-" + (m ? m + "-" : "") + "tick").add(I.axisGroup), I.chart.styledMode || r.attr({
            stroke: L,
            "stroke-width": n
          })), r[i ? "attr" : "animate"]({
            d: this.getMarkPath(o, u, d[0], r.strokeWidth() * M, I.horiz, C),
            opacity: v
          }));
        }, l.prototype.renderLabel = function (u, v, M, I) {
          var L = this.axis,
            C = L.horiz,
            m = L.options,
            d = this.label,
            o = m.labels,
            n = o.step;
          L = s(this.tickmarkOffset, L.tickmarkOffset);
          var r = u.x;
          u = u.y;
          var i = !0;
          d && g(r) && (d.xy = u = this.getLabelPosition(r, u, d, C, o, L, I, n), this.isFirst && !this.isLast && !m.showFirstLabel || this.isLast && !this.isFirst && !m.showLastLabel ? i = !1 : !C || o.step || o.rotation || v || M === 0 || this.handleOverflow(u), n && I % n && (i = !1), i && g(u.y) ? (u.opacity = M, d[this.isNewLabel ? "attr" : "animate"](u).show(!0), this.isNewLabel = !1) : (d.hide(), this.isNewLabel = !0));
        }, l.prototype.replaceMovedLabel = function () {
          var u = this.label,
            v = this.axis,
            M = v.reversed;
          if (u && !this.isNew) {
            var I = v.horiz ? M ? v.left : v.width + v.left : u.xy.x;
            M = v.horiz ? u.xy.y : M ? v.width + v.top : v.top, u.animate({
              x: I,
              y: M,
              opacity: 0
            }, void 0, u.destroy), delete this.label;
          }
          v.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
        }, l;
      }(), E;
    }), V(S, "Core/Axis/Axis.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/Axis/AxisDefaults.js"], S["Core/Color/Color.js"], S["Core/Defaults.js"], S["Core/Foundation.js"], S["Core/Globals.js"], S["Core/Axis/Tick.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z, w) {
      var A = D.animObject,
        k = H.defaultOptions,
        g = X.registerEventOptions,
        p = W.deg2rad,
        h = w.arrayMax,
        s = w.arrayMin,
        l = w.clamp,
        u = w.correctFloat,
        v = w.defined,
        M = w.destroyObjectProperties,
        I = w.erase,
        L = w.error,
        C = w.extend,
        m = w.fireEvent,
        d = w.isArray,
        o = w.isNumber,
        n = w.isString,
        r = w.merge,
        i = w.normalizeTickInterval,
        t = w.objectEach,
        e = w.pick,
        a = w.relativeLength,
        c = w.removeEvent,
        y = w.splat,
        b = w.syncTimeout,
        j = function j(P, f) {
          return i(f, void 0, void 0, e(P.options.allowDecimals, 0.5 > f || P.tickAmount !== void 0), !!P.tickAmount);
        };
      return D = function () {
        function P(f, x) {
          this.zoomEnabled = this.width = this.visible = this.userOptions = this.translationSlope = this.transB = this.transA = this.top = this.ticks = this.tickRotCorr = this.tickPositions = this.tickmarkOffset = this.tickInterval = this.tickAmount = this.side = this.series = this.right = this.positiveValuesOnly = this.pos = this.pointRangePadding = this.pointRange = this.plotLinesAndBandsGroups = this.plotLinesAndBands = this.paddedTicks = this.overlap = this.options = this.offset = this.names = this.minPixelPadding = this.minorTicks = this.minorTickInterval = this.min = this.maxLabelLength = this.max = this.len = this.left = this.labelFormatter = this.labelEdge = this.isLinked = this.height = this.hasVisibleSeries = this.hasNames = this.eventOptions = this.coll = this.closestPointRange = this.chart = this.bottom = this.alternateBands = void 0, this.init(f, x);
        }
        return P.prototype.init = function (f, x) {
          var N = x.isX;
          this.chart = f, this.horiz = f.inverted && !this.isZAxis ? !N : N, this.isXAxis = N, this.coll = this.coll || (N ? "xAxis" : "yAxis"), m(this, "init", {
            userOptions: x
          }), this.opposite = e(x.opposite, this.opposite), this.side = e(x.side, this.side, this.horiz ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(x);
          var R = this.options,
            F = R.labels,
            T = R.type;
          this.userOptions = x, this.minPixelPadding = 0, this.reversed = e(R.reversed, this.reversed), this.visible = R.visible, this.zoomEnabled = R.zoomEnabled, this.hasNames = T === "category" || R.categories === !0, this.categories = R.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = v(R.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len = 0, this.minRange = this.userMinRange = R.minRange || R.maxZoom, this.range = R.range, this.offset = R.offset || 0, this.min = this.max = null, x = e(R.crosshair, y(f.options.tooltip.crosshairs)[N ? 0 : 1]), this.crosshair = x === !0 ? {} : x, f.axes.indexOf(this) === -1 && (N ? f.axes.splice(f.xAxis.length, 0, this) : f.axes.push(this), f[this.coll].push(this)), this.series = this.series || [], f.inverted && !this.isZAxis && N && typeof this.reversed > "u" && (this.reversed = !0), this.labelRotation = o(F.rotation) ? F.rotation : void 0, g(this, R), m(this, "afterInit");
        }, P.prototype.setOptions = function (f) {
          this.options = r(E.defaultXAxisOptions, this.coll === "yAxis" && E.defaultYAxisOptions, [E.defaultTopAxisOptions, E.defaultRightAxisOptions, E.defaultBottomAxisOptions, E.defaultLeftAxisOptions][this.side], r(k[this.coll], f)), m(this, "afterSetOptions", {
            userOptions: f
          });
        }, P.prototype.defaultLabelFormatter = function (f) {
          var x = this.axis;
          f = this.chart.numberFormatter;
          var N = o(this.value) ? this.value : NaN,
            R = x.chart.time,
            F = this.dateTimeLabelFormat,
            T = k.lang,
            G = T.numericSymbols;
          T = T.numericSymbolMagnitude || 1e3;
          var _ = x.logarithmic ? Math.abs(N) : x.tickInterval,
            q = G && G.length;
          if (x.categories) var Y = "".concat(this.value);else if (F) Y = R.dateFormat(F, N);else if (q && 1e3 <= _) for (; q-- && typeof Y > "u";) x = Math.pow(T, q + 1), _ >= x && 10 * N % x === 0 && G[q] !== null && N !== 0 && (Y = f(N / x, -1) + G[q]);
          return typeof Y > "u" && (Y = 1e4 <= Math.abs(N) ? f(N, -1) : f(N, -1, void 0, "")), Y;
        }, P.prototype.getSeriesExtremes = function () {
          var f = this,
            x = f.chart,
            N;
          m(this, "getSeriesExtremes", null, function () {
            f.hasVisibleSeries = !1, f.dataMin = f.dataMax = f.threshold = null, f.softThreshold = !f.isXAxis, f.series.forEach(function (R) {
              if (R.visible || !x.options.chart.ignoreHiddenSeries) {
                var F = R.options,
                  T = F.threshold;
                if (f.hasVisibleSeries = !0, f.positiveValuesOnly && 0 >= T && (T = null), f.isXAxis) {
                  if (F = R.xData, F.length) {
                    F = f.logarithmic ? F.filter(f.validatePositiveValue) : F, N = R.getXExtremes(F);
                    var G = N.min,
                      _ = N.max;
                    o(G) || G instanceof Date || (F = F.filter(o), N = R.getXExtremes(F), G = N.min, _ = N.max), F.length && (f.dataMin = Math.min(e(f.dataMin, G), G), f.dataMax = Math.max(e(f.dataMax, _), _));
                  }
                } else R = R.applyExtremes(), o(R.dataMin) && (G = R.dataMin, f.dataMin = Math.min(e(f.dataMin, G), G)), o(R.dataMax) && (_ = R.dataMax, f.dataMax = Math.max(e(f.dataMax, _), _)), v(T) && (f.threshold = T), (!F.softThreshold || f.positiveValuesOnly) && (f.softThreshold = !1);
              }
            });
          }), m(this, "afterGetSeriesExtremes");
        }, P.prototype.translate = function (f, x, N, R, F, T) {
          var G = this.linkedParent || this,
            _ = R && G.old ? G.old.min : G.min;
          if (!o(_)) return NaN;
          var q = G.minPixelPadding;
          F = (G.isOrdinal || G.brokenAxis && G.brokenAxis.hasBreaks || G.logarithmic && F) && G.lin2val;
          var Y = 1,
            U = 0;
          return R = R && G.old ? G.old.transA : G.transA, R || (R = G.transA), N && (Y *= -1, U = G.len), G.reversed && (Y *= -1, U -= Y * (G.sector || G.len)), x ? (T = (f * Y + U - q) / R + _, F && (T = G.lin2val(T))) : (F && (f = G.val2lin(f)), f = Y * (f - _) * R, T = (G.isRadial ? f : u(f)) + U + Y * q + (o(T) ? R * T : 0)), T;
        }, P.prototype.toPixels = function (f, x) {
          return this.translate(f, !1, !this.horiz, void 0, !0) + (x ? 0 : this.pos);
        }, P.prototype.toValue = function (f, x) {
          return this.translate(f - (x ? 0 : this.pos), !0, !this.horiz, void 0, !0);
        }, P.prototype.getPlotLinePath = function (f) {
          function x(it, $, Q) {
            return et !== "pass" && (it < $ || it > Q) && (et ? it = l(it, $, Q) : st = !0), it;
          }
          var N = this,
            R = N.chart,
            F = N.left,
            T = N.top,
            G = f.old,
            _ = f.value,
            q = f.lineWidth,
            Y = G && R.oldChartHeight || R.chartHeight,
            U = G && R.oldChartWidth || R.chartWidth,
            Z = N.transB,
            J = f.translatedValue,
            et = f.force,
            nt,
            lt,
            ct,
            tt,
            st;
          return f = {
            value: _,
            lineWidth: q,
            old: G,
            force: et,
            acrossPanes: f.acrossPanes,
            translatedValue: J
          }, m(this, "getPlotLinePath", f, function (it) {
            J = e(J, N.translate(_, void 0, void 0, G)), J = l(J, -1e5, 1e5), nt = ct = Math.round(J + Z), lt = tt = Math.round(Y - J - Z), o(J) ? N.horiz ? (lt = T, tt = Y - N.bottom, nt = ct = x(nt, F, F + N.width)) : (nt = F, ct = U - N.right, lt = tt = x(lt, T, T + N.height)) : (st = !0, et = !1), it.path = st && !et ? null : R.renderer.crispLine([["M", nt, lt], ["L", ct, tt]], q || 1);
          }), f.path;
        }, P.prototype.getLinearTickPositions = function (f, x, N) {
          var R = u(Math.floor(x / f) * f);
          N = u(Math.ceil(N / f) * f);
          var F = [],
            T;
          if (u(R + f) === R && (T = 20), this.single) return [x];
          for (x = R; x <= N && (F.push(x), x = u(x + f, T), x !== G);) var G = x;
          return F;
        }, P.prototype.getMinorTickInterval = function () {
          var f = this.options;
          return f.minorTicks === !0 ? e(f.minorTickInterval, "auto") : f.minorTicks === !1 ? null : f.minorTickInterval;
        }, P.prototype.getMinorTickPositions = function () {
          var f = this.options,
            x = this.tickPositions,
            N = this.minorTickInterval,
            R = this.pointRangePadding || 0,
            F = this.min - R;
          R = this.max + R;
          var T = R - F,
            G = [];
          if (T && T / N < this.len / 3) {
            var _ = this.logarithmic;
            if (_) this.paddedTicks.forEach(function (q, Y, U) {
              Y && G.push.apply(G, _.getLogTickPositions(N, U[Y - 1], U[Y], !0));
            });else if (this.dateTime && this.getMinorTickInterval() === "auto") G = G.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(N), F, R, f.startOfWeek));else for (f = F + (x[0] - F) % N; f <= R && f !== G[0]; f += N) G.push(f);
          }
          return G.length !== 0 && this.trimTicks(G), G;
        }, P.prototype.adjustForMinRange = function () {
          var f = this.options,
            x = this.logarithmic,
            N = this.min,
            R = this.max,
            F = 0,
            T,
            G,
            _,
            q;
          if (this.isXAxis && typeof this.minRange > "u" && !x && (v(f.min) || v(f.max) || v(f.floor) || v(f.ceiling) ? this.minRange = null : (this.series.forEach(function (J) {
            if (_ = J.xData, q = J.xIncrement ? 1 : _.length - 1, 1 < _.length) for (T = q; 0 < T; T--) G = _[T] - _[T - 1], (!F || G < F) && (F = G);
          }), this.minRange = Math.min(5 * F, this.dataMax - this.dataMin))), R - N < this.minRange) {
            var Y = this.dataMax - this.dataMin >= this.minRange,
              U = this.minRange,
              Z = (U - R + N) / 2;
            Z = [N - Z, e(f.min, N - Z)], Y && (Z[2] = this.logarithmic ? this.logarithmic.log2lin(this.dataMin) : this.dataMin), N = h(Z), R = [N + U, e(f.max, N + U)], Y && (R[2] = x ? x.log2lin(this.dataMax) : this.dataMax), R = s(R), R - N < U && (Z[0] = R - U, Z[1] = e(f.min, R - U), N = h(Z));
          }
          this.min = N, this.max = R;
        }, P.prototype.getClosest = function () {
          var f;
          return this.categories ? f = 1 : this.series.forEach(function (x) {
            var N = x.closestPointRange,
              R = x.visible || !x.chart.options.chart.ignoreHiddenSeries;
            !x.noSharedTooltip && v(N) && R && (f = v(f) ? Math.min(f, N) : N);
          }), f;
        }, P.prototype.nameToX = function (f) {
          var x = d(this.options.categories),
            N = x ? this.categories : this.names,
            R = f.options.x;
          if (f.series.requireSorting = !1, v(R) || (R = this.options.uniqueNames && N ? x ? N.indexOf(f.name) : e(N.keys[f.name], -1) : f.series.autoIncrement()), R === -1) {
            if (!x && N) var F = N.length;
          } else F = R;
          return typeof F < "u" ? (this.names[F] = f.name, this.names.keys[f.name] = F) : f.x && (F = f.x), F;
        }, P.prototype.updateNames = function () {
          var f = this,
            x = this.names;
          0 < x.length && (Object.keys(x.keys).forEach(function (N) {
            delete x.keys[N];
          }), x.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach(function (N) {
            N.xIncrement = null, (!N.points || N.isDirtyData) && (f.max = Math.max(f.max, N.xData.length - 1), N.processData(), N.generatePoints()), N.data.forEach(function (R, F) {
              if (R && R.options && typeof R.name < "u") {
                var T = f.nameToX(R);
                typeof T < "u" && T !== R.x && (R.x = T, N.xData[F] = T);
              }
            });
          }));
        }, P.prototype.setAxisTranslation = function () {
          var f = this,
            x = f.max - f.min,
            N = f.linkedParent,
            R = !!f.categories,
            F = f.isXAxis,
            T = f.axisPointRange || 0,
            G = 0,
            _ = 0,
            q = f.transA;
          if (F || R || T) {
            var Y = f.getClosest();
            N ? (G = N.minPointOffset, _ = N.pointRangePadding) : f.series.forEach(function (U) {
              var Z = R ? 1 : F ? e(U.options.pointRange, Y, 0) : f.axisPointRange || 0,
                J = U.options.pointPlacement;
              T = Math.max(T, Z), (!f.single || R) && (U = U.is("xrange") ? !F : F, G = Math.max(G, U && n(J) ? 0 : Z / 2), _ = Math.max(_, U && J === "on" ? 0 : Z));
            }), N = f.ordinal && f.ordinal.slope && Y ? f.ordinal.slope / Y : 1, f.minPointOffset = G *= N, f.pointRangePadding = _ *= N, f.pointRange = Math.min(T, f.single && R ? 1 : x), F && (f.closestPointRange = Y);
          }
          f.translationSlope = f.transA = q = f.staticScale || f.len / (x + _ || 1), f.transB = f.horiz ? f.left : f.bottom, f.minPixelPadding = q * G, m(this, "afterSetAxisTranslation");
        }, P.prototype.minFromRange = function () {
          return this.max - this.range;
        }, P.prototype.setTickInterval = function (f) {
          var x = this.chart,
            N = this.logarithmic,
            R = this.options,
            F = this.isXAxis,
            T = this.isLinked,
            G = R.tickPixelInterval,
            _ = this.categories,
            q = this.softThreshold,
            Y = R.maxPadding,
            U = R.minPadding,
            Z = o(R.tickInterval) && 0 <= R.tickInterval ? R.tickInterval : void 0,
            J = o(this.threshold) ? this.threshold : null;
          this.dateTime || _ || T || this.getTickAmount();
          var et = e(this.userMin, R.min),
            nt = e(this.userMax, R.max);
          if (T) {
            this.linkedParent = x[this.coll][R.linkedTo];
            var lt = this.linkedParent.getExtremes();
            this.min = e(lt.min, lt.dataMin), this.max = e(lt.max, lt.dataMax), R.type !== this.linkedParent.options.type && L(11, 1, x);
          } else {
            if (q && v(J)) {
              if (this.dataMin >= J) lt = J, U = 0;else if (this.dataMax <= J) {
                var ct = J;
                Y = 0;
              }
            }
            this.min = e(et, lt, this.dataMin), this.max = e(nt, ct, this.dataMax);
          }
          if (N && (this.positiveValuesOnly && !f && 0 >= Math.min(this.min, e(this.dataMin, this.min)) && L(10, 1, x), this.min = u(N.log2lin(this.min), 16), this.max = u(N.log2lin(this.max), 16)), this.range && v(this.max) && (this.userMin = this.min = et = Math.max(this.dataMin, this.minFromRange()), this.userMax = nt = this.max, this.range = null), m(this, "foundExtremes"), this.beforePadding && this.beforePadding(), this.adjustForMinRange(), !(_ || this.axisPointRange || this.stacking && this.stacking.usePercentage || T) && v(this.min) && v(this.max) && (x = this.max - this.min) && (!v(et) && U && (this.min -= x * U), !v(nt) && Y && (this.max += x * Y)), o(this.userMin) || (o(R.softMin) && R.softMin < this.min && (this.min = et = R.softMin), o(R.floor) && (this.min = Math.max(this.min, R.floor))), o(this.userMax) || (o(R.softMax) && R.softMax > this.max && (this.max = nt = R.softMax), o(R.ceiling) && (this.max = Math.min(this.max, R.ceiling))), q && v(this.dataMin) && (J = J || 0, !v(et) && this.min < J && this.dataMin >= J ? this.min = this.options.minRange ? Math.min(J, this.max - this.minRange) : J : !v(nt) && this.max > J && this.dataMax <= J && (this.max = this.options.minRange ? Math.max(J, this.min + this.minRange) : J)), o(this.min) && o(this.max) && !this.chart.polar && this.min > this.max && (v(this.options.min) ? this.max = this.min : v(this.options.max) && (this.min = this.max)), this.tickInterval = this.min === this.max || typeof this.min > "u" || typeof this.max > "u" ? 1 : T && this.linkedParent && !Z && G === this.linkedParent.options.tickPixelInterval ? Z = this.linkedParent.tickInterval : e(Z, this.tickAmount ? (this.max - this.min) / Math.max(this.tickAmount - 1, 1) : void 0, _ ? 1 : (this.max - this.min) * G / Math.max(this.len, G)), F && !f) {
            var tt = this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max);
            this.series.forEach(function (st) {
              st.forceCrop = st.forceCropping && st.forceCropping(), st.processData(tt);
            }), m(this, "postProcessData", {
              hasExtremesChanged: tt
            });
          }
          this.setAxisTranslation(), m(this, "initialAxisTranslation"), this.pointRange && !Z && (this.tickInterval = Math.max(this.pointRange, this.tickInterval)), f = e(R.minTickInterval, this.dateTime && !this.series.some(function (st) {
            return st.noSharedTooltip;
          }) ? this.closestPointRange : 0), !Z && this.tickInterval < f && (this.tickInterval = f), this.dateTime || this.logarithmic || Z || (this.tickInterval = j(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
        }, P.prototype.setTickPositions = function () {
          var f = this.options,
            x = f.tickPositions,
            N = f.tickPositioner,
            R = this.getMinorTickInterval(),
            F = this.hasVerticalPanning(),
            T = this.coll === "colorAxis",
            G = (T || !F) && f.startOnTick;
          F = (T || !F) && f.endOnTick, T = [];
          var _;
          if (this.tickmarkOffset = this.categories && f.tickmarkPlacement === "between" && this.tickInterval === 1 ? 0.5 : 0, this.minorTickInterval = R === "auto" && this.tickInterval ? this.tickInterval / 5 : R, this.single = this.min === this.max && v(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || f.allowDecimals !== !1), x) T = x.slice();else if (o(this.min) && o(this.max)) {
            if (this.ordinal && this.ordinal.positions || !((this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200))) {
              if (this.dateTime) T = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, f.units), this.min, this.max, f.startOfWeek, this.ordinal && this.ordinal.positions, this.closestPointRange, !0);else if (this.logarithmic) T = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);else for (R = f = this.tickInterval; R <= 2 * f && (T = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && T.length > this.tickAmount);) this.tickInterval = j(this, R *= 1.1);
            } else T = [this.min, this.max], L(19, !1, this.chart);
            T.length > this.len && (T = [T[0], T[T.length - 1]], T[0] === T[1] && (T.length = 1)), N && (this.tickPositions = T, (_ = N.apply(this, [this.min, this.max])) && (T = _));
          }
          this.tickPositions = T, this.paddedTicks = T.slice(0), this.trimTicks(T, G, F), !this.isLinked && o(this.min) && o(this.max) && (this.single && 2 > T.length && !this.categories && !this.series.some(function (q) {
            return q.is("heatmap") && q.options.pointPlacement === "between";
          }) && (this.min -= 0.5, this.max += 0.5), x || _ || this.adjustTickAmount()), m(this, "afterSetTickPositions");
        }, P.prototype.trimTicks = function (f, x, N) {
          var R = f[0],
            F = f[f.length - 1],
            T = !this.isOrdinal && this.minPointOffset || 0;
          if (m(this, "trimTicks"), !this.isLinked) {
            if (x && R !== -1 / 0) this.min = R;else for (; this.min - T > f[0];) f.shift();
            if (N) this.max = F;else for (; this.max + T < f[f.length - 1];) f.pop();
            f.length === 0 && v(R) && !this.options.tickPositions && f.push((F + R) / 2);
          }
        }, P.prototype.alignToOthers = function () {
          var f = this,
            x = [this],
            N = f.options,
            R = this.coll === "yAxis" && this.chart.options.chart.alignThresholds,
            F = [],
            T;
          if (f.thresholdAlignment = void 0, (this.chart.options.chart.alignTicks !== !1 && N.alignTicks || R) && N.startOnTick !== !1 && N.endOnTick !== !1 && !f.logarithmic) {
            var G = function G(Y) {
                var U = Y.options;
                return [Y.horiz ? U.left : U.top, U.width, U.height, U.pane].join();
              },
              _ = G(this);
            this.chart[this.coll].forEach(function (Y) {
              var U = Y.series;
              U.length && U.some(function (Z) {
                return Z.visible;
              }) && Y !== f && G(Y) === _ && (T = !0, x.push(Y));
            });
          }
          if (T && R) {
            x.forEach(function (Y) {
              Y = Y.getThresholdAlignment(f), o(Y) && F.push(Y);
            });
            var q = 1 < F.length ? F.reduce(function (Y, U) {
              return Y + U;
            }, 0) / F.length : void 0;
            x.forEach(function (Y) {
              Y.thresholdAlignment = q;
            });
          }
          return T;
        }, P.prototype.getThresholdAlignment = function (f) {
          if ((!o(this.dataMin) || this !== f && this.series.some(function (x) {
            return x.isDirty || x.isDirtyData;
          })) && this.getSeriesExtremes(), o(this.threshold)) return f = l((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1), this.options.reversed && (f = 1 - f), f;
        }, P.prototype.getTickAmount = function () {
          var f = this.options,
            x = f.tickPixelInterval,
            N = f.tickAmount;
          !v(f.tickInterval) && !N && this.len < x && !this.isRadial && !this.logarithmic && f.startOnTick && f.endOnTick && (N = 2), !N && this.alignToOthers() && (N = Math.ceil(this.len / x) + 1), 4 > N && (this.finalTickAmt = N, N = 5), this.tickAmount = N;
        }, P.prototype.adjustTickAmount = function () {
          var f = this,
            x = f.finalTickAmt,
            N = f.max,
            R = f.min,
            F = f.options,
            T = f.tickPositions,
            G = f.tickAmount,
            _ = f.thresholdAlignment,
            q = T && T.length,
            Y = e(f.threshold, f.softThreshold ? 0 : null),
            U = f.tickInterval;
          if (o(_)) {
            var Z = 0.5 > _ ? Math.ceil(_ * (G - 1)) : Math.floor(_ * (G - 1));
            F.reversed && (Z = G - 1 - Z);
          }
          if (f.hasData() && o(R) && o(N)) {
            if (_ = function _() {
              f.transA *= (q - 1) / (G - 1), f.min = F.startOnTick ? T[0] : Math.min(R, T[0]), f.max = F.endOnTick ? T[T.length - 1] : Math.max(N, T[T.length - 1]);
            }, o(Z) && o(f.threshold)) {
              for (; T[Z] !== Y || T.length !== G || T[0] > R || T[T.length - 1] < N;) {
                for (T.length = 0, T.push(f.threshold); T.length < G;) T[Z] === void 0 || T[Z] > f.threshold ? T.unshift(u(T[0] - U)) : T.push(u(T[T.length - 1] + U));
                if (U > 8 * f.tickInterval) break;
                U *= 2;
              }
              _();
            } else if (q < G) {
              for (; T.length < G;) T.length % 2 || R === Y ? T.push(u(T[T.length - 1] + U)) : T.unshift(u(T[0] - U));
              _();
            }
            if (v(x)) {
              for (U = Y = T.length; U--;) (x === 3 && U % 2 === 1 || 2 >= x && 0 < U && U < Y - 1) && T.splice(U, 1);
              f.finalTickAmt = void 0;
            }
          }
        }, P.prototype.setScale = function () {
          var f = !1,
            x = !1;
          this.series.forEach(function (R) {
            f = f || R.isDirtyData || R.isDirty, x = x || R.xAxis && R.xAxis.isDirty || !1;
          }), this.setAxisSize();
          var N = this.len !== (this.old && this.old.len);
          N || f || x || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (this.stacking && (this.stacking.resetStacks(), this.stacking.buildStacks()), this.forceRedraw = !1, this.getSeriesExtremes(), this.setTickInterval(), this.isDirty || (this.isDirty = N || this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max))) : this.stacking && this.stacking.cleanStacks(), f && this.panningState && (this.panningState.isDirty = !0), m(this, "afterSetScale");
        }, P.prototype.setExtremes = function (f, x, N, R, F) {
          var T = this,
            G = T.chart;
          N = e(N, !0), T.series.forEach(function (_) {
            delete _.kdTree;
          }), F = C(F, {
            min: f,
            max: x
          }), m(T, "setExtremes", F, function () {
            T.userMin = f, T.userMax = x, T.eventArgs = F, N && G.redraw(R);
          });
        }, P.prototype.zoom = function (f, x) {
          var N = this,
            R = this.dataMin,
            F = this.dataMax,
            T = this.options,
            G = Math.min(R, e(T.min, R)),
            _ = Math.max(F, e(T.max, F));
          return f = {
            newMin: f,
            newMax: x
          }, m(this, "zoom", f, function (q) {
            var Y = q.newMin,
              U = q.newMax;
            (Y !== N.min || U !== N.max) && (N.allowZoomOutside || (v(R) && (Y < G && (Y = G), Y > _ && (Y = _)), v(F) && (U < G && (U = G), U > _ && (U = _))), N.displayBtn = typeof Y < "u" || typeof U < "u", N.setExtremes(Y, U, !1, void 0, {
              trigger: "zoom"
            })), q.zoomed = !0;
          }), f.zoomed;
        }, P.prototype.setAxisSize = function () {
          var f = this.chart,
            x = this.options,
            N = x.offsets || [0, 0, 0, 0],
            R = this.horiz,
            F = this.width = Math.round(a(e(x.width, f.plotWidth - N[3] + N[1]), f.plotWidth)),
            T = this.height = Math.round(a(e(x.height, f.plotHeight - N[0] + N[2]), f.plotHeight)),
            G = this.top = Math.round(a(e(x.top, f.plotTop + N[0]), f.plotHeight, f.plotTop));
          x = this.left = Math.round(a(e(x.left, f.plotLeft + N[3]), f.plotWidth, f.plotLeft)), this.bottom = f.chartHeight - T - G, this.right = f.chartWidth - F - x, this.len = Math.max(R ? F : T, 0), this.pos = R ? x : G;
        }, P.prototype.getExtremes = function () {
          var f = this.logarithmic;
          return {
            min: f ? u(f.lin2log(this.min)) : this.min,
            max: f ? u(f.lin2log(this.max)) : this.max,
            dataMin: this.dataMin,
            dataMax: this.dataMax,
            userMin: this.userMin,
            userMax: this.userMax
          };
        }, P.prototype.getThreshold = function (f) {
          var x = this.logarithmic,
            N = x ? x.lin2log(this.min) : this.min;
          return x = x ? x.lin2log(this.max) : this.max, f === null || f === -1 / 0 ? f = N : f === 1 / 0 ? f = x : N > f ? f = N : x < f && (f = x), this.translate(f, 0, 1, 0, 1);
        }, P.prototype.autoLabelAlign = function (f) {
          var x = (e(f, 0) - 90 * this.side + 720) % 360;
          return f = {
            align: "center"
          }, m(this, "autoLabelAlign", f, function (N) {
            15 < x && 165 > x ? N.align = "right" : 195 < x && 345 > x && (N.align = "left");
          }), f.align;
        }, P.prototype.tickSize = function (f) {
          var x = this.options,
            N = e(x[f === "tick" ? "tickWidth" : "minorTickWidth"], f === "tick" && this.isXAxis && !this.categories ? 1 : 0),
            R = x[f === "tick" ? "tickLength" : "minorTickLength"];
          if (N && R) {
            x[f + "Position"] === "inside" && (R = -R);
            var F = [R, N];
          }
          return f = {
            tickSize: F
          }, m(this, "afterTickSize", f), f.tickSize;
        }, P.prototype.labelMetrics = function () {
          var f = this.tickPositions && this.tickPositions[0] || 0;
          return this.chart.renderer.fontMetrics(this.options.labels.style.fontSize, this.ticks[f] && this.ticks[f].label);
        }, P.prototype.unsquish = function () {
          var f = this.options.labels,
            x = this.horiz,
            N = this.tickInterval,
            R = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / N),
            F = f.rotation,
            T = this.labelMetrics(),
            G = Math.max(this.max - this.min, 0),
            _ = function _(ct) {
              var tt = ct / (R || 1);
              return tt = 1 < tt ? Math.ceil(tt) : 1, tt * N > G && ct !== 1 / 0 && R !== 1 / 0 && G && (tt = Math.ceil(G / N)), u(tt * N);
            },
            q = N,
            Y = Number.MAX_VALUE;
          if (x) {
            if (!f.staggerLines) if (o(F)) var U = [F];else R < f.autoRotationLimit && (U = f.autoRotation);
            if (U) for (var Z = x = void 0, J = 0, et = U; J < et.length; J++) {
              var nt = et[J];
              if ((nt === F || nt && -90 <= nt && 90 >= nt) && (x = _(Math.abs(T.h / Math.sin(p * nt))), Z = x + Math.abs(nt / 360), Z < Y)) {
                Y = Z;
                var lt = nt;
                q = x;
              }
            }
          } else q = _(T.h);
          return this.autoRotation = U, this.labelRotation = e(lt, o(F) ? F : 0), f.step ? N : q;
        }, P.prototype.getSlotWidth = function (f) {
          var x = this.chart,
            N = this.horiz,
            R = this.options.labels,
            F = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1),
            T = x.margin[3];
          if (f && o(f.slotWidth)) return f.slotWidth;
          if (N && 2 > R.step) return R.rotation ? 0 : (this.staggerLines || 1) * this.len / F;
          if (!N) {
            if (f = R.style.width, f !== void 0) return parseInt(String(f), 10);
            if (T) return T - x.spacing[3];
          }
          return 0.33 * x.chartWidth;
        }, P.prototype.renderUnsquish = function () {
          var f = this.chart,
            x = f.renderer,
            N = this.tickPositions,
            R = this.ticks,
            F = this.options.labels,
            T = F.style,
            G = this.horiz,
            _ = this.getSlotWidth(),
            q = Math.max(1, Math.round(_ - 2 * F.padding)),
            Y = {},
            U = this.labelMetrics(),
            Z = T.textOverflow,
            J = 0;
          if (n(F.rotation) || (Y.rotation = F.rotation || 0), N.forEach(function (ct) {
            ct = R[ct], ct.movedLabel && ct.replaceMovedLabel(), ct && ct.label && ct.label.textPxLength > J && (J = ct.label.textPxLength);
          }), this.maxLabelLength = J, this.autoRotation) J > q && J > U.h ? Y.rotation = this.labelRotation : this.labelRotation = 0;else if (_) {
            var et = q;
            if (!Z) {
              var nt = "clip";
              for (q = N.length; !G && q--;) {
                var lt = N[q];
                (lt = R[lt].label) && (lt.styles && lt.styles.textOverflow === "ellipsis" ? lt.css({
                  textOverflow: "clip"
                }) : lt.textPxLength > _ && lt.css({
                  width: _ + "px"
                }), lt.getBBox().height > this.len / N.length - (U.h - U.f) && (lt.specificTextOverflow = "ellipsis"));
              }
            }
          }
          Y.rotation && (et = J > 0.5 * f.chartHeight ? 0.33 * f.chartHeight : J, Z || (nt = "ellipsis")), (this.labelAlign = F.align || this.autoLabelAlign(this.labelRotation)) && (Y.align = this.labelAlign), N.forEach(function (ct) {
            var tt = (ct = R[ct]) && ct.label,
              st = T.width,
              it = {};
            tt && (tt.attr(Y), ct.shortenLabel ? ct.shortenLabel() : et && !st && T.whiteSpace !== "nowrap" && (et < tt.textPxLength || tt.element.tagName === "SPAN") ? (it.width = et + "px", Z || (it.textOverflow = tt.specificTextOverflow || nt), tt.css(it)) : tt.styles && tt.styles.width && !it.width && !st && tt.css({
              width: null
            }), delete tt.specificTextOverflow, ct.rotation = Y.rotation);
          }, this), this.tickRotCorr = x.rotCorr(U.b, this.labelRotation || 0, this.side !== 0);
        }, P.prototype.hasData = function () {
          return this.series.some(function (f) {
            return f.hasData();
          }) || this.options.showEmpty && v(this.min) && v(this.max);
        }, P.prototype.addTitle = function (f) {
          var x = this.chart.renderer,
            N = this.horiz,
            R = this.opposite,
            F = this.options.title,
            T = this.chart.styledMode,
            G;
          this.axisTitle || ((G = F.textAlign) || (G = (N ? {
            low: "left",
            middle: "center",
            high: "right"
          } : {
            low: R ? "right" : "left",
            middle: "center",
            high: R ? "left" : "right"
          })[F.align]), this.axisTitle = x.text(F.text || "", 0, 0, F.useHTML).attr({
            zIndex: 7,
            rotation: F.rotation,
            align: G
          }).addClass("highcharts-axis-title"), T || this.axisTitle.css(r(F.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), T || F.style.width || this.isRadial || this.axisTitle.css({
            width: this.len + "px"
          }), this.axisTitle[f ? "show" : "hide"](f);
        }, P.prototype.generateTick = function (f) {
          var x = this.ticks;
          x[f] ? x[f].addLabel() : x[f] = new z(this, f);
        }, P.prototype.getOffset = function () {
          var f = this,
            x = this,
            N = x.chart,
            R = x.horiz,
            F = x.options,
            T = x.side,
            G = x.ticks,
            _ = x.tickPositions,
            q = x.coll,
            Y = x.axisParent,
            U = N.renderer,
            Z = N.inverted && !x.isZAxis ? [1, 0, 3, 2][T] : T,
            J = x.hasData(),
            et = F.title,
            nt = F.labels,
            lt = N.axisOffset;
          N = N.clipOffset;
          var ct = [-1, 1, 1, -1][T],
            tt = F.className,
            st,
            it = 0,
            $ = 0,
            Q = 0;
          if (x.showAxis = st = J || F.showEmpty, x.staggerLines = x.horiz && nt.staggerLines || void 0, !x.axisGroup) {
            var ot = function ot(rt, ht, pt) {
              return U.g(rt).attr({
                zIndex: pt
              }).addClass("highcharts-".concat(q.toLowerCase()).concat(ht, " ") + (f.isRadial ? "highcharts-radial-axis".concat(ht, " ") : "") + (tt || "")).add(Y);
            };
            x.gridGroup = ot("grid", "-grid", F.gridZIndex), x.axisGroup = ot("axis", "", F.zIndex), x.labelGroup = ot("axis-labels", "-labels", nt.zIndex);
          }
          if (J || x.isLinked ? (_.forEach(function (rt) {
            x.generateTick(rt);
          }), x.renderUnsquish(), x.reserveSpaceDefault = T === 0 || T === 2 || {
            1: "left",
            3: "right"
          }[T] === x.labelAlign, e(nt.reserveSpace, x.labelAlign === "center" ? !0 : null, x.reserveSpaceDefault) && _.forEach(function (rt) {
            Q = Math.max(G[rt].getLabelSize(), Q);
          }), x.staggerLines && (Q *= x.staggerLines), x.labelOffset = Q * (x.opposite ? -1 : 1)) : t(G, function (rt, ht) {
            rt.destroy(), delete G[ht];
          }), et && et.text && et.enabled !== !1 && (x.addTitle(st), st && et.reserveSpace !== !1)) {
            x.titleOffset = it = x.axisTitle.getBBox()[R ? "height" : "width"];
            var at = et.offset;
            $ = v(at) ? 0 : e(et.margin, R ? 5 : 10);
          }
          x.renderLine(), x.offset = ct * e(F.offset, lt[T] ? lt[T] + (F.margin || 0) : 0), x.tickRotCorr = x.tickRotCorr || {
            x: 0,
            y: 0
          }, et = T === 0 ? -x.labelMetrics().h : T === 2 ? x.tickRotCorr.y : 0, J = Math.abs(Q) + $, Q && (J = J - et + ct * (R ? e(nt.y, x.tickRotCorr.y + 8 * ct) : nt.x)), x.axisTitleMargin = e(at, J), x.getMaxLabelDimensions && (x.maxLabelDimensions = x.getMaxLabelDimensions(G, _)), q !== "colorAxis" && (R = this.tickSize("tick"), lt[T] = Math.max(lt[T], (x.axisTitleMargin || 0) + it + ct * x.offset, J, _ && _.length && R ? R[0] + ct * x.offset : 0), F = !x.axisLine || F.offset ? 0 : 2 * Math.floor(x.axisLine.strokeWidth() / 2), N[Z] = Math.max(N[Z], F)), m(this, "afterGetOffset");
        }, P.prototype.getLinePath = function (f) {
          var x = this.chart,
            N = this.opposite,
            R = this.offset,
            F = this.horiz,
            T = this.left + (N ? this.width : 0) + R;
          return R = x.chartHeight - this.bottom - (N ? this.height : 0) + R, N && (f *= -1), x.renderer.crispLine([["M", F ? this.left : T, F ? R : this.top], ["L", F ? x.chartWidth - this.right : T, F ? R : x.chartHeight - this.bottom]], f);
        }, P.prototype.renderLine = function () {
          this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
            stroke: this.options.lineColor,
            "stroke-width": this.options.lineWidth,
            zIndex: 7
          }));
        }, P.prototype.getTitlePosition = function () {
          var f = this.horiz,
            x = this.left,
            N = this.top,
            R = this.len,
            F = this.options.title,
            T = f ? x : N,
            G = this.opposite,
            _ = this.offset,
            q = F.x,
            Y = F.y,
            U = this.axisTitle,
            Z = this.chart.renderer.fontMetrics(F.style.fontSize, U);
          return U = U ? Math.max(U.getBBox(!1, 0).height - Z.h - 1, 0) : 0, R = {
            low: T + (f ? 0 : R),
            middle: T + R / 2,
            high: T + (f ? R : 0)
          }[F.align], x = (f ? N + this.height : x) + (f ? 1 : -1) * (G ? -1 : 1) * (this.axisTitleMargin || 0) + [-U, U, Z.f, -U][this.side], f = {
            x: f ? R + q : x + (G ? this.width : 0) + _ + q,
            y: f ? x + Y - (G ? this.height : 0) + _ : R + Y
          }, m(this, "afterGetTitlePosition", {
            titlePosition: f
          }), f;
        }, P.prototype.renderMinorTick = function (f, x) {
          var N = this.minorTicks;
          N[f] || (N[f] = new z(this, f, "minor")), x && N[f].isNew && N[f].render(null, !0), N[f].render(null, !1, 1);
        }, P.prototype.renderTick = function (f, x, N) {
          var R = this.ticks;
          (!this.isLinked || f >= this.min && f <= this.max || this.grid && this.grid.isColumn) && (R[f] || (R[f] = new z(this, f)), N && R[f].isNew && R[f].render(x, !0, -1), R[f].render(x));
        }, P.prototype.render = function () {
          var f = this,
            x = f.chart,
            N = f.logarithmic,
            R = f.options,
            F = f.isLinked,
            T = f.tickPositions,
            G = f.axisTitle,
            _ = f.ticks,
            q = f.minorTicks,
            Y = f.alternateBands,
            U = R.stackLabels,
            Z = R.alternateGridColor,
            J = f.tickmarkOffset,
            et = f.axisLine,
            nt = f.showAxis,
            lt = A(x.renderer.globalAnimation),
            ct,
            tt;
          if (f.labelEdge.length = 0, f.overlap = !1, [_, q, Y].forEach(function (it) {
            t(it, function ($) {
              $.isActive = !1;
            });
          }), f.hasData() || F) {
            var st = f.chart.hasRendered && f.old && o(f.old.min);
            f.minorTickInterval && !f.categories && f.getMinorTickPositions().forEach(function (it) {
              f.renderMinorTick(it, st);
            }), T.length && (T.forEach(function (it, $) {
              f.renderTick(it, $, st);
            }), J && (f.min === 0 || f.single) && (_[-1] || (_[-1] = new z(f, -1, null, !0)), _[-1].render(-1))), Z && T.forEach(function (it, $) {
              tt = typeof T[$ + 1] < "u" ? T[$ + 1] + J : f.max - J, $ % 2 === 0 && it < f.max && tt <= f.max + (x.polar ? -J : J) && (Y[it] || (Y[it] = new W.PlotLineOrBand(f)), ct = it + J, Y[it].options = {
                from: N ? N.lin2log(ct) : ct,
                to: N ? N.lin2log(tt) : tt,
                color: Z,
                className: "highcharts-alternate-grid"
              }, Y[it].render(), Y[it].isActive = !0);
            }), f._addedPlotLB || (f._addedPlotLB = !0, (R.plotLines || []).concat(R.plotBands || []).forEach(function (it) {
              f.addPlotBandOrLine(it);
            }));
          }
          [_, q, Y].forEach(function (it) {
            var $ = [],
              Q = lt.duration;
            t(it, function (ot, at) {
              ot.isActive || (ot.render(at, !1, 0), ot.isActive = !1, $.push(at));
            }), b(function () {
              for (var ot = $.length; ot--;) it[$[ot]] && !it[$[ot]].isActive && (it[$[ot]].destroy(), delete it[$[ot]]);
            }, it !== Y && x.hasRendered && Q ? Q : 0);
          }), et && (et[et.isPlaced ? "animate" : "attr"]({
            d: this.getLinePath(et.strokeWidth())
          }), et.isPlaced = !0, et[nt ? "show" : "hide"](nt)), G && nt && (R = f.getTitlePosition(), G[G.isNew ? "attr" : "animate"](R), G.isNew = !1), U && U.enabled && f.stacking && f.stacking.renderStackTotals(), f.old = {
            len: f.len,
            max: f.max,
            min: f.min,
            transA: f.transA,
            userMax: f.userMax,
            userMin: f.userMin
          }, f.isDirty = !1, m(this, "afterRender");
        }, P.prototype.redraw = function () {
          this.visible && (this.render(), this.plotLinesAndBands.forEach(function (f) {
            f.render();
          })), this.series.forEach(function (f) {
            f.isDirty = !0;
          });
        }, P.prototype.getKeepProps = function () {
          return this.keepProps || P.keepProps;
        }, P.prototype.destroy = function (f) {
          var x = this,
            N = x.plotLinesAndBands,
            R = this.eventOptions;
          if (m(this, "destroy", {
            keepEvents: f
          }), f || c(x), [x.ticks, x.minorTicks, x.alternateBands].forEach(function (T) {
            M(T);
          }), N) for (f = N.length; f--;) N[f].destroy();
          "axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function (T) {
            x[T] && (x[T] = x[T].destroy());
          });
          for (var F in x.plotLinesAndBandsGroups) x.plotLinesAndBandsGroups[F] = x.plotLinesAndBandsGroups[F].destroy();
          t(x, function (T, G) {
            x.getKeepProps().indexOf(G) === -1 && delete x[G];
          }), this.eventOptions = R;
        }, P.prototype.drawCrosshair = function (f, x) {
          var N = this.crosshair,
            R = e(N && N.snap, !0),
            F = this.chart,
            T,
            G = this.cross;
          if (m(this, "drawCrosshair", {
            e: f,
            point: x
          }), f || (f = this.cross && this.cross.e), N && (v(x) || !R) !== !1) {
            if (R ? v(x) && (T = e(this.coll !== "colorAxis" ? x.crosshairPos : null, this.isXAxis ? x.plotX : this.len - x.plotY)) : T = f && (this.horiz ? f.chartX - this.pos : this.len - f.chartY + this.pos), v(T)) {
              var _ = {
                value: x && (this.isXAxis ? x.x : e(x.stackY, x.y)),
                translatedValue: T
              };
              F.polar && C(_, {
                isCrosshair: !0,
                chartX: f && f.chartX,
                chartY: f && f.chartY,
                point: x
              }), _ = this.getPlotLinePath(_) || null;
            }
            if (!v(_)) {
              this.hideCrosshair();
              return;
            }
            R = this.categories && !this.isRadial, G || (this.cross = G = F.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (R ? "category " : "thin ") + (N.className || "")).attr({
              zIndex: e(N.zIndex, 2)
            }).add(), F.styledMode || (G.attr({
              stroke: N.color || (R ? B.parse("#ccd6eb").setOpacity(0.25).get() : "#cccccc"),
              "stroke-width": e(N.width, 1)
            }).css({
              "pointer-events": "none"
            }), N.dashStyle && G.attr({
              dashstyle: N.dashStyle
            }))), G.show().attr({
              d: _
            }), R && !N.width && G.attr({
              "stroke-width": this.transA
            }), this.cross.e = f;
          } else this.hideCrosshair();
          m(this, "afterDrawCrosshair", {
            e: f,
            point: x
          });
        }, P.prototype.hideCrosshair = function () {
          this.cross && this.cross.hide(), m(this, "afterHideCrosshair");
        }, P.prototype.hasVerticalPanning = function () {
          var f = this.chart.options.chart.panning;
          return !!(f && f.enabled && /y/.test(f.type));
        }, P.prototype.validatePositiveValue = function (f) {
          return o(f) && 0 < f;
        }, P.prototype.update = function (f, x) {
          var N = this.chart;
          f = r(this.userOptions, f), this.destroy(!0), this.init(N, f), N.isDirtyBox = !0, e(x, !0) && N.redraw();
        }, P.prototype.remove = function (f) {
          for (var x = this.chart, N = this.coll, R = this.series, F = R.length; F--;) R[F] && R[F].remove(!1);
          I(x.axes, this), I(x[N], this), x[N].forEach(function (T, G) {
            T.options.index = T.userOptions.index = G;
          }), this.destroy(), x.isDirtyBox = !0, e(f, !0) && x.redraw();
        }, P.prototype.setTitle = function (f, x) {
          this.update({
            title: f
          }, x);
        }, P.prototype.setCategories = function (f, x) {
          this.update({
            categories: f
          }, x);
        }, P.defaultOptions = E.defaultXAxisOptions, P.keepProps = "extKey hcEvents names series userMax userMin".split(" "), P;
      }(), D;
    }), V(S, "Core/Axis/DateTimeAxis.js", [S["Core/Utilities.js"]], function (D) {
      var E = D.addEvent,
        B = D.getMagnitude,
        H = D.normalizeTickInterval,
        X = D.timeUnits,
        W;
      return function (z) {
        function w() {
          return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
        }
        function A(p) {
          p.userOptions.type !== "datetime" ? this.dateTime = void 0 : this.dateTime || (this.dateTime = new g(this));
        }
        var k = [];
        z.compose = function (p) {
          return k.indexOf(p) === -1 && (k.push(p), p.keepProps.push("dateTime"), p.prototype.getTimeTicks = w, E(p, "init", A)), p;
        };
        var g = function () {
          function p(h) {
            this.axis = h;
          }
          return p.prototype.normalizeTimeTickInterval = function (h, s) {
            var l = s || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]];
            s = l[l.length - 1];
            var u = X[s[0]],
              v = s[1],
              M;
            for (M = 0; M < l.length && (s = l[M], u = X[s[0]], v = s[1], !(l[M + 1] && h <= (u * v[v.length - 1] + X[l[M + 1][0]]) / 2)); M++);
            return u === X.year && h < 5 * u && (v = [1, 2, 5]), h = H(h / u, v, s[0] === "year" ? Math.max(B(h / u), 1) : 1), {
              unitRange: u,
              count: h,
              unitName: s[0]
            };
          }, p.prototype.getXDateFormat = function (h, s) {
            var l = this.axis,
              u = l.chart.time;
            return l.closestPointRange ? u.getDateFormat(l.closestPointRange, h, l.options.startOfWeek, s) || u.resolveDTLFormat(s.year).main : u.resolveDTLFormat(s.day).main;
          }, p;
        }();
        z.Additions = g;
      }(W || (W = {})), W;
    }), V(S, "Core/Axis/LogarithmicAxis.js", [S["Core/Utilities.js"]], function (D) {
      var E = D.addEvent,
        B = D.normalizeTickInterval,
        H = D.pick,
        X;
      return function (W) {
        function z(g) {
          var p = this.logarithmic;
          g.userOptions.type !== "logarithmic" ? this.logarithmic = void 0 : p || (this.logarithmic = new k(this));
        }
        function w() {
          var g = this.logarithmic;
          g && (this.lin2val = function (p) {
            return g.lin2log(p);
          }, this.val2lin = function (p) {
            return g.log2lin(p);
          });
        }
        var A = [];
        W.compose = function (g) {
          return A.indexOf(g) === -1 && (A.push(g), g.keepProps.push("logarithmic"), E(g, "init", z), E(g, "afterInit", w)), g;
        };
        var k = function () {
          function g(p) {
            this.axis = p;
          }
          return g.prototype.getLogTickPositions = function (p, h, s, l) {
            var u = this.axis,
              v = u.len,
              M = u.options,
              I = [];
            if (l || (this.minorAutoInterval = void 0), 0.5 <= p) p = Math.round(p), I = u.getLinearTickPositions(p, h, s);else if (0.08 <= p) {
              var L = Math.floor(h),
                C,
                m = M = void 0;
              for (v = 0.3 < p ? [1, 2, 4] : 0.15 < p ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9]; L < s + 1 && !m; L++) {
                var d = v.length;
                for (C = 0; C < d && !m; C++) {
                  var o = this.log2lin(this.lin2log(L) * v[C]);
                  o > h && (!l || M <= s) && typeof M < "u" && I.push(M), M > s && (m = !0), M = o;
                }
              }
            } else h = this.lin2log(h), s = this.lin2log(s), p = l ? u.getMinorTickInterval() : M.tickInterval, p = H(p === "auto" ? null : p, this.minorAutoInterval, M.tickPixelInterval / (l ? 5 : 1) * (s - h) / ((l ? v / u.tickPositions.length : v) || 1)), p = B(p), I = u.getLinearTickPositions(p, h, s).map(this.log2lin), l || (this.minorAutoInterval = p / 5);
            return l || (u.tickInterval = p), I;
          }, g.prototype.lin2log = function (p) {
            return Math.pow(10, p);
          }, g.prototype.log2lin = function (p) {
            return Math.log(p) / Math.LN10;
          }, g;
        }();
        W.Additions = k;
      }(X || (X = {})), X;
    }), V(S, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [S["Core/Utilities.js"]], function (D) {
      var E = D.erase,
        B = D.extend,
        H = D.isNumber,
        X;
      return function (W) {
        var z = [],
          w;
        W.compose = function (k, g) {
          return w || (w = k), z.indexOf(g) === -1 && (z.push(g), B(g.prototype, A.prototype)), g;
        };
        var A = function () {
          function k() {}
          return k.prototype.getPlotBandPath = function (g, p, h) {
            h === void 0 && (h = this.options);
            var s = this.getPlotLinePath({
                value: p,
                force: !0,
                acrossPanes: h.acrossPanes
              }),
              l = [],
              u = this.horiz;
            if (p = !H(this.min) || !H(this.max) || g < this.min && p < this.min || g > this.max && p > this.max, g = this.getPlotLinePath({
              value: g,
              force: !0,
              acrossPanes: h.acrossPanes
            }), h = 1, g && s) {
              if (p) {
                var v = g.toString() === s.toString();
                h = 0;
              }
              for (p = 0; p < g.length; p += 2) {
                var M = g[p],
                  I = g[p + 1],
                  L = s[p],
                  C = s[p + 1];
                M[0] !== "M" && M[0] !== "L" || I[0] !== "M" && I[0] !== "L" || L[0] !== "M" && L[0] !== "L" || C[0] !== "M" && C[0] !== "L" || (u && L[1] === M[1] ? (L[1] += h, C[1] += h) : u || L[2] !== M[2] || (L[2] += h, C[2] += h), l.push(["M", M[1], M[2]], ["L", I[1], I[2]], ["L", C[1], C[2]], ["L", L[1], L[2]], ["Z"])), l.isFlat = v;
              }
            }
            return l;
          }, k.prototype.addPlotBand = function (g) {
            return this.addPlotBandOrLine(g, "plotBands");
          }, k.prototype.addPlotLine = function (g) {
            return this.addPlotBandOrLine(g, "plotLines");
          }, k.prototype.addPlotBandOrLine = function (g, p) {
            var h = this,
              s = this.userOptions,
              l = new w(this, g);
            if (this.visible && (l = l.render()), l) {
              if (this._addedPlotLB || (this._addedPlotLB = !0, (s.plotLines || []).concat(s.plotBands || []).forEach(function (v) {
                h.addPlotBandOrLine(v);
              })), p) {
                var u = s[p] || [];
                u.push(g), s[p] = u;
              }
              this.plotLinesAndBands.push(l);
            }
            return l;
          }, k.prototype.removePlotBandOrLine = function (g) {
            var p = this.plotLinesAndBands,
              h = this.options,
              s = this.userOptions;
            if (p) {
              for (var l = p.length; l--;) p[l].id === g && p[l].destroy();
              [h.plotLines || [], s.plotLines || [], h.plotBands || [], s.plotBands || []].forEach(function (u) {
                for (l = u.length; l--;) (u[l] || {}).id === g && E(u, u[l]);
              });
            }
          }, k.prototype.removePlotBand = function (g) {
            this.removePlotBandOrLine(g);
          }, k.prototype.removePlotLine = function (g) {
            this.removePlotBandOrLine(g);
          }, k;
        }();
      }(X || (X = {})), X;
    }), V(S, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [S["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], S["Core/Utilities.js"]], function (D, E) {
      var B = E.arrayMax,
        H = E.arrayMin,
        X = E.defined,
        W = E.destroyObjectProperties,
        z = E.erase,
        w = E.fireEvent,
        A = E.merge,
        k = E.objectEach,
        g = E.pick;
      return E = function () {
        function p(h, s) {
          this.axis = h, s && (this.options = s, this.id = s.id);
        }
        return p.compose = function (h) {
          return D.compose(p, h);
        }, p.prototype.render = function () {
          w(this, "render");
          var h = this,
            s = h.axis,
            l = s.horiz,
            u = s.logarithmic,
            v = h.options,
            M = v.color,
            I = g(v.zIndex, 0),
            L = v.events,
            C = {},
            m = s.chart.renderer,
            d = v.label,
            o = h.label,
            n = v.to,
            r = v.from,
            i = v.value,
            t = h.svgElem,
            e = [],
            a = X(r) && X(n);
          e = X(i);
          var c = !t,
            y = {
              class: "highcharts-plot-" + (a ? "band " : "line ") + (v.className || "")
            },
            b = a ? "bands" : "lines";
          if (u && (r = u.log2lin(r), n = u.log2lin(n), i = u.log2lin(i)), s.chart.styledMode || (e ? (y.stroke = M || "#999999", y["stroke-width"] = g(v.width, 1), v.dashStyle && (y.dashstyle = v.dashStyle)) : a && (y.fill = M || "#e6ebf5", v.borderWidth && (y.stroke = v.borderColor, y["stroke-width"] = v.borderWidth))), C.zIndex = I, b += "-" + I, (u = s.plotLinesAndBandsGroups[b]) || (s.plotLinesAndBandsGroups[b] = u = m.g("plot-" + b).attr(C).add()), c && (h.svgElem = t = m.path().attr(y).add(u)), e) e = s.getPlotLinePath({
            value: i,
            lineWidth: t.strokeWidth(),
            acrossPanes: v.acrossPanes
          });else if (a) e = s.getPlotBandPath(r, n, v);else return;
          return !h.eventsAdded && L && (k(L, function (j, P) {
            t.on(P, function (f) {
              L[P].apply(h, [f]);
            });
          }), h.eventsAdded = !0), (c || !t.d) && e && e.length ? t.attr({
            d: e
          }) : t && (e ? (t.show(), t.animate({
            d: e
          })) : t.d && (t.hide(), o && (h.label = o = o.destroy()))), d && (X(d.text) || X(d.formatter)) && e && e.length && 0 < s.width && 0 < s.height && !e.isFlat ? (d = A({
            align: l && a && "center",
            x: l ? !a && 4 : 10,
            verticalAlign: !l && a && "middle",
            y: l ? a ? 16 : 10 : a ? 6 : -4,
            rotation: l && !a && 90
          }, d), this.renderLabel(d, e, a, I)) : o && o.hide(), h;
        }, p.prototype.renderLabel = function (h, s, l, u) {
          var v = this.axis,
            M = v.chart.renderer,
            I = this.label;
          I || (this.label = I = M.text(this.getLabelText(h), 0, 0, h.useHTML).attr({
            align: h.textAlign || h.align,
            rotation: h.rotation,
            class: "highcharts-plot-" + (l ? "band" : "line") + "-label " + (h.className || ""),
            zIndex: u
          }).add(), v.chart.styledMode || I.css(A({
            textOverflow: "ellipsis"
          }, h.style))), u = s.xBounds || [s[0][1], s[1][1], l ? s[2][1] : s[0][1]], s = s.yBounds || [s[0][2], s[1][2], l ? s[2][2] : s[0][2]], l = H(u), M = H(s), I.align(h, !1, {
            x: l,
            y: M,
            width: B(u) - l,
            height: B(s) - M
          }), I.alignValue && I.alignValue !== "left" || (h = h.clip ? v.width : v.chart.chartWidth, I.css({
            width: (I.rotation === 90 ? v.height - (I.alignAttr.y - v.top) : h - (I.alignAttr.x - v.left)) + "px"
          })), I.show(!0);
        }, p.prototype.getLabelText = function (h) {
          return X(h.formatter) ? h.formatter.call(this) : h.text;
        }, p.prototype.destroy = function () {
          z(this.axis.plotLinesAndBands, this), delete this.axis, W(this);
        }, p;
      }(), E;
    }), V(S, "Core/Tooltip.js", [S["Core/FormatUtilities.js"], S["Core/Globals.js"], S["Core/Renderer/RendererUtilities.js"], S["Core/Renderer/RendererRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H, X) {
      var W = D.format,
        z = E.doc,
        w = B.distribute,
        A = X.clamp,
        k = X.css,
        g = X.discardElement,
        p = X.extend,
        h = X.fireEvent,
        s = X.isArray,
        l = X.isNumber,
        u = X.isString,
        v = X.merge,
        M = X.pick,
        I = X.splat,
        L = X.syncTimeout;
      return D = function () {
        function C(m, d) {
          this.allowShared = !0, this.container = void 0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.now = {}, this.options = {}, this.outside = !1, this.chart = m, this.init(m, d);
        }
        return C.prototype.applyFilter = function () {
          var m = this.chart;
          m.renderer.definition({
            tagName: "filter",
            attributes: {
              id: "drop-shadow-" + m.index,
              opacity: 0.5
            },
            children: [{
              tagName: "feGaussianBlur",
              attributes: {
                in: "SourceAlpha",
                stdDeviation: 1
              }
            }, {
              tagName: "feOffset",
              attributes: {
                dx: 1,
                dy: 1
              }
            }, {
              tagName: "feComponentTransfer",
              children: [{
                tagName: "feFuncA",
                attributes: {
                  type: "linear",
                  slope: 0.3
                }
              }]
            }, {
              tagName: "feMerge",
              children: [{
                tagName: "feMergeNode"
              }, {
                tagName: "feMergeNode",
                attributes: {
                  in: "SourceGraphic"
                }
              }]
            }]
          });
        }, C.prototype.bodyFormatter = function (m) {
          return m.map(function (d) {
            var o = d.series.tooltipOptions;
            return (o[(d.point.formatPrefix || "point") + "Formatter"] || d.point.tooltipFormatter).call(d.point, o[(d.point.formatPrefix || "point") + "Format"] || "");
          });
        }, C.prototype.cleanSplit = function (m) {
          this.chart.series.forEach(function (d) {
            var o = d && d.tt;
            o && (!o.isActive || m ? d.tt = o.destroy() : o.isActive = !1);
          });
        }, C.prototype.defaultFormatter = function (m) {
          var d = this.points || I(this),
            o = [m.tooltipFooterHeaderFormatter(d[0])];
          return o = o.concat(m.bodyFormatter(d)), o.push(m.tooltipFooterHeaderFormatter(d[0], !0)), o;
        }, C.prototype.destroy = function () {
          this.label && (this.label = this.label.destroy()), this.split && this.tt && (this.cleanSplit(!0), this.tt = this.tt.destroy()), this.renderer && (this.renderer = this.renderer.destroy(), g(this.container)), X.clearTimeout(this.hideTimer), X.clearTimeout(this.tooltipTimeout);
        }, C.prototype.getAnchor = function (m, d) {
          var o = this.chart,
            n = o.pointer,
            r = o.inverted,
            i = o.plotTop;
          if (o = o.plotLeft, m = I(m), m[0].series && m[0].series.yAxis && !m[0].series.yAxis.options.reversedStacks && (m = m.slice().reverse()), this.followPointer && d) typeof d.chartX > "u" && (d = n.normalize(d)), m = [d.chartX - o, d.chartY - i];else if (m[0].tooltipPos) m = m[0].tooltipPos;else {
            var t = 0,
              e = 0;
            m.forEach(function (a) {
              (a = a.pos(!0)) && (t += a[0], e += a[1]);
            }), t /= m.length, e /= m.length, this.shared && 1 < m.length && d && (r ? t = d.chartX : e = d.chartY), m = [t - o, e - i];
          }
          return m.map(Math.round);
        }, C.prototype.getClassName = function (m, d, o) {
          var n = m.series,
            r = n.options;
          return [this.options.className, "highcharts-label", o && "highcharts-tooltip-header", d ? "highcharts-tooltip-box" : "highcharts-tooltip", !o && "highcharts-color-" + M(m.colorIndex, n.colorIndex), r && r.className].filter(u).join(" ");
        }, C.prototype.getLabel = function () {
          var m = this,
            d = this.chart.styledMode,
            o = this.options,
            n = this.split && this.allowShared,
            r = o.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none"),
            i,
            t = this.chart.renderer;
          if (m.label) {
            var e = !m.label.hasClass("highcharts-label");
            (n && !e || !n && e) && m.destroy();
          }
          if (!this.label) {
            if (this.outside) {
              e = this.chart.options.chart.style;
              var a = H.getRendererType();
              this.container = i = E.doc.createElement("div"), i.className = "highcharts-tooltip-container", k(i, {
                position: "absolute",
                top: "1px",
                pointerEvents: r,
                zIndex: Math.max(this.options.style.zIndex || 0, (e && e.zIndex || 0) + 3)
              }), E.doc.body.appendChild(i), this.renderer = t = new a(i, 0, 0, e, void 0, void 0, t.styledMode);
            }
            if (n ? this.label = t.g("tooltip") : (this.label = t.label("", 0, 0, o.shape, void 0, void 0, o.useHTML, void 0, "tooltip").attr({
              padding: o.padding,
              r: o.borderRadius
            }), d || this.label.attr({
              fill: o.backgroundColor,
              "stroke-width": o.borderWidth
            }).css(o.style).css({
              pointerEvents: r
            }).shadow(o.shadow)), d && o.shadow && (this.applyFilter(), this.label.attr({
              filter: "url(#drop-shadow-" + this.chart.index + ")"
            })), m.outside && !m.split) {
              var c = this.label,
                y = c.xSetter,
                b = c.ySetter;
              c.xSetter = function (j) {
                y.call(c, m.distance), i.style.left = j + "px";
              }, c.ySetter = function (j) {
                b.call(c, m.distance), i.style.top = j + "px";
              };
            }
            this.label.attr({
              zIndex: 8
            }).add();
          }
          return this.label;
        }, C.prototype.getPosition = function (m, d, o) {
          var n = this.chart,
            r = this.distance,
            i = {},
            t = n.inverted && o.h || 0,
            e = this.outside,
            a = e ? z.documentElement.clientWidth - 2 * r : n.chartWidth,
            c = e ? Math.max(z.body.scrollHeight, z.documentElement.scrollHeight, z.body.offsetHeight, z.documentElement.offsetHeight, z.documentElement.clientHeight) : n.chartHeight,
            y = n.pointer.getChartPosition(),
            b = function b(G) {
              var _ = G === "x";
              return [G, _ ? a : c, _ ? m : d].concat(e ? [_ ? m * y.scaleX : d * y.scaleY, _ ? y.left - r + (o.plotX + n.plotLeft) * y.scaleX : y.top - r + (o.plotY + n.plotTop) * y.scaleY, 0, _ ? a : c] : [_ ? m : d, _ ? o.plotX + n.plotLeft : o.plotY + n.plotTop, _ ? n.plotLeft : n.plotTop, _ ? n.plotLeft + n.plotWidth : n.plotTop + n.plotHeight]);
            },
            j = b("y"),
            P = b("x"),
            f;
          b = !!o.negative, !n.polar && n.hoverSeries && n.hoverSeries.yAxis && n.hoverSeries.yAxis.reversed && (b = !b);
          var x = !this.followPointer && M(o.ttBelow, !n.inverted === b),
            N = function N(G, _, q, Y, U, Z, J) {
              var et = e ? G === "y" ? r * y.scaleY : r * y.scaleX : r,
                nt = (q - Y) / 2,
                lt = Y < U - r,
                ct = U + r + Y < _,
                tt = U - et - q + nt;
              if (U = U + et - nt, x && ct) i[G] = U;else if (!x && lt) i[G] = tt;else if (lt) i[G] = Math.min(J - Y, 0 > tt - t ? tt : tt - t);else if (ct) i[G] = Math.max(Z, U + t + q > _ ? U : U + t);else return !1;
            },
            R = function R(G, _, q, Y, U) {
              var Z;
              return U < r || U > _ - r ? Z = !1 : i[G] = U < q / 2 ? 1 : U > _ - Y / 2 ? _ - Y - 2 : U - q / 2, Z;
            },
            F = function F(G) {
              var _ = j;
              j = P, P = _, f = G;
            },
            T = function T() {
              N.apply(0, j) !== !1 ? R.apply(0, P) !== !1 || f || (F(!0), T()) : f ? i.x = i.y = 0 : (F(!0), T());
            };
          return (n.inverted || 1 < this.len) && F(), T(), i;
        }, C.prototype.hide = function (m) {
          var d = this;
          X.clearTimeout(this.hideTimer), m = M(m, this.options.hideDelay), this.isHidden || (this.hideTimer = L(function () {
            d.getLabel().fadeOut(m && void 0), d.isHidden = !0;
          }, m));
        }, C.prototype.init = function (m, d) {
          this.chart = m, this.options = d, this.crosshairs = [], this.now = {
            x: 0,
            y: 0
          }, this.isHidden = !0, this.split = d.split && !m.inverted && !m.polar, this.shared = d.shared || this.split, this.outside = M(d.outside, !(!m.scrollablePixelsX && !m.scrollablePixelsY));
        }, C.prototype.shouldStickOnContact = function (m) {
          return !(this.followPointer || !this.options.stickOnContact || m && !this.chart.pointer.inClass(m.target, "highcharts-tooltip"));
        }, C.prototype.move = function (m, d, o, n) {
          var r = this,
            i = r.now,
            t = r.options.animation !== !1 && !r.isHidden && (1 < Math.abs(m - i.x) || 1 < Math.abs(d - i.y)),
            e = r.followPointer || 1 < r.len;
          p(i, {
            x: t ? (2 * i.x + m) / 3 : m,
            y: t ? (i.y + d) / 2 : d,
            anchorX: e ? void 0 : t ? (2 * i.anchorX + o) / 3 : o,
            anchorY: e ? void 0 : t ? (i.anchorY + n) / 2 : n
          }), r.getLabel().attr(i), r.drawTracker(), t && (X.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function () {
            r && r.move(m, d, o, n);
          }, 32));
        }, C.prototype.refresh = function (m, d) {
          var o = this.chart,
            n = this.options,
            r = o.pointer,
            i = I(m),
            t = i[0],
            e = [],
            a = n.formatter || this.defaultFormatter,
            c = this.shared,
            y = o.styledMode,
            b = {};
          if (n.enabled && t.series) {
            X.clearTimeout(this.hideTimer), this.allowShared = !(!s(m) && m.series && m.series.noSharedTooltip), this.followPointer = !this.split && t.series.tooltipOptions.followPointer, m = this.getAnchor(m, d);
            var j = m[0],
              P = m[1];
            if (c && this.allowShared ? (r.applyInactiveState(i), i.forEach(function (N) {
              N.setState("hover"), e.push(N.getLabelConfig());
            }), b = {
              x: t.category,
              y: t.y
            }, b.points = e) : b = t.getLabelConfig(), this.len = e.length, a = a.call(b, this), c = t.series, this.distance = M(c.tooltipOptions.distance, 16), a === !1) this.hide();else {
              if (this.split && this.allowShared) this.renderSplit(a, i);else {
                var f = j,
                  x = P;
                if (d && r.isDirectTouch && (f = d.chartX - o.plotLeft, x = d.chartY - o.plotTop), o.polar || c.options.clip === !1 || i.some(function (N) {
                  return r.isDirectTouch || N.series.shouldShowTooltip(f, x);
                })) d = this.getLabel(), n.style.width && !y || d.css({
                  width: o.spacingBox.width + "px"
                }), d.attr({
                  text: a && a.join ? a.join("") : a
                }), d.addClass(this.getClassName(t), !0), y || d.attr({
                  stroke: n.borderColor || t.color || c.color || "#666666"
                }), this.updatePosition({
                  plotX: j,
                  plotY: P,
                  negative: t.negative,
                  ttBelow: t.ttBelow,
                  h: m[2] || 0
                });else {
                  this.hide();
                  return;
                }
              }
              this.isHidden && this.label && this.label.attr({
                opacity: 1
              }).show(), this.isHidden = !1;
            }
            h(this, "refresh");
          }
        }, C.prototype.renderSplit = function (m, d) {
          function o(ct, tt, st, it, $) {
            return $ === void 0 && ($ = !0), st ? (tt = Y ? 0 : et, ct = A(ct - it / 2, G.left, G.right - it - (n.outside ? U : 0))) : (tt -= Z, ct = $ ? ct - it - R : ct + R, ct = A(ct, $ ? ct : G.left, G.right)), {
              x: ct,
              y: tt
            };
          }
          var n = this,
            r = n.chart,
            i = n.chart,
            t = i.chartWidth,
            e = i.chartHeight,
            a = i.plotHeight,
            c = i.plotLeft,
            y = i.plotTop,
            b = i.pointer,
            j = i.scrollablePixelsY;
          j = j === void 0 ? 0 : j;
          var P = i.scrollablePixelsX,
            f = i.scrollingContainer;
          f = f === void 0 ? {
            scrollLeft: 0,
            scrollTop: 0
          } : f;
          var x = f.scrollLeft;
          f = f.scrollTop;
          var N = i.styledMode,
            R = n.distance,
            F = n.options,
            T = n.options.positioner,
            G = n.outside && typeof P != "number" ? z.documentElement.getBoundingClientRect() : {
              left: x,
              right: x + t,
              top: f,
              bottom: f + e
            },
            _ = n.getLabel(),
            q = this.renderer || r.renderer,
            Y = !(!r.xAxis[0] || !r.xAxis[0].opposite);
          r = b.getChartPosition();
          var U = r.left;
          r = r.top;
          var Z = y + f,
            J = 0,
            et = a - j;
          u(m) && (m = [!1, m]), m = m.slice(0, d.length + 1).reduce(function (ct, tt, st) {
            if (tt !== !1 && tt !== "") {
              st = d[st - 1] || {
                isHeader: !0,
                plotX: d[0].plotX,
                plotY: a,
                series: {}
              };
              var it = st.isHeader,
                $ = it ? n : st.series;
              tt = tt.toString();
              var Q = $.tt,
                ot = st.isHeader,
                at = st.series;
              Q || (Q = {
                padding: F.padding,
                r: F.borderRadius
              }, N || (Q.fill = F.backgroundColor, Q["stroke-width"] = F.borderWidth), Q = q.label("", 0, 0, F[ot ? "headerShape" : "shape"], void 0, void 0, F.useHTML).addClass(n.getClassName(st, !0, ot)).attr(Q).add(_)), Q.isActive = !0, Q.attr({
                text: tt
              }), N || Q.css(F.style).shadow(F.shadow).attr({
                stroke: F.borderColor || st.color || at.color || "#333333"
              }), $ = $.tt = Q, ot = $.getBBox(), tt = ot.width + $.strokeWidth(), it && (J = ot.height, et += J, Y && (Z -= J)), at = st.plotX, at = at === void 0 ? 0 : at, Q = st.plotY, Q = Q === void 0 ? 0 : Q;
              var rt = st.series;
              if (st.isHeader) {
                at = c + at;
                var ht = y + a / 2;
              } else {
                var pt = rt.xAxis,
                  dt = rt.yAxis;
                at = pt.pos + A(at, -R, pt.len + R), rt.shouldShowTooltip(0, dt.pos - y + Q, {
                  ignoreX: !0
                }) && (ht = dt.pos + Q);
              }
              at = A(at, G.left - R, G.right + R), typeof ht == "number" ? (ot = ot.height + 1, Q = T ? T.call(n, tt, ot, st) : o(at, ht, it, tt), ct.push({
                align: T ? 0 : void 0,
                anchorX: at,
                anchorY: ht,
                boxWidth: tt,
                point: st,
                rank: M(Q.rank, it ? 1 : 0),
                size: ot,
                target: Q.y,
                tt: $,
                x: Q.x
              })) : $.isActive = !1;
            }
            return ct;
          }, []), !T && m.some(function (ct) {
            var tt = (n.outside ? U : 0) + ct.anchorX;
            return tt < G.left && tt + ct.boxWidth < G.right ? !0 : tt < U - G.left + ct.boxWidth && G.right - tt > tt;
          }) && (m = m.map(function (ct) {
            var tt = o(ct.anchorX, ct.anchorY, ct.point.isHeader, ct.boxWidth, !1);
            return p(ct, {
              target: tt.y,
              x: tt.x
            });
          })), n.cleanSplit(), w(m, et);
          var nt = U,
            lt = U;
          m.forEach(function (ct) {
            var tt = ct.x,
              st = ct.boxWidth;
            ct = ct.isHeader, ct || (n.outside && U + tt < nt && (nt = U + tt), !ct && n.outside && nt + st > lt && (lt = U + tt));
          }), m.forEach(function (ct) {
            var tt = ct.x,
              st = ct.anchorX,
              it = ct.pos,
              $ = ct.point.isHeader;
            if (it = {
              visibility: typeof it > "u" ? "hidden" : "inherit",
              x: tt,
              y: (it || 0) + Z,
              anchorX: st,
              anchorY: ct.anchorY
            }, n.outside && tt < st) {
              var Q = U - nt;
              0 < Q && ($ || (it.x = tt + Q, it.anchorX = st + Q), $ && (it.x = (lt - nt) / 2, it.anchorX = st + Q));
            }
            ct.tt.attr(it);
          }), m = n.container, j = n.renderer, n.outside && m && j && (i = _.getBBox(), j.setSize(i.width + i.x, i.height + i.y, !1), m.style.left = nt + "px", m.style.top = r + "px");
        }, C.prototype.drawTracker = function () {
          if (this.shouldStickOnContact()) {
            var m = this.chart,
              d = this.label,
              o = this.shared ? m.hoverPoints : m.hoverPoint;
            if (d && o) {
              var n = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
              };
              o = this.getAnchor(o);
              var r = d.getBBox();
              o[0] += m.plotLeft - d.translateX, o[1] += m.plotTop - d.translateY, n.x = Math.min(0, o[0]), n.y = Math.min(0, o[1]), n.width = 0 > o[0] ? Math.max(Math.abs(o[0]), r.width - o[0]) : Math.max(Math.abs(o[0]), r.width), n.height = 0 > o[1] ? Math.max(Math.abs(o[1]), r.height - Math.abs(o[1])) : Math.max(Math.abs(o[1]), r.height), this.tracker ? this.tracker.attr(n) : (this.tracker = d.renderer.rect(n).addClass("highcharts-tracker").add(d), m.styledMode || this.tracker.attr({
                fill: "rgba(0,0,0,0)"
              }));
            }
          } else this.tracker && this.tracker.destroy();
        }, C.prototype.styledModeFormat = function (m) {
          return m.replace('style="font-size: 10px"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
        }, C.prototype.tooltipFooterHeaderFormatter = function (m, d) {
          var o = m.series,
            n = o.tooltipOptions,
            r = o.xAxis,
            i = r && r.dateTime;
          r = {
            isFooter: d,
            labelConfig: m
          };
          var t = n.xDateFormat,
            e = n[d ? "footerFormat" : "headerFormat"];
          return h(this, "headerFormatter", r, function (a) {
            i && !t && l(m.key) && (t = i.getXDateFormat(m.key, n.dateTimeLabelFormats)), i && t && (m.point && m.point.tooltipDateKeys || ["key"]).forEach(function (c) {
              e = e.replace("{point." + c + "}", "{point." + c + ":" + t + "}");
            }), o.chart.styledMode && (e = this.styledModeFormat(e)), a.text = W(e, {
              point: m,
              series: o
            }, this.chart);
          }), r.text;
        }, C.prototype.update = function (m) {
          this.destroy(), v(!0, this.chart.options.tooltip.userOptions, m), this.init(this.chart, v(!0, this.options, m));
        }, C.prototype.updatePosition = function (m) {
          var d = this.chart,
            o = this.distance,
            n = this.options,
            r = d.pointer,
            i = this.getLabel(),
            t = r.getChartPosition();
          r = t.left;
          var e = t.top,
            a = t.scaleX;
          t = t.scaleY;
          var c = (n.positioner || this.getPosition).call(this, i.width, i.height, m),
            y = (m.plotX || 0) + d.plotLeft;
          m = (m.plotY || 0) + d.plotTop, this.outside && (n.positioner && (c.x += r - o, c.y += e - o), o = n.borderWidth + 2 * o, this.renderer.setSize(i.width + o, i.height + o, !1), (a !== 1 || t !== 1) && (k(this.container, {
            transform: "scale(".concat(a, ", ").concat(t, ")")
          }), y *= a, m *= t), y += r - c.x, m += e - c.y), this.move(Math.round(c.x), Math.round(c.y || 0), y, m);
        }, C;
      }(), D;
    }), V(S, "Core/Series/Point.js", [S["Core/Renderer/HTML/AST.js"], S["Core/Animation/AnimationUtilities.js"], S["Core/Defaults.js"], S["Core/FormatUtilities.js"], S["Core/Utilities.js"]], function (D, E, B, H, X) {
      var W = E.animObject,
        z = B.defaultOptions,
        w = H.format,
        A = X.addEvent,
        k = X.defined,
        g = X.erase,
        p = X.extend,
        h = X.fireEvent,
        s = X.getNestedProperty,
        l = X.isArray,
        u = X.isFunction,
        v = X.isNumber,
        M = X.isObject,
        I = X.merge,
        L = X.objectEach,
        C = X.pick,
        m = X.syncTimeout,
        d = X.removeEvent,
        o = X.uniqueKey;
      return E = function () {
        function n() {
          this.category = void 0, this.formatPrefix = "point", this.id = void 0, this.isNull = !1, this.percentage = this.options = this.name = void 0, this.selected = !1, this.total = this.shapeArgs = this.series = void 0, this.visible = !0, this.x = void 0;
        }
        return n.prototype.animateBeforeDestroy = function () {
          var r = this,
            i = {
              x: r.startXPos,
              opacity: 0
            },
            t = r.getGraphicalProps();
          t.singular.forEach(function (e) {
            r[e] = r[e].animate(e === "dataLabel" ? {
              x: r[e].startXPos,
              y: r[e].startYPos,
              opacity: 0
            } : i);
          }), t.plural.forEach(function (e) {
            r[e].forEach(function (a) {
              a.element && a.animate(p({
                x: r.startXPos
              }, a.startYPos ? {
                x: a.startXPos,
                y: a.startYPos
              } : {}));
            });
          });
        }, n.prototype.applyOptions = function (r, i) {
          var t = this.series,
            e = t.options.pointValKey || t.pointValKey;
          return r = n.prototype.optionsToObject.call(this, r), p(this, r), this.options = this.options ? p(this.options, r) : r, r.group && delete this.group, r.dataLabels && delete this.dataLabels, e && (this.y = n.prototype.getNestedProperty.call(this, e)), this.formatPrefix = (this.isNull = this.isValid && !this.isValid()) ? "null" : "point", this.selected && (this.state = "select"), "name" in this && typeof i > "u" && t.xAxis && t.xAxis.hasNames && (this.x = t.xAxis.nameToX(this)), typeof this.x > "u" && t ? this.x = typeof i > "u" ? t.autoIncrement() : i : v(r.x) && t.options.relativeXValue && (this.x = t.autoIncrement(r.x)), this;
        }, n.prototype.destroy = function () {
          function r() {
            (i.graphic || i.graphics || i.dataLabel || i.dataLabels) && (d(i), i.destroyElements());
            for (y in i) i[y] = null;
          }
          var i = this,
            t = i.series,
            e = t.chart;
          t = t.options.dataSorting;
          var a = e.hoverPoints,
            c = W(i.series.chart.renderer.globalAnimation),
            y;
          i.legendItem && e.legend.destroyItem(i), a && (i.setState(), g(a, i), a.length || (e.hoverPoints = null)), i === e.hoverPoint && i.onMouseOut(), t && t.enabled ? (this.animateBeforeDestroy(), m(r, c.duration)) : r(), e.pointCount--;
        }, n.prototype.destroyElements = function (r) {
          var i = this;
          r = i.getGraphicalProps(r), r.singular.forEach(function (t) {
            i[t] = i[t].destroy();
          }), r.plural.forEach(function (t) {
            i[t].forEach(function (e) {
              e && e.element && e.destroy();
            }), delete i[t];
          });
        }, n.prototype.firePointEvent = function (r, i, t) {
          var e = this,
            a = this.series.options;
          (a.point.events[r] || e.options && e.options.events && e.options.events[r]) && e.importEvents(), r === "click" && a.allowPointSelect && (t = function t(c) {
            e.select && e.select(null, c.ctrlKey || c.metaKey || c.shiftKey);
          }), h(e, r, i, t);
        }, n.prototype.getClassName = function () {
          return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + (typeof this.colorIndex < "u" ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
        }, n.prototype.getGraphicalProps = function (r) {
          var i = this,
            t = [],
            e = {
              singular: [],
              plural: []
            },
            a;
          for (r = r || {
            graphic: 1,
            dataLabel: 1
          }, r.graphic && t.push("graphic", "shadowGroup"), r.dataLabel && t.push("dataLabel", "dataLabelPath", "dataLabelUpper", "connector"), a = t.length; a--;) {
            var c = t[a];
            i[c] && e.singular.push(c);
          }
          return ["graphic", "dataLabel", "connector"].forEach(function (y) {
            var b = y + "s";
            r[y] && i[b] && e.plural.push(b);
          }), e;
        }, n.prototype.getLabelConfig = function () {
          return {
            x: this.category,
            y: this.y,
            color: this.color,
            colorIndex: this.colorIndex,
            key: this.name || this.category,
            series: this.series,
            point: this,
            percentage: this.percentage,
            total: this.total || this.stackTotal
          };
        }, n.prototype.getNestedProperty = function (r) {
          if (r) return r.indexOf("custom.") === 0 ? s(r, this.options) : this[r];
        }, n.prototype.getZone = function () {
          var r = this.series,
            i = r.zones;
          r = r.zoneAxis || "y";
          var t,
            e = 0;
          for (t = i[e]; this[r] >= t.value;) t = i[++e];
          return this.nonZonedColor || (this.nonZonedColor = this.color), this.color = t && t.color && !this.options.color ? t.color : this.nonZonedColor, t;
        }, n.prototype.hasNewShapeType = function () {
          return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
        }, n.prototype.init = function (r, i, t) {
          return this.series = r, this.applyOptions(i, t), this.id = k(this.id) ? this.id : o(), this.resolveColor(), r.chart.pointCount++, h(this, "afterInit"), this;
        }, n.prototype.isValid = function () {
          return this.x !== null && v(this.y);
        }, n.prototype.optionsToObject = function (r) {
          var i = this.series,
            t = i.options.keys,
            e = t || i.pointArrayMap || ["y"],
            a = e.length,
            c = {},
            y = 0,
            b = 0;
          if (v(r) || r === null) c[e[0]] = r;else if (l(r)) for (!t && r.length > a && (i = typeof r[0], i === "string" ? c.name = r[0] : i === "number" && (c.x = r[0]), y++); b < a;) t && typeof r[y] > "u" || (0 < e[b].indexOf(".") ? n.prototype.setNestedProperty(c, r[y], e[b]) : c[e[b]] = r[y]), y++, b++;else typeof r == "object" && (c = r, r.dataLabels && (i._hasPointLabels = !0), r.marker && (i._hasPointMarkers = !0));
          return c;
        }, n.prototype.pos = function (r, i) {
          i === void 0 && (i = this.plotY);
          var t = this.plotX,
            e = this.series,
            a = e.chart,
            c = e.xAxis;
          e = e.yAxis;
          var y = 0,
            b = 0;
          if (v(t) && v(i)) return r && (y = c ? c.pos : a.plotLeft, b = e ? e.pos : a.plotTop), a.inverted && c && e ? [e.len - i + b, c.len - t + y] : [t + y, i + b];
        }, n.prototype.resolveColor = function () {
          var r = this.series,
            i = r.chart.styledMode,
            t = r.chart.options.chart.colorCount;
          if (delete this.nonZonedColor, r.options.colorByPoint) {
            if (!i) {
              t = r.options.colors || r.chart.options.colors;
              var e = t[r.colorCounter];
              t = t.length;
            }
            i = r.colorCounter, r.colorCounter++, r.colorCounter === t && (r.colorCounter = 0);
          } else i || (e = r.color), i = r.colorIndex;
          this.colorIndex = C(this.options.colorIndex, i), this.color = C(this.options.color, e);
        }, n.prototype.setNestedProperty = function (r, i, t) {
          return t.split(".").reduce(function (e, a, c, y) {
            return e[a] = y.length - 1 === c ? i : M(e[a], !0) ? e[a] : {}, e[a];
          }, r), r;
        }, n.prototype.shouldDraw = function () {
          return !this.isNull;
        }, n.prototype.tooltipFormatter = function (r) {
          var i = this.series,
            t = i.tooltipOptions,
            e = C(t.valueDecimals, ""),
            a = t.valuePrefix || "",
            c = t.valueSuffix || "";
          return i.chart.styledMode && (r = i.chart.tooltip.styledModeFormat(r)), (i.pointArrayMap || ["y"]).forEach(function (y) {
            y = "{point." + y, (a || c) && (r = r.replace(RegExp(y + "}", "g"), a + y + "}" + c)), r = r.replace(RegExp(y + "}", "g"), y + ":,." + e + "f}");
          }), w(r, {
            point: this,
            series: this.series
          }, i.chart);
        }, n.prototype.update = function (r, i, t, e) {
          function a() {
            c.applyOptions(r);
            var x = b && c.hasMockGraphic;
            x = c.y === null ? !x : x, b && x && (c.graphic = b.destroy(), delete c.hasMockGraphic), M(r, !0) && (b && b.element && r && r.marker && typeof r.marker.symbol < "u" && (c.graphic = b.destroy()), r && r.dataLabels && c.dataLabel && (c.dataLabel = c.dataLabel.destroy()), c.connector && (c.connector = c.connector.destroy())), f = c.index, y.updateParallelArrays(c, f), P.data[f] = M(P.data[f], !0) || M(r, !0) ? c.options : C(r, P.data[f]), y.isDirty = y.isDirtyData = !0, !y.fixedBox && y.hasCartesianSeries && (j.isDirtyBox = !0), P.legendType === "point" && (j.isDirtyLegend = !0), i && j.redraw(t);
          }
          var c = this,
            y = c.series,
            b = c.graphic,
            j = y.chart,
            P = y.options,
            f;
          i = C(i, !0), e === !1 ? a() : c.firePointEvent("update", {
            options: r
          }, a);
        }, n.prototype.remove = function (r, i) {
          this.series.removePoint(this.series.data.indexOf(this), r, i);
        }, n.prototype.select = function (r, i) {
          var t = this,
            e = t.series,
            a = e.chart;
          this.selectedStaging = r = C(r, !t.selected), t.firePointEvent(r ? "select" : "unselect", {
            accumulate: i
          }, function () {
            t.selected = t.options.selected = r, e.options.data[e.data.indexOf(t)] = t.options, t.setState(r && "select"), i || a.getSelectedPoints().forEach(function (c) {
              var y = c.series;
              c.selected && c !== t && (c.selected = c.options.selected = !1, y.options.data[y.data.indexOf(c)] = c.options, c.setState(a.hoverPoints && y.options.inactiveOtherPoints ? "inactive" : ""), c.firePointEvent("unselect"));
            });
          }), delete this.selectedStaging;
        }, n.prototype.onMouseOver = function (r) {
          var i = this.series.chart,
            t = i.pointer;
          r = r ? t.normalize(r) : t.getChartCoordinatesFromPoint(this, i.inverted), t.runPointActions(r, this);
        }, n.prototype.onMouseOut = function () {
          var r = this.series.chart;
          this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (r.hoverPoints || []).forEach(function (i) {
            i.setState();
          }), r.hoverPoints = r.hoverPoint = null;
        }, n.prototype.importEvents = function () {
          if (!this.hasImportedEvents) {
            var r = this,
              i = I(r.series.options.point, r.options).events;
            r.events = i, L(i, function (t, e) {
              u(t) && A(r, e, t);
            }), this.hasImportedEvents = !0;
          }
        }, n.prototype.setState = function (r, i) {
          var t = this.series,
            e = this.state,
            a = t.options.states[r || "normal"] || {},
            c = z.plotOptions[t.type].marker && t.options.marker,
            y = c && c.enabled === !1,
            b = c && c.states && c.states[r || "normal"] || {},
            j = b.enabled === !1,
            P = this.marker || {},
            f = t.chart,
            x = c && t.markerAttribs,
            N = t.halo,
            R,
            F = t.stateMarkerGraphic;
          if (r = r || "", !(r === this.state && !i || this.selected && r !== "select" || a.enabled === !1 || r && (j || y && b.enabled === !1) || r && P.states && P.states[r] && P.states[r].enabled === !1)) {
            if (this.state = r, x && (R = t.markerAttribs(this, r)), this.graphic && !this.hasMockGraphic) {
              if (e && this.graphic.removeClass("highcharts-point-" + e), r && this.graphic.addClass("highcharts-point-" + r), !f.styledMode) {
                e = t.pointAttribs(this, r);
                var T = C(f.options.chart.animation, a.animation),
                  G = e.opacity;
                t.options.inactiveOtherPoints && v(G) && ((this.dataLabels || []).forEach(function (_) {
                  _ && !_.hasClass("highcharts-data-label-hidden") && _.animate({
                    opacity: G
                  }, T);
                }), this.connector && this.connector.animate({
                  opacity: G
                }, T)), this.graphic.animate(e, T);
              }
              R && this.graphic.animate(R, C(f.options.chart.animation, b.animation, c.animation)), F && F.hide();
            } else r && b && (c = P.symbol || t.symbol, F && F.currentSymbol !== c && (F = F.destroy()), R && (F ? F[i ? "animate" : "attr"]({
              x: R.x,
              y: R.y
            }) : c && (t.stateMarkerGraphic = F = f.renderer.symbol(c, R.x, R.y, R.width, R.height).add(t.markerGroup), F.currentSymbol = c)), !f.styledMode && F && this.state !== "inactive" && F.attr(t.pointAttribs(this, r))), F && (F[r && this.isInside ? "show" : "hide"](), F.element.point = this, F.addClass(this.getClassName(), !0));
            a = a.halo, R = (F = this.graphic || F) && F.visibility || "inherit", a && a.size && F && R !== "hidden" && !this.isCluster ? (N || (t.halo = N = f.renderer.path().add(F.parentGroup)), N.show()[i ? "animate" : "attr"]({
              d: this.haloPath(a.size)
            }), N.attr({
              class: "highcharts-halo highcharts-color-" + C(this.colorIndex, t.colorIndex) + (this.className ? " " + this.className : ""),
              visibility: R,
              zIndex: -1
            }), N.point = this, f.styledMode || N.attr(p({
              fill: this.color || t.color,
              "fill-opacity": a.opacity
            }, D.filterUserAttributes(a.attributes || {})))) : N && N.point && N.point.haloPath && N.animate({
              d: N.point.haloPath(0)
            }, null, N.hide), h(this, "afterSetState", {
              state: r
            });
          }
        }, n.prototype.haloPath = function (r) {
          var i = this.pos();
          return i ? this.series.chart.renderer.symbols.circle(Math.floor(i[0]) - r, i[1] - r, 2 * r, 2 * r) : [];
        }, n;
      }(), E;
    }), V(S, "Core/Pointer.js", [S["Core/Color/Color.js"], S["Core/Globals.js"], S["Core/Tooltip.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = D.parse,
        W = E.charts,
        z = E.noop,
        w = H.addEvent,
        A = H.attr,
        k = H.css,
        g = H.defined,
        p = H.extend,
        h = H.find,
        s = H.fireEvent,
        l = H.isNumber,
        u = H.isObject,
        v = H.objectEach,
        M = H.offset,
        I = H.pick,
        L = H.splat;
      return D = function () {
        function C(m, d) {
          this.lastValidTouch = {}, this.pinchDown = [], this.runChartClick = !1, this.eventsToUnbind = [], this.chart = m, this.hasDragged = !1, this.options = d, this.init(m, d);
        }
        return C.prototype.applyInactiveState = function (m) {
          var d = [],
            o;
          (m || []).forEach(function (n) {
            o = n.series, d.push(o), o.linkedParent && d.push(o.linkedParent), o.linkedSeries && (d = d.concat(o.linkedSeries)), o.navigatorSeries && d.push(o.navigatorSeries);
          }), this.chart.series.forEach(function (n) {
            d.indexOf(n) === -1 ? n.setState("inactive", !0) : n.options.inactiveOtherPoints && n.setAllPointsToState("inactive");
          });
        }, C.prototype.destroy = function () {
          var m = this;
          this.eventsToUnbind.forEach(function (d) {
            return d();
          }), this.eventsToUnbind = [], E.chartCount || (C.unbindDocumentMouseUp && (C.unbindDocumentMouseUp = C.unbindDocumentMouseUp()), C.unbindDocumentTouchEnd && (C.unbindDocumentTouchEnd = C.unbindDocumentTouchEnd())), clearInterval(m.tooltipTimeout), v(m, function (d, o) {
            m[o] = void 0;
          });
        }, C.prototype.getSelectionMarkerAttrs = function (m, d) {
          var o = this,
            n = {
              args: {
                chartX: m,
                chartY: d
              },
              attrs: {},
              shapeType: "rect"
            };
          return s(this, "getSelectionMarkerAttrs", n, function (r) {
            var i = o.chart,
              t = o.mouseDownX;
            t = t === void 0 ? 0 : t;
            var e = o.mouseDownY;
            e = e === void 0 ? 0 : e;
            var a = o.zoomHor,
              c = o.zoomVert;
            r = r.attrs, r.x = i.plotLeft, r.y = i.plotTop, r.width = a ? 1 : i.plotWidth, r.height = c ? 1 : i.plotHeight, a && (i = m - t, r.width = Math.abs(i), r.x = (0 < i ? 0 : i) + t), c && (i = d - e, r.height = Math.abs(i), r.y = (0 < i ? 0 : i) + e);
          }), n;
        }, C.prototype.drag = function (m) {
          var d = this.chart,
            o = d.options.chart,
            n = d.plotLeft,
            r = d.plotTop,
            i = d.plotWidth,
            t = d.plotHeight,
            e = this.mouseDownX || 0,
            a = this.mouseDownY || 0,
            c = u(o.panning) ? o.panning && o.panning.enabled : o.panning,
            y = o.panKey && m[o.panKey + "Key"],
            b = m.chartX,
            j = m.chartY,
            P = this.selectionMarker;
          P && P.touch || (b < n ? b = n : b > n + i && (b = n + i), j < r ? j = r : j > r + t && (j = r + t), this.hasDragged = Math.sqrt(Math.pow(e - b, 2) + Math.pow(a - j, 2)), 10 < this.hasDragged && (n = d.isInsidePlot(e - n, a - r, {
            visiblePlotOnly: !0
          }), j = this.getSelectionMarkerAttrs(b, j), b = j.shapeType, j = j.attrs, !d.hasCartesianSeries && !d.mapView || !this.zoomX && !this.zoomY || !n || y || P || (this.selectionMarker = P = d.renderer[b](), P.attr({
            class: "highcharts-selection-marker",
            zIndex: 7
          }).add(), d.styledMode || P.attr({
            fill: o.selectionMarkerFill || X("#335cad").setOpacity(0.25).get()
          })), P && P.attr(j), n && !P && c && d.pan(m, o.panning)));
        }, C.prototype.dragStart = function (m) {
          var d = this.chart;
          d.mouseIsDown = m.type, d.cancelClick = !1, d.mouseDownX = this.mouseDownX = m.chartX, d.mouseDownY = this.mouseDownY = m.chartY;
        }, C.prototype.getSelectionBox = function (m) {
          var d = {
            args: {
              marker: m
            },
            result: {}
          };
          return s(this, "getSelectionBox", d, function (o) {
            o.result = {
              x: m.attr ? +m.attr("x") : m.x,
              y: m.attr ? +m.attr("y") : m.y,
              width: m.attr ? m.attr("width") : m.width,
              height: m.attr ? m.attr("height") : m.height
            };
          }), d.result;
        }, C.prototype.drop = function (m) {
          var d = this,
            o = this.chart,
            n = this.hasPinched;
          if (this.selectionMarker) {
            var r = this.getSelectionBox(this.selectionMarker),
              i = r.x,
              t = r.y,
              e = r.width,
              a = r.height,
              c = {
                originalEvent: m,
                xAxis: [],
                yAxis: [],
                x: i,
                y: t,
                width: e,
                height: a
              },
              y = !!o.mapView;
            (this.hasDragged || n) && (o.axes.forEach(function (b) {
              if (b.zoomEnabled && g(b.min) && (n || d[{
                xAxis: "zoomX",
                yAxis: "zoomY"
              }[b.coll]]) && l(i) && l(t) && l(e) && l(a)) {
                var j = b.horiz,
                  P = m.type === "touchend" ? b.minPixelPadding : 0,
                  f = b.toValue((j ? i : t) + P);
                j = b.toValue((j ? i + e : t + a) - P), c[b.coll].push({
                  axis: b,
                  min: Math.min(f, j),
                  max: Math.max(f, j)
                }), y = !0;
              }
            }), y && s(o, "selection", c, function (b) {
              o.zoom(p(b, n ? {
                animation: !1
              } : null));
            })), l(o.index) && (this.selectionMarker = this.selectionMarker.destroy()), n && this.scaleGroups();
          }
          o && l(o.index) && (k(o.container, {
            cursor: o._cursor
          }), o.cancelClick = 10 < this.hasDragged, o.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
        }, C.prototype.findNearestKDPoint = function (m, d, o) {
          var n;
          return m.forEach(function (r) {
            var i = !(r.noSharedTooltip && d) && 0 > r.options.findNearestPointBy.indexOf("y");
            if (r = r.searchPoint(o, i), (i = u(r, !0) && r.series) && !(i = !u(n, !0))) {
              i = n.distX - r.distX;
              var t = n.dist - r.dist,
                e = (r.series.group && r.series.group.zIndex) - (n.series.group && n.series.group.zIndex);
              i = 0 < (i !== 0 && d ? i : t !== 0 ? t : e !== 0 ? e : n.series.index > r.series.index ? -1 : 1);
            }
            i && (n = r);
          }), n;
        }, C.prototype.getChartCoordinatesFromPoint = function (m, d) {
          var o = m.series,
            n = o.xAxis;
          o = o.yAxis;
          var r = m.shapeArgs;
          if (n && o) {
            var i = I(m.clientX, m.plotX),
              t = m.plotY || 0;
            return m.isNode && r && l(r.x) && l(r.y) && (i = r.x, t = r.y), d ? {
              chartX: o.len + o.pos - t,
              chartY: n.len + n.pos - i
            } : {
              chartX: i + n.pos,
              chartY: t + o.pos
            };
          }
          if (r && r.x && r.y) return {
            chartX: r.x,
            chartY: r.y
          };
        }, C.prototype.getChartPosition = function () {
          if (this.chartPosition) return this.chartPosition;
          var m = this.chart.container,
            d = M(m);
          this.chartPosition = {
            left: d.left,
            top: d.top,
            scaleX: 1,
            scaleY: 1
          };
          var o = m.offsetWidth;
          return m = m.offsetHeight, 2 < o && 2 < m && (this.chartPosition.scaleX = d.width / o, this.chartPosition.scaleY = d.height / m), this.chartPosition;
        }, C.prototype.getCoordinates = function (m) {
          var d = {
            xAxis: [],
            yAxis: []
          };
          return this.chart.axes.forEach(function (o) {
            d[o.isXAxis ? "xAxis" : "yAxis"].push({
              axis: o,
              value: o.toValue(m[o.horiz ? "chartX" : "chartY"])
            });
          }), d;
        }, C.prototype.getHoverData = function (m, d, o, n, r, i) {
          var t = [];
          n = !(!n || !m);
          var e = function e(b) {
              return b.visible && !(!r && b.directTouch) && I(b.options.enableMouseTracking, !0);
            },
            a = {
              chartX: i ? i.chartX : void 0,
              chartY: i ? i.chartY : void 0,
              shared: r
            };
          s(this, "beforeGetHoverData", a);
          var c = d && !d.stickyTracking ? [d] : o.filter(function (b) {
              return b.stickyTracking && (a.filter || e)(b);
            }),
            y = n || !i ? m : this.findNearestKDPoint(c, r, i);
          return d = y && y.series, y && (r && !d.noSharedTooltip ? (c = o.filter(function (b) {
            return a.filter ? a.filter(b) : e(b) && !b.noSharedTooltip;
          }), c.forEach(function (b) {
            var j = h(b.points, function (P) {
              return P.x === y.x && !P.isNull;
            });
            u(j) && (b.boosted && b.boost && (j = b.boost.getPoint(j)), t.push(j));
          })) : t.push(y)), a = {
            hoverPoint: y
          }, s(this, "afterGetHoverData", a), {
            hoverPoint: a.hoverPoint,
            hoverSeries: d,
            hoverPoints: t
          };
        }, C.prototype.getPointFromEvent = function (m) {
          m = m.target;
          for (var d; m && !d;) d = m.point, m = m.parentNode;
          return d;
        }, C.prototype.onTrackerMouseOut = function (m) {
          m = m.relatedTarget || m.toElement;
          var d = this.chart.hoverSeries;
          this.isDirectTouch = !1, !d || !m || d.stickyTracking || this.inClass(m, "highcharts-tooltip") || this.inClass(m, "highcharts-series-" + d.index) && this.inClass(m, "highcharts-tracker") || d.onMouseOut();
        }, C.prototype.inClass = function (m, d) {
          for (var o; m;) {
            if (o = A(m, "class")) {
              if (o.indexOf(d) !== -1) return !0;
              if (o.indexOf("highcharts-container") !== -1) return !1;
            }
            m = m.parentElement;
          }
        }, C.prototype.init = function (m, d) {
          this.options = d, this.chart = m, this.runChartClick = !(!d.chart.events || !d.chart.events.click), this.pinchDown = [], this.lastValidTouch = {}, B && (m.tooltip = new B(m, d.tooltip)), this.setDOMEvents();
        }, C.prototype.normalize = function (m, d) {
          var o = m.touches,
            n = o ? o.length ? o.item(0) : I(o.changedTouches, m.changedTouches)[0] : m;
          return d || (d = this.getChartPosition()), o = n.pageX - d.left, n = n.pageY - d.top, o /= d.scaleX, n /= d.scaleY, p(m, {
            chartX: Math.round(o),
            chartY: Math.round(n)
          });
        }, C.prototype.onContainerClick = function (m) {
          var d = this.chart,
            o = d.hoverPoint;
          m = this.normalize(m);
          var n = d.plotLeft,
            r = d.plotTop;
          d.cancelClick || (o && this.inClass(m.target, "highcharts-tracker") ? (s(o.series, "click", p(m, {
            point: o
          })), d.hoverPoint && o.firePointEvent("click", m)) : (p(m, this.getCoordinates(m)), d.isInsidePlot(m.chartX - n, m.chartY - r, {
            visiblePlotOnly: !0
          }) && s(d, "click", m)));
        }, C.prototype.onContainerMouseDown = function (m) {
          var d = ((m.buttons || m.button) & 1) === 1;
          m = this.normalize(m), E.isFirefox && m.button !== 0 && this.onContainerMouseMove(m), (typeof m.button > "u" || d) && (this.zoomOption(m), d && m.preventDefault && m.preventDefault(), this.dragStart(m));
        }, C.prototype.onContainerMouseLeave = function (m) {
          var d = W[I(C.hoverChartIndex, -1)],
            o = this.chart.tooltip;
          m = this.normalize(m), d && (m.relatedTarget || m.toElement) && (d.pointer.reset(), d.pointer.chartPosition = void 0), o && !o.isHidden && this.reset();
        }, C.prototype.onContainerMouseEnter = function (m) {
          delete this.chartPosition;
        }, C.prototype.onContainerMouseMove = function (m) {
          var d = this.chart,
            o = d.tooltip;
          m = this.normalize(m), this.setHoverChartIndex(), m.preventDefault || (m.returnValue = !1), (d.mouseIsDown === "mousedown" || this.touchSelect(m)) && this.drag(m), d.openMenu || !this.inClass(m.target, "highcharts-tracker") && !d.isInsidePlot(m.chartX - d.plotLeft, m.chartY - d.plotTop, {
            visiblePlotOnly: !0
          }) || o && o.shouldStickOnContact(m) || (this.inClass(m.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(m));
        }, C.prototype.onDocumentTouchEnd = function (m) {
          var d = W[I(C.hoverChartIndex, -1)];
          d && d.pointer.drop(m);
        }, C.prototype.onContainerTouchMove = function (m) {
          this.touchSelect(m) ? this.onContainerMouseMove(m) : this.touch(m);
        }, C.prototype.onContainerTouchStart = function (m) {
          this.touchSelect(m) ? this.onContainerMouseDown(m) : (this.zoomOption(m), this.touch(m, !0));
        }, C.prototype.onDocumentMouseMove = function (m) {
          var d = this.chart,
            o = d.tooltip,
            n = this.chartPosition;
          m = this.normalize(m, n), !n || d.isInsidePlot(m.chartX - d.plotLeft, m.chartY - d.plotTop, {
            visiblePlotOnly: !0
          }) || o && o.shouldStickOnContact(m) || this.inClass(m.target, "highcharts-tracker") || this.reset();
        }, C.prototype.onDocumentMouseUp = function (m) {
          var d = W[I(C.hoverChartIndex, -1)];
          d && d.pointer.drop(m);
        }, C.prototype.pinch = function (m) {
          var d = this,
            o = d.chart,
            n = d.pinchDown,
            r = m.touches || [],
            i = r.length,
            t = d.lastValidTouch,
            e = d.hasZoom,
            a = {},
            c = i === 1 && (d.inClass(m.target, "highcharts-tracker") && o.runTrackerClick || d.runChartClick),
            y = {},
            b = d.chart.tooltip;
          b = i === 1 && I(b && b.options.followTouchMove, !0);
          var j = d.selectionMarker;
          1 < i ? d.initiated = !0 : b && (d.initiated = !1), e && d.initiated && !c && m.cancelable !== !1 && m.preventDefault(), [].map.call(r, function (P) {
            return d.normalize(P);
          }), m.type === "touchstart" ? ([].forEach.call(r, function (P, f) {
            n[f] = {
              chartX: P.chartX,
              chartY: P.chartY
            };
          }), t.x = [n[0].chartX, n[1] && n[1].chartX], t.y = [n[0].chartY, n[1] && n[1].chartY], o.axes.forEach(function (P) {
            if (P.zoomEnabled) {
              var f = o.bounds[P.horiz ? "h" : "v"],
                x = P.minPixelPadding,
                N = P.toPixels(Math.min(I(P.options.min, P.dataMin), P.dataMin)),
                R = P.toPixels(Math.max(I(P.options.max, P.dataMax), P.dataMax)),
                F = Math.max(N, R);
              f.min = Math.min(P.pos, Math.min(N, R) - x), f.max = Math.max(P.pos + P.len, F + x);
            }
          }), d.res = !0) : b ? this.runPointActions(d.normalize(m)) : n.length && (s(o, "touchpan", {
            originalEvent: m
          }, function () {
            j || (d.selectionMarker = j = p({
              destroy: z,
              touch: !0
            }, o.plotBox)), d.pinchTranslate(n, r, a, j, y, t), d.hasPinched = e, d.scaleGroups(a, y);
          }), d.res && (d.res = !1, this.reset(!1, 0)));
        }, C.prototype.pinchTranslate = function (m, d, o, n, r, i) {
          this.zoomHor && this.pinchTranslateDirection(!0, m, d, o, n, r, i), this.zoomVert && this.pinchTranslateDirection(!1, m, d, o, n, r, i);
        }, C.prototype.pinchTranslateDirection = function (m, d, o, n, r, i, t, e) {
          var a = this.chart,
            c = m ? "x" : "y",
            y = m ? "X" : "Y",
            b = "chart" + y,
            j = m ? "width" : "height",
            P = a["plot" + (m ? "Left" : "Top")],
            f = a.inverted,
            x = a.bounds[m ? "h" : "v"],
            N = d.length === 1,
            R = d[0][b],
            F = !N && d[1][b];
          d = function d() {
            typeof Y == "number" && 20 < Math.abs(R - F) && (_ = e || Math.abs(q - Y) / Math.abs(R - F)), G = (P - q) / _ + R, T = a["plot" + (m ? "Width" : "Height")] / _;
          };
          var T,
            G,
            _ = e || 1,
            q = o[0][b],
            Y = !N && o[1][b];
          if (d(), o = G, o < x.min) {
            o = x.min;
            var U = !0;
          } else o + T > x.max && (o = x.max - T, U = !0);
          U ? (q -= 0.8 * (q - t[c][0]), typeof Y == "number" && (Y -= 0.8 * (Y - t[c][1])), d()) : t[c] = [q, Y], f || (i[c] = G - P, i[j] = T), i = f ? 1 / _ : _, r[j] = T, r[c] = o, n[f ? m ? "scaleY" : "scaleX" : "scale" + y] = _, n["translate" + y] = i * P + (q - i * R);
        }, C.prototype.reset = function (m, d) {
          var o = this.chart,
            n = o.hoverSeries,
            r = o.hoverPoint,
            i = o.hoverPoints,
            t = o.tooltip,
            e = t && t.shared ? i : r;
          m && e && L(e).forEach(function (a) {
            a.series.isCartesian && typeof a.plotX > "u" && (m = !1);
          }), m ? t && e && L(e).length && (t.refresh(e), t.shared && i ? i.forEach(function (a) {
            a.setState(a.state, !0), a.series.isCartesian && (a.series.xAxis.crosshair && a.series.xAxis.drawCrosshair(null, a), a.series.yAxis.crosshair && a.series.yAxis.drawCrosshair(null, a));
          }) : r && (r.setState(r.state, !0), o.axes.forEach(function (a) {
            a.crosshair && r.series[a.coll] === a && a.drawCrosshair(null, r);
          }))) : (r && r.onMouseOut(), i && i.forEach(function (a) {
            a.setState();
          }), n && n.onMouseOut(), t && t.hide(d), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), o.axes.forEach(function (a) {
            a.hideCrosshair();
          }), this.hoverX = o.hoverPoints = o.hoverPoint = null);
        }, C.prototype.runPointActions = function (m, d, o) {
          var n = this.chart,
            r = n.tooltip && n.tooltip.options.enabled ? n.tooltip : void 0,
            i = r ? r.shared : !1,
            t = d || n.hoverPoint,
            e = t && t.series || n.hoverSeries;
          d = this.getHoverData(t, e, n.series, (!m || m.type !== "touchmove") && (!!d || e && e.directTouch && this.isDirectTouch), i, m), t = d.hoverPoint, e = d.hoverSeries;
          var a = d.hoverPoints;
          d = e && e.tooltipOptions.followPointer && !e.tooltipOptions.split;
          var c = i && e && !e.noSharedTooltip;
          if (t && (o || t !== n.hoverPoint || r && r.isHidden)) {
            if ((n.hoverPoints || []).forEach(function (y) {
              a.indexOf(y) === -1 && y.setState();
            }), n.hoverSeries !== e && e.onMouseOver(), this.applyInactiveState(a), (a || []).forEach(function (y) {
              y.setState("hover");
            }), n.hoverPoint && n.hoverPoint.firePointEvent("mouseOut"), !t.series) return;
            n.hoverPoints = a, n.hoverPoint = t, t.firePointEvent("mouseOver", void 0, function () {
              r && t && r.refresh(c ? a : t, m);
            });
          } else d && r && !r.isHidden && (o = r.getAnchor([{}], m), n.isInsidePlot(o[0], o[1], {
            visiblePlotOnly: !0
          }) && r.updatePosition({
            plotX: o[0],
            plotY: o[1]
          }));
          this.unDocMouseMove || (this.unDocMouseMove = w(n.container.ownerDocument, "mousemove", function (y) {
            var b = W[C.hoverChartIndex];
            b && b.pointer.onDocumentMouseMove(y);
          }), this.eventsToUnbind.push(this.unDocMouseMove)), n.axes.forEach(function (y) {
            var b = I((y.crosshair || {}).snap, !0),
              j;
            b && ((j = n.hoverPoint) && j.series[y.coll] === y || (j = h(a, function (P) {
              return P.series && P.series[y.coll] === y;
            }))), j || !b ? y.drawCrosshair(m, j) : y.hideCrosshair();
          });
        }, C.prototype.scaleGroups = function (m, d) {
          var o = this.chart;
          o.series.forEach(function (n) {
            var r = m || n.getPlotBox();
            n.group && (n.xAxis && n.xAxis.zoomEnabled || o.mapView) && (n.group.attr(r), n.markerGroup && (n.markerGroup.attr(r), n.markerGroup.clip(d ? o.clipRect : null)), n.dataLabelsGroup && n.dataLabelsGroup.attr(r));
          }), o.clipRect.attr(d || o.clipBox);
        }, C.prototype.setDOMEvents = function () {
          var m = this,
            d = this.chart.container,
            o = d.ownerDocument;
          d.onmousedown = this.onContainerMouseDown.bind(this), d.onmousemove = this.onContainerMouseMove.bind(this), d.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(w(d, "mouseenter", this.onContainerMouseEnter.bind(this))), this.eventsToUnbind.push(w(d, "mouseleave", this.onContainerMouseLeave.bind(this))), C.unbindDocumentMouseUp || (C.unbindDocumentMouseUp = w(o, "mouseup", this.onDocumentMouseUp.bind(this)));
          for (var n = this.chart.renderTo.parentElement; n && n.tagName !== "BODY";) this.eventsToUnbind.push(w(n, "scroll", function () {
            delete m.chartPosition;
          })), n = n.parentElement;
          E.hasTouch && (this.eventsToUnbind.push(w(d, "touchstart", this.onContainerTouchStart.bind(this), {
            passive: !1
          })), this.eventsToUnbind.push(w(d, "touchmove", this.onContainerTouchMove.bind(this), {
            passive: !1
          })), C.unbindDocumentTouchEnd || (C.unbindDocumentTouchEnd = w(o, "touchend", this.onDocumentTouchEnd.bind(this), {
            passive: !1
          })));
        }, C.prototype.setHoverChartIndex = function () {
          var m = this.chart,
            d = E.charts[I(C.hoverChartIndex, -1)];
          d && d !== m && d.pointer.onContainerMouseLeave({
            relatedTarget: m.container
          }), d && d.mouseIsDown || (C.hoverChartIndex = m.index);
        }, C.prototype.touch = function (m, d) {
          var o = this.chart;
          if (this.setHoverChartIndex(), m.touches.length === 1) {
            if (m = this.normalize(m), o.isInsidePlot(m.chartX - o.plotLeft, m.chartY - o.plotTop, {
              visiblePlotOnly: !0
            }) && !o.openMenu) {
              if (d && this.runPointActions(m), m.type === "touchmove") {
                d = this.pinchDown;
                var n = d[0] ? 4 <= Math.sqrt(Math.pow(d[0].chartX - m.chartX, 2) + Math.pow(d[0].chartY - m.chartY, 2)) : !1;
              }
              I(n, !0) && this.pinch(m);
            } else d && this.reset();
          } else m.touches.length === 2 && this.pinch(m);
        }, C.prototype.touchSelect = function (m) {
          return !(!this.chart.options.chart.zooming.singleTouch || !m.touches || m.touches.length !== 1);
        }, C.prototype.zoomOption = function (m) {
          var d = this.chart,
            o = d.options.chart;
          d = d.inverted;
          var n = o.zooming.type || "";
          /touch/.test(m.type) && (n = I(o.zooming.pinchType, n)), this.zoomX = m = /x/.test(n), this.zoomY = o = /y/.test(n), this.zoomHor = m && !d || o && d, this.zoomVert = o && !d || m && d, this.hasZoom = m || o;
        }, C;
      }(), D;
    }), V(S, "Core/MSPointer.js", [S["Core/Globals.js"], S["Core/Pointer.js"], S["Core/Utilities.js"]], function (D, E, B) {
      function H() {
        var M = [];
        return M.item = function (I) {
          return this[I];
        }, h(u, function (I) {
          M.push({
            pageX: I.pageX,
            pageY: I.pageY,
            target: I.target
          });
        }), M;
      }
      function X(M, I, L, C) {
        var m = z[E.hoverChartIndex || NaN];
        M.pointerType !== "touch" && M.pointerType !== M.MSPOINTER_TYPE_TOUCH || !m || (m = m.pointer, C(M), m[I]({
          type: L,
          target: M.currentTarget,
          preventDefault: A,
          touches: H()
        }));
      }
      var W = this && this.__extends || function () {
          var _M = function M(I, L) {
            return _M = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (C, m) {
              C.__proto__ = m;
            } || function (C, m) {
              for (var d in m) m.hasOwnProperty(d) && (C[d] = m[d]);
            }, _M(I, L);
          };
          return function (I, L) {
            function C() {
              this.constructor = I;
            }
            _M(I, L), I.prototype = L === null ? Object.create(L) : (C.prototype = L.prototype, new C());
          };
        }(),
        z = D.charts,
        w = D.doc,
        A = D.noop,
        k = D.win,
        g = B.addEvent,
        p = B.css,
        h = B.objectEach,
        s = B.pick,
        l = B.removeEvent,
        u = {},
        v = !!k.PointerEvent;
      return function (M) {
        function I() {
          return M !== null && M.apply(this, arguments) || this;
        }
        return W(I, M), I.isRequired = function () {
          return !(D.hasTouch || !k.PointerEvent && !k.MSPointerEvent);
        }, I.prototype.batchMSEvents = function (L) {
          L(this.chart.container, v ? "pointerdown" : "MSPointerDown", this.onContainerPointerDown), L(this.chart.container, v ? "pointermove" : "MSPointerMove", this.onContainerPointerMove), L(w, v ? "pointerup" : "MSPointerUp", this.onDocumentPointerUp);
        }, I.prototype.destroy = function () {
          this.batchMSEvents(l), M.prototype.destroy.call(this);
        }, I.prototype.init = function (L, C) {
          M.prototype.init.call(this, L, C), this.hasZoom && p(L.container, {
            "-ms-touch-action": "none",
            "touch-action": "none"
          });
        }, I.prototype.onContainerPointerDown = function (L) {
          X(L, "onContainerTouchStart", "touchstart", function (C) {
            u[C.pointerId] = {
              pageX: C.pageX,
              pageY: C.pageY,
              target: C.currentTarget
            };
          });
        }, I.prototype.onContainerPointerMove = function (L) {
          X(L, "onContainerTouchMove", "touchmove", function (C) {
            u[C.pointerId] = {
              pageX: C.pageX,
              pageY: C.pageY
            }, u[C.pointerId].target || (u[C.pointerId].target = C.currentTarget);
          });
        }, I.prototype.onDocumentPointerUp = function (L) {
          X(L, "onDocumentTouchEnd", "touchend", function (C) {
            delete u[C.pointerId];
          });
        }, I.prototype.setDOMEvents = function () {
          var L = this.chart.tooltip;
          M.prototype.setDOMEvents.call(this), (this.hasZoom || s(L && L.options.followTouchMove, !0)) && this.batchMSEvents(g);
        }, I;
      }(E);
    }), V(S, "Core/Legend/Legend.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/FormatUtilities.js"], S["Core/Globals.js"], S["Core/Series/Point.js"], S["Core/Renderer/RendererUtilities.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W) {
      var z = D.animObject,
        w = D.setAnimation,
        A = E.format,
        k = B.marginNames,
        g = X.distribute,
        p = W.addEvent,
        h = W.createElement,
        s = W.css,
        l = W.defined,
        u = W.discardElement,
        v = W.find,
        M = W.fireEvent,
        I = W.isNumber,
        L = W.merge,
        C = W.pick,
        m = W.relativeLength,
        d = W.stableSort,
        o = W.syncTimeout;
      return D = function () {
        function n(r, i) {
          this.allItems = [], this.contentGroup = this.box = void 0, this.display = !1, this.group = void 0, this.offsetWidth = this.maxLegendWidth = this.maxItemWidth = this.legendWidth = this.legendHeight = this.lastLineHeight = this.lastItemY = this.itemY = this.itemX = this.itemMarginTop = this.itemMarginBottom = this.itemHeight = this.initialItemY = 0, this.options = void 0, this.padding = 0, this.pages = [], this.proximate = !1, this.scrollGroup = void 0, this.widthOption = this.totalItemWidth = this.titleHeight = this.symbolWidth = this.symbolHeight = 0, this.chart = r, this.init(r, i);
        }
        return n.prototype.init = function (r, i) {
          this.chart = r, this.setOptions(i), i.enabled && (this.render(), p(this.chart, "endResize", function () {
            this.legend.positionCheckboxes();
          }), this.proximate ? this.unchartrender = p(this.chart, "render", function () {
            this.legend.proximatePositions(), this.legend.positionItems();
          }) : this.unchartrender && this.unchartrender());
        }, n.prototype.setOptions = function (r) {
          var i = C(r.padding, 8);
          this.options = r, this.chart.styledMode || (this.itemStyle = r.itemStyle, this.itemHiddenStyle = L(this.itemStyle, r.itemHiddenStyle)), this.itemMarginTop = r.itemMarginTop || 0, this.itemMarginBottom = r.itemMarginBottom || 0, this.padding = i, this.initialItemY = i - 5, this.symbolWidth = C(r.symbolWidth, 16), this.pages = [], this.proximate = r.layout === "proximate" && !this.chart.inverted, this.baseline = void 0;
        }, n.prototype.update = function (r, i) {
          var t = this.chart;
          this.setOptions(L(!0, this.options, r)), this.destroy(), t.isDirtyLegend = t.isDirtyBox = !0, C(i, !0) && t.redraw(), M(this, "afterUpdate");
        }, n.prototype.colorizeItem = function (r, i) {
          var t = r.legendItem || {},
            e = t.group,
            a = t.label,
            c = t.line;
          if (t = t.symbol, e && e[i ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
            var y = this.options;
            e = this.itemHiddenStyle.color, y = i ? y.itemStyle.color : e;
            var b = i && r.color || e,
              j = r.options && r.options.marker,
              P = {
                fill: b
              };
            a && a.css({
              fill: y,
              color: y
            }), c && c.attr({
              stroke: b
            }), t && (j && t.isMarker && (P = r.pointAttribs(), i || (P.stroke = P.fill = e)), t.attr(P));
          }
          M(this, "afterColorizeItem", {
            item: r,
            visible: i
          });
        }, n.prototype.positionItems = function () {
          this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
        }, n.prototype.positionItem = function (r) {
          var i = this,
            t = r.legendItem || {},
            e = t.group,
            a = t.x;
          a = a === void 0 ? 0 : a, t = t.y, t = t === void 0 ? 0 : t;
          var c = this.options,
            y = c.symbolPadding,
            b = !c.rtl;
          c = r.checkbox, e && e.element && (y = {
            translateX: b ? a : this.legendWidth - a - 2 * y - 4,
            translateY: t
          }, e[l(e.translateY) ? "animate" : "attr"](y, void 0, function () {
            M(i, "afterPositionItem", {
              item: r
            });
          })), c && (c.x = a, c.y = t);
        }, n.prototype.destroyItem = function (r) {
          for (var i = r.checkbox, t = r.legendItem || {}, e = 0, a = ["group", "label", "line", "symbol"]; e < a.length; e++) {
            var c = a[e];
            t[c] && (t[c] = t[c].destroy());
          }
          i && u(i), r.legendItem = void 0;
        }, n.prototype.destroy = function () {
          for (var r = 0, i = this.getAllItems(); r < i.length; r++) this.destroyItem(i[r]);
          for (r = 0, i = "clipRect up down pager nav box title group".split(" "); r < i.length; r++) {
            var t = i[r];
            this[t] && (this[t] = this[t].destroy());
          }
          this.display = null;
        }, n.prototype.positionCheckboxes = function () {
          var r = this.group && this.group.alignAttr,
            i = this.clipHeight || this.legendHeight,
            t = this.titleHeight;
          if (r) {
            var e = r.translateY;
            this.allItems.forEach(function (a) {
              var c = a.checkbox;
              if (c) {
                var y = e + t + c.y + (this.scrollOffset || 0) + 3;
                s(c, {
                  left: r.translateX + a.checkboxOffset + c.x - 20 + "px",
                  top: y + "px",
                  display: this.proximate || y > e - 6 && y < e + i - 6 ? "" : "none"
                });
              }
            }, this);
          }
        }, n.prototype.renderTitle = function () {
          var r = this.options,
            i = this.padding,
            t = r.title,
            e = 0;
          t.text && (this.title || (this.title = this.chart.renderer.label(t.text, i - 3, i - 4, void 0, void 0, void 0, r.useHTML, void 0, "legend-title").attr({
            zIndex: 1
          }), this.chart.styledMode || this.title.css(t.style), this.title.add(this.group)), t.width || this.title.css({
            width: this.maxLegendWidth + "px"
          }), r = this.title.getBBox(), e = r.height, this.offsetWidth = r.width, this.contentGroup.attr({
            translateY: e
          })), this.titleHeight = e;
        }, n.prototype.setText = function (r) {
          var i = this.options;
          r.legendItem.label.attr({
            text: i.labelFormat ? A(i.labelFormat, r, this.chart) : i.labelFormatter.call(r)
          });
        }, n.prototype.renderItem = function (r) {
          var i = r.legendItem = r.legendItem || {},
            t = this.chart,
            e = t.renderer,
            a = this.options,
            c = this.symbolWidth,
            y = a.symbolPadding || 0,
            b = this.itemStyle,
            j = this.itemHiddenStyle,
            P = a.layout === "horizontal" ? C(a.itemDistance, 20) : 0,
            f = !a.rtl,
            x = !r.series,
            N = !x && r.series.drawLegendSymbol ? r.series : r,
            R = N.options,
            F = this.createCheckboxForItem && R && R.showCheckbox,
            T = a.useHTML,
            G = r.options.className,
            _ = i.label;
          R = c + y + P + (F ? 20 : 0), _ || (i.group = e.g("legend-item").addClass("highcharts-" + N.type + "-series highcharts-color-" + r.colorIndex + (G ? " " + G : "") + (x ? " highcharts-series-" + r.index : "")).attr({
            zIndex: 1
          }).add(this.scrollGroup), i.label = _ = e.text("", f ? c + y : -y, this.baseline || 0, T), t.styledMode || _.css(L(r.visible ? b : j)), _.attr({
            align: f ? "left" : "right",
            zIndex: 2
          }).add(i.group), this.baseline || (this.fontMetrics = e.fontMetrics(t.styledMode ? 12 : b.fontSize, _), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, _.attr("y", this.baseline), this.symbolHeight = a.symbolHeight || this.fontMetrics.f, a.squareSymbol && (this.symbolWidth = C(a.symbolWidth, Math.max(this.symbolHeight, 16)), R = this.symbolWidth + y + P + (F ? 20 : 0), f && _.attr("x", this.symbolWidth + y))), N.drawLegendSymbol(this, r), this.setItemEvents && this.setItemEvents(r, _, T)), F && !r.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(r), this.colorizeItem(r, r.visible), !t.styledMode && b.width || _.css({
            width: (a.itemWidth || this.widthOption || t.spacingBox.width) - R + "px"
          }), this.setText(r), t = _.getBBox(), e = this.fontMetrics && this.fontMetrics.h || 0, r.itemWidth = r.checkboxOffset = a.itemWidth || i.labelWidth || t.width + R, this.maxItemWidth = Math.max(this.maxItemWidth, r.itemWidth), this.totalItemWidth += r.itemWidth, this.itemHeight = r.itemHeight = Math.round(i.labelHeight || (t.height > 1.5 * e ? t.height : e));
        }, n.prototype.layoutItem = function (r) {
          var i = this.options,
            t = this.padding,
            e = i.layout === "horizontal",
            a = r.itemHeight,
            c = this.itemMarginBottom,
            y = this.itemMarginTop,
            b = e ? C(i.itemDistance, 20) : 0,
            j = this.maxLegendWidth;
          i = i.alignColumns && this.totalItemWidth > j ? this.maxItemWidth : r.itemWidth;
          var P = r.legendItem || {};
          e && this.itemX - t + i > j && (this.itemX = t, this.lastLineHeight && (this.itemY += y + this.lastLineHeight + c), this.lastLineHeight = 0), this.lastItemY = y + this.itemY + c, this.lastLineHeight = Math.max(a, this.lastLineHeight), P.x = this.itemX, P.y = this.itemY, e ? this.itemX += i : (this.itemY += y + a + c, this.lastLineHeight = a), this.offsetWidth = this.widthOption || Math.max((e ? this.itemX - t - (r.checkbox ? 0 : b) : i) + t, this.offsetWidth);
        }, n.prototype.getAllItems = function () {
          var r = [];
          return this.chart.series.forEach(function (i) {
            var t = i && i.options;
            i && C(t.showInLegend, l(t.linkedTo) ? !1 : void 0, !0) && (r = r.concat((i.legendItem || {}).labels || (t.legendType === "point" ? i.data : i)));
          }), M(this, "afterGetAllItems", {
            allItems: r
          }), r;
        }, n.prototype.getAlignment = function () {
          var r = this.options;
          return this.proximate ? r.align.charAt(0) + "tv" : r.floating ? "" : r.align.charAt(0) + r.verticalAlign.charAt(0) + r.layout.charAt(0);
        }, n.prototype.adjustMargins = function (r, i) {
          var t = this.chart,
            e = this.options,
            a = this.getAlignment();
          a && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function (c, y) {
            c.test(a) && !l(r[y]) && (t[k[y]] = Math.max(t[k[y]], t.legend[(y + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][y] * e[y % 2 ? "x" : "y"] + C(e.margin, 12) + i[y] + (t.titleOffset[y] || 0)));
          });
        }, n.prototype.proximatePositions = function () {
          var r = this.chart,
            i = [],
            t = this.options.align === "left";
          this.allItems.forEach(function (b) {
            var j,
              P = t;
            if (b.yAxis) {
              b.xAxis.options.reversed && (P = !P), b.points && (j = v(P ? b.points : b.points.slice(0).reverse(), function (x) {
                return I(x.plotY);
              })), P = this.itemMarginTop + b.legendItem.label.getBBox().height + this.itemMarginBottom;
              var f = b.yAxis.top - r.plotTop;
              b.visible ? (j = j ? j.plotY : b.yAxis.height, j += f - 0.3 * P) : j = f + b.yAxis.height, i.push({
                target: j,
                size: P,
                item: b
              });
            }
          }, this);
          for (var e, a = 0, c = g(i, r.plotHeight); a < c.length; a++) {
            var y = c[a];
            e = y.item.legendItem || {}, I(y.pos) && (e.y = r.plotTop - r.spacing[0] + y.pos);
          }
        }, n.prototype.render = function () {
          var r = this.chart,
            i = r.renderer,
            t = this.options,
            e = this.padding,
            a = this.getAllItems(),
            c = this.group,
            y = this.box;
          this.itemX = e, this.itemY = this.initialItemY, this.lastItemY = this.offsetWidth = 0, this.widthOption = m(t.width, r.spacingBox.width - e);
          var b = r.spacingBox.width - 2 * e - t.x;
          -1 < ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) && (b /= 2), this.maxLegendWidth = this.widthOption || b, c || (this.group = c = i.g("legend").addClass(t.className || "").attr({
            zIndex: 7
          }).add(), this.contentGroup = i.g().attr({
            zIndex: 1
          }).add(c), this.scrollGroup = i.g().add(this.contentGroup)), this.renderTitle(), d(a, function (P, f) {
            return (P.options && P.options.legendIndex || 0) - (f.options && f.options.legendIndex || 0);
          }), t.reversed && a.reverse(), this.allItems = a, this.display = b = !!a.length, this.itemHeight = this.totalItemWidth = this.maxItemWidth = this.lastLineHeight = 0, a.forEach(this.renderItem, this), a.forEach(this.layoutItem, this), a = (this.widthOption || this.offsetWidth) + e;
          var j = this.lastItemY + this.lastLineHeight + this.titleHeight;
          j = this.handleOverflow(j), j += e, y || (this.box = y = i.rect().addClass("highcharts-legend-box").attr({
            r: t.borderRadius
          }).add(c)), r.styledMode || y.attr({
            stroke: t.borderColor,
            "stroke-width": t.borderWidth || 0,
            fill: t.backgroundColor || "none"
          }).shadow(t.shadow), 0 < a && 0 < j && y[y.placed ? "animate" : "attr"](y.crisp.call({}, {
            x: 0,
            y: 0,
            width: a,
            height: j
          }, y.strokeWidth())), c[b ? "show" : "hide"](), r.styledMode && c.getStyle("display") === "none" && (a = j = 0), this.legendWidth = a, this.legendHeight = j, b && this.align(), this.proximate || this.positionItems(), M(this, "afterRender");
        }, n.prototype.align = function (r) {
          r === void 0 && (r = this.chart.spacingBox);
          var i = this.chart,
            t = this.options,
            e = r.y;
          /(lth|ct|rth)/.test(this.getAlignment()) && 0 < i.titleOffset[0] ? e += i.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && 0 < i.titleOffset[2] && (e -= i.titleOffset[2]), e !== r.y && (r = L(r, {
            y: e
          })), i.hasRendered || (this.group.placed = !1), this.group.align(L(t, {
            width: this.legendWidth,
            height: this.legendHeight,
            verticalAlign: this.proximate ? "top" : t.verticalAlign
          }), !0, r);
        }, n.prototype.handleOverflow = function (r) {
          var i = this,
            t = this.chart,
            e = t.renderer,
            a = this.options,
            c = a.y,
            y = a.verticalAlign === "top",
            b = this.padding,
            j = a.maxHeight,
            P = a.navigation,
            f = C(P.animation, !0),
            x = P.arrowSize || 12,
            N = this.pages,
            R = this.allItems,
            F = function F(Z) {
              typeof Z == "number" ? U.attr({
                height: Z
              }) : U && (i.clipRect = U.destroy(), i.contentGroup.clip()), i.contentGroup.div && (i.contentGroup.div.style.clip = Z ? "rect(" + b + "px,9999px," + (b + Z) + "px,0)" : "auto");
            },
            T = function T(Z) {
              return i[Z] = e.circle(0, 0, 1.3 * x).translate(x / 2, x / 2).add(Y), t.styledMode || i[Z].attr("fill", "rgba(0,0,0,0.0001)"), i[Z];
            },
            G,
            _,
            q;
          c = t.spacingBox.height + (y ? -c : c) - b;
          var Y = this.nav,
            U = this.clipRect;
          return a.layout !== "horizontal" || a.verticalAlign === "middle" || a.floating || (c /= 2), j && (c = Math.min(c, j)), N.length = 0, r && 0 < c && r > c && P.enabled !== !1 ? (this.clipHeight = G = Math.max(c - 20 - this.titleHeight - b, 0), this.currentPage = C(this.currentPage, 1), this.fullHeight = r, R.forEach(function (Z, J) {
            q = Z.legendItem || {}, Z = q.y || 0;
            var et = Math.round(q.label.getBBox().height),
              nt = N.length;
            (!nt || Z - N[nt - 1] > G && (_ || Z) !== N[nt - 1]) && (N.push(_ || Z), nt++), q.pageIx = nt - 1, _ && ((R[J - 1].legendItem || {}).pageIx = nt - 1), J === R.length - 1 && Z + et - N[nt - 1] > G && et <= G && (N.push(Z), q.pageIx = nt), Z !== _ && (_ = Z);
          }), U || (U = i.clipRect = e.clipRect(0, b, 9999, 0), i.contentGroup.clip(U)), F(G), Y || (this.nav = Y = e.g().attr({
            zIndex: 1
          }).add(this.group), this.up = e.symbol("triangle", 0, 0, x, x).add(Y), T("upTracker").on("click", function () {
            i.scroll(-1, f);
          }), this.pager = e.text("", 15, 10).addClass("highcharts-legend-navigation"), !t.styledMode && P.style && this.pager.css(P.style), this.pager.add(Y), this.down = e.symbol("triangle-down", 0, 0, x, x).add(Y), T("downTracker").on("click", function () {
            i.scroll(1, f);
          })), i.scroll(0), r = c) : Y && (F(), this.nav = Y.destroy(), this.scrollGroup.attr({
            translateY: 1
          }), this.clipHeight = 0), r;
        }, n.prototype.scroll = function (r, i) {
          var t = this,
            e = this.chart,
            a = this.pages,
            c = a.length,
            y = this.clipHeight,
            b = this.options.navigation,
            j = this.pager,
            P = this.padding,
            f = this.currentPage + r;
          f > c && (f = c), 0 < f && (typeof i < "u" && w(i, e), this.nav.attr({
            translateX: P,
            translateY: y + this.padding + 7 + this.titleHeight,
            visibility: "inherit"
          }), [this.up, this.upTracker].forEach(function (x) {
            x.attr({
              class: f === 1 ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
            });
          }), j.attr({
            text: f + "/" + c
          }), [this.down, this.downTracker].forEach(function (x) {
            x.attr({
              x: 18 + this.pager.getBBox().width,
              class: f === c ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
            });
          }, this), e.styledMode || (this.up.attr({
            fill: f === 1 ? b.inactiveColor : b.activeColor
          }), this.upTracker.css({
            cursor: f === 1 ? "default" : "pointer"
          }), this.down.attr({
            fill: f === c ? b.inactiveColor : b.activeColor
          }), this.downTracker.css({
            cursor: f === c ? "default" : "pointer"
          })), this.scrollOffset = -a[f - 1] + this.initialItemY, this.scrollGroup.animate({
            translateY: this.scrollOffset
          }), this.currentPage = f, this.positionCheckboxes(), r = z(C(i, e.renderer.globalAnimation, !0)), o(function () {
            M(t, "afterScroll", {
              currentPage: f
            });
          }, r.duration));
        }, n.prototype.setItemEvents = function (r, i, t) {
          var e = this,
            a = r.legendItem || {},
            c = e.chart.renderer.boxWrapper,
            y = r instanceof H,
            b = "highcharts-legend-" + (y ? "point" : "series") + "-active",
            j = e.chart.styledMode,
            P = function P(x) {
              e.allItems.forEach(function (N) {
                r !== N && [N].concat(N.linkedSeries || []).forEach(function (R) {
                  R.setState(x, !y);
                });
              });
            },
            f = 0;
          for (t = t ? [i, a.symbol] : [a.group]; f < t.length; f++) (a = t[f]) && a.on("mouseover", function () {
            r.visible && P("inactive"), r.setState("hover"), r.visible && c.addClass(b), j || i.css(e.options.itemHoverStyle);
          }).on("mouseout", function () {
            e.chart.styledMode || i.css(L(r.visible ? e.itemStyle : e.itemHiddenStyle)), P(""), c.removeClass(b), r.setState();
          }).on("click", function (x) {
            var N = function N() {
              r.setVisible && r.setVisible(), P(r.visible ? "inactive" : "");
            };
            c.removeClass(b), x = {
              browserEvent: x
            }, r.firePointEvent ? r.firePointEvent("legendItemClick", x, N) : M(r, "legendItemClick", x, N);
          });
        }, n.prototype.createCheckboxForItem = function (r) {
          r.checkbox = h("input", {
            type: "checkbox",
            className: "highcharts-legend-checkbox",
            checked: r.selected,
            defaultChecked: r.selected
          }, this.options.itemCheckboxStyle, this.chart.container), p(r.checkbox, "click", function (i) {
            M(r.series || r, "checkboxClick", {
              checked: i.target.checked,
              item: r
            }, function () {
              r.select();
            });
          });
        }, n;
      }(), D;
    }), V(S, "Core/Series/SeriesRegistry.js", [S["Core/Globals.js"], S["Core/Defaults.js"], S["Core/Series/Point.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = E.defaultOptions,
        W = H.extendClass,
        z = H.merge,
        w;
      return function (A) {
        function k(g, p) {
          var h = X.plotOptions || {},
            s = p.defaultOptions,
            l = p.prototype;
          l.type = g, l.pointClass || (l.pointClass = B), s && (h[g] = s), A.seriesTypes[g] = p;
        }
        A.seriesTypes = D.seriesTypes, A.registerSeriesType = k, A.seriesType = function (g, p, h, s, l) {
          var u = X.plotOptions || {};
          return p = p || "", u[g] = z(u[p], h), k(g, W(A.seriesTypes[p] || function () {}, s)), A.seriesTypes[g].prototype.type = g, l && (A.seriesTypes[g].prototype.pointClass = W(B, l)), A.seriesTypes[g];
        };
      }(w || (w = {})), w;
    }), V(S, "Core/Chart/Chart.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/Axis/Axis.js"], S["Core/Defaults.js"], S["Core/FormatUtilities.js"], S["Core/Foundation.js"], S["Core/Globals.js"], S["Core/Legend/Legend.js"], S["Core/MSPointer.js"], S["Core/Pointer.js"], S["Core/Renderer/RendererRegistry.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Renderer/SVG/SVGRenderer.js"], S["Core/Time.js"], S["Core/Utilities.js"], S["Core/Renderer/HTML/AST.js"]], function (D, E, B, H, X, W, z, w, A, k, g, p, h, s, l) {
      var u = D.animate,
        v = D.animObject,
        M = D.setAnimation,
        I = B.defaultOptions,
        L = B.defaultTime,
        C = H.numberFormat,
        m = X.registerEventOptions,
        d = W.charts,
        o = W.doc,
        n = W.marginNames,
        r = W.svg,
        i = W.win,
        t = g.seriesTypes,
        e = s.addEvent,
        a = s.attr,
        c = s.cleanRecursively,
        y = s.createElement,
        b = s.css,
        j = s.defined,
        P = s.discardElement,
        f = s.erase,
        x = s.error,
        N = s.extend,
        R = s.find,
        F = s.fireEvent,
        T = s.getStyle,
        G = s.isArray,
        _ = s.isNumber,
        q = s.isObject,
        Y = s.isString,
        U = s.merge,
        Z = s.objectEach,
        J = s.pick,
        et = s.pInt,
        nt = s.relativeLength,
        lt = s.removeEvent,
        ct = s.splat,
        tt = s.syncTimeout,
        st = s.uniqueKey;
      return D = function () {
        function it($, Q, ot) {
          this.series = this.renderTo = this.renderer = this.pointer = this.pointCount = this.plotWidth = this.plotTop = this.plotLeft = this.plotHeight = this.plotBox = this.options = this.numberFormatter = this.margin = this.legend = this.labelCollectors = this.isResizing = this.index = this.eventOptions = this.container = this.colorCounter = this.clipBox = this.chartWidth = this.chartHeight = this.bounds = this.axisOffset = this.axes = void 0, this.sharedClips = {}, this.yAxis = this.xAxis = this.userOptions = this.titleOffset = this.time = this.symbolCounter = this.spacingBox = this.spacing = void 0, this.getArgs($, Q, ot);
        }
        return it.chart = function ($, Q, ot) {
          return new it($, Q, ot);
        }, it.prototype.getArgs = function ($, Q, ot) {
          Y($) || $.nodeName ? (this.renderTo = $, this.init(Q, ot)) : this.init($, Q);
        }, it.prototype.init = function ($, Q) {
          var ot = $.plotOptions || {};
          F(this, "init", {
            args: arguments
          }, function () {
            var at = U(I, $),
              rt = at.chart;
            Z(at.plotOptions, function (pt, dt) {
              q(pt) && (pt.tooltip = ot[dt] && U(ot[dt].tooltip) || void 0);
            }), at.tooltip.userOptions = $.chart && $.chart.forExport && $.tooltip.userOptions || $.tooltip, this.userOptions = $, this.margin = [], this.spacing = [], this.bounds = {
              h: {},
              v: {}
            }, this.labelCollectors = [], this.callback = Q, this.isResizing = 0;
            var ht = rt.zooming = rt.zooming || {};
            $.chart && !$.chart.zooming && (ht.resetButton = rt.resetZoomButton), ht.key = J(ht.key, rt.zoomKey), ht.pinchType = J(ht.pinchType, rt.pinchType), ht.singleTouch = J(ht.singleTouch, rt.zoomBySingleTouch), ht.type = J(ht.type, rt.zoomType), this.options = at, this.axes = [], this.series = [], this.time = $.time && Object.keys($.time).length ? new h($.time) : W.time, this.numberFormatter = rt.numberFormatter || C, this.styledMode = rt.styledMode, this.hasCartesianSeries = rt.showAxes, this.index = d.length, d.push(this), W.chartCount++, m(this, rt), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, F(this, "afterInit"), this.firstRender();
          });
        }, it.prototype.initSeries = function ($) {
          var Q = this.options.chart;
          Q = $.type || Q.type || Q.defaultSeriesType;
          var ot = t[Q];
          return ot || x(17, !0, this, {
            missingModuleFor: Q
          }), Q = new ot(), typeof Q.init == "function" && Q.init(this, $), Q;
        }, it.prototype.setSeriesData = function () {
          this.getSeriesOrderByLinks().forEach(function ($) {
            $.points || $.data || !$.enabledDataSorting || $.setData($.options.data, !1);
          });
        }, it.prototype.getSeriesOrderByLinks = function () {
          return this.series.concat().sort(function ($, Q) {
            return $.linkedSeries.length || Q.linkedSeries.length ? Q.linkedSeries.length - $.linkedSeries.length : 0;
          });
        }, it.prototype.orderSeries = function ($) {
          var Q = this.series;
          $ = $ || 0;
          for (var ot = Q.length; $ < ot; ++$) Q[$] && (Q[$].index = $, Q[$].name = Q[$].getName());
        }, it.prototype.isInsidePlot = function ($, Q, ot) {
          ot === void 0 && (ot = {});
          var at = this.inverted,
            rt = this.plotBox,
            ht = this.plotLeft,
            pt = this.plotTop,
            dt = this.scrollablePlotBox,
            gt = 0,
            ut = 0;
          ot.visiblePlotOnly && this.scrollingContainer && (ut = this.scrollingContainer, gt = ut.scrollLeft, ut = ut.scrollTop);
          var ft = ot.series;
          if (rt = ot.visiblePlotOnly && dt || rt, dt = ot.inverted ? Q : $, Q = ot.inverted ? $ : Q, $ = {
            x: dt,
            y: Q,
            isInsidePlot: !0,
            options: ot
          }, !ot.ignoreX) {
            var vt = ft && (at && !this.polar ? ft.yAxis : ft.xAxis) || {
              pos: ht,
              len: 1 / 0
            };
            dt = ot.paneCoordinates ? vt.pos + dt : ht + dt, dt >= Math.max(gt + ht, vt.pos) && dt <= Math.min(gt + ht + rt.width, vt.pos + vt.len) || ($.isInsidePlot = !1);
          }
          return !ot.ignoreY && $.isInsidePlot && (at = ot.axis && !ot.axis.isXAxis && ot.axis || ft && (at ? ft.xAxis : ft.yAxis) || {
            pos: pt,
            len: 1 / 0
          }, ot = ot.paneCoordinates ? at.pos + Q : pt + Q, ot >= Math.max(ut + pt, at.pos) && ot <= Math.min(ut + pt + rt.height, at.pos + at.len) || ($.isInsidePlot = !1)), F(this, "afterIsInsidePlot", $), $.isInsidePlot;
        }, it.prototype.redraw = function ($) {
          F(this, "beforeRedraw");
          var Q = this.hasCartesianSeries ? this.axes : this.colorAxis || [],
            ot = this.series,
            at = this.pointer,
            rt = this.legend,
            ht = this.userOptions.legend,
            pt = this.renderer,
            dt = pt.isHidden(),
            gt = [],
            ut = this.isDirtyBox,
            ft = this.isDirtyLegend;
          for (this.setResponsive && this.setResponsive(!1), M(this.hasRendered ? $ : !1, this), dt && this.temporaryDisplay(), this.layOutTitles(), $ = ot.length; $--;) {
            var vt = ot[$];
            if (vt.options.stacking || vt.options.centerInCategory) {
              var mt = !0;
              if (vt.isDirty) {
                var xt = !0;
                break;
              }
            }
          }
          if (xt) for ($ = ot.length; $--;) vt = ot[$], vt.options.stacking && (vt.isDirty = !0);
          ot.forEach(function (yt) {
            yt.isDirty && (yt.options.legendType === "point" ? (typeof yt.updateTotals == "function" && yt.updateTotals(), ft = !0) : ht && (ht.labelFormatter || ht.labelFormat) && (ft = !0)), yt.isDirtyData && F(yt, "updatedData");
          }), ft && rt && rt.options.enabled && (rt.render(), this.isDirtyLegend = !1), mt && this.getStacks(), Q.forEach(function (yt) {
            yt.updateNames(), yt.setScale();
          }), this.getMargins(), Q.forEach(function (yt) {
            yt.isDirty && (ut = !0);
          }), Q.forEach(function (yt) {
            var wt = yt.min + "," + yt.max;
            yt.extKey !== wt && (yt.extKey = wt, gt.push(function () {
              F(yt, "afterSetExtremes", N(yt.eventArgs, yt.getExtremes())), delete yt.eventArgs;
            })), (ut || mt) && yt.redraw();
          }), ut && this.drawChartBox(), F(this, "predraw"), ot.forEach(function (yt) {
            (ut || yt.isDirty) && yt.visible && yt.redraw(), yt.isDirtyData = !1;
          }), at && at.reset(!0), pt.draw(), F(this, "redraw"), F(this, "render"), dt && this.temporaryDisplay(!0), gt.forEach(function (yt) {
            yt.call();
          });
        }, it.prototype.get = function ($) {
          function Q(ht) {
            return ht.id === $ || ht.options && ht.options.id === $;
          }
          for (var ot = this.series, at = R(this.axes, Q) || R(this.series, Q), rt = 0; !at && rt < ot.length; rt++) at = R(ot[rt].points || [], Q);
          return at;
        }, it.prototype.getAxes = function () {
          var $ = this,
            Q = this.options,
            ot = Q.xAxis = ct(Q.xAxis || {});
          Q = Q.yAxis = ct(Q.yAxis || {}), F(this, "getAxes"), ot.forEach(function (at, rt) {
            at.index = rt, at.isX = !0;
          }), Q.forEach(function (at, rt) {
            at.index = rt;
          }), ot.concat(Q).forEach(function (at) {
            new E($, at);
          }), F(this, "afterGetAxes");
        }, it.prototype.getSelectedPoints = function () {
          return this.series.reduce(function ($, Q) {
            return Q.getPointsCollection().forEach(function (ot) {
              J(ot.selectedStaging, ot.selected) && $.push(ot);
            }), $;
          }, []);
        }, it.prototype.getSelectedSeries = function () {
          return this.series.filter(function ($) {
            return $.selected;
          });
        }, it.prototype.setTitle = function ($, Q, ot) {
          this.applyDescription("title", $), this.applyDescription("subtitle", Q), this.applyDescription("caption", void 0), this.layOutTitles(ot);
        }, it.prototype.applyDescription = function ($, Q) {
          var ot = this,
            at = $ === "title" ? {
              color: "#333333",
              fontSize: this.options.isStock ? "16px" : "18px"
            } : {
              color: "#666666"
            };
          at = this.options[$] = U(!this.styledMode && {
            style: at
          }, this.options[$], Q);
          var rt = this[$];
          rt && Q && (this[$] = rt = rt.destroy()), at && !rt && (rt = this.renderer.text(at.text, 0, 0, at.useHTML).attr({
            align: at.align,
            class: "highcharts-" + $,
            zIndex: at.zIndex || 4
          }).add(), rt.update = function (ht) {
            ot[{
              title: "setTitle",
              subtitle: "setSubtitle",
              caption: "setCaption"
            }[$]](ht);
          }, this.styledMode || rt.css(at.style), this[$] = rt);
        }, it.prototype.layOutTitles = function ($) {
          var Q = [0, 0, 0],
            ot = this.renderer,
            at = this.spacingBox;
          ["title", "subtitle", "caption"].forEach(function (ht) {
            var pt = this[ht],
              dt = this.options[ht],
              gt = dt.verticalAlign || "top";
            ht = ht === "title" ? gt === "top" ? -3 : 0 : gt === "top" ? Q[0] + 2 : 0;
            var ut;
            if (pt) {
              this.styledMode || (ut = dt.style && dt.style.fontSize), ut = ot.fontMetrics(ut, pt).b, pt.css({
                width: (dt.width || at.width + (dt.widthAdjust || 0)) + "px"
              });
              var ft = Math.round(pt.getBBox(dt.useHTML).height);
              pt.align(N({
                y: gt === "bottom" ? ut : ht + ut,
                height: ft
              }, dt), !1, "spacingBox"), dt.floating || (gt === "top" ? Q[0] = Math.ceil(Q[0] + ft) : gt === "bottom" && (Q[2] = Math.ceil(Q[2] + ft)));
            }
          }, this), Q[0] && (this.options.title.verticalAlign || "top") === "top" && (Q[0] += this.options.title.margin), Q[2] && this.options.caption.verticalAlign === "bottom" && (Q[2] += this.options.caption.margin);
          var rt = !this.titleOffset || this.titleOffset.join(",") !== Q.join(",");
          this.titleOffset = Q, F(this, "afterLayOutTitles"), !this.isDirtyBox && rt && (this.isDirtyBox = this.isDirtyLegend = rt, this.hasRendered && J($, !0) && this.isDirtyBox && this.redraw());
        }, it.prototype.getChartSize = function () {
          var $ = this.options.chart,
            Q = $.width;
          $ = $.height;
          var ot = this.renderTo;
          j(Q) || (this.containerWidth = T(ot, "width")), j($) || (this.containerHeight = T(ot, "height")), this.chartWidth = Math.max(0, Q || this.containerWidth || 600), this.chartHeight = Math.max(0, nt($, this.chartWidth) || (1 < this.containerHeight ? this.containerHeight : 400));
        }, it.prototype.temporaryDisplay = function ($) {
          var Q = this.renderTo;
          if ($) for (; Q && Q.style;) Q.hcOrigStyle && (b(Q, Q.hcOrigStyle), delete Q.hcOrigStyle), Q.hcOrigDetached && (o.body.removeChild(Q), Q.hcOrigDetached = !1), Q = Q.parentNode;else for (; Q && Q.style && (o.body.contains(Q) || Q.parentNode || (Q.hcOrigDetached = !0, o.body.appendChild(Q)), (T(Q, "display", !1) === "none" || Q.hcOricDetached) && (Q.hcOrigStyle = {
            display: Q.style.display,
            height: Q.style.height,
            overflow: Q.style.overflow
          }, $ = {
            display: "block",
            overflow: "hidden"
          }, Q !== this.renderTo && ($.height = 0), b(Q, $), Q.offsetWidth || Q.style.setProperty("display", "block", "important")), Q = Q.parentNode, Q !== o.body););
        }, it.prototype.setClassName = function ($) {
          this.container.className = "highcharts-container " + ($ || "");
        }, it.prototype.getContainer = function () {
          var $ = this.options,
            Q = $.chart,
            ot = st(),
            at,
            rt = this.renderTo;
          rt || (this.renderTo = rt = Q.renderTo), Y(rt) && (this.renderTo = rt = o.getElementById(rt)), rt || x(13, !0, this);
          var ht = et(a(rt, "data-highcharts-chart"));
          _(ht) && d[ht] && d[ht].hasRendered && d[ht].destroy(), a(rt, "data-highcharts-chart", this.index), rt.innerHTML = l.emptyHTML, Q.skipClone || rt.offsetWidth || this.temporaryDisplay(), this.getChartSize(), ht = this.chartWidth;
          var pt = this.chartHeight;
          if (b(rt, {
            overflow: "hidden"
          }), this.styledMode || (at = N({
            position: "relative",
            overflow: "hidden",
            width: ht + "px",
            height: pt + "px",
            textAlign: "left",
            lineHeight: "normal",
            zIndex: 0,
            "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
            userSelect: "none",
            "touch-action": "manipulation",
            outline: "none"
          }, Q.style || {})), this.container = ot = y("div", {
            id: ot
          }, at, rt), this._cursor = ot.style.cursor, this.renderer = new (Q.renderer || !r ? k.getRendererType(Q.renderer) : p)(ot, ht, pt, void 0, Q.forExport, $.exporting && $.exporting.allowHTML, this.styledMode), M(void 0, this), this.setClassName(Q.className), this.styledMode) for (var dt in $.defs) this.renderer.definition($.defs[dt]);else this.renderer.setStyle(Q.style);
          this.renderer.chartIndex = this.index, F(this, "afterGetContainer");
        }, it.prototype.getMargins = function ($) {
          var Q = this.spacing,
            ot = this.margin,
            at = this.titleOffset;
          this.resetMargins(), at[0] && !j(ot[0]) && (this.plotTop = Math.max(this.plotTop, at[0] + Q[0])), at[2] && !j(ot[2]) && (this.marginBottom = Math.max(this.marginBottom, at[2] + Q[2])), this.legend && this.legend.display && this.legend.adjustMargins(ot, Q), F(this, "getMargins"), $ || this.getAxisMargins();
        }, it.prototype.getAxisMargins = function () {
          var $ = this,
            Q = $.axisOffset = [0, 0, 0, 0],
            ot = $.colorAxis,
            at = $.margin,
            rt = function rt(ht) {
              ht.forEach(function (pt) {
                pt.visible && pt.getOffset();
              });
            };
          $.hasCartesianSeries ? rt($.axes) : ot && ot.length && rt(ot), n.forEach(function (ht, pt) {
            j(at[pt]) || ($[ht] += Q[pt]);
          }), $.setChartSize();
        }, it.prototype.reflow = function ($) {
          var Q = this,
            ot = Q.options.chart,
            at = Q.renderTo,
            rt = j(ot.width) && j(ot.height),
            ht = ot.width || T(at, "width");
          ot = ot.height || T(at, "height"), at = $ ? $.target : i, delete Q.pointer.chartPosition, !rt && !Q.isPrinting && ht && ot && (at === i || at === o) && ((ht !== Q.containerWidth || ot !== Q.containerHeight) && (s.clearTimeout(Q.reflowTimeout), Q.reflowTimeout = tt(function () {
            Q.container && Q.setSize(void 0, void 0, !1);
          }, $ ? 100 : 0)), Q.containerWidth = ht, Q.containerHeight = ot);
        }, it.prototype.setReflow = function ($) {
          var Q = this;
          $ === !1 || this.unbindReflow ? $ === !1 && this.unbindReflow && (this.unbindReflow = this.unbindReflow()) : (this.unbindReflow = e(i, "resize", function (ot) {
            Q.options && Q.reflow(ot);
          }), e(this, "destroy", this.unbindReflow));
        }, it.prototype.setSize = function ($, Q, ot) {
          var at = this,
            rt = at.renderer;
          at.isResizing += 1, M(ot, at), ot = rt.globalAnimation, at.oldChartHeight = at.chartHeight, at.oldChartWidth = at.chartWidth, typeof $ < "u" && (at.options.chart.width = $), typeof Q < "u" && (at.options.chart.height = Q), at.getChartSize(), at.styledMode || (ot ? u : b)(at.container, {
            width: at.chartWidth + "px",
            height: at.chartHeight + "px"
          }, ot), at.setChartSize(!0), rt.setSize(at.chartWidth, at.chartHeight, ot), at.axes.forEach(function (ht) {
            ht.isDirty = !0, ht.setScale();
          }), at.isDirtyLegend = !0, at.isDirtyBox = !0, at.layOutTitles(), at.getMargins(), at.redraw(ot), at.oldChartHeight = null, F(at, "resize"), tt(function () {
            at && F(at, "endResize", null, function () {
              --at.isResizing;
            });
          }, v(ot).duration);
        }, it.prototype.setChartSize = function ($) {
          var Q = this.inverted,
            ot = this.renderer,
            at = this.chartWidth,
            rt = this.chartHeight,
            ht = this.options.chart,
            pt = this.spacing,
            dt = this.clipOffset,
            gt,
            ut,
            ft,
            vt;
          this.plotLeft = gt = Math.round(this.plotLeft), this.plotTop = ut = Math.round(this.plotTop), this.plotWidth = ft = Math.max(0, Math.round(at - gt - this.marginRight)), this.plotHeight = vt = Math.max(0, Math.round(rt - ut - this.marginBottom)), this.plotSizeX = Q ? vt : ft, this.plotSizeY = Q ? ft : vt, this.plotBorderWidth = ht.plotBorderWidth || 0, this.spacingBox = ot.spacingBox = {
            x: pt[3],
            y: pt[0],
            width: at - pt[3] - pt[1],
            height: rt - pt[0] - pt[2]
          }, this.plotBox = ot.plotBox = {
            x: gt,
            y: ut,
            width: ft,
            height: vt
          }, Q = 2 * Math.floor(this.plotBorderWidth / 2), at = Math.ceil(Math.max(Q, dt[3]) / 2), rt = Math.ceil(Math.max(Q, dt[0]) / 2), this.clipBox = {
            x: at,
            y: rt,
            width: Math.floor(this.plotSizeX - Math.max(Q, dt[1]) / 2 - at),
            height: Math.max(0, Math.floor(this.plotSizeY - Math.max(Q, dt[2]) / 2 - rt))
          }, $ || (this.axes.forEach(function (mt) {
            mt.setAxisSize(), mt.setAxisTranslation();
          }), ot.alignElements()), F(this, "afterSetChartSize", {
            skipAxes: $
          });
        }, it.prototype.resetMargins = function () {
          F(this, "resetMargins");
          var $ = this,
            Q = $.options.chart;
          ["margin", "spacing"].forEach(function (ot) {
            var at = Q[ot],
              rt = q(at) ? at : [at, at, at, at];
            ["Top", "Right", "Bottom", "Left"].forEach(function (ht, pt) {
              $[ot][pt] = J(Q[ot + ht], rt[pt]);
            });
          }), n.forEach(function (ot, at) {
            $[ot] = J($.margin[at], $.spacing[at]);
          }), $.axisOffset = [0, 0, 0, 0], $.clipOffset = [0, 0, 0, 0];
        }, it.prototype.drawChartBox = function () {
          var $ = this.options.chart,
            Q = this.renderer,
            ot = this.chartWidth,
            at = this.chartHeight,
            rt = this.styledMode,
            ht = this.plotBGImage,
            pt = $.backgroundColor,
            dt = $.plotBackgroundColor,
            gt = $.plotBackgroundImage,
            ut = this.plotLeft,
            ft = this.plotTop,
            vt = this.plotWidth,
            mt = this.plotHeight,
            xt = this.plotBox,
            yt = this.clipRect,
            wt = this.clipBox,
            Ct = this.chartBackground,
            bt = this.plotBackground,
            Dt = this.plotBorder,
            Ot,
            Pt = "animate";
          if (Ct || (this.chartBackground = Ct = Q.rect().addClass("highcharts-background").add(), Pt = "attr"), rt) var Et = Ot = Ct.strokeWidth();else Et = $.borderWidth || 0, Ot = Et + ($.shadow ? 8 : 0), pt = {
            fill: pt || "none"
          }, (Et || Ct["stroke-width"]) && (pt.stroke = $.borderColor, pt["stroke-width"] = Et), Ct.attr(pt).shadow($.shadow);
          Ct[Pt]({
            x: Ot / 2,
            y: Ot / 2,
            width: ot - Ot - Et % 2,
            height: at - Ot - Et % 2,
            r: $.borderRadius
          }), Pt = "animate", bt || (Pt = "attr", this.plotBackground = bt = Q.rect().addClass("highcharts-plot-background").add()), bt[Pt](xt), rt || (bt.attr({
            fill: dt || "none"
          }).shadow($.plotShadow), gt && (ht ? (gt !== ht.attr("href") && ht.attr("href", gt), ht.animate(xt)) : this.plotBGImage = Q.image(gt, ut, ft, vt, mt).add())), yt ? yt.animate({
            width: wt.width,
            height: wt.height
          }) : this.clipRect = Q.clipRect(wt), Pt = "animate", Dt || (Pt = "attr", this.plotBorder = Dt = Q.rect().addClass("highcharts-plot-border").attr({
            zIndex: 1
          }).add()), rt || Dt.attr({
            stroke: $.plotBorderColor,
            "stroke-width": $.plotBorderWidth || 0,
            fill: "none"
          }), Dt[Pt](Dt.crisp({
            x: ut,
            y: ft,
            width: vt,
            height: mt
          }, -Dt.strokeWidth())), this.isDirtyBox = !1, F(this, "afterDrawChartBox");
        }, it.prototype.propFromSeries = function () {
          var $ = this,
            Q = $.options.chart,
            ot = $.options.series,
            at,
            rt,
            ht;
          ["inverted", "angular", "polar"].forEach(function (pt) {
            for (rt = t[Q.type || Q.defaultSeriesType], ht = Q[pt] || rt && rt.prototype[pt], at = ot && ot.length; !ht && at--;) (rt = t[ot[at].type]) && rt.prototype[pt] && (ht = !0);
            $[pt] = ht;
          });
        }, it.prototype.linkSeries = function () {
          var $ = this,
            Q = $.series;
          Q.forEach(function (ot) {
            ot.linkedSeries.length = 0;
          }), Q.forEach(function (ot) {
            var at = ot.options.linkedTo;
            Y(at) && (at = at === ":previous" ? $.series[ot.index - 1] : $.get(at)) && at.linkedParent !== ot && (at.linkedSeries.push(ot), ot.linkedParent = at, at.enabledDataSorting && ot.setDataSortingOptions(), ot.visible = J(ot.options.visible, at.options.visible, ot.visible));
          }), F(this, "afterLinkSeries");
        }, it.prototype.renderSeries = function () {
          this.series.forEach(function ($) {
            $.translate(), $.render();
          });
        }, it.prototype.renderLabels = function () {
          var $ = this,
            Q = $.options.labels;
          Q.items && Q.items.forEach(function (ot) {
            var at = N(Q.style, ot.style),
              rt = et(at.left) + $.plotLeft,
              ht = et(at.top) + $.plotTop + 12;
            delete at.left, delete at.top, $.renderer.text(ot.html, rt, ht).attr({
              zIndex: 2
            }).css(at).add();
          });
        }, it.prototype.render = function () {
          var $ = this.axes,
            Q = this.colorAxis,
            ot = this.renderer,
            at = this.options,
            rt = function rt(ut) {
              ut.forEach(function (ft) {
                ft.visible && ft.render();
              });
            },
            ht = 0;
          this.setTitle(), this.legend = new z(this, at.legend), this.getStacks && this.getStacks(), this.getMargins(!0), this.setChartSize(), at = this.plotWidth, $.some(function (ut) {
            if (ut.horiz && ut.visible && ut.options.labels.enabled && ut.series.length) return ht = 21, !0;
          });
          var pt = this.plotHeight = Math.max(this.plotHeight - ht, 0);
          $.forEach(function (ut) {
            ut.setScale();
          }), this.getAxisMargins();
          var dt = 1.1 < at / this.plotWidth,
            gt = 1.05 < pt / this.plotHeight;
          (dt || gt) && ($.forEach(function (ut) {
            (ut.horiz && dt || !ut.horiz && gt) && ut.setTickInterval(!0);
          }), this.getMargins()), this.drawChartBox(), this.hasCartesianSeries ? rt($) : Q && Q.length && rt(Q), this.seriesGroup || (this.seriesGroup = ot.g("series-group").attr({
            zIndex: 3
          }).add()), this.renderSeries(), this.renderLabels(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
        }, it.prototype.addCredits = function ($) {
          var Q = this,
            ot = U(!0, this.options.credits, $);
          ot.enabled && !this.credits && (this.credits = this.renderer.text(ot.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function () {
            ot.href && (i.location.href = ot.href);
          }).attr({
            align: ot.position.align,
            zIndex: 8
          }), Q.styledMode || this.credits.css(ot.style), this.credits.add().align(ot.position), this.credits.update = function (at) {
            Q.credits = Q.credits.destroy(), Q.addCredits(at);
          });
        }, it.prototype.destroy = function () {
          var $ = this,
            Q = $.axes,
            ot = $.series,
            at = $.container,
            rt = at && at.parentNode,
            ht;
          for (F($, "destroy"), $.renderer.forExport ? f(d, $) : d[$.index] = void 0, W.chartCount--, $.renderTo.removeAttribute("data-highcharts-chart"), lt($), ht = Q.length; ht--;) Q[ht] = Q[ht].destroy();
          for (this.scroller && this.scroller.destroy && this.scroller.destroy(), ht = ot.length; ht--;) ot[ht] = ot[ht].destroy();
          "title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function (pt) {
            var dt = $[pt];
            dt && dt.destroy && ($[pt] = dt.destroy());
          }), at && (at.innerHTML = l.emptyHTML, lt(at), rt && P(at)), Z($, function (pt, dt) {
            delete $[dt];
          });
        }, it.prototype.firstRender = function () {
          var $ = this,
            Q = $.options;
          (!$.isReadyToRender || $.isReadyToRender()) && ($.getContainer(), $.resetMargins(), $.setChartSize(), $.propFromSeries(), $.getAxes(), (G(Q.series) ? Q.series : []).forEach(function (ot) {
            $.initSeries(ot);
          }), $.linkSeries(), $.setSeriesData(), F($, "beforeRender"), A && (w.isRequired() ? $.pointer = new w($, Q) : $.pointer = new A($, Q)), $.render(), $.pointer.getChartPosition(), !$.renderer.imgCount && !$.hasLoaded && $.onload(), $.temporaryDisplay(!0));
        }, it.prototype.onload = function () {
          this.callbacks.concat([this.callback]).forEach(function ($) {
            $ && typeof this.index < "u" && $.apply(this, [this]);
          }, this), F(this, "load"), F(this, "render"), j(this.index) && this.setReflow(this.options.chart.reflow), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
        }, it.prototype.warnIfA11yModuleNotLoaded = function () {
          var $ = this.options,
            Q = this.title;
          $ && !this.accessibility && (this.renderer.boxWrapper.attr({
            role: "img",
            "aria-label": (Q && Q.element.textContent || "").replace(/</g, "&lt;")
          }), $.accessibility && $.accessibility.enabled === !1 || x('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
        }, it.prototype.addSeries = function ($, Q, ot) {
          var at = this,
            rt;
          return $ && (Q = J(Q, !0), F(at, "addSeries", {
            options: $
          }, function () {
            rt = at.initSeries($), at.isDirtyLegend = !0, at.linkSeries(), rt.enabledDataSorting && rt.setData($.data, !1), F(at, "afterAddSeries", {
              series: rt
            }), Q && at.redraw(ot);
          })), rt;
        }, it.prototype.addAxis = function ($, Q, ot, at) {
          return this.createAxis(Q ? "xAxis" : "yAxis", {
            axis: $,
            redraw: ot,
            animation: at
          });
        }, it.prototype.addColorAxis = function ($, Q, ot) {
          return this.createAxis("colorAxis", {
            axis: $,
            redraw: Q,
            animation: ot
          });
        }, it.prototype.createAxis = function ($, Q) {
          return $ = new E(this, U(Q.axis, {
            index: this[$].length,
            isX: $ === "xAxis"
          })), J(Q.redraw, !0) && this.redraw(Q.animation), $;
        }, it.prototype.showLoading = function ($) {
          var Q = this,
            ot = Q.options,
            at = ot.loading,
            rt = function rt() {
              ht && b(ht, {
                left: Q.plotLeft + "px",
                top: Q.plotTop + "px",
                width: Q.plotWidth + "px",
                height: Q.plotHeight + "px"
              });
            },
            ht = Q.loadingDiv,
            pt = Q.loadingSpan;
          ht || (Q.loadingDiv = ht = y("div", {
            className: "highcharts-loading highcharts-loading-hidden"
          }, null, Q.container)), pt || (Q.loadingSpan = pt = y("span", {
            className: "highcharts-loading-inner"
          }, null, ht), e(Q, "redraw", rt)), ht.className = "highcharts-loading", l.setElementHTML(pt, J($, ot.lang.loading, "")), Q.styledMode || (b(ht, N(at.style, {
            zIndex: 10
          })), b(pt, at.labelStyle), Q.loadingShown || (b(ht, {
            opacity: 0,
            display: ""
          }), u(ht, {
            opacity: at.style.opacity || 0.5
          }, {
            duration: at.showDuration || 0
          }))), Q.loadingShown = !0, rt();
        }, it.prototype.hideLoading = function () {
          var $ = this.options,
            Q = this.loadingDiv;
          Q && (Q.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || u(Q, {
            opacity: 0
          }, {
            duration: $.loading.hideDuration || 100,
            complete: function complete() {
              b(Q, {
                display: "none"
              });
            }
          })), this.loadingShown = !1;
        }, it.prototype.update = function ($, Q, ot, at) {
          var rt = this,
            ht = {
              credits: "addCredits",
              title: "setTitle",
              subtitle: "setSubtitle",
              caption: "setCaption"
            },
            pt = $.isResponsiveOptions,
            dt = [],
            gt,
            ut;
          F(rt, "update", {
            options: $
          }), pt || rt.setResponsive(!1, !0), $ = c($, rt.options), rt.userOptions = U(rt.userOptions, $);
          var ft = $.chart;
          if (ft) {
            if (U(!0, rt.options.chart, ft), "className" in ft && rt.setClassName(ft.className), "reflow" in ft && rt.setReflow(ft.reflow), "inverted" in ft || "polar" in ft || "type" in ft) {
              rt.propFromSeries();
              var vt = !0;
            }
            "alignTicks" in ft && (vt = !0), "events" in ft && m(this, ft), Z(ft, function (mt, xt) {
              rt.propsRequireUpdateSeries.indexOf("chart." + xt) !== -1 && (gt = !0), rt.propsRequireDirtyBox.indexOf(xt) !== -1 && (rt.isDirtyBox = !0), rt.propsRequireReflow.indexOf(xt) !== -1 && (pt ? rt.isDirtyBox = !0 : ut = !0);
            }), !rt.styledMode && ft.style && rt.renderer.setStyle(rt.options.chart.style || {});
          }
          !rt.styledMode && $.colors && (this.options.colors = $.colors), $.time && (this.time === L && (this.time = new h($.time)), U(!0, rt.options.time, $.time)), Z($, function (mt, xt) {
            rt[xt] && typeof rt[xt].update == "function" ? rt[xt].update(mt, !1) : typeof rt[ht[xt]] == "function" ? rt[ht[xt]](mt) : xt !== "colors" && rt.collectionsWithUpdate.indexOf(xt) === -1 && U(!0, rt.options[xt], $[xt]), xt !== "chart" && rt.propsRequireUpdateSeries.indexOf(xt) !== -1 && (gt = !0);
          }), this.collectionsWithUpdate.forEach(function (mt) {
            if ($[mt]) {
              var xt = [];
              rt[mt].forEach(function (yt, wt) {
                yt.options.isInternal || xt.push(J(yt.options.index, wt));
              }), ct($[mt]).forEach(function (yt, wt) {
                var Ct = j(yt.id),
                  bt;
                Ct && (bt = rt.get(yt.id)), !bt && rt[mt] && (bt = rt[mt][xt ? xt[wt] : wt]) && Ct && j(bt.options.id) && (bt = void 0), bt && bt.coll === mt && (bt.update(yt, !1), ot && (bt.touched = !0)), !bt && ot && rt.collectionsWithInit[mt] && (rt.collectionsWithInit[mt][0].apply(rt, [yt].concat(rt.collectionsWithInit[mt][1] || []).concat([!1])).touched = !0);
              }), ot && rt[mt].forEach(function (yt) {
                yt.touched || yt.options.isInternal ? delete yt.touched : dt.push(yt);
              });
            }
          }), dt.forEach(function (mt) {
            mt.chart && mt.remove && mt.remove(!1);
          }), vt && rt.axes.forEach(function (mt) {
            mt.update({}, !1);
          }), gt && rt.getSeriesOrderByLinks().forEach(function (mt) {
            mt.chart && mt.update({}, !1);
          }, this), vt = ft && ft.width, ft = ft && (Y(ft.height) ? nt(ft.height, vt || rt.chartWidth) : ft.height), ut || _(vt) && vt !== rt.chartWidth || _(ft) && ft !== rt.chartHeight ? rt.setSize(vt, ft, at) : J(Q, !0) && rt.redraw(at), F(rt, "afterUpdate", {
            options: $,
            redraw: Q,
            animation: at
          });
        }, it.prototype.setSubtitle = function ($, Q) {
          this.applyDescription("subtitle", $), this.layOutTitles(Q);
        }, it.prototype.setCaption = function ($, Q) {
          this.applyDescription("caption", $), this.layOutTitles(Q);
        }, it.prototype.showResetZoom = function () {
          function $() {
            Q.zoomOut();
          }
          var Q = this,
            ot = I.lang,
            at = Q.options.chart.zooming.resetButton,
            rt = at.theme,
            ht = at.relativeTo === "chart" || at.relativeTo === "spacingBox" ? null : "scrollablePlotBox";
          F(this, "beforeShowResetZoom", null, function () {
            Q.resetZoomButton = Q.renderer.button(ot.resetZoom, null, null, $, rt).attr({
              align: at.position.align,
              title: ot.resetZoomTitle
            }).addClass("highcharts-reset-zoom").add().align(at.position, !1, ht);
          }), F(this, "afterShowResetZoom");
        }, it.prototype.zoomOut = function () {
          F(this, "selection", {
            resetSelection: !0
          }, this.zoom);
        }, it.prototype.zoom = function ($) {
          var Q = this,
            ot = Q.pointer,
            at = !1,
            rt;
          !$ || $.resetSelection ? (Q.axes.forEach(function (pt) {
            rt = pt.zoom();
          }), ot.initiated = !1) : $.xAxis.concat($.yAxis).forEach(function (pt) {
            var dt = pt.axis;
            (ot[dt.isXAxis ? "zoomX" : "zoomY"] && j(ot.mouseDownX) && j(ot.mouseDownY) && Q.isInsidePlot(ot.mouseDownX - Q.plotLeft, ot.mouseDownY - Q.plotTop, {
              axis: dt
            }) || !j(Q.inverted ? ot.mouseDownX : ot.mouseDownY)) && (rt = dt.zoom(pt.min, pt.max), dt.displayBtn && (at = !0));
          });
          var ht = Q.resetZoomButton;
          at && !ht ? Q.showResetZoom() : !at && q(ht) && (Q.resetZoomButton = ht.destroy()), rt && Q.redraw(J(Q.options.chart.animation, $ && $.animation, 100 > Q.pointCount));
        }, it.prototype.pan = function ($, Q) {
          var ot = this,
            at = ot.hoverPoints;
          Q = typeof Q == "object" ? Q : {
            enabled: Q,
            type: "x"
          };
          var rt = ot.options.chart;
          rt && rt.panning && (rt.panning = Q);
          var ht = Q.type,
            pt;
          F(this, "pan", {
            originalEvent: $
          }, function () {
            at && at.forEach(function (ut) {
              ut.setState();
            });
            var dt = ot.xAxis;
            ht === "xy" ? dt = dt.concat(ot.yAxis) : ht === "y" && (dt = ot.yAxis);
            var gt = {};
            dt.forEach(function (ut) {
              if (ut.options.panningEnabled && !ut.options.isInternal) {
                var ft = ut.horiz,
                  vt = $[ft ? "chartX" : "chartY"];
                ft = ft ? "mouseDownX" : "mouseDownY";
                var mt = ot[ft],
                  xt = ut.minPointOffset || 0,
                  yt = ut.reversed && !ot.inverted || !ut.reversed && ot.inverted ? -1 : 1,
                  wt = ut.getExtremes(),
                  Ct = ut.toValue(mt - vt, !0) + xt * yt,
                  bt = ut.toValue(mt + ut.len - vt, !0) - (xt * yt || ut.isXAxis && ut.pointRangePadding || 0),
                  Dt = bt < Ct;
                yt = ut.hasVerticalPanning(), mt = Dt ? bt : Ct, Ct = Dt ? Ct : bt;
                var Ot = ut.panningState;
                !yt || ut.isXAxis || Ot && !Ot.isDirty || ut.series.forEach(function (Pt) {
                  var Et = Pt.getProcessedData(!0);
                  Et = Pt.getExtremes(Et.yData, !0), Ot || (Ot = {
                    startMin: Number.MAX_VALUE,
                    startMax: -Number.MAX_VALUE
                  }), _(Et.dataMin) && _(Et.dataMax) && (Ot.startMin = Math.min(J(Pt.options.threshold, 1 / 0), Et.dataMin, Ot.startMin), Ot.startMax = Math.max(J(Pt.options.threshold, -1 / 0), Et.dataMax, Ot.startMax));
                }), yt = Math.min(J(Ot && Ot.startMin, wt.dataMin), xt ? wt.min : ut.toValue(ut.toPixels(wt.min) - ut.minPixelPadding)), bt = Math.max(J(Ot && Ot.startMax, wt.dataMax), xt ? wt.max : ut.toValue(ut.toPixels(wt.max) + ut.minPixelPadding)), ut.panningState = Ot, ut.isOrdinal || (xt = yt - mt, 0 < xt && (Ct += xt, mt = yt), xt = Ct - bt, 0 < xt && (Ct = bt, mt -= xt), ut.series.length && mt !== wt.min && Ct !== wt.max && mt >= yt && Ct <= bt && (ut.setExtremes(mt, Ct, !1, !1, {
                  trigger: "pan"
                }), !ot.resetZoomButton && mt !== yt && Ct !== bt && ht.match("y") && (ot.showResetZoom(), ut.displayBtn = !1), pt = !0), gt[ft] = vt);
              }
            }), Z(gt, function (ut, ft) {
              ot[ft] = ut;
            }), pt && ot.redraw(!1), b(ot.container, {
              cursor: "move"
            });
          });
        }, it;
      }(), N(D.prototype, {
        callbacks: [],
        collectionsWithInit: {
          xAxis: [D.prototype.addAxis, [!0]],
          yAxis: [D.prototype.addAxis, [!1]],
          series: [D.prototype.addSeries]
        },
        collectionsWithUpdate: ["xAxis", "yAxis", "series"],
        propsRequireDirtyBox: "backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
        propsRequireReflow: "margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
        propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" ")
      }), D;
    }), V(S, "Core/Legend/LegendSymbol.js", [S["Core/Utilities.js"]], function (D) {
      var E = D.extend,
        B = D.merge,
        H = D.pick,
        X;
      return function (W) {
        W.drawLineMarker = function (z) {
          var w = this.legendItem = this.legendItem || {},
            A = this.options,
            k = z.symbolWidth,
            g = z.symbolHeight,
            p = g / 2,
            h = this.chart.renderer,
            s = w.group;
          z = z.baseline - Math.round(0.3 * z.fontMetrics.b);
          var l = {},
            u = A.marker,
            v = 0;
          this.chart.styledMode || (l = {
            "stroke-width": Math.min(A.lineWidth || 0, 24)
          }, A.dashStyle ? l.dashstyle = A.dashStyle : A.linecap !== "square" && (l["stroke-linecap"] = "round")), w.line = h.path().addClass("highcharts-graph").attr(l).add(s), l["stroke-linecap"] && (v = Math.min(w.line.strokeWidth(), k) / 2), w.line.attr({
            d: [["M", v, z], ["L", k - v, z]]
          }), u && u.enabled !== !1 && k && (A = Math.min(H(u.radius, p), p), this.symbol.indexOf("url") === 0 && (u = B(u, {
            width: g,
            height: g
          }), A = 0), w.symbol = w = h.symbol(this.symbol, k / 2 - A, z - A, 2 * A, 2 * A, E({
            context: "legend"
          }, u)).addClass("highcharts-point").add(s), w.isMarker = !0);
        }, W.drawRectangle = function (z, w) {
          w = w.legendItem || {};
          var A = z.symbolHeight,
            k = z.options.squareSymbol;
          w.symbol = this.chart.renderer.rect(k ? (z.symbolWidth - A) / 2 : 0, z.baseline - A + 1, k ? A : z.symbolWidth, A, H(z.options.symbolRadius, A / 2)).addClass("highcharts-point").attr({
            zIndex: 3
          }).add(w.group);
        };
      }(X || (X = {})), X;
    }), V(S, "Core/Series/SeriesDefaults.js", [], function () {
      return {
        lineWidth: 2,
        allowPointSelect: !1,
        crisp: !0,
        showCheckbox: !1,
        animation: {
          duration: 1e3
        },
        events: {},
        marker: {
          enabledThreshold: 2,
          lineColor: "#ffffff",
          lineWidth: 0,
          radius: 4,
          states: {
            normal: {
              animation: !0
            },
            hover: {
              animation: {
                duration: 50
              },
              enabled: !0,
              radiusPlus: 2,
              lineWidthPlus: 1
            },
            select: {
              fillColor: "#cccccc",
              lineColor: "#000000",
              lineWidth: 2
            }
          }
        },
        point: {
          events: {}
        },
        dataLabels: {
          animation: {},
          align: "center",
          borderWidth: 0,
          defer: !0,
          formatter: function formatter() {
            var D = this.series.chart.numberFormatter;
            return typeof this.y != "number" ? "" : D(this.y, -1);
          },
          padding: 5,
          style: {
            fontSize: "11px",
            fontWeight: "bold",
            color: "contrast",
            textOutline: "1px contrast"
          },
          verticalAlign: "bottom",
          x: 0,
          y: 0
        },
        cropThreshold: 300,
        opacity: 1,
        pointRange: 0,
        softThreshold: !0,
        states: {
          normal: {
            animation: !0
          },
          hover: {
            animation: {
              duration: 50
            },
            lineWidthPlus: 1,
            marker: {},
            halo: {
              size: 10,
              opacity: 0.25
            }
          },
          select: {
            animation: {
              duration: 0
            }
          },
          inactive: {
            animation: {
              duration: 50
            },
            opacity: 0.2
          }
        },
        stickyTracking: !0,
        turboThreshold: 1e3,
        findNearestPointBy: "x"
      };
    }), V(S, "Core/Series/Series.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/Defaults.js"], S["Core/Foundation.js"], S["Core/Globals.js"], S["Core/Legend/LegendSymbol.js"], S["Core/Series/Point.js"], S["Core/Series/SeriesDefaults.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Renderer/SVG/SVGElement.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z, w, A, k) {
      var g = D.animObject,
        p = D.setAnimation,
        h = E.defaultOptions,
        s = B.registerEventOptions,
        l = H.hasTouch,
        u = H.svg,
        v = H.win,
        M = w.seriesTypes,
        I = k.arrayMax,
        L = k.arrayMin,
        C = k.clamp,
        m = k.cleanRecursively,
        d = k.correctFloat,
        o = k.defined,
        n = k.erase,
        r = k.error,
        i = k.extend,
        t = k.find,
        e = k.fireEvent,
        a = k.getNestedProperty,
        c = k.isArray,
        y = k.isNumber,
        b = k.isString,
        j = k.merge,
        P = k.objectEach,
        f = k.pick,
        x = k.removeEvent,
        N = k.splat,
        R = k.syncTimeout;
      return D = function () {
        function F() {
          this.zones = this.yAxis = this.xAxis = this.userOptions = this.tooltipOptions = this.processedYData = this.processedXData = this.points = this.options = this.linkedSeries = this.index = this.eventsToUnbind = this.eventOptions = this.data = this.chart = this._i = void 0;
        }
        return F.prototype.init = function (T, G) {
          e(this, "init", {
            options: G
          });
          var _ = this,
            q = T.series;
          this.eventsToUnbind = [], _.chart = T, _.options = _.setOptions(G), G = _.options, _.linkedSeries = [], _.bindAxes(), i(_, {
            name: G.name,
            state: "",
            visible: G.visible !== !1,
            selected: G.selected === !0
          }), s(this, G);
          var Y = G.events;
          (Y && Y.click || G.point && G.point.events && G.point.events.click || G.allowPointSelect) && (T.runTrackerClick = !0), _.getColor(), _.getSymbol(), _.parallelArrays.forEach(function (Z) {
            _[Z + "Data"] || (_[Z + "Data"] = []);
          }), _.isCartesian && (T.hasCartesianSeries = !0);
          var U;
          q.length && (U = q[q.length - 1]), _._i = f(U && U._i, -1) + 1, _.opacity = _.options.opacity, T.orderSeries(this.insert(q)), G.dataSorting && G.dataSorting.enabled ? _.setDataSortingOptions() : _.points || _.data || _.setData(G.data, !1), e(this, "afterInit");
        }, F.prototype.is = function (T) {
          return M[T] && this instanceof M[T];
        }, F.prototype.insert = function (T) {
          var G = this.options.index,
            _;
          if (y(G)) {
            for (_ = T.length; _--;) if (G >= f(T[_].options.index, T[_]._i)) {
              T.splice(_ + 1, 0, this);
              break;
            }
            _ === -1 && T.unshift(this), _ += 1;
          } else T.push(this);
          return f(_, T.length - 1);
        }, F.prototype.bindAxes = function () {
          var T = this,
            G = T.options,
            _ = T.chart,
            q;
          e(this, "bindAxes", null, function () {
            (T.axisTypes || []).forEach(function (Y) {
              var U = 0;
              _[Y].forEach(function (Z) {
                q = Z.options, (G[Y] === U && !q.isInternal || typeof G[Y] < "u" && G[Y] === q.id || typeof G[Y] > "u" && q.index === 0) && (T.insert(Z.series), T[Y] = Z, Z.isDirty = !0), q.isInternal || U++;
              }), T[Y] || T.optionalAxis === Y || r(18, !0, _);
            });
          }), e(this, "afterBindAxes");
        }, F.prototype.updateParallelArrays = function (T, G) {
          var _ = T.series,
            q = arguments,
            Y = y(G) ? function (U) {
              var Z = U === "y" && _.toYData ? _.toYData(T) : T[U];
              _[U + "Data"][G] = Z;
            } : function (U) {
              Array.prototype[G].apply(_[U + "Data"], Array.prototype.slice.call(q, 2));
            };
          _.parallelArrays.forEach(Y);
        }, F.prototype.hasData = function () {
          return this.visible && typeof this.dataMax < "u" && typeof this.dataMin < "u" || this.visible && this.yData && 0 < this.yData.length;
        }, F.prototype.autoIncrement = function (T) {
          var G = this.options,
            _ = G.pointIntervalUnit,
            q = G.relativeXValue,
            Y = this.chart.time,
            U = this.xIncrement,
            Z;
          return U = f(U, G.pointStart, 0), this.pointInterval = Z = f(this.pointInterval, G.pointInterval, 1), q && y(T) && (Z *= T), _ && (G = new Y.Date(U), _ === "day" ? Y.set("Date", G, Y.get("Date", G) + Z) : _ === "month" ? Y.set("Month", G, Y.get("Month", G) + Z) : _ === "year" && Y.set("FullYear", G, Y.get("FullYear", G) + Z), Z = G.getTime() - U), q && y(T) ? U + Z : (this.xIncrement = U + Z, U);
        }, F.prototype.setDataSortingOptions = function () {
          var T = this.options;
          i(this, {
            requireSorting: !1,
            sorted: !1,
            enabledDataSorting: !0,
            allowDG: !1
          }), o(T.pointRange) || (T.pointRange = 1);
        }, F.prototype.setOptions = function (T) {
          var G = this.chart,
            _ = G.options,
            q = _.plotOptions,
            Y = G.userOptions || {};
          T = j(T), G = G.styledMode;
          var U = {
            plotOptions: q,
            userOptions: T
          };
          e(this, "setOptions", U);
          var Z = U.plotOptions[this.type],
            J = Y.plotOptions || {};
          return this.userOptions = U.userOptions, Y = j(Z, q.series, Y.plotOptions && Y.plotOptions[this.type], T), this.tooltipOptions = j(h.tooltip, h.plotOptions.series && h.plotOptions.series.tooltip, h.plotOptions[this.type].tooltip, _.tooltip.userOptions, q.series && q.series.tooltip, q[this.type].tooltip, T.tooltip), this.stickyTracking = f(T.stickyTracking, J[this.type] && J[this.type].stickyTracking, J.series && J.series.stickyTracking, this.tooltipOptions.shared && !this.noSharedTooltip ? !0 : Y.stickyTracking), Z.marker === null && delete Y.marker, this.zoneAxis = Y.zoneAxis, q = this.zones = (Y.zones || []).slice(), !Y.negativeColor && !Y.negativeFillColor || Y.zones || (_ = {
            value: Y[this.zoneAxis + "Threshold"] || Y.threshold || 0,
            className: "highcharts-negative"
          }, G || (_.color = Y.negativeColor, _.fillColor = Y.negativeFillColor), q.push(_)), q.length && o(q[q.length - 1].value) && q.push(G ? {} : {
            color: this.color,
            fillColor: this.fillColor
          }), e(this, "afterSetOptions", {
            options: Y
          }), Y;
        }, F.prototype.getName = function () {
          return f(this.options.name, "Series " + (this.index + 1));
        }, F.prototype.getCyclic = function (T, G, _) {
          var q = this.chart,
            Y = this.userOptions,
            U = T + "Index",
            Z = T + "Counter",
            J = _ ? _.length : f(q.options.chart[T + "Count"], q[T + "Count"]);
          if (!G) {
            var et = f(Y[U], Y["_" + U]);
            o(et) || (q.series.length || (q[Z] = 0), Y["_" + U] = et = q[Z] % J, q[Z] += 1), _ && (G = _[et]);
          }
          typeof et < "u" && (this[U] = et), this[T] = G;
        }, F.prototype.getColor = function () {
          this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || h.plotOptions[this.type].color, this.chart.options.colors);
        }, F.prototype.getPointsCollection = function () {
          return (this.hasGroupedData ? this.points : this.data) || [];
        }, F.prototype.getSymbol = function () {
          this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
        }, F.prototype.findPointIndex = function (T, G) {
          var _ = T.id,
            q = T.x,
            Y = this.points,
            U = this.options.dataSorting,
            Z,
            J;
          if (_) U = this.chart.get(_), U instanceof W && (Z = U);else if ((this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) && (Z = function Z(nt) {
            return !nt.touched && nt.index === T.index;
          }, U && U.matchByName ? Z = function Z(nt) {
            return !nt.touched && nt.name === T.name;
          } : this.options.relativeXValue && (Z = function Z(nt) {
            return !nt.touched && nt.options.x === T.x;
          }), Z = t(Y, Z), !Z)) return;
          if (Z) {
            var et = Z && Z.index;
            typeof et < "u" && (J = !0);
          }
          return typeof et > "u" && y(q) && (et = this.xData.indexOf(q, G)), et !== -1 && typeof et < "u" && this.cropped && (et = et >= this.cropStart ? et - this.cropStart : et), !J && y(et) && Y[et] && Y[et].touched && (et = void 0), et;
        }, F.prototype.updateData = function (T, G) {
          var _ = this.options,
            q = _.dataSorting,
            Y = this.points,
            U = [],
            Z = this.requireSorting,
            J = T.length === Y.length,
            et,
            nt,
            lt,
            ct = !0;
          if (this.xIncrement = null, T.forEach(function (tt, st) {
            var it = o(tt) && this.pointClass.prototype.optionsToObject.call({
                series: this
              }, tt) || {},
              $ = it.x;
            it.id || y($) ? (it = this.findPointIndex(it, lt), it === -1 || typeof it > "u" ? U.push(tt) : Y[it] && tt !== _.data[it] ? (Y[it].update(tt, !1, null, !1), Y[it].touched = !0, Z && (lt = it + 1)) : Y[it] && (Y[it].touched = !0), (!J || st !== it || q && q.enabled || this.hasDerivedData) && (et = !0)) : U.push(tt);
          }, this), et) for (T = Y.length; T--;) (nt = Y[T]) && !nt.touched && nt.remove && nt.remove(!1, G);else !J || q && q.enabled ? ct = !1 : (T.forEach(function (tt, st) {
            tt !== Y[st].y && Y[st].update && Y[st].update(tt, !1, null, !1);
          }), U.length = 0);
          return Y.forEach(function (tt) {
            tt && (tt.touched = !1);
          }), ct ? (U.forEach(function (tt) {
            this.addPoint(tt, !1, null, null, !1);
          }, this), this.xIncrement === null && this.xData && this.xData.length && (this.xIncrement = I(this.xData), this.autoIncrement()), !0) : !1;
        }, F.prototype.setData = function (T, G, _, q) {
          G === void 0 && (G = !0);
          var Y = this,
            U = Y.points,
            Z = U && U.length || 0,
            J = Y.options,
            et = Y.chart,
            nt = J.dataSorting,
            lt = Y.xAxis,
            ct = J.turboThreshold,
            tt = this.xData,
            st = this.yData,
            it = Y.pointArrayMap;
          it = it && it.length;
          var $ = J.keys,
            Q,
            ot = 0,
            at = 1,
            rt = null;
          if (!et.options.chart.allowMutatingData) {
            J.data && delete Y.options.data, Y.userOptions.data && delete Y.userOptions.data;
            var ht = j(!0, T);
          }
          if (T = ht || T || [], ht = T.length, nt && nt.enabled && (T = this.sortData(T)), et.options.chart.allowMutatingData && q !== !1 && ht && Z && !Y.cropped && !Y.hasGroupedData && Y.visible && !Y.boosted && (Q = this.updateData(T, _)), !Q) {
            if (Y.xIncrement = null, Y.colorCounter = 0, this.parallelArrays.forEach(function (pt) {
              Y[pt + "Data"].length = 0;
            }), ct && ht > ct) {
              if (rt = Y.getFirstValidPoint(T), y(rt)) for (_ = 0; _ < ht; _++) tt[_] = this.autoIncrement(), st[_] = T[_];else if (c(rt)) {
                if (it) {
                  if (rt.length === it) for (_ = 0; _ < ht; _++) tt[_] = this.autoIncrement(), st[_] = T[_];else for (_ = 0; _ < ht; _++) q = T[_], tt[_] = q[0], st[_] = q.slice(1, it + 1);
                } else if ($ && (ot = $.indexOf("x"), at = $.indexOf("y"), ot = 0 <= ot ? ot : 0, at = 0 <= at ? at : 1), rt.length === 1 && (at = 0), ot === at) for (_ = 0; _ < ht; _++) tt[_] = this.autoIncrement(), st[_] = T[_][at];else for (_ = 0; _ < ht; _++) q = T[_], tt[_] = q[ot], st[_] = q[at];
              } else r(12, !1, et);
            } else for (_ = 0; _ < ht; _++) typeof T[_] < "u" && (q = {
              series: Y
            }, Y.pointClass.prototype.applyOptions.apply(q, [T[_]]), Y.updateParallelArrays(q, _));
            for (st && b(st[0]) && r(14, !0, et), Y.data = [], Y.options.data = Y.userOptions.data = T, _ = Z; _--;) U[_] && U[_].destroy && U[_].destroy();
            lt && (lt.minRange = lt.userMinRange), Y.isDirty = et.isDirtyBox = !0, Y.isDirtyData = !!U, _ = !1;
          }
          J.legendType === "point" && (this.processData(), this.generatePoints()), G && et.redraw(_);
        }, F.prototype.sortData = function (T) {
          var G = this,
            _ = G.options.dataSorting.sortKey || "y",
            q = function q(Y, U) {
              return o(U) && Y.pointClass.prototype.optionsToObject.call({
                series: Y
              }, U) || {};
            };
          return T.forEach(function (Y, U) {
            T[U] = q(G, Y), T[U].index = U;
          }, this), T.concat().sort(function (Y, U) {
            return Y = a(_, Y), U = a(_, U), U < Y ? -1 : U > Y ? 1 : 0;
          }).forEach(function (Y, U) {
            Y.x = U;
          }, this), G.linkedSeries && G.linkedSeries.forEach(function (Y) {
            var U = Y.options,
              Z = U.data;
            U.dataSorting && U.dataSorting.enabled || !Z || (Z.forEach(function (J, et) {
              Z[et] = q(Y, J), T[et] && (Z[et].x = T[et].x, Z[et].index = et);
            }), Y.setData(Z, !1));
          }), T;
        }, F.prototype.getProcessedData = function (T) {
          var G = this.xAxis,
            _ = this.options,
            q = _.cropThreshold,
            Y = T || this.getExtremesFromAll || _.getExtremesFromAll,
            U = this.isCartesian;
          T = G && G.val2lin, _ = !(!G || !G.logarithmic);
          var Z = 0,
            J = this.xData,
            et = this.yData,
            nt = this.requireSorting,
            lt = !1,
            ct = J.length;
          if (G) {
            lt = G.getExtremes();
            var tt = lt.min,
              st = lt.max;
            lt = !(!G.categories || G.names.length);
          }
          if (U && this.sorted && !Y && (!q || ct > q || this.forceCrop)) {
            if (J[ct - 1] < tt || J[0] > st) J = [], et = [];else if (this.yData && (J[0] < tt || J[ct - 1] > st)) {
              var it = this.cropData(this.xData, this.yData, tt, st);
              J = it.xData, et = it.yData, Z = it.start, it = !0;
            }
          }
          for (q = J.length || 1; --q;) if (G = _ ? T(J[q]) - T(J[q - 1]) : J[q] - J[q - 1], 0 < G && (typeof $ > "u" || G < $)) var $ = G;else 0 > G && nt && !lt && (r(15, !1, this.chart), nt = !1);
          return {
            xData: J,
            yData: et,
            cropped: it,
            cropStart: Z,
            closestPointRange: $
          };
        }, F.prototype.processData = function (T) {
          var G = this.xAxis;
          if (this.isCartesian && !this.isDirty && !G.isDirty && !this.yAxis.isDirty && !T) return !1;
          T = this.getProcessedData(), this.cropped = T.cropped, this.cropStart = T.cropStart, this.processedXData = T.xData, this.processedYData = T.yData, this.closestPointRange = this.basePointRange = T.closestPointRange, e(this, "afterProcessData");
        }, F.prototype.cropData = function (T, G, _, q, Y) {
          var U = T.length,
            Z,
            J = 0,
            et = U;
          for (Y = f(Y, this.cropShoulder), Z = 0; Z < U; Z++) if (T[Z] >= _) {
            J = Math.max(0, Z - Y);
            break;
          }
          for (_ = Z; _ < U; _++) if (T[_] > q) {
            et = _ + Y;
            break;
          }
          return {
            xData: T.slice(J, et),
            yData: G.slice(J, et),
            start: J,
            end: et
          };
        }, F.prototype.generatePoints = function () {
          var T = this.options,
            G = this.processedData || T.data,
            _ = this.processedXData,
            q = this.processedYData,
            Y = this.pointClass,
            U = _.length,
            Z = this.cropStart || 0,
            J = this.hasGroupedData,
            et = T.keys,
            nt = [];
          T = T.dataGrouping && T.dataGrouping.groupAll ? Z : 0;
          var lt,
            ct,
            tt = this.data;
          if (!tt && !J) {
            var st = [];
            st.length = G.length, tt = this.data = st;
          }
          for (et && J && (this.options.keys = !1), ct = 0; ct < U; ct++) {
            if (st = Z + ct, J) {
              var it = new Y().init(this, [_[ct]].concat(N(q[ct])));
              it.dataGroup = this.groupMap[T + ct], it.dataGroup.options && (it.options = it.dataGroup.options, i(it, it.dataGroup.options), delete it.dataLabels);
            } else (it = tt[st]) || typeof G[st] > "u" || (tt[st] = it = new Y().init(this, G[st], _[ct]));
            it && (it.index = J ? T + ct : st, nt[ct] = it);
          }
          if (this.options.keys = et, tt && (U !== (lt = tt.length) || J)) for (ct = 0; ct < lt; ct++) ct !== Z || J || (ct += U), tt[ct] && (tt[ct].destroyElements(), tt[ct].plotX = void 0);
          this.data = tt, this.points = nt, e(this, "afterGeneratePoints");
        }, F.prototype.getXExtremes = function (T) {
          return {
            min: L(T),
            max: I(T)
          };
        }, F.prototype.getExtremes = function (T, G) {
          var _ = this.xAxis,
            q = this.yAxis,
            Y = this.processedXData || this.xData,
            U = [],
            Z = this.requireSorting ? this.cropShoulder : 0;
          q = q ? q.positiveValuesOnly : !1;
          var J,
            et = 0,
            nt = 0,
            lt = 0;
          T = T || this.stackedYData || this.processedYData || [];
          var ct = T.length;
          if (_) {
            var tt = _.getExtremes();
            et = tt.min, nt = tt.max;
          }
          for (J = 0; J < ct; J++) {
            var st = Y[J];
            tt = T[J];
            var it = (y(tt) || c(tt)) && (tt.length || 0 < tt || !q);
            if (st = G || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !_ || (Y[J + Z] || st) >= et && (Y[J - Z] || st) <= nt, it && st) if (it = tt.length) for (; it--;) y(tt[it]) && (U[lt++] = tt[it]);else U[lt++] = tt;
          }
          return T = {
            activeYData: U,
            dataMin: L(U),
            dataMax: I(U)
          }, e(this, "afterGetExtremes", {
            dataExtremes: T
          }), T;
        }, F.prototype.applyExtremes = function () {
          var T = this.getExtremes();
          return this.dataMin = T.dataMin, this.dataMax = T.dataMax, T;
        }, F.prototype.getFirstValidPoint = function (T) {
          for (var G = T.length, _ = 0, q = null; q === null && _ < G;) q = T[_], _++;
          return q;
        }, F.prototype.translate = function () {
          this.processedXData || this.processData(), this.generatePoints();
          var T = this.options,
            G = T.stacking,
            _ = this.xAxis,
            q = _.categories,
            Y = this.enabledDataSorting,
            U = this.yAxis,
            Z = this.points,
            J = Z.length,
            et = this.pointPlacementToXValue(),
            nt = !!et,
            lt = T.threshold,
            ct = T.startFromThreshold ? lt : 0,
            tt = this.zoneAxis || "y",
            st,
            it,
            $ = Number.MAX_VALUE;
          for (st = 0; st < J; st++) {
            var Q = Z[st],
              ot = Q.x,
              at = void 0,
              rt = void 0,
              ht = Q.y,
              pt = Q.low,
              dt = G && U.stacking && U.stacking.stacks[(this.negStacks && ht < (ct ? 0 : lt) ? "-" : "") + this.stackKey];
            if ((U.positiveValuesOnly && !U.validatePositiveValue(ht) || _.positiveValuesOnly && !_.validatePositiveValue(ot)) && (Q.isNull = !0), Q.plotX = it = d(C(_.translate(ot, 0, 0, 0, 1, et, this.type === "flags"), -1e5, 1e5)), G && this.visible && dt && dt[ot]) {
              var gt = this.getStackIndicator(gt, ot, this.index);
              !Q.isNull && gt.key && (at = dt[ot], rt = at.points[gt.key]), at && c(rt) && (pt = rt[0], ht = rt[1], pt === ct && gt.key === dt[ot].base && (pt = f(y(lt) ? lt : U.min)), U.positiveValuesOnly && o(pt) && 0 >= pt && (pt = void 0), Q.total = Q.stackTotal = f(at.total), Q.percentage = o(Q.y) && at.total ? Q.y / at.total * 100 : void 0, Q.stackY = ht, this.irregularWidths || at.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis));
            }
            if (Q.yBottom = o(pt) ? C(U.translate(pt, 0, 1, 0, 1), -1e5, 1e5) : void 0, this.dataModify && (ht = this.dataModify.modifyValue(ht, st)), Q.plotY = void 0, y(ht) && (at = U.translate(ht, !1, !0, !1, !0), typeof at < "u" && (Q.plotY = C(at, -1e5, 1e5))), Q.isInside = this.isPointInside(Q), Q.clientX = nt ? d(_.translate(ot, 0, 0, 0, 1, et)) : it, Q.negative = Q[tt] < (T[tt + "Threshold"] || lt || 0), Q.category = f(q && q[Q.x], Q.x), !Q.isNull && Q.visible !== !1) {
              typeof ut < "u" && ($ = Math.min($, Math.abs(it - ut)));
              var ut = it;
            }
            Q.zone = this.zones.length ? Q.getZone() : void 0, !Q.graphic && this.group && Y && (Q.isNew = !0);
          }
          this.closestPointRangePx = $, e(this, "afterTranslate");
        }, F.prototype.getValidPoints = function (T, G, _) {
          var q = this.chart;
          return (T || this.points || []).filter(function (Y) {
            return G && !q.isInsidePlot(Y.plotX, Y.plotY, {
              inverted: q.inverted
            }) ? !1 : Y.visible !== !1 && (_ || !Y.isNull);
          });
        }, F.prototype.getClipBox = function () {
          var T = this.chart,
            G = this.xAxis,
            _ = this.yAxis,
            q = j(T.clipBox);
          return G && G.len !== T.plotSizeX && (q.width = G.len), _ && _.len !== T.plotSizeY && (q.height = _.len), q;
        }, F.prototype.getSharedClipKey = function () {
          return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0);
        }, F.prototype.setClip = function () {
          var T = this.chart,
            G = this.group,
            _ = this.markerGroup,
            q = T.sharedClips;
          T = T.renderer;
          var Y = this.getClipBox(),
            U = this.getSharedClipKey(),
            Z = q[U];
          Z ? Z.animate(Y) : q[U] = Z = T.clipRect(Y), G && G.clip(this.options.clip === !1 ? void 0 : Z), _ && _.clip();
        }, F.prototype.animate = function (T) {
          var G = this.chart,
            _ = this.group,
            q = this.markerGroup,
            Y = G.inverted,
            U = g(this.options.animation),
            Z = [this.getSharedClipKey(), U.duration, U.easing, U.defer].join(),
            J = G.sharedClips[Z],
            et = G.sharedClips[Z + "m"];
          if (T && _) U = this.getClipBox(), J ? J.attr("height", U.height) : (U.width = 0, Y && (U.x = G.plotHeight), J = G.renderer.clipRect(U), G.sharedClips[Z] = J, et = G.renderer.clipRect({
            x: -99,
            y: -99,
            width: Y ? G.plotWidth + 199 : 99,
            height: Y ? 99 : G.plotHeight + 199
          }), G.sharedClips[Z + "m"] = et), _.clip(J), q && q.clip(et);else if (J && !J.hasClass("highcharts-animating")) {
            G = this.getClipBox();
            var nt = U.step;
            q && q.element.childNodes.length && (U.step = function (lt, ct) {
              nt && nt.apply(ct, arguments), ct.prop === "width" && et && et.element && et.attr(Y ? "height" : "width", lt + 99);
            }), J.addClass("highcharts-animating").animate(G, U);
          }
        }, F.prototype.afterAnimate = function () {
          var T = this;
          this.setClip(), P(this.chart.sharedClips, function (G, _, q) {
            G && !T.chart.container.querySelector('[clip-path="url(#'.concat(G.id, ')"]')) && (G.destroy(), delete q[_]);
          }), this.finishedAnimating = !0, e(this, "afterAnimate");
        }, F.prototype.drawPoints = function (T) {
          T === void 0 && (T = this.points);
          var G = this.chart,
            _ = G.styledMode,
            q = this.colorAxis,
            Y = this.options.marker,
            U = this[this.specialGroup || "markerGroup"],
            Z = this.xAxis,
            J = f(Y.enabled, !Z || Z.isRadial ? !0 : null, this.closestPointRangePx >= Y.enabledThreshold * Y.radius),
            et,
            nt;
          if (Y.enabled !== !1 || this._hasPointMarkers) for (et = 0; et < T.length; et++) {
            var lt = T[et],
              ct = (nt = lt.graphic) ? "animate" : "attr",
              tt = lt.marker || {},
              st = !!lt.marker;
            if ((J && typeof tt.enabled > "u" || tt.enabled) && !lt.isNull && lt.visible !== !1) {
              var it = f(tt.symbol, this.symbol, "rect"),
                $ = this.markerAttribs(lt, lt.selected && "select");
              this.enabledDataSorting && (lt.startXPos = Z.reversed ? -($.width || 0) : Z.width);
              var Q = lt.isInside !== !1;
              !nt && Q && (0 < ($.width || 0) || lt.hasImage) && (lt.graphic = nt = G.renderer.symbol(it, $.x, $.y, $.width, $.height, st ? tt : Y).add(U), this.enabledDataSorting && G.hasRendered && (nt.attr({
                x: lt.startXPos
              }), ct = "animate")), nt && ct === "animate" && nt[Q ? "show" : "hide"](Q).animate($), nt && (tt = this.pointAttribs(lt, _ || !lt.selected ? void 0 : "select"), _ ? q && nt.css({
                fill: tt.fill
              }) : nt[ct](tt)), nt && nt.addClass(lt.getClassName(), !0);
            } else nt && (lt.graphic = nt.destroy());
          }
        }, F.prototype.markerAttribs = function (T, G) {
          var _ = this.options,
            q = _.marker,
            Y = T.marker || {},
            U = Y.symbol || q.symbol,
            Z = {},
            J = f(Y.radius, q && q.radius);
          return G && (q = q.states[G], G = Y.states && Y.states[G], J = f(G && G.radius, q && q.radius, J && J + (q && q.radiusPlus || 0))), T.hasImage = U && U.indexOf("url") === 0, T.hasImage && (J = 0), T = T.pos(), y(J) && T && (Z.x = T[0] - J, Z.y = T[1] - J, _.crisp && (Z.x = Math.floor(Z.x))), J && (Z.width = Z.height = 2 * J), Z;
        }, F.prototype.pointAttribs = function (T, G) {
          var _ = this.options.marker,
            q = T && T.options,
            Y = q && q.marker || {},
            U = q && q.color,
            Z = T && T.color,
            J = T && T.zone && T.zone.color,
            et = this.color;
          return T = f(Y.lineWidth, _.lineWidth), q = 1, et = U || J || Z || et, U = Y.fillColor || _.fillColor || et, Z = Y.lineColor || _.lineColor || et, G = G || "normal", _ = _.states[G] || {}, G = Y.states && Y.states[G] || {}, T = f(G.lineWidth, _.lineWidth, T + f(G.lineWidthPlus, _.lineWidthPlus, 0)), U = G.fillColor || _.fillColor || U, Z = G.lineColor || _.lineColor || Z, q = f(G.opacity, _.opacity, q), {
            stroke: Z,
            "stroke-width": T,
            fill: U,
            opacity: q
          };
        }, F.prototype.destroy = function (T) {
          var G = this,
            _ = G.chart,
            q = /AppleWebKit\/533/.test(v.navigator.userAgent),
            Y = G.data || [],
            U,
            Z,
            J,
            et;
          for (e(G, "destroy", {
            keepEventsForUpdate: T
          }), this.removeEvents(T), (G.axisTypes || []).forEach(function (nt) {
            (et = G[nt]) && et.series && (n(et.series, G), et.isDirty = et.forceRedraw = !0);
          }), G.legendItem && G.chart.legend.destroyItem(G), Z = Y.length; Z--;) (J = Y[Z]) && J.destroy && J.destroy();
          G.clips && G.clips.forEach(function (nt) {
            return nt.destroy();
          }), k.clearTimeout(G.animationTimeout), P(G, function (nt, lt) {
            nt instanceof A && !nt.survive && (U = q && lt === "group" ? "hide" : "destroy", nt[U]());
          }), _.hoverSeries === G && (_.hoverSeries = void 0), n(_.series, G), _.orderSeries(), P(G, function (nt, lt) {
            T && lt === "hcEvents" || delete G[lt];
          });
        }, F.prototype.applyZones = function () {
          var T = this,
            G = this.chart,
            _ = G.renderer,
            q = this.zones,
            Y = this.clips || [],
            U = this.graph,
            Z = this.area,
            J = Math.max(G.plotWidth, G.plotHeight),
            et = this[(this.zoneAxis || "y") + "Axis"],
            nt = G.inverted,
            lt,
            ct,
            tt,
            st,
            it,
            $,
            Q,
            ot,
            at = !1;
          if (q.length && (U || Z) && et && typeof et.min < "u") {
            var rt = et.reversed,
              ht = et.horiz;
            U && !this.showLine && U.hide(), Z && Z.hide();
            var pt = et.getExtremes();
            q.forEach(function (dt, gt) {
              lt = rt ? ht ? G.plotWidth : 0 : ht ? 0 : et.toPixels(pt.min) || 0, lt = C(f(ct, lt), 0, J), ct = C(Math.round(et.toPixels(f(dt.value, pt.max), !0) || 0), 0, J), at && (lt = ct = et.toPixels(pt.max)), st = Math.abs(lt - ct), it = Math.min(lt, ct), $ = Math.max(lt, ct), et.isXAxis ? (tt = {
                x: nt ? $ : it,
                y: 0,
                width: st,
                height: J
              }, ht || (tt.x = G.plotHeight - tt.x)) : (tt = {
                x: 0,
                y: nt ? $ : it,
                width: J,
                height: st
              }, ht && (tt.y = G.plotWidth - tt.y)), nt && _.isVML && (tt = et.isXAxis ? {
                x: 0,
                y: rt ? it : $,
                height: tt.width,
                width: G.chartWidth
              } : {
                x: tt.y - G.plotLeft - G.spacingBox.x,
                y: 0,
                width: tt.height,
                height: G.chartHeight
              }), Y[gt] ? Y[gt].animate(tt) : Y[gt] = _.clipRect(tt), Q = T["zone-area-" + gt], ot = T["zone-graph-" + gt], U && ot && ot.clip(Y[gt]), Z && Q && Q.clip(Y[gt]), at = dt.value > pt.max, T.resetZones && ct === 0 && (ct = void 0);
            }), this.clips = Y;
          } else T.visible && (U && U.show(), Z && Z.show());
        }, F.prototype.plotGroup = function (T, G, _, q, Y) {
          var U = this[T],
            Z = !U;
          return _ = {
            visibility: _,
            zIndex: q || 0.1
          }, typeof this.opacity > "u" || this.chart.styledMode || this.state === "inactive" || (_.opacity = this.opacity), Z && (this[T] = U = this.chart.renderer.g().add(Y)), U.addClass("highcharts-" + G + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (o(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (U.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), U.attr(_)[Z ? "attr" : "animate"](this.getPlotBox(G)), U;
        }, F.prototype.getPlotBox = function (T) {
          var G = this.xAxis,
            _ = this.yAxis,
            q = this.chart;
          return T = q.inverted && !q.polar && G && this.invertible !== !1 && T === "series", q.inverted && (G = _, _ = this.xAxis), {
            translateX: G ? G.left : q.plotLeft,
            translateY: _ ? _.top : q.plotTop,
            rotation: T ? 90 : 0,
            rotationOriginX: T ? (G.len - _.len) / 2 : 0,
            rotationOriginY: T ? (G.len + _.len) / 2 : 0,
            scaleX: T ? -1 : 1,
            scaleY: 1
          };
        }, F.prototype.removeEvents = function (T) {
          T || x(this), this.eventsToUnbind.length && (this.eventsToUnbind.forEach(function (G) {
            G();
          }), this.eventsToUnbind.length = 0);
        }, F.prototype.render = function () {
          var T = this,
            G = T.chart,
            _ = T.options,
            q = g(_.animation),
            Y = T.visible ? "inherit" : "hidden",
            U = _.zIndex,
            Z = T.hasRendered,
            J = G.seriesGroup;
          G = !T.finishedAnimating && G.renderer.isSVG ? q.duration : 0, e(this, "render"), T.plotGroup("group", "series", Y, U, J), T.markerGroup = T.plotGroup("markerGroup", "markers", Y, U, J), _.clip !== !1 && T.setClip(), T.animate && G && T.animate(!0), T.drawGraph && (T.drawGraph(), T.applyZones()), T.visible && T.drawPoints(), T.drawDataLabels && T.drawDataLabels(), T.redrawPoints && T.redrawPoints(), T.drawTracker && T.options.enableMouseTracking !== !1 && T.drawTracker(), T.animate && G && T.animate(), Z || (G && q.defer && (G += q.defer), T.animationTimeout = R(function () {
            T.afterAnimate();
          }, G || 0)), T.isDirty = !1, T.hasRendered = !0, e(T, "afterRender");
        }, F.prototype.redraw = function () {
          var T = this.isDirty || this.isDirtyData;
          this.translate(), this.render(), T && delete this.kdTree;
        }, F.prototype.searchPoint = function (T, G) {
          var _ = this.xAxis,
            q = this.yAxis,
            Y = this.chart.inverted;
          return this.searchKDTree({
            clientX: Y ? _.len - T.chartY + _.pos : T.chartX - _.pos,
            plotY: Y ? q.len - T.chartX + q.pos : T.chartY - q.pos
          }, G, T);
        }, F.prototype.buildKDTree = function (T) {
          function G(Y, U, Z) {
            var J = Y && Y.length;
            if (J) {
              var et = _.kdAxisArray[U % Z];
              return Y.sort(function (nt, lt) {
                return nt[et] - lt[et];
              }), J = Math.floor(J / 2), {
                point: Y[J],
                left: G(Y.slice(0, J), U + 1, Z),
                right: G(Y.slice(J + 1), U + 1, Z)
              };
            }
          }
          this.buildingKdTree = !0;
          var _ = this,
            q = -1 < _.options.findNearestPointBy.indexOf("y") ? 2 : 1;
          delete _.kdTree, R(function () {
            _.kdTree = G(_.getValidPoints(null, !_.directTouch), q, q), _.buildingKdTree = !1;
          }, _.options.kdNow || T && T.type === "touchstart" ? 0 : 1);
        }, F.prototype.searchKDTree = function (T, G, _) {
          function q(et, nt, lt, ct) {
            var tt = nt.point,
              st = Y.kdAxisArray[lt % ct],
              it = tt,
              $ = o(et[U]) && o(tt[U]) ? Math.pow(et[U] - tt[U], 2) : null,
              Q = o(et[Z]) && o(tt[Z]) ? Math.pow(et[Z] - tt[Z], 2) : null;
            return Q = ($ || 0) + (Q || 0), tt.dist = o(Q) ? Math.sqrt(Q) : Number.MAX_VALUE, tt.distX = o($) ? Math.sqrt($) : Number.MAX_VALUE, st = et[st] - tt[st], Q = 0 > st ? "left" : "right", $ = 0 > st ? "right" : "left", nt[Q] && (Q = q(et, nt[Q], lt + 1, ct), it = Q[J] < it[J] ? Q : tt), nt[$] && Math.sqrt(st * st) < it[J] && (et = q(et, nt[$], lt + 1, ct), it = et[J] < it[J] ? et : it), it;
          }
          var Y = this,
            U = this.kdAxisArray[0],
            Z = this.kdAxisArray[1],
            J = G ? "distX" : "dist";
          if (G = -1 < Y.options.findNearestPointBy.indexOf("y") ? 2 : 1, this.kdTree || this.buildingKdTree || this.buildKDTree(_), this.kdTree) return q(T, this.kdTree, G, G);
        }, F.prototype.pointPlacementToXValue = function () {
          var T = this.options,
            G = T.pointRange,
            _ = this.xAxis;
          return T = T.pointPlacement, T === "between" && (T = _.reversed ? -0.5 : 0.5), y(T) ? T * (G || _.pointRange) : 0;
        }, F.prototype.isPointInside = function (T) {
          var G = this.chart,
            _ = this.xAxis,
            q = this.yAxis;
          return typeof T.plotY < "u" && typeof T.plotX < "u" && 0 <= T.plotY && T.plotY <= (q ? q.len : G.plotHeight) && 0 <= T.plotX && T.plotX <= (_ ? _.len : G.plotWidth);
        }, F.prototype.drawTracker = function () {
          var T = this,
            G = T.options,
            _ = G.trackByArea,
            q = [].concat(_ ? T.areaPath : T.graphPath),
            Y = T.chart,
            U = Y.pointer,
            Z = Y.renderer,
            J = Y.options.tooltip.snap,
            et = T.tracker,
            nt = function nt(ct) {
              Y.hoverSeries !== T && T.onMouseOver();
            },
            lt = "rgba(192,192,192," + (u ? 1e-4 : 2e-3) + ")";
          et ? et.attr({
            d: q
          }) : T.graph && (T.tracker = Z.path(q).attr({
            visibility: T.visible ? "inherit" : "hidden",
            zIndex: 2
          }).addClass(_ ? "highcharts-tracker-area" : "highcharts-tracker-line").add(T.group), Y.styledMode || T.tracker.attr({
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            stroke: lt,
            fill: _ ? lt : "none",
            "stroke-width": T.graph.strokeWidth() + (_ ? 0 : 2 * J)
          }), [T.tracker, T.markerGroup, T.dataLabelsGroup].forEach(function (ct) {
            ct && (ct.addClass("highcharts-tracker").on("mouseover", nt).on("mouseout", function (tt) {
              U.onTrackerMouseOut(tt);
            }), G.cursor && !Y.styledMode && ct.css({
              cursor: G.cursor
            }), l) && ct.on("touchstart", nt);
          })), e(this, "afterDrawTracker");
        }, F.prototype.addPoint = function (T, G, _, q, Y) {
          var U = this.options,
            Z = this.data,
            J = this.chart,
            et = this.xAxis;
          et = et && et.hasNames && et.names;
          var nt = U.data,
            lt = this.xData,
            ct;
          G = f(G, !0);
          var tt = {
            series: this
          };
          this.pointClass.prototype.applyOptions.apply(tt, [T]);
          var st = tt.x,
            it = lt.length;
          if (this.requireSorting && st < lt[it - 1]) for (ct = !0; it && lt[it - 1] > st;) it--;
          this.updateParallelArrays(tt, "splice", it, 0, 0), this.updateParallelArrays(tt, it), et && tt.name && (et[st] = tt.name), nt.splice(it, 0, T), (ct || this.processedData) && (this.data.splice(it, 0, null), this.processData()), U.legendType === "point" && this.generatePoints(), _ && (Z[0] && Z[0].remove ? Z[0].remove(!1) : (Z.shift(), this.updateParallelArrays(tt, "shift"), nt.shift())), Y !== !1 && e(this, "addPoint", {
            point: tt
          }), this.isDirtyData = this.isDirty = !0, G && J.redraw(q);
        }, F.prototype.removePoint = function (T, G, _) {
          var q = this,
            Y = q.data,
            U = Y[T],
            Z = q.points,
            J = q.chart,
            et = function et() {
              Z && Z.length === Y.length && Z.splice(T, 1), Y.splice(T, 1), q.options.data.splice(T, 1), q.updateParallelArrays(U || {
                series: q
              }, "splice", T, 1), U && U.destroy(), q.isDirty = !0, q.isDirtyData = !0, G && J.redraw();
            };
          p(_, J), G = f(G, !0), U ? U.firePointEvent("remove", null, et) : et();
        }, F.prototype.remove = function (T, G, _, q) {
          function Y() {
            U.destroy(q), Z.isDirtyLegend = Z.isDirtyBox = !0, Z.linkSeries(), f(T, !0) && Z.redraw(G);
          }
          var U = this,
            Z = U.chart;
          _ !== !1 ? e(U, "remove", null, Y) : Y();
        }, F.prototype.update = function (T, G) {
          T = m(T, this.userOptions), e(this, "update", {
            options: T
          });
          var _ = this,
            q = _.chart,
            Y = _.userOptions,
            U = _.initialType || _.type,
            Z = q.options.plotOptions,
            J = M[U].prototype,
            et = _.finishedAnimating && {
              animation: !1
            },
            nt = {},
            lt = ["eventOptions", "navigatorSeries", "baseSeries"],
            ct = T.type || Y.type || q.options.chart.type,
            tt = !(this.hasDerivedData || ct && ct !== this.type || typeof T.pointStart < "u" || typeof T.pointInterval < "u" || typeof T.relativeXValue < "u" || T.joinBy || T.mapData || _.hasOptionChanged("dataGrouping") || _.hasOptionChanged("pointStart") || _.hasOptionChanged("pointInterval") || _.hasOptionChanged("pointIntervalUnit") || _.hasOptionChanged("keys"));
          if (ct = ct || U, tt && (lt.push("data", "isDirtyData", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "_hasPointLabels", "clips", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX"), T.visible !== !1 && lt.push("area", "graph"), _.parallelArrays.forEach(function (it) {
            lt.push(it + "Data");
          }), T.data && (T.dataSorting && i(_.options.dataSorting, T.dataSorting), this.setData(T.data, !1))), T = j(Y, et, {
            index: typeof Y.index > "u" ? _.index : Y.index,
            pointStart: f(Z && Z.series && Z.series.pointStart, Y.pointStart, _.xData[0])
          }, !tt && {
            data: _.options.data
          }, T), tt && T.data && (T.data = _.options.data), lt = ["group", "markerGroup", "dataLabelsGroup", "transformGroup", "shadowGroup"].concat(lt), lt.forEach(function (it) {
            lt[it] = _[it], delete _[it];
          }), Z = !1, M[ct]) {
            if (Z = ct !== _.type, _.remove(!1, !1, !1, !0), Z) if (Object.setPrototypeOf) Object.setPrototypeOf(_, M[ct].prototype);else {
              et = Object.hasOwnProperty.call(_, "hcEvents") && _.hcEvents;
              for (st in J) _[st] = void 0;
              i(_, M[ct].prototype), et ? _.hcEvents = et : delete _.hcEvents;
            }
          } else r(17, !0, q, {
            missingModuleFor: ct
          });
          if (lt.forEach(function (it) {
            _[it] = lt[it];
          }), _.init(q, T), tt && this.points) {
            if (T = _.options, T.visible === !1) nt.graphic = 1, nt.dataLabel = 1;else if (!_._hasPointLabels) {
              J = T.marker;
              var st = T.dataLabels;
              Y = Y.marker || {}, !J || J.enabled !== !1 && Y.symbol === J.symbol && Y.height === J.height && Y.width === J.width || (nt.graphic = 1), st && st.enabled === !1 && (nt.dataLabel = 1);
            }
            for (Y = 0, J = this.points; Y < J.length; Y++) (st = J[Y]) && st.series && (st.resolveColor(), Object.keys(nt).length && st.destroyElements(nt), T.showInLegend === !1 && st.legendItem && q.legend.destroyItem(st));
          }
          _.initialType = U, q.linkSeries(), Z && _.linkedSeries.length && (_.isDirtyData = !0), e(this, "afterUpdate"), f(G, !0) && q.redraw(tt ? void 0 : !1);
        }, F.prototype.setName = function (T) {
          this.name = this.options.name = this.userOptions.name = T, this.chart.isDirtyLegend = !0;
        }, F.prototype.hasOptionChanged = function (T) {
          var G = this.options[T],
            _ = this.chart.options.plotOptions,
            q = this.userOptions[T];
          return q ? G !== q : G !== f(_ && _[this.type] && _[this.type][T], _ && _.series && _.series[T], G);
        }, F.prototype.onMouseOver = function () {
          var T = this.chart,
            G = T.hoverSeries;
          T.pointer.setHoverChartIndex(), G && G !== this && G.onMouseOut(), this.options.events.mouseOver && e(this, "mouseOver"), this.setState("hover"), T.hoverSeries = this;
        }, F.prototype.onMouseOut = function () {
          var T = this.options,
            G = this.chart,
            _ = G.tooltip,
            q = G.hoverPoint;
          G.hoverSeries = null, q && q.onMouseOut(), this && T.events.mouseOut && e(this, "mouseOut"), !_ || this.stickyTracking || _.shared && !this.noSharedTooltip || _.hide(), G.series.forEach(function (Y) {
            Y.setState("", !0);
          });
        }, F.prototype.setState = function (T, G) {
          var _ = this,
            q = _.options,
            Y = _.graph,
            U = q.inactiveOtherPoints,
            Z = q.states,
            J = f(Z[T || "normal"] && Z[T || "normal"].animation, _.chart.options.chart.animation),
            et = q.lineWidth,
            nt = 0,
            lt = q.opacity;
          if (T = T || "", _.state !== T && ([_.group, _.markerGroup, _.dataLabelsGroup].forEach(function (ct) {
            ct && (_.state && ct.removeClass("highcharts-series-" + _.state), T && ct.addClass("highcharts-series-" + T));
          }), _.state = T, !_.chart.styledMode)) {
            if (Z[T] && Z[T].enabled === !1) return;
            if (T && (et = Z[T].lineWidth || et + (Z[T].lineWidthPlus || 0), lt = f(Z[T].opacity, lt)), Y && !Y.dashstyle && y(et)) for (q = {
              "stroke-width": et
            }, Y.animate(q, J); _["zone-graph-" + nt];) _["zone-graph-" + nt].animate(q, J), nt += 1;
            U || [_.group, _.markerGroup, _.dataLabelsGroup, _.labelBySeries].forEach(function (ct) {
              ct && ct.animate({
                opacity: lt
              }, J);
            });
          }
          G && U && _.points && _.setAllPointsToState(T || void 0);
        }, F.prototype.setAllPointsToState = function (T) {
          this.points.forEach(function (G) {
            G.setState && G.setState(T);
          });
        }, F.prototype.setVisible = function (T, G) {
          var _ = this,
            q = _.chart,
            Y = q.options.chart.ignoreHiddenSeries,
            U = _.visible,
            Z = (_.visible = T = _.options.visible = _.userOptions.visible = typeof T > "u" ? !U : T) ? "show" : "hide";
          ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach(function (J) {
            _[J] && _[J][Z]();
          }), (q.hoverSeries === _ || (q.hoverPoint && q.hoverPoint.series) === _) && _.onMouseOut(), _.legendItem && q.legend.colorizeItem(_, T), _.isDirty = !0, _.options.stacking && q.series.forEach(function (J) {
            J.options.stacking && J.visible && (J.isDirty = !0);
          }), _.linkedSeries.forEach(function (J) {
            J.setVisible(T, !1);
          }), Y && (q.isDirtyBox = !0), e(_, Z), G !== !1 && q.redraw();
        }, F.prototype.show = function () {
          this.setVisible(!0);
        }, F.prototype.hide = function () {
          this.setVisible(!1);
        }, F.prototype.select = function (T) {
          this.selected = T = this.options.selected = typeof T > "u" ? !this.selected : T, this.checkbox && (this.checkbox.checked = T), e(this, T ? "select" : "unselect");
        }, F.prototype.shouldShowTooltip = function (T, G, _) {
          return _ === void 0 && (_ = {}), _.series = this, _.visiblePlotOnly = !0, this.chart.isInsidePlot(T, G, _);
        }, F.defaultOptions = z, F.types = w.seriesTypes, F.registerType = w.registerSeriesType, F;
      }(), i(D.prototype, {
        axisTypes: ["xAxis", "yAxis"],
        coll: "series",
        colorCounter: 0,
        cropShoulder: 1,
        directTouch: !1,
        drawLegendSymbol: X.drawLineMarker,
        isCartesian: !0,
        kdAxisArray: ["clientX", "plotY"],
        parallelArrays: ["x", "y"],
        pointClass: W,
        requireSorting: !0,
        sorted: !0
      }), w.series = D, D;
    }), V(S, "Extensions/ScrollablePlotArea.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/Axis/Axis.js"], S["Core/Chart/Chart.js"], S["Core/Series/Series.js"], S["Core/Renderer/RendererRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W) {
      var z = D.stop,
        w = W.addEvent,
        A = W.createElement,
        k = W.defined,
        g = W.merge,
        p = W.pick;
      w(B, "afterSetChartSize", function (h) {
        var s = this.options.chart.scrollablePlotArea,
          l = s && s.minWidth;
        if (s = s && s.minHeight, !this.renderer.forExport) {
          if (l) {
            if (this.scrollablePixelsX = l = Math.max(0, l - this.chartWidth)) {
              this.scrollablePlotBox = this.renderer.scrollablePlotBox = g(this.plotBox), this.plotBox.width = this.plotWidth += l, this.inverted ? this.clipBox.height += l : this.clipBox.width += l;
              var u = {
                1: {
                  name: "right",
                  value: l
                }
              };
            }
          } else s && (this.scrollablePixelsY = l = Math.max(0, s - this.chartHeight), k(l) && (this.scrollablePlotBox = this.renderer.scrollablePlotBox = g(this.plotBox), this.plotBox.height = this.plotHeight += l, this.inverted ? this.clipBox.width += l : this.clipBox.height += l, u = {
            2: {
              name: "bottom",
              value: l
            }
          }));
          u && !h.skipAxes && this.axes.forEach(function (v) {
            u[v.side] ? v.getPlotLinePath = function () {
              var M = u[v.side].name,
                I = this[M];
              this[M] = I - u[v.side].value;
              var L = E.prototype.getPlotLinePath.apply(this, arguments);
              return this[M] = I, L;
            } : (v.setAxisSize(), v.setAxisTranslation());
          });
        }
      }), w(B, "render", function () {
        this.scrollablePixelsX || this.scrollablePixelsY ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
      }), B.prototype.setUpScrolling = function () {
        var h = this,
          s = {
            WebkitOverflowScrolling: "touch",
            overflowX: "hidden",
            overflowY: "hidden"
          };
        this.scrollablePixelsX && (s.overflowX = "auto"), this.scrollablePixelsY && (s.overflowY = "auto"), this.scrollingParent = A("div", {
          className: "highcharts-scrolling-parent"
        }, {
          position: "relative"
        }, this.renderTo), this.scrollingContainer = A("div", {
          className: "highcharts-scrolling"
        }, s, this.scrollingParent);
        var l;
        w(this.scrollingContainer, "scroll", function () {
          h.pointer && (delete h.pointer.chartPosition, h.hoverPoint && (l = h.hoverPoint), h.pointer.runPointActions(void 0, l, !0));
        }), this.innerContainer = A("div", {
          className: "highcharts-inner-container"
        }, null, this.scrollingContainer), this.innerContainer.appendChild(this.container), this.setUpScrolling = null;
      }, B.prototype.moveFixedElements = function () {
        var h = this.container,
          s = this.fixedRenderer,
          l = ".highcharts-breadcrumbs-group .highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-drillup-button .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "),
          u;
        this.scrollablePixelsX && !this.inverted ? u = ".highcharts-yaxis" : this.scrollablePixelsX && this.inverted || this.scrollablePixelsY && !this.inverted ? u = ".highcharts-xaxis" : this.scrollablePixelsY && this.inverted && (u = ".highcharts-yaxis"), u && l.push("" + u + ":not(.highcharts-radial-axis)", "" + u + "-labels:not(.highcharts-radial-axis-labels)"), l.forEach(function (v) {
          [].forEach.call(h.querySelectorAll(v), function (M) {
            (M.namespaceURI === s.SVG_NS ? s.box : s.box.parentNode).appendChild(M), M.style.pointerEvents = "auto";
          });
        });
      }, B.prototype.applyFixed = function () {
        var h = !this.fixedDiv,
          s = this.options.chart,
          l = s.scrollablePlotArea,
          u = X.getRendererType();
        h ? (this.fixedDiv = A("div", {
          className: "highcharts-fixed"
        }, {
          position: "absolute",
          overflow: "hidden",
          pointerEvents: "none",
          zIndex: (s.style && s.style.zIndex || 0) + 2,
          top: 0
        }, null, !0), this.scrollingContainer && this.scrollingContainer.parentNode.insertBefore(this.fixedDiv, this.scrollingContainer), this.renderTo.style.overflow = "visible", this.fixedRenderer = s = new u(this.fixedDiv, this.chartWidth, this.chartHeight, this.options.chart.style), this.scrollableMask = s.path().attr({
          fill: this.options.chart.backgroundColor || "#fff",
          "fill-opacity": p(l.opacity, 0.85),
          zIndex: -1
        }).addClass("highcharts-scrollable-mask").add(), w(this, "afterShowResetZoom", this.moveFixedElements), w(this, "afterApplyDrilldown", this.moveFixedElements), w(this, "afterLayOutTitles", this.moveFixedElements)) : this.fixedRenderer.setSize(this.chartWidth, this.chartHeight), (this.scrollableDirty || h) && (this.scrollableDirty = !1, this.moveFixedElements()), s = this.chartWidth + (this.scrollablePixelsX || 0), u = this.chartHeight + (this.scrollablePixelsY || 0), z(this.container), this.container.style.width = s + "px", this.container.style.height = u + "px", this.renderer.boxWrapper.attr({
          width: s,
          height: u,
          viewBox: [0, 0, s, u].join(" ")
        }), this.chartBackground.attr({
          width: s,
          height: u
        }), this.scrollingContainer.style.height = this.chartHeight + "px", h && (l.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixelsX * l.scrollPositionX), l.scrollPositionY && (this.scrollingContainer.scrollTop = this.scrollablePixelsY * l.scrollPositionY)), u = this.axisOffset, h = this.plotTop - u[0] - 1, l = this.plotLeft - u[3] - 1, s = this.plotTop + this.plotHeight + u[2] + 1, u = this.plotLeft + this.plotWidth + u[1] + 1;
        var v = this.plotLeft + this.plotWidth - (this.scrollablePixelsX || 0),
          M = this.plotTop + this.plotHeight - (this.scrollablePixelsY || 0);
        h = this.scrollablePixelsX ? [["M", 0, h], ["L", this.plotLeft - 1, h], ["L", this.plotLeft - 1, s], ["L", 0, s], ["Z"], ["M", v, h], ["L", this.chartWidth, h], ["L", this.chartWidth, s], ["L", v, s], ["Z"]] : this.scrollablePixelsY ? [["M", l, 0], ["L", l, this.plotTop - 1], ["L", u, this.plotTop - 1], ["L", u, 0], ["Z"], ["M", l, M], ["L", l, this.chartHeight], ["L", u, this.chartHeight], ["L", u, M], ["Z"]] : [["M", 0, 0]], this.redrawTrigger !== "adjustHeight" && this.scrollableMask.attr({
          d: h
        });
      }, w(E, "afterInit", function () {
        this.chart.scrollableDirty = !0;
      }), w(H, "show", function () {
        this.chart.scrollableDirty = !0;
      });
    }), V(S, "Core/Axis/Stacking/StackItem.js", [S["Core/FormatUtilities.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = D.format,
        X = E.series,
        W = B.destroyObjectProperties,
        z = B.pick,
        w = B.isNumber;
      return D = function () {
        function A(k, g, p, h, s) {
          var l = k.chart.inverted,
            u = k.reversed;
          this.axis = k, k = this.isNegative = !!p != !!u, this.options = g = g || {}, this.x = h, this.cumulative = this.total = null, this.points = {}, this.hasValidPoints = !1, this.stack = s, this.rightCliff = this.leftCliff = 0, this.alignOptions = {
            align: g.align || (l ? k ? "left" : "right" : "center"),
            verticalAlign: g.verticalAlign || (l ? "middle" : k ? "bottom" : "top"),
            y: g.y,
            x: g.x
          }, this.textAlign = g.textAlign || (l ? k ? "right" : "left" : "center");
        }
        return A.prototype.destroy = function () {
          W(this, this.axis);
        }, A.prototype.render = function (k) {
          var g = this.axis.chart,
            p = this.options,
            h = p.format;
          h = h ? H(h, this, g) : p.formatter.call(this), this.label ? this.label.attr({
            text: h,
            visibility: "hidden"
          }) : (this.label = g.renderer.label(h, null, void 0, p.shape, void 0, void 0, p.useHTML, !1, "stack-labels"), h = {
            r: p.borderRadius || 0,
            text: h,
            padding: z(p.padding, 5),
            visibility: "hidden"
          }, g.styledMode || (h.fill = p.backgroundColor, h.stroke = p.borderColor, h["stroke-width"] = p.borderWidth, this.label.css(p.style || {})), this.label.attr(h), this.label.added || this.label.add(k)), this.label.labelrank = g.plotSizeY;
        }, A.prototype.setOffset = function (k, g, p, h, s, l) {
          var u = this.alignOptions,
            v = this.axis,
            M = this.label,
            I = this.options,
            L = this.textAlign,
            C = v.chart;
          k = this.getStackBox({
            xOffset: k,
            width: g,
            boxBottom: p,
            boxTop: h,
            defaultX: s,
            xAxis: l
          }), s = u.verticalAlign, M && k && (g = M.getBBox(), p = M.padding, h = z(I.overflow, "justify") === "justify", u.x = I.x || 0, u.y = I.y || 0, s = this.adjustStackPosition({
            labelBox: g,
            verticalAlign: s,
            textAlign: L
          }), L = s.x, s = s.y, k.x -= L, k.y -= s, M.align(u, !1, k), (L = C.isInsidePlot(M.alignAttr.x + u.x + L, M.alignAttr.y + u.y + s)) || (h = !1), h && X.prototype.justifyDataLabel.call(v, M, u, M.alignAttr, g, k), M.attr({
            x: M.alignAttr.x,
            y: M.alignAttr.y,
            rotation: I.rotation,
            rotationOriginX: g.width / 2,
            rotationOriginY: g.height / 2
          }), z(!h && I.crop, !0) && (L = w(M.x) && w(M.y) && C.isInsidePlot(M.x - p + M.width, M.y) && C.isInsidePlot(M.x + p, M.y)), M[L ? "show" : "hide"]());
        }, A.prototype.adjustStackPosition = function (k) {
          var g = k.labelBox,
            p = {
              bottom: 0,
              middle: 1,
              top: 2,
              right: 1,
              center: 0,
              left: -1
            };
          return {
            x: g.width / 2 + g.width / 2 * p[k.textAlign],
            y: g.height / 2 * p[k.verticalAlign]
          };
        }, A.prototype.getStackBox = function (k) {
          var g = this.axis,
            p = g.chart,
            h = k.boxTop,
            s = k.defaultX,
            l = k.xOffset,
            u = k.width,
            v = k.boxBottom;
          return h = g.stacking.usePercentage ? 100 : z(h, this.total, 0), h = g.toPixels(h), k = z(s, (k.xAxis || p.xAxis[0]).toPixels(this.x)) + l, g = g.toPixels(v || 0), g = Math.abs(h - g), v = this.isNegative, p.inverted ? {
            x: (v ? h : h - g) - p.plotLeft,
            y: k - p.plotTop,
            width: g,
            height: u
          } : {
            x: k - p.plotLeft,
            y: (v ? h - g : h) - p.plotTop,
            width: u,
            height: g
          };
        }, A;
      }(), D;
    }), V(S, "Core/Axis/Stacking/StackingAxis.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/Axis/Axis.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Axis/Stacking/StackItem.js"], S["Core/Utilities.js"]], function (D, E, B, H, X) {
      function W() {
        var i = this,
          t = i.inverted;
        i.yAxis.forEach(function (e) {
          e.stacking && e.stacking.stacks && e.hasVisibleSeries && (e.stacking.oldStacks = e.stacking.stacks);
        }), i.series.forEach(function (e) {
          var a = e.xAxis && e.xAxis.options || {};
          !e.options.stacking || e.visible !== !0 && i.options.chart.ignoreHiddenSeries !== !1 || (e.stackKey = [e.type, o(e.options.stack, ""), t ? a.top : a.left, t ? a.height : a.width].join());
        });
      }
      function z() {
        var i = this.stacking;
        if (i) {
          var t = i.stacks;
          d(t, function (e, a) {
            I(e), t[a] = null;
          }), i && i.stackTotalGroup && i.stackTotalGroup.destroy();
        }
      }
      function w() {
        this.coll !== "yAxis" || this.stacking || (this.stacking = new n(this));
      }
      function A(i, t, e, a) {
        return !M(i) || i.x !== t || a && i.stackKey !== a ? i = {
          x: t,
          index: 0,
          key: a,
          stackKey: a
        } : i.index++, i.key = [e, t, i.index].join(), i;
      }
      function k() {
        var i = this,
          t = i.stackKey,
          e = i.yAxis.stacking.stacks,
          a = i.processedXData,
          c = i[i.options.stacking + "Stacker"],
          y;
        c && [t, "-" + t].forEach(function (b) {
          for (var j = a.length, P, f; j--;) P = a[j], y = i.getStackIndicator(y, P, i.index, b), (f = (P = e[b] && e[b][P]) && P.points[y.key]) && c.call(i, f, P, j);
        });
      }
      function g(i, t, e) {
        t = t.total ? 100 / t.total : 0, i[0] = v(i[0] * t), i[1] = v(i[1] * t), this.stackedYData[e] = i[1];
      }
      function p() {
        var i = this.yAxis.stacking;
        this.options.centerInCategory && (this.is("column") || this.is("columnrange")) && !this.options.stacking && 1 < this.chart.series.length ? l.setStackedPoints.call(this, "group") : i && d(i.stacks, function (t, e) {
          e.slice(-5) === "group" && (d(t, function (a) {
            return a.destroy();
          }), delete i.stacks[e]);
        });
      }
      function h(i) {
        var t = this.chart,
          e = i || this.options.stacking;
        if (e && (this.visible === !0 || t.options.chart.ignoreHiddenSeries === !1)) {
          var a = this.processedXData,
            c = this.processedYData,
            y = [],
            b = c.length,
            j = this.options,
            P = j.threshold,
            f = o(j.startFromThreshold && P, 0);
          j = j.stack, i = i ? "" + this.type + ",".concat(e) : this.stackKey;
          var x = "-" + i,
            N = this.negStacks;
          t = e === "group" ? t.yAxis[0] : this.yAxis;
          var R = t.stacking.stacks,
            F = t.stacking.oldStacks,
            T,
            G;
          for (t.stacking.stacksTouched += 1, G = 0; G < b; G++) {
            var _ = a[G],
              q = c[G],
              Y = this.getStackIndicator(Y, _, this.index),
              U = Y.key,
              Z = (T = N && q < (f ? 0 : P)) ? x : i;
            R[Z] || (R[Z] = {}), R[Z][_] || (F[Z] && F[Z][_] ? (R[Z][_] = F[Z][_], R[Z][_].total = null) : R[Z][_] = new H(t, t.options.stackLabels, !!T, _, j)), Z = R[Z][_], q !== null ? (Z.points[U] = Z.points[this.index] = [o(Z.cumulative, f)], M(Z.cumulative) || (Z.base = U), Z.touched = t.stacking.stacksTouched, 0 < Y.index && this.singleStacks === !1 && (Z.points[U][0] = Z.points[this.index + "," + _ + ",0"][0])) : Z.points[U] = Z.points[this.index] = null, e === "percent" ? (T = T ? i : x, N && R[T] && R[T][_] ? (T = R[T][_], Z.total = T.total = Math.max(T.total, Z.total) + Math.abs(q) || 0) : Z.total = v(Z.total + (Math.abs(q) || 0))) : e === "group" ? (C(q) && (q = q[0]), q !== null && (Z.total = (Z.total || 0) + 1)) : Z.total = v(Z.total + (q || 0)), Z.cumulative = e === "group" ? (Z.total || 1) - 1 : o(Z.cumulative, f) + (q || 0), q !== null && (Z.points[U].push(Z.cumulative), y[G] = Z.cumulative, Z.hasValidPoints = !0);
          }
          e === "percent" && (t.stacking.usePercentage = !0), e !== "group" && (this.stackedYData = y), t.stacking.oldStacks = {};
        }
      }
      var s = D.getDeferredAnimation,
        l = B.series.prototype,
        u = X.addEvent,
        v = X.correctFloat,
        M = X.defined,
        I = X.destroyObjectProperties,
        L = X.fireEvent,
        C = X.isArray,
        m = X.isNumber,
        d = X.objectEach,
        o = X.pick,
        n = function () {
          function i(t) {
            this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = t;
          }
          return i.prototype.buildStacks = function () {
            var t = this.axis,
              e = t.series,
              a = t.options.reversedStacks,
              c = e.length,
              y;
            for (this.usePercentage = !1, y = c; y--;) {
              var b = e[a ? y : c - y - 1];
              b.setStackedPoints(), b.setGroupedPoints();
            }
            for (y = 0; y < c; y++) e[y].modifyStacks();
            L(t, "afterBuildStacks");
          }, i.prototype.cleanStacks = function () {
            if (this.oldStacks) var t = this.stacks = this.oldStacks;
            d(t, function (e) {
              d(e, function (a) {
                a.cumulative = a.total;
              });
            });
          }, i.prototype.resetStacks = function () {
            var t = this;
            d(this.stacks, function (e) {
              d(e, function (a, c) {
                m(a.touched) && a.touched < t.stacksTouched ? (a.destroy(), delete e[c]) : (a.total = null, a.cumulative = null);
              });
            });
          }, i.prototype.renderStackTotals = function () {
            var t = this.axis,
              e = t.chart,
              a = e.renderer,
              c = this.stacks;
            t = s(e, t.options.stackLabels && t.options.stackLabels.animation || !1);
            var y = this.stackTotalGroup = this.stackTotalGroup || a.g("stack-labels").attr({
              zIndex: 6,
              opacity: 0
            }).add();
            y.translate(e.plotLeft, e.plotTop), d(c, function (b) {
              d(b, function (j) {
                j.render(y);
              });
            }), y.animate({
              opacity: 1
            }, t);
          }, i;
        }(),
        r;
      return function (i) {
        var t = [];
        i.compose = function (e, a, c) {
          t.indexOf(e) === -1 && (t.push(e), u(e, "init", w), u(e, "destroy", z)), t.indexOf(a) === -1 && (t.push(a), a.prototype.getStacks = W), t.indexOf(c) === -1 && (t.push(c), e = c.prototype, e.getStackIndicator = A, e.modifyStacks = k, e.percentStacker = g, e.setGroupedPoints = p, e.setStackedPoints = h);
        };
      }(r || (r = {})), r;
    }), V(S, "Series/Line/LineSeries.js", [S["Core/Series/Series.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = this && this.__extends || function () {
          var _z2 = function z(w, A) {
            return _z2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (k, g) {
              k.__proto__ = g;
            } || function (k, g) {
              for (var p in g) g.hasOwnProperty(p) && (k[p] = g[p]);
            }, _z2(w, A);
          };
          return function (w, A) {
            function k() {
              this.constructor = w;
            }
            _z2(w, A), w.prototype = A === null ? Object.create(A) : (k.prototype = A.prototype, new k());
          };
        }(),
        X = B.defined,
        W = B.merge;
      return B = function (z) {
        function w() {
          var A = z !== null && z.apply(this, arguments) || this;
          return A.data = void 0, A.options = void 0, A.points = void 0, A;
        }
        return H(w, z), w.prototype.drawGraph = function () {
          var A = this,
            k = this.options,
            g = (this.gappedPath || this.getGraphPath).call(this),
            p = this.chart.styledMode,
            h = [["graph", "highcharts-graph"]];
          p || h[0].push(k.lineColor || this.color || "#cccccc", k.dashStyle), h = A.getZonesGraphs(h), h.forEach(function (s, l) {
            var u = s[0],
              v = A[u],
              M = v ? "animate" : "attr";
            v ? (v.endX = A.preventGraphAnimation ? null : g.xMap, v.animate({
              d: g
            })) : g.length && (A[u] = v = A.chart.renderer.path(g).addClass(s[1]).attr({
              zIndex: 1
            }).add(A.group)), v && !p && (u = {
              stroke: s[2],
              "stroke-width": k.lineWidth || 0,
              fill: A.fillGraph && A.color || "none"
            }, s[3] ? u.dashstyle = s[3] : k.linecap !== "square" && (u["stroke-linecap"] = u["stroke-linejoin"] = "round"), v[M](u).shadow(2 > l && k.shadow)), v && (v.startX = g.xMap, v.isArea = g.isArea);
          });
        }, w.prototype.getGraphPath = function (A, k, g) {
          var p = this,
            h = p.options,
            s = [],
            l = [],
            u,
            v = h.step;
          A = A || p.points;
          var M = A.reversed;
          return M && A.reverse(), (v = {
            right: 1,
            center: 2
          }[v] || v && 3) && M && (v = 4 - v), A = this.getValidPoints(A, !1, !(h.connectNulls && !k && !g)), A.forEach(function (I, L) {
            var C = I.plotX,
              m = I.plotY,
              d = A[L - 1];
            (I.leftCliff || d && d.rightCliff) && !g && (u = !0), I.isNull && !X(k) && 0 < L ? u = !h.connectNulls : I.isNull && !k ? u = !0 : (L === 0 || u ? L = [["M", I.plotX, I.plotY]] : p.getPointSpline ? L = [p.getPointSpline(A, I, L)] : v ? (L = v === 1 ? [["L", d.plotX, m]] : v === 2 ? [["L", (d.plotX + C) / 2, d.plotY], ["L", (d.plotX + C) / 2, m]] : [["L", C, d.plotY]], L.push(["L", C, m])) : L = [["L", C, m]], l.push(I.x), v && (l.push(I.x), v === 2 && l.push(I.x)), s.push.apply(s, L), u = !1);
          }), s.xMap = l, p.graphPath = s;
        }, w.prototype.getZonesGraphs = function (A) {
          return this.zones.forEach(function (k, g) {
            g = ["zone-graph-" + g, "highcharts-graph highcharts-zone-graph-" + g + " " + (k.className || "")], this.chart.styledMode || g.push(k.color || this.color, k.dashStyle || this.options.dashStyle), A.push(g);
          }, this), A;
        }, w.defaultOptions = W(D.defaultOptions, {}), w;
      }(D), E.registerSeriesType("line", B), B;
    }), V(S, "Series/Area/AreaSeries.js", [S["Core/Color/Color.js"], S["Core/Legend/LegendSymbol.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = this && this.__extends || function () {
          var _g2 = function g(p, h) {
            return _g2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (s, l) {
              s.__proto__ = l;
            } || function (s, l) {
              for (var u in l) l.hasOwnProperty(u) && (s[u] = l[u]);
            }, _g2(p, h);
          };
          return function (p, h) {
            function s() {
              this.constructor = p;
            }
            _g2(p, h), p.prototype = h === null ? Object.create(h) : (s.prototype = h.prototype, new s());
          };
        }(),
        W = D.parse,
        z = B.seriesTypes.line;
      D = H.extend;
      var w = H.merge,
        A = H.objectEach,
        k = H.pick;
      return H = function (g) {
        function p() {
          var h = g !== null && g.apply(this, arguments) || this;
          return h.data = void 0, h.options = void 0, h.points = void 0, h;
        }
        return X(p, g), p.prototype.drawGraph = function () {
          this.areaPath = [], g.prototype.drawGraph.apply(this);
          var h = this,
            s = this.areaPath,
            l = this.options,
            u = [["area", "highcharts-area", this.color, l.fillColor]];
          this.zones.forEach(function (v, M) {
            u.push(["zone-area-" + M, "highcharts-area highcharts-zone-area-" + M + " " + v.className, v.color || h.color, v.fillColor || l.fillColor]);
          }), u.forEach(function (v) {
            var M = v[0],
              I = {},
              L = h[M],
              C = L ? "animate" : "attr";
            L ? (L.endX = h.preventGraphAnimation ? null : s.xMap, L.animate({
              d: s
            })) : (I.zIndex = 0, L = h[M] = h.chart.renderer.path(s).addClass(v[1]).add(h.group), L.isArea = !0), h.chart.styledMode || (I.fill = k(v[3], W(v[2]).setOpacity(k(l.fillOpacity, 0.75)).get())), L[C](I), L.startX = s.xMap, L.shiftUnit = l.step ? 2 : 1;
          });
        }, p.prototype.getGraphPath = function (h) {
          var s = z.prototype.getGraphPath,
            l = this.options,
            u = l.stacking,
            v = this.yAxis,
            M = [],
            I = [],
            L = this.index,
            C = v.stacking.stacks[this.stackKey],
            m = l.threshold,
            d = Math.round(v.getThreshold(l.threshold));
          l = k(l.connectNulls, u === "percent");
          var o = function o(a, c, y) {
            var b = h[a];
            a = u && C[b.x].points[L];
            var j = b[y + "Null"] || 0;
            if (y = b[y + "Cliff"] || 0, b = !0, y || j) {
              var P = (j ? a[0] : a[1]) + y,
                f = a[0] + y;
              b = !!j;
            } else !u && h[c] && h[c].isNull && (P = f = m);
            typeof P < "u" && (I.push({
              plotX: t,
              plotY: P === null ? d : v.getThreshold(P),
              isNull: b,
              isCliff: !0
            }), M.push({
              plotX: t,
              plotY: f === null ? d : v.getThreshold(f),
              doCurve: !1
            }));
          };
          h = h || this.points, u && (h = this.getStackPoints(h));
          for (var n = 0, r = h.length; n < r; ++n) {
            u || (h[n].leftCliff = h[n].rightCliff = h[n].leftNull = h[n].rightNull = void 0);
            var i = h[n].isNull,
              t = k(h[n].rectPlotX, h[n].plotX),
              e = u ? k(h[n].yBottom, d) : d;
            (!i || l) && (l || o(n, n - 1, "left"), i && !u && l || (I.push(h[n]), M.push({
              x: n,
              plotX: t,
              plotY: e
            })), l || o(n, n + 1, "right"));
          }
          return o = s.call(this, I, !0, !0), M.reversed = !0, i = s.call(this, M, !0, !0), (e = i[0]) && e[0] === "M" && (i[0] = ["L", e[1], e[2]]), i = o.concat(i), i.length && i.push(["Z"]), s = s.call(this, I, !1, l), i.xMap = o.xMap, this.areaPath = i, s;
        }, p.prototype.getStackPoints = function (h) {
          var s = this,
            l = [],
            u = [],
            v = this.xAxis,
            M = this.yAxis,
            I = M.stacking.stacks[this.stackKey],
            L = {},
            C = M.series,
            m = C.length,
            d = M.options.reversedStacks ? 1 : -1,
            o = C.indexOf(s);
          if (h = h || this.points, this.options.stacking) {
            for (var n = 0; n < h.length; n++) h[n].leftNull = h[n].rightNull = void 0, L[h[n].x] = h[n];
            A(I, function (i, t) {
              i.total !== null && u.push(t);
            }), u.sort(function (i, t) {
              return i - t;
            });
            var r = C.map(function (i) {
              return i.visible;
            });
            u.forEach(function (i, t) {
              var e = 0,
                a,
                c;
              if (L[i] && !L[i].isNull) l.push(L[i]), [-1, 1].forEach(function (b) {
                var j = b === 1 ? "rightNull" : "leftNull",
                  P = I[u[t + b]],
                  f = 0;
                if (P) for (var x = o; 0 <= x && x < m;) {
                  var N = C[x].index;
                  a = P.points[N], a || (N === s.index ? L[i][j] = !0 : r[x] && (c = I[i].points[N]) && (f -= c[1] - c[0])), x += d;
                }
                L[i][b === 1 ? "rightCliff" : "leftCliff"] = f;
              });else {
                for (var y = o; 0 <= y && y < m;) {
                  if (a = I[i].points[C[y].index]) {
                    e = a[1];
                    break;
                  }
                  y += d;
                }
                e = k(e, 0), e = M.translate(e, 0, 1, 0, 1), l.push({
                  isNull: !0,
                  plotX: v.translate(i, 0, 0, 0, 1),
                  x: i,
                  plotY: e,
                  yBottom: e
                });
              }
            });
          }
          return l;
        }, p.defaultOptions = w(z.defaultOptions, {
          threshold: 0
        }), p;
      }(z), D(H.prototype, {
        singleStacks: !1,
        drawLegendSymbol: E.drawRectangle
      }), B.registerSeriesType("area", H), H;
    }), V(S, "Series/Spline/SplineSeries.js", [S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E) {
      var B = this && this.__extends || function () {
          var _z3 = function z(w, A) {
            return _z3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (k, g) {
              k.__proto__ = g;
            } || function (k, g) {
              for (var p in g) g.hasOwnProperty(p) && (k[p] = g[p]);
            }, _z3(w, A);
          };
          return function (w, A) {
            function k() {
              this.constructor = w;
            }
            _z3(w, A), w.prototype = A === null ? Object.create(A) : (k.prototype = A.prototype, new k());
          };
        }(),
        H = D.seriesTypes.line,
        X = E.merge,
        W = E.pick;
      return E = function (z) {
        function w() {
          var A = z !== null && z.apply(this, arguments) || this;
          return A.data = void 0, A.options = void 0, A.points = void 0, A;
        }
        return B(w, z), w.prototype.getPointSpline = function (A, k, g) {
          var p = k.plotX || 0,
            h = k.plotY || 0,
            s = A[g - 1];
          if (g = A[g + 1], s && !s.isNull && s.doCurve !== !1 && !k.isCliff && g && !g.isNull && g.doCurve !== !1 && !k.isCliff) {
            A = s.plotY || 0;
            var l = g.plotX || 0;
            g = g.plotY || 0;
            var u = 0,
              v = (1.5 * p + (s.plotX || 0)) / 2.5,
              M = (1.5 * h + A) / 2.5;
            l = (1.5 * p + l) / 2.5;
            var I = (1.5 * h + g) / 2.5;
            l !== v && (u = (I - M) * (l - p) / (l - v) + h - I), M += u, I += u, M > A && M > h ? (M = Math.max(A, h), I = 2 * h - M) : M < A && M < h && (M = Math.min(A, h), I = 2 * h - M), I > g && I > h ? (I = Math.max(g, h), M = 2 * h - I) : I < g && I < h && (I = Math.min(g, h), M = 2 * h - I), k.rightContX = l, k.rightContY = I;
          }
          return k = ["C", W(s.rightContX, s.plotX, 0), W(s.rightContY, s.plotY, 0), W(v, p, 0), W(M, h, 0), p, h], s.rightContX = s.rightContY = void 0, k;
        }, w.defaultOptions = X(H.defaultOptions), w;
      }(H), D.registerSeriesType("spline", E), E;
    }), V(S, "Series/AreaSpline/AreaSplineSeries.js", [S["Series/Spline/SplineSeries.js"], S["Core/Legend/LegendSymbol.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = this && this.__extends || function () {
          var _k5 = function k(g, p) {
            return _k5 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k5(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k5(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        W = B.seriesTypes,
        z = W.area;
      W = W.area.prototype;
      var w = H.extend,
        A = H.merge;
      return H = function (k) {
        function g() {
          var p = k !== null && k.apply(this, arguments) || this;
          return p.data = void 0, p.points = void 0, p.options = void 0, p;
        }
        return X(g, k), g.defaultOptions = A(D.defaultOptions, z.defaultOptions), g;
      }(D), w(H.prototype, {
        getGraphPath: W.getGraphPath,
        getStackPoints: W.getStackPoints,
        drawGraph: W.drawGraph,
        drawLegendSymbol: E.drawRectangle
      }), B.registerSeriesType("areaspline", H), H;
    }), V(S, "Series/Column/ColumnSeriesDefaults.js", [], function () {
      return {
        borderRadius: 0,
        centerInCategory: !1,
        groupPadding: 0.2,
        marker: null,
        pointPadding: 0.1,
        minPointLength: 0,
        cropThreshold: 50,
        pointRange: null,
        states: {
          hover: {
            halo: !1,
            brightness: 0.1
          },
          select: {
            color: "#cccccc",
            borderColor: "#000000"
          }
        },
        dataLabels: {
          align: void 0,
          verticalAlign: void 0,
          y: void 0
        },
        startFromThreshold: !0,
        stickyTracking: !1,
        tooltip: {
          distance: 6
        },
        threshold: 0,
        borderColor: "#ffffff"
      };
    }), V(S, "Series/Column/ColumnSeries.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/Color/Color.js"], S["Series/Column/ColumnSeriesDefaults.js"], S["Core/Globals.js"], S["Core/Legend/LegendSymbol.js"], S["Core/Series/Series.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z, w) {
      var A = this && this.__extends || function () {
          var _m2 = function m(d, o) {
            return _m2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (n, r) {
              n.__proto__ = r;
            } || function (n, r) {
              for (var i in r) r.hasOwnProperty(i) && (n[i] = r[i]);
            }, _m2(d, o);
          };
          return function (d, o) {
            function n() {
              this.constructor = d;
            }
            _m2(d, o), d.prototype = o === null ? Object.create(o) : (n.prototype = o.prototype, new n());
          };
        }(),
        k = D.animObject,
        g = E.parse,
        p = H.hasTouch;
      D = H.noop;
      var h = w.clamp,
        s = w.defined,
        l = w.extend,
        u = w.fireEvent,
        v = w.isArray,
        M = w.isNumber,
        I = w.merge,
        L = w.pick,
        C = w.objectEach;
      return w = function (m) {
        function d() {
          var o = m !== null && m.apply(this, arguments) || this;
          return o.borderWidth = void 0, o.data = void 0, o.group = void 0, o.options = void 0, o.points = void 0, o;
        }
        return A(d, m), d.prototype.animate = function (o) {
          var n = this,
            r = this.yAxis,
            i = n.options,
            t = this.chart.inverted,
            e = {},
            a = t ? "translateX" : "translateY";
          if (o) e.scaleY = 1e-3, o = h(r.toPixels(i.threshold), r.pos, r.pos + r.len), t ? e.translateX = o - r.len : e.translateY = o, n.clipBox && n.setClip(), n.group.attr(e);else {
            var c = Number(n.group.attr(a));
            n.group.animate({
              scaleY: 1
            }, l(k(n.options.animation), {
              step: function step(y, b) {
                n.group && (e[a] = c + b.pos * (r.pos - c), n.group.attr(e));
              }
            }));
          }
        }, d.prototype.init = function (o, n) {
          m.prototype.init.apply(this, arguments);
          var r = this;
          o = r.chart, o.hasRendered && o.series.forEach(function (i) {
            i.type === r.type && (i.isDirty = !0);
          });
        }, d.prototype.getColumnMetrics = function () {
          var o = this,
            n = o.options,
            r = o.xAxis,
            i = o.yAxis,
            t = r.options.reversedStacks;
          t = r.reversed && !t || !r.reversed && t;
          var e = {},
            a,
            c = 0;
          n.grouping === !1 ? c = 1 : o.chart.series.forEach(function (P) {
            var f = P.yAxis,
              x = P.options;
            if (P.type === o.type && (P.visible || !o.chart.options.chart.ignoreHiddenSeries) && i.len === f.len && i.pos === f.pos) {
              if (x.stacking && x.stacking !== "group") {
                a = P.stackKey, typeof e[a] > "u" && (e[a] = c++);
                var N = e[a];
              } else x.grouping !== !1 && (N = c++);
              P.columnIndex = N;
            }
          });
          var y = Math.min(Math.abs(r.transA) * (r.ordinal && r.ordinal.slope || n.pointRange || r.closestPointRange || r.tickInterval || 1), r.len),
            b = y * n.groupPadding,
            j = (y - 2 * b) / (c || 1);
          return n = Math.min(n.maxPointWidth || r.len, L(n.pointWidth, j * (1 - 2 * n.pointPadding))), o.columnMetrics = {
            width: n,
            offset: (j - n) / 2 + (b + ((o.columnIndex || 0) + (t ? 1 : 0)) * j - y / 2) * (t ? -1 : 1),
            paddedWidth: j,
            columnCount: c
          }, o.columnMetrics;
        }, d.prototype.crispCol = function (o, n, r, i) {
          var t = this.chart,
            e = this.borderWidth,
            a = -(e % 2 ? 0.5 : 0);
          return e = e % 2 ? 0.5 : 1, t.inverted && t.renderer.isVML && (e += 1), this.options.crisp && (r = Math.round(o + r) + a, o = Math.round(o) + a, r -= o), i = Math.round(n + i) + e, a = 0.5 >= Math.abs(n) && 0.5 < i, n = Math.round(n) + e, i -= n, a && i && (--n, i += 1), {
            x: o,
            y: n,
            width: r,
            height: i
          };
        }, d.prototype.adjustForMissingColumns = function (o, n, r, i) {
          var t = this,
            e = this.options.stacking;
          if (!r.isNull && 1 < i.columnCount) {
            var a = this.yAxis.options.reversedStacks,
              c = 0,
              y = a ? 0 : -i.columnCount;
            C(this.yAxis.stacking && this.yAxis.stacking.stacks, function (b) {
              if (typeof r.x == "number") {
                var j = b[r.x.toString()];
                j && (b = j.points[t.index], e ? (b && (c = y), j.hasValidPoints && (a ? y++ : y--)) : v(b) && (b = Object.keys(j.points).filter(function (P) {
                  return !P.match(",") && j.points[P] && 1 < j.points[P].length;
                }).map(parseFloat).sort(function (P, f) {
                  return f - P;
                }), c = b.indexOf(t.index), y = b.length));
              }
            }), o = (r.plotX || 0) + ((y - 1) * i.paddedWidth + n) / 2 - n - c * i.paddedWidth;
          }
          return o;
        }, d.prototype.translate = function () {
          var o = this,
            n = o.chart,
            r = o.options,
            i = o.dense = 2 > o.closestPointRange * o.xAxis.transA;
          i = o.borderWidth = L(r.borderWidth, i ? 0 : 1);
          var t = o.xAxis,
            e = o.yAxis,
            a = r.threshold,
            c = o.translatedThreshold = e.getThreshold(a),
            y = L(r.minPointLength, 5),
            b = o.getColumnMetrics(),
            j = b.width,
            P = o.pointXOffset = b.offset,
            f = o.dataMin,
            x = o.dataMax,
            N = o.barW = Math.max(j, 1 + 2 * i);
          n.inverted && (c -= 0.5), r.pointPadding && (N = Math.ceil(N)), W.prototype.translate.apply(o), o.points.forEach(function (R) {
            var F = L(R.yBottom, c),
              T = 999 + Math.abs(F),
              G = R.plotX || 0;
            T = h(R.plotY, -T, e.len + T);
            var _ = Math.min(T, F),
              q = Math.max(T, F) - _,
              Y = j,
              U = G + P,
              Z = N;
            y && Math.abs(q) < y && (q = y, G = !e.reversed && !R.negative || e.reversed && R.negative, M(a) && M(x) && R.y === a && x <= a && (e.min || 0) < a && (f !== x || (e.max || 0) <= a) && (G = !G), _ = Math.abs(_ - c) > y ? F - y : c - (G ? y : 0)), s(R.options.pointWidth) && (Y = Z = Math.ceil(R.options.pointWidth), U -= Math.round((Y - j) / 2)), r.centerInCategory && (U = o.adjustForMissingColumns(U, Y, R, b)), R.barX = U, R.pointWidth = Y, R.tooltipPos = n.inverted ? [h(e.len + e.pos - n.plotLeft - T, e.pos - n.plotLeft, e.len + e.pos - n.plotLeft), t.len + t.pos - n.plotTop - U - Z / 2, q] : [t.left - n.plotLeft + U + Z / 2, h(T + e.pos - n.plotTop, e.pos - n.plotTop, e.len + e.pos - n.plotTop), q], R.shapeType = o.pointClass.prototype.shapeType || "rect", R.shapeArgs = o.crispCol.apply(o, R.isNull ? [U, c, Z, 0] : [U, _, Z, q]);
          });
        }, d.prototype.drawGraph = function () {
          this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
        }, d.prototype.pointAttribs = function (o, n) {
          var r = this.options,
            i = this.pointAttrToOptions || {},
            t = i.stroke || "borderColor",
            e = i["stroke-width"] || "borderWidth",
            a = o && o.color || this.color,
            c = o && o[t] || r[t] || a;
          i = o && o.options.dashStyle || r.dashStyle;
          var y = o && o[e] || r[e] || this[e] || 0,
            b = L(o && o.opacity, r.opacity, 1);
          if (o && this.zones.length) {
            var j = o.getZone();
            a = o.options.color || j && (j.color || o.nonZonedColor) || this.color, j && (c = j.borderColor || c, i = j.dashStyle || i, y = j.borderWidth || y);
          }
          return n && o && (o = I(r.states[n], o.options.states && o.options.states[n] || {}), n = o.brightness, a = o.color || typeof n < "u" && g(a).brighten(o.brightness).get() || a, c = o[t] || c, y = o[e] || y, i = o.dashStyle || i, b = L(o.opacity, b)), t = {
            fill: a,
            stroke: c,
            "stroke-width": y,
            opacity: b
          }, i && (t.dashstyle = i), t;
        }, d.prototype.drawPoints = function (o) {
          o === void 0 && (o = this.points);
          var n = this,
            r = this.chart,
            i = n.options,
            t = r.renderer,
            e = i.animationLimit || 250,
            a;
          o.forEach(function (c) {
            var y = c.graphic,
              b = !!y,
              j = y && r.pointCount < e ? "animate" : "attr";
            M(c.plotY) && c.y !== null ? (a = c.shapeArgs, y && c.hasNewShapeType() && (y = y.destroy()), n.enabledDataSorting && (c.startXPos = n.xAxis.reversed ? -(a && a.width || 0) : n.xAxis.width), y || (c.graphic = y = t[c.shapeType](a).add(c.group || n.group)) && n.enabledDataSorting && r.hasRendered && r.pointCount < e && (y.attr({
              x: c.startXPos
            }), b = !0, j = "animate"), y && b && y[j](I(a)), i.borderRadius && y[j]({
              r: i.borderRadius
            }), r.styledMode || y[j](n.pointAttribs(c, c.selected && "select")).shadow(c.allowShadow !== !1 && i.shadow, null, i.stacking && !i.borderRadius), y && (y.addClass(c.getClassName(), !0), y.attr({
              visibility: c.visible ? "inherit" : "hidden"
            }))) : y && (c.graphic = y.destroy());
          });
        }, d.prototype.drawTracker = function (o) {
          o === void 0 && (o = this.points);
          var n = this,
            r = n.chart,
            i = r.pointer,
            t = function t(a) {
              var c = i.getPointFromEvent(a);
              typeof c < "u" && (i.isDirectTouch = !0, c.onMouseOver(a));
            },
            e;
          o.forEach(function (a) {
            e = v(a.dataLabels) ? a.dataLabels : a.dataLabel ? [a.dataLabel] : [], a.graphic && (a.graphic.element.point = a), e.forEach(function (c) {
              c.div ? c.div.point = a : c.element.point = a;
            });
          }), n._hasTracking || (n.trackerGroups.forEach(function (a) {
            n[a] && (n[a].addClass("highcharts-tracker").on("mouseover", t).on("mouseout", function (c) {
              i.onTrackerMouseOut(c);
            }), p && n[a].on("touchstart", t), !r.styledMode && n.options.cursor && n[a].css({
              cursor: n.options.cursor
            }));
          }), n._hasTracking = !0), u(this, "afterDrawTracker");
        }, d.prototype.remove = function () {
          var o = this,
            n = o.chart;
          n.hasRendered && n.series.forEach(function (r) {
            r.type === o.type && (r.isDirty = !0);
          }), W.prototype.remove.apply(o, arguments);
        }, d.defaultOptions = I(W.defaultOptions, B), d;
      }(W), l(w.prototype, {
        cropShoulder: 0,
        directTouch: !0,
        drawLegendSymbol: X.drawRectangle,
        getSymbol: D,
        negStacks: !0,
        trackerGroups: ["group", "dataLabelsGroup"]
      }), z.registerSeriesType("column", w), w;
    }), V(S, "Core/Series/DataLabel.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/FormatUtilities.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = D.getDeferredAnimation,
        X = E.format,
        W = B.defined,
        z = B.extend,
        w = B.fireEvent,
        A = B.isArray,
        k = B.isString,
        g = B.merge,
        p = B.objectEach,
        h = B.pick,
        s = B.splat,
        l;
      return function (u) {
        function v(o, n, r, i, t) {
          var e = this,
            a = this.chart,
            c = this.isCartesian && a.inverted,
            y = this.enabledDataSorting,
            b = o.plotX,
            j = o.plotY,
            P = r.rotation,
            f = r.align,
            x = W(b) && W(j) && a.isInsidePlot(b, Math.round(j), {
              inverted: c,
              paneCoordinates: !0,
              series: e
            });
          j = function j(T) {
            y && e.xAxis && !N && e.setDataLabelStartPos(o, n, t, x, T);
          };
          var N = h(r.overflow, y ? "none" : "justify") === "justify";
          if (b = this.visible && o.visible !== !1 && W(b) && (o.series.forceDL || y && !N || x || h(r.inside, !!this.options.stacking) && i && a.isInsidePlot(b, c ? i.x + 1 : i.y + i.height - 1, {
            inverted: c,
            paneCoordinates: !0,
            series: e
          })), c = o.pos(), b && c) {
            P && n.attr({
              align: f
            }), f = n.getBBox(!0);
            var R = [0, 0],
              F = a.renderer.fontMetrics(a.styledMode ? void 0 : r.style.fontSize, n).b;
            i = z({
              x: c[0],
              y: Math.round(c[1]),
              width: 0,
              height: 0
            }, i), z(r, {
              width: f.width,
              height: f.height
            }), P ? (N = !1, R = a.renderer.rotCorr(F, P), F = {
              x: i.x + (r.x || 0) + i.width / 2 + R.x,
              y: i.y + (r.y || 0) + {
                top: 0,
                middle: 0.5,
                bottom: 1
              }[r.verticalAlign] * i.height
            }, R = [f.x - Number(n.attr("x")), f.y - Number(n.attr("y"))], j(F), n[t ? "attr" : "animate"](F)) : (j(i), n.align(r, void 0, i), F = n.alignAttr), N && 0 <= i.height ? this.justifyDataLabel(n, r, F, f, i, t) : h(r.crop, !0) && (i = F.x, j = F.y, i += R[0], j += R[1], b = a.isInsidePlot(i, j, {
              paneCoordinates: !0,
              series: e
            }) && a.isInsidePlot(i + f.width, j + f.height, {
              paneCoordinates: !0,
              series: e
            })), r.shape && !P && n[t ? "attr" : "animate"]({
              anchorX: c[0],
              anchorY: c[1]
            });
          }
          t && y && (n.placed = !1), b || y && !N ? n.show() : (n.hide(), n.placed = !1);
        }
        function M(o, n) {
          var r = n.filter;
          return r ? (n = r.operator, o = o[r.property], r = r.value, n === ">" && o > r || n === "<" && o < r || n === ">=" && o >= r || n === "<=" && o <= r || n === "==" && o == r || n === "===" && o === r) : !0;
        }
        function I(o) {
          o === void 0 && (o = this.points);
          var n = this,
            r = n.chart,
            i = n.options,
            t = n.hasRendered || 0,
            e = r.renderer,
            a = r.options.chart,
            c = a.backgroundColor;
          a = a.plotBackgroundColor;
          var y = e.getContrast(k(a) && a || k(c) && c || "#000000"),
            b = i.dataLabels,
            j;
          if (c = b.animation, c = b.defer ? H(r, c, n) : {
            defer: 0,
            duration: 0
          }, b = C(C(r.options.plotOptions && r.options.plotOptions.series && r.options.plotOptions.series.dataLabels, r.options.plotOptions && r.options.plotOptions[n.type] && r.options.plotOptions[n.type].dataLabels), b), w(this, "drawDataLabels"), A(b) || b.enabled || n._hasPointLabels) {
            var P = n.plotGroup("dataLabelsGroup", "data-labels", t ? "inherit" : "hidden", b.zIndex || 6);
            P.attr({
              opacity: +t
            }), !t && (t = n.dataLabelsGroup) && (n.visible && P.show(), t[i.animation ? "animate" : "attr"]({
              opacity: 1
            }, c)), o.forEach(function (f) {
              j = s(C(b, f.dlOptions || f.options && f.options.dataLabels)), j.forEach(function (x, N) {
                var R = x.enabled && (!f.isNull || f.dataLabelOnNull) && M(f, x),
                  F = f.connectors ? f.connectors[N] : f.connector,
                  T = f.dataLabels ? f.dataLabels[N] : f.dataLabel,
                  G = !T,
                  _ = h(x.distance, f.labelDistance);
                if (R) {
                  var q = f.getLabelConfig(),
                    Y = h(x[f.formatPrefix + "Format"], x.format);
                  q = W(Y) ? X(Y, q, r) : (x[f.formatPrefix + "Formatter"] || x.formatter).call(q, x), Y = x.style;
                  var U = x.rotation;
                  r.styledMode || (Y.color = h(x.color, Y.color, n.color, "#000000"), Y.color === "contrast" ? (f.contrastColor = e.getContrast(f.color || n.color), Y.color = !W(_) && x.inside || 0 > _ || i.stacking ? f.contrastColor : y) : delete f.contrastColor, i.cursor && (Y.cursor = i.cursor));
                  var Z = {
                    r: x.borderRadius || 0,
                    rotation: U,
                    padding: x.padding,
                    zIndex: 1
                  };
                  if (!r.styledMode) {
                    _ = x.backgroundColor;
                    var J = x.borderColor;
                    Z.fill = _ === "auto" ? f.color : _, Z.stroke = J === "auto" ? f.color : J, Z["stroke-width"] = x.borderWidth;
                  }
                  p(Z, function (et, nt) {
                    typeof et > "u" && delete Z[nt];
                  });
                }
                !T || R && W(q) && !!T.div == !!x.useHTML && (T.rotation && x.rotation || T.rotation === x.rotation) || (G = !0, f.dataLabel = T = f.dataLabel && f.dataLabel.destroy(), f.dataLabels && (f.dataLabels.length === 1 ? delete f.dataLabels : delete f.dataLabels[N]), N || delete f.dataLabel, F && (f.connector = f.connector.destroy(), f.connectors && (f.connectors.length === 1 ? delete f.connectors : delete f.connectors[N]))), R && W(q) ? (T ? Z.text = q : (f.dataLabels = f.dataLabels || [], T = f.dataLabels[N] = U ? e.text(q, 0, 0, x.useHTML).addClass("highcharts-data-label") : e.label(q, 0, 0, x.shape, null, null, x.useHTML, null, "data-label"), N || (f.dataLabel = T), T.addClass(" highcharts-data-label-color-" + f.colorIndex + " " + (x.className || "") + (x.useHTML ? " highcharts-tracker" : ""))), T.options = x, T.attr(Z), r.styledMode || T.css(Y).shadow(x.shadow), (N = x[f.formatPrefix + "TextPath"] || x.textPath) && !x.useHTML && (T.setTextPath(f.getDataLabelPath && f.getDataLabelPath(T) || f.graphic, N), f.dataLabelPath && !N.enabled && (f.dataLabelPath = f.dataLabelPath.destroy())), T.added || T.add(P), n.alignDataLabel(f, T, x, null, G)) : T && T.hide();
              });
            });
          }
          w(this, "afterDrawDataLabels");
        }
        function L(o, n, r, i, t, e) {
          var a = this.chart,
            c = n.align,
            y = n.verticalAlign,
            b = o.box ? 0 : o.padding || 0,
            j = n.x;
          j = j === void 0 ? 0 : j;
          var P = n.y;
          P = P === void 0 ? 0 : P;
          var f = (r.x || 0) + b;
          if (0 > f) {
            c === "right" && 0 <= j ? (n.align = "left", n.inside = !0) : j -= f;
            var x = !0;
          }
          return f = (r.x || 0) + i.width - b, f > a.plotWidth && (c === "left" && 0 >= j ? (n.align = "right", n.inside = !0) : j += a.plotWidth - f, x = !0), f = r.y + b, 0 > f && (y === "bottom" && 0 <= P ? (n.verticalAlign = "top", n.inside = !0) : P -= f, x = !0), f = (r.y || 0) + i.height - b, f > a.plotHeight && (y === "top" && 0 >= P ? (n.verticalAlign = "bottom", n.inside = !0) : P += a.plotHeight - f, x = !0), x && (n.x = j, n.y = P, o.placed = !e, o.align(n, void 0, t)), x;
        }
        function C(o, n) {
          var r = [],
            i;
          if (A(o) && !A(n)) r = o.map(function (t) {
            return g(t, n);
          });else if (A(n) && !A(o)) r = n.map(function (t) {
            return g(o, t);
          });else if (A(o) || A(n)) for (i = Math.max(o.length, n.length); i--;) r[i] = g(o[i], n[i]);else r = g(o, n);
          return r;
        }
        function m(o, n, r, i, t) {
          var e = this.chart,
            a = e.inverted,
            c = this.xAxis,
            y = c.reversed,
            b = a ? n.height / 2 : n.width / 2;
          o = (o = o.pointWidth) ? o / 2 : 0, n.startXPos = a ? t.x : y ? -b - o : c.width - b + o, n.startYPos = a ? y ? this.yAxis.height - b + o : -b - o : t.y, i ? n.visibility === "hidden" && (n.show(), n.attr({
            opacity: 0
          }).animate({
            opacity: 1
          })) : n.attr({
            opacity: 1
          }).animate({
            opacity: 0
          }, void 0, n.hide), e.hasRendered && (r && n.attr({
            x: n.startXPos,
            y: n.startYPos
          }), n.placed = !0);
        }
        var d = [];
        u.compose = function (o) {
          if (d.indexOf(o) === -1) {
            var n = o.prototype;
            d.push(o), n.alignDataLabel = v, n.drawDataLabels = I, n.justifyDataLabel = L, n.setDataLabelStartPos = m;
          }
        };
      }(l || (l = {})), l;
    }), V(S, "Series/Column/ColumnDataLabel.js", [S["Core/Series/DataLabel.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = E.series,
        X = B.merge,
        W = B.pick,
        z;
      return function (w) {
        function A(g, p, h, s, l) {
          var u = this.chart.inverted,
            v = g.series,
            M = (v.xAxis ? v.xAxis.len : this.chart.plotSizeX) || 0;
          v = (v.yAxis ? v.yAxis.len : this.chart.plotSizeY) || 0;
          var I = g.dlBox || g.shapeArgs,
            L = W(g.below, g.plotY > W(this.translatedThreshold, v)),
            C = W(h.inside, !!this.options.stacking);
          I && (s = X(I), 0 > s.y && (s.height += s.y, s.y = 0), I = s.y + s.height - v, 0 < I && I < s.height && (s.height -= I), u && (s = {
            x: v - s.y - s.height,
            y: M - s.x - s.width,
            width: s.height,
            height: s.width
          }), C || (u ? (s.x += L ? 0 : s.width, s.width = 0) : (s.y += L ? s.height : 0, s.height = 0))), h.align = W(h.align, !u || C ? "center" : L ? "right" : "left"), h.verticalAlign = W(h.verticalAlign, u || C ? "middle" : L ? "top" : "bottom"), H.prototype.alignDataLabel.call(this, g, p, h, s, l), h.inside && g.contrastColor && p.css({
            color: g.contrastColor
          });
        }
        var k = [];
        w.compose = function (g) {
          D.compose(H), k.indexOf(g) === -1 && (k.push(g), g.prototype.alignDataLabel = A);
        };
      }(z || (z = {})), z;
    }), V(S, "Series/Bar/BarSeries.js", [S["Series/Column/ColumnSeries.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = this && this.__extends || function () {
          var _z4 = function z(w, A) {
            return _z4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (k, g) {
              k.__proto__ = g;
            } || function (k, g) {
              for (var p in g) g.hasOwnProperty(p) && (k[p] = g[p]);
            }, _z4(w, A);
          };
          return function (w, A) {
            function k() {
              this.constructor = w;
            }
            _z4(w, A), w.prototype = A === null ? Object.create(A) : (k.prototype = A.prototype, new k());
          };
        }(),
        X = B.extend,
        W = B.merge;
      return B = function (z) {
        function w() {
          var A = z !== null && z.apply(this, arguments) || this;
          return A.data = void 0, A.options = void 0, A.points = void 0, A;
        }
        return H(w, z), w.defaultOptions = W(D.defaultOptions, {}), w;
      }(D), X(B.prototype, {
        inverted: !0
      }), E.registerSeriesType("bar", B), B;
    }), V(S, "Series/Scatter/ScatterSeriesDefaults.js", [], function () {
      return {
        lineWidth: 0,
        findNearestPointBy: "xy",
        jitter: {
          x: 0,
          y: 0
        },
        marker: {
          enabled: !0
        },
        tooltip: {
          headerFormat: '<span style="color:{point.color}">●</span> <span style="font-size: 10px"> {series.name}</span><br/>',
          pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
        }
      };
    }), V(S, "Series/Scatter/ScatterSeries.js", [S["Series/Scatter/ScatterSeriesDefaults.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = this && this.__extends || function () {
          var _k6 = function k(g, p) {
            return _k6 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k6(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k6(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        X = E.seriesTypes,
        W = X.column,
        z = X.line;
      X = B.addEvent;
      var w = B.extend,
        A = B.merge;
      return B = function (k) {
        function g() {
          var p = k !== null && k.apply(this, arguments) || this;
          return p.data = void 0, p.options = void 0, p.points = void 0, p;
        }
        return H(g, k), g.prototype.applyJitter = function () {
          var p = this,
            h = this.options.jitter,
            s = this.points.length;
          h && this.points.forEach(function (l, u) {
            ["x", "y"].forEach(function (v, M) {
              var I = "plot" + v.toUpperCase();
              if (h[v] && !l.isNull) {
                var L = p[v + "Axis"],
                  C = h[v] * L.transA;
                if (L && !L.isLog) {
                  var m = Math.max(0, l[I] - C);
                  L = Math.min(L.len, l[I] + C), M = 1e4 * Math.sin(u + M * s), l[I] = m + (L - m) * (M - Math.floor(M)), v === "x" && (l.clientX = l.plotX);
                }
              }
            });
          });
        }, g.prototype.drawGraph = function () {
          this.options.lineWidth ? k.prototype.drawGraph.call(this) : this.graph && (this.graph = this.graph.destroy());
        }, g.defaultOptions = A(z.defaultOptions, D), g;
      }(z), w(B.prototype, {
        drawTracker: W.prototype.drawTracker,
        sorted: !1,
        requireSorting: !1,
        noSharedTooltip: !0,
        trackerGroups: ["group", "markerGroup", "dataLabelsGroup"],
        takeOrdinalPosition: !1
      }), X(B, "afterTranslate", function () {
        this.applyJitter();
      }), E.registerSeriesType("scatter", B), B;
    }), V(S, "Series/CenteredUtilities.js", [S["Core/Globals.js"], S["Core/Series/Series.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = D.deg2rad,
        X = B.fireEvent,
        W = B.isNumber,
        z = B.pick,
        w = B.relativeLength,
        A;
      return function (k) {
        k.getCenter = function () {
          var g = this.options,
            p = this.chart,
            h = 2 * (g.slicedOffset || 0),
            s = p.plotWidth - 2 * h,
            l = p.plotHeight - 2 * h,
            u = g.center,
            v = Math.min(s, l),
            M = g.thickness,
            I = g.size,
            L = g.innerSize || 0;
          for (typeof I == "string" && (I = parseFloat(I)), typeof L == "string" && (L = parseFloat(L)), g = [z(u[0], "50%"), z(u[1], "50%"), z(I && 0 > I ? void 0 : g.size, "100%"), z(L && 0 > L ? void 0 : g.innerSize || 0, "0%")], !p.angular || this instanceof E || (g[3] = 0), u = 0; 4 > u; ++u) I = g[u], p = 2 > u || u === 2 && /%$/.test(I), g[u] = w(I, [s, l, v, g[2]][u]) + (p ? h : 0);
          return g[3] > g[2] && (g[3] = g[2]), W(M) && 2 * M < g[2] && 0 < M && (g[3] = g[2] - 2 * M), X(this, "afterGetCenter", {
            positions: g
          }), g;
        }, k.getStartAndEndRadians = function (g, p) {
          return g = W(g) ? g : 0, p = W(p) && p > g && 360 > p - g ? p : g + 360, {
            start: H * (g + -90),
            end: H * (p + -90)
          };
        };
      }(A || (A = {})), A;
    }), V(S, "Series/Pie/PiePoint.js", [S["Core/Animation/AnimationUtilities.js"], S["Core/Series/Point.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = this && this.__extends || function () {
          var _g3 = function g(p, h) {
            return _g3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (s, l) {
              s.__proto__ = l;
            } || function (s, l) {
              for (var u in l) l.hasOwnProperty(u) && (s[u] = l[u]);
            }, _g3(p, h);
          };
          return function (p, h) {
            function s() {
              this.constructor = p;
            }
            _g3(p, h), p.prototype = h === null ? Object.create(h) : (s.prototype = h.prototype, new s());
          };
        }(),
        X = D.setAnimation,
        W = B.addEvent,
        z = B.defined;
      D = B.extend;
      var w = B.isNumber,
        A = B.pick,
        k = B.relativeLength;
      return E = function (g) {
        function p() {
          var h = g !== null && g.apply(this, arguments) || this;
          return h.labelDistance = void 0, h.options = void 0, h.series = void 0, h;
        }
        return H(p, g), p.prototype.getConnectorPath = function () {
          var h = this.labelPosition,
            s = this.series.options.dataLabels,
            l = this.connectorShapes,
            u = s.connectorShape;
          return l[u] && (u = l[u]), u.call(this, {
            x: h.final.x,
            y: h.final.y,
            alignment: h.alignment
          }, h.connectorPosition, s);
        }, p.prototype.getTranslate = function () {
          return this.sliced ? this.slicedTranslation : {
            translateX: 0,
            translateY: 0
          };
        }, p.prototype.haloPath = function (h) {
          var s = this.shapeArgs;
          return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(s.x, s.y, s.r + h, s.r + h, {
            innerR: s.r - 1,
            start: s.start,
            end: s.end
          });
        }, p.prototype.init = function () {
          var h = this;
          g.prototype.init.apply(this, arguments), this.name = A(this.name, "Slice");
          var s = function s(l) {
            h.slice(l.type === "select");
          };
          return W(this, "select", s), W(this, "unselect", s), this;
        }, p.prototype.isValid = function () {
          return w(this.y) && 0 <= this.y;
        }, p.prototype.setVisible = function (h, s) {
          var l = this,
            u = this.series,
            v = u.chart,
            M = u.options.ignoreHiddenPoint;
          s = A(s, M), h !== this.visible && (this.visible = this.options.visible = h = typeof h > "u" ? !this.visible : h, u.options.data[u.data.indexOf(this)] = this.options, ["graphic", "dataLabel", "connector", "shadowGroup"].forEach(function (I) {
            l[I] && l[I][h ? "show" : "hide"](h);
          }), this.legendItem && v.legend.colorizeItem(this, h), h || this.state !== "hover" || this.setState(""), M && (u.isDirty = !0), s && v.redraw());
        }, p.prototype.slice = function (h, s, l) {
          var u = this.series;
          X(l, u.chart), A(s, !0), this.sliced = this.options.sliced = z(h) ? h : !this.sliced, u.options.data[u.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate()), this.shadowGroup && this.shadowGroup.animate(this.getTranslate());
        }, p;
      }(E), D(E.prototype, {
        connectorShapes: {
          fixedOffset: function fixedOffset(g, p, h) {
            var s = p.breakAt;
            return p = p.touchingSliceAt, [["M", g.x, g.y], h.softConnector ? ["C", g.x + (g.alignment === "left" ? -5 : 5), g.y, 2 * s.x - p.x, 2 * s.y - p.y, s.x, s.y] : ["L", s.x, s.y], ["L", p.x, p.y]];
          },
          straight: function straight(g, p) {
            return p = p.touchingSliceAt, [["M", g.x, g.y], ["L", p.x, p.y]];
          },
          crookedLine: function crookedLine(g, p, h) {
            p = p.touchingSliceAt;
            var s = this.series,
              l = s.center[0],
              u = s.chart.plotWidth,
              v = s.chart.plotLeft;
            s = g.alignment;
            var M = this.shapeArgs.r;
            return h = k(h.crookDistance, 1), u = s === "left" ? l + M + (u + v - l - M) * (1 - h) : v + (l - M) * h, h = ["L", u, g.y], l = !0, (s === "left" ? u > g.x || u < p.x : u < g.x || u > p.x) && (l = !1), g = [["M", g.x, g.y]], l && g.push(h), g.push(["L", p.x, p.y]), g;
          }
        }
      }), E;
    }), V(S, "Series/Pie/PieSeriesDefaults.js", [], function () {
      return {
        center: [null, null],
        clip: !1,
        colorByPoint: !0,
        dataLabels: {
          allowOverlap: !0,
          connectorPadding: 5,
          connectorShape: "fixedOffset",
          crookDistance: "70%",
          distance: 30,
          enabled: !0,
          formatter: function formatter() {
            return this.point.isNull ? void 0 : this.point.name;
          },
          softConnector: !0,
          x: 0
        },
        fillColor: void 0,
        ignoreHiddenPoint: !0,
        inactiveOtherPoints: !0,
        legendType: "point",
        marker: null,
        size: null,
        showInLegend: !1,
        slicedOffset: 10,
        stickyTracking: !1,
        tooltip: {
          followPointer: !0
        },
        borderColor: "#ffffff",
        borderWidth: 1,
        lineWidth: void 0,
        states: {
          hover: {
            brightness: 0.1
          }
        }
      };
    }), V(S, "Series/Pie/PieSeries.js", [S["Series/CenteredUtilities.js"], S["Series/Column/ColumnSeries.js"], S["Core/Globals.js"], S["Core/Legend/LegendSymbol.js"], S["Series/Pie/PiePoint.js"], S["Series/Pie/PieSeriesDefaults.js"], S["Core/Series/Series.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Renderer/SVG/Symbols.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z, w, A, k) {
      var g = this && this.__extends || function () {
          var _I = function I(L, C) {
            return _I = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (m, d) {
              m.__proto__ = d;
            } || function (m, d) {
              for (var o in d) d.hasOwnProperty(o) && (m[o] = d[o]);
            }, _I(L, C);
          };
          return function (L, C) {
            function m() {
              this.constructor = L;
            }
            _I(L, C), L.prototype = C === null ? Object.create(C) : (m.prototype = C.prototype, new m());
          };
        }(),
        p = D.getStartAndEndRadians;
      B = B.noop;
      var h = k.clamp,
        s = k.extend,
        l = k.fireEvent,
        u = k.merge,
        v = k.pick,
        M = k.relativeLength;
      return k = function (I) {
        function L() {
          var C = I !== null && I.apply(this, arguments) || this;
          return C.center = void 0, C.data = void 0, C.maxLabelDistance = void 0, C.options = void 0, C.points = void 0, C;
        }
        return g(L, I), L.prototype.animate = function (C) {
          var m = this,
            d = m.points,
            o = m.startAngleRad;
          C || d.forEach(function (n) {
            var r = n.graphic,
              i = n.shapeArgs;
            r && i && (r.attr({
              r: v(n.startR, m.center && m.center[3] / 2),
              start: o,
              end: o
            }), r.animate({
              r: i.r,
              start: i.start,
              end: i.end
            }, m.options.animation));
          });
        }, L.prototype.drawEmpty = function () {
          var C = this.startAngleRad,
            m = this.endAngleRad,
            d = this.options;
          if (this.total === 0 && this.center) {
            var o = this.center[0],
              n = this.center[1];
            this.graph || (this.graph = this.chart.renderer.arc(o, n, this.center[1] / 2, 0, C, m).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
              d: A.arc(o, n, this.center[2] / 2, 0, {
                start: C,
                end: m,
                innerR: this.center[3] / 2
              })
            }), this.chart.styledMode || this.graph.attr({
              "stroke-width": d.borderWidth,
              fill: d.fillColor || "none",
              stroke: d.color || "#cccccc"
            });
          } else this.graph && (this.graph = this.graph.destroy());
        }, L.prototype.drawPoints = function () {
          var C = this.chart.renderer;
          this.points.forEach(function (m) {
            m.graphic && m.hasNewShapeType() && (m.graphic = m.graphic.destroy()), m.graphic || (m.graphic = C[m.shapeType](m.shapeArgs).add(m.series.group), m.delayedRendering = !0);
          });
        }, L.prototype.generatePoints = function () {
          I.prototype.generatePoints.call(this), this.updateTotals();
        }, L.prototype.getX = function (C, m, d) {
          var o = this.center,
            n = this.radii ? this.radii[d.index] || 0 : o[2] / 2;
          return C = Math.asin(h((C - o[1]) / (n + d.labelDistance), -1, 1)), o[0] + (m ? -1 : 1) * Math.cos(C) * (n + d.labelDistance) + (0 < d.labelDistance ? (m ? -1 : 1) * this.options.dataLabels.padding : 0);
        }, L.prototype.hasData = function () {
          return !!this.processedXData.length;
        }, L.prototype.redrawPoints = function () {
          var C = this,
            m = C.chart,
            d = m.renderer,
            o = C.options.shadow,
            n,
            r,
            i,
            t;
          this.drawEmpty(), !o || C.shadowGroup || m.styledMode || (C.shadowGroup = d.g("shadow").attr({
            zIndex: -1
          }).add(C.group)), C.points.forEach(function (e) {
            var a = {};
            if (r = e.graphic, !e.isNull && r) {
              var c = void 0;
              t = e.shapeArgs, n = e.getTranslate(), m.styledMode || (c = e.shadowGroup, o && !c && (c = e.shadowGroup = d.g("shadow").add(C.shadowGroup)), c && c.attr(n), i = C.pointAttribs(e, e.selected && "select")), e.delayedRendering ? (r.setRadialReference(C.center).attr(t).attr(n), m.styledMode || r.attr(i).attr({
                "stroke-linejoin": "round"
              }).shadow(o, c), e.delayedRendering = !1) : (r.setRadialReference(C.center), m.styledMode || u(!0, a, i), u(!0, a, t, n), r.animate(a)), r.attr({
                visibility: e.visible ? "inherit" : "hidden"
              }), r.addClass(e.getClassName(), !0);
            } else r && (e.graphic = r.destroy());
          });
        }, L.prototype.sortByAngle = function (C, m) {
          C.sort(function (d, o) {
            return typeof d.angle < "u" && (o.angle - d.angle) * m;
          });
        }, L.prototype.translate = function (C) {
          l(this, "translate"), this.generatePoints();
          var m = this.options,
            d = m.slicedOffset,
            o = d + (m.borderWidth || 0),
            n = p(m.startAngle, m.endAngle),
            r = this.startAngleRad = n.start;
          n = (this.endAngleRad = n.end) - r;
          var i = this.points,
            t = m.dataLabels.distance;
          m = m.ignoreHiddenPoint;
          var e = i.length,
            a,
            c = 0;
          for (C || (this.center = C = this.getCenter()), a = 0; a < e; a++) {
            var y = i[a],
              b = r + c * n;
            !y.isValid() || m && !y.visible || (c += y.percentage / 100);
            var j = r + c * n,
              P = {
                x: C[0],
                y: C[1],
                r: C[2] / 2,
                innerR: C[3] / 2,
                start: Math.round(1e3 * b) / 1e3,
                end: Math.round(1e3 * j) / 1e3
              };
            y.shapeType = "arc", y.shapeArgs = P, y.labelDistance = v(y.options.dataLabels && y.options.dataLabels.distance, t), y.labelDistance = M(y.labelDistance, P.r), this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, y.labelDistance), j = (j + b) / 2, j > 1.5 * Math.PI ? j -= 2 * Math.PI : j < -Math.PI / 2 && (j += 2 * Math.PI), y.slicedTranslation = {
              translateX: Math.round(Math.cos(j) * d),
              translateY: Math.round(Math.sin(j) * d)
            }, P = Math.cos(j) * C[2] / 2;
            var f = Math.sin(j) * C[2] / 2;
            y.tooltipPos = [C[0] + 0.7 * P, C[1] + 0.7 * f], y.half = j < -Math.PI / 2 || j > Math.PI / 2 ? 1 : 0, y.angle = j, b = Math.min(o, y.labelDistance / 5), y.labelPosition = {
              natural: {
                x: C[0] + P + Math.cos(j) * y.labelDistance,
                y: C[1] + f + Math.sin(j) * y.labelDistance
              },
              final: {},
              alignment: 0 > y.labelDistance ? "center" : y.half ? "right" : "left",
              connectorPosition: {
                breakAt: {
                  x: C[0] + P + Math.cos(j) * b,
                  y: C[1] + f + Math.sin(j) * b
                },
                touchingSliceAt: {
                  x: C[0] + P,
                  y: C[1] + f
                }
              }
            };
          }
          l(this, "afterTranslate");
        }, L.prototype.updateTotals = function () {
          var C = this.points,
            m = C.length,
            d = this.options.ignoreHiddenPoint,
            o,
            n = 0;
          for (o = 0; o < m; o++) {
            var r = C[o];
            !r.isValid() || d && !r.visible || (n += r.y);
          }
          for (this.total = n, o = 0; o < m; o++) r = C[o], r.percentage = 0 < n && (r.visible || !d) ? r.y / n * 100 : 0, r.total = n;
        }, L.defaultOptions = u(z.defaultOptions, W), L;
      }(z), s(k.prototype, {
        axisTypes: [],
        directTouch: !0,
        drawGraph: void 0,
        drawLegendSymbol: H.drawRectangle,
        drawTracker: E.prototype.drawTracker,
        getCenter: D.getCenter,
        getSymbol: B,
        isCartesian: !1,
        noSharedTooltip: !0,
        pointAttribs: E.prototype.pointAttribs,
        pointClass: X,
        requireSorting: !1,
        searchPoint: B,
        trackerGroups: ["group", "dataLabelsGroup"]
      }), w.registerSeriesType("pie", k), k;
    }), V(S, "Series/Pie/PieDataLabel.js", [S["Core/Series/DataLabel.js"], S["Core/Globals.js"], S["Core/Renderer/RendererUtilities.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H, X) {
      var W = E.noop,
        z = B.distribute,
        w = H.series,
        A = X.arrayMax,
        k = X.clamp,
        g = X.defined,
        p = X.merge,
        h = X.pick,
        s = X.relativeLength,
        l;
      return function (u) {
        function v() {
          var m = this,
            d = m.data,
            o = m.chart,
            n = m.options.dataLabels || {},
            r = n.connectorPadding,
            i = o.plotWidth,
            t = o.plotHeight,
            e = o.plotLeft,
            a = Math.round(o.chartWidth / 3),
            c = m.center,
            y = c[2] / 2,
            b = c[1],
            j = [[], []],
            P = [0, 0, 0, 0],
            f = m.dataLabelPositioners,
            x,
            N,
            R,
            F,
            T,
            G,
            _,
            q,
            Y,
            U,
            Z,
            J;
          m.visible && (n.enabled || m._hasPointLabels) && (d.forEach(function (et) {
            et.dataLabel && et.visible && et.dataLabel.shortened && (et.dataLabel.attr({
              width: "auto"
            }).css({
              width: "auto",
              textOverflow: "clip"
            }), et.dataLabel.shortened = !1);
          }), w.prototype.drawDataLabels.apply(m), d.forEach(function (et) {
            et.dataLabel && (et.visible ? (j[et.half].push(et), et.dataLabel._pos = null, !g(n.style.width) && !g(et.options.dataLabels && et.options.dataLabels.style && et.options.dataLabels.style.width) && et.dataLabel.getBBox().width > a && (et.dataLabel.css({
              width: Math.round(0.7 * a) + "px"
            }), et.dataLabel.shortened = !0)) : (et.dataLabel = et.dataLabel.destroy(), et.dataLabels && et.dataLabels.length === 1 && delete et.dataLabels));
          }), j.forEach(function (et, nt) {
            var lt = et.length,
              ct = [],
              tt;
            if (lt) {
              if (m.sortByAngle(et, nt - 0.5), 0 < m.maxLabelDistance) {
                var st = Math.max(0, b - y - m.maxLabelDistance),
                  it = Math.min(b + y + m.maxLabelDistance, o.plotHeight);
                et.forEach(function ($) {
                  0 < $.labelDistance && $.dataLabel && ($.top = Math.max(0, b - y - $.labelDistance), $.bottom = Math.min(b + y + $.labelDistance, o.plotHeight), tt = $.dataLabel.getBBox().height || 21, $.distributeBox = {
                    target: $.labelPosition.natural.y - $.top + tt / 2,
                    size: tt,
                    rank: $.y
                  }, ct.push($.distributeBox));
                }), st = it + tt - st, z(ct, st, st / 5);
              }
              for (Z = 0; Z < lt; Z++) {
                if (x = et[Z], G = x.labelPosition, F = x.dataLabel, U = x.visible === !1 ? "hidden" : "inherit", Y = st = G.natural.y, ct && g(x.distributeBox) && (typeof x.distributeBox.pos > "u" ? U = "hidden" : (_ = x.distributeBox.size, Y = f.radialDistributionY(x))), delete x.positionIndex, n.justify) q = f.justify(x, y, c);else switch (n.alignTo) {
                  case "connectors":
                    q = f.alignToConnectors(et, nt, i, e);
                    break;
                  case "plotEdges":
                    q = f.alignToPlotEdges(F, nt, i, e);
                    break;
                  default:
                    q = f.radialDistributionX(m, x, Y, st);
                }
                F._attr = {
                  visibility: U,
                  align: G.alignment
                }, J = x.options.dataLabels || {}, F._pos = {
                  x: q + h(J.x, n.x) + ({
                    left: r,
                    right: -r
                  }[G.alignment] || 0),
                  y: Y + h(J.y, n.y) - 10
                }, G.final.x = q, G.final.y = Y, h(n.crop, !0) && (T = F.getBBox().width, st = null, q - T < r && nt === 1 ? (st = Math.round(T - q + r), P[3] = Math.max(st, P[3])) : q + T > i - r && nt === 0 && (st = Math.round(q + T - i + r), P[1] = Math.max(st, P[1])), 0 > Y - _ / 2 ? P[0] = Math.max(Math.round(-Y + _ / 2), P[0]) : Y + _ / 2 > t && (P[2] = Math.max(Math.round(Y + _ / 2 - t), P[2])), F.sideOverflow = st);
              }
            }
          }), A(P) === 0 || this.verifyDataLabelOverflow(P)) && (this.placeDataLabels(), this.points.forEach(function (et) {
            if (J = p(n, et.options.dataLabels), N = h(J.connectorWidth, 1)) {
              var nt;
              R = et.connector, (F = et.dataLabel) && F._pos && et.visible && 0 < et.labelDistance ? (U = F._attr.visibility, (nt = !R) && (et.connector = R = o.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + et.colorIndex + (et.className ? " " + et.className : "")).add(m.dataLabelsGroup), o.styledMode || R.attr({
                "stroke-width": N,
                stroke: J.connectorColor || et.color || "#666666"
              })), R[nt ? "attr" : "animate"]({
                d: et.getConnectorPath()
              }), R.attr("visibility", U)) : R && (et.connector = R.destroy());
            }
          }));
        }
        function M() {
          this.points.forEach(function (m) {
            var d = m.dataLabel,
              o;
            d && m.visible && ((o = d._pos) ? (d.sideOverflow && (d._attr.width = Math.max(d.getBBox().width - d.sideOverflow, 0), d.css({
              width: d._attr.width + "px",
              textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis"
            }), d.shortened = !0), d.attr(d._attr), d[d.moved ? "animate" : "attr"](o), d.moved = !0) : d && d.attr({
              y: -9999
            })), delete m.distributeBox;
          }, this);
        }
        function I(m) {
          var d = this.center,
            o = this.options,
            n = o.center,
            r = o.minSize || 80,
            i = o.size !== null;
          if (!i) {
            if (n[0] !== null) var t = Math.max(d[2] - Math.max(m[1], m[3]), r);else t = Math.max(d[2] - m[1] - m[3], r), d[0] += (m[3] - m[1]) / 2;
            n[1] !== null ? t = k(t, r, d[2] - Math.max(m[0], m[2])) : (t = k(t, r, d[2] - m[0] - m[2]), d[1] += (m[0] - m[2]) / 2), t < d[2] ? (d[2] = t, d[3] = Math.min(o.thickness ? Math.max(0, t - 2 * o.thickness) : Math.max(0, s(o.innerSize || 0, t)), t), this.translate(d), this.drawDataLabels && this.drawDataLabels()) : i = !0;
          }
          return i;
        }
        var L = [],
          C = {
            radialDistributionY: function radialDistributionY(m) {
              return m.top + m.distributeBox.pos;
            },
            radialDistributionX: function radialDistributionX(m, d, o, n) {
              return m.getX(o < d.top + 2 || o > d.bottom - 2 ? n : o, d.half, d);
            },
            justify: function justify(m, d, o) {
              return o[0] + (m.half ? -1 : 1) * (d + m.labelDistance);
            },
            alignToPlotEdges: function alignToPlotEdges(m, d, o, n) {
              return m = m.getBBox().width, d ? m + n : o - m - n;
            },
            alignToConnectors: function alignToConnectors(m, d, o, n) {
              var r = 0,
                i;
              return m.forEach(function (t) {
                i = t.dataLabel.getBBox().width, i > r && (r = i);
              }), d ? r + n : o - r - n;
            }
          };
        u.compose = function (m) {
          D.compose(w), L.indexOf(m) === -1 && (L.push(m), m = m.prototype, m.dataLabelPositioners = C, m.alignDataLabel = W, m.drawDataLabels = v, m.placeDataLabels = M, m.verifyDataLabelOverflow = I);
        };
      }(l || (l = {})), l;
    }), V(S, "Extensions/OverlappingDataLabels.js", [S["Core/Chart/Chart.js"], S["Core/Utilities.js"]], function (D, E) {
      function B(k, g) {
        var p = !1;
        if (k) {
          var h = k.newOpacity;
          k.oldOpacity !== h && (k.alignAttr && k.placed ? (k[h ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), p = !0, k.alignAttr.opacity = h, k[k.isOld ? "animate" : "attr"](k.alignAttr, null, function () {
            g.styledMode || k.css({
              pointerEvents: h ? "auto" : "none"
            });
          }), X(g, "afterHideOverlappingLabel")) : k.attr({
            opacity: h
          })), k.isOld = !0;
        }
        return p;
      }
      var H = E.addEvent,
        X = E.fireEvent,
        W = E.isArray,
        z = E.isNumber,
        w = E.objectEach,
        A = E.pick;
      H(D, "render", function () {
        var k = this,
          g = [];
        (this.labelCollectors || []).forEach(function (p) {
          g = g.concat(p());
        }), (this.yAxis || []).forEach(function (p) {
          p.stacking && p.options.stackLabels && !p.options.stackLabels.allowOverlap && w(p.stacking.stacks, function (h) {
            w(h, function (s) {
              s.label && g.push(s.label);
            });
          });
        }), (this.series || []).forEach(function (p) {
          var h = p.options.dataLabels;
          p.visible && (h.enabled !== !1 || p._hasPointLabels) && (h = function h(s) {
            return s.forEach(function (l) {
              l.visible && (W(l.dataLabels) ? l.dataLabels : l.dataLabel ? [l.dataLabel] : []).forEach(function (u) {
                var v = u.options;
                u.labelrank = A(v.labelrank, l.labelrank, l.shapeArgs && l.shapeArgs.height), v.allowOverlap ? (u.oldOpacity = u.opacity, u.newOpacity = 1, B(u, k)) : g.push(u);
              });
            });
          }, h(p.nodes || []), h(p.points));
        }), this.hideOverlappingLabels(g);
      }), D.prototype.hideOverlappingLabels = function (k) {
        var g = this,
          p = k.length,
          h = g.renderer,
          s,
          l,
          u,
          v = !1,
          M = function M(C) {
            var m,
              d = C.box ? 0 : C.padding || 0,
              o = m = 0,
              n;
            if (C && (!C.alignAttr || C.placed)) {
              var r = C.alignAttr || {
                  x: C.attr("x"),
                  y: C.attr("y")
                },
                i = C.parentGroup;
              C.width || (m = C.getBBox(), C.width = m.width, C.height = m.height, m = h.fontMetrics(null, C.element).h);
              var t = C.width - 2 * d;
              return (n = {
                left: "0",
                center: "0.5",
                right: "1"
              }[C.alignValue]) ? o = +n * t : z(C.x) && Math.round(C.x) !== C.translateX && (o = C.x - C.translateX), {
                x: r.x + (i.translateX || 0) + d - (o || 0),
                y: r.y + (i.translateY || 0) + d - m,
                width: C.width - 2 * d,
                height: C.height - 2 * d
              };
            }
          };
        for (l = 0; l < p; l++) (s = k[l]) && (s.oldOpacity = s.opacity, s.newOpacity = 1, s.absoluteBox = M(s));
        for (k.sort(function (C, m) {
          return (m.labelrank || 0) - (C.labelrank || 0);
        }), l = 0; l < p; l++) {
          var I = (M = k[l]) && M.absoluteBox;
          for (s = l + 1; s < p; ++s) {
            var L = (u = k[s]) && u.absoluteBox;
            !I || !L || M === u || M.newOpacity === 0 || u.newOpacity === 0 || M.visibility === "hidden" || u.visibility === "hidden" || L.x >= I.x + I.width || L.x + L.width <= I.x || L.y >= I.y + I.height || L.y + L.height <= I.y || ((M.labelrank < u.labelrank ? M : u).newOpacity = 0);
          }
        }
        k.forEach(function (C) {
          B(C, g) && (v = !0);
        }), v && X(g, "afterHideAllOverlappingLabels");
      };
    }), V(S, "Core/Responsive.js", [S["Core/Utilities.js"]], function (D) {
      var E = D.extend,
        B = D.find,
        H = D.isArray,
        X = D.isObject,
        W = D.merge,
        z = D.objectEach,
        w = D.pick,
        A = D.splat,
        k = D.uniqueKey,
        g;
      return function (p) {
        var h = [];
        p.compose = function (l) {
          return h.indexOf(l) === -1 && (h.push(l), E(l.prototype, s.prototype)), l;
        };
        var s = function () {
          function l() {}
          return l.prototype.currentOptions = function (u) {
            function v(L, C, m, d) {
              var o;
              z(L, function (n, r) {
                if (!d && -1 < M.collectionsWithUpdate.indexOf(r) && C[r]) for (n = A(n), m[r] = [], o = 0; o < Math.max(n.length, C[r].length); o++) C[r][o] && (n[o] === void 0 ? m[r][o] = C[r][o] : (m[r][o] = {}, v(n[o], C[r][o], m[r][o], d + 1)));else X(n) ? (m[r] = H(n) ? [] : {}, v(n, C[r] || {}, m[r], d + 1)) : m[r] = typeof C[r] > "u" ? null : C[r];
              });
            }
            var M = this,
              I = {};
            return v(u, this.options, I, 0), I;
          }, l.prototype.matchResponsiveRule = function (u, v) {
            var M = u.condition;
            (M.callback || function () {
              return this.chartWidth <= w(M.maxWidth, Number.MAX_VALUE) && this.chartHeight <= w(M.maxHeight, Number.MAX_VALUE) && this.chartWidth >= w(M.minWidth, 0) && this.chartHeight >= w(M.minHeight, 0);
            }).call(this) && v.push(u._id);
          }, l.prototype.setResponsive = function (u, v) {
            var M = this,
              I = this.options.responsive,
              L = this.currentResponsive,
              C = [];
            !v && I && I.rules && I.rules.forEach(function (m) {
              typeof m._id > "u" && (m._id = k()), M.matchResponsiveRule(m, C);
            }, this), v = W.apply(void 0, C.map(function (m) {
              return B((I || {}).rules || [], function (d) {
                return d._id === m;
              });
            }).map(function (m) {
              return m && m.chartOptions;
            })), v.isResponsiveOptions = !0, C = C.toString() || void 0, C !== (L && L.ruleIds) && (L && this.update(L.undoOptions, u, !0), C ? (L = this.currentOptions(v), L.isResponsiveOptions = !0, this.currentResponsive = {
              ruleIds: C,
              mergedOptions: v,
              undoOptions: L
            }, this.update(v, u, !0)) : this.currentResponsive = void 0);
          }, l;
        }();
      }(g || (g = {})), g;
    }), V(S, "masters/highcharts.src.js", [S["Core/Globals.js"], S["Core/Utilities.js"], S["Core/Defaults.js"], S["Core/Animation/Fx.js"], S["Core/Animation/AnimationUtilities.js"], S["Core/Renderer/HTML/AST.js"], S["Core/FormatUtilities.js"], S["Core/Renderer/RendererUtilities.js"], S["Core/Renderer/SVG/SVGElement.js"], S["Core/Renderer/SVG/SVGRenderer.js"], S["Core/Renderer/HTML/HTMLElement.js"], S["Core/Renderer/HTML/HTMLRenderer.js"], S["Core/Axis/Axis.js"], S["Core/Axis/DateTimeAxis.js"], S["Core/Axis/LogarithmicAxis.js"], S["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], S["Core/Axis/Tick.js"], S["Core/Tooltip.js"], S["Core/Series/Point.js"], S["Core/Pointer.js"], S["Core/MSPointer.js"], S["Core/Legend/Legend.js"], S["Core/Chart/Chart.js"], S["Core/Axis/Stacking/StackingAxis.js"], S["Core/Axis/Stacking/StackItem.js"], S["Core/Series/Series.js"], S["Core/Series/SeriesRegistry.js"], S["Series/Column/ColumnSeries.js"], S["Series/Column/ColumnDataLabel.js"], S["Series/Pie/PieSeries.js"], S["Series/Pie/PieDataLabel.js"], S["Core/Series/DataLabel.js"], S["Core/Responsive.js"], S["Core/Color/Color.js"], S["Core/Time.js"]], function (D, E, B, H, X, W, z, w, A, k, g, p, h, s, l, u, v, M, I, L, C, m, d, o, n, r, i, t, e, a, c, y, b, j, P) {
      return D.animate = X.animate, D.animObject = X.animObject, D.getDeferredAnimation = X.getDeferredAnimation, D.setAnimation = X.setAnimation, D.stop = X.stop, D.timers = H.timers, D.AST = W, D.Axis = h, D.Chart = d, D.chart = d.chart, D.Fx = H, D.Legend = m, D.PlotLineOrBand = u, D.Point = I, D.Pointer = C.isRequired() ? C : L, D.Series = r, D.StackItem = n, D.SVGElement = A, D.SVGRenderer = k, D.Tick = v, D.Time = P, D.Tooltip = M, D.Color = j, D.color = j.parse, p.compose(k), g.compose(A), D.defaultOptions = B.defaultOptions, D.getOptions = B.getOptions, D.time = B.defaultTime, D.setOptions = B.setOptions, D.dateFormat = z.dateFormat, D.format = z.format, D.numberFormat = z.numberFormat, D.addEvent = E.addEvent, D.arrayMax = E.arrayMax, D.arrayMin = E.arrayMin, D.attr = E.attr, D.clearTimeout = E.clearTimeout, D.correctFloat = E.correctFloat, D.createElement = E.createElement, D.css = E.css, D.defined = E.defined, D.destroyObjectProperties = E.destroyObjectProperties, D.discardElement = E.discardElement, D.distribute = w.distribute, D.erase = E.erase, D.error = E.error, D.extend = E.extend, D.extendClass = E.extendClass, D.find = E.find, D.fireEvent = E.fireEvent, D.getMagnitude = E.getMagnitude, D.getStyle = E.getStyle, D.inArray = E.inArray, D.isArray = E.isArray, D.isClass = E.isClass, D.isDOMElement = E.isDOMElement, D.isFunction = E.isFunction, D.isNumber = E.isNumber, D.isObject = E.isObject, D.isString = E.isString, D.keys = E.keys, D.merge = E.merge, D.normalizeTickInterval = E.normalizeTickInterval, D.objectEach = E.objectEach, D.offset = E.offset, D.pad = E.pad, D.pick = E.pick, D.pInt = E.pInt, D.relativeLength = E.relativeLength, D.removeEvent = E.removeEvent, D.seriesType = i.seriesType, D.splat = E.splat, D.stableSort = E.stableSort, D.syncTimeout = E.syncTimeout, D.timeUnits = E.timeUnits, D.uniqueKey = E.uniqueKey, D.useSerialIds = E.useSerialIds, D.wrap = E.wrap, e.compose(t), y.compose(r), s.compose(h), l.compose(h), c.compose(a), u.compose(h), b.compose(d), o.compose(h, d, r), D;
    }), V(S, "Core/Axis/BrokenAxis.js", [S["Core/Axis/Stacking/StackItem.js"], S["Core/Utilities.js"]], function (D, E) {
      var B = E.addEvent,
        H = E.find,
        X = E.fireEvent,
        W = E.isArray,
        z = E.isNumber,
        w = E.pick,
        A;
      return function (k) {
        function g() {
          typeof this.brokenAxis < "u" && this.brokenAxis.setBreaks(this.options.breaks, !1);
        }
        function p() {
          this.brokenAxis && this.brokenAxis.hasBreaks && (this.options.ordinal = !1);
        }
        function h() {
          var C = this.brokenAxis;
          if (C && C.hasBreaks) {
            for (var m = this.tickPositions, d = this.tickPositions.info, o = [], n = 0; n < m.length; n++) C.isInAnyBreak(m[n]) || o.push(m[n]);
            this.tickPositions = o, this.tickPositions.info = d;
          }
        }
        function s() {
          this.brokenAxis || (this.brokenAxis = new L(this));
        }
        function l() {
          var C = this.options.connectNulls,
            m = this.points,
            d = this.xAxis,
            o = this.yAxis;
          if (this.isDirty) for (var n = m.length; n--;) {
            var r = m[n],
              i = !(r.y === null && C === !1) && (d && d.brokenAxis && d.brokenAxis.isInAnyBreak(r.x, !0) || o && o.brokenAxis && o.brokenAxis.isInAnyBreak(r.y, !0));
            r.visible = i ? !1 : r.options.visible !== !1;
          }
        }
        function u() {
          this.drawBreaks(this.xAxis, ["x"]), this.drawBreaks(this.yAxis, w(this.pointArrayMap, ["y"]));
        }
        function v(C, m) {
          var d = this,
            o = d.points,
            n,
            r,
            i,
            t;
          if (C && C.brokenAxis && C.brokenAxis.hasBreaks) {
            var e = C.brokenAxis;
            m.forEach(function (a) {
              n = e && e.breakArray || [], r = C.isXAxis ? C.min : w(d.options.threshold, C.min), o.forEach(function (c) {
                t = w(c["stack" + a.toUpperCase()], c[a]), n.forEach(function (y) {
                  z(r) && z(t) && (i = !1, r < y.from && t > y.to || r > y.from && t < y.from ? i = "pointBreak" : (r < y.from && t > y.from && t < y.to || r > y.from && t > y.to && t < y.from) && (i = "pointInBreak"), i && X(C, i, {
                    point: c,
                    brk: y
                  }));
                });
              });
            });
          }
        }
        function M() {
          var C = this.currentDataGrouping,
            m = C && C.gapSize;
          C = this.points.slice();
          var d = this.yAxis,
            o = this.options.gapSize,
            n = C.length - 1,
            r;
          if (o && 0 < n) for (this.options.gapUnit !== "value" && (o *= this.basePointRange), m && m > o && m >= this.basePointRange && (o = m), r = void 0; n--;) r && r.visible !== !1 || (r = C[n + 1]), m = C[n], r.visible !== !1 && m.visible !== !1 && (r.x - m.x > o && (r = (m.x + r.x) / 2, C.splice(n + 1, 0, {
            isNull: !0,
            x: r
          }), d.stacking && this.options.stacking && (r = d.stacking.stacks[this.stackKey][r] = new D(d, d.options.stackLabels, !1, r, this.stack), r.total = 0)), r = m);
          return this.getGraphPath(C);
        }
        var I = [];
        k.compose = function (C, m) {
          if (I.indexOf(C) === -1 && (I.push(C), C.keepProps.push("brokenAxis"), B(C, "init", s), B(C, "afterInit", g), B(C, "afterSetTickPositions", h), B(C, "afterSetOptions", p)), I.indexOf(m) === -1) {
            I.push(m);
            var d = m.prototype;
            d.drawBreaks = v, d.gappedPath = M, B(m, "afterGeneratePoints", l), B(m, "afterRender", u);
          }
          return C;
        };
        var L = function () {
          function C(m) {
            this.hasBreaks = !1, this.axis = m;
          }
          return C.isInBreak = function (m, d) {
            var o = m.repeat || 1 / 0,
              n = m.from,
              r = m.to - m.from;
            return d = d >= n ? (d - n) % o : o - (n - d) % o, m.inclusive ? d <= r : d < r && d !== 0;
          }, C.lin2Val = function (m) {
            var d = this.brokenAxis;
            if (d = d && d.breakArray, !d || !z(m)) return m;
            var o;
            for (o = 0; o < d.length; o++) {
              var n = d[o];
              if (n.from >= m) break;
              (n.to < m || C.isInBreak(n, m)) && (m += n.len);
            }
            return m;
          }, C.val2Lin = function (m) {
            var d = this.brokenAxis;
            if (d = d && d.breakArray, !d || !z(m)) return m;
            var o = m,
              n;
            for (n = 0; n < d.length; n++) {
              var r = d[n];
              if (r.to <= m) o -= r.len;else {
                if (r.from >= m) break;
                if (C.isInBreak(r, m)) {
                  o -= m - r.from;
                  break;
                }
              }
            }
            return o;
          }, C.prototype.findBreakAt = function (m, d) {
            return H(d, function (o) {
              return o.from < m && m < o.to;
            });
          }, C.prototype.isInAnyBreak = function (m, d) {
            var o = this.axis,
              n = o.options.breaks || [],
              r = n.length,
              i;
            if (r && z(m)) {
              for (; r--;) if (C.isInBreak(n[r], m)) {
                var t = !0;
                i || (i = w(n[r].showPoints, !o.isXAxis));
              }
              var e = t && d ? t && !i : t;
            }
            return e;
          }, C.prototype.setBreaks = function (m, d) {
            var o = this,
              n = o.axis,
              r = W(m) && !!m.length;
            n.isDirty = o.hasBreaks !== r, o.hasBreaks = r, n.options.breaks = n.userOptions.breaks = m, n.forceRedraw = !0, n.series.forEach(function (i) {
              i.isDirty = !0;
            }), r || n.val2lin !== C.val2Lin || (delete n.val2lin, delete n.lin2val), r && (n.userOptions.ordinal = !1, n.lin2val = C.lin2Val, n.val2lin = C.val2Lin, n.setExtremes = function (i, t, e, a, c) {
              if (o.hasBreaks) {
                for (var y = this.options.breaks || [], b; b = o.findBreakAt(i, y);) i = b.to;
                for (; b = o.findBreakAt(t, y);) t = b.from;
                t < i && (t = i);
              }
              n.constructor.prototype.setExtremes.call(this, i, t, e, a, c);
            }, n.setAxisTranslation = function () {
              if (n.constructor.prototype.setAxisTranslation.call(this), o.unitLength = void 0, o.hasBreaks) {
                var i = n.options.breaks || [],
                  t = [],
                  e = [],
                  a = w(n.pointRangePadding, 0),
                  c = 0,
                  y,
                  b = n.userMin || n.min,
                  j = n.userMax || n.max,
                  P;
                i.forEach(function (N) {
                  y = N.repeat || 1 / 0, z(b) && z(j) && (C.isInBreak(N, b) && (b += N.to % y - b % y), C.isInBreak(N, j) && (j -= j % y - N.from % y));
                }), i.forEach(function (N) {
                  if (x = N.from, y = N.repeat || 1 / 0, z(b) && z(j)) {
                    for (; x - y > b;) x -= y;
                    for (; x < b;) x += y;
                    for (P = x; P < j; P += y) t.push({
                      value: P,
                      move: "in"
                    }), t.push({
                      value: P + N.to - N.from,
                      move: "out",
                      size: N.breakSize
                    });
                  }
                }), t.sort(function (N, R) {
                  return N.value === R.value ? (N.move === "in" ? 0 : 1) - (R.move === "in" ? 0 : 1) : N.value - R.value;
                });
                var f = 0,
                  x = b;
                t.forEach(function (N) {
                  f += N.move === "in" ? 1 : -1, f === 1 && N.move === "in" && (x = N.value), f === 0 && z(x) && (e.push({
                    from: x,
                    to: N.value,
                    len: N.value - x - (N.size || 0)
                  }), c += N.value - x - (N.size || 0));
                }), o.breakArray = e, z(b) && z(j) && z(n.min) && (o.unitLength = j - b - c + a, X(n, "afterBreaks"), n.staticScale ? n.transA = n.staticScale : o.unitLength && (n.transA *= (j - n.min + a) / o.unitLength), a && (n.minPixelPadding = n.transA * (n.minPointOffset || 0)), n.min = b, n.max = j);
              }
            }), w(d, !0) && n.chart.redraw();
          }, C;
        }();
        k.Additions = L;
      }(A || (A = {})), A;
    }), V(S, "masters/modules/broken-axis.src.js", [S["Core/Globals.js"], S["Core/Axis/BrokenAxis.js"]], function (D, E) {
      E.compose(D.Axis, D.Series);
    }), V(S, "Extensions/DataGrouping/ApproximationRegistry.js", [], function () {
      return {};
    }), V(S, "Extensions/DataGrouping/ApproximationDefaults.js", [S["Extensions/DataGrouping/ApproximationRegistry.js"], S["Core/Utilities.js"]], function (D, E) {
      function B(k) {
        var g = k.length;
        return k = H(k), A(k) && g && (k = z(k / g)), k;
      }
      function H(k) {
        var g = k.length;
        if (!g && k.hasNulls) var p = null;else if (g) for (p = 0; g--;) p += k[g];
        return p;
      }
      var X = E.arrayMax,
        W = E.arrayMin,
        z = E.correctFloat,
        w = E.extend,
        A = E.isNumber;
      return E = {
        average: B,
        averages: function averages() {
          var k = [];
          return [].forEach.call(arguments, function (g) {
            k.push(B(g));
          }), typeof k[0] > "u" ? void 0 : k;
        },
        close: function close(k) {
          return k.length ? k[k.length - 1] : k.hasNulls ? null : void 0;
        },
        high: function high(k) {
          return k.length ? X(k) : k.hasNulls ? null : void 0;
        },
        hlc: function hlc(k, g, p) {
          if (k = D.high(k), g = D.low(g), p = D.close(p), A(k) || A(g) || A(p)) return [k, g, p];
        },
        low: function low(k) {
          return k.length ? W(k) : k.hasNulls ? null : void 0;
        },
        ohlc: function ohlc(k, g, p, h) {
          if (k = D.open(k), g = D.high(g), p = D.low(p), h = D.close(h), A(k) || A(g) || A(p) || A(h)) return [k, g, p, h];
        },
        open: function open(k) {
          return k.length ? k[0] : k.hasNulls ? null : void 0;
        },
        range: function range(k, g) {
          if (k = D.low(k), g = D.high(g), A(k) || A(g)) return [k, g];
          if (k === null && g === null) return null;
        },
        sum: H
      }, w(D, E), E;
    }), V(S, "Extensions/DataGrouping/DataGroupingDefaults.js", [], function () {
      return {
        common: {
          groupPixelWidth: 2,
          dateTimeLabelFormats: {
            millisecond: ["%A, %b %e, %H:%M:%S.%L", "%A, %b %e, %H:%M:%S.%L", "-%H:%M:%S.%L"],
            second: ["%A, %b %e, %H:%M:%S", "%A, %b %e, %H:%M:%S", "-%H:%M:%S"],
            minute: ["%A, %b %e, %H:%M", "%A, %b %e, %H:%M", "-%H:%M"],
            hour: ["%A, %b %e, %H:%M", "%A, %b %e, %H:%M", "-%H:%M"],
            day: ["%A, %b %e, %Y", "%A, %b %e", "-%A, %b %e, %Y"],
            week: ["Week from %A, %b %e, %Y", "%A, %b %e", "-%A, %b %e, %Y"],
            month: ["%B %Y", "%B", "-%B %Y"],
            year: ["%Y", "%Y", "-%Y"]
          }
        },
        seriesSpecific: {
          line: {},
          spline: {},
          area: {},
          areaspline: {},
          arearange: {},
          column: {
            groupPixelWidth: 10
          },
          columnrange: {
            groupPixelWidth: 10
          },
          candlestick: {
            groupPixelWidth: 10
          },
          ohlc: {
            groupPixelWidth: 5
          },
          hlc: {
            groupPixelWidth: 5
          },
          heikinashi: {
            groupPixelWidth: 10
          }
        },
        units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1]], ["week", [1]], ["month", [1, 3, 6]], ["year", null]]
      };
    }), V(S, "Extensions/DataGrouping/DataGroupingAxisComposition.js", [S["Extensions/DataGrouping/DataGroupingDefaults.js"], S["Core/Utilities.js"]], function (D, E) {
      function B(h) {
        var s = this,
          l = s.series;
        l.forEach(function (u) {
          u.groupPixelWidth = void 0;
        }), l.forEach(function (u) {
          u.groupPixelWidth = s.getGroupPixelWidth && s.getGroupPixelWidth(), u.groupPixelWidth && (u.hasProcessed = !0), u.applyGrouping(!!h.hasExtremesChanged);
        });
      }
      function H() {
        for (var h = this.series, s = h.length, l = 0, u = !1, v, M; s--;) (M = h[s].options.dataGrouping) && (l = Math.max(l, k(M.groupPixelWidth, D.common.groupPixelWidth)), v = (h[s].processedXData || h[s].data).length, (h[s].groupPixelWidth || v > this.chart.plotSizeX / l || v && M.forced) && (u = !0));
        return u ? l : 0;
      }
      function X() {
        this.series.forEach(function (h) {
          h.hasProcessed = !1;
        });
      }
      function W(h, s) {
        var l;
        if (s = k(s, !0), h || (h = {
          forced: !1,
          units: null
        }), this instanceof p) for (l = this.series.length; l--;) this.series[l].update({
          dataGrouping: h
        }, !1);else this.chart.options.series.forEach(function (u) {
          u.dataGrouping = typeof h == "boolean" ? h : A(h, u.dataGrouping);
        });
        this.ordinal && (this.ordinal.slope = void 0), s && this.chart.redraw();
      }
      var z = E.addEvent,
        w = E.extend,
        A = E.merge,
        k = E.pick,
        g = [],
        p;
      return {
        compose: function compose(h) {
          p = h, g.indexOf(h) === -1 && (g.push(h), z(h, "afterSetScale", X), z(h, "postProcessData", B), w(h.prototype, {
            applyGrouping: B,
            getGroupPixelWidth: H,
            setDataGrouping: W
          }));
        }
      };
    }), V(S, "Extensions/DataGrouping/DataGroupingSeriesComposition.js", [S["Extensions/DataGrouping/ApproximationRegistry.js"], S["Extensions/DataGrouping/DataGroupingDefaults.js"], S["Core/Axis/DateTimeAxis.js"], S["Core/Defaults.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W) {
      function z(d) {
        var o = this.chart,
          n = this.options.dataGrouping,
          r = this.allowDG !== !1 && n && L(n.enabled, o.options.isStock),
          i = this.visible || !o.options.chart.ignoreHiddenSeries,
          t = this.currentDataGrouping,
          e = !1;
        if (r && !this.requireSorting && (this.requireSorting = e = !0), d = !!(this.isCartesian && !this.isDirty && !this.xAxis.isDirty && !this.yAxis.isDirty && !d) || !r, e && (this.requireSorting = !1), !d) {
          this.destroyGroupedData();
          var a = n.groupAll ? this.xData : this.processedXData,
            c = n.groupAll ? this.yData : this.processedYData;
          r = o.plotSizeX, d = this.xAxis;
          var y = d.options.ordinal,
            b = this.groupPixelWidth;
          if (e = void 0, b && a && a.length && r) {
            this.isDirty = e = !0, this.points = null;
            var j = d.getExtremes(),
              P = j.min;
            j = j.max, y = y && d.ordinal && d.ordinal.getGroupIntervalFactor(P, j, this) || 1, r = d.getTimeTicks(B.Additions.prototype.normalizeTimeTickInterval(b * (j - P) / r * y, n.units || E.units), Math.min(P, a[0]), Math.max(j, a[a.length - 1]), d.options.startOfWeek, a, this.closestPointRange), b = h.groupData.apply(this, [a, c, r, n.approximation]), a = b.groupedXData, c = b.groupedYData, y = 0, n && n.smoothed && a.length && (n.firstAnchor = "firstPoint", n.anchor = "middle", n.lastAnchor = "lastPoint", u(32, !1, o, {
              "dataGrouping.smoothed": "use dataGrouping.anchor"
            })), o = a;
            var f = this.options.dataGrouping;
            if (P = this.currentDataGrouping && this.currentDataGrouping.gapSize, f && this.xData && P && this.groupMap) {
              var x = o.length - 1,
                N = f.anchor,
                R = L(f.firstAnchor, N);
              if (f = L(f.lastAnchor, N), N && N !== "start") {
                var F = P * {
                  middle: 0.5,
                  end: 1
                }[N];
                for (N = o.length - 1; N-- && 0 < N;) o[N] += F;
              }
              if (R && R !== "start" && this.xData[0] >= o[0]) {
                N = this.groupMap[0].start, F = this.groupMap[0].length;
                var T = void 0;
                M(N) && M(F) && (T = N + (F - 1)), o[0] = {
                  middle: o[0] + 0.5 * P,
                  end: o[0] + P,
                  firstPoint: this.xData[0],
                  lastPoint: T && this.xData[T]
                }[R];
              }
              f && f !== "start" && P && o[x] >= j - P && (j = this.groupMap[this.groupMap.length - 1].start, o[x] = {
                middle: o[x] + 0.5 * P,
                end: o[x] + P,
                firstPoint: j && this.xData[j],
                lastPoint: this.xData[this.xData.length - 1]
              }[f]);
            }
            for (j = 1; j < r.length; j++) r.info.segmentStarts && r.info.segmentStarts.indexOf(j) !== -1 || (y = Math.max(r[j] - r[j - 1], y));
            j = r.info, j.gapSize = y, this.closestPointRange = r.info.totalRange, this.groupMap = b.groupMap, i && (i = a, l(i[0]) && M(d.min) && M(d.dataMin) && i[0] < d.min && ((!l(d.options.min) && d.min <= d.dataMin || d.min === d.dataMin) && (d.min = Math.min(i[0], d.min)), d.dataMin = Math.min(i[0], d.dataMin)), l(i[i.length - 1]) && M(d.max) && M(d.dataMax) && i[i.length - 1] > d.max && ((!l(d.options.max) && M(d.dataMax) && d.max >= d.dataMax || d.max === d.dataMax) && (d.max = Math.max(i[i.length - 1], d.max)), d.dataMax = Math.max(i[i.length - 1], d.dataMax))), n.groupAll && (this.allGroupedData = c, n = this.cropData(a, c, d.min, d.max, 1), a = n.xData, c = n.yData, this.cropStart = n.start), this.processedXData = a, this.processedYData = c;
          } else this.groupMap = null;
          this.hasGroupedData = e, this.currentDataGrouping = j, this.preventGraphAnimation = (t && t.totalRange) !== (j && j.totalRange);
        }
      }
      function w() {
        this.groupedData && (this.groupedData.forEach(function (d, o) {
          d && (this.groupedData[o] = d.destroy ? d.destroy() : null);
        }, this), this.groupedData.length = 0);
      }
      function A() {
        C.apply(this), this.destroyGroupedData(), this.groupedData = this.hasGroupedData ? this.points : null;
      }
      function k() {
        return this.is("arearange") ? "range" : this.is("ohlc") ? "ohlc" : this.is("hlc") ? "hlc" : this.is("column") ? "sum" : "average";
      }
      function g(d, o, n, r) {
        var i = this,
          t = i.data,
          e = i.options && i.options.data,
          a = [],
          c = [],
          y = [],
          b = d.length,
          j = !!o,
          P = [],
          f = i.pointArrayMap,
          x = f && f.length,
          N = ["x"].concat(f || ["y"]),
          R = this.options.dataGrouping && this.options.dataGrouping.groupAll,
          F = 0,
          T = 0;
        if (r = typeof r == "function" ? r : r && D[r] ? D[r] : D[i.getDGApproximation && i.getDGApproximation() || "average"], x) for (var G = f.length; G--;) P.push([]);else P.push([]);
        G = x || 1;
        for (var _ = 0; _ <= b; _++) if (!(d[_] < n[0])) {
          for (; typeof n[F + 1] < "u" && d[_] >= n[F + 1] || _ === b;) {
            var q = n[F];
            i.dataGroupInfo = {
              start: R ? T : i.cropStart + T,
              length: P[0].length
            };
            var Y = r.apply(i, P);
            for (i.pointClass && !l(i.dataGroupInfo.options) && (i.dataGroupInfo.options = I(i.pointClass.prototype.optionsToObject.call({
              series: i
            }, i.options.data[i.cropStart + T])), N.forEach(function (Z) {
              delete i.dataGroupInfo.options[Z];
            })), typeof Y < "u" && (a.push(q), c.push(Y), y.push(i.dataGroupInfo)), T = _, q = 0; q < G; q++) P[q].length = 0, P[q].hasNulls = !1;
            if (F += 1, _ === b) break;
          }
          if (_ === b) break;
          if (f) {
            q = i.options.dataGrouping && i.options.dataGrouping.groupAll ? _ : i.cropStart + _, Y = t && t[q] || i.pointClass.prototype.applyOptions.apply({
              series: i
            }, [e[q]]);
            var U = void 0;
            for (q = 0; q < x; q++) U = Y[f[q]], M(U) ? P[q].push(U) : U === null && (P[q].hasNulls = !0);
          } else q = j ? o[_] : null, M(q) ? P[0].push(q) : q === null && (P[0].hasNulls = !0);
        }
        return {
          groupedXData: a,
          groupedYData: c,
          groupMap: y
        };
      }
      function p(d) {
        d = d.options;
        var o = this.type,
          n = this.chart.options.plotOptions,
          r = this.useCommonDataGrouping && E.common,
          i = E.seriesSpecific,
          t = H.defaultOptions.plotOptions[o].dataGrouping;
        if (n && (i[o] || r)) {
          var e = this.chart.rangeSelector;
          t || (t = I(E.common, i[o])), d.dataGrouping = I(r, t, n.series && n.series.dataGrouping, n[o].dataGrouping, this.userOptions.dataGrouping, !d.isInternal && e && M(e.selected) && e.buttonOptions[e.selected].dataGrouping);
        }
      }
      var h = X.series.prototype,
        s = W.addEvent,
        l = W.defined,
        u = W.error,
        v = W.extend,
        M = W.isNumber,
        I = W.merge,
        L = W.pick,
        C = h.generatePoints,
        m = [];
      return {
        compose: function compose(d) {
          var o = d.prototype.pointClass;
          m.indexOf(o) === -1 && (m.push(o), s(o, "update", function () {
            if (this.dataGroup) return u(24, !1, this.series.chart), !1;
          })), m.indexOf(d) === -1 && (m.push(d), s(d, "afterSetOptions", p), s(d, "destroy", w), v(d.prototype, {
            applyGrouping: z,
            destroyGroupedData: w,
            generatePoints: A,
            getDGApproximation: k,
            groupData: g
          }));
        },
        groupData: g
      };
    }), V(S, "Extensions/DataGrouping/DataGrouping.js", [S["Extensions/DataGrouping/DataGroupingAxisComposition.js"], S["Extensions/DataGrouping/DataGroupingDefaults.js"], S["Extensions/DataGrouping/DataGroupingSeriesComposition.js"], S["Core/FormatUtilities.js"], S["Core/Utilities.js"]], function (D, E, B, H, X) {
      function W(p) {
        var h = this.chart,
          s = h.time,
          l = p.labelConfig,
          u = l.series,
          v = u.tooltipOptions,
          M = u.options.dataGrouping,
          I = u.xAxis,
          L = v.xDateFormat,
          C = v[p.isFooter ? "footerFormat" : "headerFormat"];
        if (I && I.options.type === "datetime" && M && k(l.key)) {
          var m = u.currentDataGrouping;
          if (M = M.dateTimeLabelFormats || E.common.dateTimeLabelFormats, m) {
            if (v = M[m.unitName], m.count === 1) L = v[0];else {
              L = v[1];
              var d = v[2];
            }
          } else !L && M && I.dateTime && (L = I.dateTime.getXDateFormat(l.x, v.dateTimeLabelFormats));
          L = s.dateFormat(L, l.key), d && (L += s.dateFormat(d, l.key + m.totalRange - 1)), u.chart.styledMode && (C = this.styledModeFormat(C)), p.text = z(C, {
            point: A(l.point, {
              key: L
            }),
            series: u
          }, h), p.preventDefault();
        }
      }
      var z = H.format,
        w = X.addEvent,
        A = X.extend,
        k = X.isNumber,
        g = [];
      return H = {
        compose: function compose(p, h, s) {
          D.compose(p), B.compose(h), g.indexOf(s) === -1 && (g.push(s), w(s, "headerFormatter", W));
        },
        groupData: B.groupData
      }, H;
    }), V(S, "masters/modules/datagrouping.src.js", [S["Core/Globals.js"], S["Extensions/DataGrouping/ApproximationDefaults.js"], S["Extensions/DataGrouping/ApproximationRegistry.js"], S["Extensions/DataGrouping/DataGrouping.js"]], function (D, E, B, H) {
      D.dataGrouping = {
        approximationDefaults: E,
        approximations: B
      }, H.compose(D.Axis, D.Series, D.Tooltip);
    }), V(S, "Series/DataModifyComposition.js", [S["Core/Axis/Axis.js"], S["Core/Series/Point.js"], S["Core/Series/Series.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = E.prototype.tooltipFormatter,
        W = H.addEvent,
        z = H.arrayMax,
        w = H.arrayMin,
        A = H.correctFloat,
        k = H.defined,
        g = H.isArray,
        p = H.isNumber,
        h = H.isString,
        s = H.pick,
        l;
      return function (u) {
        function v(t, e, a) {
          this.isXAxis || (this.series.forEach(function (c) {
            t === "compare" && typeof e != "boolean" ? c.setCompare(e, !1) : t !== "cumulative" || h(e) || c.setCumulative(e, !1);
          }), s(a, !0) && this.chart.redraw());
        }
        function M(t) {
          var e = this,
            a = e.series.chart.numberFormatter,
            c = function c(y) {
              t = t.replace("{point." + y + "}", (0 < e[y] && y === "change" ? "+" : "") + a(e[y], s(e.series.tooltipOptions.changeDecimals, 2)));
            };
          return k(e.change) && c("change"), k(e.cumulativeSum) && c("cumulativeSum"), X.apply(this, [t]);
        }
        function I() {
          var t = this.options.compare;
          if (t === "percent" || t === "value" || this.options.cumulative) {
            var e = new i(this);
            t === "percent" || t === "value" ? e.initCompare(t) : e.initCumulative();
          }
          this.dataModify = e;
        }
        function L(t) {
          t = t.dataExtremes;
          var e = t.activeYData;
          if (this.dataModify && t) {
            var a = void 0;
            this.options.compare ? a = [this.dataModify.modifyValue(t.dataMin), this.dataModify.modifyValue(t.dataMax)] : this.options.cumulative && g(e) && 2 <= e.length && (a = i.getCumulativeExtremes(e)), a && (t.dataMin = w(a), t.dataMax = z(a));
          }
        }
        function C(t, e) {
          this.options.compare = this.userOptions.compare = t, this.update({}, s(e, !0)), !this.dataModify || t !== "value" && t !== "percent" ? this.points.forEach(function (a) {
            delete a.change;
          }) : this.dataModify.initCompare(t);
        }
        function m() {
          if (this.xAxis && this.processedYData && this.dataModify) {
            var t = this.processedXData,
              e = this.processedYData,
              a = e.length,
              c = this.options.compareStart === !0 ? 0 : 1,
              y = -1,
              b;
            for (this.pointArrayMap && (y = this.pointArrayMap.indexOf(this.options.pointValKey || this.pointValKey || "y")), b = 0; b < a - c; b++) {
              var j = e[b] && -1 < y ? e[b][y] : e[b];
              if (p(j) && j !== 0 && t[b + c] >= (this.xAxis.min || 0)) {
                this.dataModify.compareValue = j;
                break;
              }
            }
          }
        }
        function d(t, e) {
          this.setModifier("compare", t, e);
        }
        function o(t, e) {
          t = s(t, !1), this.options.cumulative = this.userOptions.cumulative = t, this.update({}, s(e, !0)), this.dataModify ? this.dataModify.initCumulative() : this.points.forEach(function (a) {
            delete a.cumulativeSum;
          });
        }
        function n(t, e) {
          this.setModifier("cumulative", t, e);
        }
        var r = [];
        u.compose = function (t, e, a) {
          if (r.indexOf(t) === -1) {
            r.push(t);
            var c = t.prototype;
            c.setCompare = C, c.setCumulative = o, W(t, "afterInit", I), W(t, "afterGetExtremes", L), W(t, "afterProcessData", m);
          }
          return r.indexOf(e) === -1 && (r.push(e), e = e.prototype, e.setCompare = d, e.setModifier = v, e.setCumulative = n), r.indexOf(a) === -1 && (r.push(a), a.prototype.tooltipFormatter = M), t;
        };
        var i = function () {
          function t(e) {
            this.series = e;
          }
          return t.prototype.modifyValue = function () {
            return 0;
          }, t.getCumulativeExtremes = function (e) {
            var a = 1 / 0,
              c = -1 / 0;
            return e.reduce(function (y, b) {
              return b = y + b, a = Math.min(a, b, y), c = Math.max(c, b, y), b;
            }), [a, c];
          }, t.prototype.initCompare = function (e) {
            this.modifyValue = function (a, c) {
              a === null && (a = 0);
              var y = this.compareValue;
              return typeof a < "u" && typeof y < "u" ? (a = e === "value" ? a - y : a / y * 100 - (this.series.options.compareBase === 100 ? 0 : 100), typeof c < "u" && (c = this.series.points[c]) && (c.change = a), a) : 0;
            };
          }, t.prototype.initCumulative = function () {
            this.modifyValue = function (e, a) {
              if (e === null && (e = 0), e !== void 0 && a !== void 0) {
                var c = 0 < a ? this.series.points[a - 1] : null;
                return c && c.cumulativeSum && (e = A(c.cumulativeSum + e)), (a = this.series.points[a]) && (a.cumulativeSum = e), e;
              }
              return 0;
            };
          }, t;
        }();
        u.Additions = i;
      }(l || (l = {})), l;
    }), V(S, "Core/Axis/NavigatorAxisComposition.js", [S["Core/Globals.js"], S["Core/Utilities.js"]], function (D, E) {
      function B() {
        this.navigatorAxis || (this.navigatorAxis = new p(this));
      }
      function H(h) {
        var s = this.chart.options,
          l = s.navigator,
          u = this.navigatorAxis,
          v = s.chart.zooming.pinchType,
          M = s.rangeSelector;
        s = s.chart.zooming.type, this.isXAxis && (l && l.enabled || M && M.enabled) && (s === "y" ? h.zoomed = !1 : (!X && s === "xy" || X && v === "xy") && this.options.range && (l = u.previousZoom, w(h.newMin) ? u.previousZoom = [this.min, this.max] : l && (h.newMin = l[0], h.newMax = l[1], u.previousZoom = void 0))), typeof h.zoomed < "u" && h.preventDefault();
      }
      var X = D.isTouchDevice,
        W = E.addEvent,
        z = E.correctFloat,
        w = E.defined,
        A = E.isNumber,
        k = E.pick,
        g = [],
        p = function () {
          function h(s) {
            this.axis = s;
          }
          return h.compose = function (s) {
            g.indexOf(s) === -1 && (g.push(s), s.keepProps.push("navigatorAxis"), W(s, "init", B), W(s, "zoom", H));
          }, h.prototype.destroy = function () {
            this.axis = void 0;
          }, h.prototype.toFixedRange = function (s, l, u, v) {
            var M = this.axis,
              I = M.chart;
            s = k(u, M.translate(s, !0, !M.horiz)), l = k(v, M.translate(l, !0, !M.horiz)), I = I && I.fixedRange, M = (M.pointRange || 0) / 2;
            var L = I && (l - s) / I;
            return w(u) || (s = z(s + M)), w(v) || (l = z(l - M)), 0.7 < L && 1.3 > L && (v ? s = l - I : l = s + I), A(s) && A(l) || (s = l = void 0), {
              min: s,
              max: l
            };
          }, h;
        }();
      return p;
    }), V(S, "Stock/Navigator/NavigatorDefaults.js", [S["Core/Color/Color.js"], S["Core/Series/SeriesRegistry.js"]], function (D, E) {
      return D = D.parse, E = E.seriesTypes, E = {
        height: 40,
        margin: 25,
        maskInside: !0,
        handles: {
          width: 7,
          height: 15,
          symbols: ["navigator-handle", "navigator-handle"],
          enabled: !0,
          lineWidth: 1,
          backgroundColor: "#f2f2f2",
          borderColor: "#999999"
        },
        maskFill: D("#6685c2").setOpacity(0.3).get(),
        outlineColor: "#cccccc",
        outlineWidth: 1,
        series: {
          type: typeof E.areaspline > "u" ? "line" : "areaspline",
          fillOpacity: 0.05,
          lineWidth: 1,
          compare: null,
          dataGrouping: {
            approximation: "average",
            enabled: !0,
            groupPixelWidth: 2,
            firstAnchor: "firstPoint",
            anchor: "middle",
            lastAnchor: "lastPoint",
            units: [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2, 3, 4]], ["week", [1, 2, 3]], ["month", [1, 3, 6]], ["year", null]]
          },
          dataLabels: {
            enabled: !1,
            zIndex: 2
          },
          id: "highcharts-navigator-series",
          className: "highcharts-navigator-series",
          lineColor: null,
          marker: {
            enabled: !1
          },
          threshold: null
        },
        xAxis: {
          overscroll: 0,
          className: "highcharts-navigator-xaxis",
          tickLength: 0,
          lineWidth: 0,
          gridLineColor: "#e6e6e6",
          gridLineWidth: 1,
          tickPixelInterval: 200,
          labels: {
            align: "left",
            style: {
              color: "#999999"
            },
            x: 3,
            y: -4
          },
          crosshair: !1
        },
        yAxis: {
          className: "highcharts-navigator-yaxis",
          gridLineWidth: 0,
          startOnTick: !1,
          endOnTick: !1,
          minPadding: 0.1,
          maxPadding: 0.1,
          labels: {
            enabled: !1
          },
          crosshair: !1,
          title: {
            text: null
          },
          tickLength: 0,
          tickWidth: 0
        }
      }, E;
    }), V(S, "Stock/Navigator/NavigatorSymbols.js", [], function () {
      return {
        "navigator-handle": function navigatorHandle(D, E, B, H, X) {
          return X === void 0 && (X = {}), D = X.width ? X.width / 2 : B, E = Math.round(D / 3) + 0.5, H = X.height || H, [["M", -D - 1, 0.5], ["L", D, 0.5], ["L", D, H + 0.5], ["L", -D - 1, H + 0.5], ["L", -D - 1, 0.5], ["M", -E, 4], ["L", -E, H - 3], ["M", E - 1, 4], ["L", E - 1, H - 3]];
        }
      };
    }), V(S, "Stock/Navigator/NavigatorComposition.js", [S["Core/Defaults.js"], S["Core/Globals.js"], S["Core/Axis/NavigatorAxisComposition.js"], S["Stock/Navigator/NavigatorDefaults.js"], S["Stock/Navigator/NavigatorSymbols.js"], S["Core/Renderer/RendererRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z) {
      function w() {
        this.navigator && this.navigator.setBaseSeries(null, !1);
      }
      function A() {
        var r = this.legend,
          i = this.navigator;
        if (i) {
          var t = r && r.options,
            e = i.xAxis,
            a = i.yAxis,
            c = i.scrollbarHeight;
          this.inverted ? (i.left = i.opposite ? this.chartWidth - c - i.height : this.spacing[3] + c, i.top = this.plotTop + c) : (i.left = d(e.left, this.plotLeft + c), i.top = i.navigatorOptions.top || this.chartHeight - i.height - c - this.spacing[2] - (this.rangeSelector && this.extraBottomMargin ? this.rangeSelector.getHeight() : 0) - (t && t.verticalAlign === "bottom" && t.layout !== "proximate" && t.enabled && !t.floating ? r.legendHeight + d(t.margin, 10) : 0) - (this.titleOffset ? this.titleOffset[2] : 0)), e && a && (this.inverted ? e.options.left = a.options.left = i.left : e.options.top = a.options.top = i.top, e.setAxisSize(), a.setAxisSize());
        }
      }
      function k(r) {
        this.navigator || this.scroller || !this.options.navigator.enabled && !this.options.scrollbar.enabled || (this.scroller = this.navigator = new n(this), d(r.redraw, !0) && this.redraw(r.animation));
      }
      function g() {
        var r = this.options;
        (r.navigator.enabled || r.scrollbar.enabled) && (this.scroller = this.navigator = new n(this));
      }
      function p() {
        var r = this.options,
          i = r.navigator,
          t = r.rangeSelector;
        if ((i && i.enabled || t && t.enabled) && (!M && r.chart.zooming.type === "x" || M && r.chart.zooming.pinchType === "x")) return !1;
      }
      function h(r) {
        var i = r.navigator;
        i && r.xAxis[0] && (r = r.xAxis[0].getExtremes(), i.render(r.min, r.max));
      }
      function s(r) {
        var i = r.options.navigator || {},
          t = r.options.scrollbar || {};
        this.navigator || this.scroller || !i.enabled && !t.enabled || (m(!0, this.options.navigator, i), m(!0, this.options.scrollbar, t), delete r.options.navigator, delete r.options.scrollbar);
      }
      function l() {
        this.chart.navigator && !this.options.isInternal && this.chart.navigator.setBaseSeries(null, !1);
      }
      var u = D.defaultOptions,
        v = D.setOptions,
        M = E.isTouchDevice,
        I = W.getRendererType,
        L = z.addEvent,
        C = z.extend,
        m = z.merge,
        d = z.pick,
        o = [],
        n;
      return {
        compose: function compose(r, i, t, e) {
          B.compose(r), n = t, o.indexOf(i) === -1 && (o.push(i), i.prototype.callbacks.push(h), L(i, "afterAddSeries", w), L(i, "afterSetChartSize", A), L(i, "afterUpdate", k), L(i, "beforeRender", g), L(i, "beforeShowResetZoom", p), L(i, "update", s)), o.indexOf(e) === -1 && (o.push(e), L(e, "afterUpdate", l)), o.indexOf(I) === -1 && (o.push(I), C(I().prototype.symbols, X)), o.indexOf(v) === -1 && (o.push(v), C(u, {
            navigator: H
          }));
        }
      };
    }), V(S, "Core/Axis/ScrollbarAxis.js", [S["Core/Utilities.js"]], function (D) {
      var E = D.addEvent,
        B = D.defined,
        H = D.pick;
      return function () {
        function X() {}
        return X.compose = function (W, z) {
          if (X.composed.indexOf(W) === -1) X.composed.push(W);else return W;
          var w = function w(A) {
            var k = H(A.options && A.options.min, A.min),
              g = H(A.options && A.options.max, A.max);
            return {
              axisMin: k,
              axisMax: g,
              scrollMin: B(A.dataMin) ? Math.min(k, A.min, A.dataMin, H(A.threshold, 1 / 0)) : k,
              scrollMax: B(A.dataMax) ? Math.max(g, A.max, A.dataMax, H(A.threshold, -1 / 0)) : g
            };
          };
          return E(W, "afterInit", function () {
            var A = this;
            A.options && A.options.scrollbar && A.options.scrollbar.enabled && (A.options.scrollbar.vertical = !A.horiz, A.options.startOnTick = A.options.endOnTick = !1, A.scrollbar = new z(A.chart.renderer, A.options.scrollbar, A.chart), E(A.scrollbar, "changed", function (k) {
              var g = w(A),
                p = g.axisMax,
                h = g.scrollMin,
                s = g.scrollMax - h;
              B(g.axisMin) && B(p) && (A.horiz && !A.reversed || !A.horiz && A.reversed ? (g = h + s * this.to, h += s * this.from) : (g = h + s * (1 - this.from), h += s * (1 - this.to)), this.shouldUpdateExtremes(k.DOMType) ? A.setExtremes(h, g, !0, k.DOMType !== "mousemove" && k.DOMType !== "touchmove", k) : this.setRange(this.from, this.to));
            }));
          }), E(W, "afterRender", function () {
            var A = w(this),
              k = A.scrollMin,
              g = A.scrollMax;
            A = this.scrollbar;
            var p = this.axisTitleMargin + (this.titleOffset || 0),
              h = this.chart.scrollbarsOffsets,
              s = this.options.margin || 0;
            A && (this.horiz ? (this.opposite || (h[1] += p), A.position(this.left, this.top + this.height + 2 + h[1] - (this.opposite ? s : 0), this.width, this.height), this.opposite || (h[1] += s), p = 1) : (this.opposite && (h[0] += p), A.position(A.options.opposite ? this.left + this.width + 2 + h[0] - (this.opposite ? 0 : s) : this.opposite ? 0 : s, this.top, this.width, this.height), this.opposite && (h[0] += s), p = 0), h[p] += A.size + A.options.margin, isNaN(k) || isNaN(g) || !B(this.min) || !B(this.max) || this.min === this.max ? A.setRange(0, 1) : (h = (this.min - k) / (g - k), k = (this.max - k) / (g - k), this.horiz && !this.reversed || !this.horiz && this.reversed ? A.setRange(h, k) : A.setRange(1 - k, 1 - h)));
          }), E(W, "afterGetOffset", function () {
            var A = this.scrollbar && !this.scrollbar.options.opposite;
            A = this.horiz ? 2 : A ? 3 : 1;
            var k = this.scrollbar;
            k && (this.chart.scrollbarsOffsets = [0, 0], this.chart.axisOffset[A] += k.size + k.options.margin);
          }), W;
        }, X.composed = [], X;
      }();
    }), V(S, "Stock/Scrollbar/ScrollbarDefaults.js", [S["Core/Globals.js"]], function (D) {
      return {
        height: D.isTouchDevice ? 20 : 14,
        barBorderRadius: 0,
        buttonBorderRadius: 0,
        liveRedraw: void 0,
        margin: 10,
        minWidth: 6,
        opposite: !0,
        step: 0.2,
        zIndex: 3,
        barBackgroundColor: "#cccccc",
        barBorderWidth: 1,
        barBorderColor: "#cccccc",
        buttonArrowColor: "#333333",
        buttonBackgroundColor: "#e6e6e6",
        buttonBorderColor: "#cccccc",
        buttonBorderWidth: 1,
        rifleColor: "#333333",
        trackBackgroundColor: "#f2f2f2",
        trackBorderColor: "#f2f2f2",
        trackBorderWidth: 1
      };
    }), V(S, "Stock/Scrollbar/Scrollbar.js", [S["Core/Defaults.js"], S["Core/Globals.js"], S["Core/Axis/ScrollbarAxis.js"], S["Stock/Scrollbar/ScrollbarDefaults.js"], S["Core/Utilities.js"]], function (D, E, B, H, X) {
      var W = D.defaultOptions,
        z = X.addEvent,
        w = X.correctFloat,
        A = X.defined,
        k = X.destroyObjectProperties,
        g = X.fireEvent,
        p = X.merge,
        h = X.pick,
        s = X.removeEvent;
      return D = function () {
        function l(u, v, M) {
          this._events = [], this.chart = void 0, this.from = this.chartY = this.chartX = 0, this.scrollbar = this.renderer = this.options = this.group = void 0, this.scrollbarButtons = [], this.scrollbarGroup = void 0, this.scrollbarLeft = 0, this.scrollbarRifles = void 0, this.scrollbarStrokeWidth = 1, this.to = this.size = this.scrollbarTop = 0, this.track = void 0, this.trackBorderWidth = 1, this.userOptions = void 0, this.y = this.x = 0, this.init(u, v, M);
        }
        return l.compose = function (u) {
          B.compose(u, l);
        }, l.swapXY = function (u, v) {
          return v && u.forEach(function (M) {
            for (var I = M.length, L, C = 0; C < I; C += 2) L = M[C + 1], typeof L == "number" && (M[C + 1] = M[C + 2], M[C + 2] = L);
          }), u;
        }, l.prototype.addEvents = function () {
          var u = this.options.inverted ? [1, 0] : [0, 1],
            v = this.scrollbarButtons,
            M = this.scrollbarGroup.element,
            I = this.track.element,
            L = this.mouseDownHandler.bind(this),
            C = this.mouseMoveHandler.bind(this),
            m = this.mouseUpHandler.bind(this);
          u = [[v[u[0]].element, "click", this.buttonToMinClick.bind(this)], [v[u[1]].element, "click", this.buttonToMaxClick.bind(this)], [I, "click", this.trackClick.bind(this)], [M, "mousedown", L], [M.ownerDocument, "mousemove", C], [M.ownerDocument, "mouseup", m]], E.hasTouch && u.push([M, "touchstart", L], [M.ownerDocument, "touchmove", C], [M.ownerDocument, "touchend", m]), u.forEach(function (d) {
            z.apply(null, d);
          }), this._events = u;
        }, l.prototype.buttonToMaxClick = function (u) {
          var v = (this.to - this.from) * h(this.options.step, 0.2);
          this.updatePosition(this.from + v, this.to + v), g(this, "changed", {
            from: this.from,
            to: this.to,
            trigger: "scrollbar",
            DOMEvent: u
          });
        }, l.prototype.buttonToMinClick = function (u) {
          var v = w(this.to - this.from) * h(this.options.step, 0.2);
          this.updatePosition(w(this.from - v), w(this.to - v)), g(this, "changed", {
            from: this.from,
            to: this.to,
            trigger: "scrollbar",
            DOMEvent: u
          });
        }, l.prototype.cursorToScrollbarPosition = function (u) {
          var v = this.options;
          return v = v.minWidth > this.calculatedWidth ? v.minWidth : 0, {
            chartX: (u.chartX - this.x - this.xOffset) / (this.barWidth - v),
            chartY: (u.chartY - this.y - this.yOffset) / (this.barWidth - v)
          };
        }, l.prototype.destroy = function () {
          var u = this,
            v = u.chart.scroller;
          u.removeEvents(), ["track", "scrollbarRifles", "scrollbar", "scrollbarGroup", "group"].forEach(function (M) {
            u[M] && u[M].destroy && (u[M] = u[M].destroy());
          }), v && u === v.scrollbar && (v.scrollbar = null, k(v.scrollbarButtons));
        }, l.prototype.drawScrollbarButton = function (u) {
          var v = this.renderer,
            M = this.scrollbarButtons,
            I = this.options,
            L = this.size,
            C = v.g().add(this.group);
          M.push(C), C = v.rect().addClass("highcharts-scrollbar-button").add(C), this.chart.styledMode || C.attr({
            stroke: I.buttonBorderColor,
            "stroke-width": I.buttonBorderWidth,
            fill: I.buttonBackgroundColor
          }), C.attr(C.crisp({
            x: -0.5,
            y: -0.5,
            width: L + 1,
            height: L + 1,
            r: I.buttonBorderRadius
          }, C.strokeWidth())), C = v.path(l.swapXY([["M", L / 2 + (u ? -1 : 1), L / 2 - 3], ["L", L / 2 + (u ? -1 : 1), L / 2 + 3], ["L", L / 2 + (u ? 2 : -2), L / 2]], I.vertical)).addClass("highcharts-scrollbar-arrow").add(M[u]), this.chart.styledMode || C.attr({
            fill: I.buttonArrowColor
          });
        }, l.prototype.init = function (u, v, M) {
          this.scrollbarButtons = [], this.renderer = u, this.userOptions = v, this.options = p(H, W.scrollbar, v), this.chart = M, this.size = h(this.options.size, this.options.height), v.enabled && (this.render(), this.addEvents());
        }, l.prototype.mouseDownHandler = function (u) {
          u = this.chart.pointer.normalize(u), u = this.cursorToScrollbarPosition(u), this.chartX = u.chartX, this.chartY = u.chartY, this.initPositions = [this.from, this.to], this.grabbedCenter = !0;
        }, l.prototype.mouseMoveHandler = function (u) {
          var v = this.chart.pointer.normalize(u),
            M = this.options.vertical ? "chartY" : "chartX",
            I = this.initPositions || [];
          !this.grabbedCenter || u.touches && u.touches[0][M] === 0 || (v = this.cursorToScrollbarPosition(v)[M], M = this[M], M = v - M, this.hasDragged = !0, this.updatePosition(I[0] + M, I[1] + M), this.hasDragged && g(this, "changed", {
            from: this.from,
            to: this.to,
            trigger: "scrollbar",
            DOMType: u.type,
            DOMEvent: u
          }));
        }, l.prototype.mouseUpHandler = function (u) {
          this.hasDragged && g(this, "changed", {
            from: this.from,
            to: this.to,
            trigger: "scrollbar",
            DOMType: u.type,
            DOMEvent: u
          }), this.grabbedCenter = this.hasDragged = this.chartX = this.chartY = null;
        }, l.prototype.position = function (u, v, M, I) {
          var L = this.options.vertical,
            C = this.rendered ? "animate" : "attr",
            m = I,
            d = 0;
          this.group.show(), this.x = u, this.y = v + this.trackBorderWidth, this.width = M, this.height = I, this.xOffset = m, this.yOffset = d, L ? (this.width = this.yOffset = M = d = this.size, this.xOffset = m = 0, this.barWidth = I - 2 * M, this.x = u += this.options.margin) : (this.height = this.xOffset = I = m = this.size, this.barWidth = M - 2 * I, this.y += this.options.margin), this.group[C]({
            translateX: u,
            translateY: this.y
          }), this.track[C]({
            width: M,
            height: I
          }), this.scrollbarButtons[1][C]({
            translateX: L ? 0 : M - m,
            translateY: L ? I - d : 0
          });
        }, l.prototype.removeEvents = function () {
          this._events.forEach(function (u) {
            s.apply(null, u);
          }), this._events.length = 0;
        }, l.prototype.render = function () {
          var u = this.renderer,
            v = this.options,
            M = this.size,
            I = this.chart.styledMode,
            L = u.g("scrollbar").attr({
              zIndex: v.zIndex
            }).hide().add();
          this.group = L, this.track = u.rect().addClass("highcharts-scrollbar-track").attr({
            x: 0,
            r: v.trackBorderRadius || 0,
            height: M,
            width: M
          }).add(L), I || this.track.attr({
            fill: v.trackBackgroundColor,
            stroke: v.trackBorderColor,
            "stroke-width": v.trackBorderWidth
          }), this.trackBorderWidth = this.track.strokeWidth(), this.track.attr({
            y: -this.trackBorderWidth % 2 / 2
          }), this.scrollbarGroup = u.g().add(L), this.scrollbar = u.rect().addClass("highcharts-scrollbar-thumb").attr({
            height: M,
            width: M,
            r: v.barBorderRadius || 0
          }).add(this.scrollbarGroup), this.scrollbarRifles = u.path(l.swapXY([["M", -3, M / 4], ["L", -3, 2 * M / 3], ["M", 0, M / 4], ["L", 0, 2 * M / 3], ["M", 3, M / 4], ["L", 3, 2 * M / 3]], v.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup), I || (this.scrollbar.attr({
            fill: v.barBackgroundColor,
            stroke: v.barBorderColor,
            "stroke-width": v.barBorderWidth
          }), this.scrollbarRifles.attr({
            stroke: v.rifleColor,
            "stroke-width": 1
          })), this.scrollbarStrokeWidth = this.scrollbar.strokeWidth(), this.scrollbarGroup.translate(-this.scrollbarStrokeWidth % 2 / 2, -this.scrollbarStrokeWidth % 2 / 2), this.drawScrollbarButton(0), this.drawScrollbarButton(1);
        }, l.prototype.setRange = function (u, v) {
          var M = this.options,
            I = M.vertical,
            L = M.minWidth,
            C = this.barWidth,
            m = !this.rendered || this.hasDragged || this.chart.navigator && this.chart.navigator.hasDragged ? "attr" : "animate";
          if (A(C)) {
            var d = C * Math.min(v, 1);
            u = Math.max(u, 0);
            var o = Math.ceil(C * u);
            this.calculatedWidth = d = w(d - o), d < L && (o = (C - L + d) * u, d = L), L = Math.floor(o + this.xOffset + this.yOffset), C = d / 2 - 0.5, this.from = u, this.to = v, I ? (this.scrollbarGroup[m]({
              translateY: L
            }), this.scrollbar[m]({
              height: d
            }), this.scrollbarRifles[m]({
              translateY: C
            }), this.scrollbarTop = L, this.scrollbarLeft = 0) : (this.scrollbarGroup[m]({
              translateX: L
            }), this.scrollbar[m]({
              width: d
            }), this.scrollbarRifles[m]({
              translateX: C
            }), this.scrollbarLeft = L, this.scrollbarTop = 0), 12 >= d ? this.scrollbarRifles.hide() : this.scrollbarRifles.show(), M.showFull === !1 && (0 >= u && 1 <= v ? this.group.hide() : this.group.show()), this.rendered = !0;
          }
        }, l.prototype.shouldUpdateExtremes = function (u) {
          return h(this.options.liveRedraw, E.svg && !E.isTouchDevice && !this.chart.boosted) || u === "mouseup" || u === "touchend" || !A(u);
        }, l.prototype.trackClick = function (u) {
          var v = this.chart.pointer.normalize(u),
            M = this.to - this.from,
            I = this.y + this.scrollbarTop,
            L = this.x + this.scrollbarLeft;
          this.options.vertical && v.chartY > I || !this.options.vertical && v.chartX > L ? this.updatePosition(this.from + M, this.to + M) : this.updatePosition(this.from - M, this.to - M), g(this, "changed", {
            from: this.from,
            to: this.to,
            trigger: "scrollbar",
            DOMEvent: u
          });
        }, l.prototype.update = function (u) {
          this.destroy(), this.init(this.chart.renderer, p(!0, this.options, u), this.chart);
        }, l.prototype.updatePosition = function (u, v) {
          1 < v && (u = w(1 - w(v - u)), v = 1), 0 > u && (v = w(v - u), u = 0), this.from = u, this.to = v;
        }, l.defaultOptions = H, l;
      }(), W.scrollbar = p(!0, D.defaultOptions, W.scrollbar), D;
    }), V(S, "Stock/Navigator/Navigator.js", [S["Core/Axis/Axis.js"], S["Core/Defaults.js"], S["Core/Globals.js"], S["Core/Axis/NavigatorAxisComposition.js"], S["Stock/Navigator/NavigatorComposition.js"], S["Stock/Scrollbar/Scrollbar.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z) {
      function w(r) {
        for (var i = [], t = 1; t < arguments.length; t++) i[t - 1] = arguments[t];
        if (i = [].filter.call(i, C), i.length) return Math[r].apply(0, i);
      }
      var A = E.defaultOptions,
        k = B.hasTouch,
        g = B.isTouchDevice,
        p = z.addEvent,
        h = z.clamp,
        s = z.correctFloat,
        l = z.defined,
        u = z.destroyObjectProperties,
        v = z.erase,
        M = z.extend,
        I = z.find,
        L = z.isArray,
        C = z.isNumber,
        m = z.merge,
        d = z.pick,
        o = z.removeEvent,
        n = z.splat;
      return function () {
        function r(i) {
          this.zoomedMin = this.zoomedMax = this.yAxis = this.xAxis = this.top = this.size = this.shades = this.rendered = this.range = this.outlineHeight = this.outline = this.opposite = this.navigatorSize = this.navigatorSeries = this.navigatorOptions = this.navigatorGroup = this.navigatorEnabled = this.left = this.height = this.handles = this.chart = this.baseSeries = void 0, this.init(i);
        }
        return r.compose = function (i, t, e) {
          X.compose(i, t, r, e);
        }, r.prototype.drawHandle = function (i, t, e, a) {
          var c = this.navigatorOptions.handles.height;
          this.handles[t][a](e ? {
            translateX: Math.round(this.left + this.height / 2),
            translateY: Math.round(this.top + parseInt(i, 10) + 0.5 - c)
          } : {
            translateX: Math.round(this.left + parseInt(i, 10)),
            translateY: Math.round(this.top + this.height / 2 - c / 2 - 1)
          });
        }, r.prototype.drawOutline = function (i, t, e, a) {
          var c = this.navigatorOptions.maskInside,
            y = this.outline.strokeWidth(),
            b = y / 2,
            j = y % 2 / 2;
          y = this.outlineHeight;
          var P = this.scrollbarHeight || 0,
            f = this.size,
            x = this.left - P,
            N = this.top;
          e ? (x -= b, e = N + t + j, t = N + i + j, j = [["M", x + y, N - P - j], ["L", x + y, e], ["L", x, e], ["L", x, t], ["L", x + y, t], ["L", x + y, N + f + P]], c && j.push(["M", x + y, e - b], ["L", x + y, t + b])) : (i += x + P - j, t += x + P - j, N += b, j = [["M", x, N], ["L", i, N], ["L", i, N + y], ["L", t, N + y], ["L", t, N], ["L", x + f + 2 * P, N]], c && j.push(["M", i - b, N], ["L", t + b, N])), this.outline[a]({
            d: j
          });
        }, r.prototype.drawMasks = function (i, t, e, a) {
          var c = this.left,
            y = this.top,
            b = this.height;
          if (e) var j = [c, c, c],
            P = [y, y + i, y + t],
            f = [b, b, b],
            x = [i, t - i, this.size - t];else j = [c, c + i, c + t], P = [y, y, y], f = [i, t - i, this.size - t], x = [b, b, b];
          this.shades.forEach(function (N, R) {
            N[a]({
              x: j[R],
              y: P[R],
              width: f[R],
              height: x[R]
            });
          });
        }, r.prototype.renderElements = function () {
          var i = this,
            t = i.navigatorOptions,
            e = t.maskInside,
            a = i.chart,
            c = a.renderer,
            y = {
              cursor: a.inverted ? "ns-resize" : "ew-resize"
            },
            b = i.navigatorGroup = c.g("navigator").attr({
              zIndex: 8,
              visibility: "hidden"
            }).add();
          if ([!e, e, !e].forEach(function (x, N) {
            var R = c.rect().addClass("highcharts-navigator-mask" + (N === 1 ? "-inside" : "-outside")).add(b);
            a.styledMode || (R.attr({
              fill: x ? t.maskFill : "rgba(0,0,0,0)"
            }), N === 1 && R.css(y)), i.shades[N] = R;
          }), i.outline = c.path().addClass("highcharts-navigator-outline").add(b), a.styledMode || i.outline.attr({
            "stroke-width": t.outlineWidth,
            stroke: t.outlineColor
          }), t.handles && t.handles.enabled) {
            var j = t.handles,
              P = j.height,
              f = j.width;
            [0, 1].forEach(function (x) {
              i.handles[x] = c.symbol(j.symbols[x], -f / 2 - 1, 0, f, P, j), a.inverted && i.handles[x].attr({
                rotation: 90,
                rotationOriginX: Math.floor(-f / 2),
                rotationOriginY: (P + f) / 2
              }), i.handles[x].attr({
                zIndex: 7 - x
              }).addClass("highcharts-navigator-handle highcharts-navigator-handle-" + ["left", "right"][x]).add(b), a.styledMode || i.handles[x].attr({
                fill: j.backgroundColor,
                stroke: j.borderColor,
                "stroke-width": j.lineWidth
              }).css(y);
            });
          }
        }, r.prototype.update = function (i) {
          (this.series || []).forEach(function (t) {
            t.baseSeries && delete t.baseSeries.navigatorSeries;
          }), this.destroy(), m(!0, this.chart.options.navigator, i), this.init(this.chart);
        }, r.prototype.render = function (i, t, e, a) {
          var c = this.chart,
            y = this.xAxis,
            b = y.pointRange || 0,
            j = y.navigatorAxis.fake ? c.xAxis[0] : y,
            P = this.navigatorEnabled,
            f = this.rendered,
            x = c.inverted,
            N = c.xAxis[0].minRange,
            R = c.xAxis[0].options.maxRange,
            F = this.scrollbarHeight,
            T;
          if (!this.hasDragged || l(e)) {
            if (i = s(i - b / 2), t = s(t + b / 2), !C(i) || !C(t)) if (f) e = 0, a = d(y.width, j.width);else return;
            this.left = d(y.left, c.plotLeft + F + (x ? c.plotWidth : 0));
            var G = this.size = T = d(y.len, (x ? c.plotHeight : c.plotWidth) - 2 * F);
            c = x ? F : T + 2 * F, e = d(e, y.toPixels(i, !0)), a = d(a, y.toPixels(t, !0)), C(e) && Math.abs(e) !== 1 / 0 || (e = 0, a = c), i = y.toValue(e, !0), t = y.toValue(a, !0);
            var _ = Math.abs(s(t - i));
            _ < N ? this.grabbedLeft ? e = y.toPixels(t - N - b, !0) : this.grabbedRight && (a = y.toPixels(i + N + b, !0)) : l(R) && s(_ - b) > R && (this.grabbedLeft ? e = y.toPixels(t - R - b, !0) : this.grabbedRight && (a = y.toPixels(i + R + b, !0))), this.zoomedMax = h(Math.max(e, a), 0, G), this.zoomedMin = h(this.fixedWidth ? this.zoomedMax - this.fixedWidth : Math.min(e, a), 0, G), this.range = this.zoomedMax - this.zoomedMin, G = Math.round(this.zoomedMax), e = Math.round(this.zoomedMin), P && (this.navigatorGroup.attr({
              visibility: "inherit"
            }), f = f && !this.hasDragged ? "animate" : "attr", this.drawMasks(e, G, x, f), this.drawOutline(e, G, x, f), this.navigatorOptions.handles.enabled && (this.drawHandle(e, 0, x, f), this.drawHandle(G, 1, x, f))), this.scrollbar && (x ? (x = this.top - F, j = this.left - F + (P || !j.opposite ? 0 : (j.titleOffset || 0) + j.axisTitleMargin), F = T + 2 * F) : (x = this.top + (P ? this.height : -F), j = this.left - F), this.scrollbar.position(j, x, c, F), this.scrollbar.setRange(this.zoomedMin / (T || 1), this.zoomedMax / (T || 1))), this.rendered = !0;
          }
        }, r.prototype.addMouseEvents = function () {
          var i = this,
            t = i.chart,
            e = t.container,
            a = [],
            c,
            y;
          i.mouseMoveHandler = c = function c(b) {
            i.onMouseMove(b);
          }, i.mouseUpHandler = y = function y(b) {
            i.onMouseUp(b);
          }, a = i.getPartsEvents("mousedown"), a.push(p(t.renderTo, "mousemove", c), p(e.ownerDocument, "mouseup", y)), k && (a.push(p(t.renderTo, "touchmove", c), p(e.ownerDocument, "touchend", y)), a.concat(i.getPartsEvents("touchstart"))), i.eventsToUnbind = a, i.series && i.series[0] && a.push(p(i.series[0].xAxis, "foundExtremes", function () {
            t.navigator.modifyNavigatorAxisExtremes();
          }));
        }, r.prototype.getPartsEvents = function (i) {
          var t = this,
            e = [];
          return ["shades", "handles"].forEach(function (a) {
            t[a].forEach(function (c, y) {
              e.push(p(c.element, i, function (b) {
                t[a + "Mousedown"](b, y);
              }));
            });
          }), e;
        }, r.prototype.shadesMousedown = function (i, t) {
          i = this.chart.pointer.normalize(i);
          var e = this.chart,
            a = this.xAxis,
            c = this.zoomedMin,
            y = this.size,
            b = this.range,
            j = this.left,
            P = i.chartX;
          if (e.inverted && (P = i.chartY, j = this.top), t === 1) this.grabbedCenter = P, this.fixedWidth = b, this.dragOffset = P - c;else {
            if (i = P - j - b / 2, t === 0) i = Math.max(0, i);else if (t === 2 && i + b >= y) if (i = y - b, this.reversedExtremes) {
              i -= b;
              var f = this.getUnionExtremes().dataMin;
            } else var x = this.getUnionExtremes().dataMax;
            i !== c && (this.fixedWidth = b, t = a.navigatorAxis.toFixedRange(i, i + b, f, x), l(t.min) && e.xAxis[0].setExtremes(Math.min(t.min, t.max), Math.max(t.min, t.max), !0, null, {
              trigger: "navigator"
            }));
          }
        }, r.prototype.handlesMousedown = function (i, t) {
          this.chart.pointer.normalize(i), i = this.chart;
          var e = i.xAxis[0],
            a = this.reversedExtremes;
          t === 0 ? (this.grabbedLeft = !0, this.otherHandlePos = this.zoomedMax, this.fixedExtreme = a ? e.min : e.max) : (this.grabbedRight = !0, this.otherHandlePos = this.zoomedMin, this.fixedExtreme = a ? e.max : e.min), i.fixedRange = null;
        }, r.prototype.onMouseMove = function (i) {
          var t = this,
            e = t.chart,
            a = t.navigatorSize,
            c = t.range,
            y = t.dragOffset,
            b = e.inverted,
            j = t.left;
          i.touches && i.touches[0].pageX === 0 || (i = e.pointer.normalize(i), e = i.chartX, b && (j = t.top, e = i.chartY), t.grabbedLeft ? (t.hasDragged = !0, t.render(0, 0, e - j, t.otherHandlePos)) : t.grabbedRight ? (t.hasDragged = !0, t.render(0, 0, t.otherHandlePos, e - j)) : t.grabbedCenter && (t.hasDragged = !0, e < y ? e = y : e > a + y - c && (e = a + y - c), t.render(0, 0, e - y, e - y + c)), t.hasDragged && t.scrollbar && d(t.scrollbar.options.liveRedraw, B.svg && !g && !this.chart.boosted) && (i.DOMType = i.type, setTimeout(function () {
            t.onMouseUp(i);
          }, 0)));
        }, r.prototype.onMouseUp = function (i) {
          var t = this.chart,
            e = this.xAxis,
            a = this.scrollbar,
            c = i.DOMEvent || i,
            y = t.inverted,
            b = this.rendered && !this.hasDragged ? "animate" : "attr";
          if (this.hasDragged && (!a || !a.hasDragged) || i.trigger === "scrollbar") {
            if (a = this.getUnionExtremes(), this.zoomedMin === this.otherHandlePos) var j = this.fixedExtreme;else if (this.zoomedMax === this.otherHandlePos) var P = this.fixedExtreme;
            this.zoomedMax === this.size && (P = this.reversedExtremes ? a.dataMin : a.dataMax), this.zoomedMin === 0 && (j = this.reversedExtremes ? a.dataMax : a.dataMin), e = e.navigatorAxis.toFixedRange(this.zoomedMin, this.zoomedMax, j, P), l(e.min) && t.xAxis[0].setExtremes(Math.min(e.min, e.max), Math.max(e.min, e.max), !0, this.hasDragged ? !1 : null, {
              trigger: "navigator",
              triggerOp: "navigator-drag",
              DOMEvent: c
            });
          }
          i.DOMType !== "mousemove" && i.DOMType !== "touchmove" && (this.grabbedLeft = this.grabbedRight = this.grabbedCenter = this.fixedWidth = this.fixedExtreme = this.otherHandlePos = this.hasDragged = this.dragOffset = null), this.navigatorEnabled && C(this.zoomedMin) && C(this.zoomedMax) && (t = Math.round(this.zoomedMin), i = Math.round(this.zoomedMax), this.shades && this.drawMasks(t, i, y, b), this.outline && this.drawOutline(t, i, y, b), this.navigatorOptions.handles.enabled && Object.keys(this.handles).length === this.handles.length && (this.drawHandle(t, 0, y, b), this.drawHandle(i, 1, y, b)));
        }, r.prototype.removeEvents = function () {
          this.eventsToUnbind && (this.eventsToUnbind.forEach(function (i) {
            i();
          }), this.eventsToUnbind = void 0), this.removeBaseSeriesEvents();
        }, r.prototype.removeBaseSeriesEvents = function () {
          var i = this.baseSeries || [];
          this.navigatorEnabled && i[0] && (this.navigatorOptions.adaptToUpdatedData !== !1 && i.forEach(function (t) {
            o(t, "updatedData", this.updatedDataHandler);
          }, this), i[0].xAxis && o(i[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes));
        }, r.prototype.init = function (i) {
          var t = i.options,
            e = t.navigator || {},
            a = e.enabled,
            c = t.scrollbar || {},
            y = c.enabled;
          t = a && e.height || 0;
          var b = y && c.height || 0;
          this.handles = [], this.shades = [], this.chart = i, this.setBaseSeries(), this.height = t, this.scrollbarHeight = b, this.scrollbarEnabled = y, this.navigatorEnabled = a, this.navigatorOptions = e, this.scrollbarOptions = c, this.outlineHeight = t + b, this.opposite = d(e.opposite, !(a || !i.inverted));
          var j = this;
          a = j.baseSeries, c = i.xAxis.length, y = i.yAxis.length;
          var P = a && a[0] && a[0].xAxis || i.xAxis[0] || {
            options: {}
          };
          i.isDirtyBox = !0, j.navigatorEnabled ? (j.xAxis = new D(i, m({
            breaks: P.options.breaks,
            ordinal: P.options.ordinal
          }, e.xAxis, {
            id: "navigator-x-axis",
            yAxis: "navigator-y-axis",
            isX: !0,
            type: "datetime",
            index: c,
            isInternal: !0,
            offset: 0,
            keepOrdinalPadding: !0,
            startOnTick: !1,
            endOnTick: !1,
            minPadding: 0,
            maxPadding: 0,
            zoomEnabled: !1
          }, i.inverted ? {
            offsets: [b, 0, -b, 0],
            width: t
          } : {
            offsets: [0, -b, 0, b],
            height: t
          })), j.yAxis = new D(i, m(e.yAxis, {
            id: "navigator-y-axis",
            alignTicks: !1,
            offset: 0,
            index: y,
            isInternal: !0,
            reversed: d(e.yAxis && e.yAxis.reversed, i.yAxis[0] && i.yAxis[0].reversed, !1),
            zoomEnabled: !1
          }, i.inverted ? {
            width: t
          } : {
            height: t
          })), a || e.series.data ? j.updateNavigatorSeries(!1) : i.series.length === 0 && (j.unbindRedraw = p(i, "beforeRedraw", function () {
            0 < i.series.length && !j.series && (j.setBaseSeries(), j.unbindRedraw());
          })), j.reversedExtremes = i.inverted && !j.xAxis.reversed || !i.inverted && j.xAxis.reversed, j.renderElements(), j.addMouseEvents()) : (j.xAxis = {
            chart: i,
            navigatorAxis: {
              fake: !0
            },
            translate: function translate(f, x) {
              var N = i.xAxis[0],
                R = N.getExtremes(),
                F = N.len - 2 * b,
                T = w("min", N.options.min, R.dataMin);
              return N = w("max", N.options.max, R.dataMax) - T, x ? f * N / F + T : F * (f - T) / N;
            },
            toPixels: function toPixels(f) {
              return this.translate(f);
            },
            toValue: function toValue(f) {
              return this.translate(f, !0);
            }
          }, j.xAxis.navigatorAxis.axis = j.xAxis, j.xAxis.navigatorAxis.toFixedRange = H.prototype.toFixedRange.bind(j.xAxis.navigatorAxis)), i.options.scrollbar.enabled && (i.scrollbar = j.scrollbar = new W(i.renderer, m(i.options.scrollbar, {
            margin: j.navigatorEnabled ? 0 : 10,
            vertical: i.inverted
          }), i), p(j.scrollbar, "changed", function (f) {
            var x = j.size,
              N = x * this.to;
            x *= this.from, j.hasDragged = j.scrollbar.hasDragged, j.render(0, 0, x, N), this.shouldUpdateExtremes(f.DOMType) && setTimeout(function () {
              j.onMouseUp(f);
            });
          })), j.addBaseSeriesEvents(), j.addChartEvents();
        }, r.prototype.getUnionExtremes = function (i) {
          var t = this.chart.xAxis[0],
            e = this.xAxis,
            a = e.options,
            c = t.options,
            y;
          return i && t.dataMin === null || (y = {
            dataMin: d(a && a.min, w("min", c.min, t.dataMin, e.dataMin, e.min)),
            dataMax: d(a && a.max, w("max", c.max, t.dataMax, e.dataMax, e.max))
          }), y;
        }, r.prototype.setBaseSeries = function (i, t) {
          var e = this.chart,
            a = this.baseSeries = [];
          i = i || e.options && e.options.navigator.baseSeries || (e.series.length ? I(e.series, function (c) {
            return !c.options.isInternal;
          }).index : 0), (e.series || []).forEach(function (c, y) {
            c.options.isInternal || !c.options.showInNavigator && (y !== i && c.options.id !== i || c.options.showInNavigator === !1) || a.push(c);
          }), this.xAxis && !this.xAxis.navigatorAxis.fake && this.updateNavigatorSeries(!0, t);
        }, r.prototype.updateNavigatorSeries = function (i, t) {
          var e = this,
            a = e.chart,
            c = e.baseSeries,
            y = {
              enableMouseTracking: !1,
              index: null,
              linkedTo: null,
              group: "nav",
              padXAxis: !1,
              xAxis: "navigator-x-axis",
              yAxis: "navigator-y-axis",
              showInLegend: !1,
              stacking: void 0,
              isInternal: !0,
              states: {
                inactive: {
                  opacity: 1
                }
              }
            },
            b = e.series = (e.series || []).filter(function (N) {
              var R = N.baseSeries;
              return 0 > c.indexOf(R) ? (R && (o(R, "updatedData", e.updatedDataHandler), delete R.navigatorSeries), N.chart && N.destroy(), !1) : !0;
            }),
            j,
            P,
            f = e.navigatorOptions.series,
            x;
          c && c.length && c.forEach(function (N) {
            var R = N.navigatorSeries,
              F = M({
                color: N.color,
                visible: N.visible
              }, L(f) ? A.navigator.series : f);
            R && e.navigatorOptions.adaptToUpdatedData === !1 || (y.name = "Navigator " + c.length, j = N.options || {}, x = j.navigatorOptions || {}, F.dataLabels = n(F.dataLabels), P = m(j, y, F, x), P.pointRange = d(F.pointRange, x.pointRange, A.plotOptions[P.type || "line"].pointRange), F = x.data || F.data, e.hasNavigatorData = e.hasNavigatorData || !!F, P.data = F || j.data && j.data.slice(0), R && R.options ? R.update(P, t) : (N.navigatorSeries = a.initSeries(P), N.navigatorSeries.baseSeries = N, b.push(N.navigatorSeries)));
          }), (f.data && (!c || !c.length) || L(f)) && (e.hasNavigatorData = !1, f = n(f), f.forEach(function (N, R) {
            y.name = "Navigator " + (b.length + 1), P = m(A.navigator.series, {
              color: a.series[R] && !a.series[R].options.isInternal && a.series[R].color || a.options.colors[R] || a.options.colors[0]
            }, y, N), P.data = N.data, P.data && (e.hasNavigatorData = !0, b.push(a.initSeries(P)));
          })), i && this.addBaseSeriesEvents();
        }, r.prototype.addBaseSeriesEvents = function () {
          var i = this,
            t = this,
            e = t.baseSeries || [];
          e[0] && e[0].xAxis && e[0].eventsToUnbind.push(p(e[0].xAxis, "foundExtremes", this.modifyBaseAxisExtremes)), e.forEach(function (a) {
            a.eventsToUnbind.push(p(a, "show", function () {
              this.navigatorSeries && this.navigatorSeries.setVisible(!0, !1);
            })), a.eventsToUnbind.push(p(a, "hide", function () {
              this.navigatorSeries && this.navigatorSeries.setVisible(!1, !1);
            })), i.navigatorOptions.adaptToUpdatedData !== !1 && a.xAxis && a.eventsToUnbind.push(p(a, "updatedData", i.updatedDataHandler)), a.eventsToUnbind.push(p(a, "remove", function () {
              this.navigatorSeries && (v(t.series, this.navigatorSeries), l(this.navigatorSeries.options) && this.navigatorSeries.remove(!1), delete this.navigatorSeries);
            }));
          });
        }, r.prototype.getBaseSeriesMin = function (i) {
          return this.baseSeries.reduce(function (t, e) {
            return Math.min(t, e.xData && e.xData.length ? e.xData[0] : t);
          }, i);
        }, r.prototype.modifyNavigatorAxisExtremes = function () {
          var i = this.xAxis;
          if (typeof i.getExtremes < "u") {
            var t = this.getUnionExtremes(!0);
            !t || t.dataMin === i.min && t.dataMax === i.max || (i.min = t.dataMin, i.max = t.dataMax);
          }
        }, r.prototype.modifyBaseAxisExtremes = function () {
          var i = this.chart.navigator,
            t = this.getExtremes(),
            e = t.dataMin,
            a = t.dataMax;
          t = t.max - t.min;
          var c = i.stickToMin,
            y = i.stickToMax,
            b = d(this.options.overscroll, 0),
            j = i.series && i.series[0],
            P = !!this.setExtremes;
          if (!this.eventArgs || this.eventArgs.trigger !== "rangeSelectorButton") {
            if (c) var f = e,
              x = f + t;
            y && (x = a + b, c || (f = Math.max(e, x - t, i.getBaseSeriesMin(j && j.xData ? j.xData[0] : -Number.MAX_VALUE)))), P && (c || y) && C(f) && (this.min = this.userMin = f, this.max = this.userMax = x);
          }
          i.stickToMin = i.stickToMax = null;
        }, r.prototype.updatedDataHandler = function () {
          var i = this.chart.navigator,
            t = this.navigatorSeries;
          i.stickToMax = d(this.chart.options.navigator && this.chart.options.navigator.stickToMax, i.reversedExtremes ? Math.round(i.zoomedMin) === 0 : Math.round(i.zoomedMax) >= Math.round(i.size)), i.stickToMin = i.shouldStickToMin(this, i), t && !i.hasNavigatorData && (t.options.pointStart = this.xData[0], t.setData(this.options.data, !1, null, !1));
        }, r.prototype.shouldStickToMin = function (i, t) {
          t = t.getBaseSeriesMin(i.xData[0]);
          var e = i.xAxis;
          i = e.max;
          var a = e.min;
          return e = e.options.range, C(i) && C(a) ? e && 0 < i - t ? i - t < e : a <= t : !1;
        }, r.prototype.addChartEvents = function () {
          this.eventsToUnbind || (this.eventsToUnbind = []), this.eventsToUnbind.push(p(this.chart, "redraw", function () {
            var i = this.navigator,
              t = i && (i.baseSeries && i.baseSeries[0] && i.baseSeries[0].xAxis || this.xAxis[0]);
            t && i.render(t.min, t.max);
          }), p(this.chart, "getMargins", function () {
            var i = this.navigator,
              t = i.opposite ? "plotTop" : "marginBottom";
            this.inverted && (t = i.opposite ? "marginRight" : "plotLeft"), this[t] = (this[t] || 0) + (i.navigatorEnabled || !this.inverted ? i.outlineHeight : 0) + i.navigatorOptions.margin;
          }));
        }, r.prototype.destroy = function () {
          var i = this;
          this.removeEvents(), this.xAxis && (v(this.chart.xAxis, this.xAxis), v(this.chart.axes, this.xAxis)), this.yAxis && (v(this.chart.yAxis, this.yAxis), v(this.chart.axes, this.yAxis)), (this.series || []).forEach(function (t) {
            t.destroy && t.destroy();
          }), "series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" ").forEach(function (t) {
            i[t] && i[t].destroy && i[t].destroy(), i[t] = null;
          }), [this.handles].forEach(function (t) {
            u(t);
          });
        }, r;
      }();
    }), V(S, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function () {
      return {
        lang: {
          rangeSelectorZoom: "Zoom",
          rangeSelectorFrom: "",
          rangeSelectorTo: "→"
        },
        rangeSelector: {
          allButtonsEnabled: !1,
          buttons: void 0,
          buttonSpacing: 5,
          dropdown: "responsive",
          enabled: void 0,
          verticalAlign: "top",
          buttonTheme: {
            width: 28,
            height: 18,
            padding: 2,
            zIndex: 7
          },
          floating: !1,
          x: 0,
          y: 0,
          height: void 0,
          inputBoxBorderColor: "none",
          inputBoxHeight: 17,
          inputBoxWidth: void 0,
          inputDateFormat: "%b %e, %Y",
          inputDateParser: void 0,
          inputEditDateFormat: "%Y-%m-%d",
          inputEnabled: !0,
          inputPosition: {
            align: "right",
            x: 0,
            y: 0
          },
          inputSpacing: 5,
          selected: void 0,
          buttonPosition: {
            align: "left",
            x: 0,
            y: 0
          },
          inputStyle: {
            color: "#335cad",
            cursor: "pointer"
          },
          labelStyle: {
            color: "#666666"
          }
        }
      };
    }), V(S, "Stock/RangeSelector/RangeSelectorComposition.js", [S["Core/Defaults.js"], S["Stock/RangeSelector/RangeSelectorDefaults.js"], S["Core/Utilities.js"]], function (D, E, B) {
      function H() {
        var o = this.range,
          n = o.type,
          r = this.max,
          i = this.chart.time,
          t = function t(y, b) {
            var j = n === "year" ? "FullYear" : "Month",
              P = new i.Date(y),
              f = i.get(j, P);
            return i.set(j, P, f + b), f === i.get(j, P) && i.set("Date", P, 0), P.getTime() - y;
          };
        if (M(o)) var e = r - o,
          a = o;else o && (e = r + t(r, -(o.count || 1)), this.chart && (this.chart.fixedRange = r - e));
        var c = L(this.dataMin, Number.MIN_VALUE);
        return M(e) || (e = c), e <= c && (e = c, typeof a > "u" && (a = t(e, o.count)), this.newMax = Math.min(e + a, L(this.dataMax, Number.MAX_VALUE))), M(r) ? !M(o) && o && o._offsetMin && (e += o._offsetMin) : e = void 0, e;
      }
      function X() {
        this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new d(this));
      }
      function W() {
        var o = this.axes,
          n = this.rangeSelector;
        n && (M(n.deferredYTDClick) && (n.clickButton(n.deferredYTDClick), delete n.deferredYTDClick), o.forEach(function (r) {
          r.updateNames(), r.setScale();
        }), this.getAxisMargins(), n.render(), o = n.options.verticalAlign, n.options.floating || (o === "bottom" ? this.extraBottomMargin = !0 : o !== "middle" && (this.extraTopMargin = !0)));
      }
      function z(o) {
        var n,
          r,
          i,
          t,
          e = o.rangeSelector,
          a = function a() {
            e && (n = o.xAxis[0].getExtremes(), r = o.legend, t = e && e.options.verticalAlign, M(n.min) && e.render(n.min, n.max), r.display && t === "top" && t === r.options.verticalAlign && (i = I(o.spacingBox), i.y = r.options.layout === "vertical" ? o.plotTop : i.y + e.getHeight(), r.group.placed = !1, r.align(i)));
          };
        e && (v(C, function (c) {
          return c[0] === o;
        }) || C.push([o, [s(o.xAxis[0], "afterSetExtremes", function (c) {
          e && e.render(c.min, c.max);
        }), s(o, "redraw", a)]]), a());
      }
      function w() {
        for (var o = 0, n = C.length; o < n; ++o) {
          var r = C[o];
          if (r[0] === this) {
            r[1].forEach(function (i) {
              return i();
            }), C.splice(o, 1);
            break;
          }
        }
      }
      function A() {
        var o = this.rangeSelector;
        o && (o = o.getHeight(), this.extraTopMargin && (this.plotTop += o), this.extraBottomMargin && (this.marginBottom += o));
      }
      function k() {
        var o = this.rangeSelector;
        o && !o.options.floating && (o.render(), o = o.options.verticalAlign, o === "bottom" ? this.extraBottomMargin = !0 : o !== "middle" && (this.extraTopMargin = !0));
      }
      function g(o) {
        var n = o.options.rangeSelector;
        o = this.extraBottomMargin;
        var r = this.extraTopMargin,
          i = this.rangeSelector;
        n && n.enabled && !l(i) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = i = new d(this)), this.extraTopMargin = this.extraBottomMargin = !1, i && (z(this), n = n && n.verticalAlign || i.options && i.options.verticalAlign, i.options.floating || (n === "bottom" ? this.extraBottomMargin = !0 : n !== "middle" && (this.extraTopMargin = !0)), this.extraBottomMargin !== o || this.extraTopMargin !== r) && (this.isDirtyBox = !0);
      }
      var p = D.defaultOptions,
        h = D.setOptions,
        s = B.addEvent,
        l = B.defined,
        u = B.extend,
        v = B.find,
        M = B.isNumber,
        I = B.merge,
        L = B.pick,
        C = [],
        m = [],
        d;
      return {
        compose: function compose(o, n, r) {
          d = r, m.indexOf(o) === -1 && (m.push(o), o.prototype.minFromRange = H), m.indexOf(n) === -1 && (m.push(n), s(n, "afterGetContainer", X), s(n, "beforeRender", W), s(n, "destroy", w), s(n, "getMargins", A), s(n, "render", k), s(n, "update", g), n.prototype.callbacks.push(z)), m.indexOf(h) === -1 && (u(p, {
            rangeSelector: E.rangeSelector
          }), u(p.lang, E.lang));
        }
      };
    }), V(S, "Stock/RangeSelector/RangeSelector.js", [S["Core/Axis/Axis.js"], S["Core/Defaults.js"], S["Core/Globals.js"], S["Stock/RangeSelector/RangeSelectorComposition.js"], S["Core/Renderer/SVG/SVGElement.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W) {
      function z(o) {
        if (o.indexOf("%L") !== -1) return "text";
        var n = "aAdewbBmoyY".split("").some(function (i) {
            return o.indexOf("%" + i) !== -1;
          }),
          r = "HkIlMS".split("").some(function (i) {
            return o.indexOf("%" + i) !== -1;
          });
        return n && r ? "datetime-local" : n ? "date" : r ? "time" : "text";
      }
      var w = E.defaultOptions,
        A = W.addEvent,
        k = W.createElement,
        g = W.css,
        p = W.defined,
        h = W.destroyObjectProperties,
        s = W.discardElement,
        l = W.extend,
        u = W.fireEvent,
        v = W.isNumber,
        M = W.merge,
        I = W.objectEach,
        L = W.pad,
        C = W.pick,
        m = W.pInt,
        d = W.splat;
      return E = function () {
        function o(n) {
          this.buttons = void 0, this.buttonOptions = o.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.options = void 0, this.chart = n, this.init(n);
        }
        return o.compose = function (n, r) {
          H.compose(n, r, o);
        }, o.prototype.clickButton = function (n, r) {
          var i = this.chart,
            t = this.buttonOptions[n],
            e = i.xAxis[0],
            a = i.scroller && i.scroller.getUnionExtremes() || e || {},
            c = t.type,
            y = t.dataGrouping,
            b = a.dataMin,
            j = a.dataMax,
            P = e && Math.round(Math.min(e.max, C(j, e.max)));
          a = t._range;
          var f,
            x = !0;
          if (b !== null && j !== null) {
            if (i.fixedRange = a, this.setSelected(n), y && (this.forcedDataGrouping = !0, D.prototype.setDataGrouping.call(e || {
              chart: this.chart
            }, y, !1), this.frozenStates = t.preserveDataGrouping), c === "month" || c === "year") {
              if (e) {
                c = {
                  range: t,
                  max: P,
                  chart: i,
                  dataMin: b,
                  dataMax: j
                };
                var N = e.minFromRange.call(c);
                v(c.newMax) && (P = c.newMax), x = !1;
              } else a = t;
            } else if (a) N = Math.max(P - a, b), P = Math.min(N + a, j), x = !1;else if (c === "ytd") {
              if (e) (typeof j > "u" || typeof b > "u") && (b = Number.MAX_VALUE, j = Number.MIN_VALUE, i.series.forEach(function (G) {
                (G = G.xData) && (b = Math.min(G[0], b), j = Math.max(G[G.length - 1], j));
              }), r = !1), c = this.getYTDExtremes(j, b, i.time.useUTC), N = f = c.min, P = c.max;else {
                this.deferredYTDClick = n;
                return;
              }
            } else c === "all" && e && (i.navigator && i.navigator.baseSeries[0] && (i.navigator.baseSeries[0].xAxis.options.range = void 0), N = b, P = j);
            if (x && t._offsetMin && p(N) && (N += t._offsetMin), t._offsetMax && p(P) && (P += t._offsetMax), this.dropdown && (this.dropdown.selectedIndex = n + 1), e) e.setExtremes(N, P, C(r, !0), void 0, {
              trigger: "rangeSelectorButton",
              rangeSelectorButton: t
            });else {
              var R = d(i.options.xAxis)[0],
                F = R.range;
              R.range = a;
              var T = R.min;
              R.min = f, A(i, "load", function () {
                R.range = F, R.min = T;
              });
            }
            u(this, "afterBtnClick");
          }
        }, o.prototype.setSelected = function (n) {
          this.selected = this.options.selected = n;
        }, o.prototype.init = function (n) {
          var r = this,
            i = n.options.rangeSelector,
            t = i.buttons || r.defaultButtons.slice(),
            e = i.selected,
            a = function a() {
              var c = r.minInput,
                y = r.maxInput;
              c && c.blur && u(c, "blur"), y && y.blur && u(y, "blur");
            };
          r.chart = n, r.options = i, r.buttons = [], r.buttonOptions = t, this.eventsToUnbind = [], this.eventsToUnbind.push(A(n.container, "mousedown", a)), this.eventsToUnbind.push(A(n, "resize", a)), t.forEach(r.computeButtonRange), typeof e < "u" && t[e] && this.clickButton(e, !1), this.eventsToUnbind.push(A(n, "load", function () {
            n.xAxis && n.xAxis[0] && A(n.xAxis[0], "setExtremes", function (c) {
              this.max - this.min !== n.fixedRange && c.trigger !== "rangeSelectorButton" && c.trigger !== "updatedData" && r.forcedDataGrouping && !r.frozenStates && this.setDataGrouping(!1, !1);
            });
          }));
        }, o.prototype.updateButtonStates = function () {
          var n = this,
            r = this.chart,
            i = this.dropdown,
            t = r.xAxis[0],
            e = Math.round(t.max - t.min),
            a = !t.hasVisibleSeries,
            c = r.scroller && r.scroller.getUnionExtremes() || t,
            y = c.dataMin,
            b = c.dataMax;
          r = n.getYTDExtremes(b, y, r.time.useUTC);
          var j = r.min,
            P = r.max,
            f = n.selected,
            x = n.options.allButtonsEnabled,
            N = n.buttons,
            R = v(f);
          n.buttonOptions.forEach(function (F, T) {
            var G = F._range,
              _ = F.type,
              q = F.count || 1,
              Y = N[T],
              U = F._offsetMax - F._offsetMin,
              Z = T === f,
              J = G > b - y,
              et = G < t.minRange;
            F = 0;
            var nt = !1,
              lt = !1;
            G = G === e, (_ === "month" || _ === "year") && e + 36e5 >= 864e5 * {
              month: 28,
              year: 365
            }[_] * q - U && e - 36e5 <= 864e5 * {
              month: 31,
              year: 366
            }[_] * q + U ? G = !0 : _ === "ytd" ? (G = P - j + U === e, nt = !Z) : _ === "all" && (G = t.max - t.min >= b - y, lt = !Z && R && G), _ = !x && (J || et || lt || a), q = Z && G || G && !R && !nt || Z && n.frozenStates, _ ? F = 3 : q && (R = !0, F = 2), Y.state !== F && (Y.setState(F), i && (i.options[T + 1].disabled = _, F === 2 && (i.selectedIndex = T + 1)), F === 0 && f === T && n.setSelected());
          });
        }, o.prototype.computeButtonRange = function (n) {
          var r = n.type,
            i = n.count || 1,
            t = {
              millisecond: 1,
              second: 1e3,
              minute: 6e4,
              hour: 36e5,
              day: 864e5,
              week: 6048e5
            };
          t[r] ? n._range = t[r] * i : (r === "month" || r === "year") && (n._range = 864e5 * {
            month: 30,
            year: 365
          }[r] * i), n._offsetMin = C(n.offsetMin, 0), n._offsetMax = C(n.offsetMax, 0), n._range += n._offsetMax - n._offsetMin;
        }, o.prototype.getInputValue = function (n) {
          n = n === "min" ? this.minInput : this.maxInput;
          var r = this.chart.options.rangeSelector,
            i = this.chart.time;
          return n ? (n.type === "text" && r.inputDateParser || this.defaultInputDateParser)(n.value, i.useUTC, i) : 0;
        }, o.prototype.setInputValue = function (n, r) {
          var i = this.options,
            t = this.chart.time,
            e = n === "min" ? this.minInput : this.maxInput;
          if (n = n === "min" ? this.minDateBox : this.maxDateBox, e) {
            var a = e.getAttribute("data-hc-time");
            a = p(a) ? Number(a) : void 0, p(r) && (p(a) && e.setAttribute("data-hc-time-previous", a), e.setAttribute("data-hc-time", r), a = r), e.value = t.dateFormat(this.inputTypeFormats[e.type] || i.inputEditDateFormat, a), n && n.attr({
              text: t.dateFormat(i.inputDateFormat, a)
            });
          }
        }, o.prototype.setInputExtremes = function (n, r, i) {
          if (n = n === "min" ? this.minInput : this.maxInput) {
            var t = this.inputTypeFormats[n.type],
              e = this.chart.time;
            t && (r = e.dateFormat(t, r), n.min !== r && (n.min = r), i = e.dateFormat(t, i), n.max !== i && (n.max = i));
          }
        }, o.prototype.showInput = function (n) {
          var r = n === "min" ? this.minDateBox : this.maxDateBox;
          if ((n = n === "min" ? this.minInput : this.maxInput) && r && this.inputGroup) {
            var i = n.type === "text",
              t = this.inputGroup,
              e = t.translateX;
            t = t.translateY;
            var a = this.options.inputBoxWidth;
            g(n, {
              width: i ? r.width + (a ? -2 : 20) + "px" : "auto",
              height: i ? r.height - 2 + "px" : "auto",
              border: "2px solid silver"
            }), i && a ? g(n, {
              left: e + r.x + "px",
              top: t + "px"
            }) : g(n, {
              left: Math.min(Math.round(r.x + e - (n.offsetWidth - r.width) / 2), this.chart.chartWidth - n.offsetWidth) + "px",
              top: t - (n.offsetHeight - r.height) / 2 + "px"
            });
          }
        }, o.prototype.hideInput = function (n) {
          (n = n === "min" ? this.minInput : this.maxInput) && g(n, {
            top: "-9999em",
            border: 0,
            width: "1px",
            height: "1px"
          });
        }, o.prototype.defaultInputDateParser = function (n, r, i) {
          var t = n.split("/").join("-").split(" ").join("T");
          if (t.indexOf("T") === -1 && (t += "T00:00"), r) t += "Z";else {
            var e;
            (e = B.isSafari) && (e = t, e = !(6 < e.length && (e.lastIndexOf("-") === e.length - 6 || e.lastIndexOf("+") === e.length - 6))), e && (e = new Date(t).getTimezoneOffset() / 60, t += 0 >= e ? "+".concat(L(-e), ":00") : "-".concat(L(e), ":00"));
          }
          return t = Date.parse(t), v(t) || (n = n.split("-"), t = Date.UTC(m(n[0]), m(n[1]) - 1, m(n[2]))), i && r && v(t) && (t += i.getTimezoneOffset(t)), t;
        }, o.prototype.drawInput = function (n) {
          function r() {
            var N = a.maxInput,
              R = a.minInput,
              F = i.xAxis[0],
              T = i.scroller && i.scroller.xAxis ? i.scroller.xAxis : F,
              G = T.dataMin;
            T = T.dataMax;
            var _ = a.getInputValue(n);
            _ !== Number(f.getAttribute("data-hc-time-previous")) && v(_) && (f.setAttribute("data-hc-time-previous", _), j && N && v(G) ? _ > Number(N.getAttribute("data-hc-time")) ? _ = void 0 : _ < G && (_ = G) : R && v(T) && (_ < Number(R.getAttribute("data-hc-time")) ? _ = void 0 : _ > T && (_ = T)), typeof _ < "u" && F.setExtremes(j ? _ : F.min, j ? F.max : _, void 0, void 0, {
              trigger: "rangeSelectorInput"
            }));
          }
          var i = this.chart,
            t = this.div,
            e = this.inputGroup,
            a = this,
            c = i.renderer.style || {},
            y = i.renderer,
            b = i.options.rangeSelector,
            j = n === "min",
            P = w.lang[j ? "rangeSelectorFrom" : "rangeSelectorTo"] || "";
          P = y.label(P, 0).addClass("highcharts-range-label").attr({
            padding: P ? 2 : 0,
            height: P ? b.inputBoxHeight : 0
          }).add(e), y = y.label("", 0).addClass("highcharts-range-input").attr({
            padding: 2,
            width: b.inputBoxWidth,
            height: b.inputBoxHeight,
            "text-align": "center"
          }).on("click", function () {
            a.showInput(n), a[n + "Input"].focus();
          }), i.styledMode || y.attr({
            stroke: b.inputBoxBorderColor,
            "stroke-width": 1
          }), y.add(e);
          var f = k("input", {
            name: n,
            className: "highcharts-range-selector"
          }, void 0, t);
          f.setAttribute("type", z(b.inputDateFormat || "%b %e, %Y")), i.styledMode || (P.css(M(c, b.labelStyle)), y.css(M({
            color: "#333333"
          }, c, b.inputStyle)), g(f, l({
            position: "absolute",
            border: 0,
            boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            width: "1px",
            height: "1px",
            padding: 0,
            textAlign: "center",
            fontSize: c.fontSize,
            fontFamily: c.fontFamily,
            top: "-9999em"
          }, b.inputStyle))), f.onfocus = function () {
            a.showInput(n);
          }, f.onblur = function () {
            f === B.doc.activeElement && r(), a.hideInput(n), a.setInputValue(n), f.blur();
          };
          var x = !1;
          return f.onchange = function () {
            x || (r(), a.hideInput(n), f.blur());
          }, f.onkeypress = function (N) {
            N.keyCode === 13 && r();
          }, f.onkeydown = function (N) {
            x = !0, N.keyCode !== 38 && N.keyCode !== 40 || r();
          }, f.onkeyup = function () {
            x = !1;
          }, {
            dateBox: y,
            input: f,
            label: P
          };
        }, o.prototype.getPosition = function () {
          var n = this.chart,
            r = n.options.rangeSelector;
          return n = r.verticalAlign === "top" ? n.plotTop - n.axisOffset[0] : 0, {
            buttonTop: n + r.buttonPosition.y,
            inputTop: n + r.inputPosition.y - 10
          };
        }, o.prototype.getYTDExtremes = function (n, r, i) {
          var t = this.chart.time,
            e = new t.Date(n),
            a = t.get("FullYear", e);
          return i = i ? t.Date.UTC(a, 0, 1) : +new t.Date(a, 0, 1), r = Math.max(r, i), e = e.getTime(), {
            max: Math.min(n || e, e),
            min: r
          };
        }, o.prototype.render = function (n, r) {
          var i = this.chart,
            t = i.renderer,
            e = i.container,
            a = i.options,
            c = a.rangeSelector,
            y = C(a.chart.style && a.chart.style.zIndex, 0) + 1;
          if (a = c.inputEnabled, c.enabled !== !1) {
            if (this.rendered || (this.group = t.g("range-selector-group").attr({
              zIndex: 7
            }).add(), this.div = k("div", void 0, {
              position: "relative",
              height: 0,
              zIndex: y
            }), this.buttonOptions.length && this.renderButtons(), e.parentNode && e.parentNode.insertBefore(this.div, e), a && (this.inputGroup = t.g("input-group").add(this.group), t = this.drawInput("min"), this.minDateBox = t.dateBox, this.minLabel = t.label, this.minInput = t.input, t = this.drawInput("max"), this.maxDateBox = t.dateBox, this.maxLabel = t.label, this.maxInput = t.input)), a && (this.setInputValue("min", n), this.setInputValue("max", r), n = i.scroller && i.scroller.getUnionExtremes() || i.xAxis[0] || {}, p(n.dataMin) && p(n.dataMax) && (i = i.xAxis[0].minRange || 0, this.setInputExtremes("min", n.dataMin, Math.min(n.dataMax, this.getInputValue("max")) - i), this.setInputExtremes("max", Math.max(n.dataMin, this.getInputValue("min")) + i, n.dataMax)), this.inputGroup)) {
              var b = 0;
              [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach(function (j) {
                if (j) {
                  var P = j.getBBox().width;
                  P && (j.attr({
                    x: b
                  }), b += P + c.inputSpacing);
                }
              });
            }
            this.alignElements(), this.rendered = !0;
          }
        }, o.prototype.renderButtons = function () {
          var n = this,
            r = this.buttons,
            i = this.options,
            t = w.lang,
            e = this.chart.renderer,
            a = M(i.buttonTheme),
            c = a && a.states,
            y = a.width || 28;
          delete a.width, delete a.states, this.buttonGroup = e.g("range-selector-buttons").add(this.group);
          var b = this.dropdown = k("select", void 0, {
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            border: 0,
            top: "-9999em",
            cursor: "pointer",
            opacity: 1e-4
          }, this.div);
          A(b, "touchstart", function () {
            b.style.fontSize = "16px";
          }), [[B.isMS ? "mouseover" : "mouseenter"], [B.isMS ? "mouseout" : "mouseleave"], ["change", "click"]].forEach(function (j) {
            var P = j[0],
              f = j[1];
            A(b, P, function () {
              var x = r[n.currentButtonIndex()];
              x && u(x.element, f || P);
            });
          }), this.zoomText = e.label(t && t.rangeSelectorZoom || "", 0).attr({
            padding: i.buttonTheme.padding,
            height: i.buttonTheme.height,
            paddingLeft: 0,
            paddingRight: 0
          }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(i.labelStyle), a["stroke-width"] = C(a["stroke-width"], 0)), k("option", {
            textContent: this.zoomText.textStr,
            disabled: !0
          }, void 0, b), this.buttonOptions.forEach(function (j, P) {
            k("option", {
              textContent: j.title || j.text
            }, void 0, b), r[P] = e.button(j.text, 0, 0, function (f) {
              var x = j.events && j.events.click,
                N;
              x && (N = x.call(j, f)), N !== !1 && n.clickButton(P), n.isActive = !0;
            }, a, c && c.hover, c && c.select, c && c.disabled).attr({
              "text-align": "center",
              width: y
            }).add(n.buttonGroup), j.title && r[P].attr("title", j.title);
          });
        }, o.prototype.alignElements = function () {
          var n = this,
            r = this.buttonGroup,
            i = this.buttons,
            t = this.chart,
            e = this.group,
            a = this.inputGroup,
            c = this.options,
            y = this.zoomText,
            b = t.options,
            j = b.exporting && b.exporting.enabled !== !1 && b.navigation && b.navigation.buttonOptions;
          b = c.buttonPosition;
          var P = c.inputPosition,
            f = c.verticalAlign,
            x = function x(T, G) {
              return j && n.titleCollision(t) && f === "top" && G.align === "right" && G.y - T.getBBox().height - 12 < (j.y || 0) + (j.height || 0) + t.spacing[0] ? -40 : 0;
            },
            N = t.plotLeft;
          if (e && b && P) {
            var R = b.x - t.spacing[3];
            if (r) {
              if (this.positionButtons(), !this.initialButtonGroupWidth) {
                var F = 0;
                y && (F += y.getBBox().width + 5), i.forEach(function (T, G) {
                  F += T.width, G !== i.length - 1 && (F += c.buttonSpacing);
                }), this.initialButtonGroupWidth = F;
              }
              N -= t.spacing[3], this.updateButtonStates(), y = x(r, b), this.alignButtonGroup(y), e.placed = r.placed = t.hasLoaded;
            }
            r = 0, a && (r = x(a, P), P.align === "left" ? R = N : P.align === "right" && (R = -Math.max(t.axisOffset[1], -r)), a.align({
              y: P.y,
              width: a.getBBox().width,
              align: P.align,
              x: P.x + R - 2
            }, !0, t.spacingBox), a.placed = t.hasLoaded), this.handleCollision(r), e.align({
              verticalAlign: f
            }, !0, t.spacingBox), a = e.alignAttr.translateY, r = e.getBBox().height + 20, x = 0, f === "bottom" && (x = (x = t.legend && t.legend.options) && x.verticalAlign === "bottom" && x.enabled && !x.floating ? t.legend.legendHeight + C(x.margin, 10) : 0, r = r + x - 20, x = a - r - (c.floating ? 0 : c.y) - (t.titleOffset ? t.titleOffset[2] : 0) - 10), f === "top" ? (c.floating && (x = 0), t.titleOffset && t.titleOffset[0] && (x = t.titleOffset[0]), x += t.margin[0] - t.spacing[0] || 0) : f === "middle" && (P.y === b.y ? x = a : (P.y || b.y) && (x = 0 > P.y || 0 > b.y ? x - Math.min(P.y, b.y) : a - r)), e.translate(c.x, c.y + Math.floor(x)), b = this.minInput, P = this.maxInput, a = this.dropdown, c.inputEnabled && b && P && (b.style.marginTop = e.translateY + "px", P.style.marginTop = e.translateY + "px"), a && (a.style.marginTop = e.translateY + "px");
          }
        }, o.prototype.alignButtonGroup = function (n, r) {
          var i = this.chart,
            t = this.buttonGroup,
            e = this.options.buttonPosition,
            a = i.plotLeft - i.spacing[3],
            c = e.x - i.spacing[3];
          e.align === "right" ? c += n - a : e.align === "center" && (c -= a / 2), t && t.align({
            y: e.y,
            width: C(r, this.initialButtonGroupWidth),
            align: e.align,
            x: c
          }, !0, i.spacingBox);
        }, o.prototype.positionButtons = function () {
          var n = this.buttons,
            r = this.chart,
            i = this.options,
            t = this.zoomText,
            e = r.hasLoaded ? "animate" : "attr",
            a = i.buttonPosition,
            c = r = r.plotLeft;
          for (t && t.visibility !== "hidden" && (t[e]({
            x: C(r + a.x, r)
          }), c += a.x + t.getBBox().width + 5), t = 0, a = this.buttonOptions.length; t < a; ++t) n[t].visibility !== "hidden" ? (n[t][e]({
            x: c
          }), c += n[t].width + i.buttonSpacing) : n[t][e]({
            x: r
          });
        }, o.prototype.handleCollision = function (n) {
          var r = this,
            i = this.chart,
            t = this.buttonGroup,
            e = this.inputGroup,
            a = this.options,
            c = a.buttonPosition,
            y = a.dropdown,
            b = a.inputPosition;
          a = function a() {
            var f = 0;
            return r.buttons.forEach(function (x) {
              x = x.getBBox(), x.width > f && (f = x.width);
            }), f;
          };
          var j = function j(f) {
              if (e && t) {
                var x = e.alignAttr.translateX + e.alignOptions.x - n + e.getBBox().x + 2,
                  N = e.alignOptions.width,
                  R = t.alignAttr.translateX + t.getBBox().x;
                return R + f > x && x + N > R && c.y < b.y + e.getBBox().height;
              }
              return !1;
            },
            P = function P() {
              e && t && e.attr({
                translateX: e.alignAttr.translateX + (i.axisOffset[1] >= -n ? 0 : -n),
                translateY: e.alignAttr.translateY + t.getBBox().height + 10
              });
            };
          if (t) {
            if (y === "always") {
              this.collapseButtons(n), j(a()) && P();
              return;
            }
            y === "never" && this.expandButtons();
          }
          e && t ? b.align === c.align || j(this.initialButtonGroupWidth + 20) ? y === "responsive" ? (this.collapseButtons(n), j(a()) && P()) : P() : y === "responsive" && this.expandButtons() : t && y === "responsive" && (this.initialButtonGroupWidth > i.plotWidth ? this.collapseButtons(n) : this.expandButtons());
        }, o.prototype.collapseButtons = function (n) {
          var r = this.buttons,
            i = this.buttonOptions,
            t = this.chart,
            e = this.dropdown,
            a = this.options,
            c = this.zoomText,
            y = t.userOptions.rangeSelector && t.userOptions.rangeSelector.buttonTheme || {},
            b = function b(P) {
              return {
                text: P ? "" + P + " ▾" : "▾",
                width: "auto",
                paddingLeft: C(a.buttonTheme.paddingLeft, y.padding, 8),
                paddingRight: C(a.buttonTheme.paddingRight, y.padding, 8)
              };
            };
          c && c.hide();
          var j = !1;
          i.forEach(function (P, f) {
            f = r[f], f.state !== 2 ? f.hide() : (f.show(), f.attr(b(P.text)), j = !0);
          }), j || (e && (e.selectedIndex = 0), r[0].show(), r[0].attr(b(this.zoomText && this.zoomText.textStr))), i = a.buttonPosition.align, this.positionButtons(), i !== "right" && i !== "center" || this.alignButtonGroup(n, r[this.currentButtonIndex()].getBBox().width), this.showDropdown();
        }, o.prototype.expandButtons = function () {
          var n = this.buttons,
            r = this.buttonOptions,
            i = this.options,
            t = this.zoomText;
          this.hideDropdown(), t && t.show(), r.forEach(function (e, a) {
            a = n[a], a.show(), a.attr({
              text: e.text,
              width: i.buttonTheme.width || 28,
              paddingLeft: C(i.buttonTheme.paddingLeft, "unset"),
              paddingRight: C(i.buttonTheme.paddingRight, "unset")
            }), 2 > a.state && a.setState(0);
          }), this.positionButtons();
        }, o.prototype.currentButtonIndex = function () {
          var n = this.dropdown;
          return n && 0 < n.selectedIndex ? n.selectedIndex - 1 : 0;
        }, o.prototype.showDropdown = function () {
          var n = this.buttonGroup,
            r = this.buttons,
            i = this.chart,
            t = this.dropdown;
          if (n && t) {
            var e = n.translateX;
            n = n.translateY, r = r[this.currentButtonIndex()].getBBox(), g(t, {
              left: i.plotLeft + e + "px",
              top: n + 0.5 + "px",
              width: r.width + "px",
              height: r.height + "px"
            }), this.hasVisibleDropdown = !0;
          }
        }, o.prototype.hideDropdown = function () {
          var n = this.dropdown;
          n && (g(n, {
            top: "-9999em",
            width: "1px",
            height: "1px"
          }), this.hasVisibleDropdown = !1);
        }, o.prototype.getHeight = function () {
          var n = this.options,
            r = this.group,
            i = n.y,
            t = n.buttonPosition.y,
            e = n.inputPosition.y;
          return n.height ? n.height : (this.alignElements(), n = r ? r.getBBox(!0).height + 13 + i : 0, r = Math.min(e, t), (0 > e && 0 > t || 0 < e && 0 < t) && (n += Math.abs(r)), n);
        }, o.prototype.titleCollision = function (n) {
          return !(n.options.title.text || n.options.subtitle.text);
        }, o.prototype.update = function (n) {
          var r = this.chart;
          M(!0, r.options.rangeSelector, n), this.destroy(), this.init(r), this.render();
        }, o.prototype.destroy = function () {
          var n = this,
            r = n.minInput,
            i = n.maxInput;
          n.eventsToUnbind && (n.eventsToUnbind.forEach(function (t) {
            return t();
          }), n.eventsToUnbind = void 0), h(n.buttons), r && (r.onfocus = r.onblur = r.onchange = null), i && (i.onfocus = i.onblur = i.onchange = null), I(n, function (t, e) {
            t && e !== "chart" && (t instanceof X ? t.destroy() : t instanceof O.HTMLElement && s(t)), t !== o.prototype[e] && (n[e] = null);
          }, this);
        }, o;
      }(), l(E.prototype, {
        defaultButtons: [{
          type: "month",
          count: 1,
          text: "1m",
          title: "View 1 month"
        }, {
          type: "month",
          count: 3,
          text: "3m",
          title: "View 3 months"
        }, {
          type: "month",
          count: 6,
          text: "6m",
          title: "View 6 months"
        }, {
          type: "ytd",
          text: "YTD",
          title: "View year to date"
        }, {
          type: "year",
          count: 1,
          text: "1y",
          title: "View 1 year"
        }, {
          type: "all",
          text: "All",
          title: "View all"
        }],
        inputTypeFormats: {
          "datetime-local": "%Y-%m-%dT%H:%M:%S",
          date: "%Y-%m-%d",
          time: "%H:%M:%S"
        }
      }), E;
    }), V(S, "Core/Axis/OrdinalAxis.js", [S["Core/Axis/Axis.js"], S["Core/Globals.js"], S["Core/Series/Series.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = H.addEvent,
        W = H.correctFloat,
        z = H.css,
        w = H.defined,
        A = H.error,
        k = H.pick,
        g = H.timeUnits,
        p = [],
        h;
      return function (s) {
        function l(i, t, e, a, c, y, b) {
          c === void 0 && (c = []), y === void 0 && (y = 0);
          var j = {},
            P = this.options.tickPixelInterval,
            f = this.chart.time,
            x = [],
            N,
            R,
            F = 0,
            T = [],
            G = -Number.MAX_VALUE;
          if (!this.options.ordinal && !this.options.breaks || !c || 3 > c.length || typeof t > "u") return f.getTimeTicks.apply(f, arguments);
          var _ = c.length;
          for (N = 0; N < _; N++) {
            var q = N && c[N - 1] > e;
            if (c[N] < t && (F = N), N === _ - 1 || c[N + 1] - c[N] > 5 * y || q) {
              if (c[N] > G) {
                for (R = f.getTimeTicks(i, c[F], c[N], a); R.length && R[0] <= G;) R.shift();
                R.length && (G = R[R.length - 1]), x.push(T.length), T = T.concat(R);
              }
              F = N + 1;
            }
            if (q) break;
          }
          if (R) {
            if (R = R.info, b && R.unitRange <= g.hour) {
              for (N = T.length - 1, F = 1; F < N; F++) if (f.dateFormat("%d", T[F]) !== f.dateFormat("%d", T[F - 1])) {
                j[T[F]] = "day";
                var Y = !0;
              }
              Y && (j[T[0]] = "day"), R.higherRanks = j;
            }
            R.segmentStarts = x, T.info = R;
          } else A(12, !1, this.chart);
          if (b && w(P)) {
            for (R = T.length, f = [], F = [], N = void 0, Y = R; Y--;) x = this.translate(T[Y]), N && (F[Y] = N - x), f[Y] = N = x;
            for (F.sort(), F = F[Math.floor(F.length / 2)], F < 0.6 * P && (F = null), Y = T[R - 1] > e ? R - 1 : R, N = void 0; Y--;) x = f[Y], R = Math.abs(N - x), N && R < 0.8 * P && (F === null || R < 0.8 * F) ? (j[T[Y]] && !j[T[Y + 1]] ? (R = Y + 1, N = x) : R = Y, T.splice(R, 1)) : N = x;
          }
          return T;
        }
        function u(i) {
          var t = this.ordinal.positions;
          if (!t) return i;
          var e = t.length - 1;
          if (0 > i) i = t[0];else if (i > e) i = t[e];else {
            e = Math.floor(i);
            var a = i - e;
          }
          return typeof a < "u" && typeof t[e] < "u" ? t[e] + (a ? a * (t[e + 1] - t[e]) : 0) : i;
        }
        function v(i) {
          var t = this.ordinal,
            e = t.positions;
          if (!e) return i;
          var a = (i - (this.old ? this.old.min : this.min)) * (this.old ? this.old.transA : this.transA) + this.minPixelPadding;
          if (0 < a && a < this.left + this.len || (t.extendedOrdinalPositions || (t.extendedOrdinalPositions = t.getExtendedPositions()), e = t.extendedOrdinalPositions), e && e.length) {
            if (i = t.getIndexOfPoint(a, e), t = W(i % 1), 0 <= i && i < e.length - 1) return e[Math.floor(i)] + t * (e[Math.ceil(i)] - e[Math.floor(i)]);
            t = e.length, a = e[0], e = e[t - 1];
            var c = (e - a) / (t - 1);
            return 0 > i ? a + c * i : e + c * (i - t);
          }
          return i;
        }
        function M(i, t) {
          var e = s.Additions.findIndexOf(i, t, !0);
          return i[e] === t ? e : e + (t - i[e]) / (i[e + 1] - i[e]);
        }
        function I() {
          this.ordinal || (this.ordinal = new s.Additions(this));
        }
        function L() {
          this.isXAxis && w(this.options.overscroll) && this.max === this.dataMax && (!this.chart.mouseIsDown || this.isInternal) && (!this.eventArgs || this.eventArgs && this.eventArgs.trigger !== "navigator") && (this.max += this.options.overscroll, !this.isInternal && w(this.userMin) && (this.min += this.options.overscroll));
        }
        function C() {
          this.horiz && !this.isDirty && (this.isDirty = this.isOrdinal && this.chart.navigator && !this.chart.navigator.adaptToUpdatedData);
        }
        function m() {
          this.ordinal && (this.ordinal.beforeSetTickPositions(), this.tickInterval = this.ordinal.postProcessTickInterval(this.tickInterval));
        }
        function d(i) {
          var t = this.xAxis[0],
            e = t.options.overscroll,
            a = i.originalEvent.chartX,
            c = this.options.chart.panning,
            y = !1;
          if (c && c.type !== "y" && t.options.ordinal && t.series.length) {
            var b = this.mouseDownX,
              j = t.getExtremes(),
              P = j.dataMax,
              f = j.min,
              x = j.max,
              N = this.hoverPoints,
              R = t.closestPointRange || t.ordinal && t.ordinal.overscrollPointsRange;
            b = (b - a) / (t.translationSlope * (t.ordinal.slope || R)), R = t.ordinal.getExtendedPositions(), R = {
              ordinal: {
                positions: R,
                extendedOrdinalPositions: R
              }
            };
            var F = t.index2val,
              T = t.val2lin,
              G = void 0,
              _ = G = void 0,
              q = void 0;
            R.ordinal.positions ? 1 < Math.abs(b) && (N && N.forEach(function (Y) {
              Y.setState();
            }), 0 > b ? (_ = R, q = t.ordinal.positions ? t : R) : (_ = t.ordinal.positions ? t : R, q = R), G = q.ordinal.positions, P > G[G.length - 1] && G.push(P), this.fixedRange = x - f, G = t.navigatorAxis.toFixedRange(void 0, void 0, F.apply(_, [T.apply(_, [f, !0]) + b]), F.apply(q, [T.apply(q, [x, !0]) + b])), G.min >= Math.min(j.dataMin, f) && G.max <= Math.max(P, x) + e && t.setExtremes(G.min, G.max, !0, !1, {
              trigger: "pan"
            }), this.mouseDownX = a, z(this.container, {
              cursor: "move"
            })) : y = !0;
          } else y = !0;
          y || c && /y/.test(c.type) ? e && (t.max = t.dataMax + e) : i.preventDefault();
        }
        function o() {
          var i = this.xAxis;
          i && i.options.ordinal && (delete i.ordinal.index, delete i.ordinal.extendedOrdinalPositions);
        }
        function n(i, t) {
          var e = this.ordinal,
            a = e.positions,
            c = e.slope,
            y = e.extendedOrdinalPositions;
          if (!a) return i;
          var b = a.length;
          if (a[0] <= i && a[b - 1] >= i) i = M(a, i);else {
            if (y || (y = e.getExtendedPositions && e.getExtendedPositions(), e.extendedOrdinalPositions = y), !y || !y.length) return i;
            b = y.length, c || (c = (y[b - 1] - y[0]) / b), a = M(y, a[0]), i >= y[0] && i <= y[b - 1] ? i = M(y, i) - a : i < y[0] ? (i = y[0] - i, i = -a - i / c) : (i -= y[b - 1], i = i / c + b - a);
          }
          return t ? i : c * (i || 0) + e.offset;
        }
        s.compose = function (i, t, e) {
          if (p.indexOf(i) === -1) {
            p.push(i);
            var a = i.prototype;
            a.getTimeTicks = l, a.index2val = u, a.lin2val = v, a.val2lin = n, a.ordinal2lin = a.val2lin, X(i, "afterInit", I), X(i, "foundExtremes", L), X(i, "afterSetScale", C), X(i, "initialAxisTranslation", m);
          }
          return p.indexOf(e) === -1 && (p.push(e), X(e, "pan", d)), p.indexOf(t) === -1 && (p.push(t), X(t, "updatedData", o)), i;
        };
        var r = function () {
          function i(t) {
            this.index = {}, this.axis = t;
          }
          return i.prototype.beforeSetTickPositions = function () {
            var t = this.axis,
              e = t.ordinal,
              a = t.getExtremes(),
              c = a.min,
              y = a.max,
              b = t.isXAxis && !!t.options.breaks;
            a = t.options.ordinal;
            var j = t.chart.options.chart.ignoreHiddenSeries,
              P,
              f,
              x = [],
              N = Number.MAX_VALUE,
              R = !1,
              F = !1,
              T = !1;
            if (a || b) {
              var G = 0;
              t.series.forEach(function (Y, U) {
                if (P = [], 0 < U && Y.options.id !== "highcharts-navigator-series" && 1 < Y.processedXData.length && (F = G !== Y.processedXData[1] - Y.processedXData[0]), G = Y.processedXData[1] - Y.processedXData[0], Y.boosted && (T = Y.boosted), !(j && Y.visible === !1 || Y.takeOrdinalPosition === !1 && !b) && (x = x.concat(Y.processedXData), _ = x.length, x.sort(function (Z, J) {
                  return Z - J;
                }), N = Math.min(N, k(Y.closestPointRange, N)), _)) {
                  for (U = 0; U < _ - 1;) x[U] !== x[U + 1] && P.push(x[U + 1]), U++;
                  P[0] !== x[0] && P.unshift(x[0]), x = P;
                }
              }), F && T && (x.pop(), x.shift());
              var _ = x.length;
              if (2 < _) {
                var q = x[1] - x[0];
                for (f = _ - 1; f-- && !R;) x[f + 1] - x[f] !== q && (R = !0);
                !t.options.keepOrdinalPadding && (x[0] - c > q || y - x[x.length - 1] > q) && (R = !0);
              } else t.options.overscroll && (_ === 2 ? N = x[1] - x[0] : _ === 1 ? (N = t.options.overscroll, x = [x[0], x[0] + N]) : N = e.overscrollPointsRange);
              R || t.forceOrdinal ? (t.options.overscroll && (e.overscrollPointsRange = N, x = x.concat(e.getOverscrollPositions())), e.positions = x, q = t.ordinal2lin(Math.max(c, x[0]), !0), f = Math.max(t.ordinal2lin(Math.min(y, x[x.length - 1]), !0), 1), e.slope = y = (y - c) / (f - q), e.offset = c - q * y) : (e.overscrollPointsRange = k(t.closestPointRange, e.overscrollPointsRange), e.positions = t.ordinal.slope = e.offset = void 0);
            }
            t.isOrdinal = a && R, e.groupIntervalFactor = null;
          }, i.findIndexOf = function (t, e, a) {
            for (var c = 0, y = t.length - 1, b; c < y;) b = Math.ceil((c + y) / 2), t[b] <= e ? c = b : y = b - 1;
            return t[c] === e || a ? c : -1;
          }, i.prototype.getExtendedPositions = function () {
            var t = this,
              e = t.axis,
              a = e.constructor.prototype,
              c = e.chart,
              y = e.series[0].currentDataGrouping,
              b = y ? y.count + y.unitName : "raw",
              j = e.options.overscroll,
              P = e.getExtremes(),
              f = void 0,
              x = t.index;
            if (x || (x = t.index = {}), !x[b]) {
              var N = {
                series: [],
                chart: c,
                forceOrdinal: !1,
                getExtremes: function getExtremes() {
                  return {
                    min: P.dataMin,
                    max: P.dataMax + j
                  };
                },
                getGroupPixelWidth: a.getGroupPixelWidth,
                getTimeTicks: a.getTimeTicks,
                options: {
                  ordinal: !0
                },
                ordinal: {
                  getGroupIntervalFactor: this.getGroupIntervalFactor
                },
                ordinal2lin: a.ordinal2lin,
                getIndexOfPoint: a.getIndexOfPoint,
                val2lin: a.val2lin
              };
              N.ordinal.axis = N, e.series.forEach(function (R) {
                f = {
                  xAxis: N,
                  xData: R.xData.slice(),
                  chart: c,
                  destroyGroupedData: E.noop,
                  getProcessedData: B.prototype.getProcessedData,
                  applyGrouping: B.prototype.applyGrouping
                }, f.xData = f.xData.concat(t.getOverscrollPositions()), f.options = {
                  dataGrouping: y ? {
                    firstAnchor: "firstPoint",
                    anchor: "middle",
                    lastAnchor: "lastPoint",
                    enabled: !0,
                    forced: !0,
                    approximation: "open",
                    units: [[y.unitName, [y.count]]]
                  } : {
                    enabled: !1
                  }
                }, N.series.push(f), R.processData.apply(f);
              }), f.closestPointRange !== f.basePointRange && f.currentDataGrouping && (N.forceOrdinal = !0), e.ordinal.beforeSetTickPositions.apply({
                axis: N
              }), x[b] = N.ordinal.positions;
            }
            return x[b];
          }, i.prototype.getGroupIntervalFactor = function (t, e, a) {
            a = a.processedXData;
            var c = a.length,
              y = [],
              b = this.groupIntervalFactor;
            if (!b) {
              for (b = 0; b < c - 1; b++) y[b] = a[b + 1] - a[b];
              y.sort(function (j, P) {
                return j - P;
              }), y = y[Math.floor(c / 2)], t = Math.max(t, a[0]), e = Math.min(e, a[c - 1]), this.groupIntervalFactor = b = c * y / (e - t);
            }
            return b;
          }, i.prototype.getIndexOfPoint = function (t, e) {
            var a = this.axis,
              c = this.positions ? this.positions[0] : 0,
              y = a.series[0].points && a.series[0].points[0] && a.series[0].points[0].plotX || a.minPixelPadding;
            return 1 < a.series.length && a.series.forEach(function (b) {
              b.points && w(b.points[0]) && w(b.points[0].plotX) && b.points[0].plotX < y && b.points[0].plotX >= k(a.min, -1 / 0) && (y = b.points[0].plotX);
            }), t = (t - y) / (a.translationSlope * (this.slope || a.closestPointRange || this.overscrollPointsRange)), i.findIndexOf(e, c) + t;
          }, i.prototype.getOverscrollPositions = function () {
            var t = this.axis,
              e = t.options.overscroll,
              a = this.overscrollPointsRange,
              c = [],
              y = t.dataMax;
            if (w(a)) for (; y <= t.dataMax + e;) y += a, c.push(y);
            return c;
          }, i.prototype.postProcessTickInterval = function (t) {
            var e = this.axis,
              a = this.slope;
            return a ? e.options.breaks ? e.closestPointRange || t : t / (a / e.closestPointRange) : t;
          }, i;
        }();
        s.Additions = r;
      }(h || (h = {})), h;
    }), V(S, "Series/HLC/HLCPoint.js", [S["Core/Series/SeriesRegistry.js"]], function (D) {
      var E = this && this.__extends || function () {
        var _B = function B(H, X) {
          return _B = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (W, z) {
            W.__proto__ = z;
          } || function (W, z) {
            for (var w in z) z.hasOwnProperty(w) && (W[w] = z[w]);
          }, _B(H, X);
        };
        return function (H, X) {
          function W() {
            this.constructor = H;
          }
          _B(H, X), H.prototype = X === null ? Object.create(X) : (W.prototype = X.prototype, new W());
        };
      }();
      return function (B) {
        function H() {
          var X = B !== null && B.apply(this, arguments) || this;
          return X.close = void 0, X.high = void 0, X.low = void 0, X.options = void 0, X.plotClose = void 0, X.series = void 0, X;
        }
        return E(H, B), H;
      }(D.seriesTypes.column.prototype.pointClass);
    }), V(S, "Series/HLC/HLCSeriesDefaults.js", [], function () {
      return {
        lineWidth: 1,
        tooltip: {
          pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'
        },
        threshold: null,
        states: {
          hover: {
            lineWidth: 3
          }
        },
        stickyTracking: !0
      };
    }), V(S, "Series/HLC/HLCSeries.js", [S["Series/HLC/HLCPoint.js"], S["Series/HLC/HLCSeriesDefaults.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = this && this.__extends || function () {
          var _A = function A(k, g) {
            return _A = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (p, h) {
              p.__proto__ = h;
            } || function (p, h) {
              for (var s in h) h.hasOwnProperty(s) && (p[s] = h[s]);
            }, _A(k, g);
          };
          return function (k, g) {
            function p() {
              this.constructor = k;
            }
            _A(k, g), k.prototype = g === null ? Object.create(g) : (p.prototype = g.prototype, new p());
          };
        }(),
        W = B.seriesTypes.column,
        z = H.extend,
        w = H.merge;
      return H = function (A) {
        function k() {
          var g = A !== null && A.apply(this, arguments) || this;
          return g.data = void 0, g.options = void 0, g.points = void 0, g.yData = void 0, g;
        }
        return X(k, A), k.prototype.extendStem = function (g, p, h) {
          var s = g[0];
          g = g[1], typeof s[2] == "number" && (s[2] = Math.max(h + p, s[2])), typeof g[2] == "number" && (g[2] = Math.min(h - p, g[2]));
        }, k.prototype.getPointPath = function (g, p) {
          p = p.strokeWidth();
          var h = g.series,
            s = p % 2 / 2,
            l = Math.round(g.plotX) - s,
            u = Math.round(g.shapeArgs.width / 2),
            v = [["M", l, Math.round(g.yBottom)], ["L", l, Math.round(g.plotHigh)]];
          return g.close !== null && (g = Math.round(g.plotClose) + s, v.push(["M", l, g], ["L", l + u, g]), h.extendStem(v, p / 2, g)), v;
        }, k.prototype.drawSinglePoint = function (g) {
          var p = g.series,
            h = p.chart,
            s = g.graphic;
          typeof g.plotY < "u" && (s || (g.graphic = s = h.renderer.path().add(p.group)), h.styledMode || s.attr(p.pointAttribs(g, g.selected && "select")), p = p.getPointPath(g, s), s[s ? "animate" : "attr"]({
            d: p
          }).addClass(g.getClassName(), !0));
        }, k.prototype.drawPoints = function () {
          this.points.forEach(this.drawSinglePoint);
        }, k.prototype.init = function () {
          A.prototype.init.apply(this, arguments), this.options.stacking = void 0;
        }, k.prototype.pointAttribs = function (g, p) {
          return g = A.prototype.pointAttribs.call(this, g, p), delete g.fill, g;
        }, k.prototype.toYData = function (g) {
          return [g.high, g.low, g.close];
        }, k.prototype.translate = function () {
          var g = this,
            p = g.yAxis,
            h = this.pointArrayMap && this.pointArrayMap.slice() || [],
            s = h.map(function (l) {
              return "plot".concat(l.charAt(0).toUpperCase() + l.slice(1));
            });
          s.push("yBottom"), h.push("low"), A.prototype.translate.apply(g), g.points.forEach(function (l) {
            h.forEach(function (u, v) {
              u = l[u], u !== null && (g.dataModify && (u = g.dataModify.modifyValue(u)), l[s[v]] = p.toPixels(u, !0));
            }), l.tooltipPos[1] = l.plotHigh + p.pos - g.chart.plotTop;
          });
        }, k.defaultOptions = w(W.defaultOptions, E), k;
      }(W), z(H.prototype, {
        pointClass: D,
        animate: null,
        directTouch: !1,
        pointArrayMap: ["high", "low", "close"],
        pointAttrToOptions: {
          stroke: "color",
          "stroke-width": "lineWidth"
        },
        pointValKey: "close"
      }), B.registerSeriesType("hlc", H), H;
    }), V(S, "Series/OHLC/OHLCPoint.js", [S["Core/Series/SeriesRegistry.js"]], function (D) {
      var E = this && this.__extends || function () {
        var _B2 = function B(H, X) {
          return _B2 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (W, z) {
            W.__proto__ = z;
          } || function (W, z) {
            for (var w in z) z.hasOwnProperty(w) && (W[w] = z[w]);
          }, _B2(H, X);
        };
        return function (H, X) {
          function W() {
            this.constructor = H;
          }
          _B2(H, X), H.prototype = X === null ? Object.create(X) : (W.prototype = X.prototype, new W());
        };
      }();
      return function (B) {
        function H() {
          var X = B !== null && B.apply(this, arguments) || this;
          return X.open = void 0, X.options = void 0, X.plotOpen = void 0, X.series = void 0, X;
        }
        return E(H, B), H.prototype.getClassName = function () {
          return B.prototype.getClassName.call(this) + (this.open < this.close ? " highcharts-point-up" : " highcharts-point-down");
        }, H.prototype.resolveUpColor = function () {
          this.open < this.close && !this.options.color && this.series.options.upColor && (this.color = this.series.options.upColor);
        }, H.prototype.resolveColor = function () {
          B.prototype.resolveColor.call(this), this.resolveUpColor();
        }, H.prototype.getZone = function () {
          var X = B.prototype.getZone.call(this);
          return this.resolveUpColor(), X;
        }, H.prototype.applyOptions = function () {
          return B.prototype.applyOptions.apply(this, arguments), this.resolveColor && this.resolveColor(), this;
        }, H;
      }(D.seriesTypes.hlc.prototype.pointClass);
    }), V(S, "Series/OHLC/OHLCSeriesDefaults.js", [], function () {
      return {
        tooltip: {
          pointFormat: '<span style="color:{point.color}">●</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'
        }
      };
    }), V(S, "Series/OHLC/OHLCSeries.js", [S["Series/OHLC/OHLCPoint.js"], S["Series/OHLC/OHLCSeriesDefaults.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      function X(s) {
        s = s.options;
        var l = s.dataGrouping;
        l && s.useOhlcData && s.id !== "highcharts-navigator-series" && (l.approximation = "ohlc");
      }
      function W(s) {
        s = s.options, s.useOhlcData && s.id !== "highcharts-navigator-series" && k(this, {
          pointValKey: h.prototype.pointValKey,
          pointArrayMap: h.prototype.pointArrayMap,
          toYData: h.prototype.toYData
        });
      }
      var z = this && this.__extends || function () {
          var _s4 = function s(l, u) {
            return _s4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (v, M) {
              v.__proto__ = M;
            } || function (v, M) {
              for (var I in M) M.hasOwnProperty(I) && (v[I] = M[I]);
            }, _s4(l, u);
          };
          return function (l, u) {
            function v() {
              this.constructor = l;
            }
            _s4(l, u), l.prototype = u === null ? Object.create(u) : (v.prototype = u.prototype, new v());
          };
        }(),
        w = B.seriesTypes.hlc,
        A = H.addEvent,
        k = H.extend,
        g = H.merge,
        p = [],
        h = function (s) {
          function l() {
            var u = s !== null && s.apply(this, arguments) || this;
            return u.data = void 0, u.options = void 0, u.points = void 0, u;
          }
          return z(l, s), l.compose = function (u) {
            p.indexOf(u) === -1 && (p.push(u), A(u, "afterSetOptions", X), A(u, "init", W));
          }, l.prototype.getPointPath = function (u, v) {
            var M = s.prototype.getPointPath.call(this, u, v);
            v = v.strokeWidth();
            var I = v % 2 / 2,
              L = Math.round(u.plotX) - I,
              C = Math.round(u.shapeArgs.width / 2);
            return u.open !== null && (u = Math.round(u.plotOpen) + I, M.push(["M", L, u], ["L", L - C, u]), s.prototype.extendStem.call(this, M, v / 2, u)), M;
          }, l.prototype.pointAttribs = function (u, v) {
            v = s.prototype.pointAttribs.call(this, u, v);
            var M = this.options;
            return delete v.fill, !u.options.color && M.upColor && u.open < u.close && (v.stroke = M.upColor), v;
          }, l.prototype.toYData = function (u) {
            return [u.open, u.high, u.low, u.close];
          }, l.defaultOptions = g(w.defaultOptions, E), l;
        }(w);
      return k(h.prototype, {
        pointClass: D,
        pointArrayMap: ["open", "high", "low", "close"]
      }), B.registerSeriesType("ohlc", h), h;
    }), V(S, "Series/Candlestick/CandlestickSeriesDefaults.js", [S["Core/Defaults.js"], S["Core/Utilities.js"]], function (D, E) {
      return {
        states: {
          hover: {
            lineWidth: 2
          }
        },
        threshold: null,
        lineColor: "#000000",
        lineWidth: 1,
        upColor: "#ffffff",
        stickyTracking: !0
      };
    }), V(S, "Series/Candlestick/CandlestickSeries.js", [S["Series/Candlestick/CandlestickSeriesDefaults.js"], S["Core/Defaults.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E, B, H) {
      var X = this && this.__extends || function () {
          var _k7 = function k(g, p) {
            return _k7 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k7(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k7(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        W = E.defaultOptions;
      E = B.seriesTypes;
      var z = E.column,
        w = E.ohlc,
        A = H.merge;
      return H = function (k) {
        function g() {
          var p = k !== null && k.apply(this, arguments) || this;
          return p.data = void 0, p.options = void 0, p.points = void 0, p;
        }
        return X(g, k), g.prototype.pointAttribs = function (p, h) {
          var s = z.prototype.pointAttribs.call(this, p, h),
            l = this.options,
            u = p.open < p.close,
            v = l.lineColor || this.color,
            M = p.color || this.color;
          return s["stroke-width"] = l.lineWidth, s.fill = p.options.color || u && l.upColor || M, s.stroke = p.options.lineColor || u && l.upLineColor || v, h && (p = l.states[h], s.fill = p.color || s.fill, s.stroke = p.lineColor || s.stroke, s["stroke-width"] = p.lineWidth || s["stroke-width"]), s;
        }, g.prototype.drawPoints = function () {
          for (var p = this.chart, h = this.yAxis.reversed, s = 0, l = this.points; s < l.length; s++) {
            var u = l[s],
              v = u.graphic,
              M = !v;
            if (typeof u.plotY < "u") {
              v || (u.graphic = v = p.renderer.path().add(this.group)), this.chart.styledMode || v.attr(this.pointAttribs(u, u.selected && "select")).shadow(this.options.shadow);
              var I = v.strokeWidth() % 2 / 2,
                L = Math.round(u.plotX) - I,
                C = u.plotOpen,
                m = u.plotClose,
                d = Math.min(C, m);
              C = Math.max(C, m);
              var o = Math.round(u.shapeArgs.width / 2);
              m = h ? C !== u.yBottom : Math.round(d) !== Math.round(u.plotHigh);
              var n = h ? Math.round(d) !== Math.round(u.plotHigh) : C !== u.yBottom;
              d = Math.round(d) + I, C = Math.round(C) + I, I = [], I.push(["M", L - o, C], ["L", L - o, d], ["L", L + o, d], ["L", L + o, C], ["Z"], ["M", L, d], ["L", L, m ? Math.round(h ? u.yBottom : u.plotHigh) : d], ["M", L, C], ["L", L, n ? Math.round(h ? u.plotHigh : u.yBottom) : C]), v[M ? "attr" : "animate"]({
                d: I
              }).addClass(u.getClassName(), !0);
            }
          }
        }, g.defaultOptions = A(w.defaultOptions, W.plotOptions, {
          tooltip: w.defaultOptions.tooltip
        }, D), g;
      }(w), B.registerSeriesType("candlestick", H), H;
    }), V(S, "Series/Flags/FlagsPoint.js", [S["Core/Series/SeriesRegistry.js"], S["Core/Utilities.js"]], function (D, E) {
      var B = this && this.__extends || function () {
          var _X2 = function X(W, z) {
            return _X2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (w, A) {
              w.__proto__ = A;
            } || function (w, A) {
              for (var k in A) A.hasOwnProperty(k) && (w[k] = A[k]);
            }, _X2(W, z);
          };
          return function (W, z) {
            function w() {
              this.constructor = W;
            }
            _X2(W, z), W.prototype = z === null ? Object.create(z) : (w.prototype = z.prototype, new w());
          };
        }(),
        H = E.isNumber;
      return function (X) {
        function W() {
          var z = X !== null && X.apply(this, arguments) || this;
          return z.options = void 0, z.series = void 0, z.ttBelow = !1, z;
        }
        return B(W, X), W.prototype.isValid = function () {
          return H(this.y) || typeof this.y > "u";
        }, W.prototype.hasNewShapeType = function () {
          var z = this.options.shape || this.series.options.shape;
          return this.graphic && z && z !== this.graphic.symbolKey;
        }, W;
      }(D.seriesTypes.column.prototype.pointClass);
    }), V(S, "Series/Flags/FlagsSeriesDefaults.js", [], function () {
      return {
        pointRange: 0,
        allowOverlapX: !1,
        shape: "flag",
        stackDistance: 12,
        textAlign: "center",
        tooltip: {
          pointFormat: "{point.text}"
        },
        threshold: null,
        y: -30,
        fillColor: "#ffffff",
        lineWidth: 1,
        states: {
          hover: {
            lineColor: "#000000",
            fillColor: "#ccd6eb"
          }
        },
        style: {
          fontSize: "11px",
          fontWeight: "bold"
        }
      };
    }), V(S, "Series/Flags/FlagsSymbols.js", [S["Core/Renderer/RendererRegistry.js"]], function (D) {
      var E;
      return function (B) {
        function H(z, w, A, k, g) {
          var p = g && g.anchorX || z;
          g = g && g.anchorY || w;
          var h = this.circle(p - 1, g - 1, 2, 2);
          return h.push(["M", p, g], ["L", z, w + k], ["L", z, w], ["L", z + A, w], ["L", z + A, w + k], ["L", z, w + k], ["Z"]), h;
        }
        function X(z, w) {
          z[w + "pin"] = function (A, k, g, p, h) {
            var s = h && h.anchorX;
            h = h && h.anchorY, w === "circle" && p > g && (A -= Math.round((p - g) / 2), g = p);
            var l = z[w](A, k, g, p);
            if (s && h) {
              var u = s;
              w === "circle" ? u = A + g / 2 : (A = l[0], g = l[1], A[0] === "M" && g[0] === "L" && (u = (A[1] + g[1]) / 2)), l.push(["M", u, k > h ? k : k + p], ["L", s, h]), l = l.concat(z.circle(s - 1, h - 1, 2, 2));
            }
            return l;
          };
        }
        var W = [];
        B.compose = function (z) {
          if (W.indexOf(z) === -1) {
            W.push(z);
            var w = z.prototype.symbols;
            w.flag = H, X(w, "circle"), X(w, "square");
          }
          var A = D.getRendererType();
          W.indexOf(A) && (W.push(A), w = z.prototype.symbols, z = A.prototype.symbols, z.circlepin = w.circlepin, z.flag = w.flag.bind(w), z.squarepin = w.squarepin);
        };
      }(E || (E = {})), E;
    }), V(S, "Series/OnSeriesComposition.js", [S["Series/Column/ColumnSeries.js"], S["Core/Series/Series.js"], S["Core/Utilities.js"]], function (D, E, B) {
      var H = D.prototype,
        X = E.prototype,
        W = B.defined,
        z = B.stableSort,
        w;
      return function (A) {
        function k(h) {
          return X.getPlotBox.call(this.options.onSeries && this.chart.get(this.options.onSeries) || this, h);
        }
        function g() {
          H.translate.apply(this);
          var h = this,
            s = h.options,
            l = h.chart,
            u = h.points,
            v = s.onSeries,
            M = (v = v && l.get(v)) && v.options.step,
            I = v && v.points,
            L = l.inverted,
            C = h.xAxis,
            m = h.yAxis;
          l = u.length - 1;
          var d;
          s = s.onKey || "y";
          var o = I && I.length,
            n = 0,
            r;
          if (v && v.visible && o) {
            n = (v.pointXOffset || 0) + (v.barW || 0) / 2;
            var i = v.currentDataGrouping,
              t = I[o - 1].x + (i ? i.totalRange : 0);
            for (z(u, function (c, y) {
              return c.x - y.x;
            }), s = "plot" + s[0].toUpperCase() + s.substr(1); o-- && u[l];) {
              var e = I[o];
              if (i = u[l], i.y = e.y, e.x <= i.x && typeof e[s] < "u") {
                if (i.x <= t && (i.plotY = e[s], e.x < i.x && !M && (r = I[o + 1]) && typeof r[s] < "u")) {
                  var a = (i.x - e.x) / (r.x - e.x);
                  i.plotY += a * (r[s] - e[s]), i.y += a * (r.y - e.y);
                }
                if (l--, o++, 0 > l) break;
              }
            }
          }
          u.forEach(function (c, y) {
            if (c.plotX += n, (typeof c.plotY > "u" || L) && (0 <= c.plotX && c.plotX <= C.len ? L ? (c.plotY = C.translate(c.x, 0, 1, 0, 1), c.plotX = W(c.y) ? m.translate(c.y, 0, 0, 0, 1) : 0) : c.plotY = (C.opposite ? 0 : h.yAxis.len) + C.offset : c.shapeArgs = {}), (d = u[y - 1]) && d.plotX === c.plotX) {
              typeof d.stackIndex > "u" && (d.stackIndex = 0);
              var b = d.stackIndex + 1;
            }
            c.stackIndex = b;
          }), this.onSeries = v;
        }
        var p = [];
        A.compose = function (h) {
          if (p.indexOf(h) === -1) {
            p.push(h);
            var s = h.prototype;
            s.getPlotBox = k, s.translate = g;
          }
          return h;
        }, A.getPlotBox = k, A.translate = g;
      }(w || (w = {})), w;
    }), V(S, "Series/Flags/FlagsSeries.js", [S["Series/Flags/FlagsPoint.js"], S["Series/Flags/FlagsSeriesDefaults.js"], S["Series/Flags/FlagsSymbols.js"], S["Core/Globals.js"], S["Series/OnSeriesComposition.js"], S["Core/Renderer/RendererUtilities.js"], S["Core/Series/SeriesRegistry.js"], S["Core/Renderer/SVG/SVGElement.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z, w, A) {
      var k = this && this.__extends || function () {
        var _I2 = function I(L, C) {
          return _I2 = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (m, d) {
            m.__proto__ = d;
          } || function (m, d) {
            for (var o in d) d.hasOwnProperty(o) && (m[o] = d[o]);
          }, _I2(L, C);
        };
        return function (L, C) {
          function m() {
            this.constructor = L;
          }
          _I2(L, C), L.prototype = C === null ? Object.create(C) : (m.prototype = C.prototype, new m());
        };
      }();
      H = H.noop;
      var g = W.distribute,
        p = z.series,
        h = z.seriesTypes.column,
        s = A.addEvent,
        l = A.defined;
      W = A.extend;
      var u = A.merge,
        v = A.objectEach,
        M = A.wrap;
      return A = function (I) {
        function L() {
          var C = I !== null && I.apply(this, arguments) || this;
          return C.data = void 0, C.options = void 0, C.points = void 0, C;
        }
        return k(L, I), L.prototype.animate = function (C) {
          C && this.setClip();
        }, L.prototype.drawPoints = function () {
          var C = this.points,
            m = this.chart,
            d = m.renderer,
            o = m.inverted,
            n = this.options,
            r = n.y,
            i = this.yAxis,
            t = {},
            e = [],
            a;
          for (a = C.length; a--;) {
            var c = C[a],
              y = (o ? c.plotY : c.plotX) > this.xAxis.len,
              b = c.plotX,
              j = c.stackIndex,
              P = c.options.shape || n.shape,
              f = c.plotY;
            typeof f < "u" && (f = c.plotY + r - (typeof j < "u" && j * n.stackDistance)), c.anchorX = j ? void 0 : c.plotX;
            var x = j ? void 0 : c.plotY,
              N = P !== "flag";
            j = c.graphic, typeof f < "u" && 0 <= b && !y ? (j && c.hasNewShapeType() && (j = j.destroy()), j || (j = c.graphic = d.label("", null, null, P, null, null, n.useHTML).addClass("highcharts-point").add(this.markerGroup), c.graphic.div && (c.graphic.div.point = c), j.isNew = !0), j.attr({
              align: N ? "center" : "left",
              width: n.width,
              height: n.height,
              "text-align": n.textAlign
            }), m.styledMode || j.attr(this.pointAttribs(c)).css(u(n.style, c.style)).shadow(n.shadow), 0 < b && (b -= j.strokeWidth() % 2), P = {
              y: f,
              anchorY: x
            }, n.allowOverlapX && (P.x = b, P.anchorX = c.anchorX), j.attr({
              text: c.options.title || n.title || "A"
            })[j.isNew ? "attr" : "animate"](P), n.allowOverlapX || (t[c.plotX] ? t[c.plotX].size = Math.max(t[c.plotX].size, j.width) : t[c.plotX] = {
              align: N ? 0.5 : 0,
              size: j.width,
              target: b,
              anchorX: b
            }), c.tooltipPos = [b, f + i.pos - m.plotTop]) : j && (c.graphic = j.destroy());
          }
          if (!n.allowOverlapX) {
            var R = 100;
            for (v(t, function (F) {
              F.plotX = F.anchorX, e.push(F), R = Math.max(F.size, R);
            }), g(e, o ? i.len : this.xAxis.len, R), m = 0; m < C.length; m++) d = C[m], r = d.plotX, (r = (o = d.graphic) && t[r]) && o && (l(r.pos) ? o[o.isNew ? "attr" : "animate"]({
              x: r.pos + (r.align || 0) * r.size,
              anchorX: d.anchorX
            }).show().isNew = !1 : o.hide().isNew = !0);
          }
          n.useHTML && this.markerGroup && M(this.markerGroup, "on", function (F) {
            return w.prototype.on.apply(F.apply(this, [].slice.call(arguments, 1)), [].slice.call(arguments, 1));
          });
        }, L.prototype.drawTracker = function () {
          var C = this.points;
          I.prototype.drawTracker.call(this);
          for (var m = function m(o) {
              var n = o.graphic;
              n && (o.unbindMouseOver && o.unbindMouseOver(), o.unbindMouseOver = s(n.element, "mouseover", function () {
                0 < o.stackIndex && !o.raised && (o._y = n.y, n.attr({
                  y: o._y - 8
                }), o.raised = !0);
                for (var r = 0; r < C.length; r++) {
                  var i = C[r];
                  i !== o && i.raised && i.graphic && (i.graphic.attr({
                    y: i._y
                  }), i.raised = !1);
                }
              }));
            }, d = 0; d < C.length; d++) m(C[d]);
        }, L.prototype.pointAttribs = function (C, m) {
          var d = this.options,
            o = C && C.color || this.color,
            n = d.lineColor,
            r = C && C.lineWidth;
          return C = C && C.fillColor || d.fillColor, m && (C = d.states[m].fillColor, n = d.states[m].lineColor, r = d.states[m].lineWidth), {
            fill: C || o,
            stroke: n || o,
            "stroke-width": r || d.lineWidth || 0
          };
        }, L.prototype.setClip = function () {
          p.prototype.setClip.apply(this, arguments), this.options.clip !== !1 && this.sharedClipKey && this.markerGroup && this.markerGroup.clip(this.chart.sharedClips[this.sharedClipKey]);
        }, L.compose = B.compose, L.defaultOptions = u(h.defaultOptions, E), L;
      }(h), X.compose(A), W(A.prototype, {
        allowDG: !1,
        forceCrop: !0,
        invertible: !1,
        noSharedTooltip: !0,
        pointClass: D,
        sorted: !1,
        takeOrdinalPosition: !1,
        trackerGroups: ["markerGroup"],
        buildKDTree: H,
        init: p.prototype.init
      }), z.registerSeriesType("flags", A), A;
    }), V(S, "Core/Chart/StockChart.js", [S["Core/Axis/Axis.js"], S["Core/Chart/Chart.js"], S["Core/FormatUtilities.js"], S["Core/Defaults.js"], S["Stock/Navigator/NavigatorDefaults.js"], S["Stock/RangeSelector/RangeSelectorDefaults.js"], S["Stock/Scrollbar/ScrollbarDefaults.js"], S["Core/Series/Series.js"], S["Core/Renderer/SVG/SVGRenderer.js"], S["Core/Utilities.js"]], function (D, E, B, H, X, W, z, w, A, k) {
      function g(n, r) {
        return n === "xAxis" ? {
          minPadding: 0,
          maxPadding: 0,
          overscroll: 0,
          ordinal: !0,
          title: {
            text: null
          },
          labels: {
            overflow: "justify"
          },
          showLastLabel: !0
        } : n === "yAxis" ? {
          labels: {
            y: -2
          },
          opposite: d(r.opposite, !0),
          showLastLabel: !(!r.categories && r.type !== "category"),
          title: {
            text: null
          }
        } : {};
      }
      function p(n, r) {
        return n === "xAxis" ? (n = {
          type: "datetime",
          categories: void 0
        }, d(r.navigator && r.navigator.enabled, X.enabled, !0) && (n.startOnTick = !1, n.endOnTick = !1), n) : {};
      }
      var h = this && this.__extends || function () {
          var _n2 = function n(r, i) {
            return _n2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (t, e) {
              t.__proto__ = e;
            } || function (t, e) {
              for (var a in e) e.hasOwnProperty(a) && (t[a] = e[a]);
            }, _n2(r, i);
          };
          return function (r, i) {
            function t() {
              this.constructor = r;
            }
            _n2(r, i), r.prototype = i === null ? Object.create(i) : (t.prototype = i.prototype, new t());
          };
        }(),
        s = B.format,
        l = H.getOptions;
      B = k.addEvent;
      var u = k.clamp,
        v = k.defined,
        M = k.extend,
        I = k.find,
        L = k.isNumber,
        C = k.isString,
        m = k.merge,
        d = k.pick,
        o = k.splat;
      return k = function (n) {
        function r() {
          return n !== null && n.apply(this, arguments) || this;
        }
        return h(r, n), r.prototype.init = function (i, t) {
          var e = l(),
            a = i.xAxis,
            c = i.yAxis,
            y = d(i.navigator && i.navigator.enabled, X.enabled, !0);
          i.xAxis = i.yAxis = void 0, y = m({
            chart: {
              panning: {
                enabled: !0,
                type: "x"
              },
              zooming: {
                pinchType: "x"
              }
            },
            navigator: {
              enabled: y
            },
            scrollbar: {
              enabled: d(z.enabled, !0)
            },
            rangeSelector: {
              enabled: d(W.rangeSelector.enabled, !0)
            },
            title: {
              text: null
            },
            tooltip: {
              split: d(e.tooltip.split, !0),
              crosshairs: !0
            },
            legend: {
              enabled: !1
            }
          }, i, {
            isStock: !0
          }), i.xAxis = a, i.yAxis = c, y.xAxis = o(i.xAxis || {}).map(function (b, j) {
            return m(g("xAxis", b), e.xAxis, e.xAxis && e.xAxis[j], b, p("xAxis", i));
          }), y.yAxis = o(i.yAxis || {}).map(function (b, j) {
            return m(g("yAxis", b), e.yAxis, e.yAxis && e.yAxis[j], b);
          }), n.prototype.init.call(this, y, t);
        }, r.prototype.createAxis = function (i, t) {
          return t.axis = m(g(i, t.axis), t.axis, p(i, this.userOptions)), n.prototype.createAxis.call(this, i, t);
        }, r;
      }(E), function (n) {
        n.stockChart = function (r, i, t) {
          return new n(r, i, t);
        };
      }(k || (k = {})), B(w, "setOptions", function (n) {
        var r;
        this.chart.options.isStock && (this.is("column") || this.is("columnrange") ? r = {
          borderWidth: 0,
          shadow: !1
        } : this.is("scatter") || this.is("sma") || (r = {
          marker: {
            enabled: !1,
            radius: 2
          }
        }), r && (n.plotOptions[this.type] = m(n.plotOptions[this.type], r)));
      }), B(D, "autoLabelAlign", function (n) {
        var r = this.chart,
          i = this.options;
        r = r._labelPanes = r._labelPanes || {};
        var t = this.options.labels;
        this.chart.options.isStock && this.coll === "yAxis" && (i = i.top + "," + i.height, !r[i] && t.enabled && (t.x === 15 && (t.x = 0), typeof t.align > "u" && (t.align = "right"), r[i] = this, n.align = "right", n.preventDefault()));
      }), B(D, "destroy", function () {
        var n = this.chart,
          r = this.options && this.options.top + "," + this.options.height;
        r && n._labelPanes && n._labelPanes[r] === this && delete n._labelPanes[r];
      }), B(D, "getPlotLinePath", function (n) {
        function r(Y) {
          var U = Y === "xAxis" ? "yAxis" : "xAxis";
          return Y = i.options[U], L(Y) ? [e[U][Y]] : C(Y) ? [e.get(Y)] : t.map(function (Z) {
            return Z[U];
          });
        }
        var i = this,
          t = this.isLinked && !this.series ? this.linkedParent.series : this.series,
          e = i.chart,
          a = e.renderer,
          c = i.left,
          y = i.top,
          b,
          j,
          P,
          f,
          x = [],
          N = [],
          R = n.translatedValue,
          F = n.value,
          T = n.force;
        if (e.options.isStock && n.acrossPanes !== !1 && i.coll === "xAxis" || i.coll === "yAxis") {
          n.preventDefault(), N = r(i.coll);
          var G = i.isXAxis ? e.yAxis : e.xAxis;
          G.forEach(function (Y) {
            if (!v(Y.options.id) || Y.options.id.indexOf("navigator") === -1) {
              var U = Y.isXAxis ? "yAxis" : "xAxis";
              U = v(Y.options[U]) ? e[U][Y.options[U]] : e[U][0], i === U && N.push(Y);
            }
          });
          var _ = N.length ? [] : [i.isXAxis ? e.yAxis[0] : e.xAxis[0]];
          N.forEach(function (Y) {
            _.indexOf(Y) !== -1 || I(_, function (U) {
              return U.pos === Y.pos && U.len === Y.len;
            }) || _.push(Y);
          });
          var q = d(R, i.translate(F, void 0, void 0, n.old));
          L(q) && (i.horiz ? _.forEach(function (Y) {
            var U;
            j = Y.pos, f = j + Y.len, b = P = Math.round(q + i.transB), T !== "pass" && (b < c || b > c + i.width) && (T ? b = P = u(b, c, c + i.width) : U = !0), U || x.push(["M", b, j], ["L", P, f]);
          }) : _.forEach(function (Y) {
            var U;
            b = Y.pos, P = b + Y.len, j = f = Math.round(y + i.height - q), T !== "pass" && (j < y || j > y + i.height) && (T ? j = f = u(j, y, y + i.height) : U = !0), U || x.push(["M", b, j], ["L", P, f]);
          })), n.path = 0 < x.length ? a.crispPolyLine(x, n.lineWidth || 1) : null;
        }
      }), A.prototype.crispPolyLine = function (n, r) {
        for (var i = 0; i < n.length; i += 2) {
          var t = n[i],
            e = n[i + 1];
          t[1] === e[1] && (t[1] = e[1] = Math.round(t[1]) - r % 2 / 2), t[2] === e[2] && (t[2] = e[2] = Math.round(t[2]) + r % 2 / 2);
        }
        return n;
      }, B(D, "afterHideCrosshair", function () {
        this.crossLabel && (this.crossLabel = this.crossLabel.hide());
      }), B(D, "afterDrawCrosshair", function (n) {
        var r, i;
        if (this.crosshair && this.crosshair.label && this.crosshair.label.enabled && this.cross && L(this.min) && L(this.max)) {
          var t = this.chart,
            e = this.logarithmic,
            a = this.crosshair.label,
            c = this.horiz,
            y = this.opposite,
            b = this.left,
            j = this.top,
            P = this.crossLabel,
            f = a.format,
            x = "",
            N = this.options.tickPosition === "inside",
            R = this.crosshair.snap !== !1,
            F = 0,
            T = n.e || this.cross && this.cross.e;
          n = n.point;
          var G = this.min,
            _ = this.max;
          e && (G = e.lin2log(G), _ = e.lin2log(_)), e = c ? "center" : y ? this.labelAlign === "right" ? "right" : "left" : this.labelAlign === "left" ? "left" : "center", P || (P = this.crossLabel = t.renderer.label("", 0, void 0, a.shape || "callout").addClass("highcharts-crosshair-label highcharts-color-" + (n && n.series ? n.series.colorIndex : this.series[0] && this.series[0].colorIndex)).attr({
            align: a.align || e,
            padding: d(a.padding, 8),
            r: d(a.borderRadius, 3),
            zIndex: 2
          }).add(this.labelGroup), t.styledMode || P.attr({
            fill: a.backgroundColor || n && n.series && n.series.color || "#666666",
            stroke: a.borderColor || "",
            "stroke-width": a.borderWidth || 0
          }).css(M({
            color: "#ffffff",
            fontWeight: "normal",
            fontSize: "11px",
            textAlign: "center"
          }, a.style || {}))), c ? (e = R ? (n.plotX || 0) + b : T.chartX, j += y ? 0 : this.height) : (e = y ? this.width + b : 0, j = R ? (n.plotY || 0) + j : T.chartY), f || a.formatter || (this.dateTime && (x = "%b %d, %Y"), f = "{value" + (x ? ":" + x : "") + "}"), x = R ? this.isXAxis ? n.x : n.y : this.toValue(c ? T.chartX : T.chartY), R = n && n.series ? n.series.isPointInside(n) : L(x) && x > G && x < _, T = "", f ? T = s(f, {
            value: x
          }, t) : a.formatter && L(x) && (T = a.formatter.call(this, x)), P.attr({
            text: T,
            x: e,
            y: j,
            visibility: R ? "inherit" : "hidden"
          }), a = P.getBBox(), L(P.y) && (c ? (N && !y || !N && y) && (j = P.y - a.height) : j = P.y - a.height / 2), c ? (r = b - a.x, i = b + this.width - a.x) : (r = this.labelAlign === "left" ? b : 0, i = this.labelAlign === "right" ? b + this.width : t.chartWidth), P.translateX < r && (F = r - P.translateX), P.translateX + a.width >= i && (F = -(P.translateX + a.width - i)), P.attr({
            x: e + F,
            y: j,
            anchorX: c ? e : this.opposite ? 0 : t.chartWidth,
            anchorY: c ? this.opposite ? t.chartHeight : 0 : j + a.height / 2
          });
        }
      }), w.prototype.forceCropping = function () {
        var n = this.chart,
          r = this.options.dataGrouping;
        return this.allowDG !== !1 && r && d(r.enabled, n.options.isStock);
      }, B(E, "update", function (n) {
        n = n.options, "scrollbar" in n && this.navigator && (m(!0, this.options.scrollbar, n.scrollbar), this.navigator.update({}), delete n.scrollbar);
      }), k;
    }), V(S, "masters/modules/stock.src.js", [S["Core/Globals.js"], S["Series/DataModifyComposition.js"], S["Stock/Navigator/Navigator.js"], S["Stock/RangeSelector/RangeSelector.js"], S["Stock/Scrollbar/Scrollbar.js"], S["Core/Axis/OrdinalAxis.js"], S["Series/OHLC/OHLCSeries.js"], S["Series/Flags/FlagsSeries.js"], S["Core/Chart/StockChart.js"]], function (D, E, B, H, X, W, z, w, A) {
      D.Navigator = B, D.RangeSelector = H, D.Scrollbar = X, D.StockChart = D.stockChart = A.stockChart, E.compose(D.Series, D.Axis, D.Point), w.compose(D.Renderer), B.compose(D.Axis, D.Chart, D.Series), z.compose(D.Series), W.compose(D.Axis, D.Series, D.Chart), H.compose(D.Axis, D.Chart), X.compose(D.Axis);
    }), V(S, "masters/highstock.src.js", [S["masters/highcharts.src.js"]], function (D) {
      return D.product = "Highstock", D;
    }), S["masters/highstock.src.js"]._modules = S, S["masters/highstock.src.js"];
  });
})(ui);
var oo = ui.exports;
var Kt = /* @__PURE__ */Xt(oo);
var fi = {
  exports: {}
};
(function (K) {
  (function (O) {
    K.exports ? (O.default = O, K.exports = O) : O(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function (O) {
    function V(S, D, E, B) {
      S.hasOwnProperty(D) || (S[D] = B.apply(null, E), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
        detail: {
          path: D,
          module: S[D]
        }
      })));
    }
    O = O ? O._modules : {}, V(O, "Accessibility/Utils/HTMLUtilities.js", [O["Core/Globals.js"], O["Core/Utilities.js"]], function (S, D) {
      function E(w) {
        if (typeof X.MouseEvent == "function") return new X.MouseEvent(w.type, w);
        if (H.createEvent) {
          var A = H.createEvent("MouseEvent");
          if (A.initMouseEvent) return A.initMouseEvent(w.type, w.bubbles, w.cancelable, w.view || X, w.detail, w.screenX, w.screenY, w.clientX, w.clientY, w.ctrlKey, w.altKey, w.shiftKey, w.metaKey, w.button, w.relatedTarget), A;
        }
        return B(w.type);
      }
      function B(w, A, k) {
        return A = A || {
          x: 0,
          y: 0
        }, typeof X.MouseEvent == "function" ? new X.MouseEvent(w, {
          bubbles: !0,
          cancelable: !0,
          composed: !0,
          button: 0,
          buttons: 1,
          relatedTarget: k || z,
          view: X,
          detail: w === "click" ? 1 : 0,
          screenX: A.x,
          screenY: A.y,
          clientX: A.x,
          clientY: A.y
        }) : H.createEvent && (k = H.createEvent("MouseEvent"), k.initMouseEvent) ? (k.initMouseEvent(w, !0, !0, X, w === "click" ? 1 : 0, A.x, A.y, A.x, A.y, !1, !1, !1, !1, 0, null), k) : {
          type: w
        };
      }
      var H = S.doc,
        X = S.win,
        W = D.css,
        z = X.EventTarget && new X.EventTarget() || "none";
      return {
        addClass: function addClass(w, A) {
          w.classList ? w.classList.add(A) : 0 > w.className.indexOf(A) && (w.className += " " + A);
        },
        cloneMouseEvent: E,
        cloneTouchEvent: function cloneTouchEvent(w) {
          var A = function A(k) {
            for (var g = [], p = 0; p < k.length; ++p) {
              var h = k.item(p);
              h && g.push(h);
            }
            return g;
          };
          return typeof X.TouchEvent == "function" ? (A = new X.TouchEvent(w.type, {
            touches: A(w.touches),
            targetTouches: A(w.targetTouches),
            changedTouches: A(w.changedTouches),
            ctrlKey: w.ctrlKey,
            shiftKey: w.shiftKey,
            altKey: w.altKey,
            metaKey: w.metaKey,
            bubbles: w.bubbles,
            cancelable: w.cancelable,
            composed: w.composed,
            detail: w.detail,
            view: w.view
          }), w.defaultPrevented && A.preventDefault(), A) : (A = E(w), A.touches = w.touches, A.changedTouches = w.changedTouches, A.targetTouches = w.targetTouches, A);
        },
        escapeStringForHTML: function escapeStringForHTML(w) {
          return w.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/\//g, "&#x2F;");
        },
        getElement: function getElement(w) {
          return H.getElementById(w);
        },
        getFakeMouseEvent: B,
        getHeadingTagNameForElement: function getHeadingTagNameForElement(w) {
          var A = function A(g) {
              return g = parseInt(g.slice(1), 10), "h" + Math.min(6, g + 1);
            },
            k = function k(g) {
              var p;
              t: {
                for (p = g; p = p.previousSibling;) {
                  var h = p.tagName || "";
                  if (/H[1-6]/.test(h)) {
                    p = h;
                    break t;
                  }
                }
                p = "";
              }
              return p ? A(p) : (g = g.parentElement, g ? (p = g.tagName, /H[1-6]/.test(p) ? A(p) : k(g)) : "p");
            };
          return k(w);
        },
        removeChildNodes: function removeChildNodes(w) {
          for (; w.lastChild;) w.removeChild(w.lastChild);
        },
        removeClass: function removeClass(w, A) {
          w.classList ? w.classList.remove(A) : w.className = w.className.replace(new RegExp(A, "g"), "");
        },
        removeElement: function removeElement(w) {
          w && w.parentNode && w.parentNode.removeChild(w);
        },
        reverseChildNodes: function reverseChildNodes(w) {
          for (var A = w.childNodes.length; A--;) w.appendChild(w.childNodes[A]);
        },
        simulatedEventTarget: z,
        stripHTMLTagsFromString: function stripHTMLTagsFromString(w) {
          return typeof w == "string" ? w.replace(/<\/?[^>]+(>|$)/g, "") : w;
        },
        visuallyHideElement: function visuallyHideElement(w) {
          W(w, {
            position: "absolute",
            width: "1px",
            height: "1px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            clip: "rect(1px, 1px, 1px, 1px)",
            marginTop: "-3px",
            "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)",
            filter: "alpha(opacity=1)",
            opacity: 0.01
          });
        }
      };
    }), V(O, "Accessibility/A11yI18n.js", [O["Core/FormatUtilities.js"], O["Core/Utilities.js"]], function (S, D) {
      var E = S.format,
        B = D.getNestedProperty,
        H = D.pick,
        X;
      return function (W) {
        function z(g, p) {
          var h = g.indexOf("#each("),
            s = g.indexOf("#plural("),
            l = g.indexOf("["),
            u = g.indexOf("]");
          if (-1 < h) {
            if (u = g.slice(h).indexOf(")") + h, s = g.substring(0, h), l = g.substring(u + 1), u = g.substring(h + 6, u).split(","), h = Number(u[1]), g = "", p = B(u[0], p)) for (h = isNaN(h) ? p.length : h, h = 0 > h ? p.length + h : Math.min(h, p.length), u = 0; u < h; ++u) g += s + p[u] + l;
            return g.length ? g : "";
          }
          if (-1 < s) {
            switch (l = g.slice(s).indexOf(")") + s, s = g.substring(s + 8, l).split(","), Number(B(s[0], p))) {
              case 0:
                g = H(s[4], s[1]);
                break;
              case 1:
                g = H(s[2], s[1]);
                break;
              case 2:
                g = H(s[3], s[1]);
                break;
              default:
                g = s[1];
            }
            return g ? (p = g, p = p.trim && p.trim() || p.replace(/^\s+|\s+$/g, "")) : p = "", p;
          }
          return -1 < l ? (s = g.substring(0, l), l = Number(g.substring(l + 1, u)), g = void 0, p = B(s, p), !isNaN(l) && p && (0 > l ? (g = p[p.length + l], typeof g > "u" && (g = p[0])) : (g = p[l], typeof g > "u" && (g = p[p.length - 1]))), typeof g < "u" ? g : "") : "{" + g + "}";
        }
        function w(g, p, h) {
          var s = function s(I, L) {
              I = I.slice(L || 0);
              var C = I.indexOf("{"),
                m = I.indexOf("}");
              if (-1 < C && m > C) return {
                statement: I.substring(C + 1, m),
                begin: L + C + 1,
                end: L + m
              };
            },
            l = [],
            u = 0;
          do {
            var v = s(g, u),
              M = g.substring(u, v && v.begin - 1);
            M.length && l.push({
              value: M,
              type: "constant"
            }), v && l.push({
              value: v.statement,
              type: "statement"
            }), u = v ? v.end + 1 : u + 1;
          } while (v);
          return l.forEach(function (I) {
            I.type === "statement" && (I.value = z(I.value, p));
          }), E(l.reduce(function (I, L) {
            return I + L.value;
          }, ""), p, h);
        }
        function A(g, p) {
          g = g.split(".");
          for (var h = this.options.lang, s = 0; s < g.length; ++s) h = h && h[g[s]];
          return typeof h == "string" ? w(h, p, this) : "";
        }
        var k = [];
        W.compose = function (g) {
          return k.indexOf(g) === -1 && (k.push(g), g.prototype.langFormat = A), g;
        }, W.i18nFormat = w;
      }(X || (X = {})), X;
    }), V(O, "Accessibility/Utils/ChartUtilities.js", [O["Core/Globals.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Core/Utilities.js"]], function (S, D, E) {
      function B(s, l) {
        var u = l.type,
          v = s.hcEvents;
        A.createEvent && (s.dispatchEvent || s.fireEvent) ? s.dispatchEvent ? s.dispatchEvent(l) : s.fireEvent(u, l) : v && v[u] ? h(s, u, l) : s.element && B(s.element, l);
      }
      function H(s) {
        var l = s.chart,
          u = {},
          v = "Seconds";
        u.Seconds = ((s.dataMax || s.max || 0) - (s.dataMin || s.min || 0)) / 1e3, u.Minutes = u.Seconds / 60, u.Hours = u.Minutes / 60, u.Days = u.Hours / 24, ["Minutes", "Hours", "Days"].forEach(function (I) {
          2 < u[I] && (v = I);
        });
        var M = u[v].toFixed(v !== "Seconds" && v !== "Minutes" ? 1 : 0);
        return l.langFormat("accessibility.axis.timeRange" + v, {
          chart: l,
          axis: s,
          range: M.replace(".0", "")
        });
      }
      function X(s) {
        var l = s.chart,
          u = l.options,
          v = u && u.accessibility && u.accessibility.screenReaderSection.axisRangeDateFormat || "",
          M = {
            min: s.dataMin || s.min || 0,
            max: s.dataMax || s.max || 0
          };
        return u = function u(I) {
          return s.dateTime ? l.time.dateFormat(v, M[I]) : M[I].toString();
        }, l.langFormat("accessibility.axis.rangeFromTo", {
          chart: l,
          axis: s,
          rangeFrom: u("min"),
          rangeTo: u("max")
        });
      }
      function W(s) {
        if (s.points && s.points.length) return (s = p(s.points, function (l) {
          return !!l.graphic;
        })) && s.graphic && s.graphic.element;
      }
      function z(s) {
        var l = W(s);
        return l && l.parentNode || s.graph && s.graph.element || s.group && s.group.element;
      }
      function w(s, l) {
        l.setAttribute("aria-hidden", !1), l !== s.renderTo && l.parentNode && l.parentNode !== A.body && (Array.prototype.forEach.call(l.parentNode.childNodes, function (u) {
          u.hasAttribute("aria-hidden") || u.setAttribute("aria-hidden", !0);
        }), w(s, l.parentNode));
      }
      var A = S.doc,
        k = D.stripHTMLTagsFromString,
        g = E.defined,
        p = E.find,
        h = E.fireEvent;
      return {
        fireEventOnWrappedOrUnwrappedElement: B,
        getChartTitle: function getChartTitle(s) {
          return k(s.options.title.text || s.langFormat("accessibility.defaultChartTitle", {
            chart: s
          }));
        },
        getAxisDescription: function getAxisDescription(s) {
          return s && (s.userOptions && s.userOptions.accessibility && s.userOptions.accessibility.description || s.axisTitle && s.axisTitle.textStr || s.options.id || s.categories && "categories" || s.dateTime && "Time" || "values");
        },
        getAxisRangeDescription: function getAxisRangeDescription(s) {
          var l = s.options || {};
          return l.accessibility && typeof l.accessibility.rangeDescription < "u" ? l.accessibility.rangeDescription : s.categories ? (l = s.chart, s = s.dataMax && s.dataMin ? l.langFormat("accessibility.axis.rangeCategories", {
            chart: l,
            axis: s,
            numCategories: s.dataMax - s.dataMin + 1
          }) : "", s) : !s.dateTime || s.min !== 0 && s.dataMin !== 0 ? X(s) : H(s);
        },
        getPointFromXY: function getPointFromXY(s, l, u) {
          for (var v = s.length, M; v--;) if (M = p(s[v].points || [], function (I) {
            return I.x === l && I.y === u;
          })) return M;
        },
        getSeriesFirstPointElement: W,
        getSeriesFromName: function getSeriesFromName(s, l) {
          return l ? (s.series || []).filter(function (u) {
            return u.name === l;
          }) : s.series;
        },
        getSeriesA11yElement: z,
        unhideChartElementFromAT: w,
        hideSeriesFromAT: function hideSeriesFromAT(s) {
          (s = z(s)) && s.setAttribute("aria-hidden", !0);
        },
        scrollToPoint: function scrollToPoint(s) {
          var l = s.series.xAxis,
            u = s.series.yAxis,
            v = l && l.scrollbar ? l : u;
          if ((l = v && v.scrollbar) && g(l.to) && g(l.from)) {
            if (u = l.to - l.from, g(v.dataMin) && g(v.dataMax)) {
              var M = v.toPixels(v.dataMin),
                I = v.toPixels(v.dataMax);
              s = (v.toPixels(s[v.coll === "xAxis" ? "x" : "y"] || 0) - M) / (I - M);
            } else s = 0;
            l.updatePosition(s - u / 2, s + u / 2), h(l, "changed", {
              from: l.from,
              to: l.to,
              trigger: "scrollbar",
              DOMEvent: null
            });
          }
        }
      };
    }), V(O, "Accessibility/Utils/DOMElementProvider.js", [O["Core/Globals.js"], O["Accessibility/Utils/HTMLUtilities.js"]], function (S, D) {
      var E = S.doc,
        B = D.removeElement;
      return function () {
        function H() {
          this.elements = [];
        }
        return H.prototype.createElement = function () {
          var X = E.createElement.apply(E, arguments);
          return this.elements.push(X), X;
        }, H.prototype.destroyCreatedElements = function () {
          this.elements.forEach(function (X) {
            B(X);
          }), this.elements = [];
        }, H;
      }();
    }), V(O, "Accessibility/Utils/EventProvider.js", [O["Core/Globals.js"], O["Core/Utilities.js"]], function (S, D) {
      var E = D.addEvent;
      return function () {
        function B() {
          this.eventRemovers = [];
        }
        return B.prototype.addEvent = function () {
          var H = E.apply(S, arguments);
          return this.eventRemovers.push(H), H;
        }, B.prototype.removeAddedEvents = function () {
          this.eventRemovers.forEach(function (H) {
            return H();
          }), this.eventRemovers = [];
        }, B;
      }();
    }), V(O, "Accessibility/AccessibilityComponent.js", [O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/DOMElementProvider.js"], O["Accessibility/Utils/EventProvider.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Core/Utilities.js"]], function (S, D, E, B, H) {
      var X = S.fireEventOnWrappedOrUnwrappedElement,
        W = B.getFakeMouseEvent;
      return S = H.extend, B = function () {
        function z() {
          this.proxyProvider = this.keyCodes = this.eventProvider = this.domElementProvider = this.chart = void 0;
        }
        return z.prototype.initBase = function (w, A) {
          this.chart = w, this.eventProvider = new E(), this.domElementProvider = new D(), this.proxyProvider = A, this.keyCodes = {
            left: 37,
            right: 39,
            up: 38,
            down: 40,
            enter: 13,
            space: 32,
            esc: 27,
            tab: 9,
            pageUp: 33,
            pageDown: 34,
            end: 35,
            home: 36
          };
        }, z.prototype.addEvent = function (w, A, k, g) {
          return this.eventProvider.addEvent(w, A, k, g);
        }, z.prototype.createElement = function (w, A) {
          return this.domElementProvider.createElement(w, A);
        }, z.prototype.fakeClickEvent = function (w) {
          var A = W("click");
          X(w, A);
        }, z.prototype.destroyBase = function () {
          this.domElementProvider.destroyCreatedElements(), this.eventProvider.removeAddedEvents();
        }, z;
      }(), S(B.prototype, {
        init: function init() {},
        getKeyboardNavigation: function getKeyboardNavigation() {},
        onChartUpdate: function onChartUpdate() {},
        onChartRender: function onChartRender() {},
        destroy: function destroy() {}
      }), B;
    }), V(O, "Accessibility/KeyboardNavigationHandler.js", [O["Core/Utilities.js"]], function (S) {
      var D = S.find;
      return S = function () {
        function E(B, H) {
          this.chart = B, this.keyCodeMap = H.keyCodeMap || [], this.validate = H.validate, this.init = H.init, this.terminate = H.terminate, this.response = {
            success: 1,
            prev: 2,
            next: 3,
            noHandler: 4,
            fail: 5
          };
        }
        return E.prototype.run = function (B) {
          var H = B.which || B.keyCode,
            X = this.response.noHandler,
            W = D(this.keyCodeMap, function (z) {
              return -1 < z[0].indexOf(H);
            });
          return W ? X = W[1].call(this, H, B) : H === 9 && (X = this.response[B.shiftKey ? "prev" : "next"]), X;
        }, E;
      }(), S;
    }), V(O, "Accessibility/Components/ContainerComponent.js", [O["Accessibility/AccessibilityComponent.js"], O["Accessibility/KeyboardNavigationHandler.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Core/Globals.js"], O["Accessibility/Utils/HTMLUtilities.js"]], function (S, D, E, B, H) {
      var X = this && this.__extends || function () {
          var _k8 = function k(g, p) {
            return _k8 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k8(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k8(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        W = E.unhideChartElementFromAT,
        z = E.getChartTitle,
        w = B.doc,
        A = H.stripHTMLTagsFromString;
      return function (k) {
        function g() {
          return k !== null && k.apply(this, arguments) || this;
        }
        return X(g, k), g.prototype.onChartUpdate = function () {
          this.handleSVGTitleElement(), this.setSVGContainerLabel(), this.setGraphicContainerAttrs(), this.setRenderToAttrs(), this.makeCreditsAccessible();
        }, g.prototype.handleSVGTitleElement = function () {
          var p = this.chart,
            h = "highcharts-title-" + p.index,
            s = A(p.langFormat("accessibility.svgContainerTitle", {
              chartTitle: z(p)
            }));
          if (s.length) {
            var l = this.svgTitleElement = this.svgTitleElement || w.createElementNS("http://www.w3.org/2000/svg", "title");
            l.textContent = s, l.id = h, p.renderTo.insertBefore(l, p.renderTo.firstChild);
          }
        }, g.prototype.setSVGContainerLabel = function () {
          var p = this.chart,
            h = p.langFormat("accessibility.svgContainerLabel", {
              chartTitle: z(p)
            });
          p.renderer.box && h.length && p.renderer.box.setAttribute("aria-label", h);
        }, g.prototype.setGraphicContainerAttrs = function () {
          var p = this.chart,
            h = p.langFormat("accessibility.graphicContainerLabel", {
              chartTitle: z(p)
            });
          h.length && p.container.setAttribute("aria-label", h);
        }, g.prototype.setRenderToAttrs = function () {
          var p = this.chart,
            h = p.options.accessibility.landmarkVerbosity !== "disabled",
            s = p.langFormat("accessibility.chartContainerLabel", {
              title: z(p),
              chart: p
            });
          s && (p.renderTo.setAttribute("role", h ? "region" : "group"), p.renderTo.setAttribute("aria-label", s));
        }, g.prototype.makeCreditsAccessible = function () {
          var p = this.chart,
            h = p.credits;
          h && (h.textStr && h.element.setAttribute("aria-label", p.langFormat("accessibility.credits", {
            creditsStr: A(h.textStr)
          })), W(p, h.element));
        }, g.prototype.getKeyboardNavigation = function () {
          var p = this.chart;
          return new D(p, {
            keyCodeMap: [],
            validate: function validate() {
              return !0;
            },
            init: function init() {
              var h = p.accessibility;
              h && h.keyboardNavigation.tabindexContainer.focus();
            }
          });
        }, g.prototype.destroy = function () {
          this.chart.renderTo.setAttribute("aria-hidden", !0);
        }, g;
      }(S);
    }), V(O, "Accessibility/FocusBorder.js", [O["Core/Renderer/SVG/SVGLabel.js"], O["Core/Utilities.js"]], function (S, D) {
      var E = D.addEvent,
        B = D.pick,
        H;
      return function (X) {
        function W() {
          var l = this.focusElement,
            u = this.options.accessibility.keyboardNavigation.focusBorder;
          l && (l.removeFocusBorder(), u.enabled && l.addFocusBorder(u.margin, {
            stroke: u.style.color,
            strokeWidth: u.style.lineWidth,
            r: u.style.borderRadius
          }));
        }
        function z(l, u) {
          var v = this.options.accessibility.keyboardNavigation.focusBorder;
          (u = u || l.element) && u.focus && (u.hcEvents && u.hcEvents.focusin || E(u, "focusin", function () {}), u.focus(), v.hideBrowserFocusOutline && (u.style.outline = "none")), this.focusElement && this.focusElement.removeFocusBorder(), this.focusElement = l, this.renderFocusBorder();
        }
        function w(l) {
          if (!l.focusBorderDestroyHook) {
            var u = l.destroy;
            l.destroy = function () {
              return l.focusBorder && l.focusBorder.destroy && l.focusBorder.destroy(), u.apply(l, arguments);
            }, l.focusBorderDestroyHook = u;
          }
        }
        function A(l, u) {
          this.focusBorder && this.removeFocusBorder();
          var v = this.getBBox(),
            M = B(l, 3),
            I = this.parentGroup,
            L = this.scaleX || I && I.scaleX,
            C = this.scaleY || I && I.scaleY;
          L = (L ? !C : C) ? Math.abs(L || C || 1) : (Math.abs(L || 1) + Math.abs(C || 1)) / 2, v.x += this.translateX ? this.translateX : 0, v.y += this.translateY ? this.translateY : 0, C = v.x - M;
          var m = v.y - M,
            d = v.width + 2 * M,
            o = v.height + 2 * M,
            n = this instanceof S;
          if (this.element.nodeName === "text" || n) {
            var r = !!this.rotation;
            if (n) var i = {
              x: r ? 1 : 0,
              y: 0
            };else {
              var t = i = 0;
              this.attr("text-anchor") === "middle" ? i = t = 0.5 : this.rotation ? i = 0.25 : t = 0.75, i = {
                x: i,
                y: t
              };
            }
            t = +this.attr("x");
            var e = +this.attr("y");
            isNaN(t) || (C = t - v.width * i.x - M), isNaN(e) || (m = e - v.height * i.y - M), n && r && (n = d, d = o, o = n, isNaN(t) || (C = t - v.height * i.x - M), isNaN(e) || (m = e - v.width * i.y - M));
          }
          this.focusBorder = this.renderer.rect(C, m, d, o, parseInt((u && u.r || 0).toString(), 10) / L).addClass("highcharts-focus-border").attr({
            zIndex: 99
          }).add(I), this.renderer.styledMode || this.focusBorder.attr({
            stroke: u && u.stroke,
            "stroke-width": (u && u.strokeWidth || 0) / L
          }), k(this, l, u), w(this);
        }
        function k(l) {
          for (var u = [], v = 1; v < arguments.length; v++) u[v - 1] = arguments[v];
          l.focusBorderUpdateHooks || (l.focusBorderUpdateHooks = {}, s.forEach(function (M) {
            M += "Setter";
            var I = l[M] || l._defaultSetter;
            l.focusBorderUpdateHooks[M] = I, l[M] = function () {
              var L = I.apply(l, arguments);
              return l.addFocusBorder.apply(l, u), L;
            };
          }));
        }
        function g() {
          p(this), this.focusBorderDestroyHook && (this.destroy = this.focusBorderDestroyHook, delete this.focusBorderDestroyHook), this.focusBorder && (this.focusBorder.destroy(), delete this.focusBorder);
        }
        function p(l) {
          l.focusBorderUpdateHooks && (Object.keys(l.focusBorderUpdateHooks).forEach(function (u) {
            var v = l.focusBorderUpdateHooks[u];
            v === l._defaultSetter ? delete l[u] : l[u] = v;
          }), delete l.focusBorderUpdateHooks);
        }
        var h = [],
          s = "x y transform width height r d stroke-width".split(" ");
        X.compose = function (l, u) {
          h.indexOf(l) === -1 && (h.push(l), l = l.prototype, l.renderFocusBorder = W, l.setFocusToElement = z), h.indexOf(u) === -1 && (h.push(u), u = u.prototype, u.addFocusBorder = A, u.removeFocusBorder = g);
        };
      }(H || (H = {})), H;
    }), V(O, "Accessibility/Utils/Announcer.js", [O["Core/Renderer/HTML/AST.js"], O["Accessibility/Utils/DOMElementProvider.js"], O["Core/Globals.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Core/Utilities.js"]], function (S, D, E, B, H) {
      var X = E.doc,
        W = B.addClass,
        z = B.visuallyHideElement,
        w = H.attr;
      return function () {
        function A(k, g) {
          this.chart = k, this.domElementProvider = new D(), this.announceRegion = this.addAnnounceRegion(g);
        }
        return A.prototype.destroy = function () {
          this.domElementProvider.destroyCreatedElements();
        }, A.prototype.announce = function (k) {
          var g = this;
          S.setElementHTML(this.announceRegion, k), this.clearAnnouncementRegionTimer && clearTimeout(this.clearAnnouncementRegionTimer), this.clearAnnouncementRegionTimer = setTimeout(function () {
            g.announceRegion.innerHTML = S.emptyHTML, delete g.clearAnnouncementRegionTimer;
          }, 1e3);
        }, A.prototype.addAnnounceRegion = function (k) {
          var g = this.chart.announcerContainer || this.createAnnouncerContainer(),
            p = this.domElementProvider.createElement("div");
          return w(p, {
            "aria-hidden": !1,
            "aria-live": k
          }), this.chart.styledMode ? W(p, "highcharts-visually-hidden") : z(p), g.appendChild(p), p;
        }, A.prototype.createAnnouncerContainer = function () {
          var k = this.chart,
            g = X.createElement("div");
          return w(g, {
            "aria-hidden": !1,
            class: "highcharts-announcer-container"
          }), g.style.position = "relative", k.renderTo.insertBefore(g, k.renderTo.firstChild), k.announcerContainer = g;
        }, A;
      }();
    }), V(O, "Accessibility/Components/AnnotationsA11y.js", [O["Accessibility/Utils/HTMLUtilities.js"]], function (S) {
      function D(z) {
        return (z.annotations || []).reduce(function (w, A) {
          return A.options && A.options.visible !== !1 && (w = w.concat(A.labels)), w;
        }, []);
      }
      function E(z) {
        return z.options && z.options.accessibility && z.options.accessibility.description || z.graphic && z.graphic.text && z.graphic.text.textStr || "";
      }
      function B(z) {
        var w = z.options && z.options.accessibility && z.options.accessibility.description;
        if (w) return w;
        w = z.chart;
        var A = E(z),
          k = z.points.filter(function (h) {
            return !!h.graphic;
          }).map(function (h) {
            var s = h.accessibility && h.accessibility.valueDescription || h.graphic && h.graphic.element && h.graphic.element.getAttribute("aria-label") || "";
            return h = h && h.series.name || "", (h ? h + ", " : "") + "data point " + s;
          }).filter(function (h) {
            return !!h;
          }),
          g = k.length,
          p = "accessibility.screenReaderSection.annotations.description" + (1 < g ? "MultiplePoints" : g ? "SinglePoint" : "NoPoints");
        return z = {
          annotationText: A,
          annotation: z,
          numPoints: g,
          annotationPoint: k[0],
          additionalAnnotationPoints: k.slice(1)
        }, w.langFormat(p, z);
      }
      function H(z) {
        return D(z).map(function (w) {
          return (w = X(W(B(w)))) ? "<li>".concat(w, "</li>") : "";
        });
      }
      var X = S.escapeStringForHTML,
        W = S.stripHTMLTagsFromString;
      return {
        getAnnotationsInfoHTML: function getAnnotationsInfoHTML(z) {
          var w = z.annotations;
          return !w || !w.length ? "" : (z = H(z), '<ul style="list-style-type: none">'.concat(z.join(" "), "</ul>"));
        },
        getAnnotationLabelDescription: B,
        getAnnotationListItems: H,
        getPointAnnotationTexts: function getPointAnnotationTexts(z) {
          var w = D(z.series.chart).filter(function (A) {
            return -1 < A.points.indexOf(z);
          });
          return w.length ? w.map(function (A) {
            return "".concat(E(A));
          }) : [];
        }
      };
    }), V(O, "Accessibility/Components/InfoRegionsComponent.js", [O["Accessibility/A11yI18n.js"], O["Accessibility/AccessibilityComponent.js"], O["Accessibility/Utils/Announcer.js"], O["Accessibility/Components/AnnotationsA11y.js"], O["Core/Renderer/HTML/AST.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Core/FormatUtilities.js"], O["Core/Globals.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Core/Utilities.js"]], function (S, D, E, B, H, X, W, z, w, A) {
      function k(r, i) {
        var t = i[0],
          e = r.series && r.series[0] || {};
        if (e = {
          numSeries: r.series.length,
          numPoints: e.points && e.points.length,
          chart: r,
          mapTitle: r.mapView && r.mapView.geoMap && r.mapView.geoMap.title
        }, !t) return r.langFormat("accessibility.chartTypes.emptyChart", e);
        if (t === "map") return e.mapTitle ? r.langFormat("accessibility.chartTypes.mapTypeDescription", e) : r.langFormat("accessibility.chartTypes.unknownMap", e);
        if (1 < r.types.length) return r.langFormat("accessibility.chartTypes.combinationChart", e);
        i = i[0], t = r.langFormat("accessibility.seriesTypeDescriptions." + i, e);
        var a = r.series && 2 > r.series.length ? "Single" : "Multiple";
        return (r.langFormat("accessibility.chartTypes." + i + a, e) || r.langFormat("accessibility.chartTypes.default" + a, e)) + (t ? " " + t : "");
      }
      var g = this && this.__extends || function () {
          var _r2 = function r(i, t) {
            return _r2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, a) {
              e.__proto__ = a;
            } || function (e, a) {
              for (var c in a) a.hasOwnProperty(c) && (e[c] = a[c]);
            }, _r2(i, t);
          };
          return function (i, t) {
            function e() {
              this.constructor = i;
            }
            _r2(i, t), i.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
          };
        }(),
        p = B.getAnnotationsInfoHTML,
        h = X.getAxisDescription,
        s = X.getAxisRangeDescription,
        l = X.getChartTitle,
        u = X.unhideChartElementFromAT,
        v = W.format,
        M = z.doc,
        I = w.addClass,
        L = w.getElement,
        C = w.getHeadingTagNameForElement,
        m = w.stripHTMLTagsFromString,
        d = w.visuallyHideElement,
        o = A.attr,
        n = A.pick;
      return function (r) {
        function i() {
          var t = r !== null && r.apply(this, arguments) || this;
          return t.announcer = void 0, t.screenReaderSections = {}, t;
        }
        return g(i, r), i.prototype.init = function () {
          var t = this.chart,
            e = this;
          this.initRegionsDefinitions(), this.addEvent(t, "aftergetTableAST", function (a) {
            e.onDataTableCreated(a);
          }), this.addEvent(t, "afterViewData", function (a) {
            a.wasHidden && (e.dataTableDiv = a.element, setTimeout(function () {
              e.focusDataTable();
            }, 300));
          }), this.announcer = new E(t, "assertive");
        }, i.prototype.initRegionsDefinitions = function () {
          var t = this;
          this.screenReaderSections = {
            before: {
              element: null,
              buildContent: function buildContent(e) {
                var a = e.options.accessibility.screenReaderSection.beforeChartFormatter;
                return a ? a(e) : t.defaultBeforeChartFormatter(e);
              },
              insertIntoDOM: function insertIntoDOM(e, a) {
                a.renderTo.insertBefore(e, a.renderTo.firstChild);
              },
              afterInserted: function afterInserted() {
                typeof t.sonifyButtonId < "u" && t.initSonifyButton(t.sonifyButtonId), typeof t.dataTableButtonId < "u" && t.initDataTableButton(t.dataTableButtonId);
              }
            },
            after: {
              element: null,
              buildContent: function buildContent(e) {
                var a = e.options.accessibility.screenReaderSection.afterChartFormatter;
                return a ? a(e) : t.defaultAfterChartFormatter();
              },
              insertIntoDOM: function insertIntoDOM(e, a) {
                a.renderTo.insertBefore(e, a.container.nextSibling);
              },
              afterInserted: function afterInserted() {
                t.chart.accessibility && t.chart.accessibility.keyboardNavigation.updateExitAnchor();
              }
            }
          };
        }, i.prototype.onChartRender = function () {
          var t = this;
          this.linkedDescriptionElement = this.getLinkedDescriptionElement(), this.setLinkedDescriptionAttrs(), Object.keys(this.screenReaderSections).forEach(function (e) {
            t.updateScreenReaderSection(e);
          });
        }, i.prototype.getLinkedDescriptionElement = function () {
          var t = this.chart.options.accessibility.linkedDescription;
          if (t) {
            if (typeof t != "string") return t;
            if (t = v(t, this.chart), t = M.querySelectorAll(t), t.length === 1) return t[0];
          }
        }, i.prototype.setLinkedDescriptionAttrs = function () {
          var t = this.linkedDescriptionElement;
          t && (t.setAttribute("aria-hidden", "true"), I(t, "highcharts-linked-description"));
        }, i.prototype.updateScreenReaderSection = function (t) {
          var e = this.chart,
            a = this.screenReaderSections[t],
            c = a.buildContent(e),
            y = a.element = a.element || this.createElement("div"),
            b = y.firstChild || this.createElement("div");
          c ? (this.setScreenReaderSectionAttribs(y, t), H.setElementHTML(b, c), y.appendChild(b), a.insertIntoDOM(y, e), e.styledMode ? I(b, "highcharts-visually-hidden") : d(b), u(e, b), a.afterInserted && a.afterInserted()) : (y.parentNode && y.parentNode.removeChild(y), a.element = null);
        }, i.prototype.setScreenReaderSectionAttribs = function (t, e) {
          var a = this.chart,
            c = a.langFormat("accessibility.screenReaderSection." + e + "RegionLabel", {
              chart: a,
              chartTitle: l(a)
            });
          e = "highcharts-screen-reader-region-".concat(e, "-").concat(a.index), o(t, {
            id: e,
            "aria-label": c || void 0
          }), t.style.position = "relative", c && t.setAttribute("role", a.options.accessibility.landmarkVerbosity === "all" ? "region" : "group");
        }, i.prototype.defaultBeforeChartFormatter = function () {
          var t = this.chart,
            e = t.options.accessibility.screenReaderSection.beforeChartFormat;
          if (!e) return "";
          var a = this.getAxesDescription(),
            c = t.sonify && t.options.sonification && t.options.sonification.enabled,
            y = "highcharts-a11y-sonify-data-btn-" + t.index,
            b = "hc-linkto-highcharts-data-table-" + t.index,
            j = p(t),
            P = t.langFormat("accessibility.screenReaderSection.annotations.heading", {
              chart: t
            });
          return a = {
            headingTagName: C(t.renderTo),
            chartTitle: l(t),
            typeDescription: this.getTypeDescriptionText(),
            chartSubtitle: this.getSubtitleText(),
            chartLongdesc: this.getLongdescText(),
            xAxisDescription: a.xAxis,
            yAxisDescription: a.yAxis,
            playAsSoundButton: c ? this.getSonifyButtonText(y) : "",
            viewTableButton: t.getCSV ? this.getDataTableButtonText(b) : "",
            annotationsTitle: j ? P : "",
            annotationsList: j
          }, t = S.i18nFormat(e, a, t), this.dataTableButtonId = b, this.sonifyButtonId = y, t.replace(/<(\w+)[^>]*?>\s*<\/\1>/g, "");
        }, i.prototype.defaultAfterChartFormatter = function () {
          var t = this.chart,
            e = t.options.accessibility.screenReaderSection.afterChartFormat;
          if (!e) return "";
          var a = {
            endOfChartMarker: this.getEndOfChartMarkerText()
          };
          return S.i18nFormat(e, a, t).replace(/<(\w+)[^>]*?>\s*<\/\1>/g, "");
        }, i.prototype.getLinkedDescription = function () {
          var t = this.linkedDescriptionElement;
          return m(t && t.innerHTML || "");
        }, i.prototype.getLongdescText = function () {
          var t = this.chart.options,
            e = t.caption;
          e = e && e.text;
          var a = this.getLinkedDescription();
          return t.accessibility.description || a || e || "";
        }, i.prototype.getTypeDescriptionText = function () {
          var t = this.chart;
          return t.types ? t.options.accessibility.typeDescription || k(t, t.types) : "";
        }, i.prototype.getDataTableButtonText = function (t) {
          var e = this.chart;
          return e = e.langFormat("accessibility.table.viewAsDataTableButtonText", {
            chart: e,
            chartTitle: l(e)
          }), '<button id="' + t + '">' + e + "</button>";
        }, i.prototype.getSonifyButtonText = function (t) {
          var e = this.chart;
          return e.options.sonification && e.options.sonification.enabled === !1 ? "" : (e = e.langFormat("accessibility.sonification.playAsSoundButtonText", {
            chart: e,
            chartTitle: l(e)
          }), '<button id="' + t + '">' + e + "</button>");
        }, i.prototype.getSubtitleText = function () {
          var t = this.chart.options.subtitle;
          return m(t && t.text || "");
        }, i.prototype.getEndOfChartMarkerText = function () {
          var t = this.chart,
            e = t.langFormat("accessibility.screenReaderSection.endOfChartMarker", {
              chart: t
            });
          return '<div id="highcharts-end-of-chart-marker-' + t.index + '">' + e + "</div>";
        }, i.prototype.onDataTableCreated = function (t) {
          var e = this.chart;
          if (e.options.accessibility.enabled) {
            this.viewDataTableButton && this.viewDataTableButton.setAttribute("aria-expanded", "true");
            var a = t.tree.attributes || {};
            a.tabindex = -1, a.summary = e.langFormat("accessibility.table.tableSummary", {
              chart: e
            }), t.tree.attributes = a;
          }
        }, i.prototype.focusDataTable = function () {
          var t = this.dataTableDiv;
          (t = t && t.getElementsByTagName("table")[0]) && t.focus && t.focus();
        }, i.prototype.initSonifyButton = function (t) {
          var e = this,
            a = this.sonifyButton = L(t),
            c = this.chart,
            y = function y(b) {
              a && (a.setAttribute("aria-hidden", "true"), a.setAttribute("aria-label", "")), b.preventDefault(), b.stopPropagation(), b = c.langFormat("accessibility.sonification.playAsSoundClickAnnouncement", {
                chart: c
              }), e.announcer.announce(b), setTimeout(function () {
                a && (a.removeAttribute("aria-hidden"), a.removeAttribute("aria-label")), c.sonify && c.sonify();
              }, 1e3);
            };
          a && c && (a.setAttribute("tabindex", -1), a.onclick = function (b) {
            (c.options.accessibility && c.options.accessibility.screenReaderSection.onPlayAsSoundClick || y).call(this, b, c);
          });
        }, i.prototype.initDataTableButton = function (t) {
          var e = this.viewDataTableButton = L(t),
            a = this.chart;
          t = t.replace("hc-linkto-", ""), e && (o(e, {
            tabindex: -1,
            "aria-expanded": !!L(t)
          }), e.onclick = a.options.accessibility.screenReaderSection.onViewDataTableClick || function () {
            a.viewData();
          });
        }, i.prototype.getAxesDescription = function () {
          var t = this.chart,
            e = function e(b, j) {
              return b = t[b], 1 < b.length || b[0] && n(b[0].options.accessibility && b[0].options.accessibility.enabled, j);
            },
            a = !!t.types && 0 > t.types.indexOf("map") && 0 > t.types.indexOf("treemap") && 0 > t.types.indexOf("tilemap"),
            c = !!t.hasCartesianSeries,
            y = e("xAxis", !t.angular && c && a);
          return e = e("yAxis", c && a), a = {}, y && (a.xAxis = this.getAxisDescriptionText("xAxis")), e && (a.yAxis = this.getAxisDescriptionText("yAxis")), a;
        }, i.prototype.getAxisDescriptionText = function (t) {
          var e = this.chart,
            a = e[t];
          return e.langFormat("accessibility.axis." + t + "Description" + (1 < a.length ? "Plural" : "Singular"), {
            chart: e,
            names: a.map(function (c) {
              return h(c);
            }),
            ranges: a.map(function (c) {
              return s(c);
            }),
            numAxes: a.length
          });
        }, i.prototype.destroy = function () {
          this.announcer && this.announcer.destroy();
        }, i;
      }(D);
    }), V(O, "Accessibility/Components/MenuComponent.js", [O["Core/Chart/Chart.js"], O["Core/Utilities.js"], O["Accessibility/AccessibilityComponent.js"], O["Accessibility/KeyboardNavigationHandler.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/HTMLUtilities.js"]], function (S, D, E, B, H, X) {
      var W = this && this.__extends || function () {
          var _g4 = function g(p, h) {
            return _g4 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (s, l) {
              s.__proto__ = l;
            } || function (s, l) {
              for (var u in l) l.hasOwnProperty(u) && (s[u] = l[u]);
            }, _g4(p, h);
          };
          return function (p, h) {
            function s() {
              this.constructor = p;
            }
            _g4(p, h), p.prototype = h === null ? Object.create(h) : (s.prototype = h.prototype, new s());
          };
        }(),
        z = D.attr,
        w = H.getChartTitle,
        A = H.unhideChartElementFromAT,
        k = X.getFakeMouseEvent;
      return D = function (g) {
        function p() {
          return g !== null && g.apply(this, arguments) || this;
        }
        return W(p, g), p.prototype.init = function () {
          var h = this.chart,
            s = this;
          this.addEvent(h, "exportMenuShown", function () {
            s.onMenuShown();
          }), this.addEvent(h, "exportMenuHidden", function () {
            s.onMenuHidden();
          }), this.createProxyGroup();
        }, p.prototype.onMenuHidden = function () {
          var h = this.chart.exportContextMenu;
          h && h.setAttribute("aria-hidden", "true"), this.setExportButtonExpandedState("false");
        }, p.prototype.onMenuShown = function () {
          var h = this.chart,
            s = h.exportContextMenu;
          s && (this.addAccessibleContextMenuAttribs(), A(h, s)), this.setExportButtonExpandedState("true");
        }, p.prototype.setExportButtonExpandedState = function (h) {
          this.exportButtonProxy && this.exportButtonProxy.buttonElement.setAttribute("aria-expanded", h);
        }, p.prototype.onChartRender = function () {
          var h = this.chart,
            s = h.focusElement,
            l = h.accessibility;
          this.proxyProvider.clearGroup("chartMenu"), this.proxyMenuButton(), this.exportButtonProxy && s && s === h.exportingGroup && (s.focusBorder ? h.setFocusToElement(s, this.exportButtonProxy.buttonElement) : l && l.keyboardNavigation.tabindexContainer.focus());
        }, p.prototype.proxyMenuButton = function () {
          var h = this.chart,
            s = this.proxyProvider,
            l = h.exportSVGElements && h.exportSVGElements[0],
            u = h.options.exporting,
            v = h.exportSVGElements && h.exportSVGElements[0];
          u && u.enabled !== !1 && u.accessibility && u.accessibility.enabled && v && v.element && l && (this.exportButtonProxy = s.addProxyElement("chartMenu", {
            click: l
          }, {
            "aria-label": h.langFormat("accessibility.exporting.menuButtonLabel", {
              chart: h,
              chartTitle: w(h)
            }),
            "aria-expanded": !1,
            title: h.options.lang.contextButtonTitle || null
          }));
        }, p.prototype.createProxyGroup = function () {
          this.chart && this.proxyProvider && this.proxyProvider.addGroup("chartMenu", "div");
        }, p.prototype.addAccessibleContextMenuAttribs = function () {
          var h = this.chart,
            s = h.exportDivElements;
          s && s.length && (s.forEach(function (l) {
            l && (l.tagName !== "LI" || l.children && l.children.length ? l.setAttribute("aria-hidden", "true") : l.setAttribute("tabindex", -1));
          }), (s = s[0] && s[0].parentNode) && z(s, {
            "aria-hidden": void 0,
            "aria-label": h.langFormat("accessibility.exporting.chartMenuLabel", {
              chart: h
            }),
            role: "list"
          }));
        }, p.prototype.getKeyboardNavigation = function () {
          var h = this.keyCodes,
            s = this.chart,
            l = this;
          return new B(s, {
            keyCodeMap: [[[h.left, h.up], function () {
              return l.onKbdPrevious(this);
            }], [[h.right, h.down], function () {
              return l.onKbdNext(this);
            }], [[h.enter, h.space], function () {
              return l.onKbdClick(this);
            }]],
            validate: function validate() {
              return !!s.exporting && s.options.exporting.enabled !== !1 && s.options.exporting.accessibility.enabled !== !1;
            },
            init: function init() {
              var u = l.exportButtonProxy,
                v = l.chart.exportingGroup;
              u && v && s.setFocusToElement(v, u.buttonElement);
            },
            terminate: function terminate() {
              s.hideExportMenu();
            }
          });
        }, p.prototype.onKbdPrevious = function (h) {
          var s = this.chart,
            l = s.options.accessibility;
          h = h.response;
          for (var u = s.highlightedExportItemIx || 0; u--;) if (s.highlightExportItem(u)) return h.success;
          return l.keyboardNavigation.wrapAround ? (s.highlightLastExportItem(), h.success) : h.prev;
        }, p.prototype.onKbdNext = function (h) {
          var s = this.chart,
            l = s.options.accessibility;
          h = h.response;
          for (var u = (s.highlightedExportItemIx || 0) + 1; u < s.exportDivElements.length; ++u) if (s.highlightExportItem(u)) return h.success;
          return l.keyboardNavigation.wrapAround ? (s.highlightExportItem(0), h.success) : h.next;
        }, p.prototype.onKbdClick = function (h) {
          var s = this.chart,
            l = s.exportDivElements[s.highlightedExportItemIx],
            u = (s.exportSVGElements && s.exportSVGElements[0]).element;
          return s.openMenu ? this.fakeClickEvent(l) : (this.fakeClickEvent(u), s.highlightExportItem(0)), h.response.success;
        }, p;
      }(E), function (g) {
        function p() {
          var v = this.exportSVGElements && this.exportSVGElements[0];
          v && (v = v.element, v.onclick) && v.onclick(k("click"));
        }
        function h() {
          var v = this.exportDivElements;
          v && this.exportContextMenu && this.openMenu && (v.forEach(function (M) {
            M && M.className === "highcharts-menu-item" && M.onmouseout && M.onmouseout(k("mouseout"));
          }), this.highlightedExportItemIx = 0, this.exportContextMenu.hideMenu(), this.container.focus());
        }
        function s(v) {
          var M = this.exportDivElements && this.exportDivElements[v],
            I = this.exportDivElements && this.exportDivElements[this.highlightedExportItemIx];
          if (M && M.tagName === "LI" && (!M.children || !M.children.length)) {
            var L = !!(this.renderTo.getElementsByTagName("g")[0] || {}).focus;
            return M.focus && L && M.focus(), I && I.onmouseout && I.onmouseout(k("mouseout")), M.onmouseover && M.onmouseover(k("mouseover")), this.highlightedExportItemIx = v, !0;
          }
          return !1;
        }
        function l() {
          if (this.exportDivElements) {
            for (var v = this.exportDivElements.length; v--;) if (this.highlightExportItem(v)) return !0;
          }
          return !1;
        }
        var u = [];
        g.compose = function (v) {
          u.indexOf(v) === -1 && (u.push(v), v = S.prototype, v.hideExportMenu = h, v.highlightExportItem = s, v.highlightLastExportItem = l, v.showExportMenu = p);
        };
      }(D || (D = {})), D;
    }), V(O, "Accessibility/KeyboardNavigation.js", [O["Core/Globals.js"], O["Accessibility/Components/MenuComponent.js"], O["Core/Utilities.js"], O["Accessibility/Utils/EventProvider.js"], O["Accessibility/Utils/HTMLUtilities.js"]], function (S, D, E, B, H) {
      var X = S.doc,
        W = S.win,
        z = E.addEvent,
        w = E.fireEvent,
        A = H.getElement,
        k = H.simulatedEventTarget;
      return E = function () {
        function g(p, h) {
          this.components = this.chart = void 0, this.currentModuleIx = NaN, this.exitAnchor = this.eventProvider = void 0, this.modules = [], this.tabindexContainer = void 0, this.init(p, h);
        }
        return g.prototype.init = function (p, h) {
          var s = this,
            l = this.eventProvider = new B();
          this.chart = p, this.components = h, this.modules = [], this.currentModuleIx = 0, this.update(), l.addEvent(this.tabindexContainer, "keydown", function (u) {
            return s.onKeydown(u);
          }), l.addEvent(this.tabindexContainer, "focus", function (u) {
            return s.onFocus(u);
          }), ["mouseup", "touchend"].forEach(function (u) {
            return l.addEvent(X, u, function (v) {
              return s.onMouseUp(v);
            });
          }), ["mousedown", "touchstart"].forEach(function (u) {
            return l.addEvent(p.renderTo, u, function () {
              s.isClickingChart = !0;
            });
          }), l.addEvent(p.renderTo, "mouseover", function () {
            s.pointerIsOverChart = !0;
          }), l.addEvent(p.renderTo, "mouseout", function () {
            s.pointerIsOverChart = !1;
          });
        }, g.prototype.update = function (p) {
          var h = this.chart.options.accessibility;
          h = h && h.keyboardNavigation;
          var s = this.components;
          this.updateContainerTabindex(), h && h.enabled && p && p.length ? (this.modules = p.reduce(function (l, u) {
            return u = s[u].getKeyboardNavigation(), l.concat(u);
          }, []), this.updateExitAnchor()) : (this.modules = [], this.currentModuleIx = 0, this.removeExitAnchor());
        }, g.prototype.updateExitAnchor = function () {
          var p = "highcharts-end-of-chart-marker-".concat(this.chart.index);
          p = A(p), this.removeExitAnchor(), p ? (this.makeElementAnExitAnchor(p), this.exitAnchor = p) : this.createExitAnchor();
        }, g.prototype.move = function (p) {
          var h = this.modules && this.modules[this.currentModuleIx];
          if (h && h.terminate && h.terminate(p), this.chart.focusElement && this.chart.focusElement.removeFocusBorder(), this.currentModuleIx += p, h = this.modules && this.modules[this.currentModuleIx]) {
            if (h.validate && !h.validate()) return this.move(p);
            if (h.init) return h.init(p), !0;
          }
          return this.currentModuleIx = 0, this.exiting = !0, 0 < p ? this.exitAnchor && this.exitAnchor.focus() : this.tabindexContainer.focus(), !1;
        }, g.prototype.onFocus = function (p) {
          var h = this.chart;
          p = p.relatedTarget && h.container.contains(p.relatedTarget), this.exiting || this.tabbingInBackwards || this.isClickingChart || p || (p = this.getFirstValidModuleIx(), p !== null && (this.currentModuleIx = p, this.modules[p].init(1))), this.exiting = !1;
        }, g.prototype.onMouseUp = function (p) {
          if (delete this.isClickingChart, !this.keyboardReset && p.relatedTarget !== k) {
            if (p = this.chart, !this.pointerIsOverChart) {
              var h = this.modules && this.modules[this.currentModuleIx || 0];
              h && h.terminate && h.terminate(), this.currentModuleIx = 0;
            }
            p.focusElement && (p.focusElement.removeFocusBorder(), delete p.focusElement), this.keyboardReset = !0;
          }
        }, g.prototype.onKeydown = function (p) {
          p = p || W.event;
          var h = this.modules && this.modules.length && this.modules[this.currentModuleIx],
            s;
          if (this.exiting = this.keyboardReset = !1, h) {
            var l = h.run(p);
            l === h.response.success ? s = !0 : l === h.response.prev ? s = this.move(-1) : l === h.response.next && (s = this.move(1)), s && (p.preventDefault(), p.stopPropagation());
          }
        }, g.prototype.updateContainerTabindex = function () {
          var p = this.chart.options.accessibility;
          p = p && p.keyboardNavigation, p = !(p && p.enabled === !1);
          var h = this.chart,
            s = h.container;
          h.renderTo.hasAttribute("tabindex") && (s.removeAttribute("tabindex"), s = h.renderTo), this.tabindexContainer = s;
          var l = s.getAttribute("tabindex");
          p && !l ? s.setAttribute("tabindex", "0") : p || h.container.removeAttribute("tabindex");
        }, g.prototype.createExitAnchor = function () {
          var p = this.chart,
            h = this.exitAnchor = X.createElement("div");
          p.renderTo.appendChild(h), this.makeElementAnExitAnchor(h);
        }, g.prototype.makeElementAnExitAnchor = function (p) {
          var h = this.tabindexContainer.getAttribute("tabindex") || 0;
          p.setAttribute("class", "highcharts-exit-anchor"), p.setAttribute("tabindex", h), p.setAttribute("aria-hidden", !1), this.addExitAnchorEventsToEl(p);
        }, g.prototype.removeExitAnchor = function () {
          this.exitAnchor && this.exitAnchor.parentNode && (this.exitAnchor.parentNode.removeChild(this.exitAnchor), delete this.exitAnchor);
        }, g.prototype.addExitAnchorEventsToEl = function (p) {
          var h = this.chart,
            s = this;
          this.eventProvider.addEvent(p, "focus", function (l) {
            l = l || W.event;
            var u = !(l.relatedTarget && h.container.contains(l.relatedTarget) || s.exiting);
            h.focusElement && delete h.focusElement, u ? (s.tabbingInBackwards = !0, s.tabindexContainer.focus(), delete s.tabbingInBackwards, l.preventDefault(), s.modules && s.modules.length && (s.currentModuleIx = s.modules.length - 1, (l = s.modules[s.currentModuleIx]) && l.validate && !l.validate() ? s.move(-1) : l && l.init(-1))) : s.exiting = !1;
          });
        }, g.prototype.getFirstValidModuleIx = function () {
          for (var p = this.modules.length, h = 0; h < p; ++h) {
            var s = this.modules[h];
            if (!s.validate || s.validate()) return h;
          }
          return null;
        }, g.prototype.destroy = function () {
          this.removeExitAnchor(), this.eventProvider.removeAddedEvents(), this.chart.container.removeAttribute("tabindex");
        }, g;
      }(), function (g) {
        function p() {
          var l = this;
          w(this, "dismissPopupContent", {}, function () {
            l.tooltip && l.tooltip.hide(0), l.hideExportMenu();
          });
        }
        function h(l) {
          (l.which || l.keyCode) === 27 && S.charts && S.charts.forEach(function (u) {
            u && u.dismissPopupContent && u.dismissPopupContent();
          });
        }
        var s = [];
        g.compose = function (l) {
          return D.compose(l), s.indexOf(l) === -1 && (s.push(l), l.prototype.dismissPopupContent = p), s.indexOf(X) === -1 && (s.push(X), z(X, "keydown", h)), l;
        };
      }(E || (E = {})), E;
    }), V(O, "Accessibility/Components/LegendComponent.js", [O["Core/Animation/AnimationUtilities.js"], O["Core/Globals.js"], O["Core/Legend/Legend.js"], O["Core/Utilities.js"], O["Accessibility/AccessibilityComponent.js"], O["Accessibility/KeyboardNavigationHandler.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/HTMLUtilities.js"]], function (S, D, E, B, H, X, W, z) {
      function w(m) {
        var d = m.legend && m.legend.allItems,
          o = m.options.legend.accessibility || {};
        return m = m.colorAxis && m.colorAxis.some(function (n) {
          return !n.dataClasses || !n.dataClasses.length;
        }), !(!d || !d.length || m || o.enabled === !1);
      }
      function A(m, d) {
        var o = d.legendItem || {};
        d.setState(m ? "hover" : "", !0), d = 0;
        for (var n = ["group", "label", "symbol"]; d < n.length; d++) {
          var r = o[n[d]];
          (r = r && r.element || r) && s(r, m ? "mouseover" : "mouseout");
        }
      }
      var k = this && this.__extends || function () {
          var _m3 = function m(d, o) {
            return _m3 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (n, r) {
              n.__proto__ = r;
            } || function (n, r) {
              for (var i in r) r.hasOwnProperty(i) && (n[i] = r[i]);
            }, _m3(d, o);
          };
          return function (d, o) {
            function n() {
              this.constructor = d;
            }
            _m3(d, o), d.prototype = o === null ? Object.create(o) : (n.prototype = o.prototype, new n());
          };
        }(),
        g = S.animObject,
        p = D.doc,
        h = B.addEvent,
        s = B.fireEvent,
        l = B.isNumber,
        u = B.pick,
        v = B.syncTimeout,
        M = W.getChartTitle,
        I = z.stripHTMLTagsFromString,
        L = z.addClass,
        C = z.removeClass;
      return S = function (m) {
        function d() {
          var o = m !== null && m.apply(this, arguments) || this;
          return o.highlightedLegendItemIx = NaN, o.proxyGroup = null, o;
        }
        return k(d, m), d.prototype.init = function () {
          var o = this;
          this.recreateProxies(), this.addEvent(E, "afterScroll", function () {
            this.chart === o.chart && (o.proxyProvider.updateGroupProxyElementPositions("legend"), o.updateLegendItemProxyVisibility(), -1 < o.highlightedLegendItemIx && this.chart.highlightLegendItem(o.highlightedLegendItemIx));
          }), this.addEvent(E, "afterPositionItem", function (n) {
            this.chart === o.chart && this.chart.renderer && o.updateProxyPositionForItem(n.item);
          }), this.addEvent(E, "afterRender", function () {
            this.chart === o.chart && this.chart.renderer && o.recreateProxies() && v(function () {
              return o.proxyProvider.updateGroupProxyElementPositions("legend");
            }, g(u(this.chart.renderer.globalAnimation, !0)).duration);
          });
        }, d.prototype.updateLegendItemProxyVisibility = function () {
          var o = this.chart,
            n = o.legend,
            r = n.currentPage || 1,
            i = n.clipHeight || 0,
            t;
          (n.allItems || []).forEach(function (e) {
            if (e.a11yProxyElement) {
              var a = n.pages && n.pages.length,
                c = e.a11yProxyElement.element,
                y = !1;
              t = e.legendItem || {}, a && (e = t.pageIx || 0, a = t.y || 0, y = t.label ? Math.round(t.label.getBBox().height) : 0, y = a + y - n.pages[e] > i || e !== r - 1), y ? o.styledMode ? L(c, "highcharts-a11y-invisible") : c.style.visibility = "hidden" : (C(c, "highcharts-a11y-invisible"), c.style.visibility = "");
            }
          });
        }, d.prototype.onChartRender = function () {
          w(this.chart) || this.removeProxies();
        }, d.prototype.highlightAdjacentLegendPage = function (o) {
          var n = this.chart,
            r = n.legend;
          o = (r.currentPage || 1) + o;
          var i = r.pages || [];
          if (0 < o && o <= i.length) for (var t = i = 0, e = r.allItems; t < e.length; t++) ((e[t].legendItem || {}).pageIx || 0) + 1 === o && (r = n.highlightLegendItem(i)) && (this.highlightedLegendItemIx = i), ++i;
        }, d.prototype.updateProxyPositionForItem = function (o) {
          o.a11yProxyElement && o.a11yProxyElement.refreshPosition();
        }, d.prototype.recreateProxies = function () {
          var o = p.activeElement,
            n = this.proxyGroup;
          return o = o && n && n.contains(o), this.removeProxies(), w(this.chart) ? (this.addLegendProxyGroup(), this.proxyLegendItems(), this.updateLegendItemProxyVisibility(), this.updateLegendTitle(), o && this.chart.highlightLegendItem(this.highlightedLegendItemIx), !0) : !1;
        }, d.prototype.removeProxies = function () {
          this.proxyProvider.removeGroup("legend");
        }, d.prototype.updateLegendTitle = function () {
          var o = this.chart,
            n = I((o.legend && o.legend.options.title && o.legend.options.title.text || "").replace(/<br ?\/?>/g, " "));
          o = o.langFormat("accessibility.legend.legendLabel" + (n ? "" : "NoTitle"), {
            chart: o,
            legendTitle: n,
            chartTitle: M(o)
          }), this.proxyProvider.updateGroupAttrs("legend", {
            "aria-label": o
          });
        }, d.prototype.addLegendProxyGroup = function () {
          this.proxyGroup = this.proxyProvider.addGroup("legend", "ul", {
            "aria-label": "_placeholder_",
            role: this.chart.options.accessibility.landmarkVerbosity === "all" ? "region" : null
          });
        }, d.prototype.proxyLegendItems = function () {
          var o = this,
            n;
          ((this.chart.legend || {}).allItems || []).forEach(function (r) {
            n = r.legendItem || {}, n.label && n.label.element && o.proxyLegendItem(r);
          });
        }, d.prototype.proxyLegendItem = function (o) {
          var n = o.legendItem || {};
          if (n.label && n.group) {
            var r = this.chart.langFormat("accessibility.legend.legendItem", {
              chart: this.chart,
              itemName: I(o.name),
              item: o
            });
            o.a11yProxyElement = this.proxyProvider.addProxyElement("legend", {
              click: n.label,
              visual: (n.group.div ? n.label : n.group).element
            }, {
              tabindex: -1,
              "aria-pressed": o.visible,
              "aria-label": r
            });
          }
        }, d.prototype.getKeyboardNavigation = function () {
          var o = this.keyCodes,
            n = this,
            r = this.chart;
          return new X(r, {
            keyCodeMap: [[[o.left, o.right, o.up, o.down], function (i) {
              return n.onKbdArrowKey(this, i);
            }], [[o.enter, o.space], function () {
              return n.onKbdClick(this);
            }], [[o.pageDown, o.pageUp], function (i) {
              return n.highlightAdjacentLegendPage(i === o.pageDown ? 1 : -1), this.response.success;
            }]],
            validate: function validate() {
              return n.shouldHaveLegendNavigation();
            },
            init: function init() {
              r.highlightLegendItem(0), n.highlightedLegendItemIx = 0;
            },
            terminate: function terminate() {
              n.highlightedLegendItemIx = -1, r.legend.allItems.forEach(function (i) {
                return A(!1, i);
              });
            }
          });
        }, d.prototype.onKbdArrowKey = function (o, n) {
          var r = this.keyCodes,
            i = o.response,
            t = this.chart,
            e = t.options.accessibility,
            a = t.legend.allItems.length;
          return n = n === r.left || n === r.up ? -1 : 1, t.highlightLegendItem(this.highlightedLegendItemIx + n) ? (this.highlightedLegendItemIx += n, i.success) : (1 < a && e.keyboardNavigation.wrapAround && o.init(n), i.success);
        }, d.prototype.onKbdClick = function (o) {
          var n = this.chart.legend.allItems[this.highlightedLegendItemIx];
          return n && n.a11yProxyElement && n.a11yProxyElement.click(), o.response.success;
        }, d.prototype.shouldHaveLegendNavigation = function () {
          if (!w(this.chart)) return !1;
          var o = this.chart,
            n = (o.options.legend || {}).accessibility || {};
          return !!(o.legend.display && n.keyboardNavigation && n.keyboardNavigation.enabled);
        }, d;
      }(H), function (m) {
        function d(r) {
          var i = this.legend.allItems,
            t = this.accessibility && this.accessibility.components.legend.highlightedLegendItemIx,
            e = i[r],
            a = e.legendItem || {};
          return e ? (l(t) && i[t] && A(!1, i[t]), i = this.legend, r = (i.allItems[r].legendItem || {}).pageIx, t = i.currentPage, typeof r < "u" && r + 1 !== t && i.scroll(1 + r - t), a = a.label, r = e.a11yProxyElement && e.a11yProxyElement.buttonElement, a && a.element && r && this.setFocusToElement(a, r), A(!0, e), !0) : !1;
        }
        function o(r) {
          var i = r.item;
          this.chart.options.accessibility.enabled && i && i.a11yProxyElement && i.a11yProxyElement.buttonElement.setAttribute("aria-pressed", r.visible ? "true" : "false");
        }
        var n = [];
        m.compose = function (r, i) {
          n.indexOf(r) === -1 && (n.push(r), r.prototype.highlightLegendItem = d), n.indexOf(i) === -1 && (n.push(i), h(i, "afterColorizeItem", o));
        };
      }(S || (S = {})), S;
    }), V(O, "Accessibility/Components/SeriesComponent/SeriesDescriber.js", [O["Accessibility/Components/AnnotationsA11y.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Core/FormatUtilities.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Core/Utilities.js"]], function (S, D, E, B, H) {
      function X(e) {
        var a = e.index;
        return e.series && e.series.data && t(a) && n(e.series.data, function (c) {
          return !!(c && typeof c.index < "u" && c.index > a && c.graphic && c.graphic.element);
        }) || null;
      }
      function W(e) {
        var a = e.chart.options.accessibility.series.pointDescriptionEnabledThreshold;
        return !!(a !== !1 && e.points && e.points.length >= a);
      }
      function z(e) {
        var a = e.options.accessibility || {};
        return !W(e) && !a.exposeAsGroupOnly;
      }
      function w(e) {
        var a = e.chart.options.accessibility.keyboardNavigation.seriesNavigation;
        return !(!e.points || !(e.points.length < a.pointNavigationEnabledThreshold || a.pointNavigationEnabledThreshold === !1));
      }
      function A(e, a) {
        var c = e.series,
          y = c.chart;
        e = y.options.accessibility.point || {};
        var b = c.options.accessibility && c.options.accessibility.point || {};
        return c = c.tooltipOptions || {}, y = y.options.lang, r(a) ? m(a, b.valueDecimals || e.valueDecimals || c.valueDecimals || -1, y.decimalPoint, y.accessibility.thousandsSep || y.thousandsSep) : a;
      }
      function k(e) {
        var a = (e.options.accessibility || {}).description;
        return a && e.chart.langFormat("accessibility.series.description", {
          description: a,
          series: e
        }) || "";
      }
      function g(e, a) {
        return e.chart.langFormat("accessibility.series." + a + "Description", {
          name: v(e[a]),
          series: e
        });
      }
      function p(e, a, c) {
        var y = a || "",
          b = c || "";
        return e.series.pointArrayMap.reduce(function (j, P) {
          j += j.length ? ", " : "";
          var f = A(e, i(e[P], e.options[P]));
          return j + (P + ": " + y + f + b);
        }, "");
      }
      function h(e) {
        var a = e.series,
          c = 1 < a.chart.series.length || a.options.name,
          y = e.series,
          b = y.chart,
          j = y.options.accessibility;
        if (j = j && j.point && j.point.valueDescriptionFormat || b.options.accessibility.point.valueDescriptionFormat, y = i(y.xAxis && y.xAxis.options.accessibility && y.xAxis.options.accessibility.enabled, !b.angular), y) {
          var P = e.series,
            f = P.chart,
            x = P.options.accessibility && P.options.accessibility.point || {},
            N = f.options.accessibility.point || {};
          (P = P.xAxis && P.xAxis.dateTime) ? (P = P.getXDateFormat(e.x || 0, f.options.tooltip.dateTimeLabelFormats), x = x.dateFormatter && x.dateFormatter(e) || N.dateFormatter && N.dateFormatter(e) || x.dateFormat || N.dateFormat || P, f = f.time.dateFormat(x, e.x || 0, void 0)) : f = void 0, x = (e.series.xAxis || {}).categories && t(e.category) && ("" + e.category).replace("<br/>", " "), N = t(e.id) && 0 > ("" + e.id).indexOf("highcharts-"), P = "x, " + e.x, f = e.name || f || x || (N ? e.id : P);
        } else f = "";
        x = t(e.index) ? e.index + 1 : "", N = e.series;
        var R = N.chart.options.accessibility.point || {},
          F = N.chart.options.accessibility && N.chart.options.accessibility.point || {},
          T = N.tooltipOptions || {};
        return P = F.valuePrefix || R.valuePrefix || T.valuePrefix || "", R = F.valueSuffix || R.valueSuffix || T.valueSuffix || "", F = A(e, e[typeof e.value < "u" ? "value" : "y"]), N = e.isNull ? N.chart.langFormat("accessibility.series.nullPointValue", {
          point: e
        }) : N.pointArrayMap ? p(e, P, R) : P + F + R, b = C(j, {
          point: e,
          index: x,
          xDescription: f,
          value: N,
          separator: y ? ", " : ""
        }, b), j = (j = e.options && e.options.accessibility && e.options.accessibility.description) ? " " + j : "", a = c ? " " + a.name + "." : "", c = e.series.chart, y = u(e), f = {
          point: e,
          annotations: y
        }, c = y.length ? c.langFormat("accessibility.series.pointAnnotationsDescription", f) : "", e.accessibility = e.accessibility || {}, e.accessibility.valueDescription = b, b + j + a + (c ? " " + c : "");
      }
      function s(e) {
        var a = z(e),
          c = w(e),
          y = e.chart.options.accessibility.point.describeNull;
        (a || c) && e.points.forEach(function (b) {
          var j;
          if (!(j = b.graphic && b.graphic.element)) {
            var P = b.series;
            if (j = P && P.chart, P = P && P.is("sunburst"), j = j && j.options.accessibility.point.describeNull, j = b.isNull && !P && j) {
              P = b.series;
              var f = X(b);
              P = (j = f && f.graphic) ? j.parentGroup : P.graph || P.group, f = f ? {
                x: i(b.plotX, f.plotX, 0),
                y: i(b.plotY, f.plotY, 0)
              } : {
                x: i(b.plotX, 0),
                y: i(b.plotY, 0)
              }, f = b.series.chart.renderer.rect(f.x, f.y, 1, 1), f.attr({
                class: "highcharts-a11y-mock-point",
                fill: "none",
                opacity: 0,
                "fill-opacity": 0,
                "stroke-opacity": 0
              }), P && P.element ? (b.graphic = f, b.hasMockGraphic = !0, f.add(P), P.element.insertBefore(f.element, j ? j.element : null), j = f.element) : j = void 0;
            }
          }
          P = b.options && b.options.accessibility && b.options.accessibility.enabled === !1, j && (b.isNull && !y ? j.setAttribute("aria-hidden", !0) : (j.setAttribute("tabindex", "-1"), e.chart.styledMode || (j.style.outline = "none"), a && !P ? (f = b.series, P = f.chart.options.accessibility.point || {}, f = f.options.accessibility && f.options.accessibility.point || {}, b = o(f.descriptionFormatter && f.descriptionFormatter(b) || P.descriptionFormatter && P.descriptionFormatter(b) || h(b)), j.setAttribute("role", "img"), j.setAttribute("aria-label", b)) : j.setAttribute("aria-hidden", !0)));
        });
      }
      function l(e) {
        var a = e.chart,
          c = a.types || [],
          y = k(e),
          b = function b(N) {
            return a[N] && 1 < a[N].length && e[N];
          },
          j = e.index + 1,
          P = g(e, "xAxis"),
          f = g(e, "yAxis"),
          x = {
            seriesNumber: j,
            series: e,
            chart: a
          };
        return c = 1 < c.length ? "Combination" : "", x = a.langFormat("accessibility.series.summary." + e.type + c, x) || a.langFormat("accessibility.series.summary.default" + c, x), b = (b("yAxis") ? " " + f + "." : "") + (b("xAxis") ? " " + P + "." : ""), C(a.options.accessibility.series.descriptionFormat || "", {
          seriesDescription: x,
          authorDescription: y ? " " + y : "",
          axisDescription: b,
          series: e,
          chart: a,
          seriesNumber: j
        }, void 0);
      }
      var u = S.getPointAnnotationTexts,
        v = D.getAxisDescription,
        M = D.getSeriesFirstPointElement,
        I = D.getSeriesA11yElement,
        L = D.unhideChartElementFromAT,
        C = E.format,
        m = E.numberFormat,
        d = B.reverseChildNodes,
        o = B.stripHTMLTagsFromString,
        n = H.find,
        r = H.isNumber,
        i = H.pick,
        t = H.defined;
      return {
        defaultPointDescriptionFormatter: h,
        defaultSeriesDescriptionFormatter: l,
        describeSeries: function describeSeries(e) {
          var a = e.chart,
            c = M(e),
            y = I(e),
            b = a.is3d && a.is3d();
          if (y) {
            y.lastChild !== c || b || d(y), s(e), L(a, y), b = e.chart, a = b.options.chart, c = 1 < b.series.length, b = b.options.accessibility.series.describeSingleSeries;
            var j = (e.options.accessibility || {}).exposeAsGroupOnly;
            a.options3d && a.options3d.enabled && c || !(c || b || j || W(e)) ? y.removeAttribute("aria-label") : (a = e.chart.options.accessibility, c = a.landmarkVerbosity, (e.options.accessibility || {}).exposeAsGroupOnly ? y.setAttribute("role", "img") : c === "all" ? y.setAttribute("role", "region") : y.setAttribute("role", "group"), y.setAttribute("tabindex", "-1"), e.chart.styledMode || (y.style.outline = "none"), y.setAttribute("aria-label", o(a.series.descriptionFormatter && a.series.descriptionFormatter(e) || l(e))));
          }
        }
      };
    }), V(O, "Accessibility/Components/SeriesComponent/NewDataAnnouncer.js", [O["Core/Globals.js"], O["Core/Utilities.js"], O["Accessibility/Utils/Announcer.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/EventProvider.js"], O["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function (S, D, E, B, H, X) {
      function W(h) {
        var s = h.series.data.filter(function (l) {
          return h.x === l.x && h.y === l.y;
        });
        return s.length === 1 ? s[0] : h;
      }
      function z(h, s) {
        var l = (h || []).concat(s || []).reduce(function (u, v) {
          return u[v.name + v.index] = v, u;
        }, {});
        return Object.keys(l).map(function (u) {
          return l[u];
        });
      }
      var w = D.addEvent,
        A = D.defined,
        k = B.getChartTitle,
        g = X.defaultPointDescriptionFormatter,
        p = X.defaultSeriesDescriptionFormatter;
      return D = function () {
        function h(s) {
          this.announcer = void 0, this.dirty = {
            allSeries: {}
          }, this.eventProvider = void 0, this.lastAnnouncementTime = 0, this.chart = s;
        }
        return h.prototype.init = function () {
          var s = this.chart,
            l = s.options.accessibility.announceNewData.interruptUser ? "assertive" : "polite";
          this.lastAnnouncementTime = 0, this.dirty = {
            allSeries: {}
          }, this.eventProvider = new H(), this.announcer = new E(s, l), this.addEventListeners();
        }, h.prototype.destroy = function () {
          this.eventProvider.removeAddedEvents(), this.announcer.destroy();
        }, h.prototype.addEventListeners = function () {
          var s = this,
            l = this.chart,
            u = this.eventProvider;
          u.addEvent(l, "afterApplyDrilldown", function () {
            s.lastAnnouncementTime = 0;
          }), u.addEvent(l, "afterAddSeries", function (v) {
            s.onSeriesAdded(v.series);
          }), u.addEvent(l, "redraw", function () {
            s.announceDirtyData();
          });
        }, h.prototype.onSeriesAdded = function (s) {
          this.chart.options.accessibility.announceNewData.enabled && (this.dirty.hasDirty = !0, this.dirty.allSeries[s.name + s.index] = s, this.dirty.newSeries = A(this.dirty.newSeries) ? void 0 : s);
        }, h.prototype.announceDirtyData = function () {
          var s = this;
          if (this.chart.options.accessibility.announceNewData && this.dirty.hasDirty) {
            var l = this.dirty.newPoint;
            l && (l = W(l)), this.queueAnnouncement(Object.keys(this.dirty.allSeries).map(function (u) {
              return s.dirty.allSeries[u];
            }), this.dirty.newSeries, l), this.dirty = {
              allSeries: {}
            };
          }
        }, h.prototype.queueAnnouncement = function (s, l, u) {
          var v = this,
            M = this.chart.options.accessibility.announceNewData;
          if (M.enabled) {
            var I = + /* @__PURE__ */new Date();
            M = Math.max(0, M.minAnnounceInterval - (I - this.lastAnnouncementTime)), s = z(this.queuedAnnouncement && this.queuedAnnouncement.series, s), (l = this.buildAnnouncementMessage(s, l, u)) && (this.queuedAnnouncement && clearTimeout(this.queuedAnnouncementTimer), this.queuedAnnouncement = {
              time: I,
              message: l,
              series: s
            }, this.queuedAnnouncementTimer = setTimeout(function () {
              v && v.announcer && (v.lastAnnouncementTime = + /* @__PURE__ */new Date(), v.announcer.announce(v.queuedAnnouncement.message), delete v.queuedAnnouncement, delete v.queuedAnnouncementTimer);
            }, M));
          }
        }, h.prototype.buildAnnouncementMessage = function (s, l, u) {
          var v = this.chart,
            M = v.options.accessibility.announceNewData;
          return M.announcementFormatter && (s = M.announcementFormatter(s, l, u), s !== !1) ? s.length ? s : null : (s = S.charts && 1 < S.charts.length ? "Multiple" : "Single", s = l ? "newSeriesAnnounce" + s : u ? "newPointAnnounce" + s : "newDataAnnounce", M = k(v), v.langFormat("accessibility.announceNewData." + s, {
            chartTitle: M,
            seriesDesc: l ? p(l) : null,
            pointDesc: u ? g(u) : null,
            point: u,
            series: l
          }));
        }, h;
      }(), function (h) {
        function s(u) {
          var v = this.chart,
            M = this.newDataAnnouncer;
          M && M.chart === v && v.options.accessibility.announceNewData.enabled && (M.dirty.newPoint = A(M.dirty.newPoint) ? void 0 : u.point);
        }
        function l() {
          var u = this.chart,
            v = this.newDataAnnouncer;
          v && v.chart === u && u.options.accessibility.announceNewData.enabled && (v.dirty.hasDirty = !0, v.dirty.allSeries[this.name + this.index] = this);
        }
        h.composedClasses = [], h.compose = function (u) {
          h.composedClasses.indexOf(u) === -1 && (h.composedClasses.push(u), w(u, "addPoint", s), w(u, "updatedData", l));
        };
      }(D || (D = {})), D;
    }), V(O, "Accessibility/ProxyElement.js", [O["Core/Globals.js"], O["Core/Utilities.js"], O["Accessibility/Utils/EventProvider.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/HTMLUtilities.js"]], function (S, D, E, B, H) {
      var X = S.doc,
        W = D.attr,
        z = D.css,
        w = D.merge,
        A = B.fireEventOnWrappedOrUnwrappedElement,
        k = H.cloneMouseEvent,
        g = H.cloneTouchEvent,
        p = H.getFakeMouseEvent,
        h = H.removeElement;
      return function () {
        function s(l, u, v, M) {
          this.chart = l, this.target = u, this.groupType = v, v = v === "ul", this.eventProvider = new E();
          var I = v ? X.createElement("li") : null,
            L = this.buttonElement = X.createElement("button");
          l.styledMode || this.hideButtonVisually(L), I ? (v && !l.styledMode && (I.style.listStyle = "none"), I.appendChild(L), this.element = I) : this.element = L, this.updateTarget(u, M);
        }
        return s.prototype.click = function () {
          var l = this.getTargetPosition();
          l.x += l.width / 2, l.y += l.height / 2, l = p("click", l), A(this.target.click, l);
        }, s.prototype.updateTarget = function (l, u) {
          this.target = l, this.updateCSSClassName();
          var v = u || {};
          Object.keys(v).forEach(function (M) {
            v[M] === null && delete v[M];
          }), W(this.buttonElement, w({
            "aria-label": this.getTargetAttr(l.click, "aria-label")
          }, v)), this.eventProvider.removeAddedEvents(), this.addProxyEventsToButton(this.buttonElement, l.click), this.refreshPosition();
        }, s.prototype.refreshPosition = function () {
          var l = this.getTargetPosition();
          z(this.buttonElement, {
            width: (l.width || 1) + "px",
            height: (l.height || 1) + "px",
            left: (Math.round(l.x) || 0) + "px",
            top: (Math.round(l.y) || 0) + "px"
          });
        }, s.prototype.remove = function () {
          this.eventProvider.removeAddedEvents(), h(this.element);
        }, s.prototype.updateCSSClassName = function () {
          var l = this.chart.legend;
          l = l.group && l.group.div, l = -1 < (l && l.className || "").indexOf("highcharts-no-tooltip");
          var u = -1 < (this.getTargetAttr(this.target.click, "class") || "").indexOf("highcharts-no-tooltip");
          this.buttonElement.className = l || u ? "highcharts-a11y-proxy-button highcharts-no-tooltip" : "highcharts-a11y-proxy-button";
        }, s.prototype.addProxyEventsToButton = function (l, u) {
          var v = this;
          "click touchstart touchend touchcancel touchmove mouseover mouseenter mouseleave mouseout".split(" ").forEach(function (M) {
            var I = M.indexOf("touch") === 0;
            v.eventProvider.addEvent(l, M, function (L) {
              var C = I ? g(L) : k(L);
              u && A(u, C), L.stopPropagation(), I || L.preventDefault();
            }, {
              passive: !1
            });
          });
        }, s.prototype.hideButtonVisually = function (l) {
          z(l, {
            borderWidth: 0,
            backgroundColor: "transparent",
            cursor: "pointer",
            outline: "none",
            opacity: 1e-3,
            filter: "alpha(opacity=1)",
            zIndex: 999,
            overflow: "hidden",
            padding: 0,
            margin: 0,
            display: "block",
            position: "absolute",
            "-ms-filter": "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)"
          });
        }, s.prototype.getTargetPosition = function () {
          var l = this.target.click;
          if (l = l.element ? l.element : l, l = this.target.visual || l, this.chart.renderTo && l && l.getBoundingClientRect) {
            l = l.getBoundingClientRect();
            var u = this.chart.pointer.getChartPosition();
            return {
              x: (l.left - u.left) / u.scaleX,
              y: (l.top - u.top) / u.scaleY,
              width: l.right / u.scaleX - l.left / u.scaleX,
              height: l.bottom / u.scaleY - l.top / u.scaleY
            };
          }
          return {
            x: 0,
            y: 0,
            width: 1,
            height: 1
          };
        }, s.prototype.getTargetAttr = function (l, u) {
          return l.element ? l.element.getAttribute(u) : l.getAttribute(u);
        }, s;
      }();
    }), V(O, "Accessibility/ProxyProvider.js", [O["Core/Globals.js"], O["Core/Utilities.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/DOMElementProvider.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Accessibility/ProxyElement.js"]], function (S, D, E, B, H, X) {
      var W = S.doc,
        z = D.attr,
        w = D.css,
        A = E.unhideChartElementFromAT,
        k = H.removeElement,
        g = H.removeChildNodes;
      return function () {
        function p(h) {
          this.chart = h, this.domElementProvider = new B(), this.groups = {}, this.groupOrder = [], this.beforeChartProxyPosContainer = this.createProxyPosContainer("before"), this.afterChartProxyPosContainer = this.createProxyPosContainer("after"), this.update();
        }
        return p.prototype.addProxyElement = function (h, s, l) {
          var u = this.groups[h];
          if (!u) throw Error("ProxyProvider.addProxyElement: Invalid group key " + h);
          return h = new X(this.chart, s, u.type, l), u.proxyContainerElement.appendChild(h.element), u.proxyElements.push(h), h;
        }, p.prototype.addGroup = function (h, s, l) {
          var u = this.groups[h];
          if (u) return u.groupElement;
          if (u = this.domElementProvider.createElement(s), l && l.role && s !== "div") {
            var v = this.domElementProvider.createElement("div");
            v.appendChild(u);
          } else v = u;
          return v.className = "highcharts-a11y-proxy-group highcharts-a11y-proxy-group-" + h.replace(/\W/g, "-"), this.groups[h] = {
            proxyContainerElement: u,
            groupElement: v,
            type: s,
            proxyElements: []
          }, z(v, l || {}), s === "ul" && u.setAttribute("role", "list"), this.afterChartProxyPosContainer.appendChild(v), this.updateGroupOrder(this.groupOrder), v;
        }, p.prototype.updateGroupAttrs = function (h, s) {
          var l = this.groups[h];
          if (!l) throw Error("ProxyProvider.updateGroupAttrs: Invalid group key " + h);
          z(l.groupElement, s);
        }, p.prototype.updateGroupOrder = function (h) {
          var s = this;
          if (this.groupOrder = h.slice(), !this.isDOMOrderGroupOrder()) {
            var l = h.indexOf("series"),
              u = -1 < l ? h.slice(0, l) : h,
              v = -1 < l ? h.slice(l + 1) : [];
            h = W.activeElement, ["before", "after"].forEach(function (M) {
              var I = s[M === "before" ? "beforeChartProxyPosContainer" : "afterChartProxyPosContainer"];
              M = M === "before" ? u : v, g(I), M.forEach(function (L) {
                (L = s.groups[L]) && I.appendChild(L.groupElement);
              });
            }), (this.beforeChartProxyPosContainer.contains(h) || this.afterChartProxyPosContainer.contains(h)) && h && h.focus && h.focus();
          }
        }, p.prototype.clearGroup = function (h) {
          var s = this.groups[h];
          if (!s) throw Error("ProxyProvider.clearGroup: Invalid group key " + h);
          g(s.proxyContainerElement);
        }, p.prototype.removeGroup = function (h) {
          var s = this.groups[h];
          s && (k(s.groupElement), delete this.groups[h]);
        }, p.prototype.update = function () {
          this.updatePosContainerPositions(), this.updateGroupOrder(this.groupOrder), this.updateProxyElementPositions();
        }, p.prototype.updateProxyElementPositions = function () {
          Object.keys(this.groups).forEach(this.updateGroupProxyElementPositions.bind(this));
        }, p.prototype.updateGroupProxyElementPositions = function (h) {
          (h = this.groups[h]) && h.proxyElements.forEach(function (s) {
            return s.refreshPosition();
          });
        }, p.prototype.destroy = function () {
          this.domElementProvider.destroyCreatedElements();
        }, p.prototype.createProxyPosContainer = function (h) {
          var s = this.domElementProvider.createElement("div");
          return s.setAttribute("aria-hidden", "false"), s.className = "highcharts-a11y-proxy-container" + (h ? "-" + h : ""), w(s, {
            top: "0",
            left: "0"
          }), this.chart.styledMode || (s.style.whiteSpace = "nowrap", s.style.position = "absolute"), s;
        }, p.prototype.getCurrentGroupOrderInDOM = function () {
          var h = this,
            s = function s(u) {
              var v = [];
              u = u.children;
              for (var M = 0; M < u.length; ++M) {
                t: {
                  for (var I = u[M], L = Object.keys(h.groups), C = L.length; C--;) {
                    var m = L[C],
                      d = h.groups[m];
                    if (d && I === d.groupElement) {
                      I = m;
                      break t;
                    }
                  }
                  I = void 0;
                }
                I && v.push(I);
              }
              return v;
            },
            l = s(this.beforeChartProxyPosContainer);
          return s = s(this.afterChartProxyPosContainer), l.push("series"), l.concat(s);
        }, p.prototype.isDOMOrderGroupOrder = function () {
          var h = this,
            s = this.getCurrentGroupOrderInDOM(),
            l = this.groupOrder.filter(function (v) {
              return v === "series" || !!h.groups[v];
            }),
            u = s.length;
          if (u !== l.length) return !1;
          for (; u--;) if (s[u] !== l[u]) return !1;
          return !0;
        }, p.prototype.updatePosContainerPositions = function () {
          var h = this.chart;
          if (!h.renderer.forExport) {
            var s = h.renderer.box;
            h.container.insertBefore(this.afterChartProxyPosContainer, s.nextSibling), h.container.insertBefore(this.beforeChartProxyPosContainer, s), A(this.chart, this.afterChartProxyPosContainer), A(this.chart, this.beforeChartProxyPosContainer);
          }
        }, p;
      }();
    }), V(O, "Stock/RangeSelector/RangeSelectorDefaults.js", [], function () {
      return {
        lang: {
          rangeSelectorZoom: "Zoom",
          rangeSelectorFrom: "",
          rangeSelectorTo: "→"
        },
        rangeSelector: {
          allButtonsEnabled: !1,
          buttons: void 0,
          buttonSpacing: 5,
          dropdown: "responsive",
          enabled: void 0,
          verticalAlign: "top",
          buttonTheme: {
            width: 28,
            height: 18,
            padding: 2,
            zIndex: 7
          },
          floating: !1,
          x: 0,
          y: 0,
          height: void 0,
          inputBoxBorderColor: "none",
          inputBoxHeight: 17,
          inputBoxWidth: void 0,
          inputDateFormat: "%b %e, %Y",
          inputDateParser: void 0,
          inputEditDateFormat: "%Y-%m-%d",
          inputEnabled: !0,
          inputPosition: {
            align: "right",
            x: 0,
            y: 0
          },
          inputSpacing: 5,
          selected: void 0,
          buttonPosition: {
            align: "left",
            x: 0,
            y: 0
          },
          inputStyle: {
            color: "#335cad",
            cursor: "pointer"
          },
          labelStyle: {
            color: "#666666"
          }
        }
      };
    }), V(O, "Stock/RangeSelector/RangeSelectorComposition.js", [O["Core/Defaults.js"], O["Stock/RangeSelector/RangeSelectorDefaults.js"], O["Core/Utilities.js"]], function (S, D, E) {
      function B() {
        var d = this.range,
          o = d.type,
          n = this.max,
          r = this.chart.time,
          i = function i(c, y) {
            var b = o === "year" ? "FullYear" : "Month",
              j = new r.Date(c),
              P = r.get(b, j);
            return r.set(b, j, P + y), P === r.get(b, j) && r.set("Date", j, 0), j.getTime() - c;
          };
        if (v(d)) var t = n - d,
          e = d;else d && (t = n + i(n, -(d.count || 1)), this.chart && (this.chart.fixedRange = n - t));
        var a = I(this.dataMin, Number.MIN_VALUE);
        return v(t) || (t = a), t <= a && (t = a, typeof e > "u" && (e = i(t, d.count)), this.newMax = Math.min(t + e, I(this.dataMax, Number.MAX_VALUE))), v(n) ? !v(d) && d && d._offsetMin && (t += d._offsetMin) : t = void 0, t;
      }
      function H() {
        this.options.rangeSelector && this.options.rangeSelector.enabled && (this.rangeSelector = new m(this));
      }
      function X() {
        var d = this.axes,
          o = this.rangeSelector;
        o && (v(o.deferredYTDClick) && (o.clickButton(o.deferredYTDClick), delete o.deferredYTDClick), d.forEach(function (n) {
          n.updateNames(), n.setScale();
        }), this.getAxisMargins(), o.render(), d = o.options.verticalAlign, o.options.floating || (d === "bottom" ? this.extraBottomMargin = !0 : d !== "middle" && (this.extraTopMargin = !0)));
      }
      function W(d) {
        var o,
          n,
          r,
          i,
          t = d.rangeSelector,
          e = function e() {
            t && (o = d.xAxis[0].getExtremes(), n = d.legend, i = t && t.options.verticalAlign, v(o.min) && t.render(o.min, o.max), n.display && i === "top" && i === n.options.verticalAlign && (r = M(d.spacingBox), r.y = n.options.layout === "vertical" ? d.plotTop : r.y + t.getHeight(), n.group.placed = !1, n.align(r)));
          };
        t && (u(L, function (a) {
          return a[0] === d;
        }) || L.push([d, [h(d.xAxis[0], "afterSetExtremes", function (a) {
          t && t.render(a.min, a.max);
        }), h(d, "redraw", e)]]), e());
      }
      function z() {
        for (var d = 0, o = L.length; d < o; ++d) {
          var n = L[d];
          if (n[0] === this) {
            n[1].forEach(function (r) {
              return r();
            }), L.splice(d, 1);
            break;
          }
        }
      }
      function w() {
        var d = this.rangeSelector;
        d && (d = d.getHeight(), this.extraTopMargin && (this.plotTop += d), this.extraBottomMargin && (this.marginBottom += d));
      }
      function A() {
        var d = this.rangeSelector;
        d && !d.options.floating && (d.render(), d = d.options.verticalAlign, d === "bottom" ? this.extraBottomMargin = !0 : d !== "middle" && (this.extraTopMargin = !0));
      }
      function k(d) {
        var o = d.options.rangeSelector;
        d = this.extraBottomMargin;
        var n = this.extraTopMargin,
          r = this.rangeSelector;
        o && o.enabled && !s(r) && this.options.rangeSelector && (this.options.rangeSelector.enabled = !0, this.rangeSelector = r = new m(this)), this.extraTopMargin = this.extraBottomMargin = !1, r && (W(this), o = o && o.verticalAlign || r.options && r.options.verticalAlign, r.options.floating || (o === "bottom" ? this.extraBottomMargin = !0 : o !== "middle" && (this.extraTopMargin = !0)), this.extraBottomMargin !== d || this.extraTopMargin !== n) && (this.isDirtyBox = !0);
      }
      var g = S.defaultOptions,
        p = S.setOptions,
        h = E.addEvent,
        s = E.defined,
        l = E.extend,
        u = E.find,
        v = E.isNumber,
        M = E.merge,
        I = E.pick,
        L = [],
        C = [],
        m;
      return {
        compose: function compose(d, o, n) {
          m = n, C.indexOf(d) === -1 && (C.push(d), d.prototype.minFromRange = B), C.indexOf(o) === -1 && (C.push(o), h(o, "afterGetContainer", H), h(o, "beforeRender", X), h(o, "destroy", z), h(o, "getMargins", w), h(o, "render", A), h(o, "update", k), o.prototype.callbacks.push(W)), C.indexOf(p) === -1 && (l(g, {
            rangeSelector: D.rangeSelector
          }), l(g.lang, D.lang));
        }
      };
    }), V(O, "Stock/RangeSelector/RangeSelector.js", [O["Core/Axis/Axis.js"], O["Core/Defaults.js"], O["Core/Globals.js"], O["Stock/RangeSelector/RangeSelectorComposition.js"], O["Core/Renderer/SVG/SVGElement.js"], O["Core/Utilities.js"]], function (S, D, E, B, H, X) {
      function W(d) {
        if (d.indexOf("%L") !== -1) return "text";
        var o = "aAdewbBmoyY".split("").some(function (r) {
            return d.indexOf("%" + r) !== -1;
          }),
          n = "HkIlMS".split("").some(function (r) {
            return d.indexOf("%" + r) !== -1;
          });
        return o && n ? "datetime-local" : o ? "date" : n ? "time" : "text";
      }
      var z = D.defaultOptions,
        w = X.addEvent,
        A = X.createElement,
        k = X.css,
        g = X.defined,
        p = X.destroyObjectProperties,
        h = X.discardElement,
        s = X.extend,
        l = X.fireEvent,
        u = X.isNumber,
        v = X.merge,
        M = X.objectEach,
        I = X.pad,
        L = X.pick,
        C = X.pInt,
        m = X.splat;
      return D = function () {
        function d(o) {
          this.buttons = void 0, this.buttonOptions = d.prototype.defaultButtons, this.initialButtonGroupWidth = 0, this.options = void 0, this.chart = o, this.init(o);
        }
        return d.compose = function (o, n) {
          B.compose(o, n, d);
        }, d.prototype.clickButton = function (o, n) {
          var r = this.chart,
            i = this.buttonOptions[o],
            t = r.xAxis[0],
            e = r.scroller && r.scroller.getUnionExtremes() || t || {},
            a = i.type,
            c = i.dataGrouping,
            y = e.dataMin,
            b = e.dataMax,
            j = t && Math.round(Math.min(t.max, L(b, t.max)));
          e = i._range;
          var P,
            f = !0;
          if (y !== null && b !== null) {
            if (r.fixedRange = e, this.setSelected(o), c && (this.forcedDataGrouping = !0, S.prototype.setDataGrouping.call(t || {
              chart: this.chart
            }, c, !1), this.frozenStates = i.preserveDataGrouping), a === "month" || a === "year") {
              if (t) {
                a = {
                  range: i,
                  max: j,
                  chart: r,
                  dataMin: y,
                  dataMax: b
                };
                var x = t.minFromRange.call(a);
                u(a.newMax) && (j = a.newMax), f = !1;
              } else e = i;
            } else if (e) x = Math.max(j - e, y), j = Math.min(x + e, b), f = !1;else if (a === "ytd") {
              if (t) (typeof b > "u" || typeof y > "u") && (y = Number.MAX_VALUE, b = Number.MIN_VALUE, r.series.forEach(function (T) {
                (T = T.xData) && (y = Math.min(T[0], y), b = Math.max(T[T.length - 1], b));
              }), n = !1), a = this.getYTDExtremes(b, y, r.time.useUTC), x = P = a.min, j = a.max;else {
                this.deferredYTDClick = o;
                return;
              }
            } else a === "all" && t && (r.navigator && r.navigator.baseSeries[0] && (r.navigator.baseSeries[0].xAxis.options.range = void 0), x = y, j = b);
            if (f && i._offsetMin && g(x) && (x += i._offsetMin), i._offsetMax && g(j) && (j += i._offsetMax), this.dropdown && (this.dropdown.selectedIndex = o + 1), t) t.setExtremes(x, j, L(n, !0), void 0, {
              trigger: "rangeSelectorButton",
              rangeSelectorButton: i
            });else {
              var N = m(r.options.xAxis)[0],
                R = N.range;
              N.range = e;
              var F = N.min;
              N.min = P, w(r, "load", function () {
                N.range = R, N.min = F;
              });
            }
            l(this, "afterBtnClick");
          }
        }, d.prototype.setSelected = function (o) {
          this.selected = this.options.selected = o;
        }, d.prototype.init = function (o) {
          var n = this,
            r = o.options.rangeSelector,
            i = r.buttons || n.defaultButtons.slice(),
            t = r.selected,
            e = function e() {
              var a = n.minInput,
                c = n.maxInput;
              a && a.blur && l(a, "blur"), c && c.blur && l(c, "blur");
            };
          n.chart = o, n.options = r, n.buttons = [], n.buttonOptions = i, this.eventsToUnbind = [], this.eventsToUnbind.push(w(o.container, "mousedown", e)), this.eventsToUnbind.push(w(o, "resize", e)), i.forEach(n.computeButtonRange), typeof t < "u" && i[t] && this.clickButton(t, !1), this.eventsToUnbind.push(w(o, "load", function () {
            o.xAxis && o.xAxis[0] && w(o.xAxis[0], "setExtremes", function (a) {
              this.max - this.min !== o.fixedRange && a.trigger !== "rangeSelectorButton" && a.trigger !== "updatedData" && n.forcedDataGrouping && !n.frozenStates && this.setDataGrouping(!1, !1);
            });
          }));
        }, d.prototype.updateButtonStates = function () {
          var o = this,
            n = this.chart,
            r = this.dropdown,
            i = n.xAxis[0],
            t = Math.round(i.max - i.min),
            e = !i.hasVisibleSeries,
            a = n.scroller && n.scroller.getUnionExtremes() || i,
            c = a.dataMin,
            y = a.dataMax;
          n = o.getYTDExtremes(y, c, n.time.useUTC);
          var b = n.min,
            j = n.max,
            P = o.selected,
            f = o.options.allButtonsEnabled,
            x = o.buttons,
            N = u(P);
          o.buttonOptions.forEach(function (R, F) {
            var T = R._range,
              G = R.type,
              _ = R.count || 1,
              q = x[F],
              Y = R._offsetMax - R._offsetMin,
              U = F === P,
              Z = T > y - c,
              J = T < i.minRange;
            R = 0;
            var et = !1,
              nt = !1;
            T = T === t, (G === "month" || G === "year") && t + 36e5 >= 864e5 * {
              month: 28,
              year: 365
            }[G] * _ - Y && t - 36e5 <= 864e5 * {
              month: 31,
              year: 366
            }[G] * _ + Y ? T = !0 : G === "ytd" ? (T = j - b + Y === t, et = !U) : G === "all" && (T = i.max - i.min >= y - c, nt = !U && N && T), G = !f && (Z || J || nt || e), _ = U && T || T && !N && !et || U && o.frozenStates, G ? R = 3 : _ && (N = !0, R = 2), q.state !== R && (q.setState(R), r && (r.options[F + 1].disabled = G, R === 2 && (r.selectedIndex = F + 1)), R === 0 && P === F && o.setSelected());
          });
        }, d.prototype.computeButtonRange = function (o) {
          var n = o.type,
            r = o.count || 1,
            i = {
              millisecond: 1,
              second: 1e3,
              minute: 6e4,
              hour: 36e5,
              day: 864e5,
              week: 6048e5
            };
          i[n] ? o._range = i[n] * r : (n === "month" || n === "year") && (o._range = 864e5 * {
            month: 30,
            year: 365
          }[n] * r), o._offsetMin = L(o.offsetMin, 0), o._offsetMax = L(o.offsetMax, 0), o._range += o._offsetMax - o._offsetMin;
        }, d.prototype.getInputValue = function (o) {
          o = o === "min" ? this.minInput : this.maxInput;
          var n = this.chart.options.rangeSelector,
            r = this.chart.time;
          return o ? (o.type === "text" && n.inputDateParser || this.defaultInputDateParser)(o.value, r.useUTC, r) : 0;
        }, d.prototype.setInputValue = function (o, n) {
          var r = this.options,
            i = this.chart.time,
            t = o === "min" ? this.minInput : this.maxInput;
          if (o = o === "min" ? this.minDateBox : this.maxDateBox, t) {
            var e = t.getAttribute("data-hc-time");
            e = g(e) ? Number(e) : void 0, g(n) && (g(e) && t.setAttribute("data-hc-time-previous", e), t.setAttribute("data-hc-time", n), e = n), t.value = i.dateFormat(this.inputTypeFormats[t.type] || r.inputEditDateFormat, e), o && o.attr({
              text: i.dateFormat(r.inputDateFormat, e)
            });
          }
        }, d.prototype.setInputExtremes = function (o, n, r) {
          if (o = o === "min" ? this.minInput : this.maxInput) {
            var i = this.inputTypeFormats[o.type],
              t = this.chart.time;
            i && (n = t.dateFormat(i, n), o.min !== n && (o.min = n), r = t.dateFormat(i, r), o.max !== r && (o.max = r));
          }
        }, d.prototype.showInput = function (o) {
          var n = o === "min" ? this.minDateBox : this.maxDateBox;
          if ((o = o === "min" ? this.minInput : this.maxInput) && n && this.inputGroup) {
            var r = o.type === "text",
              i = this.inputGroup,
              t = i.translateX;
            i = i.translateY;
            var e = this.options.inputBoxWidth;
            k(o, {
              width: r ? n.width + (e ? -2 : 20) + "px" : "auto",
              height: r ? n.height - 2 + "px" : "auto",
              border: "2px solid silver"
            }), r && e ? k(o, {
              left: t + n.x + "px",
              top: i + "px"
            }) : k(o, {
              left: Math.min(Math.round(n.x + t - (o.offsetWidth - n.width) / 2), this.chart.chartWidth - o.offsetWidth) + "px",
              top: i - (o.offsetHeight - n.height) / 2 + "px"
            });
          }
        }, d.prototype.hideInput = function (o) {
          (o = o === "min" ? this.minInput : this.maxInput) && k(o, {
            top: "-9999em",
            border: 0,
            width: "1px",
            height: "1px"
          });
        }, d.prototype.defaultInputDateParser = function (o, n, r) {
          var i = o.split("/").join("-").split(" ").join("T");
          if (i.indexOf("T") === -1 && (i += "T00:00"), n) i += "Z";else {
            var t;
            (t = E.isSafari) && (t = i, t = !(6 < t.length && (t.lastIndexOf("-") === t.length - 6 || t.lastIndexOf("+") === t.length - 6))), t && (t = new Date(i).getTimezoneOffset() / 60, i += 0 >= t ? "+".concat(I(-t), ":00") : "-".concat(I(t), ":00"));
          }
          return i = Date.parse(i), u(i) || (o = o.split("-"), i = Date.UTC(C(o[0]), C(o[1]) - 1, C(o[2]))), r && n && u(i) && (i += r.getTimezoneOffset(i)), i;
        }, d.prototype.drawInput = function (o) {
          function n() {
            var x = e.maxInput,
              N = e.minInput,
              R = r.xAxis[0],
              F = r.scroller && r.scroller.xAxis ? r.scroller.xAxis : R,
              T = F.dataMin;
            F = F.dataMax;
            var G = e.getInputValue(o);
            G !== Number(P.getAttribute("data-hc-time-previous")) && u(G) && (P.setAttribute("data-hc-time-previous", G), b && x && u(T) ? G > Number(x.getAttribute("data-hc-time")) ? G = void 0 : G < T && (G = T) : N && u(F) && (G < Number(N.getAttribute("data-hc-time")) ? G = void 0 : G > F && (G = F)), typeof G < "u" && R.setExtremes(b ? G : R.min, b ? R.max : G, void 0, void 0, {
              trigger: "rangeSelectorInput"
            }));
          }
          var r = this.chart,
            i = this.div,
            t = this.inputGroup,
            e = this,
            a = r.renderer.style || {},
            c = r.renderer,
            y = r.options.rangeSelector,
            b = o === "min",
            j = z.lang[b ? "rangeSelectorFrom" : "rangeSelectorTo"] || "";
          j = c.label(j, 0).addClass("highcharts-range-label").attr({
            padding: j ? 2 : 0,
            height: j ? y.inputBoxHeight : 0
          }).add(t), c = c.label("", 0).addClass("highcharts-range-input").attr({
            padding: 2,
            width: y.inputBoxWidth,
            height: y.inputBoxHeight,
            "text-align": "center"
          }).on("click", function () {
            e.showInput(o), e[o + "Input"].focus();
          }), r.styledMode || c.attr({
            stroke: y.inputBoxBorderColor,
            "stroke-width": 1
          }), c.add(t);
          var P = A("input", {
            name: o,
            className: "highcharts-range-selector"
          }, void 0, i);
          P.setAttribute("type", W(y.inputDateFormat || "%b %e, %Y")), r.styledMode || (j.css(v(a, y.labelStyle)), c.css(v({
            color: "#333333"
          }, a, y.inputStyle)), k(P, s({
            position: "absolute",
            border: 0,
            boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            width: "1px",
            height: "1px",
            padding: 0,
            textAlign: "center",
            fontSize: a.fontSize,
            fontFamily: a.fontFamily,
            top: "-9999em"
          }, y.inputStyle))), P.onfocus = function () {
            e.showInput(o);
          }, P.onblur = function () {
            P === E.doc.activeElement && n(), e.hideInput(o), e.setInputValue(o), P.blur();
          };
          var f = !1;
          return P.onchange = function () {
            f || (n(), e.hideInput(o), P.blur());
          }, P.onkeypress = function (x) {
            x.keyCode === 13 && n();
          }, P.onkeydown = function (x) {
            f = !0, x.keyCode !== 38 && x.keyCode !== 40 || n();
          }, P.onkeyup = function () {
            f = !1;
          }, {
            dateBox: c,
            input: P,
            label: j
          };
        }, d.prototype.getPosition = function () {
          var o = this.chart,
            n = o.options.rangeSelector;
          return o = n.verticalAlign === "top" ? o.plotTop - o.axisOffset[0] : 0, {
            buttonTop: o + n.buttonPosition.y,
            inputTop: o + n.inputPosition.y - 10
          };
        }, d.prototype.getYTDExtremes = function (o, n, r) {
          var i = this.chart.time,
            t = new i.Date(o),
            e = i.get("FullYear", t);
          return r = r ? i.Date.UTC(e, 0, 1) : +new i.Date(e, 0, 1), n = Math.max(n, r), t = t.getTime(), {
            max: Math.min(o || t, t),
            min: n
          };
        }, d.prototype.render = function (o, n) {
          var r = this.chart,
            i = r.renderer,
            t = r.container,
            e = r.options,
            a = e.rangeSelector,
            c = L(e.chart.style && e.chart.style.zIndex, 0) + 1;
          if (e = a.inputEnabled, a.enabled !== !1) {
            if (this.rendered || (this.group = i.g("range-selector-group").attr({
              zIndex: 7
            }).add(), this.div = A("div", void 0, {
              position: "relative",
              height: 0,
              zIndex: c
            }), this.buttonOptions.length && this.renderButtons(), t.parentNode && t.parentNode.insertBefore(this.div, t), e && (this.inputGroup = i.g("input-group").add(this.group), i = this.drawInput("min"), this.minDateBox = i.dateBox, this.minLabel = i.label, this.minInput = i.input, i = this.drawInput("max"), this.maxDateBox = i.dateBox, this.maxLabel = i.label, this.maxInput = i.input)), e && (this.setInputValue("min", o), this.setInputValue("max", n), o = r.scroller && r.scroller.getUnionExtremes() || r.xAxis[0] || {}, g(o.dataMin) && g(o.dataMax) && (r = r.xAxis[0].minRange || 0, this.setInputExtremes("min", o.dataMin, Math.min(o.dataMax, this.getInputValue("max")) - r), this.setInputExtremes("max", Math.max(o.dataMin, this.getInputValue("min")) + r, o.dataMax)), this.inputGroup)) {
              var y = 0;
              [this.minLabel, this.minDateBox, this.maxLabel, this.maxDateBox].forEach(function (b) {
                if (b) {
                  var j = b.getBBox().width;
                  j && (b.attr({
                    x: y
                  }), y += j + a.inputSpacing);
                }
              });
            }
            this.alignElements(), this.rendered = !0;
          }
        }, d.prototype.renderButtons = function () {
          var o = this,
            n = this.buttons,
            r = this.options,
            i = z.lang,
            t = this.chart.renderer,
            e = v(r.buttonTheme),
            a = e && e.states,
            c = e.width || 28;
          delete e.width, delete e.states, this.buttonGroup = t.g("range-selector-buttons").add(this.group);
          var y = this.dropdown = A("select", void 0, {
            position: "absolute",
            width: "1px",
            height: "1px",
            padding: 0,
            border: 0,
            top: "-9999em",
            cursor: "pointer",
            opacity: 1e-4
          }, this.div);
          w(y, "touchstart", function () {
            y.style.fontSize = "16px";
          }), [[E.isMS ? "mouseover" : "mouseenter"], [E.isMS ? "mouseout" : "mouseleave"], ["change", "click"]].forEach(function (b) {
            var j = b[0],
              P = b[1];
            w(y, j, function () {
              var f = n[o.currentButtonIndex()];
              f && l(f.element, P || j);
            });
          }), this.zoomText = t.label(i && i.rangeSelectorZoom || "", 0).attr({
            padding: r.buttonTheme.padding,
            height: r.buttonTheme.height,
            paddingLeft: 0,
            paddingRight: 0
          }).add(this.buttonGroup), this.chart.styledMode || (this.zoomText.css(r.labelStyle), e["stroke-width"] = L(e["stroke-width"], 0)), A("option", {
            textContent: this.zoomText.textStr,
            disabled: !0
          }, void 0, y), this.buttonOptions.forEach(function (b, j) {
            A("option", {
              textContent: b.title || b.text
            }, void 0, y), n[j] = t.button(b.text, 0, 0, function (P) {
              var f = b.events && b.events.click,
                x;
              f && (x = f.call(b, P)), x !== !1 && o.clickButton(j), o.isActive = !0;
            }, e, a && a.hover, a && a.select, a && a.disabled).attr({
              "text-align": "center",
              width: c
            }).add(o.buttonGroup), b.title && n[j].attr("title", b.title);
          });
        }, d.prototype.alignElements = function () {
          var o = this,
            n = this.buttonGroup,
            r = this.buttons,
            i = this.chart,
            t = this.group,
            e = this.inputGroup,
            a = this.options,
            c = this.zoomText,
            y = i.options,
            b = y.exporting && y.exporting.enabled !== !1 && y.navigation && y.navigation.buttonOptions;
          y = a.buttonPosition;
          var j = a.inputPosition,
            P = a.verticalAlign,
            f = function f(F, T) {
              return b && o.titleCollision(i) && P === "top" && T.align === "right" && T.y - F.getBBox().height - 12 < (b.y || 0) + (b.height || 0) + i.spacing[0] ? -40 : 0;
            },
            x = i.plotLeft;
          if (t && y && j) {
            var N = y.x - i.spacing[3];
            if (n) {
              if (this.positionButtons(), !this.initialButtonGroupWidth) {
                var R = 0;
                c && (R += c.getBBox().width + 5), r.forEach(function (F, T) {
                  R += F.width, T !== r.length - 1 && (R += a.buttonSpacing);
                }), this.initialButtonGroupWidth = R;
              }
              x -= i.spacing[3], this.updateButtonStates(), c = f(n, y), this.alignButtonGroup(c), t.placed = n.placed = i.hasLoaded;
            }
            n = 0, e && (n = f(e, j), j.align === "left" ? N = x : j.align === "right" && (N = -Math.max(i.axisOffset[1], -n)), e.align({
              y: j.y,
              width: e.getBBox().width,
              align: j.align,
              x: j.x + N - 2
            }, !0, i.spacingBox), e.placed = i.hasLoaded), this.handleCollision(n), t.align({
              verticalAlign: P
            }, !0, i.spacingBox), e = t.alignAttr.translateY, n = t.getBBox().height + 20, f = 0, P === "bottom" && (f = (f = i.legend && i.legend.options) && f.verticalAlign === "bottom" && f.enabled && !f.floating ? i.legend.legendHeight + L(f.margin, 10) : 0, n = n + f - 20, f = e - n - (a.floating ? 0 : a.y) - (i.titleOffset ? i.titleOffset[2] : 0) - 10), P === "top" ? (a.floating && (f = 0), i.titleOffset && i.titleOffset[0] && (f = i.titleOffset[0]), f += i.margin[0] - i.spacing[0] || 0) : P === "middle" && (j.y === y.y ? f = e : (j.y || y.y) && (f = 0 > j.y || 0 > y.y ? f - Math.min(j.y, y.y) : e - n)), t.translate(a.x, a.y + Math.floor(f)), y = this.minInput, j = this.maxInput, e = this.dropdown, a.inputEnabled && y && j && (y.style.marginTop = t.translateY + "px", j.style.marginTop = t.translateY + "px"), e && (e.style.marginTop = t.translateY + "px");
          }
        }, d.prototype.alignButtonGroup = function (o, n) {
          var r = this.chart,
            i = this.buttonGroup,
            t = this.options.buttonPosition,
            e = r.plotLeft - r.spacing[3],
            a = t.x - r.spacing[3];
          t.align === "right" ? a += o - e : t.align === "center" && (a -= e / 2), i && i.align({
            y: t.y,
            width: L(n, this.initialButtonGroupWidth),
            align: t.align,
            x: a
          }, !0, r.spacingBox);
        }, d.prototype.positionButtons = function () {
          var o = this.buttons,
            n = this.chart,
            r = this.options,
            i = this.zoomText,
            t = n.hasLoaded ? "animate" : "attr",
            e = r.buttonPosition,
            a = n = n.plotLeft;
          for (i && i.visibility !== "hidden" && (i[t]({
            x: L(n + e.x, n)
          }), a += e.x + i.getBBox().width + 5), i = 0, e = this.buttonOptions.length; i < e; ++i) o[i].visibility !== "hidden" ? (o[i][t]({
            x: a
          }), a += o[i].width + r.buttonSpacing) : o[i][t]({
            x: n
          });
        }, d.prototype.handleCollision = function (o) {
          var n = this,
            r = this.chart,
            i = this.buttonGroup,
            t = this.inputGroup,
            e = this.options,
            a = e.buttonPosition,
            c = e.dropdown,
            y = e.inputPosition;
          e = function e() {
            var P = 0;
            return n.buttons.forEach(function (f) {
              f = f.getBBox(), f.width > P && (P = f.width);
            }), P;
          };
          var b = function b(P) {
              if (t && i) {
                var f = t.alignAttr.translateX + t.alignOptions.x - o + t.getBBox().x + 2,
                  x = t.alignOptions.width,
                  N = i.alignAttr.translateX + i.getBBox().x;
                return N + P > f && f + x > N && a.y < y.y + t.getBBox().height;
              }
              return !1;
            },
            j = function j() {
              t && i && t.attr({
                translateX: t.alignAttr.translateX + (r.axisOffset[1] >= -o ? 0 : -o),
                translateY: t.alignAttr.translateY + i.getBBox().height + 10
              });
            };
          if (i) {
            if (c === "always") {
              this.collapseButtons(o), b(e()) && j();
              return;
            }
            c === "never" && this.expandButtons();
          }
          t && i ? y.align === a.align || b(this.initialButtonGroupWidth + 20) ? c === "responsive" ? (this.collapseButtons(o), b(e()) && j()) : j() : c === "responsive" && this.expandButtons() : i && c === "responsive" && (this.initialButtonGroupWidth > r.plotWidth ? this.collapseButtons(o) : this.expandButtons());
        }, d.prototype.collapseButtons = function (o) {
          var n = this.buttons,
            r = this.buttonOptions,
            i = this.chart,
            t = this.dropdown,
            e = this.options,
            a = this.zoomText,
            c = i.userOptions.rangeSelector && i.userOptions.rangeSelector.buttonTheme || {},
            y = function y(j) {
              return {
                text: j ? "" + j + " ▾" : "▾",
                width: "auto",
                paddingLeft: L(e.buttonTheme.paddingLeft, c.padding, 8),
                paddingRight: L(e.buttonTheme.paddingRight, c.padding, 8)
              };
            };
          a && a.hide();
          var b = !1;
          r.forEach(function (j, P) {
            P = n[P], P.state !== 2 ? P.hide() : (P.show(), P.attr(y(j.text)), b = !0);
          }), b || (t && (t.selectedIndex = 0), n[0].show(), n[0].attr(y(this.zoomText && this.zoomText.textStr))), r = e.buttonPosition.align, this.positionButtons(), r !== "right" && r !== "center" || this.alignButtonGroup(o, n[this.currentButtonIndex()].getBBox().width), this.showDropdown();
        }, d.prototype.expandButtons = function () {
          var o = this.buttons,
            n = this.buttonOptions,
            r = this.options,
            i = this.zoomText;
          this.hideDropdown(), i && i.show(), n.forEach(function (t, e) {
            e = o[e], e.show(), e.attr({
              text: t.text,
              width: r.buttonTheme.width || 28,
              paddingLeft: L(r.buttonTheme.paddingLeft, "unset"),
              paddingRight: L(r.buttonTheme.paddingRight, "unset")
            }), 2 > e.state && e.setState(0);
          }), this.positionButtons();
        }, d.prototype.currentButtonIndex = function () {
          var o = this.dropdown;
          return o && 0 < o.selectedIndex ? o.selectedIndex - 1 : 0;
        }, d.prototype.showDropdown = function () {
          var o = this.buttonGroup,
            n = this.buttons,
            r = this.chart,
            i = this.dropdown;
          if (o && i) {
            var t = o.translateX;
            o = o.translateY, n = n[this.currentButtonIndex()].getBBox(), k(i, {
              left: r.plotLeft + t + "px",
              top: o + 0.5 + "px",
              width: n.width + "px",
              height: n.height + "px"
            }), this.hasVisibleDropdown = !0;
          }
        }, d.prototype.hideDropdown = function () {
          var o = this.dropdown;
          o && (k(o, {
            top: "-9999em",
            width: "1px",
            height: "1px"
          }), this.hasVisibleDropdown = !1);
        }, d.prototype.getHeight = function () {
          var o = this.options,
            n = this.group,
            r = o.y,
            i = o.buttonPosition.y,
            t = o.inputPosition.y;
          return o.height ? o.height : (this.alignElements(), o = n ? n.getBBox(!0).height + 13 + r : 0, n = Math.min(t, i), (0 > t && 0 > i || 0 < t && 0 < i) && (o += Math.abs(n)), o);
        }, d.prototype.titleCollision = function (o) {
          return !(o.options.title.text || o.options.subtitle.text);
        }, d.prototype.update = function (o) {
          var n = this.chart;
          v(!0, n.options.rangeSelector, o), this.destroy(), this.init(n), this.render();
        }, d.prototype.destroy = function () {
          var o = this,
            n = o.minInput,
            r = o.maxInput;
          o.eventsToUnbind && (o.eventsToUnbind.forEach(function (i) {
            return i();
          }), o.eventsToUnbind = void 0), p(o.buttons), n && (n.onfocus = n.onblur = n.onchange = null), r && (r.onfocus = r.onblur = r.onchange = null), M(o, function (i, t) {
            i && t !== "chart" && (i instanceof H ? i.destroy() : i instanceof window.HTMLElement && h(i)), i !== d.prototype[t] && (o[t] = null);
          }, this);
        }, d;
      }(), s(D.prototype, {
        defaultButtons: [{
          type: "month",
          count: 1,
          text: "1m",
          title: "View 1 month"
        }, {
          type: "month",
          count: 3,
          text: "3m",
          title: "View 3 months"
        }, {
          type: "month",
          count: 6,
          text: "6m",
          title: "View 6 months"
        }, {
          type: "ytd",
          text: "YTD",
          title: "View year to date"
        }, {
          type: "year",
          count: 1,
          text: "1y",
          title: "View 1 year"
        }, {
          type: "all",
          text: "All",
          title: "View all"
        }],
        inputTypeFormats: {
          "datetime-local": "%Y-%m-%dT%H:%M:%S",
          date: "%Y-%m-%d",
          time: "%H:%M:%S"
        }
      }), D;
    }), V(O, "Accessibility/Components/RangeSelectorComponent.js", [O["Stock/RangeSelector/RangeSelector.js"], O["Accessibility/AccessibilityComponent.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/Announcer.js"], O["Accessibility/KeyboardNavigationHandler.js"], O["Core/Utilities.js"]], function (S, D, E, B, H, X) {
      var W = this && this.__extends || function () {
          var _g5 = function g(p, h) {
            return _g5 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (s, l) {
              s.__proto__ = l;
            } || function (s, l) {
              for (var u in l) l.hasOwnProperty(u) && (s[u] = l[u]);
            }, _g5(p, h);
          };
          return function (p, h) {
            function s() {
              this.constructor = p;
            }
            _g5(p, h), p.prototype = h === null ? Object.create(h) : (s.prototype = h.prototype, new s());
          };
        }(),
        z = E.unhideChartElementFromAT,
        w = E.getAxisRangeDescription,
        A = X.addEvent,
        k = X.attr;
      return D = function (g) {
        function p() {
          var h = g !== null && g.apply(this, arguments) || this;
          return h.announcer = void 0, h;
        }
        return W(p, g), p.prototype.init = function () {
          this.announcer = new B(this.chart, "polite");
        }, p.prototype.onChartUpdate = function () {
          var h = this.chart,
            s = this,
            l = h.rangeSelector;
          l && (this.updateSelectorVisibility(), this.setDropdownAttrs(), l.buttons && l.buttons.length && l.buttons.forEach(function (u) {
            s.setRangeButtonAttrs(u);
          }), l.maxInput && l.minInput && ["minInput", "maxInput"].forEach(function (u, v) {
            (u = l[u]) && (z(h, u), s.setRangeInputAttrs(u, "accessibility.rangeSelector." + (v ? "max" : "min") + "InputLabel"));
          }));
        }, p.prototype.updateSelectorVisibility = function () {
          var h = this.chart,
            s = h.rangeSelector,
            l = s && s.dropdown,
            u = s && s.buttons || [];
          s && s.hasVisibleDropdown && l ? (z(h, l), u.forEach(function (v) {
            return v.element.setAttribute("aria-hidden", !0);
          })) : (l && l.setAttribute("aria-hidden", !0), u.forEach(function (v) {
            return z(h, v.element);
          }));
        }, p.prototype.setDropdownAttrs = function () {
          var h = this.chart,
            s = h.rangeSelector && h.rangeSelector.dropdown;
          s && (h = h.langFormat("accessibility.rangeSelector.dropdownLabel", {
            rangeTitle: h.options.lang.rangeSelectorZoom
          }), s.setAttribute("aria-label", h), s.setAttribute("tabindex", -1));
        }, p.prototype.setRangeButtonAttrs = function (h) {
          k(h.element, {
            tabindex: -1,
            role: "button"
          });
        }, p.prototype.setRangeInputAttrs = function (h, s) {
          var l = this.chart;
          k(h, {
            tabindex: -1,
            "aria-label": l.langFormat(s, {
              chart: l
            })
          });
        }, p.prototype.onButtonNavKbdArrowKey = function (h, s) {
          var l = h.response,
            u = this.keyCodes,
            v = this.chart,
            M = v.options.accessibility.keyboardNavigation.wrapAround;
          return s = s === u.left || s === u.up ? -1 : 1, v.highlightRangeSelectorButton(v.highlightedRangeSelectorItemIx + s) ? l.success : M ? (h.init(s), l.success) : l[0 < s ? "next" : "prev"];
        }, p.prototype.onButtonNavKbdClick = function (h) {
          h = h.response;
          var s = this.chart;
          return s.oldRangeSelectorItemState !== 3 && this.fakeClickEvent(s.rangeSelector.buttons[s.highlightedRangeSelectorItemIx].element), h.success;
        }, p.prototype.onAfterBtnClick = function () {
          var h = this.chart,
            s = w(h.xAxis[0]);
          (h = h.langFormat("accessibility.rangeSelector.clickButtonAnnouncement", {
            chart: h,
            axisRangeDescription: s
          })) && this.announcer.announce(h);
        }, p.prototype.onInputKbdMove = function (h) {
          var s = this.chart,
            l = s.rangeSelector,
            u = s.highlightedInputRangeIx = (s.highlightedInputRangeIx || 0) + h;
          1 < u || 0 > u ? s.accessibility && (s.accessibility.keyboardNavigation.tabindexContainer.focus(), s.accessibility.keyboardNavigation.move(h)) : l && (h = l[u ? "maxDateBox" : "minDateBox"], l = l[u ? "maxInput" : "minInput"], h && l && s.setFocusToElement(h, l));
        }, p.prototype.onInputNavInit = function (h) {
          var s = this,
            l = this,
            u = this.chart,
            v = 0 < h ? 0 : 1,
            M = u.rangeSelector,
            I = M && M[v ? "maxDateBox" : "minDateBox"];
          if (h = M && M.minInput, M = M && M.maxInput, u.highlightedInputRangeIx = v, I && h && M) {
            u.setFocusToElement(I, v ? M : h), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), u = function u(m) {
              (m.which || m.keyCode) === s.keyCodes.tab && (m.preventDefault(), m.stopPropagation(), l.onInputKbdMove(m.shiftKey ? -1 : 1));
            };
            var L = A(h, "keydown", u),
              C = A(M, "keydown", u);
            this.removeInputKeydownHandler = function () {
              L(), C();
            };
          }
        }, p.prototype.onInputNavTerminate = function () {
          var h = this.chart.rangeSelector || {};
          h.maxInput && h.hideInput("max"), h.minInput && h.hideInput("min"), this.removeInputKeydownHandler && (this.removeInputKeydownHandler(), delete this.removeInputKeydownHandler);
        }, p.prototype.initDropdownNav = function () {
          var h = this,
            s = this.chart,
            l = s.rangeSelector,
            u = l && l.dropdown;
          l && u && (s.setFocusToElement(l.buttonGroup, u), this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeDropdownKeydownHandler = A(u, "keydown", function (v) {
            var M = s.accessibility;
            (v.which || v.keyCode) === h.keyCodes.tab && (v.preventDefault(), v.stopPropagation(), M && (M.keyboardNavigation.tabindexContainer.focus(), M.keyboardNavigation.move(v.shiftKey ? -1 : 1)));
          }));
        }, p.prototype.getRangeSelectorButtonNavigation = function () {
          var h = this.chart,
            s = this.keyCodes,
            l = this;
          return new H(h, {
            keyCodeMap: [[[s.left, s.right, s.up, s.down], function (u) {
              return l.onButtonNavKbdArrowKey(this, u);
            }], [[s.enter, s.space], function () {
              return l.onButtonNavKbdClick(this);
            }]],
            validate: function validate() {
              return !!(h.rangeSelector && h.rangeSelector.buttons && h.rangeSelector.buttons.length);
            },
            init: function init(u) {
              var v = h.rangeSelector;
              v && v.hasVisibleDropdown ? l.initDropdownNav() : v && (v = v.buttons.length - 1, h.highlightRangeSelectorButton(0 < u ? 0 : v));
            },
            terminate: function terminate() {
              l.removeDropdownKeydownHandler && (l.removeDropdownKeydownHandler(), delete l.removeDropdownKeydownHandler);
            }
          });
        }, p.prototype.getRangeSelectorInputNavigation = function () {
          var h = this.chart,
            s = this;
          return new H(h, {
            keyCodeMap: [],
            validate: function validate() {
              return !!(h.rangeSelector && h.rangeSelector.inputGroup && h.rangeSelector.inputGroup.element.style.visibility !== "hidden" && h.options.rangeSelector.inputEnabled !== !1 && h.rangeSelector.minInput && h.rangeSelector.maxInput);
            },
            init: function init(l) {
              s.onInputNavInit(l);
            },
            terminate: function terminate() {
              s.onInputNavTerminate();
            }
          });
        }, p.prototype.getKeyboardNavigation = function () {
          return [this.getRangeSelectorButtonNavigation(), this.getRangeSelectorInputNavigation()];
        }, p.prototype.destroy = function () {
          this.removeDropdownKeydownHandler && this.removeDropdownKeydownHandler(), this.removeInputKeydownHandler && this.removeInputKeydownHandler(), this.announcer && this.announcer.destroy();
        }, p;
      }(D), function (g) {
        function p(l) {
          var u = this.rangeSelector && this.rangeSelector.buttons || [],
            v = this.highlightedRangeSelectorItemIx,
            M = this.rangeSelector && this.rangeSelector.selected;
          return typeof v < "u" && u[v] && v !== M && u[v].setState(this.oldRangeSelectorItemState || 0), this.highlightedRangeSelectorItemIx = l, u[l] ? (this.setFocusToElement(u[l].box, u[l].element), l !== M && (this.oldRangeSelectorItemState = u[l].state, u[l].setState(1)), !0) : !1;
        }
        function h() {
          var l = this.chart.accessibility;
          if (l && l.components.rangeSelector) return l.components.rangeSelector.onAfterBtnClick();
        }
        var s = [];
        g.compose = function (l, u) {
          s.indexOf(l) === -1 && (s.push(l), l.prototype.highlightRangeSelectorButton = p), s.indexOf(u) === -1 && (s.push(u), A(S, "afterBtnClick", h));
        };
      }(D || (D = {})), D;
    }), V(O, "Accessibility/Components/SeriesComponent/ForcedMarkers.js", [O["Core/Utilities.js"]], function (S) {
      var D = S.addEvent,
        E = S.merge,
        B;
      return function (H) {
        function X(g) {
          E(!0, g, {
            marker: {
              enabled: !0,
              states: {
                normal: {
                  opacity: 0
                }
              }
            }
          });
        }
        function W(g) {
          return g.marker.states && g.marker.states.normal && g.marker.states.normal.opacity;
        }
        function z() {
          this.chart.styledMode && (this.markerGroup && this.markerGroup[this.a11yMarkersForced ? "addClass" : "removeClass"]("highcharts-a11y-markers-hidden"), this._hasPointMarkers && this.points && this.points.length && this.points.forEach(function (g) {
            g.graphic && (g.graphic[g.hasForcedA11yMarker ? "addClass" : "removeClass"]("highcharts-a11y-marker-hidden"), g.graphic[g.hasForcedA11yMarker === !1 ? "addClass" : "removeClass"]("highcharts-a11y-marker-visible"));
          }));
        }
        function w(g) {
          this.resetA11yMarkerOptions = E(g.options.marker || {}, this.userOptions.marker || {});
        }
        function A() {
          var g = this.options,
            p = (this.options.accessibility && this.options.accessibility.enabled) !== !1;
          if ((p = this.chart.options.accessibility.enabled && p) && (p = this.chart.options.accessibility, p = this.points.length < p.series.pointDescriptionEnabledThreshold || p.series.pointDescriptionEnabledThreshold === !1), p) {
            if (g.marker && g.marker.enabled === !1 && (this.a11yMarkersForced = !0, X(this.options)), this._hasPointMarkers && this.points && this.points.length) for (g = this.points.length; g--;) {
              p = this.points[g];
              var h = p.options,
                s = p.hasForcedA11yMarker;
              delete p.hasForcedA11yMarker, h.marker && (s = s && W(h) === 0, h.marker.enabled && !s ? (E(!0, h.marker, {
                states: {
                  normal: {
                    opacity: W(h) || 1
                  }
                }
              }), p.hasForcedA11yMarker = !1) : h.marker.enabled === !1 && (X(h), p.hasForcedA11yMarker = !0));
            }
          } else this.a11yMarkersForced && (delete this.a11yMarkersForced, (g = this.resetA11yMarkerOptions) && this.update({
            marker: {
              enabled: g.enabled,
              states: {
                normal: {
                  opacity: g.states && g.states.normal && g.states.normal.opacity
                }
              }
            }
          }), delete this.resetA11yMarkerOptions);
        }
        var k = [];
        H.compose = function (g) {
          k.indexOf(g) === -1 && (k.push(g), D(g, "afterSetOptions", w), D(g, "render", A), D(g, "afterRender", z));
        };
      }(B || (B = {})), B;
    }), V(O, "Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js", [O["Core/Series/Point.js"], O["Core/Series/Series.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Globals.js"], O["Core/Utilities.js"], O["Accessibility/KeyboardNavigationHandler.js"], O["Accessibility/Utils/EventProvider.js"], O["Accessibility/Utils/ChartUtilities.js"]], function (S, D, E, B, H, X, W, z) {
      function w(C) {
        var m = C.index,
          d = C.series.points,
          o = d.length;
        if (d[m] !== C) {
          for (; o--;) if (d[o] === C) return o;
        } else return m;
      }
      function A(C) {
        var m = C.chart.options.accessibility.keyboardNavigation.seriesNavigation,
          d = C.options.accessibility || {},
          o = d.keyboardNavigation;
        return o && o.enabled === !1 || d.enabled === !1 || C.options.enableMouseTracking === !1 || !C.visible || m.pointNavigationEnabledThreshold && m.pointNavigationEnabledThreshold <= C.points.length;
      }
      function k(C) {
        var m = C.series.chart.options.accessibility,
          d = C.options.accessibility && C.options.accessibility.enabled === !1;
        return C.isNull && m.keyboardNavigation.seriesNavigation.skipNullPoints || C.visible === !1 || C.isInside === !1 || d || A(C.series);
      }
      function g(C) {
        C = C.series || [];
        for (var m = C.length, d = 0; d < m; ++d) if (!A(C[d])) {
          t: {
            for (var o = C[d].points || [], n = o.length, r = 0; r < n; ++r) if (!k(o[r])) {
              o = o[r];
              break t;
            }
            o = null;
          }
          if (o) return o;
        }
        return null;
      }
      function p(C) {
        for (var m = C.series.length, d = !1; m-- && (C.highlightedPoint = C.series[m].points[C.series[m].points.length - 1], !(d = C.series[m].highlightNextValidPoint())););
        return d;
      }
      function h(C) {
        return delete C.highlightedPoint, (C = g(C)) ? C.highlight() : !1;
      }
      var s = E.seriesTypes,
        l = B.doc,
        u = H.defined,
        v = H.fireEvent,
        M = z.getPointFromXY,
        I = z.getSeriesFromName,
        L = z.scrollToPoint;
      return E = function () {
        function C(m, d) {
          this.keyCodes = d, this.chart = m;
        }
        return C.prototype.init = function () {
          var m = this,
            d = this.chart,
            o = this.eventProvider = new W();
          o.addEvent(D, "destroy", function () {
            return m.onSeriesDestroy(this);
          }), o.addEvent(d, "afterApplyDrilldown", function () {
            var n = g(this);
            n && n.highlight(!1);
          }), o.addEvent(d, "drilldown", function (n) {
            n = n.point;
            var r = n.series;
            m.lastDrilledDownPoint = {
              x: n.x,
              y: n.y,
              seriesName: r ? r.name : ""
            };
          }), o.addEvent(d, "drillupall", function () {
            setTimeout(function () {
              m.onDrillupAll();
            }, 10);
          }), o.addEvent(S, "afterSetState", function () {
            var n = this.graphic && this.graphic.element,
              r = l.activeElement,
              i = r && r.getAttribute("class");
            i = i && -1 < i.indexOf("highcharts-a11y-proxy-button"), d.highlightedPoint === this && r !== n && !i && n && n.focus && n.focus();
          });
        }, C.prototype.onDrillupAll = function () {
          var m = this.lastDrilledDownPoint,
            d = this.chart,
            o = m && I(d, m.seriesName),
            n;
          m && o && u(m.x) && u(m.y) && (n = M(o, m.x, m.y)), n = n || g(d), d.container && d.container.focus(), n && n.highlight && n.highlight(!1);
        }, C.prototype.getKeyboardNavigationHandler = function () {
          var m = this,
            d = this.keyCodes,
            o = this.chart,
            n = o.inverted;
          return new X(o, {
            keyCodeMap: [[n ? [d.up, d.down] : [d.left, d.right], function (r) {
              return m.onKbdSideways(this, r);
            }], [n ? [d.left, d.right] : [d.up, d.down], function (r) {
              return m.onKbdVertical(this, r);
            }], [[d.enter, d.space], function (r, i) {
              return (r = o.highlightedPoint) && (i.point = r, v(r.series, "click", i), r.firePointEvent("click")), this.response.success;
            }], [[d.home], function () {
              return h(o), this.response.success;
            }], [[d.end], function () {
              return p(o), this.response.success;
            }], [[d.pageDown, d.pageUp], function (r) {
              return o.highlightAdjacentSeries(r === d.pageDown), this.response.success;
            }]],
            init: function init() {
              return m.onHandlerInit(this);
            },
            validate: function validate() {
              return !!g(o);
            },
            terminate: function terminate() {
              return m.onHandlerTerminate();
            }
          });
        }, C.prototype.onKbdSideways = function (m, d) {
          var o = this.keyCodes;
          return this.attemptHighlightAdjacentPoint(m, d === o.right || d === o.down);
        }, C.prototype.onHandlerInit = function (m) {
          var d = this.chart;
          return d.options.accessibility.keyboardNavigation.seriesNavigation.rememberPointFocus && d.highlightedPoint ? d.highlightedPoint.highlight() : h(d), m.response.success;
        }, C.prototype.onKbdVertical = function (m, d) {
          var o = this.chart,
            n = this.keyCodes;
          return d = d === n.down || d === n.right, n = o.options.accessibility.keyboardNavigation.seriesNavigation, n.mode && n.mode === "serialize" ? this.attemptHighlightAdjacentPoint(m, d) : (o[o.highlightedPoint && o.highlightedPoint.series.keyboardMoveVertical ? "highlightAdjacentPointVertical" : "highlightAdjacentSeries"](d), m.response.success);
        }, C.prototype.onHandlerTerminate = function () {
          var m = this.chart,
            d = m.options.accessibility.keyboardNavigation;
          m.tooltip && m.tooltip.hide(0);
          var o = m.highlightedPoint && m.highlightedPoint.series;
          o && o.onMouseOut && o.onMouseOut(), m.highlightedPoint && m.highlightedPoint.onMouseOut && m.highlightedPoint.onMouseOut(), d.seriesNavigation.rememberPointFocus || delete m.highlightedPoint;
        }, C.prototype.attemptHighlightAdjacentPoint = function (m, d) {
          var o = this.chart,
            n = o.options.accessibility.keyboardNavigation.wrapAround;
          return o.highlightAdjacentPoint(d) || n && (d ? h(o) : p(o)) ? m.response.success : m.response[d ? "next" : "prev"];
        }, C.prototype.onSeriesDestroy = function (m) {
          var d = this.chart;
          d.highlightedPoint && d.highlightedPoint.series === m && (delete d.highlightedPoint, d.focusElement && d.focusElement.removeFocusBorder());
        }, C.prototype.destroy = function () {
          this.eventProvider.removeAddedEvents();
        }, C;
      }(), function (C) {
        function m(e) {
          var a = this.series,
            c = this.highlightedPoint,
            y = c && w(c) || 0,
            b = c && c.series.points || [],
            j = this.series && this.series[this.series.length - 1];
          if (j = j && j.points && j.points[j.points.length - 1], !a[0] || !a[0].points) return !1;
          if (c) {
            if (a = a[c.series.index + (e ? 1 : -1)], y = b[y + (e ? 1 : -1)], !y && a && (y = a.points[e ? 0 : a.points.length - 1]), !y) return !1;
          } else y = e ? a[0].points[0] : j;
          return k(y) ? (a = y.series, A(a) ? this.highlightedPoint = e ? a.points[a.points.length - 1] : a.points[0] : this.highlightedPoint = y, this.highlightAdjacentPoint(e)) : y.highlight();
        }
        function d(e) {
          var a = this.highlightedPoint,
            c = 1 / 0,
            y;
          return !u(a.plotX) || !u(a.plotY) ? !1 : (this.series.forEach(function (b) {
            A(b) || b.points.forEach(function (j) {
              if (u(j.plotY) && u(j.plotX) && j !== a) {
                var P = j.plotY - a.plotY,
                  f = Math.abs(j.plotX - a.plotX);
                f = Math.abs(P) * Math.abs(P) + f * f * 4, b.yAxis && b.yAxis.reversed && (P *= -1), !(0 >= P && e || 0 <= P && !e || 5 > f || k(j)) && f < c && (c = f, y = j);
              }
            });
          }), y ? y.highlight() : !1);
        }
        function o(e) {
          var a = this.highlightedPoint,
            c = this.series && this.series[this.series.length - 1],
            y = c && c.points && c.points[c.points.length - 1];
          return this.highlightedPoint ? (c = this.series[a.series.index + (e ? -1 : 1)], !c || (y = n(a, c, 4), !y) ? !1 : A(c) ? (y.highlight(), e = this.highlightAdjacentSeries(e), e || (a.highlight(), !1)) : (y.highlight(), y.series.highlightNextValidPoint())) : (c = e ? this.series && this.series[0] : c, (y = e ? c && c.points && c.points[0] : y) ? y.highlight() : !1);
        }
        function n(e, a, c, y) {
          var b = 1 / 0,
            j = a.points.length,
            P = function P(N) {
              return !(u(N.plotX) && u(N.plotY));
            };
          if (!P(e)) {
            for (; j--;) {
              var f = a.points[j];
              if (!P(f) && (f = (e.plotX - f.plotX) * (e.plotX - f.plotX) * (c || 1) + (e.plotY - f.plotY) * (e.plotY - f.plotY) * (y || 1), f < b)) {
                b = f;
                var x = j;
              }
            }
            return u(x) ? a.points[x] : void 0;
          }
        }
        function r(e) {
          e === void 0 && (e = !0);
          var a = this.series.chart;
          return !this.isNull && e ? this.onMouseOver() : a.tooltip && a.tooltip.hide(0), L(this), this.graphic && (a.setFocusToElement(this.graphic), !e && a.focusElement && a.focusElement.removeFocusBorder()), a.highlightedPoint = this, this;
        }
        function i() {
          var e = this.chart.highlightedPoint,
            a = (e && e.series) === this ? w(e) : 0;
          e = this.points;
          var c = e.length;
          if (e && c) {
            for (var y = a; y < c; ++y) if (!k(e[y])) return e[y].highlight();
            for (; 0 <= a; --a) if (!k(e[a])) return e[a].highlight();
          }
          return !1;
        }
        var t = [];
        C.compose = function (e, a, c) {
          t.indexOf(e) === -1 && (t.push(e), e = e.prototype, e.highlightAdjacentPoint = m, e.highlightAdjacentPointVertical = d, e.highlightAdjacentSeries = o), t.indexOf(a) === -1 && (t.push(a), a.prototype.highlight = r), t.indexOf(c) === -1 && (t.push(c), a = c.prototype, a.keyboardMoveVertical = !0, ["column", "gantt", "pie"].forEach(function (y) {
            s[y] && (s[y].prototype.keyboardMoveVertical = !1);
          }), a.highlightNextValidPoint = i);
        };
      }(E || (E = {})), E;
    }), V(O, "Accessibility/Components/SeriesComponent/SeriesComponent.js", [O["Accessibility/AccessibilityComponent.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Components/SeriesComponent/ForcedMarkers.js"], O["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], O["Accessibility/Components/SeriesComponent/SeriesDescriber.js"], O["Accessibility/Components/SeriesComponent/SeriesKeyboardNavigation.js"], O["Core/Tooltip.js"]], function (S, D, E, B, H, X, W) {
      var z = this && this.__extends || function () {
          var _k9 = function k(g, p) {
            return _k9 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k9(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k9(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        w = D.hideSeriesFromAT,
        A = H.describeSeries;
      return function (k) {
        function g() {
          return k !== null && k.apply(this, arguments) || this;
        }
        return z(g, k), g.compose = function (p, h, s) {
          B.compose(s), E.compose(s), X.compose(p, h, s);
        }, g.prototype.init = function () {
          this.newDataAnnouncer = new B(this.chart), this.newDataAnnouncer.init(), this.keyboardNavigation = new X(this.chart, this.keyCodes), this.keyboardNavigation.init(), this.hideTooltipFromATWhenShown(), this.hideSeriesLabelsFromATWhenShown();
        }, g.prototype.hideTooltipFromATWhenShown = function () {
          var p = this;
          this.addEvent(W, "refresh", function () {
            this.chart === p.chart && this.label && this.label.element && this.label.element.setAttribute("aria-hidden", !0);
          });
        }, g.prototype.hideSeriesLabelsFromATWhenShown = function () {
          this.addEvent(this.chart, "afterDrawSeriesLabels", function () {
            this.series.forEach(function (p) {
              p.labelBySeries && p.labelBySeries.attr("aria-hidden", !0);
            });
          });
        }, g.prototype.onChartRender = function () {
          this.chart.series.forEach(function (p) {
            (p.options.accessibility && p.options.accessibility.enabled) !== !1 && p.visible ? A(p) : w(p);
          });
        }, g.prototype.getKeyboardNavigation = function () {
          return this.keyboardNavigation.getKeyboardNavigationHandler();
        }, g.prototype.destroy = function () {
          this.newDataAnnouncer.destroy(), this.keyboardNavigation.destroy();
        }, g;
      }(S);
    }), V(O, "Accessibility/Components/ZoomComponent.js", [O["Accessibility/AccessibilityComponent.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Accessibility/KeyboardNavigationHandler.js"], O["Core/Utilities.js"]], function (S, D, E, B, H) {
      var X = this && this.__extends || function () {
          var _k10 = function k(g, p) {
            return _k10 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (h, s) {
              h.__proto__ = s;
            } || function (h, s) {
              for (var l in s) s.hasOwnProperty(l) && (h[l] = s[l]);
            }, _k10(g, p);
          };
          return function (g, p) {
            function h() {
              this.constructor = g;
            }
            _k10(g, p), g.prototype = p === null ? Object.create(p) : (h.prototype = p.prototype, new h());
          };
        }(),
        W = D.unhideChartElementFromAT,
        z = E.getFakeMouseEvent,
        w = H.attr,
        A = H.pick;
      return function (k) {
        function g() {
          var p = k !== null && k.apply(this, arguments) || this;
          return p.focusedMapNavButtonIx = -1, p;
        }
        return X(g, k), g.prototype.init = function () {
          var p = this,
            h = this.chart;
          this.proxyProvider.addGroup("zoom", "div"), ["afterShowResetZoom", "afterApplyDrilldown", "drillupall"].forEach(function (s) {
            p.addEvent(h, s, function () {
              p.updateProxyOverlays();
            });
          });
        }, g.prototype.onChartUpdate = function () {
          var p = this.chart,
            h = this;
          p.mapNavigation && p.mapNavigation.navButtons.forEach(function (s, l) {
            W(p, s.element), h.setMapNavButtonAttrs(s.element, "accessibility.zoom.mapZoom" + (l ? "Out" : "In"));
          });
        }, g.prototype.setMapNavButtonAttrs = function (p, h) {
          var s = this.chart;
          h = s.langFormat(h, {
            chart: s
          }), w(p, {
            tabindex: -1,
            role: "button",
            "aria-label": h
          });
        }, g.prototype.onChartRender = function () {
          this.updateProxyOverlays();
        }, g.prototype.updateProxyOverlays = function () {
          var p = this.chart;
          this.proxyProvider.clearGroup("zoom"), p.resetZoomButton && this.createZoomProxyButton(p.resetZoomButton, "resetZoomProxyButton", p.langFormat("accessibility.zoom.resetZoomButton", {
            chart: p
          })), p.drillUpButton && p.breadcrumbs && p.breadcrumbs.list && this.createZoomProxyButton(p.drillUpButton, "drillUpProxyButton", p.langFormat("accessibility.drillUpButton", {
            chart: p,
            buttonText: p.breadcrumbs.getButtonText(p.breadcrumbs.list[p.breadcrumbs.list.length - 1])
          }));
        }, g.prototype.createZoomProxyButton = function (p, h, s) {
          this[h] = this.proxyProvider.addProxyElement("zoom", {
            click: p
          }, {
            "aria-label": s,
            tabindex: -1
          });
        }, g.prototype.getMapZoomNavigation = function () {
          var p = this.keyCodes,
            h = this.chart,
            s = this;
          return new B(h, {
            keyCodeMap: [[[p.up, p.down, p.left, p.right], function (l) {
              return s.onMapKbdArrow(this, l);
            }], [[p.tab], function (l, u) {
              return s.onMapKbdTab(this, u);
            }], [[p.space, p.enter], function () {
              return s.onMapKbdClick(this);
            }]],
            validate: function validate() {
              return !!(h.mapView && h.mapNavigation && h.mapNavigation.navButtons.length);
            },
            init: function init(l) {
              return s.onMapNavInit(l);
            }
          });
        }, g.prototype.onMapKbdArrow = function (p, h) {
          var s = this.chart,
            l = this.keyCodes,
            u = s.container,
            v = h === l.up || h === l.down;
          return h = (v ? s.plotHeight : s.plotWidth) / 10 * (h === l.left || h === l.up ? 1 : -1), l = 10 * Math.random(), s = {
            x: u.offsetLeft + s.plotLeft + s.plotWidth / 2 + l,
            y: u.offsetTop + s.plotTop + s.plotHeight / 2 + l
          }, v = v ? {
            x: s.x,
            y: s.y + h
          } : {
            x: s.x + h,
            y: s.y
          }, [z("mousedown", s), z("mousemove", v), z("mouseup", v)].forEach(function (M) {
            return u.dispatchEvent(M);
          }), p.response.success;
        }, g.prototype.onMapKbdTab = function (p, h) {
          var s = this.chart;
          p = p.response;
          var l = (h = h.shiftKey) && !this.focusedMapNavButtonIx || !h && this.focusedMapNavButtonIx;
          return s.mapNavigation.navButtons[this.focusedMapNavButtonIx].setState(0), l ? (s.mapView && s.mapView.zoomBy(), p[h ? "prev" : "next"]) : (this.focusedMapNavButtonIx += h ? -1 : 1, h = s.mapNavigation.navButtons[this.focusedMapNavButtonIx], s.setFocusToElement(h.box, h.element), h.setState(2), p.success);
        }, g.prototype.onMapKbdClick = function (p) {
          return this.fakeClickEvent(this.chart.mapNavigation.navButtons[this.focusedMapNavButtonIx].element), p.response.success;
        }, g.prototype.onMapNavInit = function (p) {
          var h = this.chart,
            s = h.mapNavigation.navButtons[0],
            l = h.mapNavigation.navButtons[1];
          s = 0 < p ? s : l, h.setFocusToElement(s.box, s.element), s.setState(2), this.focusedMapNavButtonIx = 0 < p ? 0 : 1;
        }, g.prototype.simpleButtonNavigation = function (p, h, s) {
          var l = this.keyCodes,
            u = this,
            v = this.chart;
          return new B(v, {
            keyCodeMap: [[[l.tab, l.up, l.down, l.left, l.right], function (M, I) {
              return this.response[M === l.tab && I.shiftKey || M === l.left || M === l.up ? "prev" : "next"];
            }], [[l.space, l.enter], function () {
              var M = s(this, v);
              return A(M, this.response.success);
            }]],
            validate: function validate() {
              return v[p] && v[p].box && u[h].buttonElement;
            },
            init: function init() {
              v.setFocusToElement(v[p].box, u[h].buttonElement);
            }
          });
        }, g.prototype.getKeyboardNavigation = function () {
          return [this.simpleButtonNavigation("resetZoomButton", "resetZoomProxyButton", function (p, h) {
            h.zoomOut();
          }), this.simpleButtonNavigation("drillUpButton", "drillUpProxyButton", function (p, h) {
            return h.drillUp(), p.response.prev;
          }), this.getMapZoomNavigation()];
        }, g;
      }(S);
    }), V(O, "Accessibility/HighContrastMode.js", [O["Core/Globals.js"]], function (S) {
      var D = S.doc,
        E = S.isMS,
        B = S.win;
      return {
        isHighContrastModeActive: function isHighContrastModeActive() {
          var H = /(Edg)/.test(B.navigator.userAgent);
          if (B.matchMedia && H) return B.matchMedia("(-ms-high-contrast: active)").matches;
          if (E && B.getComputedStyle) {
            H = D.createElement("div"), H.style.backgroundImage = "url(".concat("data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", ")"), D.body.appendChild(H);
            var X = (H.currentStyle || B.getComputedStyle(H)).backgroundImage;
            return D.body.removeChild(H), X === "none";
          }
          return B.matchMedia && B.matchMedia("(forced-colors: active)").matches;
        },
        setHighContrastTheme: function setHighContrastTheme(H) {
          H.highContrastModeActive = !0;
          var X = H.options.accessibility.highContrastTheme;
          H.update(X, !1), H.series.forEach(function (W) {
            var z = X.plotOptions[W.type] || {};
            W.update({
              color: z.color || "windowText",
              colors: [z.color || "windowText"],
              borderColor: z.borderColor || "window"
            }), W.points.forEach(function (w) {
              w.options && w.options.color && w.update({
                color: z.color || "windowText",
                borderColor: z.borderColor || "window"
              }, !1);
            });
          }), H.redraw();
        }
      };
    }), V(O, "Accessibility/HighContrastTheme.js", [], function () {
      return {
        chart: {
          backgroundColor: "window"
        },
        title: {
          style: {
            color: "windowText"
          }
        },
        subtitle: {
          style: {
            color: "windowText"
          }
        },
        colorAxis: {
          minColor: "windowText",
          maxColor: "windowText",
          stops: []
        },
        colors: ["windowText"],
        xAxis: {
          gridLineColor: "windowText",
          labels: {
            style: {
              color: "windowText"
            }
          },
          lineColor: "windowText",
          minorGridLineColor: "windowText",
          tickColor: "windowText",
          title: {
            style: {
              color: "windowText"
            }
          }
        },
        yAxis: {
          gridLineColor: "windowText",
          labels: {
            style: {
              color: "windowText"
            }
          },
          lineColor: "windowText",
          minorGridLineColor: "windowText",
          tickColor: "windowText",
          title: {
            style: {
              color: "windowText"
            }
          }
        },
        tooltip: {
          backgroundColor: "window",
          borderColor: "windowText",
          style: {
            color: "windowText"
          }
        },
        plotOptions: {
          series: {
            lineColor: "windowText",
            fillColor: "window",
            borderColor: "windowText",
            edgeColor: "windowText",
            borderWidth: 1,
            dataLabels: {
              connectorColor: "windowText",
              color: "windowText",
              style: {
                color: "windowText",
                textOutline: "none"
              }
            },
            marker: {
              lineColor: "windowText",
              fillColor: "windowText"
            }
          },
          pie: {
            color: "window",
            colors: ["window"],
            borderColor: "windowText",
            borderWidth: 1
          },
          boxplot: {
            fillColor: "window"
          },
          candlestick: {
            lineColor: "windowText",
            fillColor: "window"
          },
          errorbar: {
            fillColor: "window"
          }
        },
        legend: {
          backgroundColor: "window",
          itemStyle: {
            color: "windowText"
          },
          itemHoverStyle: {
            color: "windowText"
          },
          itemHiddenStyle: {
            color: "#555"
          },
          title: {
            style: {
              color: "windowText"
            }
          }
        },
        credits: {
          style: {
            color: "windowText"
          }
        },
        labels: {
          style: {
            color: "windowText"
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: "windowText"
          },
          activeDataLabelStyle: {
            color: "windowText"
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: "windowText",
            theme: {
              fill: "window"
            }
          }
        },
        rangeSelector: {
          buttonTheme: {
            fill: "window",
            stroke: "windowText",
            style: {
              color: "windowText"
            },
            states: {
              hover: {
                fill: "window",
                stroke: "windowText",
                style: {
                  color: "windowText"
                }
              },
              select: {
                fill: "#444",
                stroke: "windowText",
                style: {
                  color: "windowText"
                }
              }
            }
          },
          inputBoxBorderColor: "windowText",
          inputStyle: {
            backgroundColor: "window",
            color: "windowText"
          },
          labelStyle: {
            color: "windowText"
          }
        },
        navigator: {
          handles: {
            backgroundColor: "window",
            borderColor: "windowText"
          },
          outlineColor: "windowText",
          maskFill: "transparent",
          series: {
            color: "windowText",
            lineColor: "windowText"
          },
          xAxis: {
            gridLineColor: "windowText"
          }
        },
        scrollbar: {
          barBackgroundColor: "#444",
          barBorderColor: "windowText",
          buttonArrowColor: "windowText",
          buttonBackgroundColor: "window",
          buttonBorderColor: "windowText",
          rifleColor: "windowText",
          trackBackgroundColor: "window",
          trackBorderColor: "windowText"
        }
      };
    }), V(O, "Accessibility/Options/A11yDefaults.js", [], function () {
      return {
        accessibility: {
          enabled: !0,
          screenReaderSection: {
            beforeChartFormat: "<{headingTagName}>{chartTitle}</{headingTagName}><div>{typeDescription}</div><div>{chartSubtitle}</div><div>{chartLongdesc}</div><div>{playAsSoundButton}</div><div>{viewTableButton}</div><div>{xAxisDescription}</div><div>{yAxisDescription}</div><div>{annotationsTitle}{annotationsList}</div>",
            afterChartFormat: "{endOfChartMarker}",
            axisRangeDateFormat: "%Y-%m-%d %H:%M:%S"
          },
          series: {
            descriptionFormat: "{seriesDescription}{authorDescription}{axisDescription}",
            describeSingleSeries: !1,
            pointDescriptionEnabledThreshold: 200
          },
          point: {
            valueDescriptionFormat: "{xDescription}{separator}{value}.",
            describeNull: !0
          },
          landmarkVerbosity: "all",
          linkedDescription: '*[data-highcharts-chart="{index}"] + .highcharts-description',
          keyboardNavigation: {
            enabled: !0,
            focusBorder: {
              enabled: !0,
              hideBrowserFocusOutline: !0,
              style: {
                color: "#335cad",
                lineWidth: 2,
                borderRadius: 3
              },
              margin: 2
            },
            order: ["series", "zoom", "rangeSelector", "legend", "chartMenu"],
            wrapAround: !0,
            seriesNavigation: {
              skipNullPoints: !0,
              pointNavigationEnabledThreshold: !1,
              rememberPointFocus: !1
            }
          },
          announceNewData: {
            enabled: !1,
            minAnnounceInterval: 5e3,
            interruptUser: !1
          }
        },
        legend: {
          accessibility: {
            enabled: !0,
            keyboardNavigation: {
              enabled: !0
            }
          }
        },
        exporting: {
          accessibility: {
            enabled: !0
          }
        }
      };
    }), V(O, "Accessibility/Options/LangDefaults.js", [], function () {
      return {
        accessibility: {
          defaultChartTitle: "Chart",
          chartContainerLabel: "{title}. Highcharts interactive chart.",
          svgContainerLabel: "Interactive chart",
          drillUpButton: "{buttonText}",
          credits: "Chart credits: {creditsStr}",
          thousandsSep: ",",
          svgContainerTitle: "",
          graphicContainerLabel: "",
          screenReaderSection: {
            beforeRegionLabel: "",
            afterRegionLabel: "",
            annotations: {
              heading: "Chart annotations summary",
              descriptionSinglePoint: "{annotationText}. Related to {annotationPoint}",
              descriptionMultiplePoints: "{annotationText}. Related to {annotationPoint}{ Also related to, #each(additionalAnnotationPoints)}",
              descriptionNoPoints: "{annotationText}"
            },
            endOfChartMarker: "End of interactive chart."
          },
          sonification: {
            playAsSoundButtonText: "Play as sound, {chartTitle}",
            playAsSoundClickAnnouncement: "Play"
          },
          legend: {
            legendLabelNoTitle: "Toggle series visibility, {chartTitle}",
            legendLabel: "Chart legend: {legendTitle}",
            legendItem: "Show {itemName}"
          },
          zoom: {
            mapZoomIn: "Zoom chart",
            mapZoomOut: "Zoom out chart",
            resetZoomButton: "Reset zoom"
          },
          rangeSelector: {
            dropdownLabel: "{rangeTitle}",
            minInputLabel: "Select start date.",
            maxInputLabel: "Select end date.",
            clickButtonAnnouncement: "Viewing {axisRangeDescription}"
          },
          table: {
            viewAsDataTableButtonText: "View as data table, {chartTitle}",
            tableSummary: "Table representation of chart."
          },
          announceNewData: {
            newDataAnnounce: "Updated data for chart {chartTitle}",
            newSeriesAnnounceSingle: "New data series: {seriesDesc}",
            newPointAnnounceSingle: "New data point: {pointDesc}",
            newSeriesAnnounceMultiple: "New data series in chart {chartTitle}: {seriesDesc}",
            newPointAnnounceMultiple: "New data point in chart {chartTitle}: {pointDesc}"
          },
          seriesTypeDescriptions: {
            boxplot: "Box plot charts are typically used to display groups of statistical data. Each data point in the chart can have up to 5 values: minimum, lower quartile, median, upper quartile, and maximum.",
            arearange: "Arearange charts are line charts displaying a range between a lower and higher value for each point.",
            areasplinerange: "These charts are line charts displaying a range between a lower and higher value for each point.",
            bubble: "Bubble charts are scatter charts where each data point also has a size value.",
            columnrange: "Columnrange charts are column charts displaying a range between a lower and higher value for each point.",
            errorbar: "Errorbar series are used to display the variability of the data.",
            funnel: "Funnel charts are used to display reduction of data in stages.",
            pyramid: "Pyramid charts consist of a single pyramid with item heights corresponding to each point value.",
            waterfall: "A waterfall chart is a column chart where each column contributes towards a total end value."
          },
          chartTypes: {
            emptyChart: "Empty chart",
            mapTypeDescription: "Map of {mapTitle} with {numSeries} data series.",
            unknownMap: "Map of unspecified region with {numSeries} data series.",
            combinationChart: "Combination chart with {numSeries} data series.",
            defaultSingle: "Chart with {numPoints} data {#plural(numPoints, points, point)}.",
            defaultMultiple: "Chart with {numSeries} data series.",
            splineSingle: "Line chart with {numPoints} data {#plural(numPoints, points, point)}.",
            splineMultiple: "Line chart with {numSeries} lines.",
            lineSingle: "Line chart with {numPoints} data {#plural(numPoints, points, point)}.",
            lineMultiple: "Line chart with {numSeries} lines.",
            columnSingle: "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.",
            columnMultiple: "Bar chart with {numSeries} data series.",
            barSingle: "Bar chart with {numPoints} {#plural(numPoints, bars, bar)}.",
            barMultiple: "Bar chart with {numSeries} data series.",
            pieSingle: "Pie chart with {numPoints} {#plural(numPoints, slices, slice)}.",
            pieMultiple: "Pie chart with {numSeries} pies.",
            scatterSingle: "Scatter chart with {numPoints} {#plural(numPoints, points, point)}.",
            scatterMultiple: "Scatter chart with {numSeries} data series.",
            boxplotSingle: "Boxplot with {numPoints} {#plural(numPoints, boxes, box)}.",
            boxplotMultiple: "Boxplot with {numSeries} data series.",
            bubbleSingle: "Bubble chart with {numPoints} {#plural(numPoints, bubbles, bubble)}.",
            bubbleMultiple: "Bubble chart with {numSeries} data series."
          },
          axis: {
            xAxisDescriptionSingular: "The chart has 1 X axis displaying {names[0]}. {ranges[0]}",
            xAxisDescriptionPlural: "The chart has {numAxes} X axes displaying {#each(names, -1) }and {names[-1]}.",
            yAxisDescriptionSingular: "The chart has 1 Y axis displaying {names[0]}. {ranges[0]}",
            yAxisDescriptionPlural: "The chart has {numAxes} Y axes displaying {#each(names, -1) }and {names[-1]}.",
            timeRangeDays: "Data range: {range} days.",
            timeRangeHours: "Data range: {range} hours.",
            timeRangeMinutes: "Data range: {range} minutes.",
            timeRangeSeconds: "Data range: {range} seconds.",
            rangeFromTo: "Data ranges from {rangeFrom} to {rangeTo}.",
            rangeCategories: "Data range: {numCategories} categories."
          },
          exporting: {
            chartMenuLabel: "Chart menu",
            menuButtonLabel: "View chart menu, {chartTitle}"
          },
          series: {
            summary: {
              default: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
              defaultCombination: "{series.name}, series {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
              line: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
              lineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.",
              spline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
              splineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.",
              column: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bars, bar)}.",
              columnCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#plural(series.points.length, bars, bar)}.",
              bar: "{series.name}, bar series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bars, bar)}.",
              barCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bar series with {series.points.length} {#plural(series.points.length, bars, bar)}.",
              pie: "{series.name}, pie {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, slices, slice)}.",
              pieCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Pie with {series.points.length} {#plural(series.points.length, slices, slice)}.",
              scatter: "{series.name}, scatter plot {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, points, point)}.",
              scatterCombination: "{series.name}, series {seriesNumber} of {chart.series.length}, scatter plot with {series.points.length} {#plural(series.points.length, points, point)}.",
              boxplot: "{series.name}, boxplot {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, boxes, box)}.",
              boxplotCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Boxplot with {series.points.length} {#plural(series.points.length, boxes, box)}.",
              bubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.",
              bubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.",
              map: "{series.name}, map {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, areas, area)}.",
              mapCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Map with {series.points.length} {#plural(series.points.length, areas, area)}.",
              mapline: "{series.name}, line {seriesNumber} of {chart.series.length} with {series.points.length} data {#plural(series.points.length, points, point)}.",
              maplineCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Line with {series.points.length} data {#plural(series.points.length, points, point)}.",
              mapbubble: "{series.name}, bubble series {seriesNumber} of {chart.series.length} with {series.points.length} {#plural(series.points.length, bubbles, bubble)}.",
              mapbubbleCombination: "{series.name}, series {seriesNumber} of {chart.series.length}. Bubble series with {series.points.length} {#plural(series.points.length, bubbles, bubble)}."
            },
            description: "{description}",
            xAxisDescription: "X axis, {name}",
            yAxisDescription: "Y axis, {name}",
            nullPointValue: "No value",
            pointAnnotationsDescription: "{Annotation: #each(annotations). }"
          }
        }
      };
    }), V(O, "Accessibility/Options/DeprecatedOptions.js", [O["Core/Utilities.js"]], function (S) {
      function D(w, A, k) {
        for (var g, p = 0; p < A.length - 1; ++p) g = A[p], w = w[g] = z(w[g], {});
        w[A[A.length - 1]] = k;
      }
      function E(w, A, k, g) {
        function p(l, u) {
          return u.reduce(function (v, M) {
            return v[M];
          }, l);
        }
        var h = p(w.options, A),
          s = p(w.options, k);
        Object.keys(g).forEach(function (l) {
          var u,
            v = h[l];
          typeof v < "u" && (D(s, g[l], v), W(32, !1, w, (u = {}, u[A.join(".") + "." + l] = k.join(".") + "." + g[l].join("."), u)));
        });
      }
      function B(w) {
        var A = w.options.chart,
          k = w.options.accessibility || {};
        ["description", "typeDescription"].forEach(function (g) {
          var p;
          A[g] && (k[g] = A[g], W(32, !1, w, (p = {}, p["chart.".concat(g)] = "use accessibility.".concat(g), p)));
        });
      }
      function H(w) {
        w.axes.forEach(function (A) {
          (A = A.options) && A.description && (A.accessibility = A.accessibility || {}, A.accessibility.description = A.description, W(32, !1, w, {
            "axis.description": "use axis.accessibility.description"
          }));
        });
      }
      function X(w) {
        var A = {
          description: ["accessibility", "description"],
          exposeElementToA11y: ["accessibility", "exposeAsGroupOnly"],
          pointDescriptionFormatter: ["accessibility", "point", "descriptionFormatter"],
          skipKeyboardNavigation: ["accessibility", "keyboardNavigation", "enabled"],
          "accessibility.pointDescriptionFormatter": ["accessibility", "point", "descriptionFormatter"]
        };
        w.series.forEach(function (k) {
          Object.keys(A).forEach(function (g) {
            var p,
              h = k.options[g];
            g === "accessibility.pointDescriptionFormatter" && (h = k.options.accessibility && k.options.accessibility.pointDescriptionFormatter), typeof h < "u" && (D(k.options, A[g], g === "skipKeyboardNavigation" ? !h : h), W(32, !1, w, (p = {}, p["series.".concat(g)] = "series." + A[g].join("."), p)));
          });
        });
      }
      var W = S.error,
        z = S.pick;
      return function (w) {
        B(w), H(w), w.series && X(w), E(w, ["accessibility"], ["accessibility"], {
          pointDateFormat: ["point", "dateFormat"],
          pointDateFormatter: ["point", "dateFormatter"],
          pointDescriptionFormatter: ["point", "descriptionFormatter"],
          pointDescriptionThreshold: ["series", "pointDescriptionEnabledThreshold"],
          pointNavigationThreshold: ["keyboardNavigation", "seriesNavigation", "pointNavigationEnabledThreshold"],
          pointValueDecimals: ["point", "valueDecimals"],
          pointValuePrefix: ["point", "valuePrefix"],
          pointValueSuffix: ["point", "valueSuffix"],
          screenReaderSectionFormatter: ["screenReaderSection", "beforeChartFormatter"],
          describeSingleSeries: ["series", "describeSingleSeries"],
          seriesDescriptionFormatter: ["series", "descriptionFormatter"],
          onTableAnchorClick: ["screenReaderSection", "onViewDataTableClick"],
          axisRangeDateFormat: ["screenReaderSection", "axisRangeDateFormat"]
        }), E(w, ["accessibility", "keyboardNavigation"], ["accessibility", "keyboardNavigation", "seriesNavigation"], {
          skipNullPoints: ["skipNullPoints"],
          mode: ["mode"]
        }), E(w, ["lang", "accessibility"], ["lang", "accessibility"], {
          legendItem: ["legend", "legendItem"],
          legendLabel: ["legend", "legendLabel"],
          mapZoomIn: ["zoom", "mapZoomIn"],
          mapZoomOut: ["zoom", "mapZoomOut"],
          resetZoomButton: ["zoom", "resetZoomButton"],
          screenReaderRegionLabel: ["screenReaderSection", "beforeRegionLabel"],
          rangeSelectorButton: ["rangeSelector", "buttonText"],
          rangeSelectorMaxInput: ["rangeSelector", "maxInputLabel"],
          rangeSelectorMinInput: ["rangeSelector", "minInputLabel"],
          svgContainerEnd: ["screenReaderSection", "endOfChartMarker"],
          viewAsDataTable: ["table", "viewAsDataTableButtonText"],
          tableSummary: ["table", "tableSummary"]
        });
      };
    }), V(O, "Accessibility/Accessibility.js", [O["Core/Defaults.js"], O["Core/Globals.js"], O["Core/Utilities.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Accessibility/A11yI18n.js"], O["Accessibility/Components/ContainerComponent.js"], O["Accessibility/FocusBorder.js"], O["Accessibility/Components/InfoRegionsComponent.js"], O["Accessibility/KeyboardNavigation.js"], O["Accessibility/Components/LegendComponent.js"], O["Accessibility/Components/MenuComponent.js"], O["Accessibility/Components/SeriesComponent/NewDataAnnouncer.js"], O["Accessibility/ProxyProvider.js"], O["Accessibility/Components/RangeSelectorComponent.js"], O["Accessibility/Components/SeriesComponent/SeriesComponent.js"], O["Accessibility/Components/ZoomComponent.js"], O["Accessibility/HighContrastMode.js"], O["Accessibility/HighContrastTheme.js"], O["Accessibility/Options/A11yDefaults.js"], O["Accessibility/Options/LangDefaults.js"], O["Accessibility/Options/DeprecatedOptions.js"]], function (S, D, E, B, H, X, W, z, w, A, k, g, p, h, s, l, u, v, M, I, L) {
      S = S.defaultOptions;
      var C = D.doc,
        m = E.addEvent,
        d = E.extend,
        o = E.fireEvent,
        n = E.merge,
        r = B.removeElement;
      return D = function () {
        function i(t) {
          this.proxyProvider = this.keyboardNavigation = this.components = this.chart = void 0, this.init(t);
        }
        return i.prototype.init = function (t) {
          this.chart = t, C.addEventListener && t.renderer.isSVG ? (L(t), this.proxyProvider = new p(this.chart), this.initComponents(), this.keyboardNavigation = new w(t, this.components)) : (this.zombie = !0, this.components = {}, t.renderTo.setAttribute("aria-hidden", !0));
        }, i.prototype.initComponents = function () {
          var t = this.chart,
            e = this.proxyProvider,
            a = t.options.accessibility;
          this.components = {
            container: new X(),
            infoRegions: new z(),
            legend: new A(),
            chartMenu: new k(),
            rangeSelector: new h(),
            series: new s(),
            zoom: new l()
          }, a.customComponents && d(this.components, a.customComponents);
          var c = this.components;
          this.getComponentOrder().forEach(function (y) {
            c[y].initBase(t, e), c[y].init();
          });
        }, i.prototype.getComponentOrder = function () {
          if (!this.components) return [];
          if (!this.components.series) return Object.keys(this.components);
          var t = Object.keys(this.components).filter(function (e) {
            return e !== "series";
          });
          return ["series"].concat(t);
        }, i.prototype.update = function () {
          var t = this.components,
            e = this.chart,
            a = e.options.accessibility;
          o(e, "beforeA11yUpdate"), e.types = this.getChartTypes(), a = a.keyboardNavigation.order, this.proxyProvider.updateGroupOrder(a), this.getComponentOrder().forEach(function (c) {
            t[c].onChartUpdate(), o(e, "afterA11yComponentUpdate", {
              name: c,
              component: t[c]
            });
          }), this.keyboardNavigation.update(a), !e.highContrastModeActive && u.isHighContrastModeActive() && u.setHighContrastTheme(e), o(e, "afterA11yUpdate", {
            accessibility: this
          });
        }, i.prototype.destroy = function () {
          var t = this.chart || {},
            e = this.components;
          Object.keys(e).forEach(function (a) {
            e[a].destroy(), e[a].destroyBase();
          }), this.proxyProvider && this.proxyProvider.destroy(), t.announcerContainer && r(t.announcerContainer), this.keyboardNavigation && this.keyboardNavigation.destroy(), t.renderTo && t.renderTo.setAttribute("aria-hidden", !0), t.focusElement && t.focusElement.removeFocusBorder();
        }, i.prototype.getChartTypes = function () {
          var t = {};
          return this.chart.series.forEach(function (e) {
            t[e.type] = 1;
          }), Object.keys(t);
        }, i;
      }(), function (i) {
        function t() {
          this.accessibility && this.accessibility.destroy();
        }
        function e() {
          this.a11yDirty && this.renderTo && (delete this.a11yDirty, this.updateA11yEnabled());
          var j = this.accessibility;
          j && !j.zombie && (j.proxyProvider.updateProxyElementPositions(), j.getComponentOrder().forEach(function (P) {
            j.components[P].onChartRender();
          }));
        }
        function a(j) {
          (j = j.options.accessibility) && (j.customComponents && (this.options.accessibility.customComponents = j.customComponents, delete j.customComponents), n(!0, this.options.accessibility, j), this.accessibility && this.accessibility.destroy && (this.accessibility.destroy(), delete this.accessibility)), this.a11yDirty = !0;
        }
        function c() {
          var j = this.accessibility,
            P = this.options.accessibility;
          P && P.enabled ? j && !j.zombie ? j.update() : (this.accessibility = j = new i(this), !j.zombie && j.update()) : j ? (j.destroy && j.destroy(), delete this.accessibility) : this.renderTo.setAttribute("aria-hidden", !0);
        }
        function y() {
          this.series.chart.accessibility && (this.series.chart.a11yDirty = !0);
        }
        var b = [];
        i.i18nFormat = H.i18nFormat, i.compose = function (j, P, f, x, N, R) {
          w.compose(j), g.compose(x), A.compose(j, P), k.compose(j), s.compose(j, f, x), H.compose(j), W.compose(j, N), R && h.compose(j, R), b.indexOf(j) === -1 && (b.push(j), j.prototype.updateA11yEnabled = c, m(j, "destroy", t), m(j, "render", e), m(j, "update", a), ["addSeries", "init"].forEach(function (F) {
            m(j, F, function () {
              this.a11yDirty = !0;
            });
          }), ["afterApplyDrilldown", "drillupall"].forEach(function (F) {
            m(j, F, function () {
              var T = this.accessibility;
              T && !T.zombie && T.update();
            });
          })), b.indexOf(f) === -1 && (b.push(f), m(f, "update", y)), b.indexOf(x) === -1 && (b.push(x), ["update", "updatedData", "remove"].forEach(function (F) {
            m(x, F, function () {
              this.chart.accessibility && (this.chart.a11yDirty = !0);
            });
          }));
        };
      }(D || (D = {})), n(!0, S, M, {
        accessibility: {
          highContrastTheme: v
        },
        lang: I
      }), D;
    }), V(O, "masters/modules/accessibility.src.js", [O["Core/Globals.js"], O["Accessibility/Accessibility.js"], O["Accessibility/AccessibilityComponent.js"], O["Accessibility/Utils/ChartUtilities.js"], O["Accessibility/Utils/HTMLUtilities.js"], O["Accessibility/KeyboardNavigationHandler.js"], O["Accessibility/Components/SeriesComponent/SeriesDescriber.js"]], function (S, D, E, B, H, X, W) {
      S.i18nFormat = D.i18nFormat, S.A11yChartUtilities = B, S.A11yHTMLUtilities = H, S.AccessibilityComponent = E, S.KeyboardNavigationHandler = X, S.SeriesAccessibilityDescriber = W, D.compose(S.Chart, S.Legend, S.Point, S.Series, S.SVGElement, S.RangeSelector);
    });
  });
})(fi);
var ro = fi.exports;
var no = /* @__PURE__ */Xt(ro);
var gi = {
  exports: {}
};
(function (K) {
  (function (O) {
    K.exports ? (O.default = O, K.exports = O) : O(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function (O) {
    function V(S, D, E, B) {
      S.hasOwnProperty(D) || (S[D] = B.apply(null, E), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
        detail: {
          path: D,
          module: S[D]
        }
      })));
    }
    O = O ? O._modules : {}, V(O, "Core/HttpUtilities.js", [O["Core/Globals.js"], O["Core/Utilities.js"]], function (S, D) {
      var E = S.doc,
        B = D.createElement,
        H = D.discardElement,
        X = D.merge,
        W = D.objectEach,
        z = {
          ajax: function ajax(w) {
            var A = {
                json: "application/json",
                xml: "application/xml",
                text: "text/plain",
                octet: "application/octet-stream"
              },
              k = new XMLHttpRequest();
            if (!w.url) return !1;
            k.open((w.type || "get").toUpperCase(), w.url, !0), w.headers && w.headers["Content-Type"] || k.setRequestHeader("Content-Type", A[w.dataType || "json"] || A.text), W(w.headers, function (g, p) {
              k.setRequestHeader(p, g);
            }), w.responseType && (k.responseType = w.responseType), k.onreadystatechange = function () {
              if (k.readyState === 4) {
                if (k.status === 200) {
                  if (w.responseType !== "blob") {
                    var g = k.responseText;
                    if (w.dataType === "json") try {
                      g = JSON.parse(g);
                    } catch (p) {
                      if (p instanceof Error) {
                        w.error && w.error(k, p);
                        return;
                      }
                    }
                  }
                  return w.success && w.success(g, k);
                }
                w.error && w.error(k, k.responseText);
              }
            }, w.data && typeof w.data != "string" && (w.data = JSON.stringify(w.data)), k.send(w.data);
          },
          getJSON: function getJSON(w, A) {
            z.ajax({
              url: w,
              success: A,
              dataType: "json",
              headers: {
                "Content-Type": "text/plain"
              }
            });
          },
          post: function post(w, A, k) {
            var g = B("form", X({
              method: "post",
              action: w,
              enctype: "multipart/form-data"
            }, k), {
              display: "none"
            }, E.body);
            W(A, function (p, h) {
              B("input", {
                type: "hidden",
                name: h,
                value: p
              }, void 0, g);
            }), g.submit(), H(g);
          }
        };
      return z;
    }), V(O, "Extensions/Data.js", [O["Core/Chart/Chart.js"], O["Core/Defaults.js"], O["Core/Globals.js"], O["Core/HttpUtilities.js"], O["Core/Series/Point.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B, H, X, W) {
      function z(m) {
        return !(!m || !(m.rowsURL || m.csvURL || m.columnsURL));
      }
      var w = D.getOptions,
        A = E.doc,
        k = B.ajax,
        g = X.seriesTypes;
      D = W.addEvent;
      var p = W.defined,
        h = W.extend,
        s = W.fireEvent,
        l = W.isNumber,
        u = W.merge,
        v = W.objectEach,
        M = W.pick,
        I = W.splat,
        L = function () {
          function m(d, o, n) {
            o === void 0 && (o = {}), this.rowsToColumns = m.rowsToColumns, this.dateFormats = {
              "YYYY/mm/dd": {
                regex: /^([0-9]{4})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{1,2})$/,
                parser: function parser(r) {
                  return r ? Date.UTC(+r[1], r[2] - 1, +r[3]) : NaN;
                }
              },
              "dd/mm/YYYY": {
                regex: /^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{4})$/,
                parser: function parser(r) {
                  return r ? Date.UTC(+r[3], r[2] - 1, +r[1]) : NaN;
                },
                alternative: "mm/dd/YYYY"
              },
              "mm/dd/YYYY": {
                regex: /^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{4})$/,
                parser: function parser(r) {
                  return r ? Date.UTC(+r[3], r[1] - 1, +r[2]) : NaN;
                }
              },
              "dd/mm/YY": {
                regex: /^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{2})$/,
                parser: function parser(r) {
                  if (!r) return NaN;
                  var i = +r[3];
                  return i = i > /* @__PURE__ */new Date().getFullYear() - 2e3 ? i + 1900 : i + 2e3, Date.UTC(i, r[2] - 1, +r[1]);
                },
                alternative: "mm/dd/YY"
              },
              "mm/dd/YY": {
                regex: /^([0-9]{1,2})[\-\/\.]([0-9]{1,2})[\-\/\.]([0-9]{2})$/,
                parser: function parser(r) {
                  return r ? Date.UTC(+r[3] + 2e3, r[1] - 1, +r[2]) : NaN;
                }
              }
            }, this.chart = n, this.chartOptions = o, this.options = d, this.rawColumns = [], this.init(d, o, n);
          }
          return m.data = function (d, o, n) {
            return o === void 0 && (o = {}), new m(d, o, n);
          }, m.rowsToColumns = function (d) {
            var o, n;
            if (d) {
              var r = [],
                i = d.length;
              for (o = 0; o < i; o++) {
                var t = d[o].length;
                for (n = 0; n < t; n++) r[n] || (r[n] = []), r[n][o] = d[o][n];
              }
            }
            return r;
          }, m.prototype.init = function (d, o, n) {
            var r = d.decimalPoint;
            if (o && (this.chartOptions = o), n && (this.chart = n), r !== "." && r !== "," && (r = void 0), this.options = d, this.columns = d.columns || this.rowsToColumns(d.rows) || [], this.firstRowAsNames = M(d.firstRowAsNames, this.firstRowAsNames, !0), this.decimalRegex = r && new RegExp("^(-?[0-9]+)" + r + "([0-9]+)$"), this.liveDataTimeout !== void 0 && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length) {
              this.dataFound();
              var i = !z(d);
            }
            i || (i = this.fetchLiveData()), i || (i = !!this.parseCSV().length), i || (i = !!this.parseTable().length), i || (i = this.parseGoogleSpreadsheet()), !i && d.afterComplete && d.afterComplete();
          }, m.prototype.getColumnDistribution = function () {
            var d = this.chartOptions,
              o = this.options,
              n = [],
              r = function r(y) {
                return (g[y || "line"].prototype.pointArrayMap || [0]).length;
              },
              i = d && d.chart && d.chart.type,
              t = [],
              e = [];
            o = o && o.seriesMapping || d && d.series && d.series.map(function () {
              return {
                x: 0
              };
            }) || [];
            var a = 0,
              c;
            (d && d.series || []).forEach(function (y) {
              t.push(r(y.type || i));
            }), o.forEach(function (y) {
              n.push(y.x || 0);
            }), n.length === 0 && n.push(0), o.forEach(function (y) {
              var b = new C(),
                j = t[a] || r(i),
                P = (d && d.series || [])[a] || {},
                f = g[P.type || i || "line"].prototype.pointArrayMap,
                x = f || ["y"];
              for ((p(y.x) || P.isCartesian || !f) && b.addColumnReader(y.x, "x"), v(y, function (N, R) {
                R !== "x" && b.addColumnReader(N, R);
              }), c = 0; c < j; c++) b.hasReader(x[c]) || b.addColumnReader(void 0, x[c]);
              e.push(b), a++;
            }), o = g[i || "line"].prototype.pointArrayMap, typeof o > "u" && (o = ["y"]), this.valueCount = {
              global: r(i),
              xColumns: n,
              individual: t,
              seriesBuilders: e,
              globalPointArrayMap: o
            };
          }, m.prototype.dataFound = function () {
            this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), this.parsed() !== !1 && this.complete();
          }, m.prototype.parseCSV = function (d) {
            function o(R, F, T, G) {
              function _(tt) {
                Z = R[tt], J = R[tt - 1], et = R[tt + 1];
              }
              function q(tt) {
                y.length < ct + 1 && y.push([tt]), y[ct][y[ct].length - 1] !== tt && y[ct].push(tt);
              }
              function Y() {
                a > lt || lt > c ? (++lt, nt = "") : (!isNaN(parseFloat(nt)) && isFinite(nt) ? (nt = parseFloat(nt), q("number")) : isNaN(Date.parse(nt)) ? q("string") : (nt = nt.replace(/\//g, "-"), q("date")), t.length < ct + 1 && t.push([]), T || (t[ct][F] = nt), nt = "", ++ct, ++lt);
              }
              var U = 0,
                Z = "",
                J = "",
                et = "",
                nt = "",
                lt = 0,
                ct = 0;
              if (R.trim().length && R.trim()[0] !== "#") {
                for (; U < R.length; U++) if (_(U), Z === '"') for (_(++U); U < R.length && (Z !== '"' || J === '"' || et === '"');) (Z !== '"' || Z === '"' && J !== '"') && (nt += Z), _(++U);else G && G[Z] ? G[Z](Z, nt) && Y() : Z === x ? Y() : nt += Z;
                Y();
              }
            }
            function n(R) {
              var F = 0,
                T = 0,
                G = !1;
              return R.some(function (_, q) {
                var Y = !1,
                  U = "";
                if (13 < q) return !0;
                for (var Z = 0; Z < _.length; Z++) {
                  q = _[Z];
                  var J = _[Z + 1],
                    et = _[Z - 1];
                  if (q === "#") break;
                  if (q === '"') {
                    if (Y) {
                      if (et !== '"' && J !== '"') {
                        for (; J === " " && Z < _.length;) J = _[++Z];
                        typeof b[J] < "u" && b[J]++, Y = !1;
                      }
                    } else Y = !0;
                  } else typeof b[q] < "u" ? (U = U.trim(), isNaN(Date.parse(U)) && !isNaN(U) && isFinite(U) || b[q]++, U = "") : U += q;
                  q === "," && T++, q === "." && F++;
                }
              }), G = b[";"] > b[","] ? ";" : ",", e.decimalPoint || (e.decimalPoint = F > T ? "." : ",", i.decimalRegex = new RegExp("^(-?[0-9]+)" + e.decimalPoint + "([0-9]+)$")), G;
            }
            function r(R, F) {
              var T = [],
                G = [],
                _ = [],
                q = 0,
                Y = !1,
                U;
              for ((!F || F > R.length) && (F = R.length); q < F; q++) if (typeof R[q] < "u" && R[q] && R[q].length) {
                var Z = R[q].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" ");
                for (_ = ["", "", ""], U = 0; U < Z.length; U++) U < _.length && (Z[U] = parseInt(Z[U], 10), Z[U] && (G[U] = !G[U] || G[U] < Z[U] ? Z[U] : G[U], typeof T[U] < "u" ? T[U] !== Z[U] && (T[U] = !1) : T[U] = Z[U], 31 < Z[U] ? _[U] = 100 > Z[U] ? "YY" : "YYYY" : 12 < Z[U] && 31 >= Z[U] ? (_[U] = "dd", Y = !0) : _[U].length || (_[U] = "mm")));
              }
              if (Y) {
                for (U = 0; U < T.length; U++) T[U] !== !1 ? 12 < G[U] && _[U] !== "YY" && _[U] !== "YYYY" && (_[U] = "YY") : 12 < G[U] && _[U] === "mm" && (_[U] = "dd");
                return _.length === 3 && _[1] === "dd" && _[2] === "dd" && (_[2] = "YY"), R = _.join("/"), (e.dateFormats || i.dateFormats)[R] ? R : (s("deduceDateFailed"), "YYYY/mm/dd");
              }
              return "YYYY/mm/dd";
            }
            var i = this,
              t = this.columns = [],
              e = d || this.options,
              a = typeof e.startColumn < "u" && e.startColumn ? e.startColumn : 0,
              c = e.endColumn || Number.MAX_VALUE,
              y = [],
              b = {
                ",": 0,
                ";": 0,
                "	": 0
              },
              j = e.csv;
            d = typeof e.startRow < "u" && e.startRow ? e.startRow : 0;
            var P = e.endRow || Number.MAX_VALUE,
              f = 0;
            if (j && e.beforeParse && (j = e.beforeParse.call(this, j)), j) {
              if (j = j.replace(/\r\n/g, "\n").replace(/\r/g, "\n").split(e.lineDelimiter || "\n"), (!d || 0 > d) && (d = 0), (!P || P >= j.length) && (P = j.length - 1), e.itemDelimiter) var x = e.itemDelimiter;else x = null, x = n(j);
              var N = 0;
              for (f = d; f <= P; f++) j[f][0] === "#" ? N++ : o(j[f], f - d - N);
              e.columnTypes && e.columnTypes.length !== 0 || !y.length || !y[0].length || y[0][1] !== "date" || e.dateFormat || (e.dateFormat = r(t[0])), this.dataFound();
            }
            return t;
          }, m.prototype.parseTable = function () {
            var d = this.options,
              o = this.columns || [],
              n = d.startRow || 0,
              r = d.endRow || Number.MAX_VALUE,
              i = d.startColumn || 0,
              t = d.endColumn || Number.MAX_VALUE;
            return d.table && (d = d.table, typeof d == "string" && (d = A.getElementById(d)), [].forEach.call(d.getElementsByTagName("tr"), function (e, a) {
              a >= n && a <= r && [].forEach.call(e.children, function (c, y) {
                var b = o[y - i],
                  j = 1;
                if ((c.tagName === "TD" || c.tagName === "TH") && y >= i && y <= t) for (o[y - i] || (o[y - i] = []), o[y - i][a - n] = c.innerHTML; a - n >= j && b[a - n - j] === void 0;) b[a - n - j] = null, j++;
              });
            }), this.dataFound()), o;
          }, m.prototype.fetchLiveData = function () {
            function d(c) {
              function y(b, j, P) {
                function f() {
                  i && n.liveDataURL === b && (o.liveDataTimeout = setTimeout(d, a));
                }
                return !b || !/^(http|\/|\.\/|\.\.\/)/.test(b) ? (b && r.error && r.error("Invalid URL"), !1) : (c && (clearTimeout(o.liveDataTimeout), n.liveDataURL = b), k({
                  url: b,
                  dataType: P || "json",
                  success: function success(x) {
                    n && n.series && j(x), f();
                  },
                  error: function error(x, N) {
                    return 3 > ++e && f(), r.error && r.error(N, x);
                  }
                }), !0);
              }
              y(t.csvURL, function (b) {
                n.update({
                  data: {
                    csv: b
                  }
                });
              }, "text") || y(t.rowsURL, function (b) {
                n.update({
                  data: {
                    rows: b
                  }
                });
              }) || y(t.columnsURL, function (b) {
                n.update({
                  data: {
                    columns: b
                  }
                });
              });
            }
            var o = this,
              n = this.chart,
              r = this.options,
              i = r.enablePolling,
              t = u(r),
              e = 0,
              a = 1e3 * (r.dataRefreshRate || 2);
            return z(r) ? (1e3 > a && (a = 1e3), delete r.csvURL, delete r.rowsURL, delete r.columnsURL, d(!0), z(r)) : !1;
          }, m.prototype.parseGoogleSpreadsheet = function () {
            function d(a) {
              var c = ["https://sheets.googleapis.com/v4/spreadsheets", r, "values", e(), "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + n.googleAPIKey].join("/");
              k({
                url: c,
                dataType: "json",
                success: function success(y) {
                  a(y), n.enablePolling && (o.liveDataTimeout = setTimeout(function () {
                    d(a);
                  }, t));
                },
                error: function error(y, b) {
                  return n.error && n.error(b, y);
                }
              });
            }
            var o = this,
              n = this.options,
              r = n.googleSpreadsheetKey,
              i = this.chart,
              t = Math.max(1e3 * (n.dataRefreshRate || 2), 4e3),
              e = function e() {
                if (n.googleSpreadsheetRange) return n.googleSpreadsheetRange;
                var a = ("ABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(n.startColumn || 0) || "A") + ((n.startRow || 0) + 1),
                  c = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(M(n.endColumn, -1)) || "ZZ";
                return p(n.endRow) && (c += n.endRow + 1), "" + a + ":".concat(c);
              };
            return r && (delete n.googleSpreadsheetKey, d(function (a) {
              if (a = a.values, !a || a.length === 0) return !1;
              var c = a.reduce(function (y, b) {
                return Math.max(y, b.length);
              }, 0);
              a.forEach(function (y) {
                for (var b = 0; b < c; b++) typeof y[b] > "u" && (y[b] = null);
              }), i && i.series ? i.update({
                data: {
                  columns: a
                }
              }) : (o.columns = a, o.dataFound());
            })), !1;
          }, m.prototype.trim = function (d, o) {
            return typeof d == "string" && (d = d.replace(/^\s+|\s+$/g, ""), o && /^[0-9\s]+$/.test(d) && (d = d.replace(/\s/g, "")), this.decimalRegex && (d = d.replace(this.decimalRegex, "$1.$2"))), d;
          }, m.prototype.parseTypes = function () {
            for (var d = this.columns || [], o = d.length; o--;) this.parseColumn(d[o], o);
          }, m.prototype.parseColumn = function (d, o) {
            var n = this.rawColumns,
              r = this.columns,
              i = this.firstRowAsNames,
              t = this.valueCount.xColumns.indexOf(o) !== -1,
              e = [],
              a = this.chartOptions,
              c = (this.options.columnTypes || [])[o];
            a = t && (a && a.xAxis && I(a.xAxis)[0].type === "category" || c === "string");
            var y = p(d.name),
              b = d.length,
              j,
              P;
            for (n[o] || (n[o] = []); b--;) {
              var f = e[b] || d[b],
                x = this.trim(f),
                N = this.trim(f, !0),
                R = parseFloat(N);
              typeof n[o][b] > "u" && (n[o][b] = x), a || b === 0 && i && !y ? d[b] = "" + x : +N === R ? (d[b] = R, 31536e6 < R && c !== "float" ? d.isDatetime = !0 : d.isNumeric = !0, typeof d[b + 1] < "u" && (P = R > d[b + 1])) : (x && x.length && (j = this.parseDate(f)), t && l(j) && c !== "float" ? (e[b] = f, d[b] = j, d.isDatetime = !0, typeof d[b + 1] < "u" && (f = j > d[b + 1], f !== P && typeof P < "u" && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, b = d.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : d.unsorted = !0), P = f)) : (d[b] = x === "" ? null : x, b !== 0 && (d.isDatetime || d.isNumeric) && (d.mixed = !0)));
            }
            if (t && d.mixed && (r[o] = n[o]), t && P && this.options.sort) for (o = 0; o < r.length; o++) r[o].reverse(), i && r[o].unshift(r[o].pop());
          }, m.prototype.parseDate = function (d) {
            var o = this.options.parseDate,
              n,
              r = this.options.dateFormat || this.dateFormat,
              i;
            if (o) var t = o(d);else if (typeof d == "string") {
              if (r) (o = this.dateFormats[r]) || (o = this.dateFormats["YYYY/mm/dd"]), (i = d.match(o.regex)) && (t = o.parser(i));else for (n in this.dateFormats) if (o = this.dateFormats[n], i = d.match(o.regex)) {
                this.dateFormat = n, this.alternativeFormat = o.alternative, t = o.parser(i);
                break;
              }
              i || (d.match(/:.+(GMT|UTC|[Z+-])/) && (d = d.replace(/\s*(?:GMT|UTC)?([+-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), i = Date.parse(d), typeof i == "object" && i !== null && i.getTime ? t = i.getTime() - 6e4 * i.getTimezoneOffset() : l(i) && (t = i - 6e4 * new Date(i).getTimezoneOffset()));
            }
            return t;
          }, m.prototype.getData = function () {
            if (this.columns) return this.rowsToColumns(this.columns).slice(1);
          }, m.prototype.parsed = function () {
            if (this.options.parsed) return this.options.parsed.call(this, this.columns);
          }, m.prototype.complete = function () {
            var d = this.columns,
              o = this.options,
              n = [],
              r,
              i,
              t;
            if (o.complete || o.afterComplete) {
              if (this.firstRowAsNames) for (i = 0; i < d.length; i++) {
                var e = d[i];
                p(e.name) || (e.name = M(e.shift(), "").toString());
              }
              e = [];
              var a = d.length,
                c = this.valueCount.seriesBuilders;
              i = [];
              var y = [];
              for (t = 0; t < a; t += 1) i.push(!0);
              for (a = 0; a < c.length; a += 1) {
                var b = c[a].getReferencedColumnIndexes();
                for (t = 0; t < b.length; t += 1) i[b[t]] = !1;
              }
              for (t = 0; t < i.length; t += 1) i[t] && y.push(t);
              for (i = 0; i < this.valueCount.seriesBuilders.length; i++) c = this.valueCount.seriesBuilders[i], c.populateColumns(y) && n.push(c);
              for (; 0 < y.length;) {
                for (c = new C(), c.addColumnReader(0, "x"), i = y.indexOf(0), i !== -1 && y.splice(i, 1), i = 0; i < this.valueCount.global; i++) c.addColumnReader(void 0, this.valueCount.globalPointArrayMap[i]);
                c.populateColumns(y) && n.push(c);
              }
              if (0 < n.length && 0 < n[0].readers.length && (y = d[n[0].readers[0].columnIndex], typeof y < "u" && (y.isDatetime ? r = "datetime" : y.isNumeric || (r = "category"))), r === "category") for (i = 0; i < n.length; i++) for (c = n[i], y = 0; y < c.readers.length; y++) c.readers[y].configName === "x" && (c.readers[y].configName = "name");
              for (i = 0; i < n.length; i++) {
                for (c = n[i], y = [], t = 0; t < d[0].length; t++) y[t] = c.read(d, t);
                e[i] = {
                  data: y
                }, c.name && (e[i].name = c.name), r === "category" && (e[i].turboThreshold = 0);
              }
              d = {
                series: e
              }, r && (d.xAxis = {
                type: r
              }, r === "category" && (d.xAxis.uniqueNames = !1)), o.complete && o.complete(d), o.afterComplete && o.afterComplete(d);
            }
          }, m.prototype.update = function (d, o) {
            var n = this.chart,
              r = n.options;
            d && (d.afterComplete = function (i) {
              i && (i.xAxis && n.xAxis[0] && i.xAxis.type === n.xAxis[0].options.type && delete i.xAxis, n.update(i, o, !0));
            }, u(!0, r.data, d), r.data && r.data.googleSpreadsheetKey && !d.columns && delete r.data.columns, this.init(r.data));
          }, m;
        }();
      D(S, "init", function (m) {
        var d = this,
          o = m.args[1],
          n = w().data,
          r = m.args[0] || {};
        (n || r && r.data) && !d.hasDataDef && (d.hasDataDef = !0, n = u(n, r.data), d.data = new L(h(n, {
          afterComplete: function afterComplete(i) {
            var t;
            if (Object.hasOwnProperty.call(r, "series")) if (typeof r.series == "object") for (t = Math.max(r.series.length, i && i.series ? i.series.length : 0); t--;) {
              var e = r.series[t] || {};
              r.series[t] = u(e, i && i.series ? i.series[t] : {});
            } else delete r.series;
            r = u(i, r), d.init(r, o);
          }
        }), r, d), m.preventDefault());
      });
      var C = function () {
        function m() {
          this.readers = [], this.pointIsArray = !0;
        }
        return m.prototype.populateColumns = function (d) {
          var o = !0;
          return this.readers.forEach(function (n) {
            typeof n.columnIndex > "u" && (n.columnIndex = d.shift());
          }), this.readers.forEach(function (n) {
            typeof n.columnIndex > "u" && (o = !1);
          }), o;
        }, m.prototype.read = function (d, o) {
          var n = this.pointIsArray,
            r = n ? [] : {};
          if (this.readers.forEach(function (t) {
            var e = d[t.columnIndex][o];
            n ? r.push(e) : 0 < t.configName.indexOf(".") ? H.prototype.setNestedProperty(r, e, t.configName) : r[t.configName] = e;
          }), typeof this.name > "u" && 2 <= this.readers.length) {
            var i = this.getReferencedColumnIndexes();
            2 <= i.length && (i.shift(), i.sort(function (t, e) {
              return t - e;
            }), this.name = d[i.shift()].name);
          }
          return r;
        }, m.prototype.addColumnReader = function (d, o) {
          this.readers.push({
            columnIndex: d,
            configName: o
          }), o !== "x" && o !== "y" && typeof o < "u" && (this.pointIsArray = !1);
        }, m.prototype.getReferencedColumnIndexes = function () {
          var d = [],
            o;
          for (o = 0; o < this.readers.length; o += 1) {
            var n = this.readers[o];
            typeof n.columnIndex < "u" && d.push(n.columnIndex);
          }
          return d;
        }, m.prototype.hasReader = function (d) {
          var o;
          for (o = 0; o < this.readers.length; o += 1) {
            var n = this.readers[o];
            if (n.configName === d) return !0;
          }
        }, m;
      }();
      return L;
    }), V(O, "masters/modules/data.src.js", [O["Core/Globals.js"], O["Core/HttpUtilities.js"], O["Extensions/Data.js"]], function (S, D, E) {
      S.ajax = D.ajax, S.data = E.data, S.getJSON = D.getJSON, S.post = D.post, S.Data = E, S.HttpUtilities = D;
    });
  });
})(gi);
var so = gi.exports;
var ao = /* @__PURE__ */Xt(so);
var mi = {
  exports: {}
};
(function (K) {
  (function (O) {
    K.exports ? (O.default = O, K.exports = O) : O(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function (O) {
    function V(S, D, E, B) {
      S.hasOwnProperty(D) || (S[D] = B.apply(null, E), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
        detail: {
          path: D,
          module: S[D]
        }
      })));
    }
    O = O ? O._modules : {}, V(O, "Extensions/Breadcrumbs.js", [O["Core/Chart/Chart.js"], O["Core/Defaults.js"], O["Core/Globals.js"], O["Core/Utilities.js"], O["Core/FormatUtilities.js"]], function (S, D, E, B, H) {
      var X = H.format;
      H = B.addEvent;
      var W = B.objectEach,
        z = B.extend,
        w = B.fireEvent,
        A = B.merge,
        k = B.pick,
        g = B.defined,
        p = B.isString;
      return z(D.defaultOptions.lang, {
        mainBreadcrumb: "Main"
      }), D = function () {
        function h(s, l) {
          this.group = void 0, this.list = [], this.elementList = {}, this.isDirty = !0, this.level = 0, this.options = void 0, l = A(s.options.drilldown && s.options.drilldown.drillUpButton, h.defaultBreadcrumbsOptions, s.options.navigation && s.options.navigation.breadcrumbs, l), this.chart = s, this.options = l || {};
        }
        return h.prototype.updateProperties = function (s) {
          this.setList(s), this.setLevel(), this.isDirty = !0;
        }, h.prototype.setList = function (s) {
          this.list = s;
        }, h.prototype.setLevel = function () {
          this.level = this.list.length && this.list.length - 1;
        }, h.prototype.getLevel = function () {
          return this.level;
        }, h.prototype.getButtonText = function (s) {
          var l = this.chart,
            u = this.options,
            v = l.options.lang,
            M = k(u.format, u.showFullPath ? "{level.name}" : "← {level.name}");
          return v = v && k(v.drillUpText, v.mainBreadcrumb), s = u.formatter && u.formatter(s) || X(M, {
            level: s.levelOptions
          }, l) || "", (p(s) && !s.length || s === "← ") && g(v) && (s = u.showFullPath ? v : "← " + v), s;
        }, h.prototype.redraw = function () {
          this.isDirty && this.render(), this.group && this.group.align(), this.isDirty = !1;
        }, h.prototype.render = function () {
          var s = this.chart,
            l = this.options;
          !this.group && l && (this.group = s.renderer.g("breadcrumbs-group").addClass("highcharts-no-tooltip highcharts-breadcrumbs").attr({
            zIndex: l.zIndex
          }).add()), l.showFullPath ? this.renderFullPathButtons() : this.renderSingleButton(), this.alignBreadcrumbsGroup();
        }, h.prototype.renderFullPathButtons = function () {
          this.destroySingleButton(), this.resetElementListState(), this.updateListElements(), this.destroyListElements();
        }, h.prototype.renderSingleButton = function () {
          var s = this.chart,
            l = this.list,
            u = this.options.buttonSpacing;
          this.destroyListElements();
          var v = this.group ? this.group.getBBox().width : u;
          l = l[l.length - 2], !s.drillUpButton && 0 < this.level ? s.drillUpButton = this.renderButton(l, v, u) : s.drillUpButton && (0 < this.level ? this.updateSingleButton() : this.destroySingleButton());
        }, h.prototype.alignBreadcrumbsGroup = function (s) {
          if (this.group) {
            var l = this.options,
              u = l.buttonTheme,
              v = l.position,
              M = l.relativeTo === "chart" || l.relativeTo === "spacingBox" ? void 0 : "scrollablePlotBox",
              I = this.group.getBBox();
            l = 2 * (u.padding || 0) + l.buttonSpacing, v.width = I.width + l, v.height = I.height + l, I = A(v), s && (I.x += s), this.options.rtl && (I.x += v.width), I.y = k(I.y, this.yOffset, 0), this.group.align(I, !0, M);
          }
        }, h.prototype.renderButton = function (s, l, u) {
          var v = this,
            M = this.chart,
            I = v.options,
            L = A(I.buttonTheme);
          return l = M.renderer.button(v.getButtonText(s), l, u, function (C) {
            var m = I.events && I.events.click,
              d;
            m && (d = m.call(v, C, s)), d !== !1 && (C.newLevel = I.showFullPath ? s.level : v.level - 1, w(v, "up", C));
          }, L).addClass("highcharts-breadcrumbs-button").add(v.group), M.styledMode || l.attr(I.style), l;
        }, h.prototype.renderSeparator = function (s, l) {
          var u = this.chart,
            v = this.options.separator;
          return s = u.renderer.label(v.text, s, l, void 0, void 0, void 0, !1).addClass("highcharts-breadcrumbs-separator").add(this.group), u.styledMode || s.css(v.style), s;
        }, h.prototype.update = function (s) {
          A(!0, this.options, s), this.destroy(), this.isDirty = !0;
        }, h.prototype.updateSingleButton = function () {
          var s = this.chart,
            l = this.list[this.level - 1];
          s.drillUpButton && s.drillUpButton.attr({
            text: this.getButtonText(l)
          });
        }, h.prototype.destroy = function () {
          this.destroySingleButton(), this.destroyListElements(!0), this.group && this.group.destroy(), this.group = void 0;
        }, h.prototype.destroyListElements = function (s) {
          var l = this.elementList;
          W(l, function (u, v) {
            (s || !l[v].updated) && (u = l[v], u.button && u.button.destroy(), u.separator && u.separator.destroy(), delete u.button, delete u.separator, delete l[v]);
          }), s && (this.elementList = {});
        }, h.prototype.destroySingleButton = function () {
          this.chart.drillUpButton && (this.chart.drillUpButton.destroy(), this.chart.drillUpButton = void 0);
        }, h.prototype.resetElementListState = function () {
          W(this.elementList, function (s) {
            s.updated = !1;
          });
        }, h.prototype.updateListElements = function () {
          var s = this,
            l = s.elementList,
            u = s.options.buttonSpacing,
            v = s.list,
            M = s.options.rtl,
            I = M ? -1 : 1,
            L = function L(d, o) {
              return I * d.getBBox().width + I * o;
            },
            C = s.group ? L(s.group, u) : u,
            m;
          v.forEach(function (d, o) {
            if (o = o === v.length - 1, l[d.level]) {
              m = l[d.level];
              var n = m.button;
              if (m.separator || o) m.separator && o && (m.separator.destroy(), delete m.separator);else {
                if (C += I * u, m.separator = s.renderSeparator(C, u), M) {
                  var r = m.separator;
                  r.translate(C - r.getBBox().width, u);
                }
                C += L(m.separator, u);
              }
              l[d.level].updated = !0;
            } else n = s.renderButton(d, C, u), M && n.translate(C - n.getBBox().width, u), C += L(n, u), o || (r = s.renderSeparator(C, u), M && r.translate(C - r.getBBox().width, u), C += L(r, u)), l[d.level] = {
              button: n,
              separator: r,
              updated: !0
            };
            n && n.setState(o ? 2 : 0);
          });
        }, h.defaultBreadcrumbsOptions = {
          buttonTheme: {
            fill: "none",
            height: 18,
            padding: 2,
            "stroke-width": 0,
            zIndex: 7,
            states: {
              select: {
                fill: "none"
              }
            },
            style: {
              color: "#335cad"
            }
          },
          buttonSpacing: 5,
          floating: !1,
          format: void 0,
          relativeTo: "plotBox",
          rtl: !1,
          position: {
            align: "left",
            verticalAlign: "top",
            x: 0,
            y: void 0
          },
          separator: {
            text: "/",
            style: {
              color: "#666666"
            }
          },
          showFullPath: !0,
          style: {},
          useHTML: !1,
          zIndex: 7
        }, h;
      }(), E.Breadcrumbs || (E.Breadcrumbs = D, H(S, "getMargins", function () {
        var h = this.breadcrumbs;
        if (h && !h.options.floating && h.level) {
          var s = h.options,
            l = s.buttonTheme;
          l = (l.height || 0) + 2 * (l.padding || 0) + s.buttonSpacing, s = s.position.verticalAlign, s === "bottom" ? (this.marginBottom = (this.marginBottom || 0) + l, h.yOffset = l) : s !== "middle" ? (this.plotTop += l, h.yOffset = -l) : h.yOffset = void 0;
        }
      }), H(S, "redraw", function () {
        this.breadcrumbs && this.breadcrumbs.redraw();
      }), H(S, "destroy", function () {
        this.breadcrumbs && (this.breadcrumbs.destroy(), this.breadcrumbs = void 0);
      }), H(S, "afterShowResetZoom", function () {
        if (this.breadcrumbs) {
          var h = this.resetZoomButton && this.resetZoomButton.getBBox(),
            s = this.breadcrumbs.options;
          h && s.position.align === "right" && s.relativeTo === "plotBox" && this.breadcrumbs.alignBreadcrumbsGroup(-h.width - s.buttonSpacing);
        }
      }), H(S, "selection", function (h) {
        h.resetSelection === !0 && this.breadcrumbs && this.breadcrumbs.alignBreadcrumbsGroup();
      })), D;
    }), V(O, "Extensions/Drilldown.js", [O["Core/Animation/AnimationUtilities.js"], O["Core/Axis/Axis.js"], O["Core/Chart/Chart.js"], O["Core/Color/Color.js"], O["Series/Column/ColumnSeries.js"], O["Core/Globals.js"], O["Core/Defaults.js"], O["Core/Series/Point.js"], O["Core/Series/Series.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Renderer/SVG/SVGRenderer.js"], O["Core/Axis/Tick.js"], O["Core/Utilities.js"], O["Extensions/Breadcrumbs.js"]], function (S, D, E, B, H, X, W, z, w, A, k, g, p, h) {
      function s(e) {
        var a = l(this.chart.options.drilldown.animation);
        e && (e.hide(), o(function () {
          e && e.added && e.fadeIn();
        }, Math.max(a.duration - 50, 0)));
      }
      var l = S.animObject,
        u = X.noop;
      S = W.defaultOptions;
      var v = p.addEvent,
        M = p.removeEvent,
        I = p.extend,
        L = p.fireEvent,
        C = p.merge,
        m = p.objectEach,
        d = p.pick,
        o = p.syncTimeout;
      A = A.seriesTypes.pie;
      var n = 1;
      I(S.lang, {}), S.drilldown = {
        activeAxisLabelStyle: {
          cursor: "pointer",
          color: "#003399",
          fontWeight: "bold",
          textDecoration: "underline"
        },
        activeDataLabelStyle: {
          cursor: "pointer",
          color: "#003399",
          fontWeight: "bold",
          textDecoration: "underline"
        },
        animation: {
          duration: 500
        },
        drillUpButton: {
          position: {
            align: "right",
            x: -10,
            y: 10
          }
        }
      }, k.prototype.Element.prototype.fadeIn = function (e) {
        this.attr({
          opacity: 0.1,
          visibility: "inherit"
        }).animate({
          opacity: d(this.newOpacity, 1)
        }, e || {
          duration: 250
        });
      }, E.prototype.addSeriesAsDrilldown = function (e, a) {
        this.addSingleSeriesAsDrilldown(e, a), this.applyDrilldown();
      }, E.prototype.addSingleSeriesAsDrilldown = function (e, a) {
        var c = e.series,
          y = c.xAxis,
          b = c.yAxis,
          j = [],
          P = [],
          f,
          x = this.styledMode ? {
            colorIndex: d(e.colorIndex, c.colorIndex)
          } : {
            color: e.color || c.color
          };
        this.drilldownLevels || (this.drilldownLevels = []);
        var N = c.options._levelNumber || 0;
        (f = this.drilldownLevels[this.drilldownLevels.length - 1]) && f.levelNumber !== N && (f = void 0), a = I(I({
          _ddSeriesId: n++
        }, x), a);
        var R = c.points.indexOf(e);
        c.chart.series.forEach(function (F) {
          F.xAxis !== y || F.isDrilling || (F.options._ddSeriesId = F.options._ddSeriesId || n++, F.options._colorIndex = F.userOptions._colorIndex, F.options._levelNumber = F.options._levelNumber || N, f ? (j = f.levelSeries, P = f.levelSeriesOptions) : (j.push(F), F.purgedOptions = C({
            _ddSeriesId: F.options._ddSeriesId,
            _levelNumber: F.options._levelNumber,
            selected: F.options.selected
          }, F.userOptions), P.push(F.purgedOptions)));
        }), e = I({
          levelNumber: N,
          seriesOptions: c.options,
          seriesPurgedOptions: c.purgedOptions,
          levelSeriesOptions: P,
          levelSeries: j,
          shapeArgs: e.shapeArgs,
          bBox: e.graphic ? e.graphic.getBBox() : {},
          color: e.isNull ? B.parse(x.color).setOpacity(0).get() : x.color,
          lowerSeriesOptions: a,
          pointOptions: c.options.data[R],
          pointIndex: R,
          oldExtremes: {
            xMin: y && y.userMin,
            xMax: y && y.userMax,
            yMin: b && b.userMin,
            yMax: b && b.userMax
          },
          resetZoomButton: f && f.levelNumber === N ? void 0 : this.resetZoomButton
        }, x), this.drilldownLevels.push(e), y && y.names && (y.names.length = 0), a = e.lowerSeries = this.addSeries(a, !1), a.options._levelNumber = N + 1, y && (y.oldPos = y.pos, y.userMin = y.userMax = null, b.userMin = b.userMax = null), c.type === a.type && (a.animate = a.animateDrilldown || u, a.options.animation = !0);
      }, E.prototype.applyDrilldown = function () {
        var e = this.drilldownLevels;
        if (e && 0 < e.length) {
          var a = e[e.length - 1].levelNumber;
          this.drilldownLevels.forEach(function (c) {
            c.levelNumber === a && c.levelSeries.forEach(function (y) {
              y.options && y.options._levelNumber === a && y.remove(!1);
            });
          });
        }
        this.resetZoomButton && (this.resetZoomButton.hide(), delete this.resetZoomButton), this.pointer.reset(), L(this, "afterDrilldown"), this.redraw(), L(this, "afterApplyDrilldown");
      };
      var r = function r(e) {
        var a = [];
        return (e = e.drilldownLevels) && e.length && (a[0] || a.push({
          level: 0,
          levelOptions: e[0].seriesOptions
        }), e.forEach(function (c, y) {
          c.levelNumber + 1 > a[a.length - 1].level && a.push({
            level: c.levelNumber + 1,
            levelOptions: C({
              name: c.lowerSeries.name
            }, c.pointOptions)
          });
        })), a;
      };
      E.prototype.drillUp = function () {
        if (this.drilldownLevels && this.drilldownLevels.length !== 0) {
          L(this, "beforeDrillUp");
          for (var e = this, a = e.drilldownLevels, c = a[a.length - 1].levelNumber, y = a.length, b = e.series, j, P, f, x, N = function N(F) {
              b.forEach(function (G) {
                G.options._ddSeriesId === F._ddSeriesId && (T = G);
              });
              var T = T || e.addSeries(F, !1);
              T.type === f.type && T.animateDrillupTo && (T.animate = T.animateDrillupTo), F === P.seriesPurgedOptions && (x = T);
            }, R = e.drilldownLevels.length; y--;) if (P = a[y], P.levelNumber === c) {
            if (a.pop(), f = P.lowerSeries, !f.chart) {
              for (j = b.length; j--;) if (b[j].options.id === P.lowerSeriesOptions.id && b[j].options._levelNumber === c + 1) {
                f = b[j];
                break;
              }
            }
            f.xData = [], f.xAxis && f.xAxis.names && (R === 0 || y === R) && (f.xAxis.names.length = 0), P.levelSeriesOptions.forEach(N), L(e, "drillup", {
              seriesOptions: P.seriesPurgedOptions || P.seriesOptions
            }), x.type === f.type && (x.drilldownLevel = P, x.options.animation = e.options.drilldown.animation, f.animateDrillupFrom && f.chart && f.animateDrillupFrom(P)), x.options._levelNumber = c, f.remove(!1), x.xAxis && (j = P.oldExtremes, x.xAxis.setExtremes(j.xMin, j.xMax, !1), x.yAxis.setExtremes(j.yMin, j.yMax, !1)), P.resetZoomButton && (e.resetZoomButton = P.resetZoomButton);
          }
          L(e, "afterDrillUp"), this.redraw(), this.ddDupes && (this.ddDupes.length = 0), L(e, "drillupall");
        }
      }, v(E, "afterInit", function () {
        var e = this;
        e.drilldown = {
          chart: e,
          fadeInGroup: s,
          update: function update(a, c) {
            C(!0, e.options.drilldown, a), d(c, !0) && e.redraw();
          }
        };
      }), v(E, "render", function () {
        (this.xAxis || []).forEach(function (e) {
          e.ddPoints = {}, e.series.forEach(function (a) {
            var c,
              y = a.xData || [],
              b = a.points;
            for (c = 0; c < y.length; c++) {
              var j = a.options.data[c];
              typeof j != "number" && (j = a.pointClass.prototype.optionsToObject.call({
                series: a
              }, j), j.drilldown && (e.ddPoints[y[c]] || (e.ddPoints[y[c]] = []), j = c - (a.cropStart || 0), e.ddPoints[y[c]].push(b && 0 <= j && j < b.length ? b[j] : !0)));
            }
          }), m(e.ticks, g.prototype.drillable);
        });
      }), v(X.Breadcrumbs, "up", function (e) {
        var a = this.chart;
        e = this.getLevel() - e.newLevel;
        for (var c = 0; c < e; c++) a.drillUp();
      }), v(E, "afterDrilldown", function () {
        var e = this.options.drilldown;
        e = e && e.breadcrumbs, this.breadcrumbs || (this.breadcrumbs = new h(this, e)), this.breadcrumbs.updateProperties(r(this));
      }), v(E, "afterDrillUp", function () {
        this.breadcrumbs && this.breadcrumbs.updateProperties(r(this));
      }), v(E, "update", function (e) {
        var a = this.breadcrumbs,
          c = e.options.drilldown && e.options.drilldown.breadcrumbs;
        a && c && a.update(e.options.drilldown.breadcrumbs);
      }), H.prototype.animateDrillupTo = function (e) {
        if (!e) {
          var a = this,
            c = a.drilldownLevel;
          this.points.forEach(function (y) {
            var b = y.dataLabel;
            y.graphic && y.graphic.hide(), b && (b.hidden = b.attr("visibility") === "hidden", b.hidden || (b.hide(), y.connector && y.connector.hide()));
          }), o(function () {
            if (a.points) {
              var y = [];
              a.data.forEach(function (b) {
                y.push(b);
              }), a.nodes && (y = y.concat(a.nodes)), y.forEach(function (b, j) {
                j = j === (c && c.pointIndex) ? "show" : "fadeIn";
                var P = j === "show" ? !0 : void 0,
                  f = b.dataLabel;
                b.graphic && b.graphic[j](P), f && !f.hidden && (f.fadeIn(), b.connector && b.connector.fadeIn());
              });
            }
          }, Math.max(this.chart.options.drilldown.animation.duration - 50, 0)), delete this.animate;
        }
      }, H.prototype.animateDrilldown = function (e) {
        var a = this,
          c = this.chart,
          y = c.drilldownLevels,
          b,
          j = l(c.options.drilldown.animation),
          P = this.xAxis,
          f = c.styledMode;
        e || (y.forEach(function (x) {
          a.options._ddSeriesId === x.lowerSeriesOptions._ddSeriesId && (b = x.shapeArgs, f || (b.fill = x.color));
        }), b.x += d(P.oldPos, P.pos) - P.pos, this.points.forEach(function (x) {
          var N = x.shapeArgs;
          f || (N.fill = x.color), x.graphic && x.graphic.attr(b).animate(I(x.shapeArgs, {
            fill: x.color || a.color
          }), j);
        }), c.drilldown && c.drilldown.fadeInGroup(this.dataLabelsGroup), delete this.animate);
      }, H.prototype.animateDrillupFrom = function (e) {
        var a = l(this.chart.options.drilldown.animation),
          c = this.group,
          y = c !== this.chart.columnGroup,
          b = this;
        b.trackerGroups.forEach(function (j) {
          b[j] && b[j].on("mouseover");
        }), y && delete this.group, this.points.forEach(function (j) {
          var P = j.graphic,
            f = e.shapeArgs,
            x = function x() {
              P.destroy(), c && y && (c = c.destroy());
            };
          P && f && (delete j.graphic, b.chart.styledMode || (f.fill = e.color), a.duration ? P.animate(f, C(a, {
            complete: x
          })) : (P.attr(f), x()));
        });
      }, A && I(A.prototype, {
        animateDrillupTo: H.prototype.animateDrillupTo,
        animateDrillupFrom: H.prototype.animateDrillupFrom,
        animateDrilldown: function animateDrilldown(e) {
          var a = this.chart.drilldownLevels[this.chart.drilldownLevels.length - 1],
            c = this.chart.options.drilldown.animation;
          if (this.is("item") && (c.duration = 0), this.center) {
            var y = a.shapeArgs,
              b = y.start,
              j = (y.end - b) / this.points.length,
              P = this.chart.styledMode;
            e || (this.points.forEach(function (f, x) {
              var N = f.shapeArgs;
              P || (y.fill = a.color, N.fill = f.color), f.graphic && f.graphic.attr(C(y, {
                start: b + x * j,
                end: b + (x + 1) * j
              }))[c ? "animate" : "attr"](N, c);
            }), this.chart.drilldown && this.chart.drilldown.fadeInGroup(this.dataLabelsGroup), delete this.animate);
          }
        }
      }), z.prototype.doDrilldown = function () {
        this.runDrilldown();
      }, z.prototype.runDrilldown = function (e, a, c) {
        var y = this.series.chart,
          b = y.options.drilldown,
          j = (b.series || []).length;
        for (y.ddDupes || (y.ddDupes = []); j-- && !P;) if (b.series[j].id === this.drilldown && y.ddDupes.indexOf(this.drilldown) === -1) {
          var P = b.series[j];
          y.ddDupes.push(this.drilldown);
        }
        L(y, "drilldown", {
          point: this,
          seriesOptions: P,
          category: a,
          originalEvent: c,
          points: typeof a < "u" && this.series.xAxis.getDDPoints(a).slice(0)
        }, function (f) {
          var x = f.point.series && f.point.series.chart,
            N = f.seriesOptions;
          x && N && (e ? x.addSingleSeriesAsDrilldown(f.point, N) : x.addSeriesAsDrilldown(f.point, N));
        });
      }, D.prototype.drilldownCategory = function (e, a) {
        this.getDDPoints(e).forEach(function (c) {
          c && c.series && c.series.visible && c.runDrilldown && c.runDrilldown(!0, e, a);
        }), this.chart.applyDrilldown();
      }, D.prototype.getDDPoints = function (e) {
        return this.ddPoints && this.ddPoints[e] || [];
      }, g.prototype.drillable = function () {
        var e = this.pos,
          a = this.label,
          c = this.axis,
          y = c.coll === "xAxis" && c.getDDPoints,
          b = y && c.getDDPoints(e),
          j = c.chart.styledMode;
        y && (a && b && b.length ? (a.drillable = !0, a.basicStyles || j || (a.basicStyles = C(a.styles)), a.addClass("highcharts-drilldown-axis-label"), a.removeOnDrillableClick && M(a.element, "click"), a.removeOnDrillableClick = v(a.element, "click", function (P) {
          P.preventDefault(), c.drilldownCategory(e, P);
        }), j || a.css(c.chart.options.drilldown.activeAxisLabelStyle)) : a && a.drillable && a.removeOnDrillableClick && (j || (a.styles = {}, a.element.removeAttribute("style"), a.css(a.basicStyles)), a.removeOnDrillableClick(), a.removeClass("highcharts-drilldown-axis-label")));
      }, v(z, "afterInit", function () {
        return this.drilldown && !this.unbindDrilldownClick && (this.unbindDrilldownClick = v(this, "click", i)), this;
      }), v(z, "update", function (e) {
        e = e.options || {}, e.drilldown && !this.unbindDrilldownClick ? this.unbindDrilldownClick = v(this, "click", i) : !e.drilldown && e.drilldown !== void 0 && this.unbindDrilldownClick && (this.unbindDrilldownClick = this.unbindDrilldownClick());
      });
      var i = function i(e) {
        var a = this.series;
        a.xAxis && a.chart.options.drilldown.allowPointDrilldown === !1 ? a.xAxis.drilldownCategory(this.x, e) : this.runDrilldown(void 0, void 0, e);
      };
      v(w, "afterDrawDataLabels", function () {
        var e = this.chart.options.drilldown.activeDataLabelStyle,
          a = this.chart.renderer,
          c = this.chart.styledMode;
        this.points.forEach(function (y) {
          var b = y.options.dataLabels,
            j = d(y.dlOptions, b && b.style, {});
          y.drilldown && y.dataLabel && (e.color !== "contrast" || c || (j.color = a.getContrast(y.color || this.color)), b && b.color && (j.color = b.color), y.dataLabel.addClass("highcharts-drilldown-data-label"), c || y.dataLabel.css(e).css(j));
        }, this);
      });
      var t = function t(e, a, c, y) {
        e[c ? "addClass" : "removeClass"]("highcharts-drilldown-point"), y || e.css({
          cursor: a
        });
      };
      v(w, "afterDrawTracker", function () {
        var e = this.chart.styledMode;
        this.points.forEach(function (a) {
          a.drilldown && a.graphic && t(a.graphic, "pointer", !0, e);
        });
      }), v(z, "afterSetState", function () {
        var e = this.series.chart.styledMode;
        this.drilldown && this.series.halo && this.state === "hover" ? t(this.series.halo, "pointer", !0, e) : this.series.halo && t(this.series.halo, "auto", !1, e);
      }), v(E, "drillup", function () {
        this.resetZoomButton && (this.resetZoomButton = this.resetZoomButton.destroy());
      }), v(E, "drillupall", function () {
        this.resetZoomButton && this.showResetZoom();
      });
    }), V(O, "masters/modules/drilldown.src.js", [], function () {});
  });
})(mi);
var ho = mi.exports;
var lo = /* @__PURE__ */Xt(ho);
var yi = {
  exports: {}
};
(function (K) {
  (function (O) {
    K.exports ? (O.default = O, K.exports = O) : O(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function (O) {
    function V(S, D, E, B) {
      S.hasOwnProperty(D) || (S[D] = B.apply(null, E), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
        detail: {
          path: D,
          module: S[D]
        }
      })));
    }
    O = O ? O._modules : {}, V(O, "Extensions/ExportData/ExportDataDefaults.js", [], function () {
      return {
        exporting: {
          csv: {
            annotations: {
              itemDelimiter: "; ",
              join: !1
            },
            columnHeaderFormatter: null,
            dateFormat: "%Y-%m-%d %H:%M:%S",
            decimalPoint: null,
            itemDelimiter: null,
            lineDelimiter: "\n"
          },
          showTable: !1,
          useMultiLevelHeaders: !0,
          useRowspanHeaders: !0
        },
        lang: {
          downloadCSV: "Download CSV",
          downloadXLS: "Download XLS",
          exportData: {
            annotationHeader: "Annotations",
            categoryHeader: "Category",
            categoryDatetimeHeader: "DateTime"
          },
          viewData: "View data table",
          hideData: "Hide data table"
        }
      };
    }), V(O, "Extensions/DownloadURL.js", [O["Core/Globals.js"]], function (S) {
      var D = S.isSafari,
        E = S.win,
        B = E.document,
        H = E.URL || E.webkitURL || E,
        X = S.dataURLtoBlob = function (W) {
          if ((W = W.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/)) && 3 < W.length && E.atob && E.ArrayBuffer && E.Uint8Array && E.Blob && H.createObjectURL) {
            var z = E.atob(W[3]),
              w = new E.ArrayBuffer(z.length);
            w = new E.Uint8Array(w);
            for (var A = 0; A < w.length; ++A) w[A] = z.charCodeAt(A);
            return W = new E.Blob([w], {
              type: W[1]
            }), H.createObjectURL(W);
          }
        };
      return S = S.downloadURL = function (W, z) {
        var w = E.navigator,
          A = B.createElement("a");
        if (typeof W == "string" || W instanceof String || !w.msSaveOrOpenBlob) {
          if (W = "".concat(W), w = /Edge\/\d+/.test(w.userAgent), (D && typeof W == "string" && W.indexOf("data:application/pdf") === 0 || w || 2e6 < W.length) && (W = X(W) || "", !W)) throw Error("Failed to convert to blob");
          if (typeof A.download < "u") A.href = W, A.download = z, B.body.appendChild(A), A.click(), B.body.removeChild(A);else try {
            var k = E.open(W, "chart");
            if (typeof k > "u" || k === null) throw Error("Failed to open window");
          } catch (_unused4) {
            E.location.href = W;
          }
        } else w.msSaveOrOpenBlob(W, z);
      }, {
        dataURLtoBlob: X,
        downloadURL: S
      };
    }), V(O, "Extensions/ExportData/ExportData.js", [O["Core/Renderer/HTML/AST.js"], O["Extensions/ExportData/ExportDataDefaults.js"], O["Core/Globals.js"], O["Core/Defaults.js"], O["Extensions/DownloadURL.js"], O["Core/Series/SeriesRegistry.js"], O["Core/Utilities.js"]], function (S, D, E, B, H, X, W) {
      function z() {
        var R = this.getCSV(!0);
        o(u(R, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(R), this.getFilename() + ".csv");
      }
      function w() {
        var R = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
        o(u(R, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + C.btoa(unescape(encodeURIComponent(R))), this.getFilename() + ".xls");
      }
      function A(R) {
        var F = "",
          T = this.getDataRows(),
          G = this.options.exporting.csv,
          _ = x(G.decimalPoint, G.itemDelimiter !== "," && R ? 1.1.toLocaleString()[1] : "."),
          q = x(G.itemDelimiter, _ === "," ? ";" : ","),
          Y = G.lineDelimiter;
        return T.forEach(function (U, Z) {
          for (var J, et = U.length; et--;) J = U[et], typeof J == "string" && (J = '"' + J + '"'), typeof J == "number" && _ !== "." && (J = J.toString().replace(".", _)), U[et] = J;
          U.length = T.length ? T[0].length : 0, F += U.join(q), Z < T.length - 1 && (F += Y);
        }), F;
      }
      function k(R) {
        var F = this.hasParallelCoordinates,
          T = this.time,
          G = this.options.exporting && this.options.exporting.csv || {},
          _ = this.xAxis,
          q = {},
          Y = [],
          U = [],
          Z = [],
          J = this.options.lang.exportData,
          et = J.categoryHeader,
          nt = J.categoryDatetimeHeader,
          lt = function lt(ht, pt, dt) {
            if (G.columnHeaderFormatter) {
              var gt = G.columnHeaderFormatter(ht, pt, dt);
              if (gt !== !1) return gt;
            }
            return ht ? ht instanceof n ? R ? {
              columnTitle: 1 < dt ? pt : ht.name,
              topLevelColumnTitle: ht.name
            } : ht.name + (1 < dt ? " (" + pt + ")" : "") : ht.options.title && ht.options.title.text || (ht.dateTime ? nt : et) : et;
          },
          ct = function ct(ht, pt, dt) {
            var gt = {},
              ut = {};
            return pt.forEach(function (ft) {
              var vt = (ht.keyToAxis && ht.keyToAxis[ft] || ft) + "Axis";
              vt = f(dt) ? ht.chart[vt][dt] : ht[vt], gt[ft] = vt && vt.categories || [], ut[ft] = vt && vt.dateTime;
            }), {
              categoryMap: gt,
              dateTimeValueAxisMap: ut
            };
          },
          tt = function tt(ht, pt) {
            return ht.data.filter(function (dt) {
              return typeof dt.y < "u" && dt.name;
            }).length && pt && !pt.categories && !ht.keyToAxis ? ht.pointArrayMap && ht.pointArrayMap.filter(function (dt) {
              return dt === "x";
            }).length ? (ht.pointArrayMap.unshift("x"), ht.pointArrayMap) : ["x", "y"] : ht.pointArrayMap || ["y"];
          },
          st = [],
          it,
          $ = 0;
        this.series.forEach(function (ht) {
          var pt = ht.xAxis,
            dt = ht.options.keys || tt(ht, pt),
            gt = dt.length,
            ut = !ht.requireSorting && {},
            ft = _.indexOf(pt),
            vt = ct(ht, dt),
            mt;
          if (ht.options.includeInDataExport !== !1 && !ht.options.isInternal && ht.visible !== !1) {
            for (j(st, function (yt) {
              return yt[0] === ft;
            }) || st.push([ft, $]), mt = 0; mt < gt;) it = lt(ht, dt[mt], dt.length), Z.push(it.columnTitle || it), R && U.push(it.topLevelColumnTitle || it), mt++;
            var xt = {
              chart: ht.chart,
              autoIncrement: ht.autoIncrement,
              options: ht.options,
              pointArrayMap: ht.pointArrayMap,
              index: ht.index
            };
            ht.options.data.forEach(function (yt, wt) {
              var Ct = {
                series: xt
              };
              F && (vt = ct(ht, dt, wt)), ht.pointClass.prototype.applyOptions.apply(Ct, [yt]);
              var bt = Ct.x;
              for (y(q[bt]) && q[bt].seriesIndices.includes(xt.index) && (yt = Object.keys(q).filter(function (Dt) {
                return q[Dt].seriesIndices.includes(xt.index) && bt;
              }).filter(function (Dt) {
                return Dt.indexOf(String(bt)) === 0;
              }), bt = bt.toString() + "," + yt.length), yt = ht.data[wt] && ht.data[wt].name, mt = 0, (!pt || ht.exportKey === "name" || !F && pt && pt.hasNames && yt) && (bt = yt), ut && (ut[bt] && (bt += "|" + wt), ut[bt] = !0), q[bt] || (q[bt] = [], q[bt].xValues = []), q[bt].x = Ct.x, q[bt].name = yt, q[bt].xValues[ft] = Ct.x, y(q[bt].seriesIndices) || (q[bt].seriesIndices = []), q[bt].seriesIndices = I(I([], q[bt].seriesIndices, !0), [xt.index], !1); mt < gt;) wt = dt[mt], yt = Ct[wt], q[bt][$ + mt] = x(vt.categoryMap[wt][yt], vt.dateTimeValueAxisMap[wt] ? T.dateFormat(G.dateFormat, yt) : null, yt), mt++;
            }), $ += mt;
          }
        });
        for (rt in q) Object.hasOwnProperty.call(q, rt) && Y.push(q[rt]);
        for (J = R ? [U, Z] : [Z], $ = st.length; $--;) {
          var Q = st[$][0],
            ot = st[$][1],
            at = _[Q];
          Y.sort(function (ht, pt) {
            return ht.xValues[Q] - pt.xValues[Q];
          });
          var rt = lt(at);
          J[0].splice(ot, 0, rt), R && J[1] && J[1].splice(ot, 0, rt), Y.forEach(function (ht) {
            var pt = ht.name;
            at && !y(pt) && (at.dateTime ? (ht.x instanceof Date && (ht.x = ht.x.getTime()), pt = T.dateFormat(G.dateFormat, ht.x)) : pt = at.categories ? x(at.names[ht.x], at.categories[ht.x], ht.x) : ht.x), ht.splice(ot, 0, pt);
          });
        }
        return J = J.concat(Y), P(this, "exportData", {
          dataRows: J
        }), J;
      }
      function g(R) {
        var F = function F(T) {
          if (!T.tagName || T.tagName === "#text") return T.textContent || "";
          var G = T.attributes,
            _ = "<".concat(T.tagName);
          return G && Object.keys(G).forEach(function (q) {
            var Y = G[q];
            _ += " ".concat(q, '="').concat(Y, '"');
          }), _ += ">", _ += T.textContent || "", (T.children || []).forEach(function (q) {
            _ += F(q);
          }), _ += "</".concat(T.tagName, ">");
        };
        return R = this.getTableAST(R), F(R);
      }
      function p(R) {
        var F = 0,
          T = [],
          G = this.options,
          _ = R ? 1.1.toLocaleString()[1] : ".",
          q = x(G.exporting.useMultiLevelHeaders, !0);
        R = this.getDataRows(q);
        var Y = q ? R.shift() : null,
          U = R.shift(),
          Z = function Z(lt, ct, tt, st) {
            var it = x(st, "");
            return ct = "highcharts-text" + (ct ? " " + ct : ""), typeof it == "number" ? (it = it.toString(), _ === "," && (it = it.replace(".", _)), ct = "highcharts-number") : st || (ct = "highcharts-empty"), tt = b({
              class: ct
            }, tt), {
              tagName: lt,
              attributes: tt,
              textContent: it
            };
          };
        G.exporting.tableCaption !== !1 && T.push({
          tagName: "caption",
          attributes: {
            class: "highcharts-table-caption"
          },
          textContent: x(G.exporting.tableCaption, G.title.text ? G.title.text : "Chart")
        });
        for (var J = 0, et = R.length; J < et; ++J) R[J].length > F && (F = R[J].length);
        T.push(function (lt, ct, tt) {
          var st = [],
            it = 0;
          tt = tt || ct && ct.length;
          var $ = 0,
            Q;
          if (Q = q && lt && ct) {
            t: if (Q = lt.length, ct.length === Q) {
              for (; Q--;) if (lt[Q] !== ct[Q]) {
                Q = !1;
                break t;
              }
              Q = !0;
            } else Q = !1;
            Q = !Q;
          }
          if (Q) {
            for (Q = []; it < tt; ++it) {
              var ot = lt[it],
                at = lt[it + 1];
              ot === at ? ++$ : $ ? (Q.push(Z("th", "highcharts-table-topheading", {
                scope: "col",
                colspan: $ + 1
              }, ot)), $ = 0) : (ot === ct[it] ? G.exporting.useRowspanHeaders ? (at = 2, delete ct[it]) : (at = 1, ct[it] = "") : at = 1, ot = Z("th", "highcharts-table-topheading", {
                scope: "col"
              }, ot), 1 < at && ot.attributes && (ot.attributes.valign = "top", ot.attributes.rowspan = at), Q.push(ot));
            }
            st.push({
              tagName: "tr",
              children: Q
            });
          }
          if (ct) {
            for (Q = [], it = 0, tt = ct.length; it < tt; ++it) typeof ct[it] < "u" && Q.push(Z("th", null, {
              scope: "col"
            }, ct[it]));
            st.push({
              tagName: "tr",
              children: Q
            });
          }
          return {
            tagName: "thead",
            children: st
          };
        }(Y, U, Math.max(F, U.length)));
        var nt = [];
        return R.forEach(function (lt) {
          for (var ct = [], tt = 0; tt < F; tt++) ct.push(Z(tt ? "td" : "th", null, tt ? {} : {
            scope: "row"
          }, lt[tt]));
          nt.push({
            tagName: "tr",
            children: ct
          });
        }), T.push({
          tagName: "tbody",
          children: nt
        }), T = {
          tree: {
            tagName: "table",
            id: "highcharts-data-table-".concat(this.index),
            children: T
          }
        }, P(this, "aftergetTableAST", T), T.tree;
      }
      function h() {
        this.toggleDataTable(!1);
      }
      function s(R) {
        var F = (R = x(R, !this.isDataTableVisible)) && !this.dataTableDiv;
        if (F && (this.dataTableDiv = L.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
          var T = this.dataTableDiv.style,
            G = T.display;
          T.display = R ? "block" : "none", R && (this.dataTableDiv.innerHTML = S.emptyHTML, new S([this.getTableAST()]).addToDOM(this.dataTableDiv), P(this, "afterViewData", {
            element: this.dataTableDiv,
            wasHidden: F || G !== T.display
          }));
        }
        this.isDataTableVisible = R, F = this.exportDivElements, G = (T = this.options.exporting) && T.buttons && T.buttons.contextButton.menuItems, R = this.options.lang, T && T.menuItemDefinitions && R && R.viewData && R.hideData && G && F && (F = F[G.indexOf("viewData")]) && S.setElementHTML(F, this.isDataTableVisible ? R.hideData : R.viewData);
      }
      function l() {
        this.toggleDataTable(!0);
      }
      function u(R, F) {
        var T = C.navigator,
          G = -1 < T.userAgent.indexOf("WebKit") && 0 > T.userAgent.indexOf("Chrome"),
          _ = C.URL || C.webkitURL || C;
        try {
          if (T.msSaveOrOpenBlob && C.MSBlobBuilder) {
            var q = new C.MSBlobBuilder();
            return q.append(R), q.getBlob("image/svg+xml");
          }
          if (!G) return _.createObjectURL(new C.Blob(["\uFEFF" + R], {
            type: F
          }));
        } catch (_unused5) {}
      }
      function v() {
        var R = this,
          F = R.dataTableDiv,
          T = function T(_, q) {
            return function (Y, U) {
              var Z = (q ? Y : U).children[_].textContent;
              return Y = (q ? U : Y).children[_].textContent, Z === "" || Y === "" || isNaN(Z) || isNaN(Y) ? Z.toString().localeCompare(Y) : Z - Y;
            };
          };
        if (F && R.options.exporting && R.options.exporting.allowTableSorting) {
          var G = F.querySelector("thead tr");
          G && G.childNodes.forEach(function (_) {
            var q = _.closest("table");
            _.addEventListener("click", function () {
              var Y = I([], F.querySelectorAll("tr:not(thead tr)"), !0),
                U = I([], _.parentNode.children, !0);
              Y.sort(T(U.indexOf(_), R.ascendingOrderInTable = !R.ascendingOrderInTable)).forEach(function (Z) {
                q.appendChild(Z);
              }), U.forEach(function (Z) {
                ["highcharts-sort-ascending", "highcharts-sort-descending"].forEach(function (J) {
                  Z.classList.contains(J) && Z.classList.remove(J);
                });
              }), _.classList.add(R.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
            });
          });
        }
      }
      function M() {
        this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
      }
      var I = this && this.__spreadArray || function (R, F, T) {
          if (T || arguments.length === 2) for (var G = 0, _ = F.length, q; G < _; G++) !q && G in F || (q || (q = Array.prototype.slice.call(F, 0, G)), q[G] = F[G]);
          return R.concat(q || Array.prototype.slice.call(F));
        },
        L = E.doc,
        C = E.win,
        m = B.getOptions,
        d = B.setOptions,
        o = H.downloadURL,
        n = X.series;
      E = X.seriesTypes;
      var r = E.arearange,
        i = E.gantt,
        t = E.map,
        e = E.mapbubble,
        a = E.treemap,
        c = W.addEvent,
        y = W.defined,
        b = W.extend,
        j = W.find,
        P = W.fireEvent,
        f = W.isNumber,
        x = W.pick,
        N = [];
      return {
        compose: function compose(R) {
          N.indexOf(R) === -1 && (N.push(R), c(R, "afterViewData", v), c(R, "render", M), R = R.prototype, R.downloadCSV = z, R.downloadXLS = w, R.getCSV = A, R.getDataRows = k, R.getTable = g, R.getTableAST = p, R.hideData = h, R.toggleDataTable = s, R.viewData = l), N.indexOf(d) === -1 && (N.push(d), (R = m().exporting) && (b(R.menuItemDefinitions, {
            downloadCSV: {
              textKey: "downloadCSV",
              onclick: function onclick() {
                this.downloadCSV();
              }
            },
            downloadXLS: {
              textKey: "downloadXLS",
              onclick: function onclick() {
                this.downloadXLS();
              }
            },
            viewData: {
              textKey: "viewData",
              onclick: function onclick() {
                this.toggleDataTable();
              }
            }
          }), R.buttons && R.buttons.contextButton.menuItems && R.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), d(D)), r && N.indexOf(r) === -1 && (N.push(r), r.prototype.keyToAxis = {
            low: "y",
            high: "y"
          }), i && N.indexOf(i) === -1 && (N.push(i), i.prototype.keyToAxis = {
            start: "x",
            end: "x"
          }), t && N.indexOf(t) === -1 && (N.push(t), t.prototype.exportKey = "name"), e && N.indexOf(e) === -1 && (N.push(e), e.prototype.exportKey = "name"), a && N.indexOf(a) === -1 && (N.push(a), a.prototype.exportKey = "name");
        }
      };
    }), V(O, "masters/modules/export-data.src.js", [O["Core/Globals.js"], O["Extensions/ExportData/ExportData.js"]], function (S, D) {
      D.compose(S.Chart);
    });
  });
})(yi);
var co = yi.exports;
var po = /* @__PURE__ */Xt(co);
var vi = {
  exports: {}
};
(function (K) {
  (function (O) {
    K.exports ? (O.default = O, K.exports = O) : O(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function (O) {
    function V(S, D, E, B) {
      S.hasOwnProperty(D) || (S[D] = B.apply(null, E), typeof CustomEvent == "function" && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
        detail: {
          path: D,
          module: S[D]
        }
      })));
    }
    O = O ? O._modules : {}, V(O, "Core/Chart/ChartNavigationComposition.js", [], function () {
      var S;
      return function (D) {
        D.compose = function (B) {
          return B.navigation || (B.navigation = new E(B)), B;
        };
        var E = function () {
          function B(H) {
            this.updates = [], this.chart = H;
          }
          return B.prototype.addUpdate = function (H) {
            this.chart.navigation.updates.push(H);
          }, B.prototype.update = function (H, X) {
            var W = this;
            this.updates.forEach(function (z) {
              z.call(W.chart, H, X);
            });
          }, B;
        }();
        D.Additions = E;
      }(S || (S = {})), S;
    }), V(O, "Extensions/Exporting/ExportingDefaults.js", [O["Core/Globals.js"]], function (S) {
      return S = S.isTouchDevice, {
        exporting: {
          allowTableSorting: !0,
          type: "image/png",
          url: "https://export.highcharts.com/",
          pdfFont: {
            normal: void 0,
            bold: void 0,
            bolditalic: void 0,
            italic: void 0
          },
          printMaxWidth: 780,
          scale: 2,
          buttons: {
            contextButton: {
              className: "highcharts-contextbutton",
              menuClassName: "highcharts-contextmenu",
              symbol: "menu",
              titleKey: "contextButtonTitle",
              menuItems: "viewFullscreen printChart separator downloadPNG downloadJPEG downloadPDF downloadSVG".split(" ")
            }
          },
          menuItemDefinitions: {
            viewFullscreen: {
              textKey: "viewFullscreen",
              onclick: function onclick() {
                this.fullscreen && this.fullscreen.toggle();
              }
            },
            printChart: {
              textKey: "printChart",
              onclick: function onclick() {
                this.print();
              }
            },
            separator: {
              separator: !0
            },
            downloadPNG: {
              textKey: "downloadPNG",
              onclick: function onclick() {
                this.exportChart();
              }
            },
            downloadJPEG: {
              textKey: "downloadJPEG",
              onclick: function onclick() {
                this.exportChart({
                  type: "image/jpeg"
                });
              }
            },
            downloadPDF: {
              textKey: "downloadPDF",
              onclick: function onclick() {
                this.exportChart({
                  type: "application/pdf"
                });
              }
            },
            downloadSVG: {
              textKey: "downloadSVG",
              onclick: function onclick() {
                this.exportChart({
                  type: "image/svg+xml"
                });
              }
            }
          }
        },
        lang: {
          viewFullscreen: "View in full screen",
          exitFullscreen: "Exit from full screen",
          printChart: "Print chart",
          downloadPNG: "Download PNG image",
          downloadJPEG: "Download JPEG image",
          downloadPDF: "Download PDF document",
          downloadSVG: "Download SVG vector image",
          contextButtonTitle: "Chart context menu"
        },
        navigation: {
          buttonOptions: {
            symbolSize: 14,
            symbolX: 12.5,
            symbolY: 10.5,
            align: "right",
            buttonSpacing: 3,
            height: 22,
            verticalAlign: "top",
            width: 24,
            symbolFill: "#666666",
            symbolStroke: "#666666",
            symbolStrokeWidth: 3,
            theme: {
              padding: 5
            }
          },
          menuStyle: {
            border: "1px solid ".concat("#999999"),
            background: "#ffffff",
            padding: "5px 0"
          },
          menuItemStyle: {
            padding: "0.5em 1em",
            color: "#333333",
            background: "none",
            fontSize: S ? "14px" : "11px",
            transition: "background 250ms, color 250ms"
          },
          menuItemHoverStyle: {
            background: "#335cad",
            color: "#ffffff"
          }
        }
      };
    }), V(O, "Extensions/Exporting/ExportingSymbols.js", [], function () {
      var S;
      return function (D) {
        function E(X, W, z, w) {
          return [["M", X, W + 2.5], ["L", X + z, W + 2.5], ["M", X, W + w / 2 + 0.5], ["L", X + z, W + w / 2 + 0.5], ["M", X, W + w - 1.5], ["L", X + z, W + w - 1.5]];
        }
        function B(X, W, z, w) {
          return X = w / 3 - 2, w = [], w = w.concat(this.circle(z - X, W, X, X), this.circle(z - X, W + X + 4, X, X), this.circle(z - X, W + 2 * (X + 4), X, X));
        }
        var H = [];
        D.compose = function (X) {
          H.indexOf(X) === -1 && (H.push(X), X = X.prototype.symbols, X.menu = E, X.menuball = B.bind(X));
        };
      }(S || (S = {})), S;
    }), V(O, "Extensions/Exporting/Fullscreen.js", [O["Core/Renderer/HTML/AST.js"], O["Core/Utilities.js"]], function (S, D) {
      function E() {
        this.fullscreen = new W(this);
      }
      var B = D.addEvent,
        H = D.fireEvent,
        X = [],
        W = function () {
          function z(w) {
            this.chart = w, this.isOpen = !1, w = w.renderTo, this.browserProps || (typeof w.requestFullscreen == "function" ? this.browserProps = {
              fullscreenChange: "fullscreenchange",
              requestFullscreen: "requestFullscreen",
              exitFullscreen: "exitFullscreen"
            } : w.mozRequestFullScreen ? this.browserProps = {
              fullscreenChange: "mozfullscreenchange",
              requestFullscreen: "mozRequestFullScreen",
              exitFullscreen: "mozCancelFullScreen"
            } : w.webkitRequestFullScreen ? this.browserProps = {
              fullscreenChange: "webkitfullscreenchange",
              requestFullscreen: "webkitRequestFullScreen",
              exitFullscreen: "webkitExitFullscreen"
            } : w.msRequestFullscreen && (this.browserProps = {
              fullscreenChange: "MSFullscreenChange",
              requestFullscreen: "msRequestFullscreen",
              exitFullscreen: "msExitFullscreen"
            }));
          }
          return z.compose = function (w) {
            X.indexOf(w) === -1 && (X.push(w), B(w, "beforeRender", E));
          }, z.prototype.close = function () {
            var w = this,
              A = w.chart,
              k = A.options.chart;
            H(A, "fullscreenClose", null, function () {
              w.isOpen && w.browserProps && A.container.ownerDocument instanceof Document && A.container.ownerDocument[w.browserProps.exitFullscreen](), w.unbindFullscreenEvent && (w.unbindFullscreenEvent = w.unbindFullscreenEvent()), A.setSize(w.origWidth, w.origHeight, !1), w.origWidth = void 0, w.origHeight = void 0, k.width = w.origWidthOption, k.height = w.origHeightOption, w.origWidthOption = void 0, w.origHeightOption = void 0, w.isOpen = !1, w.setButtonText();
            });
          }, z.prototype.open = function () {
            var w = this,
              A = w.chart,
              k = A.options.chart;
            H(A, "fullscreenOpen", null, function () {
              if (k && (w.origWidthOption = k.width, w.origHeightOption = k.height), w.origWidth = A.chartWidth, w.origHeight = A.chartHeight, w.browserProps) {
                var g = B(A.container.ownerDocument, w.browserProps.fullscreenChange, function () {
                    w.isOpen ? (w.isOpen = !1, w.close()) : (A.setSize(null, null, !1), w.isOpen = !0, w.setButtonText());
                  }),
                  p = B(A, "destroy", g);
                w.unbindFullscreenEvent = function () {
                  g(), p();
                };
                var h = A.renderTo[w.browserProps.requestFullscreen]();
                h && h.catch(function () {
                  alert("Full screen is not supported inside a frame.");
                });
              }
            });
          }, z.prototype.setButtonText = function () {
            var w = this.chart,
              A = w.exportDivElements,
              k = w.options.exporting,
              g = k && k.buttons && k.buttons.contextButton.menuItems;
            w = w.options.lang, k && k.menuItemDefinitions && w && w.exitFullscreen && w.viewFullscreen && g && A && (A = A[g.indexOf("viewFullscreen")]) && S.setElementHTML(A, this.isOpen ? w.exitFullscreen : k.menuItemDefinitions.viewFullscreen.text || w.viewFullscreen);
          }, z.prototype.toggle = function () {
            this.isOpen ? this.close() : this.open();
          }, z;
        }();
      return W;
    }), V(O, "Core/HttpUtilities.js", [O["Core/Globals.js"], O["Core/Utilities.js"]], function (S, D) {
      var E = S.doc,
        B = D.createElement,
        H = D.discardElement,
        X = D.merge,
        W = D.objectEach,
        z = {
          ajax: function ajax(w) {
            var A = {
                json: "application/json",
                xml: "application/xml",
                text: "text/plain",
                octet: "application/octet-stream"
              },
              k = new XMLHttpRequest();
            if (!w.url) return !1;
            k.open((w.type || "get").toUpperCase(), w.url, !0), w.headers && w.headers["Content-Type"] || k.setRequestHeader("Content-Type", A[w.dataType || "json"] || A.text), W(w.headers, function (g, p) {
              k.setRequestHeader(p, g);
            }), w.responseType && (k.responseType = w.responseType), k.onreadystatechange = function () {
              if (k.readyState === 4) {
                if (k.status === 200) {
                  if (w.responseType !== "blob") {
                    var g = k.responseText;
                    if (w.dataType === "json") try {
                      g = JSON.parse(g);
                    } catch (p) {
                      if (p instanceof Error) {
                        w.error && w.error(k, p);
                        return;
                      }
                    }
                  }
                  return w.success && w.success(g, k);
                }
                w.error && w.error(k, k.responseText);
              }
            }, w.data && typeof w.data != "string" && (w.data = JSON.stringify(w.data)), k.send(w.data);
          },
          getJSON: function getJSON(w, A) {
            z.ajax({
              url: w,
              success: A,
              dataType: "json",
              headers: {
                "Content-Type": "text/plain"
              }
            });
          },
          post: function post(w, A, k) {
            var g = B("form", X({
              method: "post",
              action: w,
              enctype: "multipart/form-data"
            }, k), {
              display: "none"
            }, E.body);
            W(A, function (p, h) {
              B("input", {
                type: "hidden",
                name: h,
                value: p
              }, void 0, g);
            }), g.submit(), H(g);
          }
        };
      return z;
    }), V(O, "Extensions/Exporting/Exporting.js", [O["Core/Renderer/HTML/AST.js"], O["Core/Chart/Chart.js"], O["Core/Chart/ChartNavigationComposition.js"], O["Core/Defaults.js"], O["Extensions/Exporting/ExportingDefaults.js"], O["Extensions/Exporting/ExportingSymbols.js"], O["Extensions/Exporting/Fullscreen.js"], O["Core/Globals.js"], O["Core/HttpUtilities.js"], O["Core/Utilities.js"]], function (S, D, E, B, H, X, W, z, w, A) {
      var k = B.defaultOptions,
        g = B.setOptions,
        p = z.doc,
        h = z.SVG_NS,
        s = z.win,
        l = A.addEvent,
        u = A.css,
        v = A.createElement,
        M = A.discardElement,
        I = A.extend,
        L = A.find,
        C = A.fireEvent,
        m = A.isObject,
        d = A.merge,
        o = A.objectEach,
        n = A.pick,
        r = A.removeEvent,
        i = A.uniqueKey,
        t;
      return function (e) {
        function a(tt) {
          var st = this,
            it = st.renderer,
            $ = d(st.options.navigation.buttonOptions, tt),
            Q = $.onclick,
            ot = $.menuItems,
            at = $.symbolSize || 12;
          if (st.btnCount || (st.btnCount = 0), st.exportDivElements || (st.exportDivElements = [], st.exportSVGElements = []), $.enabled !== !1 && $.theme) {
            var rt = $.theme,
              ht;
            st.styledMode || (rt.fill = n(rt.fill, "#ffffff"), rt.stroke = n(rt.stroke, "none")), Q ? ht = function ht(gt) {
              gt && gt.stopPropagation(), Q.call(st, gt);
            } : ot && (ht = function ht(gt) {
              gt && gt.stopPropagation(), st.contextMenu(pt.menuClassName, ot, pt.translateX, pt.translateY, pt.width, pt.height, pt), pt.setState(2);
            }), $.text && $.symbol ? rt.paddingLeft = n(rt.paddingLeft, 30) : $.text || I(rt, {
              width: $.width,
              height: $.height,
              padding: 0
            }), st.styledMode || (rt["stroke-linecap"] = "round", rt.fill = n(rt.fill, "#ffffff"), rt.stroke = n(rt.stroke, "none"));
            var pt = it.button($.text, 0, 0, ht, rt, void 0, void 0, void 0, void 0, $.useHTML).addClass(tt.className).attr({
              title: n(st.options.lang[$._titleKey || $.titleKey], "")
            });
            if (pt.menuClassName = tt.menuClassName || "highcharts-menu-" + st.btnCount++, $.symbol) {
              var dt = it.symbol($.symbol, $.symbolX - at / 2, $.symbolY - at / 2, at, at, {
                width: at,
                height: at
              }).addClass("highcharts-button-symbol").attr({
                zIndex: 1
              }).add(pt);
              st.styledMode || dt.attr({
                stroke: $.symbolStroke,
                fill: $.symbolFill,
                "stroke-width": $.symbolStrokeWidth || 1
              });
            }
            pt.add(st.exportingGroup).align(I($, {
              width: pt.width,
              x: n($.x, st.buttonOffset)
            }), !0, "spacingBox"), st.buttonOffset += (pt.width + $.buttonSpacing) * ($.align === "right" ? -1 : 1), st.exportSVGElements.push(pt, dt);
          }
        }
        function c() {
          if (this.printReverseInfo) {
            var tt = this.printReverseInfo,
              st = tt.childNodes,
              it = tt.origDisplay;
            tt = tt.resetParams, this.moveContainers(this.renderTo), [].forEach.call(st, function ($, Q) {
              $.nodeType === 1 && ($.style.display = it[Q] || "");
            }), this.isPrinting = !1, tt && this.setSize.apply(this, tt), delete this.printReverseInfo, ct = void 0, C(this, "afterPrint");
          }
        }
        function y() {
          var tt = p.body,
            st = this.options.exporting.printMaxWidth,
            it = {
              childNodes: tt.childNodes,
              origDisplay: [],
              resetParams: void 0
            };
          this.isPrinting = !0, this.pointer.reset(null, 0), C(this, "beforePrint"), st && this.chartWidth > st && (it.resetParams = [this.options.chart.width, void 0, !1], this.setSize(st, void 0, !1)), [].forEach.call(it.childNodes, function ($, Q) {
            $.nodeType === 1 && (it.origDisplay[Q] = $.style.display, $.style.display = "none");
          }), this.moveContainers(tt), this.printReverseInfo = it;
        }
        function b(tt) {
          tt.renderExporting(), l(tt, "redraw", tt.renderExporting), l(tt, "destroy", tt.destroyExport);
        }
        function j(tt, st, it, $, Q, ot, at) {
          var rt = this,
            ht = rt.options.navigation,
            pt = rt.chartWidth,
            dt = rt.chartHeight,
            gt = "cache-" + tt,
            ut = Math.max(Q, ot),
            ft = rt[gt];
          if (!ft) {
            rt.exportContextMenu = rt[gt] = ft = v("div", {
              className: tt
            }, {
              position: "absolute",
              zIndex: 1e3,
              padding: ut + "px",
              pointerEvents: "auto"
            }, rt.fixedDiv || rt.container);
            var vt = v("ul", {
              className: "highcharts-menu"
            }, {
              listStyle: "none",
              margin: 0,
              padding: 0
            }, ft);
            rt.styledMode || u(vt, I({
              MozBoxShadow: "3px 3px 10px #888",
              WebkitBoxShadow: "3px 3px 10px #888",
              boxShadow: "3px 3px 10px #888"
            }, ht.menuStyle)), ft.hideMenu = function () {
              u(ft, {
                display: "none"
              }), at && at.setState(0), rt.openMenu = !1, u(rt.renderTo, {
                overflow: "hidden"
              }), u(rt.container, {
                overflow: "hidden"
              }), A.clearTimeout(ft.hideTimer), C(rt, "exportMenuHidden");
            }, rt.exportEvents.push(l(ft, "mouseleave", function () {
              ft.hideTimer = s.setTimeout(ft.hideMenu, 500);
            }), l(ft, "mouseenter", function () {
              A.clearTimeout(ft.hideTimer);
            }), l(p, "mouseup", function (mt) {
              rt.pointer.inClass(mt.target, tt) || ft.hideMenu();
            }), l(ft, "click", function () {
              rt.openMenu && ft.hideMenu();
            })), st.forEach(function (mt) {
              if (typeof mt == "string" && (mt = rt.options.exporting.menuItemDefinitions[mt]), m(mt, !0)) {
                var xt = void 0;
                mt.separator ? xt = v("hr", void 0, void 0, vt) : (mt.textKey === "viewData" && rt.isDataTableVisible && (mt.textKey = "hideData"), xt = v("li", {
                  className: "highcharts-menu-item",
                  onclick: function onclick(yt) {
                    yt && yt.stopPropagation(), ft.hideMenu(), mt.onclick && mt.onclick.apply(rt, arguments);
                  }
                }, void 0, vt), S.setElementHTML(xt, mt.text || rt.options.lang[mt.textKey]), rt.styledMode || (xt.onmouseover = function () {
                  u(this, ht.menuItemHoverStyle);
                }, xt.onmouseout = function () {
                  u(this, ht.menuItemStyle);
                }, u(xt, I({
                  cursor: "pointer"
                }, ht.menuItemStyle || {})))), rt.exportDivElements.push(xt);
              }
            }), rt.exportDivElements.push(vt, ft), rt.exportMenuWidth = ft.offsetWidth, rt.exportMenuHeight = ft.offsetHeight;
          }
          st = {
            display: "block"
          }, it + rt.exportMenuWidth > pt ? st.right = pt - it - Q - ut + "px" : st.left = it - ut + "px", $ + ot + rt.exportMenuHeight > dt && at.alignOptions.verticalAlign !== "top" ? st.bottom = dt - $ - ut + "px" : st.top = $ + ot - ut + "px", u(ft, st), u(rt.renderTo, {
            overflow: ""
          }), u(rt.container, {
            overflow: ""
          }), rt.openMenu = !0, C(rt, "exportMenuShown");
        }
        function P(tt) {
          var st = tt ? tt.target : this,
            it = st.exportSVGElements,
            $ = st.exportDivElements;
          tt = st.exportEvents;
          var Q;
          it && (it.forEach(function (ot, at) {
            ot && (ot.onclick = ot.ontouchstart = null, Q = "cache-" + ot.menuClassName, st[Q] && delete st[Q], it[at] = ot.destroy());
          }), it.length = 0), st.exportingGroup && (st.exportingGroup.destroy(), delete st.exportingGroup), $ && ($.forEach(function (ot, at) {
            ot && (A.clearTimeout(ot.hideTimer), r(ot, "mouseleave"), $[at] = ot.onmouseout = ot.onmouseover = ot.ontouchstart = ot.onclick = null, M(ot));
          }), $.length = 0), tt && (tt.forEach(function (ot) {
            ot();
          }), tt.length = 0);
        }
        function f(tt, st) {
          st = this.getSVGForExport(tt, st), tt = d(this.options.exporting, tt), w.post(tt.url, {
            filename: tt.filename ? tt.filename.replace(/\//g, "-") : this.getFilename(),
            type: tt.type,
            width: tt.width || 0,
            scale: tt.scale,
            svg: st
          }, tt.formAttributes);
        }
        function x() {
          return this.styledMode && this.inlineStyles(), this.container.innerHTML;
        }
        function N() {
          var tt = this.userOptions.title && this.userOptions.title.text,
            st = this.options.exporting.filename;
          return st ? st.replace(/\//g, "-") : (typeof tt == "string" && (st = tt.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z0-9\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!st || 5 > st.length) && (st = "chart"), st);
        }
        function R(tt) {
          var st,
            it = d(this.options, tt);
          it.plotOptions = d(this.userOptions.plotOptions, tt && tt.plotOptions), it.time = d(this.userOptions.time, tt && tt.time);
          var $ = v("div", null, {
              position: "absolute",
              top: "-9999em",
              width: this.chartWidth + "px",
              height: this.chartHeight + "px"
            }, p.body),
            Q = this.renderTo.style.width,
            ot = this.renderTo.style.height;
          Q = it.exporting.sourceWidth || it.chart.width || /px$/.test(Q) && parseInt(Q, 10) || (it.isGantt ? 800 : 600), ot = it.exporting.sourceHeight || it.chart.height || /px$/.test(ot) && parseInt(ot, 10) || 400, I(it.chart, {
            animation: !1,
            renderTo: $,
            forExport: !0,
            renderer: "SVGRenderer",
            width: Q,
            height: ot
          }), it.exporting.enabled = !1, delete it.data, it.series = [], this.series.forEach(function (ht) {
            st = d(ht.userOptions, {
              animation: !1,
              enableMouseTracking: !1,
              showCheckbox: !1,
              visible: ht.visible
            }), st.isInternal || it.series.push(st);
          });
          var at = {};
          this.axes.forEach(function (ht) {
            ht.userOptions.internalKey || (ht.userOptions.internalKey = i()), ht.options.isInternal || (at[ht.coll] || (at[ht.coll] = !0, it[ht.coll] = []), it[ht.coll].push(d(ht.userOptions, {
              visible: ht.visible
            })));
          });
          var rt = new this.constructor(it, this.callback);
          return tt && ["xAxis", "yAxis", "series"].forEach(function (ht) {
            var pt = {};
            tt[ht] && (pt[ht] = tt[ht], rt.update(pt));
          }), this.axes.forEach(function (ht) {
            var pt = L(rt.axes, function (ut) {
                return ut.options.internalKey === ht.userOptions.internalKey;
              }),
              dt = ht.getExtremes(),
              gt = dt.userMin;
            dt = dt.userMax, pt && (typeof gt < "u" && gt !== pt.min || typeof dt < "u" && dt !== pt.max) && pt.setExtremes(gt, dt, !0, !1);
          }), ot = rt.getChartHTML(), C(this, "getSVG", {
            chartCopy: rt
          }), ot = this.sanitizeSVG(ot, it), it = null, rt.destroy(), M($), ot;
        }
        function F(tt, st) {
          var it = this.options.exporting;
          return this.getSVG(d({
            chart: {
              borderRadius: 0
            }
          }, it.chartOptions, st, {
            exporting: {
              sourceWidth: tt && tt.sourceWidth || it.sourceWidth,
              sourceHeight: tt && tt.sourceHeight || it.sourceHeight
            }
          }));
        }
        function T(tt) {
          return tt.replace(/([A-Z])/g, function (st, it) {
            return "-" + it.toLowerCase();
          });
        }
        function G() {
          function tt(rt) {
            var ht = {};
            if (at && rt.nodeType === 1 && lt.indexOf(rt.nodeName) === -1) {
              var pt = s.getComputedStyle(rt, null),
                dt = rt.nodeName === "svg" ? {} : s.getComputedStyle(rt.parentNode, null);
              if (!$[rt.nodeName]) {
                Q = at.getElementsByTagName("svg")[0];
                var gt = at.createElementNS(rt.namespaceURI, rt.nodeName);
                Q.appendChild(gt);
                var ut = s.getComputedStyle(gt, null),
                  ft = {};
                for (var vt in ut) typeof ut[vt] != "string" || /^[0-9]+$/.test(vt) || (ft[vt] = ut[vt]);
                $[rt.nodeName] = ft, rt.nodeName === "text" && delete $.text.fill, Q.removeChild(gt);
              }
              for (var mt in pt) if (z.isFirefox || z.isMS || z.isSafari || Object.hasOwnProperty.call(pt, mt)) {
                vt = pt[mt];
                var xt = mt;
                if (gt = ut = !1, it.length) {
                  for (ft = it.length; ft-- && !ut;) ut = it[ft].test(xt);
                  gt = !ut;
                }
                for (xt === "transform" && vt === "none" && (gt = !0), ft = st.length; ft-- && !gt;) gt = st[ft].test(xt) || typeof vt == "function";
                gt || dt[xt] === vt && rt.nodeName !== "svg" || $[rt.nodeName][xt] === vt || (nt && nt.indexOf(xt) === -1 ? ht[xt] = vt : vt && rt.setAttribute(T(xt), vt));
              }
              u(rt, ht), rt.nodeName === "svg" && rt.setAttribute("stroke-width", "1px"), rt.nodeName !== "text" && [].forEach.call(rt.children || rt.childNodes, tt);
            }
          }
          var st = et,
            it = e.inlineAllowlist,
            $ = {},
            Q,
            ot = p.createElement("iframe");
          u(ot, {
            width: "1px",
            height: "1px",
            visibility: "hidden"
          }), p.body.appendChild(ot);
          var at = ot.contentWindow && ot.contentWindow.document;
          at && at.body.appendChild(at.createElementNS(h, "svg")), tt(this.container.querySelector("svg")), Q.parentNode.removeChild(Q), ot.parentNode.removeChild(ot);
        }
        function _(tt) {
          (this.fixedDiv ? [this.fixedDiv, this.scrollingContainer] : [this.container]).forEach(function (st) {
            tt.appendChild(st);
          });
        }
        function q() {
          var tt = this;
          tt.exporting = {
            update: function update(st, it) {
              tt.isDirtyExporting = !0, d(!0, tt.options.exporting, st), n(it, !0) && tt.redraw();
            }
          }, E.compose(tt).navigation.addUpdate(function (st, it) {
            tt.isDirtyExporting = !0, d(!0, tt.options.navigation, st), n(it, !0) && tt.redraw();
          });
        }
        function Y() {
          var tt = this;
          tt.isPrinting || (ct = tt, z.isSafari || tt.beforePrint(), setTimeout(function () {
            s.focus(), s.print(), z.isSafari || setTimeout(function () {
              tt.afterPrint();
            }, 1e3);
          }, 1));
        }
        function U() {
          var tt = this,
            st = tt.options.exporting,
            it = st.buttons,
            $ = tt.isDirtyExporting || !tt.exportSVGElements;
          tt.buttonOffset = 0, tt.isDirtyExporting && tt.destroyExport(), $ && st.enabled !== !1 && (tt.exportEvents = [], tt.exportingGroup = tt.exportingGroup || tt.renderer.g("exporting-group").attr({
            zIndex: 3
          }).add(), o(it, function (Q) {
            tt.addButton(Q);
          }), tt.isDirtyExporting = !1);
        }
        function Z(tt, st) {
          var it = tt.indexOf("</svg>") + 6,
            $ = tt.substr(it);
          return tt = tt.substr(0, it), st && st.exporting && st.exporting.allowHTML && $ && ($ = '<foreignObject x="0" y="0" width="' + st.chart.width + '" height="' + st.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + $.replace(/(<(?:img|br).*?(?=>))>/g, "$1 />") + "</body></foreignObject>", tt = tt.replace("</svg>", $ + "</svg>")), tt = tt.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery[0-9]+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;);?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (|NS[0-9]+:)href=/g, " xlink:href=").replace(/\n/, " ").replace(/(fill|stroke)="rgba\(([ 0-9]+,[ 0-9]+,[ 0-9]+),([ 0-9\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, " ").replace(/&shy;/g, "­"), this.ieSanitizeSVG && (tt = this.ieSanitizeSVG(tt)), tt;
        }
        var J = [],
          et = [/-/, /^(clipPath|cssText|d|height|width)$/, /^font$/, /[lL]ogical(Width|Height)$/, /^parentRule$/, /perspective/, /TapHighlightColor/, /^transition/, /^length$/, /^[0-9]+$/],
          nt = "fill stroke strokeLinecap strokeLinejoin strokeWidth textAnchor x y".split(" ");
        e.inlineAllowlist = [];
        var lt = ["clipPath", "defs", "desc"],
          ct;
        e.compose = function (tt, st) {
          X.compose(st), W.compose(tt), J.indexOf(tt) === -1 && (J.push(tt), st = tt.prototype, st.afterPrint = c, st.exportChart = f, st.inlineStyles = G, st.print = Y, st.sanitizeSVG = Z, st.getChartHTML = x, st.getSVG = R, st.getSVGForExport = F, st.getFilename = N, st.moveContainers = _, st.beforePrint = y, st.contextMenu = j, st.addButton = a, st.destroyExport = P, st.renderExporting = U, st.callbacks.push(b), l(tt, "init", q), z.isSafari && z.win.matchMedia("print").addListener(function (it) {
            ct && (it.matches ? ct.beforePrint() : ct.afterPrint());
          })), J.indexOf(g) === -1 && (J.push(g), k.exporting = d(H.exporting, k.exporting), k.lang = d(H.lang, k.lang), k.navigation = d(H.navigation, k.navigation));
        };
      }(t || (t = {})), t;
    }), V(O, "masters/modules/exporting.src.js", [O["Core/Globals.js"], O["Extensions/Exporting/Exporting.js"], O["Core/HttpUtilities.js"]], function (S, D, E) {
      S.HttpUtilities = E, S.ajax = E.ajax, S.getJSON = E.getJSON, S.post = E.post, D.compose(S.Chart, S.Renderer);
    });
  });
})(vi);
var uo = vi.exports;
var fo = /* @__PURE__ */Xt(uo);
var go = typeof global == "object" && global && global.Object === Object && global;
var xi = go;
var mo = typeof self == "object" && self && self.Object === Object && self,
  yo = xi || mo || Function("return this")();
var Nt = yo;
var vo = Nt.Symbol;
var Gt = vo;
var bi = Object.prototype,
  xo = bi.hasOwnProperty,
  bo = bi.toString,
  qt = Gt ? Gt.toStringTag : void 0;
function wo(K) {
  var O = xo.call(K, qt),
    V = K[qt];
  try {
    K[qt] = void 0;
    var S = !0;
  } catch (_unused6) {}
  var D = bo.call(K);
  return S && (O ? K[qt] = V : delete K[qt]), D;
}
var So = Object.prototype,
  Co = So.toString;
function ko(K) {
  return Co.call(K);
}
var Mo = "[object Null]",
  Ao = "[object Undefined]",
  Ge = Gt ? Gt.toStringTag : void 0;
function Yt(K) {
  return K == null ? K === void 0 ? Ao : Mo : Ge && Ge in Object(K) ? wo(K) : ko(K);
}
function Ft(K) {
  return K != null && typeof K == "object";
}
var To = "[object Symbol]";
function Ce(K) {
  return typeof K == "symbol" || Ft(K) && Yt(K) == To;
}
function wi(K, O) {
  for (var V = -1, S = K == null ? 0 : K.length, D = Array(S); ++V < S;) D[V] = O(K[V], V, K);
  return D;
}
var Oo = Array.isArray;
var jt = Oo;
var Do = 1 / 0,
  Fe = Gt ? Gt.prototype : void 0,
  He = Fe ? Fe.toString : void 0;
function Si(K) {
  if (typeof K == "string") return K;
  if (jt(K)) return wi(K, Si) + "";
  if (Ce(K)) return He ? He.call(K) : "";
  var O = K + "";
  return O == "0" && 1 / K == -Do ? "-0" : O;
}
function It(K) {
  var O = typeof K;
  return K != null && (O == "object" || O == "function");
}
function ke(K) {
  return K;
}
var Po = "[object AsyncFunction]",
  Eo = "[object Function]",
  jo = "[object GeneratorFunction]",
  Lo = "[object Proxy]";
function Me(K) {
  if (!It(K)) return !1;
  var O = Yt(K);
  return O == Eo || O == jo || O == Po || O == Lo;
}
var Io = Nt["__core-js_shared__"];
var pe = Io;
var ze = function () {
  var K = /[^.]+$/.exec(pe && pe.keys && pe.keys.IE_PROTO || "");
  return K ? "Symbol(src)_1." + K : "";
}();
function No(K) {
  return !!ze && ze in K;
}
var Bo = Function.prototype,
  Ro = Bo.toString;
function Wt(K) {
  if (K != null) {
    try {
      return Ro.call(K);
    } catch (_unused7) {}
    try {
      return K + "";
    } catch (_unused8) {}
  }
  return "";
}
var _o = /[\\^$.*+?()[\]{}|]/g,
  Go = /^\[object .+?Constructor\]$/,
  Fo = Function.prototype,
  Ho = Object.prototype,
  zo = Fo.toString,
  Xo = Ho.hasOwnProperty,
  Yo = RegExp("^" + zo.call(Xo).replace(_o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Wo(K) {
  if (!It(K) || No(K)) return !1;
  var O = Me(K) ? Yo : Go;
  return O.test(Wt(K));
}
function Uo(K, O) {
  return K == null ? void 0 : K[O];
}
function Ut(K, O) {
  var V = Uo(K, O);
  return Wo(V) ? V : void 0;
}
var Ko = Ut(Nt, "WeakMap");
var fe = Ko;
var Xe = Object.create,
  qo = function () {
    function K() {}
    return function (O) {
      if (!It(O)) return {};
      if (Xe) return Xe(O);
      K.prototype = O;
      var V = new K();
      return K.prototype = void 0, V;
    };
  }();
var Zo = qo;
function Vo(K, O, V) {
  switch (V.length) {
    case 0:
      return K.call(O);
    case 1:
      return K.call(O, V[0]);
    case 2:
      return K.call(O, V[0], V[1]);
    case 3:
      return K.call(O, V[0], V[1], V[2]);
  }
  return K.apply(O, V);
}
function $o(K, O) {
  var V = -1,
    S = K.length;
  for (O || (O = Array(S)); ++V < S;) O[V] = K[V];
  return O;
}
var Qo = 800,
  Jo = 16,
  tr = Date.now;
function er(K) {
  var O = 0,
    V = 0;
  return function () {
    var S = tr(),
      D = Jo - (S - V);
    if (V = S, D > 0) {
      if (++O >= Qo) return arguments[0];
    } else O = 0;
    return K.apply(void 0, arguments);
  };
}
function ir(K) {
  return function () {
    return K;
  };
}
var or = function () {
  try {
    var K = Ut(Object, "defineProperty");
    return K({}, "", {}), K;
  } catch (_unused9) {}
}();
var ee = or;
var rr = ee ? function (K, O) {
  return ee(K, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ir(O),
    writable: !0
  });
} : ke;
var nr = rr;
var sr = er(nr);
var ar = sr;
var hr = 9007199254740991,
  lr = /^(?:0|[1-9]\d*)$/;
function se(K, O) {
  var V = typeof K;
  return O = O == null ? hr : O, !!O && (V == "number" || V != "symbol" && lr.test(K)) && K > -1 && K % 1 == 0 && K < O;
}
function Ae(K, O, V) {
  O == "__proto__" && ee ? ee(K, O, {
    configurable: !0,
    enumerable: !0,
    value: V,
    writable: !0
  }) : K[O] = V;
}
function Qt(K, O) {
  return K === O || K !== K && O !== O;
}
var cr = Object.prototype,
  pr = cr.hasOwnProperty;
function Ci(K, O, V) {
  var S = K[O];
  (!(pr.call(K, O) && Qt(S, V)) || V === void 0 && !(O in K)) && Ae(K, O, V);
}
function dr(K, O, V, S) {
  var D = !V;
  V || (V = {});
  for (var E = -1, B = O.length; ++E < B;) {
    var H = O[E],
      X = S ? S(V[H], K[H], H, V, K) : void 0;
    X === void 0 && (X = K[H]), D ? Ae(V, H, X) : Ci(V, H, X);
  }
  return V;
}
var Ye = Math.max;
function ur(K, O, V) {
  return O = Ye(O === void 0 ? K.length - 1 : O, 0), function () {
    for (var S = arguments, D = -1, E = Ye(S.length - O, 0), B = Array(E); ++D < E;) B[D] = S[O + D];
    D = -1;
    for (var H = Array(O + 1); ++D < O;) H[D] = S[D];
    return H[O] = V(B), Vo(K, this, H);
  };
}
function fr(K, O) {
  return ar(ur(K, O, ke), K + "");
}
var gr = 9007199254740991;
function Te(K) {
  return typeof K == "number" && K > -1 && K % 1 == 0 && K <= gr;
}
function ae(K) {
  return K != null && Te(K.length) && !Me(K);
}
function mr(K, O, V) {
  if (!It(V)) return !1;
  var S = typeof O;
  return (S == "number" ? ae(V) && se(O, V.length) : S == "string" && O in V) ? Qt(V[O], K) : !1;
}
function yr(K) {
  return fr(function (O, V) {
    var S = -1,
      D = V.length,
      E = D > 1 ? V[D - 1] : void 0,
      B = D > 2 ? V[2] : void 0;
    for (E = K.length > 3 && typeof E == "function" ? (D--, E) : void 0, B && mr(V[0], V[1], B) && (E = D < 3 ? void 0 : E, D = 1), O = Object(O); ++S < D;) {
      var H = V[S];
      H && K(O, H, S, E);
    }
    return O;
  });
}
var vr = Object.prototype;
function Oe(K) {
  var O = K && K.constructor,
    V = typeof O == "function" && O.prototype || vr;
  return K === V;
}
function xr(K, O) {
  for (var V = -1, S = Array(K); ++V < K;) S[V] = O(V);
  return S;
}
var br = "[object Arguments]";
function We(K) {
  return Ft(K) && Yt(K) == br;
}
var ki = Object.prototype,
  wr = ki.hasOwnProperty,
  Sr = ki.propertyIsEnumerable,
  Cr = We(function () {
    return arguments;
  }()) ? We : function (K) {
    return Ft(K) && wr.call(K, "callee") && !Sr.call(K, "callee");
  };
var ie = Cr;
function kr() {
  return !1;
}
var Mi = typeof exports == "object" && exports && !exports.nodeType && exports,
  Ue = Mi && typeof module == "object" && module && !module.nodeType && module,
  Mr = Ue && Ue.exports === Mi,
  Ke = Mr ? Nt.Buffer : void 0,
  Ar = Ke ? Ke.isBuffer : void 0,
  Tr = Ar || kr;
var oe = Tr;
var Or = "[object Arguments]",
  Dr = "[object Array]",
  Pr = "[object Boolean]",
  Er = "[object Date]",
  jr = "[object Error]",
  Lr = "[object Function]",
  Ir = "[object Map]",
  Nr = "[object Number]",
  Br = "[object Object]",
  Rr = "[object RegExp]",
  _r = "[object Set]",
  Gr = "[object String]",
  Fr = "[object WeakMap]",
  Hr = "[object ArrayBuffer]",
  zr = "[object DataView]",
  Xr = "[object Float32Array]",
  Yr = "[object Float64Array]",
  Wr = "[object Int8Array]",
  Ur = "[object Int16Array]",
  Kr = "[object Int32Array]",
  qr = "[object Uint8Array]",
  Zr = "[object Uint8ClampedArray]",
  Vr = "[object Uint16Array]",
  $r = "[object Uint32Array]",
  Mt = {};
Mt[Xr] = Mt[Yr] = Mt[Wr] = Mt[Ur] = Mt[Kr] = Mt[qr] = Mt[Zr] = Mt[Vr] = Mt[$r] = !0;
Mt[Or] = Mt[Dr] = Mt[Hr] = Mt[Pr] = Mt[zr] = Mt[Er] = Mt[jr] = Mt[Lr] = Mt[Ir] = Mt[Nr] = Mt[Br] = Mt[Rr] = Mt[_r] = Mt[Gr] = Mt[Fr] = !1;
function Qr(K) {
  return Ft(K) && Te(K.length) && !!Mt[Yt(K)];
}
function Jr(K) {
  return function (O) {
    return K(O);
  };
}
var Ai = typeof exports == "object" && exports && !exports.nodeType && exports,
  Zt = Ai && typeof module == "object" && module && !module.nodeType && module,
  tn = Zt && Zt.exports === Ai,
  de = tn && xi.process,
  en = function () {
    try {
      var K = Zt && Zt.require && Zt.require("util").types;
      return K || de && de.binding && de.binding("util");
    } catch (_unused10) {}
  }();
var qe = en;
var Ze = qe && qe.isTypedArray,
  on = Ze ? Jr(Ze) : Qr;
var De = on;
var rn = Object.prototype,
  nn = rn.hasOwnProperty;
function Ti(K, O) {
  var V = jt(K),
    S = !V && ie(K),
    D = !V && !S && oe(K),
    E = !V && !S && !D && De(K),
    B = V || S || D || E,
    H = B ? xr(K.length, String) : [],
    X = H.length;
  for (var W in K) (O || nn.call(K, W)) && !(B && (
  // Safari 9 has enumerable `arguments.length` in strict mode.
  W == "length" ||
  // Node.js 0.10 has enumerable non-index properties on buffers.
  D && (W == "offset" || W == "parent") ||
  // PhantomJS 2 has enumerable non-index properties on typed arrays.
  E && (W == "buffer" || W == "byteLength" || W == "byteOffset") ||
  // Skip index properties.
  se(W, X))) && H.push(W);
  return H;
}
function Oi(K, O) {
  return function (V) {
    return K(O(V));
  };
}
var sn = Oi(Object.keys, Object);
var an = sn;
var hn = Object.prototype,
  ln = hn.hasOwnProperty;
function cn(K) {
  if (!Oe(K)) return an(K);
  var O = [];
  for (var V in Object(K)) ln.call(K, V) && V != "constructor" && O.push(V);
  return O;
}
function Di(K) {
  return ae(K) ? Ti(K) : cn(K);
}
function pn(K) {
  var O = [];
  if (K != null) for (var V in Object(K)) O.push(V);
  return O;
}
var dn = Object.prototype,
  un = dn.hasOwnProperty;
function fn(K) {
  if (!It(K)) return pn(K);
  var O = Oe(K),
    V = [];
  for (var S in K) S == "constructor" && (O || !un.call(K, S)) || V.push(S);
  return V;
}
function Pe(K) {
  return ae(K) ? Ti(K, !0) : fn(K);
}
var gn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  mn = /^\w*$/;
function Ee(K, O) {
  if (jt(K)) return !1;
  var V = typeof K;
  return V == "number" || V == "symbol" || V == "boolean" || K == null || Ce(K) ? !0 : mn.test(K) || !gn.test(K) || O != null && K in Object(O);
}
var yn = Ut(Object, "create");
var Vt = yn;
function vn() {
  this.__data__ = Vt ? Vt(null) : {}, this.size = 0;
}
function xn(K) {
  var O = this.has(K) && delete this.__data__[K];
  return this.size -= O ? 1 : 0, O;
}
var bn = "__lodash_hash_undefined__",
  wn = Object.prototype,
  Sn = wn.hasOwnProperty;
function Cn(K) {
  var O = this.__data__;
  if (Vt) {
    var V = O[K];
    return V === bn ? void 0 : V;
  }
  return Sn.call(O, K) ? O[K] : void 0;
}
var kn = Object.prototype,
  Mn = kn.hasOwnProperty;
function An(K) {
  var O = this.__data__;
  return Vt ? O[K] !== void 0 : Mn.call(O, K);
}
var Tn = "__lodash_hash_undefined__";
function On(K, O) {
  var V = this.__data__;
  return this.size += this.has(K) ? 0 : 1, V[K] = Vt && O === void 0 ? Tn : O, this;
}
function zt(K) {
  var O = -1,
    V = K == null ? 0 : K.length;
  for (this.clear(); ++O < V;) {
    var S = K[O];
    this.set(S[0], S[1]);
  }
}
zt.prototype.clear = vn;
zt.prototype.delete = xn;
zt.prototype.get = Cn;
zt.prototype.has = An;
zt.prototype.set = On;
function Dn() {
  this.__data__ = [], this.size = 0;
}
function he(K, O) {
  for (var V = K.length; V--;) if (Qt(K[V][0], O)) return V;
  return -1;
}
var Pn = Array.prototype,
  En = Pn.splice;
function jn(K) {
  var O = this.__data__,
    V = he(O, K);
  if (V < 0) return !1;
  var S = O.length - 1;
  return V == S ? O.pop() : En.call(O, V, 1), --this.size, !0;
}
function Ln(K) {
  var O = this.__data__,
    V = he(O, K);
  return V < 0 ? void 0 : O[V][1];
}
function In(K) {
  return he(this.__data__, K) > -1;
}
function Nn(K, O) {
  var V = this.__data__,
    S = he(V, K);
  return S < 0 ? (++this.size, V.push([K, O])) : V[S][1] = O, this;
}
function Bt(K) {
  var O = -1,
    V = K == null ? 0 : K.length;
  for (this.clear(); ++O < V;) {
    var S = K[O];
    this.set(S[0], S[1]);
  }
}
Bt.prototype.clear = Dn;
Bt.prototype.delete = jn;
Bt.prototype.get = Ln;
Bt.prototype.has = In;
Bt.prototype.set = Nn;
var Bn = Ut(Nt, "Map");
var $t = Bn;
function Rn() {
  this.size = 0, this.__data__ = {
    hash: new zt(),
    map: new ($t || Bt)(),
    string: new zt()
  };
}
function _n(K) {
  var O = typeof K;
  return O == "string" || O == "number" || O == "symbol" || O == "boolean" ? K !== "__proto__" : K === null;
}
function le(K, O) {
  var V = K.__data__;
  return _n(O) ? V[typeof O == "string" ? "string" : "hash"] : V.map;
}
function Gn(K) {
  var O = le(this, K).delete(K);
  return this.size -= O ? 1 : 0, O;
}
function Fn(K) {
  return le(this, K).get(K);
}
function Hn(K) {
  return le(this, K).has(K);
}
function zn(K, O) {
  var V = le(this, K),
    S = V.size;
  return V.set(K, O), this.size += V.size == S ? 0 : 1, this;
}
function Rt(K) {
  var O = -1,
    V = K == null ? 0 : K.length;
  for (this.clear(); ++O < V;) {
    var S = K[O];
    this.set(S[0], S[1]);
  }
}
Rt.prototype.clear = Rn;
Rt.prototype.delete = Gn;
Rt.prototype.get = Fn;
Rt.prototype.has = Hn;
Rt.prototype.set = zn;
var Xn = "Expected a function";
function je(K, O) {
  if (typeof K != "function" || O != null && typeof O != "function") throw new TypeError(Xn);
  var V = function V() {
    var S = arguments,
      D = O ? O.apply(this, S) : S[0],
      E = V.cache;
    if (E.has(D)) return E.get(D);
    var B = K.apply(this, S);
    return V.cache = E.set(D, B) || E, B;
  };
  return V.cache = new (je.Cache || Rt)(), V;
}
je.Cache = Rt;
var Yn = 500;
function Wn(K) {
  var O = je(K, function (S) {
      return V.size === Yn && V.clear(), S;
    }),
    V = O.cache;
  return O;
}
var Un = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  Kn = /\\(\\)?/g,
  qn = Wn(function (K) {
    var O = [];
    return K.charCodeAt(0) === 46 && O.push(""), K.replace(Un, function (V, S, D, E) {
      O.push(D ? E.replace(Kn, "$1") : S || V);
    }), O;
  });
var Zn = qn;
function Vn(K) {
  return K == null ? "" : Si(K);
}
function ce(K, O) {
  return jt(K) ? K : Ee(K, O) ? [K] : Zn(Vn(K));
}
var $n = 1 / 0;
function Jt(K) {
  if (typeof K == "string" || Ce(K)) return K;
  var O = K + "";
  return O == "0" && 1 / K == -$n ? "-0" : O;
}
function Le(K, O) {
  O = ce(O, K);
  for (var V = 0, S = O.length; K != null && V < S;) K = K[Jt(O[V++])];
  return V && V == S ? K : void 0;
}
function Qn(K, O, V) {
  var S = K == null ? void 0 : Le(K, O);
  return S === void 0 ? V : S;
}
function Pi(K, O) {
  for (var V = -1, S = O.length, D = K.length; ++V < S;) K[D + V] = O[V];
  return K;
}
var Jn = Oi(Object.getPrototypeOf, Object);
var Ie = Jn;
var ts = "[object Object]",
  es = Function.prototype,
  is = Object.prototype,
  Ei = es.toString,
  os = is.hasOwnProperty,
  rs = Ei.call(Object);
function ns(K) {
  if (!Ft(K) || Yt(K) != ts) return !1;
  var O = Ie(K);
  if (O === null) return !0;
  var V = os.call(O, "constructor") && O.constructor;
  return typeof V == "function" && V instanceof V && Ei.call(V) == rs;
}
function ss() {
  this.__data__ = new Bt(), this.size = 0;
}
function as(K) {
  var O = this.__data__,
    V = O.delete(K);
  return this.size = O.size, V;
}
function hs(K) {
  return this.__data__.get(K);
}
function ls(K) {
  return this.__data__.has(K);
}
var cs = 200;
function ps(K, O) {
  var V = this.__data__;
  if (V instanceof Bt) {
    var S = V.__data__;
    if (!$t || S.length < cs - 1) return S.push([K, O]), this.size = ++V.size, this;
    V = this.__data__ = new Rt(S);
  }
  return V.set(K, O), this.size = V.size, this;
}
function Lt(K) {
  var O = this.__data__ = new Bt(K);
  this.size = O.size;
}
Lt.prototype.clear = ss;
Lt.prototype.delete = as;
Lt.prototype.get = hs;
Lt.prototype.has = ls;
Lt.prototype.set = ps;
var ji = typeof exports == "object" && exports && !exports.nodeType && exports,
  Ve = ji && typeof module == "object" && module && !module.nodeType && module,
  ds = Ve && Ve.exports === ji,
  $e = ds ? Nt.Buffer : void 0,
  Qe = $e ? $e.allocUnsafe : void 0;
function us(K, O) {
  if (O) return K.slice();
  var V = K.length,
    S = Qe ? Qe(V) : new K.constructor(V);
  return K.copy(S), S;
}
function fs(K, O) {
  for (var V = -1, S = K == null ? 0 : K.length, D = 0, E = []; ++V < S;) {
    var B = K[V];
    O(B, V, K) && (E[D++] = B);
  }
  return E;
}
function Li() {
  return [];
}
var gs = Object.prototype,
  ms = gs.propertyIsEnumerable,
  Je = Object.getOwnPropertySymbols,
  ys = Je ? function (K) {
    return K == null ? [] : (K = Object(K), fs(Je(K), function (O) {
      return ms.call(K, O);
    }));
  } : Li;
var Ii = ys;
var vs = Object.getOwnPropertySymbols,
  xs = vs ? function (K) {
    for (var O = []; K;) Pi(O, Ii(K)), K = Ie(K);
    return O;
  } : Li;
var bs = xs;
function Ni(K, O, V) {
  var S = O(K);
  return jt(K) ? S : Pi(S, V(K));
}
function ti(K) {
  return Ni(K, Di, Ii);
}
function ws(K) {
  return Ni(K, Pe, bs);
}
var Ss = Ut(Nt, "DataView");
var ge = Ss;
var Cs = Ut(Nt, "Promise");
var me = Cs;
var ks = Ut(Nt, "Set");
var ye = ks;
var ei = "[object Map]",
  Ms = "[object Object]",
  ii = "[object Promise]",
  oi = "[object Set]",
  ri = "[object WeakMap]",
  ni = "[object DataView]",
  As = Wt(ge),
  Ts = Wt($t),
  Os = Wt(me),
  Ds = Wt(ye),
  Ps = Wt(fe),
  Ht = Yt;
(ge && Ht(new ge(new ArrayBuffer(1))) != ni || $t && Ht(new $t()) != ei || me && Ht(me.resolve()) != ii || ye && Ht(new ye()) != oi || fe && Ht(new fe()) != ri) && (Ht = function Ht(K) {
  var O = Yt(K),
    V = O == Ms ? K.constructor : void 0,
    S = V ? Wt(V) : "";
  if (S) switch (S) {
    case As:
      return ni;
    case Ts:
      return ei;
    case Os:
      return ii;
    case Ds:
      return oi;
    case Ps:
      return ri;
  }
  return O;
});
var si = Ht;
var Es = Nt.Uint8Array;
var re = Es;
function js(K) {
  var O = new K.constructor(K.byteLength);
  return new re(O).set(new re(K)), O;
}
function Ls(K, O) {
  var V = O ? js(K.buffer) : K.buffer;
  return new K.constructor(V, K.byteOffset, K.length);
}
function Is(K) {
  return typeof K.constructor == "function" && !Oe(K) ? Zo(Ie(K)) : {};
}
var Ns = "__lodash_hash_undefined__";
function Bs(K) {
  return this.__data__.set(K, Ns), this;
}
function Rs(K) {
  return this.__data__.has(K);
}
function ne(K) {
  var O = -1,
    V = K == null ? 0 : K.length;
  for (this.__data__ = new Rt(); ++O < V;) this.add(K[O]);
}
ne.prototype.add = ne.prototype.push = Bs;
ne.prototype.has = Rs;
function _s(K, O) {
  for (var V = -1, S = K == null ? 0 : K.length; ++V < S;) if (O(K[V], V, K)) return !0;
  return !1;
}
function Gs(K, O) {
  return K.has(O);
}
var Fs = 1,
  Hs = 2;
function Bi(K, O, V, S, D, E) {
  var B = V & Fs,
    H = K.length,
    X = O.length;
  if (H != X && !(B && X > H)) return !1;
  var W = E.get(K),
    z = E.get(O);
  if (W && z) return W == O && z == K;
  var w = -1,
    A = !0,
    k = V & Hs ? new ne() : void 0;
  for (E.set(K, O), E.set(O, K); ++w < H;) {
    var g = K[w],
      p = O[w];
    if (S) var h = B ? S(p, g, w, O, K, E) : S(g, p, w, K, O, E);
    if (h !== void 0) {
      if (h) continue;
      A = !1;
      break;
    }
    if (k) {
      if (!_s(O, function (s, l) {
        if (!Gs(k, l) && (g === s || D(g, s, V, S, E))) return k.push(l);
      })) {
        A = !1;
        break;
      }
    } else if (!(g === p || D(g, p, V, S, E))) {
      A = !1;
      break;
    }
  }
  return E.delete(K), E.delete(O), A;
}
function zs(K) {
  var O = -1,
    V = Array(K.size);
  return K.forEach(function (S, D) {
    V[++O] = [D, S];
  }), V;
}
function Xs(K) {
  var O = -1,
    V = Array(K.size);
  return K.forEach(function (S) {
    V[++O] = S;
  }), V;
}
var Ys = 1,
  Ws = 2,
  Us = "[object Boolean]",
  Ks = "[object Date]",
  qs = "[object Error]",
  Zs = "[object Map]",
  Vs = "[object Number]",
  $s = "[object RegExp]",
  Qs = "[object Set]",
  Js = "[object String]",
  ta = "[object Symbol]",
  ea = "[object ArrayBuffer]",
  ia = "[object DataView]",
  ai = Gt ? Gt.prototype : void 0,
  ue = ai ? ai.valueOf : void 0;
function oa(K, O, V, S, D, E, B) {
  switch (V) {
    case ia:
      if (K.byteLength != O.byteLength || K.byteOffset != O.byteOffset) return !1;
      K = K.buffer, O = O.buffer;
    case ea:
      return !(K.byteLength != O.byteLength || !E(new re(K), new re(O)));
    case Us:
    case Ks:
    case Vs:
      return Qt(+K, +O);
    case qs:
      return K.name == O.name && K.message == O.message;
    case $s:
    case Js:
      return K == O + "";
    case Zs:
      var H = zs;
    case Qs:
      var X = S & Ys;
      if (H || (H = Xs), K.size != O.size && !X) return !1;
      var W = B.get(K);
      if (W) return W == O;
      S |= Ws, B.set(K, O);
      var z = Bi(H(K), H(O), S, D, E, B);
      return B.delete(K), z;
    case ta:
      if (ue) return ue.call(K) == ue.call(O);
  }
  return !1;
}
var ra = 1,
  na = Object.prototype,
  sa = na.hasOwnProperty;
function aa(K, O, V, S, D, E) {
  var B = V & ra,
    H = ti(K),
    X = H.length,
    W = ti(O),
    z = W.length;
  if (X != z && !B) return !1;
  for (var w = X; w--;) {
    var A = H[w];
    if (!(B ? A in O : sa.call(O, A))) return !1;
  }
  var k = E.get(K),
    g = E.get(O);
  if (k && g) return k == O && g == K;
  var p = !0;
  E.set(K, O), E.set(O, K);
  for (var h = B; ++w < X;) {
    A = H[w];
    var s = K[A],
      l = O[A];
    if (S) var u = B ? S(l, s, A, O, K, E) : S(s, l, A, K, O, E);
    if (!(u === void 0 ? s === l || D(s, l, V, S, E) : u)) {
      p = !1;
      break;
    }
    h || (h = A == "constructor");
  }
  if (p && !h) {
    var v = K.constructor,
      M = O.constructor;
    v != M && "constructor" in K && "constructor" in O && !(typeof v == "function" && v instanceof v && typeof M == "function" && M instanceof M) && (p = !1);
  }
  return E.delete(K), E.delete(O), p;
}
var ha = 1,
  hi = "[object Arguments]",
  li = "[object Array]",
  te = "[object Object]",
  la = Object.prototype,
  ci = la.hasOwnProperty;
function ca(K, O, V, S, D, E) {
  var B = jt(K),
    H = jt(O),
    X = B ? li : si(K),
    W = H ? li : si(O);
  X = X == hi ? te : X, W = W == hi ? te : W;
  var z = X == te,
    w = W == te,
    A = X == W;
  if (A && oe(K)) {
    if (!oe(O)) return !1;
    B = !0, z = !1;
  }
  if (A && !z) return E || (E = new Lt()), B || De(K) ? Bi(K, O, V, S, D, E) : oa(K, O, X, V, S, D, E);
  if (!(V & ha)) {
    var k = z && ci.call(K, "__wrapped__"),
      g = w && ci.call(O, "__wrapped__");
    if (k || g) {
      var p = k ? K.value() : K,
        h = g ? O.value() : O;
      return E || (E = new Lt()), D(p, h, V, S, E);
    }
  }
  return A ? (E || (E = new Lt()), aa(K, O, V, S, D, E)) : !1;
}
function Ne(K, O, V, S, D) {
  return K === O ? !0 : K == null || O == null || !Ft(K) && !Ft(O) ? K !== K && O !== O : ca(K, O, V, S, Ne, D);
}
var pa = 1,
  da = 2;
function ua(K, O, V, S) {
  var D = V.length,
    E = D,
    B = !S;
  if (K == null) return !E;
  for (K = Object(K); D--;) {
    var H = V[D];
    if (B && H[2] ? H[1] !== K[H[0]] : !(H[0] in K)) return !1;
  }
  for (; ++D < E;) {
    H = V[D];
    var X = H[0],
      W = K[X],
      z = H[1];
    if (B && H[2]) {
      if (W === void 0 && !(X in K)) return !1;
    } else {
      var w = new Lt();
      if (S) var A = S(W, z, X, K, O, w);
      if (!(A === void 0 ? Ne(z, W, pa | da, S, w) : A)) return !1;
    }
  }
  return !0;
}
function Ri(K) {
  return K === K && !It(K);
}
function fa(K) {
  for (var O = Di(K), V = O.length; V--;) {
    var S = O[V],
      D = K[S];
    O[V] = [S, D, Ri(D)];
  }
  return O;
}
function _i(K, O) {
  return function (V) {
    return V == null ? !1 : V[K] === O && (O !== void 0 || K in Object(V));
  };
}
function ga(K) {
  var O = fa(K);
  return O.length == 1 && O[0][2] ? _i(O[0][0], O[0][1]) : function (V) {
    return V === K || ua(V, K, O);
  };
}
function ma(K, O) {
  return K != null && O in Object(K);
}
function ya(K, O, V) {
  O = ce(O, K);
  for (var S = -1, D = O.length, E = !1; ++S < D;) {
    var B = Jt(O[S]);
    if (!(E = K != null && V(K, B))) break;
    K = K[B];
  }
  return E || ++S != D ? E : (D = K == null ? 0 : K.length, !!D && Te(D) && se(B, D) && (jt(K) || ie(K)));
}
function va(K, O) {
  return K != null && ya(K, O, ma);
}
var xa = 1,
  ba = 2;
function wa(K, O) {
  return Ee(K) && Ri(O) ? _i(Jt(K), O) : function (V) {
    var S = Qn(V, K);
    return S === void 0 && S === O ? va(V, K) : Ne(O, S, xa | ba);
  };
}
function Sa(K) {
  return function (O) {
    return O == null ? void 0 : O[K];
  };
}
function Ca(K) {
  return function (O) {
    return Le(O, K);
  };
}
function ka(K) {
  return Ee(K) ? Sa(Jt(K)) : Ca(K);
}
function Ma(K) {
  return typeof K == "function" ? K : K == null ? ke : typeof K == "object" ? jt(K) ? wa(K[0], K[1]) : ga(K) : ka(K);
}
function Aa(K) {
  return function (O, V, S) {
    for (var D = -1, E = Object(O), B = S(O), H = B.length; H--;) {
      var X = B[K ? H : ++D];
      if (V(E[X], X, E) === !1) break;
    }
    return O;
  };
}
var Ta = Aa();
var Oa = Ta;
function ve(K, O, V) {
  (V !== void 0 && !Qt(K[O], V) || V === void 0 && !(O in K)) && Ae(K, O, V);
}
function Da(K) {
  return Ft(K) && ae(K);
}
function xe(K, O) {
  if (!(O === "constructor" && typeof K[O] == "function") && O != "__proto__") return K[O];
}
function Pa(K) {
  return dr(K, Pe(K));
}
function Ea(K, O, V, S, D, E, B) {
  var H = xe(K, V),
    X = xe(O, V),
    W = B.get(X);
  if (W) {
    ve(K, V, W);
    return;
  }
  var z = E ? E(H, X, V + "", K, O, B) : void 0,
    w = z === void 0;
  if (w) {
    var A = jt(X),
      k = !A && oe(X),
      g = !A && !k && De(X);
    z = X, A || k || g ? jt(H) ? z = H : Da(H) ? z = $o(H) : k ? (w = !1, z = us(X, !0)) : g ? (w = !1, z = Ls(X, !0)) : z = [] : ns(X) || ie(X) ? (z = H, ie(H) ? z = Pa(H) : (!It(H) || Me(H)) && (z = Is(X))) : w = !1;
  }
  w && (B.set(X, z), D(z, X, S, E, B), B.delete(X)), ve(K, V, z);
}
function Gi(K, O, V, S, D) {
  K !== O && Oa(O, function (E, B) {
    if (D || (D = new Lt()), It(E)) Ea(K, O, B, V, Gi, S, D);else {
      var H = S ? S(xe(K, B), E, B + "", K, O, D) : void 0;
      H === void 0 && (H = E), ve(K, B, H);
    }
  }, Pe);
}
var ja = yr(function (K, O, V) {
  Gi(K, O, V);
});
var La = ja;
function Ia(K, O, V, S) {
  if (!It(K)) return K;
  O = ce(O, K);
  for (var D = -1, E = O.length, B = E - 1, H = K; H != null && ++D < E;) {
    var X = Jt(O[D]),
      W = V;
    if (X === "__proto__" || X === "constructor" || X === "prototype") return K;
    if (D != B) {
      var z = H[X];
      W = S ? S(z, X, H) : void 0, W === void 0 && (W = It(z) ? z : se(O[D + 1]) ? [] : {});
    }
    Ci(H, X, W), H = H[X];
  }
  return K;
}
function Na(K, O, V) {
  for (var S = -1, D = O.length, E = {}; ++S < D;) {
    var B = O[S],
      H = Le(K, B);
    V(H, B) && Ia(E, ce(B, K), H);
  }
  return E;
}
function Ba(K, O) {
  if (K == null) return {};
  var V = wi(ws(K), function (S) {
    return [S];
  });
  return O = Ma(O), Na(K, V, function (S, D) {
    return O(S, D[0]);
  });
}
var _t = /* @__PURE__ */function (K) {
    return K.LINE = "line", K.BAR = "bar", K.COLUMN = "column", K.SCATTER = "scatter", K.PIE = "pie", K.GAUGE = "gauge", K.AREA = "area", K;
  }(_t || {}),
  Ra = /* @__PURE__ */function (K) {
    return K.HORIZONTAL = "horizontal", K.VERTICAL = "vertical", K;
  }(Ra || {}),
  be = /* @__PURE__ */function (K) {
    return K.REDUCED = "reduced-set", K.FULL = "full-set", K;
  }(be || {});
function _a(K) {
  var O = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
  if (K) return Vi(K, O);
}
function Ga(K, O) {
  var V = document.createElement("div");
  V.classList.add(O), K.parentNode && (K.parentNode.appendChild(V), V.appendChild(K));
}
function Qa() {
  return ["dark-blue", "teal", "purple", "berry", "orange", "grey"];
}
function Ja() {
  return ["dark-blue", "dark-blue", "teal", "teal", "purple", "purple", "berry", "berry", "orange", "orange", "grey", "grey"];
}
var Fa = pi(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["[beacon-tag-name=beacon-legend]{--chart-context-pointer-chart: pointer}figure{background-color:var(--beacon-chart-color-background);margin:0}@media (min-width: 640px){figure:not([data-layout-horizontal=center]){display:grid;grid-auto-flow:column;grid-template-columns:var(--beacon-chart-column-width-left, 1fr) var(--beacon-chart-column-width-right, 1fr)}figure[data-layout-horizontal=left] .legend-container{grid-column:1/2}figure[data-layout-horizontal=left] .chart{grid-column:2/3}figure[data-layout-vertical=middle]{align-items:center}figure[data-layout-vertical=bottom]{align-items:end}}.chart{block-size:var(--beacon-custom-chart-container-size-block, auto)}.highcharts-background{fill:var(--beacon-chart-color-background)}.legend-container{background-color:var(--beacon-chart-color-background);padding-inline-start:var(--beacon-legend-space-padding-interactive)}.highcharts-focus-border{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc(var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)));stroke:var(--beacon-system-color-border-focus-outer, var(--beacon-color-shadow-focus));stroke-width:var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo))}.highcharts-container{color:inherit;font-family:inherit}.highcharts-title{font-size:var(--beacon-headline-font-size-50);line-height:var(--beacon-headline-font-line-height-module-50)}.highcharts-subtitle,.highcharts-caption{font-size:var(--beacon-caption-font-size-300);line-height:var(--beacon-caption-font-line-height-module-300)}.highcharts-axis-title,.highcharts-title{font-weight:var(--beacon-font-weight-bold)}.highcharts-axis-labels,.highcharts-axis-title{font-size:var(--beacon-caption-font-size-200);line-height:var(--beacon-caption-font-line-height-module-200)}.highcharts-tooltip-box{fill:var(--beacon-chart-tooltip-color-background);fill-opacity:100%}.tooltip-value{font-weight:700}.highcharts-series-inactive,.data-label--inactive{opacity:.2}.highcharts-navigator-series .highcharts-area{fill-opacity:16%}.highcharts-grid-line,.highcharts-axis-line{stroke:var(--beacon-chart-grid-line-color-stroke);stroke-width:1px}.highcharts-plot-line.origin-line,.highcharts-tick{stroke:var(--beacon-chart-origin-line-color-stroke);stroke-width:1px}.highcharts-plot-band.negative-area{fill:var(--beacon-chart-highlight-area-color-fill);fill-opacity:100%}.chart--bar .highcharts-tick,.chart--column .highcharts-tick{display:none}.chart-and-tooltip-wrapper{position:relative}.highcharts-color-0{fill:var(--beacon-chart-series-color-0);stroke:var(--beacon-chart-series-color-0)}.highcharts-color-1{fill:var(--beacon-chart-series-color-1);stroke:var(--beacon-chart-series-color-1)}.highcharts-color-2{fill:var(--beacon-chart-series-color-2);stroke:var(--beacon-chart-series-color-2)}.highcharts-color-3{fill:var(--beacon-chart-series-color-3);stroke:var(--beacon-chart-series-color-3)}.highcharts-color-4{fill:var(--beacon-chart-series-color-4);stroke:var(--beacon-chart-series-color-4)}.highcharts-color-5{fill:var(--beacon-chart-series-color-5);stroke:var(--beacon-chart-series-color-5)}.highcharts-color-6{fill:var(--beacon-chart-series-color-6);stroke:var(--beacon-chart-series-color-6)}.highcharts-color-7{fill:var(--beacon-chart-series-color-7);stroke:var(--beacon-chart-series-color-7)}.highcharts-color-8{fill:var(--beacon-chart-series-color-8);stroke:var(--beacon-chart-series-color-8)}.highcharts-color-9{fill:var(--beacon-chart-series-color-9);stroke:var(--beacon-chart-series-color-9)}.highcharts-color-10{fill:var(--beacon-chart-series-color-10);stroke:var(--beacon-chart-series-color-10)}.highcharts-color-11{fill:var(--beacon-chart-series-color-11);stroke:var(--beacon-chart-series-color-11)}\n"])));
var Ha = Object.defineProperty,
  za = Object.getOwnPropertyDescriptor,
  kt = function kt(K, O, V, S) {
    for (var D = S > 1 ? void 0 : S ? za(O, V) : O, E = K.length - 1, B; E >= 0; E--) (B = K[E]) && (D = (S ? B(O, V, D) : B(D)) || D);
    return S && D && Ha(O, V, D), D;
  };
(_Kt$AST$allowedTags = Kt.AST.allowedTags).push.apply(_Kt$AST$allowedTags, _toConsumableArray(At.highchartsASTTags));
(_Kt$AST$allowedAttrib = Kt.AST.allowedAttributes).push.apply(_Kt$AST$allowedAttrib, _toConsumableArray(At.highchartsASTAttributes));
var St = /*#__PURE__*/function (_Hi) {
  _inherits(St, _Hi);
  function St() {
    var _this;
    _classCallCheck(this, St);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(St).apply(this, arguments)), _this.chartTitle = "", _this.chartSubtitle = "", _this.caption = "", _this.hideCaption = !1, _this.yAxisLabel = "", _this.xAxisLabel = "", _this.stockChart = !1, _this.hideNavigator = !1, _this.staticLegend = !1, _this.hideLegendMetric = !1, _this.drillUpText = "Back", _this.visibleLegendItems = 4, _this.tableId = "", _this.legendLayout = At.defaultLegendLayout, _this.series = [], _this.drilldownSeries = [], _this.options = {}, _this.tooltipTitle = "", _this.tooltipVariant = $i.SINGLE_LINE, _this.disableTooltipTitle = !1, _this.chart = null, _this.chartLoadedSeries = [];
    return _this;
  }
  _createClass(St, [{
    key: "initializeHighcharts",
    /**
     * Applies modules and events to the used Highcharts package.
     *
     * @param pkg Highcharts
     */
    value: function initializeHighcharts(O) {
      no(O), fo(O), po(O), lo(O), io(O), O.addEvent(O.Chart, "afterViewData", Wi);
    }
    /**
     * Getter for context menu items - defined to allow overriding in component classes
     */
  }, {
    key: "createChartOptions",
    /**
     * Merge all possible chart options into a single object
     * @returns Options for Highcharts to render
     */
    value: function createChartOptions() {
      return La(this.chartOptions, this.localComponentOptions, this.filteredOptions);
    } /** The color order pattern to use for themeing. */
  }, {
    key: "createChart",
    /**
     * Base method for creating the component's chart. Expected to be extended in extended classes.
     * @see firstUpdated
     * @abstract
     */
    value: function () {
      var _createChart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var O;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.initializeHighcharts(Kt), this.tableId && (this.series = [], console.warn("Your chart's [series] prop has been emptied because you supplied a [table-id] of \"".concat(this.tableId, "\". If that was unintentional, remove the [table-id] prop from your component.")), ao(Kt), document.getElementById(this.tableId) || console.warn("It looks like you're trying to use data from a HTML table with the id \"".concat(this.tableId, "\". Make sure there's a table with that ID.")));
              O = this.createChartOptions();
              return _context.abrupt("return", (this.stockChart ? this.chart = Kt.stockChart(this.chartContainer, O) : (O.series && O.series.length > 0 && this.maxDataPoints && O.series.forEach(function (V) {
                var S;
                (S = V.data) == null || S.splice(_this2.maxDataPoints, 1 / 0);
              }), this.chart = Kt.chart(this.chartContainer, O)), this.chart));
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", (console.error(_context.t0), !1));
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 6]]);
      }));
      function createChart() {
        return _createChart.apply(this, arguments);
      }
      return createChart;
    }()
    /**
     * Initializes the chartLoadedSeries object from the chart emitted when
     * the chart loads, and uses the results to render a legend and legend-item
     * @param chart the chart object used to build the data-visualization
     */
  }, {
    key: "createLegend",
    value: function createLegend(O) {
      var _this3 = this;
      if (O) {
        var V = Ki(O);
        O.series.forEach(function (S, D) {
          typeof _this3.series[D] > "u" && O.series[D].remove();
        }), this.chartLoadedSeries = O.series.map(function (S, D) {
          return {
            name: S.name,
            index: D,
            multiSymbol: V
          };
        });
      }
    }
    /** Functions to be run after the load event is fired from Highcharts.
     * Initializes the chart object and creates the legend from the same chart,
     * then adds a wrapper class that applies a css class with the reduced or full
     * color set to use.
     * @param chart the chart object used to build the data-visualization
     */
  }, {
    key: "onChartLoad",
    value: function onChartLoad(O) {
      if (O) {
        this.chart = O, this.createLegend(O);
        var V = this.colorOrder;
        V && Ga(this, V);
      }
    }
  }, {
    key: "onChartRedraw",
    value: function onChartRedraw(O) {
      this.createLegend(O);
    }
  }, {
    key: "onDrilldown",
    value: function onDrilldown(O) {}
  }, {
    key: "onDrillup",
    value: function onDrillup(O) {}
  }, {
    key: "firstUpdated",
    value: function () {
      var _firstUpdated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.updateComplete;
            case 2:
              this.createChart();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function firstUpdated() {
        return _firstUpdated.apply(this, arguments);
      }
      return firstUpdated;
    }() /** Updates the chart with a given set of options after the chart has been created. */
  }, {
    key: "updateChart",
    value: function updateChart() {
      var O = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var V;
      return (V = this.chart) == null ? void 0 : V.update(O);
    }
    /**
     * Sets the state of all unhovered series to inactive
     * for the highCharts opacity update logic to take effect
     * @param index the index of the series being hovered
     */
  }, {
    key: "setUnhoveredStateInactive",
    value: function setUnhoveredStateInactive(O) {
      var V;
      (V = this.chart) == null || V.series.forEach(function (S, D) {
        D !== O && S.setState(At.pointInactiveState);
      });
    }
    /**
     * Resets the state of all points.
     */
  }, {
    key: "raiseAllSeriesOpacity",
    value: function raiseAllSeriesOpacity() {
      var O;
      (O = this.chart) == null || O.series.forEach(function (V) {
        V.setState(At.pointActiveState);
      });
    }
    /**
     * changes the opacity of the associated series to be fully visible
     * while lowering the opacity of other series when a legend-item is hovered
     * @param e a beacon-event-mouseenter event fired by a hovered legend-item
     */
  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter(O) {
      var V, S;
      var D = parseInt((V = O.target) == null ? void 0 : V.index, At.decimalNumber);
      (D || D === 0) && (S = O.target) != null && S.selected && !O.target.isStatic && this.setUnhoveredStateInactive(D);
    }
    /**
     * Resets the opacity of all series to the default value when a legend-item
     * is unhovered.
     * @param e a beacon-event-mouseexit event fired by a hovered legend-item
     */
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(O) {
      var V;
      (V = O.target) != null && V.selected && !O.target.isStatic && this.raiseAllSeriesOpacity();
    }
    /**
     * Uses the Highcharts toggle the visibility of a series associated
     * with the clicked legend
     * @param e a beacon-event-click event fired by a clicked legend-item
     */
  }, {
    key: "handleLegendClick",
    value: function handleLegendClick(O) {
      var V = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.legend;
      var S = O.target;
      V && S && (V.AllItemsSelected && V.legendItems.length > 1 ? (this.legend.deselectOtherLegends(S.index), this.handleSeriesVisibility(S)) : (S.toggleSelected(), this.handleSeriesVisibility(S)));
    }
    /**
     * shows or hides a clicked legendItem based on its selected attribute
     * @param LegendItem the slotted legendItem
     */
  }, {
    key: "handleSeriesVisibility",
    value: function handleSeriesVisibility(O) {
      var V = O.index;
      O.selected && (this.showSeries(V), this.chartContainer.classList.contains(At.deselectedClassName) && this.chartContainer.classList.remove(At.deselectedClassName)), O.selected || (this.hideSeries(V), this.legend.AllItemsDeselected && this.chartContainer.classList.add(At.deselectedClassName));
    }
    /**
     * Listens to the beacon-event-hide event
     * emitted from a beacon legend item
     * and hides the associated series
     * @param e beacon-event-hide
     */
  }, {
    key: "handleLegendItemHide",
    value: function handleLegendItemHide(O) {
      var V = O.target.index;
      this.hideSeries(V);
    }
    /**
     * Calls the highcharts hide function on the input series index
     * @param index the index of the chart series to be hidden
     */
  }, {
    key: "hideSeries",
    value: function hideSeries(O) {
      var V;
      (V = this.chart) == null || V.series[O].hide();
    }
    /**
     * Calls the highcharts show function on the input series index
     * @param index the index of the chart series to be shown
     */
  }, {
    key: "showSeries",
    value: function showSeries(O) {
      var V;
      (V = this.chart) == null || V.series[O].show();
    }
  }, {
    key: "willUpdate",
    value: function willUpdate(O) {
      var V = this.createChartOptions();
      Qi || this.updateChart(V);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return Be(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<figure\n      class=\"base\"\n      data-layout-vertical=\"", "\"\n      data-layout-horizontal=\"", "\"\n    >\n      <div id=\"container\" class=\"chart chart--", "\"></div>\n      <div id=\"legend\" class=\"legend-container\">\n        ", "\n      </div>\n    </figure>"])), this.legendLayout.vertical, this.legendLayout.horizontal, this.type, Re(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<", " class=\"legend\" @beacon-event-mouseenter=", " @beacon-event-mouseleave=", " @beacon-event-click=", " @beacon-event-hide=", " direction=", " visible-items=", " ?is-static=", ">\n          ", "\n        </", ">"])), this.getScopedTag(At.beaconLegendName), this.handleMouseEnter, this.handleMouseLeave, this.handleLegendClick, this.handleLegendItemHide, this.legendLayout.direction, this.visibleLegendItems, this.staticLegend, Xi(this.chartLoadedSeries, function (O) {
        return Re(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<", " data-legend-item=\"primary\" label=", " index=", " value=", ">", "</", ">"])), _this4.getScopedTag(At.beaconLegendItemName), O.name, O.index, _this4.hideLegendMetric ? _e : O.value, O.multiSymbol ? Be(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), qi(O.index)) : _e, _this4.getScopedTag(At.beaconLegendItemName));
      }), this.getScopedTag(At.beaconLegendName)));
    }
  }, {
    key: "type",
    /** The type of chart being rendered. Defaults to a line chart, following Highcharts defaults. */get: function get() {
      return _t.LINE;
    } /** Calculates the size of the chart's container and the box where data is plotted. */
  }, {
    key: "chartSize",
    get: function get() {
      if (!this.chart) return {};
      var O = this.chart,
        V = O.chartHeight,
        S = O.chartWidth,
        D = O.plotHeight,
        E = O.plotWidth;
      return {
        chartHeight: V,
        chartWidth: S,
        plotHeight: D,
        plotWidth: E
      };
    }
  }, {
    key: "exportMenuItems",
    get: function get() {
      return this.tableId ? At.exportMenuItems : [].concat(_toConsumableArray(At.exportMenuItems), [At.exportMenuViewDataLabel]);
    }
    /**
     * Local options defined on the chart-component level. Defaults to `null`. Expected to be redefined in extended component classes.
     * @abstract
     */
  }, {
    key: "localComponentOptions",
    get: function get() {
      return null;
    } /** The consumer-defined options with the appropriate keys filtered out. */
  }, {
    key: "filteredOptions",
    get: function get() {
      var _this5 = this;
      var O = ["legend", "colors", "series"];
      return this.options ? Ba(this.options, function (V, S) {
        return S === At.seriesName && !_this5.tableId || !O.includes(S);
      }) : {};
    }
    /**
     * The global options applied to all chart components as a base. Merges a set of global options with additional possible configurations.
     *
     * @note Labels and titles have `useHTML: true` in order to apply `line-height` rules.
     *
     * @see filteredOptions
     * @see localComponentOptions
     */
  }, {
    key: "chartOptions",
    get: function get() {
      var _this6 = this;
      var O, V, S, D;
      var E = [_t.BAR, _t.COLUMN, _t.LINE, _t.AREA, _t.PIE, _t.GAUGE];
      return {
        accessibility: {
          description: this.hideCaption && this.caption
        },
        caption: {
          margin: At.captionMargin,
          text: !this.hideCaption && this.caption,
          useHTML: !0
        },
        chart: {
          colorCount: 12,
          events: {
            // Doesn't use `this.chart` as the argument because doing so returns a null object
            load: function load(B) {
              return _this6.onChartLoad(B.target);
            },
            redraw: function redraw(B) {
              return _this6.onChartRedraw(B.target);
            },
            drilldown: function drilldown(B) {
              return _this6.onDrilldown(B);
            },
            drillup: function drillup(B) {
              return _this6.onDrillup(B);
            }
          },
          styledMode: !0,
          type: this.type
        },
        credits: {
          enabled: !1
        },
        data: {
          table: this.tableId || null
        },
        drilldown: {
          breadcrumbs: {
            format: "".concat(this.drillUpText),
            showFullPath: !1
          },
          series: this.drilldownSeries
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: this.exportMenuItems
            }
          },
          chartOptions: {
            chart: {
              styledMode: !1
              // Turned off because the exported images don't know about the styles since they are in the shadow root.
            }
          },

          sourceHeight: (O = this.chartSize) == null ? void 0 : O.chartHeight,
          sourceWidth: (V = this.chartSize) == null ? void 0 : V.chartWidth
        },
        legend: {
          enabled: !1
        },
        navigator: {
          enabled: this.stockChart && !this.hideNavigator
        },
        plotOptions: {
          // Store a reference to the scoped BeaconTable component
          custom: {
            tableElement: this.getScopedTagName(At.beaconTableName)
          }
        },
        series: ((S = this.options) == null ? void 0 : S.series) || this.series,
        subtitle: {
          align: "left",
          text: this.chartSubtitle,
          useHTML: !0
        },
        symbols: _toConsumableArray(Object.values(Ui)),
        title: {
          align: "left",
          margin: window.innerWidth >= Yi.LARGE ? At.titleSpacers.large : At.titleSpacers.small,
          text: this.chartTitle,
          useHTML: !0
        },
        tooltip: {
          enabled: !E.includes(this.type),
          useHTML: !0
        },
        xAxis: {
          categories: this.categories,
          labels: {
            useHTML: !0
          },
          tickLength: parseInt(Fi, At.decimalNumber),
          title: {
            text: this.xAxisLabel,
            useHTML: !0
          }
        },
        yAxis: {
          labels: {
            useHTML: !0
          },
          plotBands: [
          // Negative area of the chart
          {
            className: "negative-area",
            from: 0,
            to: (D = this.chart) == null ? void 0 : D.yAxis[0].min
          }],
          plotLines: [
          // Origin Line
          {
            className: "origin-line",
            value: 0,
            zIndex: 10
            // Layers it over the rest of the chart elements
          }],

          title: {
            text: this.yAxisLabel,
            useHTML: !0
          }
        }
      };
    }
    /**
     * Store the series length separately to account for series as `series`, `table-id`, or `options`.
     * @see BeaconBarChart
     */
  }, {
    key: "seriesLength",
    get: function get() {
      var O, V;
      return (V = (O = this.chart) == null ? void 0 : O.series) == null ? void 0 : V.length;
    } /** The total number of categories, based on the maximum length of all series. */
  }, {
    key: "totalChartCategories",
    get: function get() {
      var O, V;
      var S = (V = (O = this.chart) == null ? void 0 : O.series) == null ? void 0 : V.map(function (E) {
        var B;
        return (B = E == null ? void 0 : E.data) == null ? void 0 : B.length;
      });
      if (!S) return;
      var D = Math.max.apply(Math, _toConsumableArray(S));
      return Number.isFinite(D) ? D : void 0;
    }
  }, {
    key: "colorOrder",
    get: function get() {
      return this.seriesLength ? this.seriesLength > 6 ? be.FULL : be.REDUCED : !1;
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(St), "styles", this), Ji, Fa];
    }
  }]);
  return St;
}(Hi(zi));
St.nestedComponents = At.beaconNestedComponents;
kt([Tt({
  attribute: "chart-title"
})], St.prototype, "chartTitle", 2);
kt([Tt({
  attribute: "chart-subtitle"
})], St.prototype, "chartSubtitle", 2);
kt([Tt()], St.prototype, "caption", 2);
kt([Tt({
  type: Boolean,
  attribute: "hide-caption"
})], St.prototype, "hideCaption", 2);
kt([Tt({
  attribute: "y-axis-label"
})], St.prototype, "yAxisLabel", 2);
kt([Tt({
  attribute: "x-axis-label"
})], St.prototype, "xAxisLabel", 2);
kt([Tt({
  type: Boolean,
  attribute: "stock-chart"
})], St.prototype, "stockChart", 2);
kt([Tt({
  type: Boolean,
  attribute: "hide-navigator"
})], St.prototype, "hideNavigator", 2);
kt([Tt({
  attribute: "static-legend",
  type: Boolean
})], St.prototype, "staticLegend", 2);
kt([Tt({
  attribute: "hide-legend-metric",
  type: Boolean
})], St.prototype, "hideLegendMetric", 2);
kt([Tt({
  attribute: "drill-up-text"
})], St.prototype, "drillUpText", 2);
kt([Tt({
  attribute: "visible-legend-items",
  type: Number
})], St.prototype, "visibleLegendItems", 2);
kt([Tt({
  converter: function converter(K) {
    return _a(K, ",");
  }
})], St.prototype, "categories", 2);
kt([Tt({
  attribute: "table-id"
})], St.prototype, "tableId", 2);
kt([Tt({
  attribute: "legend-layout",
  converter: function converter(K) {
    return Zi(K);
  }
})], St.prototype, "legendLayout", 2);
kt([Tt({
  type: Array
})], St.prototype, "series", 2);
kt([Tt({
  attribute: "drilldown-series",
  type: Array
})], St.prototype, "drilldownSeries", 2);
kt([Tt({
  type: Object
})], St.prototype, "options", 2);
kt([Tt({
  attribute: "tooltip-title"
})], St.prototype, "tooltipTitle", 2);
kt([Tt({
  attribute: "tooltip-variant"
})], St.prototype, "tooltipVariant", 2);
kt([Tt({
  attribute: "disable-tooltip-title",
  type: Boolean
})], St.prototype, "disableTooltipTitle", 2);
kt([we()], St.prototype, "chart", 2);
kt([we()], St.prototype, "chartLoadedSeries", 2);
kt([Se("#container")], St.prototype, "chartContainer", 2);
kt([Se('[beacon-tag-name="beacon-legend"]')], St.prototype, "legend", 2);
kt([Se(".base")], St.prototype, "baseElement", 2);
kt([we()], St.prototype, "maxDataPoints", 2);
export { La as Ia, Qa, Ra, St, Xt, _a, _t, be, Ja as qa, to };